import { SceneAction, SceneCondition } from '@lualtek/shared-parts/automations/scenes/types';
import { Dataset } from '../../types/dataset';
import { AreaIcon } from '../../types/area';
import { ContentsValues as NotificationValues } from '@lualtek/dynamic-glossary/types';
import { RichTextProps } from '@graphcms/rich-text-react-renderer';

type NotificationValuesComplete = NotificationValues & { hygraphId: string };

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | undefined | null;
export type InputMaybe<T> = T | undefined | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the date-timeformat outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representationof dates and times using the Gregorian calendar. */
  DateTime: unknown;
  /** Raw JSON value */
  Json: unknown;
  /** The Long scalar type represents non-fractional signed whole numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: unknown;
  /** Slate-compatible RichText AST */
  RichTextAST: unknown;
  actions: SceneAction[];
  areaicon: AreaIcon;
  bigint: number;
  bpchar: string;
  conditions: SceneCondition[];
  dataset: Dataset;
  json: unknown;
  jsonb: unknown;
  notification_values: NotificationValuesComplete;
  numeric: number;
  richtextraw: RichTextProps['content'];
  time: string;
  timestamptz: string;
  uuid: unknown;
};

export enum ActionsAreaScopes {
  CULTIVATION = 'CULTIVATION',
  OTHER = 'OTHER'
}

export enum ActionsCultivationTypes {
  APPLES = 'APPLES',
  ARTICHOKES = 'ARTICHOKES',
  ASPARAGUS = 'ASPARAGUS',
  AVOCADOS = 'AVOCADOS',
  BARLEY = 'BARLEY',
  BASIL = 'BASIL',
  BEANS = 'BEANS',
  BEETS = 'BEETS',
  BELL_PEPPER = 'BELL_PEPPER',
  BERRIES = 'BERRIES',
  BLACKBERRIES = 'BLACKBERRIES',
  BLUEBERRIES = 'BLUEBERRIES',
  BROCCOLI = 'BROCCOLI',
  BULBS = 'BULBS',
  CABBAGE = 'CABBAGE',
  CARROTS = 'CARROTS',
  CAULIFLOWER = 'CAULIFLOWER',
  CELERY = 'CELERY',
  CHRYSANTHEMUMS = 'CHRYSANTHEMUMS',
  CILANTRO = 'CILANTRO',
  CITRUS_FRUITS = 'CITRUS_FRUITS',
  CORN = 'CORN',
  CUCUMBERS = 'CUCUMBERS',
  CURRANTS = 'CURRANTS',
  DAISIES = 'DAISIES',
  DILL = 'DILL',
  EGGPLANT = 'EGGPLANT',
  FRUITING_VEGETABLES = 'FRUITING_VEGETABLES',
  GARLIC = 'GARLIC',
  GRAINS = 'GRAINS',
  GRAPEVINE = 'GRAPEVINE',
  HERBS = 'HERBS',
  KALE = 'KALE',
  LEAFY_VEGETABLES = 'LEAFY_VEGETABLES',
  LEGUMES = 'LEGUMES',
  LETTUCE = 'LETTUCE',
  LILIES = 'LILIES',
  MANGOES = 'MANGOES',
  MARIGOLDS = 'MARIGOLDS',
  MELONS = 'MELONS',
  MINT = 'MINT',
  NUTS = 'NUTS',
  OATS = 'OATS',
  OLIVES = 'OLIVES',
  ONIONS = 'ONIONS',
  ORCHIDS = 'ORCHIDS',
  OREGANO = 'OREGANO',
  PARSLEY = 'PARSLEY',
  PEARS = 'PEARS',
  PEAS = 'PEAS',
  PEPPERS = 'PEPPERS',
  POME_FRUITS = 'POME_FRUITS',
  POTATOES = 'POTATOES',
  PUMPKINS = 'PUMPKINS',
  RADISHES = 'RADISHES',
  RASPBERRIES = 'RASPBERRIES',
  ROOT_VEGETABLES = 'ROOT_VEGETABLES',
  ROSEMARY = 'ROSEMARY',
  ROSES = 'ROSES',
  SPINACH = 'SPINACH',
  SQUASH = 'SQUASH',
  STONE_FRUITS = 'STONE_FRUITS',
  STRAWBERRIES = 'STRAWBERRIES',
  SUNFLOWERS = 'SUNFLOWERS',
  SWEET_POTATOES = 'SWEET_POTATOES',
  THYME = 'THYME',
  TOMATO = 'TOMATO',
  TROPICAL_FRUITS = 'TROPICAL_FRUITS',
  TUBERS = 'TUBERS',
  TULIPS = 'TULIPS',
  WHEAT = 'WHEAT',
  ZUCCHINI = 'ZUCCHINI'
}

export enum ActionsFarmingContainers {
  GROW_BAG = 'GROW_BAG',
  POT = 'POT'
}

export enum ActionsFarmingMethods {
  SOIL = 'SOIL',
  SOILLESS = 'SOILLESS'
}

export enum ActionsFarmingStructures {
  GREENHOUSE = 'GREENHOUSE',
  OPEN_FIELD = 'OPEN_FIELD',
  TUNNEL = 'TUNNEL'
}

export type Aggregate = {
  __typename?: 'Aggregate';
  count: Scalars['Int'];
};

export type AnalysisApplicationCreateInput = {
  analysis_id: Scalars['Int'];
  application_id: Scalars['Int'];
  area_id?: InputMaybe<Scalars['Int']>;
  devices: Array<Scalars['Int']>;
  enabled: Scalars['Boolean'];
  name: Scalars['String'];
};

export type AnalysisApplicationCreateOutput = {
  __typename?: 'AnalysisApplicationCreateOutput';
  id: Scalars['Int'];
};

export type AnalysisApplicationUpdateInput = {
  analysis_application_id: Scalars['Int'];
  devices: Array<Scalars['Int']>;
  enabled: Scalars['Boolean'];
  name: Scalars['String'];
};

export type AnalysisApplicationUpdateOutput = {
  __typename?: 'AnalysisApplicationUpdateOutput';
  id: Scalars['Int'];
};

export type ApplicationWeather = {
  __typename?: 'ApplicationWeather';
  alerts: Array<ApplicationWeatherAlert>;
  current: ApplicationWeatherCurrent;
  forecast: Array<ApplicationWeatherForecast>;
};

export type ApplicationWeatherAlert = {
  __typename?: 'ApplicationWeatherAlert';
  description: Scalars['String'];
  end: Scalars['numeric'];
  event: Scalars['String'];
  sender_name: Scalars['String'];
  start: Scalars['numeric'];
  tags?: Maybe<Array<Scalars['String']>>;
};

export type ApplicationWeatherCurrent = {
  __typename?: 'ApplicationWeatherCurrent';
  cloudy: Scalars['Boolean'];
  humidity: Scalars['numeric'];
  pressure: Scalars['numeric'];
  sunrise: Scalars['timestamptz'];
  sunset: Scalars['timestamptz'];
  temperature: Scalars['numeric'];
  time: Scalars['timestamptz'];
  weatherIconId: Scalars['String'];
  windDegree: Scalars['numeric'];
  windGust: Scalars['numeric'];
  windSpeed: Scalars['numeric'];
};

export type ApplicationWeatherForecast = {
  __typename?: 'ApplicationWeatherForecast';
  cloudy: Scalars['Boolean'];
  humidity: Scalars['numeric'];
  pressure: Scalars['numeric'];
  temperature: ApplicationWeatherForecastTemperature;
  time: Scalars['timestamptz'];
  weatherIconId: Scalars['String'];
  windDegree: Scalars['numeric'];
  windGust: Scalars['numeric'];
  windSpeed: Scalars['numeric'];
};

export type ApplicationWeatherForecastTemperature = {
  __typename?: 'ApplicationWeatherForecastTemperature';
  max: Scalars['numeric'];
  min: Scalars['numeric'];
};

export type ApplicationWeatherInput = {
  application_id: Scalars['Int'];
};

export type ApplicationWeatherOutput = {
  __typename?: 'ApplicationWeatherOutput';
  weather: ApplicationWeather;
};

export type AreaCreateInput = {
  application_id: Scalars['Int'];
  cultivation?: InputMaybe<AreaScopeCultivation>;
  description?: InputMaybe<Scalars['String']>;
  device_ids: Array<InputMaybe<Scalars['Int']>>;
  icon: Scalars['json'];
  name: Scalars['String'];
  scope: ActionsAreaScopes;
};

export type AreaCreateOutput = {
  __typename?: 'AreaCreateOutput';
  id: Scalars['Int'];
};

export type AreaScopeCultivation = {
  clay_percentage?: InputMaybe<Scalars['Int']>;
  cultivation_type: ActionsCultivationTypes;
  farming_container?: InputMaybe<ActionsFarmingContainers>;
  farming_container_capacity?: InputMaybe<Scalars['Int']>;
  farming_method: ActionsFarmingMethods;
  farming_structure: ActionsFarmingStructures;
  organic_material_percentage?: InputMaybe<Scalars['Int']>;
  sand_percentage?: InputMaybe<Scalars['Int']>;
  substrate_id?: InputMaybe<Scalars['Int']>;
};

export type AreaUpdateInput = {
  area_id: Scalars['Int'];
  cultivation?: InputMaybe<AreaScopeCultivation>;
  description?: InputMaybe<Scalars['String']>;
  device_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  icon?: InputMaybe<Scalars['json']>;
  name?: InputMaybe<Scalars['String']>;
};

export type AreaUpdateOutput = {
  __typename?: 'AreaUpdateOutput';
  id: Scalars['Int'];
};

/** Asset system model */
export type Asset = Entity & Node & {
  __typename?: 'Asset';
  avatarAuthor: Array<Author>;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Asset>;
  /** The file name */
  fileName: Scalars['String'];
  /** The file handle */
  handle: Scalars['String'];
  /** The height of the file */
  height?: Maybe<Scalars['Float']>;
  /** List of Asset versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Asset>;
  /** The mime type of the file */
  mimeType?: Maybe<Scalars['String']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** The file size */
  size?: Maybe<Scalars['Float']>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** Returns information you need to upload the asset. The type of upload is dependant on what you pass into asset creations as upload type. */
  upload?: Maybe<AssetUpload>;
  /** Get the url for the asset with provided transformations applied. */
  url: Scalars['String'];
  /** The file width */
  width?: Maybe<Scalars['Float']>;
};


/** Asset system model */
export type AssetAvatarAuthorArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AuthorOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AuthorWhereInput>;
};


/** Asset system model */
export type AssetCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** Asset system model */
export type AssetHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


/** Asset system model */
export type AssetLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean'];
  locales?: Array<Locale>;
};


/** Asset system model */
export type AssetPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Asset system model */
export type AssetUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetUrlArgs = {
  transformation?: InputMaybe<AssetTransformationInput>;
};

/** A connection to a list of items. */
export type AssetConnection = {
  __typename?: 'AssetConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AssetEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AssetCreateInput = {
  avatarAuthor?: InputMaybe<AuthorCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fileName?: InputMaybe<Scalars['String']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<AssetCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']>;
};

export type AssetCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fileName?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']>;
};

export type AssetCreateLocalizationInput = {
  /** Localization input */
  data: AssetCreateLocalizationDataInput;
  locale: Locale;
};

export type AssetCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<AssetCreateLocalizationInput>>;
};

export type AssetCreateOneInlineInput = {
  /** Connect one existing Asset document */
  connect?: InputMaybe<AssetWhereUniqueInput>;
  /** Create and connect one Asset document */
  create?: InputMaybe<AssetCreateInput>;
};

/** An edge in a connection. */
export type AssetEdge = {
  __typename?: 'AssetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Asset;
};

/** Identifies documents */
export type AssetManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  avatarAuthor_every?: InputMaybe<AuthorWhereInput>;
  avatarAuthor_none?: InputMaybe<AuthorWhereInput>;
  avatarAuthor_some?: InputMaybe<AuthorWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AssetWhereStageInput>;
  documentInStages_none?: InputMaybe<AssetWhereStageInput>;
  documentInStages_some?: InputMaybe<AssetWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upload?: InputMaybe<AssetUploadWhereInput>;
};

export enum AssetOrderByInput {
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  FILENAME_ASC = 'fileName_ASC',
  FILENAME_DESC = 'fileName_DESC',
  HANDLE_ASC = 'handle_ASC',
  HANDLE_DESC = 'handle_DESC',
  HEIGHT_ASC = 'height_ASC',
  HEIGHT_DESC = 'height_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  MIMETYPE_ASC = 'mimeType_ASC',
  MIMETYPE_DESC = 'mimeType_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  SIZE_ASC = 'size_ASC',
  SIZE_DESC = 'size_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC',
  WIDTH_ASC = 'width_ASC',
  WIDTH_DESC = 'width_DESC'
}

/** Identifies documents */
export type AssetSingleRelationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  upload?: InputMaybe<AssetUploadWhereInput>;
};

/** Transformations for Assets */
export type AssetTransformationInput = {
  document?: InputMaybe<DocumentTransformationInput>;
  image?: InputMaybe<ImageTransformationInput>;
  /** Pass true if you want to validate the passed transformation parameters */
  validateOptions?: InputMaybe<Scalars['Boolean']>;
};

export type AssetUpdateInput = {
  avatarAuthor?: InputMaybe<AuthorUpdateManyInlineInput>;
  fileName?: InputMaybe<Scalars['String']>;
  /** Manage document localizations */
  localizations?: InputMaybe<AssetUpdateLocalizationsInput>;
  /** Use this to define if its a reupload for the asset */
  reUpload?: InputMaybe<Scalars['Boolean']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']>;
};

export type AssetUpdateLocalizationDataInput = {
  fileName?: InputMaybe<Scalars['String']>;
  /** Use this to define if its a reupload for the asset */
  reUpload?: InputMaybe<Scalars['Boolean']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']>;
};

export type AssetUpdateLocalizationInput = {
  data: AssetUpdateLocalizationDataInput;
  locale: Locale;
};

export type AssetUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<AssetCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<AssetUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<AssetUpsertLocalizationInput>>;
};

export type AssetUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']>;
};

export type AssetUpdateOneInlineInput = {
  /** Connect existing Asset document */
  connect?: InputMaybe<AssetWhereUniqueInput>;
  /** Create and connect one Asset document */
  create?: InputMaybe<AssetCreateInput>;
  /** Delete currently connected Asset document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected Asset document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single Asset document */
  update?: InputMaybe<AssetUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Asset document */
  upsert?: InputMaybe<AssetUpsertWithNestedWhereUniqueInput>;
};

export type AssetUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AssetUpdateInput;
  /** Unique document search */
  where: AssetWhereUniqueInput;
};

/** Asset Upload */
export type AssetUpload = {
  __typename?: 'AssetUpload';
  /** Asset Upload Error */
  error?: Maybe<AssetUploadError>;
  /** Expiry Timestamp */
  expiresAt?: Maybe<Scalars['DateTime']>;
  /** Asset Request Data for upload */
  requestPostData?: Maybe<AssetUploadRequestPostData>;
  /** Asset Request Data for upload */
  status?: Maybe<AssetUploadStatus>;
};

/** Represents asset upload error */
export type AssetUploadError = {
  __typename?: 'AssetUploadError';
  code: Scalars['String'];
  message: Scalars['String'];
};

/** Asset Upload Request Post Data */
export type AssetUploadRequestPostData = {
  __typename?: 'AssetUploadRequestPostData';
  /** The algorithm to use in the form field. This value should be passed in the `X-Amz-Algorithm` form field. */
  algorithm: Scalars['String'];
  /** The credential to use in the form field. This value should be passed in the `X-Amz-Credential` form field. */
  credential: Scalars['String'];
  /** The date the request was signed, formatted as YYYYMMDDTHHMMSSZ. This value should be passed in the `X-Amz-Date` header. */
  date: Scalars['String'];
  /** The key to use in the form field. This value should be passed in the `Key` form field. */
  key: Scalars['String'];
  /** The policy to use in the form field. This value should be passed in the `Policy` form field. */
  policy: Scalars['String'];
  /** The security token to use in the form field. This field is optional only pass it if its not null. This value should be passed in the `X-Amz-Security-Token` form field if not null. */
  securityToken?: Maybe<Scalars['String']>;
  /** The signature to use in the form field. This value should be passed in the `X-Amz-Signature` form field. */
  signature: Scalars['String'];
  /** The URL to which the file should be uploaded with a POST request. */
  url: Scalars['String'];
};

/** System Asset Upload Status */
export enum AssetUploadStatus {
  ASSET_CREATE_PENDING = 'ASSET_CREATE_PENDING',
  ASSET_ERROR_UPLOAD = 'ASSET_ERROR_UPLOAD',
  ASSET_UPDATE_PENDING = 'ASSET_UPDATE_PENDING',
  ASSET_UPLOAD_COMPLETE = 'ASSET_UPLOAD_COMPLETE'
}

/** Identifies documents */
export type AssetUploadWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetUploadWhereInput>>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  expiresAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  expiresAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  expiresAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  expiresAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  expiresAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  expiresAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  expiresAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  status?: InputMaybe<AssetUploadStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<AssetUploadStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
};

export type AssetUpsertInput = {
  /** Create document if it didn't exist */
  create: AssetCreateInput;
  /** Update document if it exists */
  update: AssetUpdateInput;
};

export type AssetUpsertLocalizationInput = {
  create: AssetCreateLocalizationDataInput;
  locale: Locale;
  update: AssetUpdateLocalizationDataInput;
};

export type AssetUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AssetUpsertInput;
  /** Unique document search */
  where: AssetWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AssetWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type AssetWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  avatarAuthor_every?: InputMaybe<AuthorWhereInput>;
  avatarAuthor_none?: InputMaybe<AuthorWhereInput>;
  avatarAuthor_some?: InputMaybe<AuthorWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AssetWhereStageInput>;
  documentInStages_none?: InputMaybe<AssetWhereStageInput>;
  documentInStages_some?: InputMaybe<AssetWhereStageInput>;
  fileName?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  fileName_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  fileName_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fileName_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  fileName_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  fileName_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  fileName_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  fileName_starts_with?: InputMaybe<Scalars['String']>;
  handle?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  handle_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  handle_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  handle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  handle_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  handle_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  handle_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  handle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  handle_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  handle_starts_with?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Float']>;
  /** All values greater than the given value. */
  height_gt?: InputMaybe<Scalars['Float']>;
  /** All values greater than or equal the given value. */
  height_gte?: InputMaybe<Scalars['Float']>;
  /** All values that are contained in given list. */
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** All values less than the given value. */
  height_lt?: InputMaybe<Scalars['Float']>;
  /** All values less than or equal the given value. */
  height_lte?: InputMaybe<Scalars['Float']>;
  /** Any other value that exists and is not equal to the given value. */
  height_not?: InputMaybe<Scalars['Float']>;
  /** All values that are not contained in given list. */
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  mimeType?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  mimeType_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  mimeType_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  mimeType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  mimeType_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  mimeType_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  mimeType_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  mimeType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  mimeType_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  mimeType_starts_with?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  size?: InputMaybe<Scalars['Float']>;
  /** All values greater than the given value. */
  size_gt?: InputMaybe<Scalars['Float']>;
  /** All values greater than or equal the given value. */
  size_gte?: InputMaybe<Scalars['Float']>;
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** All values less than the given value. */
  size_lt?: InputMaybe<Scalars['Float']>;
  /** All values less than or equal the given value. */
  size_lte?: InputMaybe<Scalars['Float']>;
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<Scalars['Float']>;
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upload?: InputMaybe<AssetUploadWhereInput>;
  width?: InputMaybe<Scalars['Float']>;
  /** All values greater than the given value. */
  width_gt?: InputMaybe<Scalars['Float']>;
  /** All values greater than or equal the given value. */
  width_gte?: InputMaybe<Scalars['Float']>;
  /** All values that are contained in given list. */
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** All values less than the given value. */
  width_lt?: InputMaybe<Scalars['Float']>;
  /** All values less than or equal the given value. */
  width_lte?: InputMaybe<Scalars['Float']>;
  /** Any other value that exists and is not equal to the given value. */
  width_not?: InputMaybe<Scalars['Float']>;
  /** All values that are not contained in given list. */
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AssetWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AssetWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Asset record uniquely */
export type AssetWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

/** List of publisher on Lualtek */
export type Author = Entity & Node & {
  __typename?: 'Author';
  /** Avatar associated to the author */
  avatar: Asset;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Author>;
  /** List of Author versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** Author displayed name on the application */
  name: Scalars['String'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** List of publisher on Lualtek */
export type AuthorAvatarArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** List of publisher on Lualtek */
export type AuthorCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** List of publisher on Lualtek */
export type AuthorDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** List of publisher on Lualtek */
export type AuthorHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


/** List of publisher on Lualtek */
export type AuthorPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** List of publisher on Lualtek */
export type AuthorScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** List of publisher on Lualtek */
export type AuthorUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AuthorConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AuthorWhereUniqueInput;
};

/** A connection to a list of items. */
export type AuthorConnection = {
  __typename?: 'AuthorConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AuthorEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AuthorCreateInput = {
  avatar: AssetCreateOneInlineInput;
  clht23zla26e701uo3rx16ld6?: InputMaybe<MessagesCollectionCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AuthorCreateManyInlineInput = {
  /** Connect multiple existing Author documents */
  connect?: InputMaybe<Array<AuthorWhereUniqueInput>>;
  /** Create and connect multiple existing Author documents */
  create?: InputMaybe<Array<AuthorCreateInput>>;
};

export type AuthorCreateOneInlineInput = {
  /** Connect one existing Author document */
  connect?: InputMaybe<AuthorWhereUniqueInput>;
  /** Create and connect one Author document */
  create?: InputMaybe<AuthorCreateInput>;
};

/** An edge in a connection. */
export type AuthorEdge = {
  __typename?: 'AuthorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Author;
};

/** Identifies documents */
export type AuthorManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AuthorWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AuthorWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AuthorWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  avatar?: InputMaybe<AssetWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AuthorWhereStageInput>;
  documentInStages_none?: InputMaybe<AuthorWhereStageInput>;
  documentInStages_some?: InputMaybe<AuthorWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum AuthorOrderByInput {
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  NAME_ASC = 'name_ASC',
  NAME_DESC = 'name_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

export type AuthorUpdateInput = {
  avatar?: InputMaybe<AssetUpdateOneInlineInput>;
  clht23zla26e701uo3rx16ld6?: InputMaybe<MessagesCollectionUpdateManyInlineInput>;
  name?: InputMaybe<Scalars['String']>;
};

export type AuthorUpdateManyInlineInput = {
  /** Connect multiple existing Author documents */
  connect?: InputMaybe<Array<AuthorConnectInput>>;
  /** Create and connect multiple Author documents */
  create?: InputMaybe<Array<AuthorCreateInput>>;
  /** Delete multiple Author documents */
  delete?: InputMaybe<Array<AuthorWhereUniqueInput>>;
  /** Disconnect multiple Author documents */
  disconnect?: InputMaybe<Array<AuthorWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Author documents */
  set?: InputMaybe<Array<AuthorWhereUniqueInput>>;
  /** Update multiple Author documents */
  update?: InputMaybe<Array<AuthorUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Author documents */
  upsert?: InputMaybe<Array<AuthorUpsertWithNestedWhereUniqueInput>>;
};

export type AuthorUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']>;
};

export type AuthorUpdateOneInlineInput = {
  /** Connect existing Author document */
  connect?: InputMaybe<AuthorWhereUniqueInput>;
  /** Create and connect one Author document */
  create?: InputMaybe<AuthorCreateInput>;
  /** Delete currently connected Author document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected Author document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single Author document */
  update?: InputMaybe<AuthorUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Author document */
  upsert?: InputMaybe<AuthorUpsertWithNestedWhereUniqueInput>;
};

export type AuthorUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AuthorUpdateInput;
  /** Unique document search */
  where: AuthorWhereUniqueInput;
};

export type AuthorUpsertInput = {
  /** Create document if it didn't exist */
  create: AuthorCreateInput;
  /** Update document if it exists */
  update: AuthorUpdateInput;
};

export type AuthorUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AuthorUpsertInput;
  /** Unique document search */
  where: AuthorWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AuthorWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type AuthorWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AuthorWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AuthorWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AuthorWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  avatar?: InputMaybe<AssetWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AuthorWhereStageInput>;
  documentInStages_none?: InputMaybe<AuthorWhereStageInput>;
  documentInStages_some?: InputMaybe<AuthorWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AuthorWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AuthorWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AuthorWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AuthorWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AuthorWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Author record uniquely */
export type AuthorWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export type AutomationDuplicateInput = {
  automation_id: Scalars['Int'];
};

export type AutomationDuplicateOutput = {
  __typename?: 'AutomationDuplicateOutput';
  id: Scalars['Int'];
};

export type BatchPayload = {
  __typename?: 'BatchPayload';
  /** The number of nodes that have been affected by the Batch operation. */
  count: Scalars['Long'];
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type BooleanComparisonExp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type CannyLoginCreateOutput = {
  __typename?: 'CannyLoginCreateOutput';
  token: Scalars['String'];
};

export type ChartLines = {
  __typename?: 'ChartLines';
  payloadKey: Scalars['String'];
  payloadType: Scalars['String'];
};

export type ChartPayload = {
  __typename?: 'ChartPayload';
  dataset?: Maybe<Scalars['dataset']>;
  lines?: Maybe<Array<ChartLines>>;
};

export type ConnectPositionInput = {
  /** Connect document after specified document */
  after?: InputMaybe<Scalars['ID']>;
  /** Connect document before specified document */
  before?: InputMaybe<Scalars['ID']>;
  /** Connect document at last position */
  end?: InputMaybe<Scalars['Boolean']>;
  /** Connect document at first position */
  start?: InputMaybe<Scalars['Boolean']>;
};

export type CreateUserInput = {
  email: Scalars['String'];
  organizationId: Scalars['Int'];
  shouldSendWelcomeEmail: Scalars['Boolean'];
};

export type CreateUserOutput = {
  __typename?: 'CreateUserOutput';
  id: Scalars['Int'];
};

export type DeviceDetailAvgMinMaxPayload = {
  __typename?: 'DeviceDetailAvgMinMaxPayload';
  avg?: Maybe<Scalars['Int']>;
  key: Scalars['String'];
  max?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
  payloadKind: Scalars['String'];
  type: Scalars['String'];
};

export type DeviceDetailInput = {
  device_id: Scalars['Int'];
  end_date?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['String']>;
};

export type DeviceDetailLastUplink = {
  __typename?: 'DeviceDetailLastUplink';
  key: Scalars['String'];
  kind: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
  value: Scalars['Int'];
};

export type DeviceDetailOutput = {
  __typename?: 'DeviceDetailOutput';
  avgPayloads: Array<DeviceDetailAvgMinMaxPayload>;
  chart?: Maybe<ChartPayload>;
  extraAvgPayloads: Array<DeviceDetailAvgMinMaxPayload>;
  hasDashboard: Scalars['Boolean'];
  id: Scalars['Int'];
  lastSeen?: Maybe<Scalars['timestamptz']>;
  lastUplink: Array<DeviceDetailLastUplink>;
  name: Scalars['String'];
  signal: DeviceDetailSignal;
};

export type DeviceDetailSignal = {
  __typename?: 'DeviceDetailSignal';
  rssi: Scalars['Int'];
  sentiment: Scalars['Int'];
  snr: Scalars['Int'];
};

export type DeviceDownlinkInput = {
  action_id: Scalars['Int'];
  device_id: Scalars['Int'];
};

export type DeviceDownlinkOutput = {
  __typename?: 'DeviceDownlinkOutput';
  id: Scalars['Int'];
};

export type DeviceLastUplink = {
  __typename?: 'DeviceLastUplink';
  key: Scalars['String'];
  kind: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
  value: Scalars['Int'];
};

export type DeviceLastUplinkInput = {
  device_id: Scalars['Int'];
};

export type DeviceLastUplinkOutput = {
  __typename?: 'DeviceLastUplinkOutput';
  chart?: Maybe<ChartPayload>;
  lastSeen?: Maybe<Scalars['timestamptz']>;
  lastUplink: Array<DeviceLastUplink>;
};

export enum DocumentFileTypes {
  /** Automatically selects the best format for the image based on the browser's capabilities. */
  AUTOIMAGE = 'autoImage',
  AVIF = 'avif',
  BMP = 'bmp',
  GIF = 'gif',
  HEIC = 'heic',
  JPG = 'jpg',
  PNG = 'png',
  SVG = 'svg',
  TIFF = 'tiff',
  WEBP = 'webp'
}

export type DocumentOutputInput = {
  /**
   * Transforms a document into a desired file type.
   * See this matrix for format support:
   *
   * JPG:	autoImage, bmp, gif, jpg, png, webp, tiff
   * PNG:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * SVG:	autoImage, bmp, gif, jpg, png, webp, tiff
   * WEBP:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * GIF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * TIFF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * AVIF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * PDF: 	autoImage, gif, jpg, png, webp, tiff
   *
   */
  format?: InputMaybe<DocumentFileTypes>;
};

/** Transformations for Documents */
export type DocumentTransformationInput = {
  /** Changes the output for the file. */
  output?: InputMaybe<DocumentOutputInput>;
};

export type DocumentVersion = {
  __typename?: 'DocumentVersion';
  createdAt: Scalars['DateTime'];
  data?: Maybe<Scalars['Json']>;
  id: Scalars['ID'];
  revision: Scalars['Int'];
  stage: Stage;
};

/** An object with an ID */
export type Entity = {
  /** The id of the object. */
  id: Scalars['ID'];
  /** The Stage of an object */
  stage: Stage;
};

/** This enumeration holds all typenames that implement the Entity interface. Components and models implement the Entity interface. */
export enum EntityTypeName {
  /** Asset system model */
  ASSET = 'Asset',
  /** List of publisher on Lualtek */
  AUTHOR = 'Author',
  /** Show a notification as Message */
  MESSAGE = 'Message',
  /** Collection of messages from Lualtek */
  MESSAGESCOLLECTION = 'MessagesCollection',
  RELEASE = 'Release',
  /** Collection of console releases from Lualtek */
  RELEASESCOLLECTION = 'ReleasesCollection',
  /** Scheduled Operation system model */
  SCHEDULEDOPERATION = 'ScheduledOperation',
  /** Scheduled Release system model */
  SCHEDULEDRELEASE = 'ScheduledRelease',
  /** User system model */
  USER = 'User'
}

/** Allows to specify input to query models and components directly */
export type EntityWhereInput = {
  /** The ID of an object */
  id: Scalars['ID'];
  locale?: InputMaybe<Locale>;
  stage: Stage;
  /** The Type name of an object */
  typename: EntityTypeName;
};

export type ImageBlurInput = {
  /** The amount of blurring to apply to the image. The value must be an integer from 1 to 20. */
  amount: Scalars['Int'];
};

/** Adds a border to the image. */
export type ImageBorderInput = {
  /** The background color of the border. The value must be a valid hex color code. Or one of the supported color names. */
  background: Scalars['String'];
  /** The color of the border. The value must be a valid hex color code. Or one of the supported color names. */
  color: Scalars['String'];
  /** The width of the border in pixels. The value must be an integer from 1 to 1000. */
  width: Scalars['Int'];
};

export type ImageCompressInput = {
  /** Preserves the metadata of the image. */
  metadata: Scalars['Boolean'];
};

/**
 * Crops the image to the specified dimensions.
 * The starting points for X and Y coordinates are [0,0], aligning with the top-left corner of the image.
 * The width and height parameters determine the size in pixels of the cropping rectangle.
 * The output will include only the portion of the image within the designated crop area.
 */
export type ImageCropInput = {
  /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  height: Scalars['Int'];
  /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  width: Scalars['Int'];
  /** The x coordinate of the image. The value must be an integer from 0 to 10000. */
  x: Scalars['Int'];
  /** The y coordinate of the image. The value must be an integer from 0 to 10000. */
  y: Scalars['Int'];
};

export enum ImageFit {
  /** Resizes the image to fit within the specified parameters without distorting, cropping, or changing the aspect ratio. */
  CLIP = 'clip',
  /** Resizes the image to fit the specified parameters exactly by removing any parts of the image that don't fit within the boundaries. */
  CROP = 'crop',
  /** Resizes the image to fit within the parameters, but as opposed to 'fit:clip' will not scale the image if the image is smaller than the output size. */
  MAX = 'max',
  /** Resizes the image to fit the specified parameters exactly by scaling the image to the desired size. The aspect ratio of the image is not respected and the image can be distorted using this method. */
  SCALE = 'scale'
}

export type ImageQualityInput = {
  /** The quality of the image. The value must be an integer from 1 to 100. */
  value: Scalars['Int'];
};

export type ImageResizeInput = {
  /** The default value for the fit parameter is fit:clip. */
  fit?: InputMaybe<ImageFit>;
  /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  height?: InputMaybe<Scalars['Int']>;
  /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  width?: InputMaybe<Scalars['Int']>;
};

export type ImageSharpenInput = {
  /** The amount of sharpening to apply to the image. The value must be an integer from 1 to 20. */
  amount: Scalars['Int'];
};

/** Transformations for Images */
export type ImageTransformationInput = {
  /** Blurs the image. */
  blur?: InputMaybe<ImageBlurInput>;
  /** Adds a border to the image. */
  border?: InputMaybe<ImageBorderInput>;
  /** Compresses the image. */
  compress?: InputMaybe<ImageCompressInput>;
  /** Crops the image to the specified dimensions. */
  crop?: InputMaybe<ImageCropInput>;
  /**
   * Changes the quality of the image. The value must be an integer from 1 to 100.
   * Only supported for the following formats jpeg, jpg, webp, gif, heif, tiff, avif.
   */
  quality?: InputMaybe<ImageQualityInput>;
  /** Resizes the image */
  resize?: InputMaybe<ImageResizeInput>;
  /** Sharpens the image. */
  sharpen?: InputMaybe<ImageSharpenInput>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntComparisonExp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** Locale system enumeration */
export enum Locale {
  /** System locale */
  EN = 'en',
  IT = 'it'
}

/** Show a notification as Message */
export type Message = Entity & {
  __typename?: 'Message';
  content: RichText;
  /** Short extracted text about the notification content */
  excerpt?: Maybe<Scalars['String']>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Message>;
  shortTitle: Scalars['String'];
  /** System stage field */
  stage: Stage;
  title: Scalars['String'];
};


/** Show a notification as Message */
export type MessageLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean'];
  locales?: Array<Locale>;
};

export type MessageCreateInput = {
  /** content input for default locale (en) */
  content: Scalars['RichTextAST'];
  /** excerpt input for default locale (en) */
  excerpt?: InputMaybe<Scalars['String']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<MessageCreateLocalizationsInput>;
  /** shortTitle input for default locale (en) */
  shortTitle: Scalars['String'];
  /** title input for default locale (en) */
  title: Scalars['String'];
};

export type MessageCreateLocalizationDataInput = {
  content: Scalars['RichTextAST'];
  excerpt?: InputMaybe<Scalars['String']>;
  shortTitle: Scalars['String'];
  title: Scalars['String'];
};

export type MessageCreateLocalizationInput = {
  /** Localization input */
  data: MessageCreateLocalizationDataInput;
  locale: Locale;
};

export type MessageCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<MessageCreateLocalizationInput>>;
};

export type MessageCreateOneInlineInput = {
  /** Create and connect one Message document */
  create?: InputMaybe<MessageCreateInput>;
};

export type MessageUpdateInput = {
  /** content input for default locale (en) */
  content?: InputMaybe<Scalars['RichTextAST']>;
  /** excerpt input for default locale (en) */
  excerpt?: InputMaybe<Scalars['String']>;
  /** Manage document localizations */
  localizations?: InputMaybe<MessageUpdateLocalizationsInput>;
  /** shortTitle input for default locale (en) */
  shortTitle?: InputMaybe<Scalars['String']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']>;
};

export type MessageUpdateLocalizationDataInput = {
  content?: InputMaybe<Scalars['RichTextAST']>;
  excerpt?: InputMaybe<Scalars['String']>;
  shortTitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type MessageUpdateLocalizationInput = {
  data: MessageUpdateLocalizationDataInput;
  locale: Locale;
};

export type MessageUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<MessageCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<MessageUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<MessageUpsertLocalizationInput>>;
};

export type MessageUpdateOneInlineInput = {
  /** Create and connect one Message document */
  create?: InputMaybe<MessageCreateInput>;
  /** Delete currently connected Message document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Update single Message document */
  update?: InputMaybe<MessageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Message document */
  upsert?: InputMaybe<MessageUpsertWithNestedWhereUniqueInput>;
};

export type MessageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: MessageUpdateInput;
  /** Unique document search */
  where: MessageWhereUniqueInput;
};

export type MessageUpsertInput = {
  /** Create document if it didn't exist */
  create: MessageCreateInput;
  /** Update document if it exists */
  update: MessageUpdateInput;
};

export type MessageUpsertLocalizationInput = {
  create: MessageCreateLocalizationDataInput;
  locale: Locale;
  update: MessageUpdateLocalizationDataInput;
};

export type MessageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: MessageUpsertInput;
  /** Unique document search */
  where: MessageWhereUniqueInput;
};

/** Identifies documents */
export type MessageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MessageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MessageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MessageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  excerpt?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  excerpt_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  excerpt_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  excerpt_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  excerpt_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  excerpt_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  excerpt_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  excerpt_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  excerpt_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  excerpt_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  shortTitle?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  shortTitle_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  shortTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  shortTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  shortTitle_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  shortTitle_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  shortTitle_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  shortTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  shortTitle_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  shortTitle_starts_with?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']>;
};

/** References Message record uniquely */
export type MessageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

/** Collection of messages from Lualtek */
export type MessagesCollection = Entity & Node & {
  __typename?: 'MessagesCollection';
  /** Publish this message as this author */
  author?: Maybe<Author>;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<MessagesCollection>;
  /** List of MessagesCollection versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  message: Message;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['String']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Collection of messages from Lualtek */
export type MessagesCollectionAuthorArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Collection of messages from Lualtek */
export type MessagesCollectionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Collection of messages from Lualtek */
export type MessagesCollectionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** Collection of messages from Lualtek */
export type MessagesCollectionHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


/** Collection of messages from Lualtek */
export type MessagesCollectionMessageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Collection of messages from Lualtek */
export type MessagesCollectionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Collection of messages from Lualtek */
export type MessagesCollectionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Collection of messages from Lualtek */
export type MessagesCollectionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type MessagesCollectionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: MessagesCollectionWhereUniqueInput;
};

/** A connection to a list of items. */
export type MessagesCollectionConnection = {
  __typename?: 'MessagesCollectionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<MessagesCollectionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type MessagesCollectionCreateInput = {
  author?: InputMaybe<AuthorCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<MessagesCollectionCreateLocalizationsInput>;
  message: MessageCreateOneInlineInput;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MessagesCollectionCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MessagesCollectionCreateLocalizationInput = {
  /** Localization input */
  data: MessagesCollectionCreateLocalizationDataInput;
  locale: Locale;
};

export type MessagesCollectionCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<MessagesCollectionCreateLocalizationInput>>;
};

export type MessagesCollectionCreateManyInlineInput = {
  /** Connect multiple existing MessagesCollection documents */
  connect?: InputMaybe<Array<MessagesCollectionWhereUniqueInput>>;
  /** Create and connect multiple existing MessagesCollection documents */
  create?: InputMaybe<Array<MessagesCollectionCreateInput>>;
};

/** An edge in a connection. */
export type MessagesCollectionEdge = {
  __typename?: 'MessagesCollectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: MessagesCollection;
};

/** Identifies documents */
export type MessagesCollectionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MessagesCollectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MessagesCollectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MessagesCollectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  author?: InputMaybe<AuthorWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<MessagesCollectionWhereStageInput>;
  documentInStages_none?: InputMaybe<MessagesCollectionWhereStageInput>;
  documentInStages_some?: InputMaybe<MessagesCollectionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  message?: InputMaybe<MessageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum MessagesCollectionOrderByInput {
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

export type MessagesCollectionUpdateInput = {
  author?: InputMaybe<AuthorUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<MessagesCollectionUpdateLocalizationsInput>;
  message?: InputMaybe<MessageUpdateOneInlineInput>;
};

export type MessagesCollectionUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<MessagesCollectionCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
};

export type MessagesCollectionUpdateManyInlineInput = {
  /** Connect multiple existing MessagesCollection documents */
  connect?: InputMaybe<Array<MessagesCollectionConnectInput>>;
  /** Create and connect multiple MessagesCollection documents */
  create?: InputMaybe<Array<MessagesCollectionCreateInput>>;
  /** Delete multiple MessagesCollection documents */
  delete?: InputMaybe<Array<MessagesCollectionWhereUniqueInput>>;
  /** Disconnect multiple MessagesCollection documents */
  disconnect?: InputMaybe<Array<MessagesCollectionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing MessagesCollection documents */
  set?: InputMaybe<Array<MessagesCollectionWhereUniqueInput>>;
  /** Update multiple MessagesCollection documents */
  update?: InputMaybe<Array<MessagesCollectionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple MessagesCollection documents */
  upsert?: InputMaybe<Array<MessagesCollectionUpsertWithNestedWhereUniqueInput>>;
};

export type MessagesCollectionUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']>;
};

export type MessagesCollectionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: MessagesCollectionUpdateInput;
  /** Unique document search */
  where: MessagesCollectionWhereUniqueInput;
};

export type MessagesCollectionUpsertInput = {
  /** Create document if it didn't exist */
  create: MessagesCollectionCreateInput;
  /** Update document if it exists */
  update: MessagesCollectionUpdateInput;
};

export type MessagesCollectionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: MessagesCollectionUpsertInput;
  /** Unique document search */
  where: MessagesCollectionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type MessagesCollectionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type MessagesCollectionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MessagesCollectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MessagesCollectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MessagesCollectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  author?: InputMaybe<AuthorWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<MessagesCollectionWhereStageInput>;
  documentInStages_none?: InputMaybe<MessagesCollectionWhereStageInput>;
  documentInStages_some?: InputMaybe<MessagesCollectionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  message?: InputMaybe<MessageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type MessagesCollectionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MessagesCollectionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MessagesCollectionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MessagesCollectionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<MessagesCollectionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References MessagesCollection record uniquely */
export type MessagesCollectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

/** An object with an ID */
export type Node = {
  /** The id of the object. */
  id: Scalars['ID'];
  /** The Stage of an object */
  stage: Stage;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Number of items in the current page. */
  pageSize?: Maybe<Scalars['Int']>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type Release = Entity & {
  __typename?: 'Release';
  /** List of changes */
  changed: Array<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Release>;
  new: Array<Scalars['String']>;
  /** System stage field */
  stage: Stage;
  version?: Maybe<Scalars['String']>;
};


export type ReleaseLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean'];
  locales?: Array<Locale>;
};

export type ReleaseCreateInput = {
  /** changed input for default locale (en) */
  changed?: InputMaybe<Array<Scalars['String']>>;
  /** content input for default locale (en) */
  content?: InputMaybe<Scalars['String']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ReleaseCreateLocalizationsInput>;
  /** new input for default locale (en) */
  new?: InputMaybe<Array<Scalars['String']>>;
  version?: InputMaybe<Scalars['String']>;
};

export type ReleaseCreateLocalizationDataInput = {
  changed?: InputMaybe<Array<Scalars['String']>>;
  content?: InputMaybe<Scalars['String']>;
  new?: InputMaybe<Array<Scalars['String']>>;
};

export type ReleaseCreateLocalizationInput = {
  /** Localization input */
  data: ReleaseCreateLocalizationDataInput;
  locale: Locale;
};

export type ReleaseCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ReleaseCreateLocalizationInput>>;
};

export type ReleaseCreateOneInlineInput = {
  /** Create and connect one Release document */
  create?: InputMaybe<ReleaseCreateInput>;
};

export type ReleaseUpdateInput = {
  /** changed input for default locale (en) */
  changed?: InputMaybe<Array<Scalars['String']>>;
  /** content input for default locale (en) */
  content?: InputMaybe<Scalars['String']>;
  /** Manage document localizations */
  localizations?: InputMaybe<ReleaseUpdateLocalizationsInput>;
  /** new input for default locale (en) */
  new?: InputMaybe<Array<Scalars['String']>>;
  version?: InputMaybe<Scalars['String']>;
};

export type ReleaseUpdateLocalizationDataInput = {
  changed?: InputMaybe<Array<Scalars['String']>>;
  content?: InputMaybe<Scalars['String']>;
  new?: InputMaybe<Array<Scalars['String']>>;
};

export type ReleaseUpdateLocalizationInput = {
  data: ReleaseUpdateLocalizationDataInput;
  locale: Locale;
};

export type ReleaseUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ReleaseCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<ReleaseUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<ReleaseUpsertLocalizationInput>>;
};

export type ReleaseUpdateOneInlineInput = {
  /** Create and connect one Release document */
  create?: InputMaybe<ReleaseCreateInput>;
  /** Delete currently connected Release document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Update single Release document */
  update?: InputMaybe<ReleaseUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Release document */
  upsert?: InputMaybe<ReleaseUpsertWithNestedWhereUniqueInput>;
};

export type ReleaseUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ReleaseUpdateInput;
  /** Unique document search */
  where: ReleaseWhereUniqueInput;
};

export type ReleaseUpsertInput = {
  /** Create document if it didn't exist */
  create: ReleaseCreateInput;
  /** Update document if it exists */
  update: ReleaseUpdateInput;
};

export type ReleaseUpsertLocalizationInput = {
  create: ReleaseCreateLocalizationDataInput;
  locale: Locale;
  update: ReleaseUpdateLocalizationDataInput;
};

export type ReleaseUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ReleaseUpsertInput;
  /** Unique document search */
  where: ReleaseWhereUniqueInput;
};

/** Identifies documents */
export type ReleaseWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ReleaseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ReleaseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ReleaseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  changed?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  changed_contains_all?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  changed_contains_none?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  changed_contains_some?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  changed_not?: InputMaybe<Array<Scalars['String']>>;
  content?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  content_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  content_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  content_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  content_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  content_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  content_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  content_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  content_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  content_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  new?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  new_contains_all?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  new_contains_none?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  new_contains_some?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  new_not?: InputMaybe<Array<Scalars['String']>>;
  version?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  version_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  version_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  version_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  version_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  version_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  version_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  version_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  version_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  version_starts_with?: InputMaybe<Scalars['String']>;
};

/** References Release record uniquely */
export type ReleaseWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

/** Collection of console releases from Lualtek */
export type ReleasesCollection = Entity & Node & {
  __typename?: 'ReleasesCollection';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<ReleasesCollection>;
  /** List of ReleasesCollection versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['String']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  release: Release;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Collection of console releases from Lualtek */
export type ReleasesCollectionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Collection of console releases from Lualtek */
export type ReleasesCollectionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** Collection of console releases from Lualtek */
export type ReleasesCollectionHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


/** Collection of console releases from Lualtek */
export type ReleasesCollectionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Collection of console releases from Lualtek */
export type ReleasesCollectionReleaseArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Collection of console releases from Lualtek */
export type ReleasesCollectionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Collection of console releases from Lualtek */
export type ReleasesCollectionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** A connection to a list of items. */
export type ReleasesCollectionConnection = {
  __typename?: 'ReleasesCollectionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ReleasesCollectionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ReleasesCollectionCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ReleasesCollectionCreateLocalizationsInput>;
  release: ReleaseCreateOneInlineInput;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReleasesCollectionCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReleasesCollectionCreateLocalizationInput = {
  /** Localization input */
  data: ReleasesCollectionCreateLocalizationDataInput;
  locale: Locale;
};

export type ReleasesCollectionCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ReleasesCollectionCreateLocalizationInput>>;
};

/** An edge in a connection. */
export type ReleasesCollectionEdge = {
  __typename?: 'ReleasesCollectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ReleasesCollection;
};

/** Identifies documents */
export type ReleasesCollectionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ReleasesCollectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ReleasesCollectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ReleasesCollectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ReleasesCollectionWhereStageInput>;
  documentInStages_none?: InputMaybe<ReleasesCollectionWhereStageInput>;
  documentInStages_some?: InputMaybe<ReleasesCollectionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  release?: InputMaybe<ReleaseWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ReleasesCollectionOrderByInput {
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

export type ReleasesCollectionUpdateInput = {
  /** Manage document localizations */
  localizations?: InputMaybe<ReleasesCollectionUpdateLocalizationsInput>;
  release?: InputMaybe<ReleaseUpdateOneInlineInput>;
};

export type ReleasesCollectionUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ReleasesCollectionCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
};

export type ReleasesCollectionUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']>;
};

export type ReleasesCollectionUpsertInput = {
  /** Create document if it didn't exist */
  create: ReleasesCollectionCreateInput;
  /** Update document if it exists */
  update: ReleasesCollectionUpdateInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ReleasesCollectionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type ReleasesCollectionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ReleasesCollectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ReleasesCollectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ReleasesCollectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ReleasesCollectionWhereStageInput>;
  documentInStages_none?: InputMaybe<ReleasesCollectionWhereStageInput>;
  documentInStages_some?: InputMaybe<ReleasesCollectionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  release?: InputMaybe<ReleaseWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ReleasesCollectionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ReleasesCollectionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ReleasesCollectionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ReleasesCollectionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ReleasesCollectionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ReleasesCollection record uniquely */
export type ReleasesCollectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

/** Custom type representing a rich text value comprising of raw rich text ast, html, markdown and text values */
export type RichText = {
  __typename?: 'RichText';
  /** Returns HTMl representation */
  html: Scalars['String'];
  /** Returns Markdown representation */
  markdown: Scalars['String'];
  /** Returns AST representation */
  raw?: Maybe<Scalars['richtextraw']>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String'];
};

/** Scheduled Operation system model */
export type ScheduledOperation = Entity & Node & {
  __typename?: 'ScheduledOperation';
  affectedDocuments: Array<ScheduledOperationAffectedDocument>;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Operation description */
  description?: Maybe<Scalars['String']>;
  /** Get the document in other stages */
  documentInStages: Array<ScheduledOperation>;
  /** Operation error message */
  errorMessage?: Maybe<Scalars['String']>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Raw operation payload including all details, this field is subject to change */
  rawPayload: Scalars['Json'];
  /** The release this operation is scheduled for */
  release?: Maybe<ScheduledRelease>;
  /** System stage field */
  stage: Stage;
  /** operation Status */
  status: ScheduledOperationStatus;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Scheduled Operation system model */
export type ScheduledOperationAffectedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** Scheduled Operation system model */
export type ScheduledOperationCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** Scheduled Operation system model */
export type ScheduledOperationPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationReleaseArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ScheduledOperationAffectedDocument = Asset | Author | MessagesCollection | ReleasesCollection;

/** A connection to a list of items. */
export type ScheduledOperationConnection = {
  __typename?: 'ScheduledOperationConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ScheduledOperationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ScheduledOperationEdge = {
  __typename?: 'ScheduledOperationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ScheduledOperation;
};

export enum ScheduledOperationOrderByInput {
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  DESCRIPTION_ASC = 'description_ASC',
  DESCRIPTION_DESC = 'description_DESC',
  ERRORMESSAGE_ASC = 'errorMessage_ASC',
  ERRORMESSAGE_DESC = 'errorMessage_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  STATUS_ASC = 'status_ASC',
  STATUS_DESC = 'status_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

/** System Scheduled Operation Status */
export enum ScheduledOperationStatus {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING'
}

/** Identifies documents */
export type ScheduledOperationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values containing the given json path. */
  rawPayload_json_path_exists?: InputMaybe<Scalars['String']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  rawPayload_value_recursive?: InputMaybe<Scalars['Json']>;
  release?: InputMaybe<ScheduledReleaseWhereInput>;
  status?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** References ScheduledOperation record uniquely */
export type ScheduledOperationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

/** Scheduled Release system model */
export type ScheduledRelease = Entity & Node & {
  __typename?: 'ScheduledRelease';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Release description */
  description?: Maybe<Scalars['String']>;
  /** Get the document in other stages */
  documentInStages: Array<ScheduledRelease>;
  /** Release error message */
  errorMessage?: Maybe<Scalars['String']>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** Whether scheduled release should be run */
  isActive: Scalars['Boolean'];
  /** Whether scheduled release is implicit */
  isImplicit: Scalars['Boolean'];
  /** Operations to run with this release */
  operations: Array<ScheduledOperation>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Release date and time */
  releaseAt?: Maybe<Scalars['DateTime']>;
  /** System stage field */
  stage: Stage;
  /** Release Status */
  status: ScheduledReleaseStatus;
  /** Release Title */
  title?: Maybe<Scalars['String']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Scheduled Release system model */
export type ScheduledReleaseCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Release system model */
export type ScheduledReleaseDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** Scheduled Release system model */
export type ScheduledReleaseOperationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Scheduled Release system model */
export type ScheduledReleasePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Release system model */
export type ScheduledReleaseUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** A connection to a list of items. */
export type ScheduledReleaseConnection = {
  __typename?: 'ScheduledReleaseConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ScheduledReleaseEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ScheduledReleaseCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

/** An edge in a connection. */
export type ScheduledReleaseEdge = {
  __typename?: 'ScheduledReleaseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ScheduledRelease;
};

export enum ScheduledReleaseOrderByInput {
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  DESCRIPTION_ASC = 'description_ASC',
  DESCRIPTION_DESC = 'description_DESC',
  ERRORMESSAGE_ASC = 'errorMessage_ASC',
  ERRORMESSAGE_DESC = 'errorMessage_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  ISACTIVE_ASC = 'isActive_ASC',
  ISACTIVE_DESC = 'isActive_DESC',
  ISIMPLICIT_ASC = 'isImplicit_ASC',
  ISIMPLICIT_DESC = 'isImplicit_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  RELEASEAT_ASC = 'releaseAt_ASC',
  RELEASEAT_DESC = 'releaseAt_DESC',
  STATUS_ASC = 'status_ASC',
  STATUS_DESC = 'status_DESC',
  TITLE_ASC = 'title_ASC',
  TITLE_DESC = 'title_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

/** System Scheduled Release Status */
export enum ScheduledReleaseStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING'
}

export type ScheduledReleaseUpdateInput = {
  description?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
};

/** Identifies documents */
export type ScheduledReleaseWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']>;
  isImplicit?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isImplicit_not?: InputMaybe<Scalars['Boolean']>;
  operations_every?: InputMaybe<ScheduledOperationWhereInput>;
  operations_none?: InputMaybe<ScheduledOperationWhereInput>;
  operations_some?: InputMaybe<ScheduledOperationWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  releaseAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  releaseAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  releaseAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  releaseAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  releaseAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  releaseAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  releaseAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  status?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  title?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** References ScheduledRelease record uniquely */
export type ScheduledReleaseWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

/** Stage system enumeration */
export enum Stage {
  /** The Draft is the default stage for all your content. */
  DRAFT = 'DRAFT',
  /** The Published stage is where you can publish your content to. */
  PUBLISHED = 'PUBLISHED'
}

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringComparisonExp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

export enum SystemDateTimeFieldVariation {
  BASE = 'BASE',
  COMBINED = 'COMBINED',
  LOCALIZATION = 'LOCALIZATION'
}

/** User system model */
export type User = Entity & Node & {
  __typename?: 'User';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** Get the document in other stages */
  documentInStages: Array<User>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** Flag to determine if user is active or not */
  isActive: Scalars['Boolean'];
  /** User Kind. Can be either MEMBER, PAT or PUBLIC */
  kind: UserKind;
  /** The username */
  name: Scalars['String'];
  /** Profile Picture url */
  picture?: Maybe<Scalars['String']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
};


/** User system model */
export type UserDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};

/** A connection to a list of items. */
export type UserConnection = {
  __typename?: 'UserConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<UserEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: User;
};

/** System User Kind */
export enum UserKind {
  APP_TOKEN = 'APP_TOKEN',
  MEMBER = 'MEMBER',
  PAT = 'PAT',
  PUBLIC = 'PUBLIC',
  WEBHOOK = 'WEBHOOK'
}

export enum UserOrderByInput {
  CREATEDAT_ASC = 'createdAt_ASC',
  CREATEDAT_DESC = 'createdAt_DESC',
  ID_ASC = 'id_ASC',
  ID_DESC = 'id_DESC',
  ISACTIVE_ASC = 'isActive_ASC',
  ISACTIVE_DESC = 'isActive_DESC',
  KIND_ASC = 'kind_ASC',
  KIND_DESC = 'kind_DESC',
  NAME_ASC = 'name_ASC',
  NAME_DESC = 'name_DESC',
  PICTURE_ASC = 'picture_ASC',
  PICTURE_DESC = 'picture_DESC',
  PUBLISHEDAT_ASC = 'publishedAt_ASC',
  PUBLISHEDAT_DESC = 'publishedAt_DESC',
  UPDATEDAT_ASC = 'updatedAt_ASC',
  UPDATEDAT_DESC = 'updatedAt_DESC'
}

/** This contains a set of filters that can be used to compare values internally */
export type UserWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type UserWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  documentInStages_every?: InputMaybe<UserWhereStageInput>;
  documentInStages_none?: InputMaybe<UserWhereStageInput>;
  documentInStages_some?: InputMaybe<UserWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<UserKind>;
  /** All values that are contained in given list. */
  kind_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  /** Any other value that exists and is not equal to the given value. */
  kind_not?: InputMaybe<UserKind>;
  /** All values that are not contained in given list. */
  kind_not_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  name?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  picture?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  picture_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  picture_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  picture_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  picture_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  picture_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  picture_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  picture_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  picture_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  picture_starts_with?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type UserWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<UserWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References User record uniquely */
export type UserWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type Version = {
  __typename?: 'Version';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  revision: Scalars['Int'];
  stage: Stage;
};

export type VersionWhereInput = {
  id: Scalars['ID'];
  revision: Scalars['Int'];
  stage: Stage;
};

/** Implemented data analysis */
export type Analysis = {
  __typename?: 'analysis';
  /** An array relationship */
  analysis__devices_payloads: Array<AnalysisDevicesPayloads>;
  /** An aggregate relationship */
  analysis__devices_payloads_aggregate: AnalysisDevicesPayloadsAggregate;
  /** An array relationship */
  analysis_applications: Array<AnalysisApplications>;
  /** An aggregate relationship */
  analysis_applications_aggregate: AnalysisApplicationsAggregate;
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  device_categories_configs: Array<AnalysisDeviceCategoriesConfigs>;
  /** An aggregate relationship */
  device_categories_configs_aggregate: AnalysisDeviceCategoriesConfigsAggregate;
  enabled: Scalars['Boolean'];
  group: AnalysisGroupsEnum;
  id: Scalars['Int'];
  kind: AnalysisKindsEnum;
  name: Scalars['String'];
  slug: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};


/** Implemented data analysis */
export type AnalysisAnalysisDevicesPayloadsArgs = {
  distinct_on?: InputMaybe<Array<AnalysisDevicesPayloadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisDevicesPayloadsOrderBy>>;
  where?: InputMaybe<AnalysisDevicesPayloadsBoolExp>;
};


/** Implemented data analysis */
export type AnalysisAnalysisDevicesPayloadsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AnalysisDevicesPayloadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisDevicesPayloadsOrderBy>>;
  where?: InputMaybe<AnalysisDevicesPayloadsBoolExp>;
};


/** Implemented data analysis */
export type AnalysisAnalysisApplicationsArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsBoolExp>;
};


/** Implemented data analysis */
export type AnalysisAnalysisApplicationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsBoolExp>;
};


/** Implemented data analysis */
export type AnalysisDeviceCategoriesConfigsArgs = {
  distinct_on?: InputMaybe<Array<AnalysisDeviceCategoriesConfigsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisDeviceCategoriesConfigsOrderBy>>;
  where?: InputMaybe<AnalysisDeviceCategoriesConfigsBoolExp>;
};


/** Implemented data analysis */
export type AnalysisDeviceCategoriesConfigsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AnalysisDeviceCategoriesConfigsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisDeviceCategoriesConfigsOrderBy>>;
  where?: InputMaybe<AnalysisDeviceCategoriesConfigsBoolExp>;
};

/** Payloads related to analysis */
export type AnalysisDevicesPayloads = {
  __typename?: 'analysis__devices_payloads';
  /** An object relationship */
  analysis: Analysis;
  analysis_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  device_payload_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  payload: DevicePayloads;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "analysis__devices_payloads" */
export type AnalysisDevicesPayloadsAggregate = {
  __typename?: 'analysis__devices_payloads_aggregate';
  aggregate?: Maybe<AnalysisDevicesPayloadsAggregateFields>;
  nodes: Array<AnalysisDevicesPayloads>;
};

export type AnalysisDevicesPayloadsAggregateBoolExp = {
  count?: InputMaybe<AnalysisDevicesPayloadsAggregateBoolExpCount>;
};

export type AnalysisDevicesPayloadsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AnalysisDevicesPayloadsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AnalysisDevicesPayloadsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "analysis__devices_payloads" */
export type AnalysisDevicesPayloadsAggregateFields = {
  __typename?: 'analysis__devices_payloads_aggregate_fields';
  avg?: Maybe<AnalysisDevicesPayloadsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AnalysisDevicesPayloadsMaxFields>;
  min?: Maybe<AnalysisDevicesPayloadsMinFields>;
  stddev?: Maybe<AnalysisDevicesPayloadsStddevFields>;
  stddev_pop?: Maybe<AnalysisDevicesPayloadsStddevPopFields>;
  stddev_samp?: Maybe<AnalysisDevicesPayloadsStddevSampFields>;
  sum?: Maybe<AnalysisDevicesPayloadsSumFields>;
  var_pop?: Maybe<AnalysisDevicesPayloadsVarPopFields>;
  var_samp?: Maybe<AnalysisDevicesPayloadsVarSampFields>;
  variance?: Maybe<AnalysisDevicesPayloadsVarianceFields>;
};


/** aggregate fields of "analysis__devices_payloads" */
export type AnalysisDevicesPayloadsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AnalysisDevicesPayloadsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "analysis__devices_payloads" */
export type AnalysisDevicesPayloadsAggregateOrderBy = {
  avg?: InputMaybe<AnalysisDevicesPayloadsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AnalysisDevicesPayloadsMaxOrderBy>;
  min?: InputMaybe<AnalysisDevicesPayloadsMinOrderBy>;
  stddev?: InputMaybe<AnalysisDevicesPayloadsStddevOrderBy>;
  stddev_pop?: InputMaybe<AnalysisDevicesPayloadsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AnalysisDevicesPayloadsStddevSampOrderBy>;
  sum?: InputMaybe<AnalysisDevicesPayloadsSumOrderBy>;
  var_pop?: InputMaybe<AnalysisDevicesPayloadsVarPopOrderBy>;
  var_samp?: InputMaybe<AnalysisDevicesPayloadsVarSampOrderBy>;
  variance?: InputMaybe<AnalysisDevicesPayloadsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "analysis__devices_payloads" */
export type AnalysisDevicesPayloadsArrRelInsertInput = {
  data: Array<AnalysisDevicesPayloadsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AnalysisDevicesPayloadsOnConflict>;
};

/** aggregate avg on columns */
export type AnalysisDevicesPayloadsAvgFields = {
  __typename?: 'analysis__devices_payloads_avg_fields';
  analysis_id?: Maybe<Scalars['Float']>;
  device_payload_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "analysis__devices_payloads" */
export type AnalysisDevicesPayloadsAvgOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "analysis__devices_payloads". All fields are combined with a logical 'AND'. */
export type AnalysisDevicesPayloadsBoolExp = {
  _and?: InputMaybe<Array<AnalysisDevicesPayloadsBoolExp>>;
  _not?: InputMaybe<AnalysisDevicesPayloadsBoolExp>;
  _or?: InputMaybe<Array<AnalysisDevicesPayloadsBoolExp>>;
  analysis?: InputMaybe<AnalysisBoolExp>;
  analysis_id?: InputMaybe<IntComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  device_payload_id?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  payload?: InputMaybe<DevicePayloadsBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "analysis__devices_payloads" */
export enum AnalysisDevicesPayloadsConstraint {
  /** unique or primary key constraint on columns "analysis_id", "device_payload_id" */
  ANALYSIS__DEVICES_PAYLOADS_DEVICE_PAYLOAD_ID_ANALYSIS_ID_KEY = 'analysis__devices_payloads_device_payload_id_analysis_id_key',
  /** unique or primary key constraint on columns "id" */
  ANALYSIS__DEVICES_PAYLOADS_PKEY = 'analysis__devices_payloads_pkey'
}

/** input type for incrementing numeric columns in table "analysis__devices_payloads" */
export type AnalysisDevicesPayloadsIncInput = {
  analysis_id?: InputMaybe<Scalars['Int']>;
  device_payload_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "analysis__devices_payloads" */
export type AnalysisDevicesPayloadsInsertInput = {
  analysis?: InputMaybe<AnalysisObjRelInsertInput>;
  analysis_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device_payload_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  payload?: InputMaybe<DevicePayloadsObjRelInsertInput>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type AnalysisDevicesPayloadsMaxFields = {
  __typename?: 'analysis__devices_payloads_max_fields';
  analysis_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  device_payload_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "analysis__devices_payloads" */
export type AnalysisDevicesPayloadsMaxOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AnalysisDevicesPayloadsMinFields = {
  __typename?: 'analysis__devices_payloads_min_fields';
  analysis_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  device_payload_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "analysis__devices_payloads" */
export type AnalysisDevicesPayloadsMinOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "analysis__devices_payloads" */
export type AnalysisDevicesPayloadsMutationResponse = {
  __typename?: 'analysis__devices_payloads_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AnalysisDevicesPayloads>;
};

/** on_conflict condition type for table "analysis__devices_payloads" */
export type AnalysisDevicesPayloadsOnConflict = {
  constraint: AnalysisDevicesPayloadsConstraint;
  update_columns?: Array<AnalysisDevicesPayloadsUpdateColumn>;
  where?: InputMaybe<AnalysisDevicesPayloadsBoolExp>;
};

/** Ordering options when selecting data from "analysis__devices_payloads". */
export type AnalysisDevicesPayloadsOrderBy = {
  analysis?: InputMaybe<AnalysisOrderBy>;
  analysis_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  payload?: InputMaybe<DevicePayloadsOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: analysis__devices_payloads */
export type AnalysisDevicesPayloadsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "analysis__devices_payloads" */
export enum AnalysisDevicesPayloadsSelectColumn {
  /** column name */
  ANALYSIS_ID = 'analysis_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEVICE_PAYLOAD_ID = 'device_payload_id',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
}

/** input type for updating data in table "analysis__devices_payloads" */
export type AnalysisDevicesPayloadsSetInput = {
  analysis_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device_payload_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type AnalysisDevicesPayloadsStddevFields = {
  __typename?: 'analysis__devices_payloads_stddev_fields';
  analysis_id?: Maybe<Scalars['Float']>;
  device_payload_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "analysis__devices_payloads" */
export type AnalysisDevicesPayloadsStddevOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AnalysisDevicesPayloadsStddevPopFields = {
  __typename?: 'analysis__devices_payloads_stddev_pop_fields';
  analysis_id?: Maybe<Scalars['Float']>;
  device_payload_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "analysis__devices_payloads" */
export type AnalysisDevicesPayloadsStddevPopOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AnalysisDevicesPayloadsStddevSampFields = {
  __typename?: 'analysis__devices_payloads_stddev_samp_fields';
  analysis_id?: Maybe<Scalars['Float']>;
  device_payload_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "analysis__devices_payloads" */
export type AnalysisDevicesPayloadsStddevSampOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "analysis__devices_payloads" */
export type AnalysisDevicesPayloadsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AnalysisDevicesPayloadsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AnalysisDevicesPayloadsStreamCursorValueInput = {
  analysis_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device_payload_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type AnalysisDevicesPayloadsSumFields = {
  __typename?: 'analysis__devices_payloads_sum_fields';
  analysis_id?: Maybe<Scalars['Int']>;
  device_payload_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "analysis__devices_payloads" */
export type AnalysisDevicesPayloadsSumOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "analysis__devices_payloads" */
export enum AnalysisDevicesPayloadsUpdateColumn {
  /** column name */
  ANALYSIS_ID = 'analysis_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEVICE_PAYLOAD_ID = 'device_payload_id',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
}

export type AnalysisDevicesPayloadsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AnalysisDevicesPayloadsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AnalysisDevicesPayloadsSetInput>;
  /** filter the rows which have to be updated */
  where: AnalysisDevicesPayloadsBoolExp;
};

/** aggregate var_pop on columns */
export type AnalysisDevicesPayloadsVarPopFields = {
  __typename?: 'analysis__devices_payloads_var_pop_fields';
  analysis_id?: Maybe<Scalars['Float']>;
  device_payload_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "analysis__devices_payloads" */
export type AnalysisDevicesPayloadsVarPopOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AnalysisDevicesPayloadsVarSampFields = {
  __typename?: 'analysis__devices_payloads_var_samp_fields';
  analysis_id?: Maybe<Scalars['Float']>;
  device_payload_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "analysis__devices_payloads" */
export type AnalysisDevicesPayloadsVarSampOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AnalysisDevicesPayloadsVarianceFields = {
  __typename?: 'analysis__devices_payloads_variance_fields';
  analysis_id?: Maybe<Scalars['Float']>;
  device_payload_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "analysis__devices_payloads" */
export type AnalysisDevicesPayloadsVarianceOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregated selection of "analysis" */
export type AnalysisAggregate = {
  __typename?: 'analysis_aggregate';
  aggregate?: Maybe<AnalysisAggregateFields>;
  nodes: Array<Analysis>;
};

/** aggregate fields of "analysis" */
export type AnalysisAggregateFields = {
  __typename?: 'analysis_aggregate_fields';
  avg?: Maybe<AnalysisAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AnalysisMaxFields>;
  min?: Maybe<AnalysisMinFields>;
  stddev?: Maybe<AnalysisStddevFields>;
  stddev_pop?: Maybe<AnalysisStddevPopFields>;
  stddev_samp?: Maybe<AnalysisStddevSampFields>;
  sum?: Maybe<AnalysisSumFields>;
  var_pop?: Maybe<AnalysisVarPopFields>;
  var_samp?: Maybe<AnalysisVarSampFields>;
  variance?: Maybe<AnalysisVarianceFields>;
};


/** aggregate fields of "analysis" */
export type AnalysisAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AnalysisSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Analysis for applications */
export type AnalysisApplications = {
  __typename?: 'analysis_applications';
  /** An object relationship */
  analysis: Analysis;
  analysis_id: Scalars['Int'];
  /** An object relationship */
  application: Applications;
  application_id: Scalars['Int'];
  /** An object relationship */
  area?: Maybe<Areas>;
  area_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  computed: Array<AnalysisApplicationsComputed>;
  /** An aggregate relationship */
  computed_aggregate: AnalysisApplicationsComputedAggregate;
  created_at: Scalars['timestamptz'];
  created_by: Scalars['Int'];
  /** An array relationship */
  dashboards: Array<ApplicationsDashboardsAnalysis>;
  /** An aggregate relationship */
  dashboards_aggregate: ApplicationsDashboardsAnalysisAggregate;
  /** An array relationship */
  devices: Array<AnalysisApplicationsDevices>;
  /** An aggregate relationship */
  devices_aggregate: AnalysisApplicationsDevicesAggregate;
  enabled: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by: Scalars['Int'];
};


/** Analysis for applications */
export type AnalysisApplicationsComputedArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsComputedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsComputedOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsComputedBoolExp>;
};


/** Analysis for applications */
export type AnalysisApplicationsComputedAggregateArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsComputedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsComputedOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsComputedBoolExp>;
};


/** Analysis for applications */
export type AnalysisApplicationsDashboardsArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsDashboardsAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsDashboardsAnalysisOrderBy>>;
  where?: InputMaybe<ApplicationsDashboardsAnalysisBoolExp>;
};


/** Analysis for applications */
export type AnalysisApplicationsDashboardsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsDashboardsAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsDashboardsAnalysisOrderBy>>;
  where?: InputMaybe<ApplicationsDashboardsAnalysisBoolExp>;
};


/** Analysis for applications */
export type AnalysisApplicationsDevicesArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsDevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsDevicesOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsDevicesBoolExp>;
};


/** Analysis for applications */
export type AnalysisApplicationsDevicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsDevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsDevicesOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsDevicesBoolExp>;
};

/** Devices used for analysis */
export type AnalysisApplicationsDevices = {
  __typename?: 'analysis_applications__devices';
  /** An object relationship */
  analysis_application: AnalysisApplications;
  analysis_application_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  created_by: Scalars['Int'];
  deleted: Scalars['Boolean'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  device: Devices;
  device_id: Scalars['Int'];
  id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  updated_by: Scalars['Int'];
};

/** aggregated selection of "analysis_applications__devices" */
export type AnalysisApplicationsDevicesAggregate = {
  __typename?: 'analysis_applications__devices_aggregate';
  aggregate?: Maybe<AnalysisApplicationsDevicesAggregateFields>;
  nodes: Array<AnalysisApplicationsDevices>;
};

export type AnalysisApplicationsDevicesAggregateBoolExp = {
  bool_and?: InputMaybe<AnalysisApplicationsDevicesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<AnalysisApplicationsDevicesAggregateBoolExpBoolOr>;
  count?: InputMaybe<AnalysisApplicationsDevicesAggregateBoolExpCount>;
};

export type AnalysisApplicationsDevicesAggregateBoolExpBoolAnd = {
  arguments: AnalysisApplicationsDevicesSelectColumnAnalysisApplicationsDevicesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AnalysisApplicationsDevicesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AnalysisApplicationsDevicesAggregateBoolExpBoolOr = {
  arguments: AnalysisApplicationsDevicesSelectColumnAnalysisApplicationsDevicesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AnalysisApplicationsDevicesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AnalysisApplicationsDevicesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AnalysisApplicationsDevicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AnalysisApplicationsDevicesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "analysis_applications__devices" */
export type AnalysisApplicationsDevicesAggregateFields = {
  __typename?: 'analysis_applications__devices_aggregate_fields';
  avg?: Maybe<AnalysisApplicationsDevicesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AnalysisApplicationsDevicesMaxFields>;
  min?: Maybe<AnalysisApplicationsDevicesMinFields>;
  stddev?: Maybe<AnalysisApplicationsDevicesStddevFields>;
  stddev_pop?: Maybe<AnalysisApplicationsDevicesStddevPopFields>;
  stddev_samp?: Maybe<AnalysisApplicationsDevicesStddevSampFields>;
  sum?: Maybe<AnalysisApplicationsDevicesSumFields>;
  var_pop?: Maybe<AnalysisApplicationsDevicesVarPopFields>;
  var_samp?: Maybe<AnalysisApplicationsDevicesVarSampFields>;
  variance?: Maybe<AnalysisApplicationsDevicesVarianceFields>;
};


/** aggregate fields of "analysis_applications__devices" */
export type AnalysisApplicationsDevicesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AnalysisApplicationsDevicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "analysis_applications__devices" */
export type AnalysisApplicationsDevicesAggregateOrderBy = {
  avg?: InputMaybe<AnalysisApplicationsDevicesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AnalysisApplicationsDevicesMaxOrderBy>;
  min?: InputMaybe<AnalysisApplicationsDevicesMinOrderBy>;
  stddev?: InputMaybe<AnalysisApplicationsDevicesStddevOrderBy>;
  stddev_pop?: InputMaybe<AnalysisApplicationsDevicesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AnalysisApplicationsDevicesStddevSampOrderBy>;
  sum?: InputMaybe<AnalysisApplicationsDevicesSumOrderBy>;
  var_pop?: InputMaybe<AnalysisApplicationsDevicesVarPopOrderBy>;
  var_samp?: InputMaybe<AnalysisApplicationsDevicesVarSampOrderBy>;
  variance?: InputMaybe<AnalysisApplicationsDevicesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "analysis_applications__devices" */
export type AnalysisApplicationsDevicesArrRelInsertInput = {
  data: Array<AnalysisApplicationsDevicesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AnalysisApplicationsDevicesOnConflict>;
};

/** aggregate avg on columns */
export type AnalysisApplicationsDevicesAvgFields = {
  __typename?: 'analysis_applications__devices_avg_fields';
  analysis_application_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "analysis_applications__devices" */
export type AnalysisApplicationsDevicesAvgOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "analysis_applications__devices". All fields are combined with a logical 'AND'. */
export type AnalysisApplicationsDevicesBoolExp = {
  _and?: InputMaybe<Array<AnalysisApplicationsDevicesBoolExp>>;
  _not?: InputMaybe<AnalysisApplicationsDevicesBoolExp>;
  _or?: InputMaybe<Array<AnalysisApplicationsDevicesBoolExp>>;
  analysis_application?: InputMaybe<AnalysisApplicationsBoolExp>;
  analysis_application_id?: InputMaybe<IntComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<IntComparisonExp>;
  deleted?: InputMaybe<BooleanComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  device?: InputMaybe<DevicesBoolExp>;
  device_id?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "analysis_applications__devices" */
export enum AnalysisApplicationsDevicesConstraint {
  /** unique or primary key constraint on columns "analysis_application_id", "device_id" */
  ANALYSIS_APPLICATIONS__DEVICE_ANALYSIS_APPLICATION_ID_DEVIC_KEY = 'analysis_applications__device_analysis_application_id_devic_key',
  /** unique or primary key constraint on columns "id" */
  ANALYSIS_APPLICATIONS__DEVICES_PKEY = 'analysis_applications__devices_pkey'
}

/** input type for incrementing numeric columns in table "analysis_applications__devices" */
export type AnalysisApplicationsDevicesIncInput = {
  analysis_application_id?: InputMaybe<Scalars['Int']>;
  created_by?: InputMaybe<Scalars['Int']>;
  device_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "analysis_applications__devices" */
export type AnalysisApplicationsDevicesInsertInput = {
  analysis_application?: InputMaybe<AnalysisApplicationsObjRelInsertInput>;
  analysis_application_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  device?: InputMaybe<DevicesObjRelInsertInput>;
  device_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type AnalysisApplicationsDevicesMaxFields = {
  __typename?: 'analysis_applications__devices_max_fields';
  analysis_application_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  device_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "analysis_applications__devices" */
export type AnalysisApplicationsDevicesMaxOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AnalysisApplicationsDevicesMinFields = {
  __typename?: 'analysis_applications__devices_min_fields';
  analysis_application_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  device_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "analysis_applications__devices" */
export type AnalysisApplicationsDevicesMinOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "analysis_applications__devices" */
export type AnalysisApplicationsDevicesMutationResponse = {
  __typename?: 'analysis_applications__devices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AnalysisApplicationsDevices>;
};

/** on_conflict condition type for table "analysis_applications__devices" */
export type AnalysisApplicationsDevicesOnConflict = {
  constraint: AnalysisApplicationsDevicesConstraint;
  update_columns?: Array<AnalysisApplicationsDevicesUpdateColumn>;
  where?: InputMaybe<AnalysisApplicationsDevicesBoolExp>;
};

/** Ordering options when selecting data from "analysis_applications__devices". */
export type AnalysisApplicationsDevicesOrderBy = {
  analysis_application?: InputMaybe<AnalysisApplicationsOrderBy>;
  analysis_application_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  deleted?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  device?: InputMaybe<DevicesOrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: analysis_applications__devices */
export type AnalysisApplicationsDevicesPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "analysis_applications__devices" */
export enum AnalysisApplicationsDevicesSelectColumn {
  /** column name */
  ANALYSIS_APPLICATION_ID = 'analysis_application_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  DELETED = 'deleted',
  /** column name */
  DELETED_AT = 'deleted_at',
  /** column name */
  DEVICE_ID = 'device_id',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by'
}

/** select "analysis_applications__devices_aggregate_bool_exp_bool_and_arguments_columns" columns of table "analysis_applications__devices" */
export enum AnalysisApplicationsDevicesSelectColumnAnalysisApplicationsDevicesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  DELETED = 'deleted'
}

/** select "analysis_applications__devices_aggregate_bool_exp_bool_or_arguments_columns" columns of table "analysis_applications__devices" */
export enum AnalysisApplicationsDevicesSelectColumnAnalysisApplicationsDevicesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  DELETED = 'deleted'
}

/** input type for updating data in table "analysis_applications__devices" */
export type AnalysisApplicationsDevicesSetInput = {
  analysis_application_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  device_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type AnalysisApplicationsDevicesStddevFields = {
  __typename?: 'analysis_applications__devices_stddev_fields';
  analysis_application_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "analysis_applications__devices" */
export type AnalysisApplicationsDevicesStddevOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AnalysisApplicationsDevicesStddevPopFields = {
  __typename?: 'analysis_applications__devices_stddev_pop_fields';
  analysis_application_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "analysis_applications__devices" */
export type AnalysisApplicationsDevicesStddevPopOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AnalysisApplicationsDevicesStddevSampFields = {
  __typename?: 'analysis_applications__devices_stddev_samp_fields';
  analysis_application_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "analysis_applications__devices" */
export type AnalysisApplicationsDevicesStddevSampOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "analysis_applications__devices" */
export type AnalysisApplicationsDevicesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AnalysisApplicationsDevicesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AnalysisApplicationsDevicesStreamCursorValueInput = {
  analysis_application_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  device_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type AnalysisApplicationsDevicesSumFields = {
  __typename?: 'analysis_applications__devices_sum_fields';
  analysis_application_id?: Maybe<Scalars['Int']>;
  created_by?: Maybe<Scalars['Int']>;
  device_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "analysis_applications__devices" */
export type AnalysisApplicationsDevicesSumOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** update columns of table "analysis_applications__devices" */
export enum AnalysisApplicationsDevicesUpdateColumn {
  /** column name */
  ANALYSIS_APPLICATION_ID = 'analysis_application_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  DELETED = 'deleted',
  /** column name */
  DELETED_AT = 'deleted_at',
  /** column name */
  DEVICE_ID = 'device_id',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by'
}

export type AnalysisApplicationsDevicesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AnalysisApplicationsDevicesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AnalysisApplicationsDevicesSetInput>;
  /** filter the rows which have to be updated */
  where: AnalysisApplicationsDevicesBoolExp;
};

/** aggregate var_pop on columns */
export type AnalysisApplicationsDevicesVarPopFields = {
  __typename?: 'analysis_applications__devices_var_pop_fields';
  analysis_application_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "analysis_applications__devices" */
export type AnalysisApplicationsDevicesVarPopOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AnalysisApplicationsDevicesVarSampFields = {
  __typename?: 'analysis_applications__devices_var_samp_fields';
  analysis_application_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "analysis_applications__devices" */
export type AnalysisApplicationsDevicesVarSampOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AnalysisApplicationsDevicesVarianceFields = {
  __typename?: 'analysis_applications__devices_variance_fields';
  analysis_application_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "analysis_applications__devices" */
export type AnalysisApplicationsDevicesVarianceOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregated selection of "analysis_applications" */
export type AnalysisApplicationsAggregate = {
  __typename?: 'analysis_applications_aggregate';
  aggregate?: Maybe<AnalysisApplicationsAggregateFields>;
  nodes: Array<AnalysisApplications>;
};

export type AnalysisApplicationsAggregateBoolExp = {
  bool_and?: InputMaybe<AnalysisApplicationsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<AnalysisApplicationsAggregateBoolExpBoolOr>;
  count?: InputMaybe<AnalysisApplicationsAggregateBoolExpCount>;
};

export type AnalysisApplicationsAggregateBoolExpBoolAnd = {
  arguments: AnalysisApplicationsSelectColumnAnalysisApplicationsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AnalysisApplicationsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AnalysisApplicationsAggregateBoolExpBoolOr = {
  arguments: AnalysisApplicationsSelectColumnAnalysisApplicationsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AnalysisApplicationsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AnalysisApplicationsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AnalysisApplicationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AnalysisApplicationsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "analysis_applications" */
export type AnalysisApplicationsAggregateFields = {
  __typename?: 'analysis_applications_aggregate_fields';
  avg?: Maybe<AnalysisApplicationsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AnalysisApplicationsMaxFields>;
  min?: Maybe<AnalysisApplicationsMinFields>;
  stddev?: Maybe<AnalysisApplicationsStddevFields>;
  stddev_pop?: Maybe<AnalysisApplicationsStddevPopFields>;
  stddev_samp?: Maybe<AnalysisApplicationsStddevSampFields>;
  sum?: Maybe<AnalysisApplicationsSumFields>;
  var_pop?: Maybe<AnalysisApplicationsVarPopFields>;
  var_samp?: Maybe<AnalysisApplicationsVarSampFields>;
  variance?: Maybe<AnalysisApplicationsVarianceFields>;
};


/** aggregate fields of "analysis_applications" */
export type AnalysisApplicationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AnalysisApplicationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "analysis_applications" */
export type AnalysisApplicationsAggregateOrderBy = {
  avg?: InputMaybe<AnalysisApplicationsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AnalysisApplicationsMaxOrderBy>;
  min?: InputMaybe<AnalysisApplicationsMinOrderBy>;
  stddev?: InputMaybe<AnalysisApplicationsStddevOrderBy>;
  stddev_pop?: InputMaybe<AnalysisApplicationsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AnalysisApplicationsStddevSampOrderBy>;
  sum?: InputMaybe<AnalysisApplicationsSumOrderBy>;
  var_pop?: InputMaybe<AnalysisApplicationsVarPopOrderBy>;
  var_samp?: InputMaybe<AnalysisApplicationsVarSampOrderBy>;
  variance?: InputMaybe<AnalysisApplicationsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "analysis_applications" */
export type AnalysisApplicationsArrRelInsertInput = {
  data: Array<AnalysisApplicationsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AnalysisApplicationsOnConflict>;
};

/** aggregate avg on columns */
export type AnalysisApplicationsAvgFields = {
  __typename?: 'analysis_applications_avg_fields';
  analysis_id?: Maybe<Scalars['Float']>;
  application_id?: Maybe<Scalars['Float']>;
  area_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "analysis_applications" */
export type AnalysisApplicationsAvgOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  application_id?: InputMaybe<OrderBy>;
  area_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "analysis_applications". All fields are combined with a logical 'AND'. */
export type AnalysisApplicationsBoolExp = {
  _and?: InputMaybe<Array<AnalysisApplicationsBoolExp>>;
  _not?: InputMaybe<AnalysisApplicationsBoolExp>;
  _or?: InputMaybe<Array<AnalysisApplicationsBoolExp>>;
  analysis?: InputMaybe<AnalysisBoolExp>;
  analysis_id?: InputMaybe<IntComparisonExp>;
  application?: InputMaybe<ApplicationsBoolExp>;
  application_id?: InputMaybe<IntComparisonExp>;
  area?: InputMaybe<AreasBoolExp>;
  area_id?: InputMaybe<IntComparisonExp>;
  computed?: InputMaybe<AnalysisApplicationsComputedBoolExp>;
  computed_aggregate?: InputMaybe<AnalysisApplicationsComputedAggregateBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<IntComparisonExp>;
  dashboards?: InputMaybe<ApplicationsDashboardsAnalysisBoolExp>;
  dashboards_aggregate?: InputMaybe<ApplicationsDashboardsAnalysisAggregateBoolExp>;
  devices?: InputMaybe<AnalysisApplicationsDevicesBoolExp>;
  devices_aggregate?: InputMaybe<AnalysisApplicationsDevicesAggregateBoolExp>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<IntComparisonExp>;
};

/** computed time series for analysis application */
export type AnalysisApplicationsComputed = {
  __typename?: 'analysis_applications_computed';
  /** An object relationship */
  analysis_application: AnalysisApplications;
  analysis_application_id: Scalars['Int'];
  computed_at: Scalars['timestamptz'];
  created_at: Scalars['timestamptz'];
  id: Scalars['bigint'];
  /** returns last value based on kind and optionally payload key */
  last_computed_value?: Maybe<Scalars['numeric']>;
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  values: Array<AnalysisApplicationsComputedValues>;
  /** An aggregate relationship */
  values_aggregate: AnalysisApplicationsComputedValuesAggregate;
};


/** computed time series for analysis application */
export type AnalysisApplicationsComputedLastComputedValueArgs = {
  args: LastComputedValueAnalysisApplicationsComputedArgs;
};


/** computed time series for analysis application */
export type AnalysisApplicationsComputedValuesArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsComputedValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsComputedValuesOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsComputedValuesBoolExp>;
};


/** computed time series for analysis application */
export type AnalysisApplicationsComputedValuesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsComputedValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsComputedValuesOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsComputedValuesBoolExp>;
};

/** aggregated selection of "analysis_applications_computed" */
export type AnalysisApplicationsComputedAggregate = {
  __typename?: 'analysis_applications_computed_aggregate';
  aggregate?: Maybe<AnalysisApplicationsComputedAggregateFields>;
  nodes: Array<AnalysisApplicationsComputed>;
};

export type AnalysisApplicationsComputedAggregateBoolExp = {
  count?: InputMaybe<AnalysisApplicationsComputedAggregateBoolExpCount>;
};

export type AnalysisApplicationsComputedAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AnalysisApplicationsComputedSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AnalysisApplicationsComputedBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "analysis_applications_computed" */
export type AnalysisApplicationsComputedAggregateFields = {
  __typename?: 'analysis_applications_computed_aggregate_fields';
  avg?: Maybe<AnalysisApplicationsComputedAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AnalysisApplicationsComputedMaxFields>;
  min?: Maybe<AnalysisApplicationsComputedMinFields>;
  stddev?: Maybe<AnalysisApplicationsComputedStddevFields>;
  stddev_pop?: Maybe<AnalysisApplicationsComputedStddevPopFields>;
  stddev_samp?: Maybe<AnalysisApplicationsComputedStddevSampFields>;
  sum?: Maybe<AnalysisApplicationsComputedSumFields>;
  var_pop?: Maybe<AnalysisApplicationsComputedVarPopFields>;
  var_samp?: Maybe<AnalysisApplicationsComputedVarSampFields>;
  variance?: Maybe<AnalysisApplicationsComputedVarianceFields>;
};


/** aggregate fields of "analysis_applications_computed" */
export type AnalysisApplicationsComputedAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AnalysisApplicationsComputedSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "analysis_applications_computed" */
export type AnalysisApplicationsComputedAggregateOrderBy = {
  avg?: InputMaybe<AnalysisApplicationsComputedAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AnalysisApplicationsComputedMaxOrderBy>;
  min?: InputMaybe<AnalysisApplicationsComputedMinOrderBy>;
  stddev?: InputMaybe<AnalysisApplicationsComputedStddevOrderBy>;
  stddev_pop?: InputMaybe<AnalysisApplicationsComputedStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AnalysisApplicationsComputedStddevSampOrderBy>;
  sum?: InputMaybe<AnalysisApplicationsComputedSumOrderBy>;
  var_pop?: InputMaybe<AnalysisApplicationsComputedVarPopOrderBy>;
  var_samp?: InputMaybe<AnalysisApplicationsComputedVarSampOrderBy>;
  variance?: InputMaybe<AnalysisApplicationsComputedVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "analysis_applications_computed" */
export type AnalysisApplicationsComputedArrRelInsertInput = {
  data: Array<AnalysisApplicationsComputedInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AnalysisApplicationsComputedOnConflict>;
};

/** aggregate avg on columns */
export type AnalysisApplicationsComputedAvgFields = {
  __typename?: 'analysis_applications_computed_avg_fields';
  analysis_application_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  /** returns last value based on kind and optionally payload key */
  last_computed_value?: Maybe<Scalars['numeric']>;
};


/** aggregate avg on columns */
export type AnalysisApplicationsComputedAvgFieldsLastComputedValueArgs = {
  args: LastComputedValueAnalysisApplicationsComputedArgs;
};

/** order by avg() on columns of table "analysis_applications_computed" */
export type AnalysisApplicationsComputedAvgOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "analysis_applications_computed". All fields are combined with a logical 'AND'. */
export type AnalysisApplicationsComputedBoolExp = {
  _and?: InputMaybe<Array<AnalysisApplicationsComputedBoolExp>>;
  _not?: InputMaybe<AnalysisApplicationsComputedBoolExp>;
  _or?: InputMaybe<Array<AnalysisApplicationsComputedBoolExp>>;
  analysis_application?: InputMaybe<AnalysisApplicationsBoolExp>;
  analysis_application_id?: InputMaybe<IntComparisonExp>;
  computed_at?: InputMaybe<TimestamptzComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  values?: InputMaybe<AnalysisApplicationsComputedValuesBoolExp>;
  values_aggregate?: InputMaybe<AnalysisApplicationsComputedValuesAggregateBoolExp>;
};

/** unique or primary key constraints on table "analysis_applications_computed" */
export enum AnalysisApplicationsComputedConstraint {
  /** unique or primary key constraint on columns "analysis_application_id", "computed_at" */
  ANALYSIS_APPLICATIONS_COMPUTE_ANALYSIS_APPLICATION_ID_COMPU_KEY = 'analysis_applications_compute_analysis_application_id_compu_key',
  /** unique or primary key constraint on columns "id" */
  ANALYSIS_APPLICATIONS_COMPUTED_PKEY = 'analysis_applications_computed_pkey'
}

/** input type for incrementing numeric columns in table "analysis_applications_computed" */
export type AnalysisApplicationsComputedIncInput = {
  analysis_application_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "analysis_applications_computed" */
export type AnalysisApplicationsComputedInsertInput = {
  analysis_application?: InputMaybe<AnalysisApplicationsObjRelInsertInput>;
  analysis_application_id?: InputMaybe<Scalars['Int']>;
  computed_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  values?: InputMaybe<AnalysisApplicationsComputedValuesArrRelInsertInput>;
};

/** aggregate max on columns */
export type AnalysisApplicationsComputedMaxFields = {
  __typename?: 'analysis_applications_computed_max_fields';
  analysis_application_id?: Maybe<Scalars['Int']>;
  computed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  /** returns last value based on kind and optionally payload key */
  last_computed_value?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** aggregate max on columns */
export type AnalysisApplicationsComputedMaxFieldsLastComputedValueArgs = {
  args: LastComputedValueAnalysisApplicationsComputedArgs;
};

/** order by max() on columns of table "analysis_applications_computed" */
export type AnalysisApplicationsComputedMaxOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  computed_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AnalysisApplicationsComputedMinFields = {
  __typename?: 'analysis_applications_computed_min_fields';
  analysis_application_id?: Maybe<Scalars['Int']>;
  computed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  /** returns last value based on kind and optionally payload key */
  last_computed_value?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** aggregate min on columns */
export type AnalysisApplicationsComputedMinFieldsLastComputedValueArgs = {
  args: LastComputedValueAnalysisApplicationsComputedArgs;
};

/** order by min() on columns of table "analysis_applications_computed" */
export type AnalysisApplicationsComputedMinOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  computed_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "analysis_applications_computed" */
export type AnalysisApplicationsComputedMutationResponse = {
  __typename?: 'analysis_applications_computed_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AnalysisApplicationsComputed>;
};

/** input type for inserting object relation for remote table "analysis_applications_computed" */
export type AnalysisApplicationsComputedObjRelInsertInput = {
  data: AnalysisApplicationsComputedInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AnalysisApplicationsComputedOnConflict>;
};

/** on_conflict condition type for table "analysis_applications_computed" */
export type AnalysisApplicationsComputedOnConflict = {
  constraint: AnalysisApplicationsComputedConstraint;
  update_columns?: Array<AnalysisApplicationsComputedUpdateColumn>;
  where?: InputMaybe<AnalysisApplicationsComputedBoolExp>;
};

/** Ordering options when selecting data from "analysis_applications_computed". */
export type AnalysisApplicationsComputedOrderBy = {
  analysis_application?: InputMaybe<AnalysisApplicationsOrderBy>;
  analysis_application_id?: InputMaybe<OrderBy>;
  computed_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  values_aggregate?: InputMaybe<AnalysisApplicationsComputedValuesAggregateOrderBy>;
};

/** primary key columns input for table: analysis_applications_computed */
export type AnalysisApplicationsComputedPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "analysis_applications_computed" */
export enum AnalysisApplicationsComputedSelectColumn {
  /** column name */
  ANALYSIS_APPLICATION_ID = 'analysis_application_id',
  /** column name */
  COMPUTED_AT = 'computed_at',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
}

/** input type for updating data in table "analysis_applications_computed" */
export type AnalysisApplicationsComputedSetInput = {
  analysis_application_id?: InputMaybe<Scalars['Int']>;
  computed_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type AnalysisApplicationsComputedStddevFields = {
  __typename?: 'analysis_applications_computed_stddev_fields';
  analysis_application_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  /** returns last value based on kind and optionally payload key */
  last_computed_value?: Maybe<Scalars['numeric']>;
};


/** aggregate stddev on columns */
export type AnalysisApplicationsComputedStddevFieldsLastComputedValueArgs = {
  args: LastComputedValueAnalysisApplicationsComputedArgs;
};

/** order by stddev() on columns of table "analysis_applications_computed" */
export type AnalysisApplicationsComputedStddevOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AnalysisApplicationsComputedStddevPopFields = {
  __typename?: 'analysis_applications_computed_stddev_pop_fields';
  analysis_application_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  /** returns last value based on kind and optionally payload key */
  last_computed_value?: Maybe<Scalars['numeric']>;
};


/** aggregate stddev_pop on columns */
export type AnalysisApplicationsComputedStddevPopFieldsLastComputedValueArgs = {
  args: LastComputedValueAnalysisApplicationsComputedArgs;
};

/** order by stddev_pop() on columns of table "analysis_applications_computed" */
export type AnalysisApplicationsComputedStddevPopOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AnalysisApplicationsComputedStddevSampFields = {
  __typename?: 'analysis_applications_computed_stddev_samp_fields';
  analysis_application_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  /** returns last value based on kind and optionally payload key */
  last_computed_value?: Maybe<Scalars['numeric']>;
};


/** aggregate stddev_samp on columns */
export type AnalysisApplicationsComputedStddevSampFieldsLastComputedValueArgs = {
  args: LastComputedValueAnalysisApplicationsComputedArgs;
};

/** order by stddev_samp() on columns of table "analysis_applications_computed" */
export type AnalysisApplicationsComputedStddevSampOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "analysis_applications_computed" */
export type AnalysisApplicationsComputedStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AnalysisApplicationsComputedStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AnalysisApplicationsComputedStreamCursorValueInput = {
  analysis_application_id?: InputMaybe<Scalars['Int']>;
  computed_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type AnalysisApplicationsComputedSumFields = {
  __typename?: 'analysis_applications_computed_sum_fields';
  analysis_application_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  /** returns last value based on kind and optionally payload key */
  last_computed_value?: Maybe<Scalars['numeric']>;
};


/** aggregate sum on columns */
export type AnalysisApplicationsComputedSumFieldsLastComputedValueArgs = {
  args: LastComputedValueAnalysisApplicationsComputedArgs;
};

/** order by sum() on columns of table "analysis_applications_computed" */
export type AnalysisApplicationsComputedSumOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "analysis_applications_computed" */
export enum AnalysisApplicationsComputedUpdateColumn {
  /** column name */
  ANALYSIS_APPLICATION_ID = 'analysis_application_id',
  /** column name */
  COMPUTED_AT = 'computed_at',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
}

export type AnalysisApplicationsComputedUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AnalysisApplicationsComputedIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AnalysisApplicationsComputedSetInput>;
  /** filter the rows which have to be updated */
  where: AnalysisApplicationsComputedBoolExp;
};

/** values related to analysis application */
export type AnalysisApplicationsComputedValues = {
  __typename?: 'analysis_applications_computed_values';
  analysis_applications_computed_id: Scalars['bigint'];
  /** An object relationship */
  computed: AnalysisApplicationsComputed;
  created_at: Scalars['timestamptz'];
  device_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  device_payload?: Maybe<DevicePayloads>;
  device_payload_id?: Maybe<Scalars['Int']>;
  id: Scalars['bigint'];
  kind: AnalysisApplicationsComputedValuesKindsEnum;
  /** An object relationship */
  kind_enum: AnalysisApplicationsComputedValuesKinds;
  updated_at: Scalars['timestamptz'];
  value?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "analysis_applications_computed_values" */
export type AnalysisApplicationsComputedValuesAggregate = {
  __typename?: 'analysis_applications_computed_values_aggregate';
  aggregate?: Maybe<AnalysisApplicationsComputedValuesAggregateFields>;
  nodes: Array<AnalysisApplicationsComputedValues>;
};

export type AnalysisApplicationsComputedValuesAggregateBoolExp = {
  count?: InputMaybe<AnalysisApplicationsComputedValuesAggregateBoolExpCount>;
};

export type AnalysisApplicationsComputedValuesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AnalysisApplicationsComputedValuesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AnalysisApplicationsComputedValuesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "analysis_applications_computed_values" */
export type AnalysisApplicationsComputedValuesAggregateFields = {
  __typename?: 'analysis_applications_computed_values_aggregate_fields';
  avg?: Maybe<AnalysisApplicationsComputedValuesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AnalysisApplicationsComputedValuesMaxFields>;
  min?: Maybe<AnalysisApplicationsComputedValuesMinFields>;
  stddev?: Maybe<AnalysisApplicationsComputedValuesStddevFields>;
  stddev_pop?: Maybe<AnalysisApplicationsComputedValuesStddevPopFields>;
  stddev_samp?: Maybe<AnalysisApplicationsComputedValuesStddevSampFields>;
  sum?: Maybe<AnalysisApplicationsComputedValuesSumFields>;
  var_pop?: Maybe<AnalysisApplicationsComputedValuesVarPopFields>;
  var_samp?: Maybe<AnalysisApplicationsComputedValuesVarSampFields>;
  variance?: Maybe<AnalysisApplicationsComputedValuesVarianceFields>;
};


/** aggregate fields of "analysis_applications_computed_values" */
export type AnalysisApplicationsComputedValuesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AnalysisApplicationsComputedValuesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "analysis_applications_computed_values" */
export type AnalysisApplicationsComputedValuesAggregateOrderBy = {
  avg?: InputMaybe<AnalysisApplicationsComputedValuesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AnalysisApplicationsComputedValuesMaxOrderBy>;
  min?: InputMaybe<AnalysisApplicationsComputedValuesMinOrderBy>;
  stddev?: InputMaybe<AnalysisApplicationsComputedValuesStddevOrderBy>;
  stddev_pop?: InputMaybe<AnalysisApplicationsComputedValuesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AnalysisApplicationsComputedValuesStddevSampOrderBy>;
  sum?: InputMaybe<AnalysisApplicationsComputedValuesSumOrderBy>;
  var_pop?: InputMaybe<AnalysisApplicationsComputedValuesVarPopOrderBy>;
  var_samp?: InputMaybe<AnalysisApplicationsComputedValuesVarSampOrderBy>;
  variance?: InputMaybe<AnalysisApplicationsComputedValuesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "analysis_applications_computed_values" */
export type AnalysisApplicationsComputedValuesArrRelInsertInput = {
  data: Array<AnalysisApplicationsComputedValuesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AnalysisApplicationsComputedValuesOnConflict>;
};

/** aggregate avg on columns */
export type AnalysisApplicationsComputedValuesAvgFields = {
  __typename?: 'analysis_applications_computed_values_avg_fields';
  analysis_applications_computed_id?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  device_payload_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "analysis_applications_computed_values" */
export type AnalysisApplicationsComputedValuesAvgOrderBy = {
  analysis_applications_computed_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "analysis_applications_computed_values". All fields are combined with a logical 'AND'. */
export type AnalysisApplicationsComputedValuesBoolExp = {
  _and?: InputMaybe<Array<AnalysisApplicationsComputedValuesBoolExp>>;
  _not?: InputMaybe<AnalysisApplicationsComputedValuesBoolExp>;
  _or?: InputMaybe<Array<AnalysisApplicationsComputedValuesBoolExp>>;
  analysis_applications_computed_id?: InputMaybe<BigintComparisonExp>;
  computed?: InputMaybe<AnalysisApplicationsComputedBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  device_id?: InputMaybe<IntComparisonExp>;
  device_payload?: InputMaybe<DevicePayloadsBoolExp>;
  device_payload_id?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  kind?: InputMaybe<AnalysisApplicationsComputedValuesKindsEnumComparisonExp>;
  kind_enum?: InputMaybe<AnalysisApplicationsComputedValuesKindsBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  value?: InputMaybe<NumericComparisonExp>;
};

/** unique or primary key constraints on table "analysis_applications_computed_values" */
export enum AnalysisApplicationsComputedValuesConstraint {
  /** unique or primary key constraint on columns "kind", "analysis_applications_computed_id", "device_payload_id" */
  ANALYSIS_APPLICATIONS_COMPUTED_VALUES_ANALYSIS_APPLICATIONS_COM = 'analysis_applications_computed_values_analysis_applications_com',
  /** unique or primary key constraint on columns "id" */
  ANALYSIS_APPLICATIONS_COMPUTED_VALUES_PKEY = 'analysis_applications_computed_values_pkey'
}

/** input type for incrementing numeric columns in table "analysis_applications_computed_values" */
export type AnalysisApplicationsComputedValuesIncInput = {
  analysis_applications_computed_id?: InputMaybe<Scalars['bigint']>;
  device_id?: InputMaybe<Scalars['Int']>;
  device_payload_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
  value?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "analysis_applications_computed_values" */
export type AnalysisApplicationsComputedValuesInsertInput = {
  analysis_applications_computed_id?: InputMaybe<Scalars['bigint']>;
  computed?: InputMaybe<AnalysisApplicationsComputedObjRelInsertInput>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device_id?: InputMaybe<Scalars['Int']>;
  device_payload?: InputMaybe<DevicePayloadsObjRelInsertInput>;
  device_payload_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<AnalysisApplicationsComputedValuesKindsEnum>;
  kind_enum?: InputMaybe<AnalysisApplicationsComputedValuesKindsObjRelInsertInput>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['numeric']>;
};

/** kind of analysis computed values */
export type AnalysisApplicationsComputedValuesKinds = {
  __typename?: 'analysis_applications_computed_values_kinds';
  comment: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "analysis_applications_computed_values_kinds" */
export type AnalysisApplicationsComputedValuesKindsAggregate = {
  __typename?: 'analysis_applications_computed_values_kinds_aggregate';
  aggregate?: Maybe<AnalysisApplicationsComputedValuesKindsAggregateFields>;
  nodes: Array<AnalysisApplicationsComputedValuesKinds>;
};

/** aggregate fields of "analysis_applications_computed_values_kinds" */
export type AnalysisApplicationsComputedValuesKindsAggregateFields = {
  __typename?: 'analysis_applications_computed_values_kinds_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<AnalysisApplicationsComputedValuesKindsMaxFields>;
  min?: Maybe<AnalysisApplicationsComputedValuesKindsMinFields>;
};


/** aggregate fields of "analysis_applications_computed_values_kinds" */
export type AnalysisApplicationsComputedValuesKindsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AnalysisApplicationsComputedValuesKindsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "analysis_applications_computed_values_kinds". All fields are combined with a logical 'AND'. */
export type AnalysisApplicationsComputedValuesKindsBoolExp = {
  _and?: InputMaybe<Array<AnalysisApplicationsComputedValuesKindsBoolExp>>;
  _not?: InputMaybe<AnalysisApplicationsComputedValuesKindsBoolExp>;
  _or?: InputMaybe<Array<AnalysisApplicationsComputedValuesKindsBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "analysis_applications_computed_values_kinds" */
export enum AnalysisApplicationsComputedValuesKindsConstraint {
  /** unique or primary key constraint on columns "value" */
  ANALYSIS_APPLICATIONS_COMPUTED_VALUES_KINDS_PKEY = 'analysis_applications_computed_values_kinds_pkey'
}

export enum AnalysisApplicationsComputedValuesKindsEnum {
  /** days flag boolean */
  DAYS_FLAG = 'DAYS_FLAG',
  /** hours flag boolean */
  HOURS_FLAG = 'HOURS_FLAG',
  /** value with corresponding payload */
  PAYLOAD_VALUE = 'PAYLOAD_VALUE',
  /** broken hours int */
  PREVIOUS_BROKEN_HOURS = 'PREVIOUS_BROKEN_HOURS',
  /** previous days int */
  PREVIOUS_DAYS = 'PREVIOUS_DAYS',
  /** probability numeric */
  PROB = 'PROB',
  /** x integer */
  X = 'X',
  /** x flag boolean */
  X_FLAG = 'X_FLAG',
  /** y integer */
  Y = 'Y',
  /** y flag boolean */
  Y_FLAG = 'Y_FLAG',
  /** z integer */
  Z = 'Z',
  /** z flag boolean */
  Z_FLAG = 'Z_FLAG'
}

/** Boolean expression to compare columns of type "analysis_applications_computed_values_kinds_enum". All fields are combined with logical 'AND'. */
export type AnalysisApplicationsComputedValuesKindsEnumComparisonExp = {
  _eq?: InputMaybe<AnalysisApplicationsComputedValuesKindsEnum>;
  _in?: InputMaybe<Array<AnalysisApplicationsComputedValuesKindsEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<AnalysisApplicationsComputedValuesKindsEnum>;
  _nin?: InputMaybe<Array<AnalysisApplicationsComputedValuesKindsEnum>>;
};

/** input type for inserting data into table "analysis_applications_computed_values_kinds" */
export type AnalysisApplicationsComputedValuesKindsInsertInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AnalysisApplicationsComputedValuesKindsMaxFields = {
  __typename?: 'analysis_applications_computed_values_kinds_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AnalysisApplicationsComputedValuesKindsMinFields = {
  __typename?: 'analysis_applications_computed_values_kinds_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "analysis_applications_computed_values_kinds" */
export type AnalysisApplicationsComputedValuesKindsMutationResponse = {
  __typename?: 'analysis_applications_computed_values_kinds_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AnalysisApplicationsComputedValuesKinds>;
};

/** input type for inserting object relation for remote table "analysis_applications_computed_values_kinds" */
export type AnalysisApplicationsComputedValuesKindsObjRelInsertInput = {
  data: AnalysisApplicationsComputedValuesKindsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AnalysisApplicationsComputedValuesKindsOnConflict>;
};

/** on_conflict condition type for table "analysis_applications_computed_values_kinds" */
export type AnalysisApplicationsComputedValuesKindsOnConflict = {
  constraint: AnalysisApplicationsComputedValuesKindsConstraint;
  update_columns?: Array<AnalysisApplicationsComputedValuesKindsUpdateColumn>;
  where?: InputMaybe<AnalysisApplicationsComputedValuesKindsBoolExp>;
};

/** Ordering options when selecting data from "analysis_applications_computed_values_kinds". */
export type AnalysisApplicationsComputedValuesKindsOrderBy = {
  comment?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: analysis_applications_computed_values_kinds */
export type AnalysisApplicationsComputedValuesKindsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "analysis_applications_computed_values_kinds" */
export enum AnalysisApplicationsComputedValuesKindsSelectColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  VALUE = 'value'
}

/** input type for updating data in table "analysis_applications_computed_values_kinds" */
export type AnalysisApplicationsComputedValuesKindsSetInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "analysis_applications_computed_values_kinds" */
export type AnalysisApplicationsComputedValuesKindsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AnalysisApplicationsComputedValuesKindsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AnalysisApplicationsComputedValuesKindsStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "analysis_applications_computed_values_kinds" */
export enum AnalysisApplicationsComputedValuesKindsUpdateColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  VALUE = 'value'
}

export type AnalysisApplicationsComputedValuesKindsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AnalysisApplicationsComputedValuesKindsSetInput>;
  /** filter the rows which have to be updated */
  where: AnalysisApplicationsComputedValuesKindsBoolExp;
};

/** aggregate max on columns */
export type AnalysisApplicationsComputedValuesMaxFields = {
  __typename?: 'analysis_applications_computed_values_max_fields';
  analysis_applications_computed_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  device_id?: Maybe<Scalars['Int']>;
  device_payload_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "analysis_applications_computed_values" */
export type AnalysisApplicationsComputedValuesMaxOrderBy = {
  analysis_applications_computed_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AnalysisApplicationsComputedValuesMinFields = {
  __typename?: 'analysis_applications_computed_values_min_fields';
  analysis_applications_computed_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  device_id?: Maybe<Scalars['Int']>;
  device_payload_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "analysis_applications_computed_values" */
export type AnalysisApplicationsComputedValuesMinOrderBy = {
  analysis_applications_computed_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "analysis_applications_computed_values" */
export type AnalysisApplicationsComputedValuesMutationResponse = {
  __typename?: 'analysis_applications_computed_values_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AnalysisApplicationsComputedValues>;
};

/** on_conflict condition type for table "analysis_applications_computed_values" */
export type AnalysisApplicationsComputedValuesOnConflict = {
  constraint: AnalysisApplicationsComputedValuesConstraint;
  update_columns?: Array<AnalysisApplicationsComputedValuesUpdateColumn>;
  where?: InputMaybe<AnalysisApplicationsComputedValuesBoolExp>;
};

/** Ordering options when selecting data from "analysis_applications_computed_values". */
export type AnalysisApplicationsComputedValuesOrderBy = {
  analysis_applications_computed_id?: InputMaybe<OrderBy>;
  computed?: InputMaybe<AnalysisApplicationsComputedOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  device_payload?: InputMaybe<DevicePayloadsOrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  kind?: InputMaybe<OrderBy>;
  kind_enum?: InputMaybe<AnalysisApplicationsComputedValuesKindsOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: analysis_applications_computed_values */
export type AnalysisApplicationsComputedValuesPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "analysis_applications_computed_values" */
export enum AnalysisApplicationsComputedValuesSelectColumn {
  /** column name */
  ANALYSIS_APPLICATIONS_COMPUTED_ID = 'analysis_applications_computed_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEVICE_ID = 'device_id',
  /** column name */
  DEVICE_PAYLOAD_ID = 'device_payload_id',
  /** column name */
  ID = 'id',
  /** column name */
  KIND = 'kind',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  VALUE = 'value'
}

/** input type for updating data in table "analysis_applications_computed_values" */
export type AnalysisApplicationsComputedValuesSetInput = {
  analysis_applications_computed_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device_id?: InputMaybe<Scalars['Int']>;
  device_payload_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<AnalysisApplicationsComputedValuesKindsEnum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type AnalysisApplicationsComputedValuesStddevFields = {
  __typename?: 'analysis_applications_computed_values_stddev_fields';
  analysis_applications_computed_id?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  device_payload_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "analysis_applications_computed_values" */
export type AnalysisApplicationsComputedValuesStddevOrderBy = {
  analysis_applications_computed_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AnalysisApplicationsComputedValuesStddevPopFields = {
  __typename?: 'analysis_applications_computed_values_stddev_pop_fields';
  analysis_applications_computed_id?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  device_payload_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "analysis_applications_computed_values" */
export type AnalysisApplicationsComputedValuesStddevPopOrderBy = {
  analysis_applications_computed_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AnalysisApplicationsComputedValuesStddevSampFields = {
  __typename?: 'analysis_applications_computed_values_stddev_samp_fields';
  analysis_applications_computed_id?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  device_payload_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "analysis_applications_computed_values" */
export type AnalysisApplicationsComputedValuesStddevSampOrderBy = {
  analysis_applications_computed_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "analysis_applications_computed_values" */
export type AnalysisApplicationsComputedValuesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AnalysisApplicationsComputedValuesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AnalysisApplicationsComputedValuesStreamCursorValueInput = {
  analysis_applications_computed_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device_id?: InputMaybe<Scalars['Int']>;
  device_payload_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<AnalysisApplicationsComputedValuesKindsEnum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type AnalysisApplicationsComputedValuesSumFields = {
  __typename?: 'analysis_applications_computed_values_sum_fields';
  analysis_applications_computed_id?: Maybe<Scalars['bigint']>;
  device_id?: Maybe<Scalars['Int']>;
  device_payload_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['bigint']>;
  value?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "analysis_applications_computed_values" */
export type AnalysisApplicationsComputedValuesSumOrderBy = {
  analysis_applications_computed_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** update columns of table "analysis_applications_computed_values" */
export enum AnalysisApplicationsComputedValuesUpdateColumn {
  /** column name */
  ANALYSIS_APPLICATIONS_COMPUTED_ID = 'analysis_applications_computed_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEVICE_ID = 'device_id',
  /** column name */
  DEVICE_PAYLOAD_ID = 'device_payload_id',
  /** column name */
  ID = 'id',
  /** column name */
  KIND = 'kind',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  VALUE = 'value'
}

export type AnalysisApplicationsComputedValuesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AnalysisApplicationsComputedValuesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AnalysisApplicationsComputedValuesSetInput>;
  /** filter the rows which have to be updated */
  where: AnalysisApplicationsComputedValuesBoolExp;
};

/** aggregate var_pop on columns */
export type AnalysisApplicationsComputedValuesVarPopFields = {
  __typename?: 'analysis_applications_computed_values_var_pop_fields';
  analysis_applications_computed_id?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  device_payload_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "analysis_applications_computed_values" */
export type AnalysisApplicationsComputedValuesVarPopOrderBy = {
  analysis_applications_computed_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AnalysisApplicationsComputedValuesVarSampFields = {
  __typename?: 'analysis_applications_computed_values_var_samp_fields';
  analysis_applications_computed_id?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  device_payload_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "analysis_applications_computed_values" */
export type AnalysisApplicationsComputedValuesVarSampOrderBy = {
  analysis_applications_computed_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AnalysisApplicationsComputedValuesVarianceFields = {
  __typename?: 'analysis_applications_computed_values_variance_fields';
  analysis_applications_computed_id?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  device_payload_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "analysis_applications_computed_values" */
export type AnalysisApplicationsComputedValuesVarianceOrderBy = {
  analysis_applications_computed_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type AnalysisApplicationsComputedVarPopFields = {
  __typename?: 'analysis_applications_computed_var_pop_fields';
  analysis_application_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  /** returns last value based on kind and optionally payload key */
  last_computed_value?: Maybe<Scalars['numeric']>;
};


/** aggregate var_pop on columns */
export type AnalysisApplicationsComputedVarPopFieldsLastComputedValueArgs = {
  args: LastComputedValueAnalysisApplicationsComputedArgs;
};

/** order by var_pop() on columns of table "analysis_applications_computed" */
export type AnalysisApplicationsComputedVarPopOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AnalysisApplicationsComputedVarSampFields = {
  __typename?: 'analysis_applications_computed_var_samp_fields';
  analysis_application_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  /** returns last value based on kind and optionally payload key */
  last_computed_value?: Maybe<Scalars['numeric']>;
};


/** aggregate var_samp on columns */
export type AnalysisApplicationsComputedVarSampFieldsLastComputedValueArgs = {
  args: LastComputedValueAnalysisApplicationsComputedArgs;
};

/** order by var_samp() on columns of table "analysis_applications_computed" */
export type AnalysisApplicationsComputedVarSampOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AnalysisApplicationsComputedVarianceFields = {
  __typename?: 'analysis_applications_computed_variance_fields';
  analysis_application_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  /** returns last value based on kind and optionally payload key */
  last_computed_value?: Maybe<Scalars['numeric']>;
};


/** aggregate variance on columns */
export type AnalysisApplicationsComputedVarianceFieldsLastComputedValueArgs = {
  args: LastComputedValueAnalysisApplicationsComputedArgs;
};

/** order by variance() on columns of table "analysis_applications_computed" */
export type AnalysisApplicationsComputedVarianceOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** unique or primary key constraints on table "analysis_applications" */
export enum AnalysisApplicationsConstraint {
  /** unique or primary key constraint on columns "application_id", "name" */
  ANALYSIS_APPLICATIONS_APPLICATION_ID_NAME_KEY = 'analysis_applications_application_id_name_key',
  /** unique or primary key constraint on columns "id" */
  ANALYSIS_APPLICATIONS_PKEY = 'analysis_applications_pkey'
}

/** input type for incrementing numeric columns in table "analysis_applications" */
export type AnalysisApplicationsIncInput = {
  analysis_id?: InputMaybe<Scalars['Int']>;
  application_id?: InputMaybe<Scalars['Int']>;
  area_id?: InputMaybe<Scalars['Int']>;
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "analysis_applications" */
export type AnalysisApplicationsInsertInput = {
  analysis?: InputMaybe<AnalysisObjRelInsertInput>;
  analysis_id?: InputMaybe<Scalars['Int']>;
  application?: InputMaybe<ApplicationsObjRelInsertInput>;
  application_id?: InputMaybe<Scalars['Int']>;
  area?: InputMaybe<AreasObjRelInsertInput>;
  area_id?: InputMaybe<Scalars['Int']>;
  computed?: InputMaybe<AnalysisApplicationsComputedArrRelInsertInput>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  dashboards?: InputMaybe<ApplicationsDashboardsAnalysisArrRelInsertInput>;
  devices?: InputMaybe<AnalysisApplicationsDevicesArrRelInsertInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type AnalysisApplicationsMaxFields = {
  __typename?: 'analysis_applications_max_fields';
  analysis_id?: Maybe<Scalars['Int']>;
  application_id?: Maybe<Scalars['Int']>;
  area_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "analysis_applications" */
export type AnalysisApplicationsMaxOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  application_id?: InputMaybe<OrderBy>;
  area_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AnalysisApplicationsMinFields = {
  __typename?: 'analysis_applications_min_fields';
  analysis_id?: Maybe<Scalars['Int']>;
  application_id?: Maybe<Scalars['Int']>;
  area_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "analysis_applications" */
export type AnalysisApplicationsMinOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  application_id?: InputMaybe<OrderBy>;
  area_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "analysis_applications" */
export type AnalysisApplicationsMutationResponse = {
  __typename?: 'analysis_applications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AnalysisApplications>;
};

/** input type for inserting object relation for remote table "analysis_applications" */
export type AnalysisApplicationsObjRelInsertInput = {
  data: AnalysisApplicationsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AnalysisApplicationsOnConflict>;
};

/** on_conflict condition type for table "analysis_applications" */
export type AnalysisApplicationsOnConflict = {
  constraint: AnalysisApplicationsConstraint;
  update_columns?: Array<AnalysisApplicationsUpdateColumn>;
  where?: InputMaybe<AnalysisApplicationsBoolExp>;
};

/** Ordering options when selecting data from "analysis_applications". */
export type AnalysisApplicationsOrderBy = {
  analysis?: InputMaybe<AnalysisOrderBy>;
  analysis_id?: InputMaybe<OrderBy>;
  application?: InputMaybe<ApplicationsOrderBy>;
  application_id?: InputMaybe<OrderBy>;
  area?: InputMaybe<AreasOrderBy>;
  area_id?: InputMaybe<OrderBy>;
  computed_aggregate?: InputMaybe<AnalysisApplicationsComputedAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  dashboards_aggregate?: InputMaybe<ApplicationsDashboardsAnalysisAggregateOrderBy>;
  devices_aggregate?: InputMaybe<AnalysisApplicationsDevicesAggregateOrderBy>;
  enabled?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: analysis_applications */
export type AnalysisApplicationsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "analysis_applications" */
export enum AnalysisApplicationsSelectColumn {
  /** column name */
  ANALYSIS_ID = 'analysis_id',
  /** column name */
  APPLICATION_ID = 'application_id',
  /** column name */
  AREA_ID = 'area_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  ENABLED = 'enabled',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by'
}

/** select "analysis_applications_aggregate_bool_exp_bool_and_arguments_columns" columns of table "analysis_applications" */
export enum AnalysisApplicationsSelectColumnAnalysisApplicationsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  ENABLED = 'enabled'
}

/** select "analysis_applications_aggregate_bool_exp_bool_or_arguments_columns" columns of table "analysis_applications" */
export enum AnalysisApplicationsSelectColumnAnalysisApplicationsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  ENABLED = 'enabled'
}

/** input type for updating data in table "analysis_applications" */
export type AnalysisApplicationsSetInput = {
  analysis_id?: InputMaybe<Scalars['Int']>;
  application_id?: InputMaybe<Scalars['Int']>;
  area_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type AnalysisApplicationsStddevFields = {
  __typename?: 'analysis_applications_stddev_fields';
  analysis_id?: Maybe<Scalars['Float']>;
  application_id?: Maybe<Scalars['Float']>;
  area_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "analysis_applications" */
export type AnalysisApplicationsStddevOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  application_id?: InputMaybe<OrderBy>;
  area_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AnalysisApplicationsStddevPopFields = {
  __typename?: 'analysis_applications_stddev_pop_fields';
  analysis_id?: Maybe<Scalars['Float']>;
  application_id?: Maybe<Scalars['Float']>;
  area_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "analysis_applications" */
export type AnalysisApplicationsStddevPopOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  application_id?: InputMaybe<OrderBy>;
  area_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AnalysisApplicationsStddevSampFields = {
  __typename?: 'analysis_applications_stddev_samp_fields';
  analysis_id?: Maybe<Scalars['Float']>;
  application_id?: Maybe<Scalars['Float']>;
  area_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "analysis_applications" */
export type AnalysisApplicationsStddevSampOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  application_id?: InputMaybe<OrderBy>;
  area_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "analysis_applications" */
export type AnalysisApplicationsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AnalysisApplicationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AnalysisApplicationsStreamCursorValueInput = {
  analysis_id?: InputMaybe<Scalars['Int']>;
  application_id?: InputMaybe<Scalars['Int']>;
  area_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type AnalysisApplicationsSumFields = {
  __typename?: 'analysis_applications_sum_fields';
  analysis_id?: Maybe<Scalars['Int']>;
  application_id?: Maybe<Scalars['Int']>;
  area_id?: Maybe<Scalars['Int']>;
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "analysis_applications" */
export type AnalysisApplicationsSumOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  application_id?: InputMaybe<OrderBy>;
  area_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** update columns of table "analysis_applications" */
export enum AnalysisApplicationsUpdateColumn {
  /** column name */
  ANALYSIS_ID = 'analysis_id',
  /** column name */
  APPLICATION_ID = 'application_id',
  /** column name */
  AREA_ID = 'area_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  ENABLED = 'enabled',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by'
}

export type AnalysisApplicationsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AnalysisApplicationsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AnalysisApplicationsSetInput>;
  /** filter the rows which have to be updated */
  where: AnalysisApplicationsBoolExp;
};

/** aggregate var_pop on columns */
export type AnalysisApplicationsVarPopFields = {
  __typename?: 'analysis_applications_var_pop_fields';
  analysis_id?: Maybe<Scalars['Float']>;
  application_id?: Maybe<Scalars['Float']>;
  area_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "analysis_applications" */
export type AnalysisApplicationsVarPopOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  application_id?: InputMaybe<OrderBy>;
  area_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AnalysisApplicationsVarSampFields = {
  __typename?: 'analysis_applications_var_samp_fields';
  analysis_id?: Maybe<Scalars['Float']>;
  application_id?: Maybe<Scalars['Float']>;
  area_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "analysis_applications" */
export type AnalysisApplicationsVarSampOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  application_id?: InputMaybe<OrderBy>;
  area_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AnalysisApplicationsVarianceFields = {
  __typename?: 'analysis_applications_variance_fields';
  analysis_id?: Maybe<Scalars['Float']>;
  application_id?: Maybe<Scalars['Float']>;
  area_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "analysis_applications" */
export type AnalysisApplicationsVarianceOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  application_id?: InputMaybe<OrderBy>;
  area_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate avg on columns */
export type AnalysisAvgFields = {
  __typename?: 'analysis_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "analysis". All fields are combined with a logical 'AND'. */
export type AnalysisBoolExp = {
  _and?: InputMaybe<Array<AnalysisBoolExp>>;
  _not?: InputMaybe<AnalysisBoolExp>;
  _or?: InputMaybe<Array<AnalysisBoolExp>>;
  analysis__devices_payloads?: InputMaybe<AnalysisDevicesPayloadsBoolExp>;
  analysis__devices_payloads_aggregate?: InputMaybe<AnalysisDevicesPayloadsAggregateBoolExp>;
  analysis_applications?: InputMaybe<AnalysisApplicationsBoolExp>;
  analysis_applications_aggregate?: InputMaybe<AnalysisApplicationsAggregateBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  device_categories_configs?: InputMaybe<AnalysisDeviceCategoriesConfigsBoolExp>;
  device_categories_configs_aggregate?: InputMaybe<AnalysisDeviceCategoriesConfigsAggregateBoolExp>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  group?: InputMaybe<AnalysisGroupsEnumComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  kind?: InputMaybe<AnalysisKindsEnumComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "analysis" */
export enum AnalysisConstraint {
  /** unique or primary key constraint on columns "name" */
  ANALYSIS_NAME_KEY = 'analysis_name_key',
  /** unique or primary key constraint on columns "id" */
  ANALYSIS_PKEY = 'analysis_pkey',
  /** unique or primary key constraint on columns "slug" */
  ANALYSIS_SLUG_KEY = 'analysis_slug_key'
}

/** Config regarding required devices categories for analysis */
export type AnalysisDeviceCategoriesConfigs = {
  __typename?: 'analysis_device_categories_configs';
  /** An object relationship */
  analysis: Analysis;
  analysis_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  device_category: DeviceCategories;
  device_category_id: Scalars['Int'];
  id: Scalars['Int'];
  max: Scalars['Int'];
  min: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "analysis_device_categories_configs" */
export type AnalysisDeviceCategoriesConfigsAggregate = {
  __typename?: 'analysis_device_categories_configs_aggregate';
  aggregate?: Maybe<AnalysisDeviceCategoriesConfigsAggregateFields>;
  nodes: Array<AnalysisDeviceCategoriesConfigs>;
};

export type AnalysisDeviceCategoriesConfigsAggregateBoolExp = {
  count?: InputMaybe<AnalysisDeviceCategoriesConfigsAggregateBoolExpCount>;
};

export type AnalysisDeviceCategoriesConfigsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AnalysisDeviceCategoriesConfigsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AnalysisDeviceCategoriesConfigsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "analysis_device_categories_configs" */
export type AnalysisDeviceCategoriesConfigsAggregateFields = {
  __typename?: 'analysis_device_categories_configs_aggregate_fields';
  avg?: Maybe<AnalysisDeviceCategoriesConfigsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AnalysisDeviceCategoriesConfigsMaxFields>;
  min?: Maybe<AnalysisDeviceCategoriesConfigsMinFields>;
  stddev?: Maybe<AnalysisDeviceCategoriesConfigsStddevFields>;
  stddev_pop?: Maybe<AnalysisDeviceCategoriesConfigsStddevPopFields>;
  stddev_samp?: Maybe<AnalysisDeviceCategoriesConfigsStddevSampFields>;
  sum?: Maybe<AnalysisDeviceCategoriesConfigsSumFields>;
  var_pop?: Maybe<AnalysisDeviceCategoriesConfigsVarPopFields>;
  var_samp?: Maybe<AnalysisDeviceCategoriesConfigsVarSampFields>;
  variance?: Maybe<AnalysisDeviceCategoriesConfigsVarianceFields>;
};


/** aggregate fields of "analysis_device_categories_configs" */
export type AnalysisDeviceCategoriesConfigsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AnalysisDeviceCategoriesConfigsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "analysis_device_categories_configs" */
export type AnalysisDeviceCategoriesConfigsAggregateOrderBy = {
  avg?: InputMaybe<AnalysisDeviceCategoriesConfigsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AnalysisDeviceCategoriesConfigsMaxOrderBy>;
  min?: InputMaybe<AnalysisDeviceCategoriesConfigsMinOrderBy>;
  stddev?: InputMaybe<AnalysisDeviceCategoriesConfigsStddevOrderBy>;
  stddev_pop?: InputMaybe<AnalysisDeviceCategoriesConfigsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AnalysisDeviceCategoriesConfigsStddevSampOrderBy>;
  sum?: InputMaybe<AnalysisDeviceCategoriesConfigsSumOrderBy>;
  var_pop?: InputMaybe<AnalysisDeviceCategoriesConfigsVarPopOrderBy>;
  var_samp?: InputMaybe<AnalysisDeviceCategoriesConfigsVarSampOrderBy>;
  variance?: InputMaybe<AnalysisDeviceCategoriesConfigsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "analysis_device_categories_configs" */
export type AnalysisDeviceCategoriesConfigsArrRelInsertInput = {
  data: Array<AnalysisDeviceCategoriesConfigsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AnalysisDeviceCategoriesConfigsOnConflict>;
};

/** aggregate avg on columns */
export type AnalysisDeviceCategoriesConfigsAvgFields = {
  __typename?: 'analysis_device_categories_configs_avg_fields';
  analysis_id?: Maybe<Scalars['Float']>;
  device_category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "analysis_device_categories_configs" */
export type AnalysisDeviceCategoriesConfigsAvgOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  device_category_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  max?: InputMaybe<OrderBy>;
  min?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "analysis_device_categories_configs". All fields are combined with a logical 'AND'. */
export type AnalysisDeviceCategoriesConfigsBoolExp = {
  _and?: InputMaybe<Array<AnalysisDeviceCategoriesConfigsBoolExp>>;
  _not?: InputMaybe<AnalysisDeviceCategoriesConfigsBoolExp>;
  _or?: InputMaybe<Array<AnalysisDeviceCategoriesConfigsBoolExp>>;
  analysis?: InputMaybe<AnalysisBoolExp>;
  analysis_id?: InputMaybe<IntComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  device_category?: InputMaybe<DeviceCategoriesBoolExp>;
  device_category_id?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  max?: InputMaybe<IntComparisonExp>;
  min?: InputMaybe<IntComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "analysis_device_categories_configs" */
export enum AnalysisDeviceCategoriesConfigsConstraint {
  /** unique or primary key constraint on columns "device_category_id", "analysis_id" */
  ANALYSIS_DEVICE_CATEGORIES_CO_ANALYSIS_ID_DEVICE_CATEGORY_I_KEY = 'analysis_device_categories_co_analysis_id_device_category_i_key',
  /** unique or primary key constraint on columns "id" */
  ANALYSIS_DEVICE_CATEGORIES_CONFIGS_PKEY = 'analysis_device_categories_configs_pkey'
}

/** input type for incrementing numeric columns in table "analysis_device_categories_configs" */
export type AnalysisDeviceCategoriesConfigsIncInput = {
  analysis_id?: InputMaybe<Scalars['Int']>;
  device_category_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  max?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "analysis_device_categories_configs" */
export type AnalysisDeviceCategoriesConfigsInsertInput = {
  analysis?: InputMaybe<AnalysisObjRelInsertInput>;
  analysis_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device_category?: InputMaybe<DeviceCategoriesObjRelInsertInput>;
  device_category_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  max?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type AnalysisDeviceCategoriesConfigsMaxFields = {
  __typename?: 'analysis_device_categories_configs_max_fields';
  analysis_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  device_category_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  max?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "analysis_device_categories_configs" */
export type AnalysisDeviceCategoriesConfigsMaxOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  device_category_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  max?: InputMaybe<OrderBy>;
  min?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AnalysisDeviceCategoriesConfigsMinFields = {
  __typename?: 'analysis_device_categories_configs_min_fields';
  analysis_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  device_category_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  max?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "analysis_device_categories_configs" */
export type AnalysisDeviceCategoriesConfigsMinOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  device_category_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  max?: InputMaybe<OrderBy>;
  min?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "analysis_device_categories_configs" */
export type AnalysisDeviceCategoriesConfigsMutationResponse = {
  __typename?: 'analysis_device_categories_configs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AnalysisDeviceCategoriesConfigs>;
};

/** on_conflict condition type for table "analysis_device_categories_configs" */
export type AnalysisDeviceCategoriesConfigsOnConflict = {
  constraint: AnalysisDeviceCategoriesConfigsConstraint;
  update_columns?: Array<AnalysisDeviceCategoriesConfigsUpdateColumn>;
  where?: InputMaybe<AnalysisDeviceCategoriesConfigsBoolExp>;
};

/** Ordering options when selecting data from "analysis_device_categories_configs". */
export type AnalysisDeviceCategoriesConfigsOrderBy = {
  analysis?: InputMaybe<AnalysisOrderBy>;
  analysis_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  device_category?: InputMaybe<DeviceCategoriesOrderBy>;
  device_category_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  max?: InputMaybe<OrderBy>;
  min?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: analysis_device_categories_configs */
export type AnalysisDeviceCategoriesConfigsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "analysis_device_categories_configs" */
export enum AnalysisDeviceCategoriesConfigsSelectColumn {
  /** column name */
  ANALYSIS_ID = 'analysis_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEVICE_CATEGORY_ID = 'device_category_id',
  /** column name */
  ID = 'id',
  /** column name */
  MAX = 'max',
  /** column name */
  MIN = 'min',
  /** column name */
  UPDATED_AT = 'updated_at'
}

/** input type for updating data in table "analysis_device_categories_configs" */
export type AnalysisDeviceCategoriesConfigsSetInput = {
  analysis_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device_category_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  max?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type AnalysisDeviceCategoriesConfigsStddevFields = {
  __typename?: 'analysis_device_categories_configs_stddev_fields';
  analysis_id?: Maybe<Scalars['Float']>;
  device_category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "analysis_device_categories_configs" */
export type AnalysisDeviceCategoriesConfigsStddevOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  device_category_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  max?: InputMaybe<OrderBy>;
  min?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AnalysisDeviceCategoriesConfigsStddevPopFields = {
  __typename?: 'analysis_device_categories_configs_stddev_pop_fields';
  analysis_id?: Maybe<Scalars['Float']>;
  device_category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "analysis_device_categories_configs" */
export type AnalysisDeviceCategoriesConfigsStddevPopOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  device_category_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  max?: InputMaybe<OrderBy>;
  min?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AnalysisDeviceCategoriesConfigsStddevSampFields = {
  __typename?: 'analysis_device_categories_configs_stddev_samp_fields';
  analysis_id?: Maybe<Scalars['Float']>;
  device_category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "analysis_device_categories_configs" */
export type AnalysisDeviceCategoriesConfigsStddevSampOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  device_category_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  max?: InputMaybe<OrderBy>;
  min?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "analysis_device_categories_configs" */
export type AnalysisDeviceCategoriesConfigsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AnalysisDeviceCategoriesConfigsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AnalysisDeviceCategoriesConfigsStreamCursorValueInput = {
  analysis_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device_category_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  max?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type AnalysisDeviceCategoriesConfigsSumFields = {
  __typename?: 'analysis_device_categories_configs_sum_fields';
  analysis_id?: Maybe<Scalars['Int']>;
  device_category_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  max?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "analysis_device_categories_configs" */
export type AnalysisDeviceCategoriesConfigsSumOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  device_category_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  max?: InputMaybe<OrderBy>;
  min?: InputMaybe<OrderBy>;
};

/** update columns of table "analysis_device_categories_configs" */
export enum AnalysisDeviceCategoriesConfigsUpdateColumn {
  /** column name */
  ANALYSIS_ID = 'analysis_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEVICE_CATEGORY_ID = 'device_category_id',
  /** column name */
  ID = 'id',
  /** column name */
  MAX = 'max',
  /** column name */
  MIN = 'min',
  /** column name */
  UPDATED_AT = 'updated_at'
}

export type AnalysisDeviceCategoriesConfigsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AnalysisDeviceCategoriesConfigsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AnalysisDeviceCategoriesConfigsSetInput>;
  /** filter the rows which have to be updated */
  where: AnalysisDeviceCategoriesConfigsBoolExp;
};

/** aggregate var_pop on columns */
export type AnalysisDeviceCategoriesConfigsVarPopFields = {
  __typename?: 'analysis_device_categories_configs_var_pop_fields';
  analysis_id?: Maybe<Scalars['Float']>;
  device_category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "analysis_device_categories_configs" */
export type AnalysisDeviceCategoriesConfigsVarPopOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  device_category_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  max?: InputMaybe<OrderBy>;
  min?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AnalysisDeviceCategoriesConfigsVarSampFields = {
  __typename?: 'analysis_device_categories_configs_var_samp_fields';
  analysis_id?: Maybe<Scalars['Float']>;
  device_category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "analysis_device_categories_configs" */
export type AnalysisDeviceCategoriesConfigsVarSampOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  device_category_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  max?: InputMaybe<OrderBy>;
  min?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AnalysisDeviceCategoriesConfigsVarianceFields = {
  __typename?: 'analysis_device_categories_configs_variance_fields';
  analysis_id?: Maybe<Scalars['Float']>;
  device_category_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "analysis_device_categories_configs" */
export type AnalysisDeviceCategoriesConfigsVarianceOrderBy = {
  analysis_id?: InputMaybe<OrderBy>;
  device_category_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  max?: InputMaybe<OrderBy>;
  min?: InputMaybe<OrderBy>;
};

/** Enum related to analysis groups */
export type AnalysisGroups = {
  __typename?: 'analysis_groups';
  comment: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "analysis_groups" */
export type AnalysisGroupsAggregate = {
  __typename?: 'analysis_groups_aggregate';
  aggregate?: Maybe<AnalysisGroupsAggregateFields>;
  nodes: Array<AnalysisGroups>;
};

/** aggregate fields of "analysis_groups" */
export type AnalysisGroupsAggregateFields = {
  __typename?: 'analysis_groups_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<AnalysisGroupsMaxFields>;
  min?: Maybe<AnalysisGroupsMinFields>;
};


/** aggregate fields of "analysis_groups" */
export type AnalysisGroupsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AnalysisGroupsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "analysis_groups". All fields are combined with a logical 'AND'. */
export type AnalysisGroupsBoolExp = {
  _and?: InputMaybe<Array<AnalysisGroupsBoolExp>>;
  _not?: InputMaybe<AnalysisGroupsBoolExp>;
  _or?: InputMaybe<Array<AnalysisGroupsBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "analysis_groups" */
export enum AnalysisGroupsConstraint {
  /** unique or primary key constraint on columns "value" */
  ANALYSIS_GROUPS_PKEY = 'analysis_groups_pkey'
}

export enum AnalysisGroupsEnum {
  /** Health related analysis */
  HEALTH = 'HEALTH',
  /** Other kind of analysis */
  OTHER = 'OTHER',
  /** Prevention analysis */
  PREVENTION = 'PREVENTION'
}

/** Boolean expression to compare columns of type "analysis_groups_enum". All fields are combined with logical 'AND'. */
export type AnalysisGroupsEnumComparisonExp = {
  _eq?: InputMaybe<AnalysisGroupsEnum>;
  _in?: InputMaybe<Array<AnalysisGroupsEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<AnalysisGroupsEnum>;
  _nin?: InputMaybe<Array<AnalysisGroupsEnum>>;
};

/** input type for inserting data into table "analysis_groups" */
export type AnalysisGroupsInsertInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AnalysisGroupsMaxFields = {
  __typename?: 'analysis_groups_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AnalysisGroupsMinFields = {
  __typename?: 'analysis_groups_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "analysis_groups" */
export type AnalysisGroupsMutationResponse = {
  __typename?: 'analysis_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AnalysisGroups>;
};

/** on_conflict condition type for table "analysis_groups" */
export type AnalysisGroupsOnConflict = {
  constraint: AnalysisGroupsConstraint;
  update_columns?: Array<AnalysisGroupsUpdateColumn>;
  where?: InputMaybe<AnalysisGroupsBoolExp>;
};

/** Ordering options when selecting data from "analysis_groups". */
export type AnalysisGroupsOrderBy = {
  comment?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: analysis_groups */
export type AnalysisGroupsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "analysis_groups" */
export enum AnalysisGroupsSelectColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  VALUE = 'value'
}

/** input type for updating data in table "analysis_groups" */
export type AnalysisGroupsSetInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "analysis_groups" */
export type AnalysisGroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AnalysisGroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AnalysisGroupsStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "analysis_groups" */
export enum AnalysisGroupsUpdateColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  VALUE = 'value'
}

export type AnalysisGroupsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AnalysisGroupsSetInput>;
  /** filter the rows which have to be updated */
  where: AnalysisGroupsBoolExp;
};

/** input type for incrementing numeric columns in table "analysis" */
export type AnalysisIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "analysis" */
export type AnalysisInsertInput = {
  analysis__devices_payloads?: InputMaybe<AnalysisDevicesPayloadsArrRelInsertInput>;
  analysis_applications?: InputMaybe<AnalysisApplicationsArrRelInsertInput>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device_categories_configs?: InputMaybe<AnalysisDeviceCategoriesConfigsArrRelInsertInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<AnalysisGroupsEnum>;
  id?: InputMaybe<Scalars['Int']>;
  kind?: InputMaybe<AnalysisKindsEnum>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Kind of possibile data analysis */
export type AnalysisKinds = {
  __typename?: 'analysis_kinds';
  comment: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "analysis_kinds" */
export type AnalysisKindsAggregate = {
  __typename?: 'analysis_kinds_aggregate';
  aggregate?: Maybe<AnalysisKindsAggregateFields>;
  nodes: Array<AnalysisKinds>;
};

/** aggregate fields of "analysis_kinds" */
export type AnalysisKindsAggregateFields = {
  __typename?: 'analysis_kinds_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<AnalysisKindsMaxFields>;
  min?: Maybe<AnalysisKindsMinFields>;
};


/** aggregate fields of "analysis_kinds" */
export type AnalysisKindsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AnalysisKindsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "analysis_kinds". All fields are combined with a logical 'AND'. */
export type AnalysisKindsBoolExp = {
  _and?: InputMaybe<Array<AnalysisKindsBoolExp>>;
  _not?: InputMaybe<AnalysisKindsBoolExp>;
  _or?: InputMaybe<Array<AnalysisKindsBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "analysis_kinds" */
export enum AnalysisKindsConstraint {
  /** unique or primary key constraint on columns "value" */
  ANALYSIS_KINDS_PKEY = 'analysis_kinds_pkey'
}

export enum AnalysisKindsEnum {
  /** Analysis with payload copy from uplink */
  PAYLOAD_COPY = 'PAYLOAD_COPY',
  /** Analysis that predicts with ML model */
  PREDICTION_MODEL = 'PREDICTION_MODEL',
  /** Analysis that predicts manipulating data (numpy, pandas, etc) */
  PREDICTION_SIMPLE = 'PREDICTION_SIMPLE',
  /** General purpose simple analysis */
  SIMPLE = 'SIMPLE',
  /** Analysis with multiple payloads */
  SIMPLE_MULTI_PAYLOAD_SOURCE = 'SIMPLE_MULTI_PAYLOAD_SOURCE',
  /** Analysis with a single payload */
  SINGLE_PAYLOAD_SOURCE = 'SINGLE_PAYLOAD_SOURCE'
}

/** Boolean expression to compare columns of type "analysis_kinds_enum". All fields are combined with logical 'AND'. */
export type AnalysisKindsEnumComparisonExp = {
  _eq?: InputMaybe<AnalysisKindsEnum>;
  _in?: InputMaybe<Array<AnalysisKindsEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<AnalysisKindsEnum>;
  _nin?: InputMaybe<Array<AnalysisKindsEnum>>;
};

/** input type for inserting data into table "analysis_kinds" */
export type AnalysisKindsInsertInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AnalysisKindsMaxFields = {
  __typename?: 'analysis_kinds_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AnalysisKindsMinFields = {
  __typename?: 'analysis_kinds_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "analysis_kinds" */
export type AnalysisKindsMutationResponse = {
  __typename?: 'analysis_kinds_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AnalysisKinds>;
};

/** on_conflict condition type for table "analysis_kinds" */
export type AnalysisKindsOnConflict = {
  constraint: AnalysisKindsConstraint;
  update_columns?: Array<AnalysisKindsUpdateColumn>;
  where?: InputMaybe<AnalysisKindsBoolExp>;
};

/** Ordering options when selecting data from "analysis_kinds". */
export type AnalysisKindsOrderBy = {
  comment?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: analysis_kinds */
export type AnalysisKindsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "analysis_kinds" */
export enum AnalysisKindsSelectColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  VALUE = 'value'
}

/** input type for updating data in table "analysis_kinds" */
export type AnalysisKindsSetInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "analysis_kinds" */
export type AnalysisKindsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AnalysisKindsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AnalysisKindsStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "analysis_kinds" */
export enum AnalysisKindsUpdateColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  VALUE = 'value'
}

export type AnalysisKindsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AnalysisKindsSetInput>;
  /** filter the rows which have to be updated */
  where: AnalysisKindsBoolExp;
};

/** aggregate max on columns */
export type AnalysisMaxFields = {
  __typename?: 'analysis_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type AnalysisMinFields = {
  __typename?: 'analysis_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "analysis" */
export type AnalysisMutationResponse = {
  __typename?: 'analysis_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Analysis>;
};

/** input type for inserting object relation for remote table "analysis" */
export type AnalysisObjRelInsertInput = {
  data: AnalysisInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AnalysisOnConflict>;
};

/** on_conflict condition type for table "analysis" */
export type AnalysisOnConflict = {
  constraint: AnalysisConstraint;
  update_columns?: Array<AnalysisUpdateColumn>;
  where?: InputMaybe<AnalysisBoolExp>;
};

/** Ordering options when selecting data from "analysis". */
export type AnalysisOrderBy = {
  analysis__devices_payloads_aggregate?: InputMaybe<AnalysisDevicesPayloadsAggregateOrderBy>;
  analysis_applications_aggregate?: InputMaybe<AnalysisApplicationsAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  device_categories_configs_aggregate?: InputMaybe<AnalysisDeviceCategoriesConfigsAggregateOrderBy>;
  enabled?: InputMaybe<OrderBy>;
  group?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  kind?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: analysis */
export type AnalysisPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "analysis" */
export enum AnalysisSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ENABLED = 'enabled',
  /** column name */
  GROUP = 'group',
  /** column name */
  ID = 'id',
  /** column name */
  KIND = 'kind',
  /** column name */
  NAME = 'name',
  /** column name */
  SLUG = 'slug',
  /** column name */
  UPDATED_AT = 'updated_at'
}

/** input type for updating data in table "analysis" */
export type AnalysisSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<AnalysisGroupsEnum>;
  id?: InputMaybe<Scalars['Int']>;
  kind?: InputMaybe<AnalysisKindsEnum>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type AnalysisStddevFields = {
  __typename?: 'analysis_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AnalysisStddevPopFields = {
  __typename?: 'analysis_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AnalysisStddevSampFields = {
  __typename?: 'analysis_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "analysis" */
export type AnalysisStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AnalysisStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AnalysisStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<AnalysisGroupsEnum>;
  id?: InputMaybe<Scalars['Int']>;
  kind?: InputMaybe<AnalysisKindsEnum>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type AnalysisSumFields = {
  __typename?: 'analysis_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "analysis" */
export enum AnalysisUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ENABLED = 'enabled',
  /** column name */
  GROUP = 'group',
  /** column name */
  ID = 'id',
  /** column name */
  KIND = 'kind',
  /** column name */
  NAME = 'name',
  /** column name */
  SLUG = 'slug',
  /** column name */
  UPDATED_AT = 'updated_at'
}

export type AnalysisUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AnalysisIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AnalysisSetInput>;
  /** filter the rows which have to be updated */
  where: AnalysisBoolExp;
};

/** aggregate var_pop on columns */
export type AnalysisVarPopFields = {
  __typename?: 'analysis_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AnalysisVarSampFields = {
  __typename?: 'analysis_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AnalysisVarianceFields = {
  __typename?: 'analysis_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "applications" */
export type Applications = {
  __typename?: 'applications';
  address?: Maybe<Scalars['String']>;
  /** An array relationship */
  analysis_applications: Array<AnalysisApplications>;
  /** An aggregate relationship */
  analysis_applications_aggregate: AnalysisApplicationsAggregate;
  /** An array relationship */
  areas: Array<Areas>;
  /** An aggregate relationship */
  areas_aggregate: AreasAggregate;
  /** An array relationship */
  automations: Array<Automations>;
  /** An aggregate relationship */
  automations_aggregate: AutomationsAggregate;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  /** An array relationship */
  dashboards: Array<ApplicationsDashboards>;
  /** An aggregate relationship */
  dashboards_aggregate: ApplicationsDashboardsAggregate;
  /** An array relationship */
  devices: Array<Devices>;
  /** An aggregate relationship */
  devices_aggregate: DevicesAggregate;
  id: Scalars['Int'];
  lat?: Maybe<Scalars['numeric']>;
  lon?: Maybe<Scalars['numeric']>;
  name: Scalars['String'];
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['Int'];
  provider_id: Scalars['String'];
  /** An object relationship */
  settings?: Maybe<ApplicationsSettings>;
  timezone: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "applications" */
export type ApplicationsAnalysisApplicationsArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsBoolExp>;
};


/** columns and relationships of "applications" */
export type ApplicationsAnalysisApplicationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsBoolExp>;
};


/** columns and relationships of "applications" */
export type ApplicationsAreasArgs = {
  distinct_on?: InputMaybe<Array<AreasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AreasOrderBy>>;
  where?: InputMaybe<AreasBoolExp>;
};


/** columns and relationships of "applications" */
export type ApplicationsAreasAggregateArgs = {
  distinct_on?: InputMaybe<Array<AreasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AreasOrderBy>>;
  where?: InputMaybe<AreasBoolExp>;
};


/** columns and relationships of "applications" */
export type ApplicationsAutomationsArgs = {
  distinct_on?: InputMaybe<Array<AutomationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutomationsOrderBy>>;
  where?: InputMaybe<AutomationsBoolExp>;
};


/** columns and relationships of "applications" */
export type ApplicationsAutomationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AutomationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutomationsOrderBy>>;
  where?: InputMaybe<AutomationsBoolExp>;
};


/** columns and relationships of "applications" */
export type ApplicationsDashboardsArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsDashboardsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsDashboardsOrderBy>>;
  where?: InputMaybe<ApplicationsDashboardsBoolExp>;
};


/** columns and relationships of "applications" */
export type ApplicationsDashboardsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsDashboardsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsDashboardsOrderBy>>;
  where?: InputMaybe<ApplicationsDashboardsBoolExp>;
};


/** columns and relationships of "applications" */
export type ApplicationsDevicesArgs = {
  distinct_on?: InputMaybe<Array<DevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicesOrderBy>>;
  where?: InputMaybe<DevicesBoolExp>;
};


/** columns and relationships of "applications" */
export type ApplicationsDevicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicesOrderBy>>;
  where?: InputMaybe<DevicesBoolExp>;
};

/** aggregated selection of "applications" */
export type ApplicationsAggregate = {
  __typename?: 'applications_aggregate';
  aggregate?: Maybe<ApplicationsAggregateFields>;
  nodes: Array<Applications>;
};

export type ApplicationsAggregateBoolExp = {
  count?: InputMaybe<ApplicationsAggregateBoolExpCount>;
};

export type ApplicationsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ApplicationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ApplicationsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "applications" */
export type ApplicationsAggregateFields = {
  __typename?: 'applications_aggregate_fields';
  avg?: Maybe<ApplicationsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ApplicationsMaxFields>;
  min?: Maybe<ApplicationsMinFields>;
  stddev?: Maybe<ApplicationsStddevFields>;
  stddev_pop?: Maybe<ApplicationsStddevPopFields>;
  stddev_samp?: Maybe<ApplicationsStddevSampFields>;
  sum?: Maybe<ApplicationsSumFields>;
  var_pop?: Maybe<ApplicationsVarPopFields>;
  var_samp?: Maybe<ApplicationsVarSampFields>;
  variance?: Maybe<ApplicationsVarianceFields>;
};


/** aggregate fields of "applications" */
export type ApplicationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ApplicationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "applications" */
export type ApplicationsAggregateOrderBy = {
  avg?: InputMaybe<ApplicationsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ApplicationsMaxOrderBy>;
  min?: InputMaybe<ApplicationsMinOrderBy>;
  stddev?: InputMaybe<ApplicationsStddevOrderBy>;
  stddev_pop?: InputMaybe<ApplicationsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ApplicationsStddevSampOrderBy>;
  sum?: InputMaybe<ApplicationsSumOrderBy>;
  var_pop?: InputMaybe<ApplicationsVarPopOrderBy>;
  var_samp?: InputMaybe<ApplicationsVarSampOrderBy>;
  variance?: InputMaybe<ApplicationsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "applications" */
export type ApplicationsArrRelInsertInput = {
  data: Array<ApplicationsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ApplicationsOnConflict>;
};

/** aggregate avg on columns */
export type ApplicationsAvgFields = {
  __typename?: 'applications_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "applications" */
export type ApplicationsAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lat?: InputMaybe<OrderBy>;
  lon?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "applications". All fields are combined with a logical 'AND'. */
export type ApplicationsBoolExp = {
  _and?: InputMaybe<Array<ApplicationsBoolExp>>;
  _not?: InputMaybe<ApplicationsBoolExp>;
  _or?: InputMaybe<Array<ApplicationsBoolExp>>;
  address?: InputMaybe<StringComparisonExp>;
  analysis_applications?: InputMaybe<AnalysisApplicationsBoolExp>;
  analysis_applications_aggregate?: InputMaybe<AnalysisApplicationsAggregateBoolExp>;
  areas?: InputMaybe<AreasBoolExp>;
  areas_aggregate?: InputMaybe<AreasAggregateBoolExp>;
  automations?: InputMaybe<AutomationsBoolExp>;
  automations_aggregate?: InputMaybe<AutomationsAggregateBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<IntComparisonExp>;
  dashboards?: InputMaybe<ApplicationsDashboardsBoolExp>;
  dashboards_aggregate?: InputMaybe<ApplicationsDashboardsAggregateBoolExp>;
  devices?: InputMaybe<DevicesBoolExp>;
  devices_aggregate?: InputMaybe<DevicesAggregateBoolExp>;
  id?: InputMaybe<IntComparisonExp>;
  lat?: InputMaybe<NumericComparisonExp>;
  lon?: InputMaybe<NumericComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organization?: InputMaybe<OrganizationsBoolExp>;
  organization_id?: InputMaybe<IntComparisonExp>;
  provider_id?: InputMaybe<StringComparisonExp>;
  settings?: InputMaybe<ApplicationsSettingsBoolExp>;
  timezone?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "applications" */
export enum ApplicationsConstraint {
  /** unique or primary key constraint on columns "id" */
  APPLICATIONS_PKEY = 'applications_pkey',
  /** unique or primary key constraint on columns "provider_id" */
  APPLICATIONS_PROVIDERID_UNIQUE = 'applications_providerId_unique'
}

/** columns and relationships of "applications_dashboards" */
export type ApplicationsDashboards = {
  __typename?: 'applications_dashboards';
  /** An array relationship */
  analysis: Array<ApplicationsDashboardsAnalysis>;
  /** An aggregate relationship */
  analysis_aggregate: ApplicationsDashboardsAnalysisAggregate;
  /** An object relationship */
  application: Applications;
  application_id: Scalars['Int'];
  /** An array relationship */
  applications_dashboards_analysis: Array<ApplicationsDashboardsAnalysis>;
  /** An aggregate relationship */
  applications_dashboards_analysis_aggregate: ApplicationsDashboardsAnalysisAggregate;
  /** An array relationship */
  applications_dashboards_devices: Array<ApplicationsDashboardsDevices>;
  /** An aggregate relationship */
  applications_dashboards_devices_aggregate: ApplicationsDashboardsDevicesAggregate;
  id: Scalars['Int'];
};


/** columns and relationships of "applications_dashboards" */
export type ApplicationsDashboardsAnalysisArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsDashboardsAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsDashboardsAnalysisOrderBy>>;
  where?: InputMaybe<ApplicationsDashboardsAnalysisBoolExp>;
};


/** columns and relationships of "applications_dashboards" */
export type ApplicationsDashboardsAnalysisAggregateArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsDashboardsAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsDashboardsAnalysisOrderBy>>;
  where?: InputMaybe<ApplicationsDashboardsAnalysisBoolExp>;
};


/** columns and relationships of "applications_dashboards" */
export type ApplicationsDashboardsApplicationsDashboardsAnalysisArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsDashboardsAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsDashboardsAnalysisOrderBy>>;
  where?: InputMaybe<ApplicationsDashboardsAnalysisBoolExp>;
};


/** columns and relationships of "applications_dashboards" */
export type ApplicationsDashboardsApplicationsDashboardsAnalysisAggregateArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsDashboardsAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsDashboardsAnalysisOrderBy>>;
  where?: InputMaybe<ApplicationsDashboardsAnalysisBoolExp>;
};


/** columns and relationships of "applications_dashboards" */
export type ApplicationsDashboardsApplicationsDashboardsDevicesArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsDashboardsDevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsDashboardsDevicesOrderBy>>;
  where?: InputMaybe<ApplicationsDashboardsDevicesBoolExp>;
};


/** columns and relationships of "applications_dashboards" */
export type ApplicationsDashboardsApplicationsDashboardsDevicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsDashboardsDevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsDashboardsDevicesOrderBy>>;
  where?: InputMaybe<ApplicationsDashboardsDevicesBoolExp>;
};

/** aggregated selection of "applications_dashboards" */
export type ApplicationsDashboardsAggregate = {
  __typename?: 'applications_dashboards_aggregate';
  aggregate?: Maybe<ApplicationsDashboardsAggregateFields>;
  nodes: Array<ApplicationsDashboards>;
};

export type ApplicationsDashboardsAggregateBoolExp = {
  count?: InputMaybe<ApplicationsDashboardsAggregateBoolExpCount>;
};

export type ApplicationsDashboardsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ApplicationsDashboardsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ApplicationsDashboardsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "applications_dashboards" */
export type ApplicationsDashboardsAggregateFields = {
  __typename?: 'applications_dashboards_aggregate_fields';
  avg?: Maybe<ApplicationsDashboardsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ApplicationsDashboardsMaxFields>;
  min?: Maybe<ApplicationsDashboardsMinFields>;
  stddev?: Maybe<ApplicationsDashboardsStddevFields>;
  stddev_pop?: Maybe<ApplicationsDashboardsStddevPopFields>;
  stddev_samp?: Maybe<ApplicationsDashboardsStddevSampFields>;
  sum?: Maybe<ApplicationsDashboardsSumFields>;
  var_pop?: Maybe<ApplicationsDashboardsVarPopFields>;
  var_samp?: Maybe<ApplicationsDashboardsVarSampFields>;
  variance?: Maybe<ApplicationsDashboardsVarianceFields>;
};


/** aggregate fields of "applications_dashboards" */
export type ApplicationsDashboardsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ApplicationsDashboardsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "applications_dashboards" */
export type ApplicationsDashboardsAggregateOrderBy = {
  avg?: InputMaybe<ApplicationsDashboardsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ApplicationsDashboardsMaxOrderBy>;
  min?: InputMaybe<ApplicationsDashboardsMinOrderBy>;
  stddev?: InputMaybe<ApplicationsDashboardsStddevOrderBy>;
  stddev_pop?: InputMaybe<ApplicationsDashboardsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ApplicationsDashboardsStddevSampOrderBy>;
  sum?: InputMaybe<ApplicationsDashboardsSumOrderBy>;
  var_pop?: InputMaybe<ApplicationsDashboardsVarPopOrderBy>;
  var_samp?: InputMaybe<ApplicationsDashboardsVarSampOrderBy>;
  variance?: InputMaybe<ApplicationsDashboardsVarianceOrderBy>;
};

/** analysis added to dashboard */
export type ApplicationsDashboardsAnalysis = {
  __typename?: 'applications_dashboards_analysis';
  /** An object relationship */
  analysis_application: AnalysisApplications;
  analysis_application_id: Scalars['Int'];
  /** An object relationship */
  application_dashboard: ApplicationsDashboards;
  application_dashboard_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "applications_dashboards_analysis" */
export type ApplicationsDashboardsAnalysisAggregate = {
  __typename?: 'applications_dashboards_analysis_aggregate';
  aggregate?: Maybe<ApplicationsDashboardsAnalysisAggregateFields>;
  nodes: Array<ApplicationsDashboardsAnalysis>;
};

export type ApplicationsDashboardsAnalysisAggregateBoolExp = {
  count?: InputMaybe<ApplicationsDashboardsAnalysisAggregateBoolExpCount>;
};

export type ApplicationsDashboardsAnalysisAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ApplicationsDashboardsAnalysisSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ApplicationsDashboardsAnalysisBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "applications_dashboards_analysis" */
export type ApplicationsDashboardsAnalysisAggregateFields = {
  __typename?: 'applications_dashboards_analysis_aggregate_fields';
  avg?: Maybe<ApplicationsDashboardsAnalysisAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ApplicationsDashboardsAnalysisMaxFields>;
  min?: Maybe<ApplicationsDashboardsAnalysisMinFields>;
  stddev?: Maybe<ApplicationsDashboardsAnalysisStddevFields>;
  stddev_pop?: Maybe<ApplicationsDashboardsAnalysisStddevPopFields>;
  stddev_samp?: Maybe<ApplicationsDashboardsAnalysisStddevSampFields>;
  sum?: Maybe<ApplicationsDashboardsAnalysisSumFields>;
  var_pop?: Maybe<ApplicationsDashboardsAnalysisVarPopFields>;
  var_samp?: Maybe<ApplicationsDashboardsAnalysisVarSampFields>;
  variance?: Maybe<ApplicationsDashboardsAnalysisVarianceFields>;
};


/** aggregate fields of "applications_dashboards_analysis" */
export type ApplicationsDashboardsAnalysisAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ApplicationsDashboardsAnalysisSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "applications_dashboards_analysis" */
export type ApplicationsDashboardsAnalysisAggregateOrderBy = {
  avg?: InputMaybe<ApplicationsDashboardsAnalysisAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ApplicationsDashboardsAnalysisMaxOrderBy>;
  min?: InputMaybe<ApplicationsDashboardsAnalysisMinOrderBy>;
  stddev?: InputMaybe<ApplicationsDashboardsAnalysisStddevOrderBy>;
  stddev_pop?: InputMaybe<ApplicationsDashboardsAnalysisStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ApplicationsDashboardsAnalysisStddevSampOrderBy>;
  sum?: InputMaybe<ApplicationsDashboardsAnalysisSumOrderBy>;
  var_pop?: InputMaybe<ApplicationsDashboardsAnalysisVarPopOrderBy>;
  var_samp?: InputMaybe<ApplicationsDashboardsAnalysisVarSampOrderBy>;
  variance?: InputMaybe<ApplicationsDashboardsAnalysisVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "applications_dashboards_analysis" */
export type ApplicationsDashboardsAnalysisArrRelInsertInput = {
  data: Array<ApplicationsDashboardsAnalysisInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ApplicationsDashboardsAnalysisOnConflict>;
};

/** aggregate avg on columns */
export type ApplicationsDashboardsAnalysisAvgFields = {
  __typename?: 'applications_dashboards_analysis_avg_fields';
  analysis_application_id?: Maybe<Scalars['Float']>;
  application_dashboard_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "applications_dashboards_analysis" */
export type ApplicationsDashboardsAnalysisAvgOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  application_dashboard_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "applications_dashboards_analysis". All fields are combined with a logical 'AND'. */
export type ApplicationsDashboardsAnalysisBoolExp = {
  _and?: InputMaybe<Array<ApplicationsDashboardsAnalysisBoolExp>>;
  _not?: InputMaybe<ApplicationsDashboardsAnalysisBoolExp>;
  _or?: InputMaybe<Array<ApplicationsDashboardsAnalysisBoolExp>>;
  analysis_application?: InputMaybe<AnalysisApplicationsBoolExp>;
  analysis_application_id?: InputMaybe<IntComparisonExp>;
  application_dashboard?: InputMaybe<ApplicationsDashboardsBoolExp>;
  application_dashboard_id?: InputMaybe<IntComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "applications_dashboards_analysis" */
export enum ApplicationsDashboardsAnalysisConstraint {
  /** unique or primary key constraint on columns "id" */
  APPLICATIONS_DASHBOARDS_ANALYSIS_PKEY = 'applications_dashboards_analysis_pkey'
}

/** input type for incrementing numeric columns in table "applications_dashboards_analysis" */
export type ApplicationsDashboardsAnalysisIncInput = {
  analysis_application_id?: InputMaybe<Scalars['Int']>;
  application_dashboard_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "applications_dashboards_analysis" */
export type ApplicationsDashboardsAnalysisInsertInput = {
  analysis_application?: InputMaybe<AnalysisApplicationsObjRelInsertInput>;
  analysis_application_id?: InputMaybe<Scalars['Int']>;
  application_dashboard?: InputMaybe<ApplicationsDashboardsObjRelInsertInput>;
  application_dashboard_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ApplicationsDashboardsAnalysisMaxFields = {
  __typename?: 'applications_dashboards_analysis_max_fields';
  analysis_application_id?: Maybe<Scalars['Int']>;
  application_dashboard_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "applications_dashboards_analysis" */
export type ApplicationsDashboardsAnalysisMaxOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  application_dashboard_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ApplicationsDashboardsAnalysisMinFields = {
  __typename?: 'applications_dashboards_analysis_min_fields';
  analysis_application_id?: Maybe<Scalars['Int']>;
  application_dashboard_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "applications_dashboards_analysis" */
export type ApplicationsDashboardsAnalysisMinOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  application_dashboard_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "applications_dashboards_analysis" */
export type ApplicationsDashboardsAnalysisMutationResponse = {
  __typename?: 'applications_dashboards_analysis_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ApplicationsDashboardsAnalysis>;
};

/** on_conflict condition type for table "applications_dashboards_analysis" */
export type ApplicationsDashboardsAnalysisOnConflict = {
  constraint: ApplicationsDashboardsAnalysisConstraint;
  update_columns?: Array<ApplicationsDashboardsAnalysisUpdateColumn>;
  where?: InputMaybe<ApplicationsDashboardsAnalysisBoolExp>;
};

/** Ordering options when selecting data from "applications_dashboards_analysis". */
export type ApplicationsDashboardsAnalysisOrderBy = {
  analysis_application?: InputMaybe<AnalysisApplicationsOrderBy>;
  analysis_application_id?: InputMaybe<OrderBy>;
  application_dashboard?: InputMaybe<ApplicationsDashboardsOrderBy>;
  application_dashboard_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: applications_dashboards_analysis */
export type ApplicationsDashboardsAnalysisPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "applications_dashboards_analysis" */
export enum ApplicationsDashboardsAnalysisSelectColumn {
  /** column name */
  ANALYSIS_APPLICATION_ID = 'analysis_application_id',
  /** column name */
  APPLICATION_DASHBOARD_ID = 'application_dashboard_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
}

/** input type for updating data in table "applications_dashboards_analysis" */
export type ApplicationsDashboardsAnalysisSetInput = {
  analysis_application_id?: InputMaybe<Scalars['Int']>;
  application_dashboard_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type ApplicationsDashboardsAnalysisStddevFields = {
  __typename?: 'applications_dashboards_analysis_stddev_fields';
  analysis_application_id?: Maybe<Scalars['Float']>;
  application_dashboard_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "applications_dashboards_analysis" */
export type ApplicationsDashboardsAnalysisStddevOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  application_dashboard_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ApplicationsDashboardsAnalysisStddevPopFields = {
  __typename?: 'applications_dashboards_analysis_stddev_pop_fields';
  analysis_application_id?: Maybe<Scalars['Float']>;
  application_dashboard_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "applications_dashboards_analysis" */
export type ApplicationsDashboardsAnalysisStddevPopOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  application_dashboard_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ApplicationsDashboardsAnalysisStddevSampFields = {
  __typename?: 'applications_dashboards_analysis_stddev_samp_fields';
  analysis_application_id?: Maybe<Scalars['Float']>;
  application_dashboard_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "applications_dashboards_analysis" */
export type ApplicationsDashboardsAnalysisStddevSampOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  application_dashboard_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "applications_dashboards_analysis" */
export type ApplicationsDashboardsAnalysisStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ApplicationsDashboardsAnalysisStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ApplicationsDashboardsAnalysisStreamCursorValueInput = {
  analysis_application_id?: InputMaybe<Scalars['Int']>;
  application_dashboard_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type ApplicationsDashboardsAnalysisSumFields = {
  __typename?: 'applications_dashboards_analysis_sum_fields';
  analysis_application_id?: Maybe<Scalars['Int']>;
  application_dashboard_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "applications_dashboards_analysis" */
export type ApplicationsDashboardsAnalysisSumOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  application_dashboard_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "applications_dashboards_analysis" */
export enum ApplicationsDashboardsAnalysisUpdateColumn {
  /** column name */
  ANALYSIS_APPLICATION_ID = 'analysis_application_id',
  /** column name */
  APPLICATION_DASHBOARD_ID = 'application_dashboard_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
}

export type ApplicationsDashboardsAnalysisUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ApplicationsDashboardsAnalysisIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ApplicationsDashboardsAnalysisSetInput>;
  /** filter the rows which have to be updated */
  where: ApplicationsDashboardsAnalysisBoolExp;
};

/** aggregate var_pop on columns */
export type ApplicationsDashboardsAnalysisVarPopFields = {
  __typename?: 'applications_dashboards_analysis_var_pop_fields';
  analysis_application_id?: Maybe<Scalars['Float']>;
  application_dashboard_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "applications_dashboards_analysis" */
export type ApplicationsDashboardsAnalysisVarPopOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  application_dashboard_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ApplicationsDashboardsAnalysisVarSampFields = {
  __typename?: 'applications_dashboards_analysis_var_samp_fields';
  analysis_application_id?: Maybe<Scalars['Float']>;
  application_dashboard_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "applications_dashboards_analysis" */
export type ApplicationsDashboardsAnalysisVarSampOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  application_dashboard_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ApplicationsDashboardsAnalysisVarianceFields = {
  __typename?: 'applications_dashboards_analysis_variance_fields';
  analysis_application_id?: Maybe<Scalars['Float']>;
  application_dashboard_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "applications_dashboards_analysis" */
export type ApplicationsDashboardsAnalysisVarianceOrderBy = {
  analysis_application_id?: InputMaybe<OrderBy>;
  application_dashboard_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** input type for inserting array relation for remote table "applications_dashboards" */
export type ApplicationsDashboardsArrRelInsertInput = {
  data: Array<ApplicationsDashboardsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ApplicationsDashboardsOnConflict>;
};

/** aggregate avg on columns */
export type ApplicationsDashboardsAvgFields = {
  __typename?: 'applications_dashboards_avg_fields';
  application_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "applications_dashboards" */
export type ApplicationsDashboardsAvgOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "applications_dashboards". All fields are combined with a logical 'AND'. */
export type ApplicationsDashboardsBoolExp = {
  _and?: InputMaybe<Array<ApplicationsDashboardsBoolExp>>;
  _not?: InputMaybe<ApplicationsDashboardsBoolExp>;
  _or?: InputMaybe<Array<ApplicationsDashboardsBoolExp>>;
  analysis?: InputMaybe<ApplicationsDashboardsAnalysisBoolExp>;
  analysis_aggregate?: InputMaybe<ApplicationsDashboardsAnalysisAggregateBoolExp>;
  application?: InputMaybe<ApplicationsBoolExp>;
  application_id?: InputMaybe<IntComparisonExp>;
  applications_dashboards_analysis?: InputMaybe<ApplicationsDashboardsAnalysisBoolExp>;
  applications_dashboards_analysis_aggregate?: InputMaybe<ApplicationsDashboardsAnalysisAggregateBoolExp>;
  applications_dashboards_devices?: InputMaybe<ApplicationsDashboardsDevicesBoolExp>;
  applications_dashboards_devices_aggregate?: InputMaybe<ApplicationsDashboardsDevicesAggregateBoolExp>;
  id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "applications_dashboards" */
export enum ApplicationsDashboardsConstraint {
  /** unique or primary key constraint on columns "id" */
  APPLICATIONS_DASHBOARDS_PKEY = 'applications_dashboards_pkey'
}

/** columns and relationships of "applications_dashboards_devices" */
export type ApplicationsDashboardsDevices = {
  __typename?: 'applications_dashboards_devices';
  application_dashboard_id: Scalars['Int'];
  /** An object relationship */
  applications_dashboard: ApplicationsDashboards;
  /** An object relationship */
  device: Devices;
  device_id: Scalars['Int'];
  id: Scalars['Int'];
};

/** aggregated selection of "applications_dashboards_devices" */
export type ApplicationsDashboardsDevicesAggregate = {
  __typename?: 'applications_dashboards_devices_aggregate';
  aggregate?: Maybe<ApplicationsDashboardsDevicesAggregateFields>;
  nodes: Array<ApplicationsDashboardsDevices>;
};

export type ApplicationsDashboardsDevicesAggregateBoolExp = {
  count?: InputMaybe<ApplicationsDashboardsDevicesAggregateBoolExpCount>;
};

export type ApplicationsDashboardsDevicesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ApplicationsDashboardsDevicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ApplicationsDashboardsDevicesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "applications_dashboards_devices" */
export type ApplicationsDashboardsDevicesAggregateFields = {
  __typename?: 'applications_dashboards_devices_aggregate_fields';
  avg?: Maybe<ApplicationsDashboardsDevicesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ApplicationsDashboardsDevicesMaxFields>;
  min?: Maybe<ApplicationsDashboardsDevicesMinFields>;
  stddev?: Maybe<ApplicationsDashboardsDevicesStddevFields>;
  stddev_pop?: Maybe<ApplicationsDashboardsDevicesStddevPopFields>;
  stddev_samp?: Maybe<ApplicationsDashboardsDevicesStddevSampFields>;
  sum?: Maybe<ApplicationsDashboardsDevicesSumFields>;
  var_pop?: Maybe<ApplicationsDashboardsDevicesVarPopFields>;
  var_samp?: Maybe<ApplicationsDashboardsDevicesVarSampFields>;
  variance?: Maybe<ApplicationsDashboardsDevicesVarianceFields>;
};


/** aggregate fields of "applications_dashboards_devices" */
export type ApplicationsDashboardsDevicesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ApplicationsDashboardsDevicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "applications_dashboards_devices" */
export type ApplicationsDashboardsDevicesAggregateOrderBy = {
  avg?: InputMaybe<ApplicationsDashboardsDevicesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ApplicationsDashboardsDevicesMaxOrderBy>;
  min?: InputMaybe<ApplicationsDashboardsDevicesMinOrderBy>;
  stddev?: InputMaybe<ApplicationsDashboardsDevicesStddevOrderBy>;
  stddev_pop?: InputMaybe<ApplicationsDashboardsDevicesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ApplicationsDashboardsDevicesStddevSampOrderBy>;
  sum?: InputMaybe<ApplicationsDashboardsDevicesSumOrderBy>;
  var_pop?: InputMaybe<ApplicationsDashboardsDevicesVarPopOrderBy>;
  var_samp?: InputMaybe<ApplicationsDashboardsDevicesVarSampOrderBy>;
  variance?: InputMaybe<ApplicationsDashboardsDevicesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "applications_dashboards_devices" */
export type ApplicationsDashboardsDevicesArrRelInsertInput = {
  data: Array<ApplicationsDashboardsDevicesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ApplicationsDashboardsDevicesOnConflict>;
};

/** aggregate avg on columns */
export type ApplicationsDashboardsDevicesAvgFields = {
  __typename?: 'applications_dashboards_devices_avg_fields';
  application_dashboard_id?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "applications_dashboards_devices" */
export type ApplicationsDashboardsDevicesAvgOrderBy = {
  application_dashboard_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "applications_dashboards_devices". All fields are combined with a logical 'AND'. */
export type ApplicationsDashboardsDevicesBoolExp = {
  _and?: InputMaybe<Array<ApplicationsDashboardsDevicesBoolExp>>;
  _not?: InputMaybe<ApplicationsDashboardsDevicesBoolExp>;
  _or?: InputMaybe<Array<ApplicationsDashboardsDevicesBoolExp>>;
  application_dashboard_id?: InputMaybe<IntComparisonExp>;
  applications_dashboard?: InputMaybe<ApplicationsDashboardsBoolExp>;
  device?: InputMaybe<DevicesBoolExp>;
  device_id?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "applications_dashboards_devices" */
export enum ApplicationsDashboardsDevicesConstraint {
  /** unique or primary key constraint on columns "id" */
  APPLICATIONS_DASHBOARDS_DEVICES_PKEY = 'applications_dashboards_devices_pkey'
}

/** input type for incrementing numeric columns in table "applications_dashboards_devices" */
export type ApplicationsDashboardsDevicesIncInput = {
  application_dashboard_id?: InputMaybe<Scalars['Int']>;
  device_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "applications_dashboards_devices" */
export type ApplicationsDashboardsDevicesInsertInput = {
  application_dashboard_id?: InputMaybe<Scalars['Int']>;
  applications_dashboard?: InputMaybe<ApplicationsDashboardsObjRelInsertInput>;
  device?: InputMaybe<DevicesObjRelInsertInput>;
  device_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type ApplicationsDashboardsDevicesMaxFields = {
  __typename?: 'applications_dashboards_devices_max_fields';
  application_dashboard_id?: Maybe<Scalars['Int']>;
  device_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "applications_dashboards_devices" */
export type ApplicationsDashboardsDevicesMaxOrderBy = {
  application_dashboard_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ApplicationsDashboardsDevicesMinFields = {
  __typename?: 'applications_dashboards_devices_min_fields';
  application_dashboard_id?: Maybe<Scalars['Int']>;
  device_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "applications_dashboards_devices" */
export type ApplicationsDashboardsDevicesMinOrderBy = {
  application_dashboard_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "applications_dashboards_devices" */
export type ApplicationsDashboardsDevicesMutationResponse = {
  __typename?: 'applications_dashboards_devices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ApplicationsDashboardsDevices>;
};

/** on_conflict condition type for table "applications_dashboards_devices" */
export type ApplicationsDashboardsDevicesOnConflict = {
  constraint: ApplicationsDashboardsDevicesConstraint;
  update_columns?: Array<ApplicationsDashboardsDevicesUpdateColumn>;
  where?: InputMaybe<ApplicationsDashboardsDevicesBoolExp>;
};

/** Ordering options when selecting data from "applications_dashboards_devices". */
export type ApplicationsDashboardsDevicesOrderBy = {
  application_dashboard_id?: InputMaybe<OrderBy>;
  applications_dashboard?: InputMaybe<ApplicationsDashboardsOrderBy>;
  device?: InputMaybe<DevicesOrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: applications_dashboards_devices */
export type ApplicationsDashboardsDevicesPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "applications_dashboards_devices" */
export enum ApplicationsDashboardsDevicesSelectColumn {
  /** column name */
  APPLICATION_DASHBOARD_ID = 'application_dashboard_id',
  /** column name */
  DEVICE_ID = 'device_id',
  /** column name */
  ID = 'id'
}

/** input type for updating data in table "applications_dashboards_devices" */
export type ApplicationsDashboardsDevicesSetInput = {
  application_dashboard_id?: InputMaybe<Scalars['Int']>;
  device_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type ApplicationsDashboardsDevicesStddevFields = {
  __typename?: 'applications_dashboards_devices_stddev_fields';
  application_dashboard_id?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "applications_dashboards_devices" */
export type ApplicationsDashboardsDevicesStddevOrderBy = {
  application_dashboard_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ApplicationsDashboardsDevicesStddevPopFields = {
  __typename?: 'applications_dashboards_devices_stddev_pop_fields';
  application_dashboard_id?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "applications_dashboards_devices" */
export type ApplicationsDashboardsDevicesStddevPopOrderBy = {
  application_dashboard_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ApplicationsDashboardsDevicesStddevSampFields = {
  __typename?: 'applications_dashboards_devices_stddev_samp_fields';
  application_dashboard_id?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "applications_dashboards_devices" */
export type ApplicationsDashboardsDevicesStddevSampOrderBy = {
  application_dashboard_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "applications_dashboards_devices" */
export type ApplicationsDashboardsDevicesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ApplicationsDashboardsDevicesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ApplicationsDashboardsDevicesStreamCursorValueInput = {
  application_dashboard_id?: InputMaybe<Scalars['Int']>;
  device_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ApplicationsDashboardsDevicesSumFields = {
  __typename?: 'applications_dashboards_devices_sum_fields';
  application_dashboard_id?: Maybe<Scalars['Int']>;
  device_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "applications_dashboards_devices" */
export type ApplicationsDashboardsDevicesSumOrderBy = {
  application_dashboard_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "applications_dashboards_devices" */
export enum ApplicationsDashboardsDevicesUpdateColumn {
  /** column name */
  APPLICATION_DASHBOARD_ID = 'application_dashboard_id',
  /** column name */
  DEVICE_ID = 'device_id',
  /** column name */
  ID = 'id'
}

export type ApplicationsDashboardsDevicesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ApplicationsDashboardsDevicesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ApplicationsDashboardsDevicesSetInput>;
  /** filter the rows which have to be updated */
  where: ApplicationsDashboardsDevicesBoolExp;
};

/** aggregate var_pop on columns */
export type ApplicationsDashboardsDevicesVarPopFields = {
  __typename?: 'applications_dashboards_devices_var_pop_fields';
  application_dashboard_id?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "applications_dashboards_devices" */
export type ApplicationsDashboardsDevicesVarPopOrderBy = {
  application_dashboard_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ApplicationsDashboardsDevicesVarSampFields = {
  __typename?: 'applications_dashboards_devices_var_samp_fields';
  application_dashboard_id?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "applications_dashboards_devices" */
export type ApplicationsDashboardsDevicesVarSampOrderBy = {
  application_dashboard_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ApplicationsDashboardsDevicesVarianceFields = {
  __typename?: 'applications_dashboards_devices_variance_fields';
  application_dashboard_id?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "applications_dashboards_devices" */
export type ApplicationsDashboardsDevicesVarianceOrderBy = {
  application_dashboard_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** input type for incrementing numeric columns in table "applications_dashboards" */
export type ApplicationsDashboardsIncInput = {
  application_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "applications_dashboards" */
export type ApplicationsDashboardsInsertInput = {
  analysis?: InputMaybe<ApplicationsDashboardsAnalysisArrRelInsertInput>;
  application?: InputMaybe<ApplicationsObjRelInsertInput>;
  application_id?: InputMaybe<Scalars['Int']>;
  applications_dashboards_analysis?: InputMaybe<ApplicationsDashboardsAnalysisArrRelInsertInput>;
  applications_dashboards_devices?: InputMaybe<ApplicationsDashboardsDevicesArrRelInsertInput>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type ApplicationsDashboardsMaxFields = {
  __typename?: 'applications_dashboards_max_fields';
  application_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "applications_dashboards" */
export type ApplicationsDashboardsMaxOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ApplicationsDashboardsMinFields = {
  __typename?: 'applications_dashboards_min_fields';
  application_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "applications_dashboards" */
export type ApplicationsDashboardsMinOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "applications_dashboards" */
export type ApplicationsDashboardsMutationResponse = {
  __typename?: 'applications_dashboards_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ApplicationsDashboards>;
};

/** input type for inserting object relation for remote table "applications_dashboards" */
export type ApplicationsDashboardsObjRelInsertInput = {
  data: ApplicationsDashboardsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<ApplicationsDashboardsOnConflict>;
};

/** on_conflict condition type for table "applications_dashboards" */
export type ApplicationsDashboardsOnConflict = {
  constraint: ApplicationsDashboardsConstraint;
  update_columns?: Array<ApplicationsDashboardsUpdateColumn>;
  where?: InputMaybe<ApplicationsDashboardsBoolExp>;
};

/** Ordering options when selecting data from "applications_dashboards". */
export type ApplicationsDashboardsOrderBy = {
  analysis_aggregate?: InputMaybe<ApplicationsDashboardsAnalysisAggregateOrderBy>;
  application?: InputMaybe<ApplicationsOrderBy>;
  application_id?: InputMaybe<OrderBy>;
  applications_dashboards_analysis_aggregate?: InputMaybe<ApplicationsDashboardsAnalysisAggregateOrderBy>;
  applications_dashboards_devices_aggregate?: InputMaybe<ApplicationsDashboardsDevicesAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: applications_dashboards */
export type ApplicationsDashboardsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "applications_dashboards" */
export enum ApplicationsDashboardsSelectColumn {
  /** column name */
  APPLICATION_ID = 'application_id',
  /** column name */
  ID = 'id'
}

/** input type for updating data in table "applications_dashboards" */
export type ApplicationsDashboardsSetInput = {
  application_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type ApplicationsDashboardsStddevFields = {
  __typename?: 'applications_dashboards_stddev_fields';
  application_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "applications_dashboards" */
export type ApplicationsDashboardsStddevOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ApplicationsDashboardsStddevPopFields = {
  __typename?: 'applications_dashboards_stddev_pop_fields';
  application_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "applications_dashboards" */
export type ApplicationsDashboardsStddevPopOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ApplicationsDashboardsStddevSampFields = {
  __typename?: 'applications_dashboards_stddev_samp_fields';
  application_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "applications_dashboards" */
export type ApplicationsDashboardsStddevSampOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "applications_dashboards" */
export type ApplicationsDashboardsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ApplicationsDashboardsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ApplicationsDashboardsStreamCursorValueInput = {
  application_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ApplicationsDashboardsSumFields = {
  __typename?: 'applications_dashboards_sum_fields';
  application_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "applications_dashboards" */
export type ApplicationsDashboardsSumOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "applications_dashboards" */
export enum ApplicationsDashboardsUpdateColumn {
  /** column name */
  APPLICATION_ID = 'application_id',
  /** column name */
  ID = 'id'
}

export type ApplicationsDashboardsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ApplicationsDashboardsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ApplicationsDashboardsSetInput>;
  /** filter the rows which have to be updated */
  where: ApplicationsDashboardsBoolExp;
};

/** aggregate var_pop on columns */
export type ApplicationsDashboardsVarPopFields = {
  __typename?: 'applications_dashboards_var_pop_fields';
  application_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "applications_dashboards" */
export type ApplicationsDashboardsVarPopOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ApplicationsDashboardsVarSampFields = {
  __typename?: 'applications_dashboards_var_samp_fields';
  application_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "applications_dashboards" */
export type ApplicationsDashboardsVarSampOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ApplicationsDashboardsVarianceFields = {
  __typename?: 'applications_dashboards_variance_fields';
  application_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "applications_dashboards" */
export type ApplicationsDashboardsVarianceOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** input type for incrementing numeric columns in table "applications" */
export type ApplicationsIncInput = {
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  lat?: InputMaybe<Scalars['numeric']>;
  lon?: InputMaybe<Scalars['numeric']>;
  organization_id?: InputMaybe<Scalars['Int']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "applications" */
export type ApplicationsInsertInput = {
  address?: InputMaybe<Scalars['String']>;
  analysis_applications?: InputMaybe<AnalysisApplicationsArrRelInsertInput>;
  areas?: InputMaybe<AreasArrRelInsertInput>;
  automations?: InputMaybe<AutomationsArrRelInsertInput>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  dashboards?: InputMaybe<ApplicationsDashboardsArrRelInsertInput>;
  devices?: InputMaybe<DevicesArrRelInsertInput>;
  id?: InputMaybe<Scalars['Int']>;
  lat?: InputMaybe<Scalars['numeric']>;
  lon?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationsObjRelInsertInput>;
  organization_id?: InputMaybe<Scalars['Int']>;
  provider_id?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<ApplicationsSettingsObjRelInsertInput>;
  timezone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type ApplicationsMaxFields = {
  __typename?: 'applications_max_fields';
  address?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['numeric']>;
  lon?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['Int']>;
  provider_id?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "applications" */
export type ApplicationsMaxOrderBy = {
  address?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lat?: InputMaybe<OrderBy>;
  lon?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  timezone?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ApplicationsMinFields = {
  __typename?: 'applications_min_fields';
  address?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['numeric']>;
  lon?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['Int']>;
  provider_id?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "applications" */
export type ApplicationsMinOrderBy = {
  address?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lat?: InputMaybe<OrderBy>;
  lon?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  timezone?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "applications" */
export type ApplicationsMutationResponse = {
  __typename?: 'applications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Applications>;
};

/** input type for inserting object relation for remote table "applications" */
export type ApplicationsObjRelInsertInput = {
  data: ApplicationsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<ApplicationsOnConflict>;
};

/** on_conflict condition type for table "applications" */
export type ApplicationsOnConflict = {
  constraint: ApplicationsConstraint;
  update_columns?: Array<ApplicationsUpdateColumn>;
  where?: InputMaybe<ApplicationsBoolExp>;
};

/** Ordering options when selecting data from "applications". */
export type ApplicationsOrderBy = {
  address?: InputMaybe<OrderBy>;
  analysis_applications_aggregate?: InputMaybe<AnalysisApplicationsAggregateOrderBy>;
  areas_aggregate?: InputMaybe<AreasAggregateOrderBy>;
  automations_aggregate?: InputMaybe<AutomationsAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  dashboards_aggregate?: InputMaybe<ApplicationsDashboardsAggregateOrderBy>;
  devices_aggregate?: InputMaybe<DevicesAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  lat?: InputMaybe<OrderBy>;
  lon?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organization?: InputMaybe<OrganizationsOrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  settings?: InputMaybe<ApplicationsSettingsOrderBy>;
  timezone?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: applications */
export type ApplicationsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "applications" */
export enum ApplicationsSelectColumn {
  /** column name */
  ADDRESS = 'address',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  ID = 'id',
  /** column name */
  LAT = 'lat',
  /** column name */
  LON = 'lon',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANIZATION_ID = 'organization_id',
  /** column name */
  PROVIDER_ID = 'provider_id',
  /** column name */
  TIMEZONE = 'timezone',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by'
}

/** input type for updating data in table "applications" */
export type ApplicationsSetInput = {
  address?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  lat?: InputMaybe<Scalars['numeric']>;
  lon?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['Int']>;
  provider_id?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** Applications settings configurable by users */
export type ApplicationsSettings = {
  __typename?: 'applications_settings';
  /** An object relationship */
  application: Applications;
  application_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  luma: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['Int']>;
  weather: Scalars['Boolean'];
};

/** aggregated selection of "applications_settings" */
export type ApplicationsSettingsAggregate = {
  __typename?: 'applications_settings_aggregate';
  aggregate?: Maybe<ApplicationsSettingsAggregateFields>;
  nodes: Array<ApplicationsSettings>;
};

/** aggregate fields of "applications_settings" */
export type ApplicationsSettingsAggregateFields = {
  __typename?: 'applications_settings_aggregate_fields';
  avg?: Maybe<ApplicationsSettingsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ApplicationsSettingsMaxFields>;
  min?: Maybe<ApplicationsSettingsMinFields>;
  stddev?: Maybe<ApplicationsSettingsStddevFields>;
  stddev_pop?: Maybe<ApplicationsSettingsStddevPopFields>;
  stddev_samp?: Maybe<ApplicationsSettingsStddevSampFields>;
  sum?: Maybe<ApplicationsSettingsSumFields>;
  var_pop?: Maybe<ApplicationsSettingsVarPopFields>;
  var_samp?: Maybe<ApplicationsSettingsVarSampFields>;
  variance?: Maybe<ApplicationsSettingsVarianceFields>;
};


/** aggregate fields of "applications_settings" */
export type ApplicationsSettingsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ApplicationsSettingsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ApplicationsSettingsAvgFields = {
  __typename?: 'applications_settings_avg_fields';
  application_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "applications_settings". All fields are combined with a logical 'AND'. */
export type ApplicationsSettingsBoolExp = {
  _and?: InputMaybe<Array<ApplicationsSettingsBoolExp>>;
  _not?: InputMaybe<ApplicationsSettingsBoolExp>;
  _or?: InputMaybe<Array<ApplicationsSettingsBoolExp>>;
  application?: InputMaybe<ApplicationsBoolExp>;
  application_id?: InputMaybe<IntComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  luma?: InputMaybe<BooleanComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<IntComparisonExp>;
  weather?: InputMaybe<BooleanComparisonExp>;
};

/** unique or primary key constraints on table "applications_settings" */
export enum ApplicationsSettingsConstraint {
  /** unique or primary key constraint on columns "application_id" */
  APPLICATIONS_SETTINGS_APPLICATION_ID_KEY = 'applications_settings_application_id_key',
  /** unique or primary key constraint on columns "id" */
  APPLICATIONS_SETTINGS_PKEY = 'applications_settings_pkey'
}

/** input type for incrementing numeric columns in table "applications_settings" */
export type ApplicationsSettingsIncInput = {
  application_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "applications_settings" */
export type ApplicationsSettingsInsertInput = {
  application?: InputMaybe<ApplicationsObjRelInsertInput>;
  application_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  luma?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  weather?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type ApplicationsSettingsMaxFields = {
  __typename?: 'applications_settings_max_fields';
  application_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type ApplicationsSettingsMinFields = {
  __typename?: 'applications_settings_min_fields';
  application_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "applications_settings" */
export type ApplicationsSettingsMutationResponse = {
  __typename?: 'applications_settings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ApplicationsSettings>;
};

/** input type for inserting object relation for remote table "applications_settings" */
export type ApplicationsSettingsObjRelInsertInput = {
  data: ApplicationsSettingsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<ApplicationsSettingsOnConflict>;
};

/** on_conflict condition type for table "applications_settings" */
export type ApplicationsSettingsOnConflict = {
  constraint: ApplicationsSettingsConstraint;
  update_columns?: Array<ApplicationsSettingsUpdateColumn>;
  where?: InputMaybe<ApplicationsSettingsBoolExp>;
};

/** Ordering options when selecting data from "applications_settings". */
export type ApplicationsSettingsOrderBy = {
  application?: InputMaybe<ApplicationsOrderBy>;
  application_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  luma?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  weather?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: applications_settings */
export type ApplicationsSettingsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "applications_settings" */
export enum ApplicationsSettingsSelectColumn {
  /** column name */
  APPLICATION_ID = 'application_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  LUMA = 'luma',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by',
  /** column name */
  WEATHER = 'weather'
}

/** input type for updating data in table "applications_settings" */
export type ApplicationsSettingsSetInput = {
  application_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  luma?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  weather?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type ApplicationsSettingsStddevFields = {
  __typename?: 'applications_settings_stddev_fields';
  application_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ApplicationsSettingsStddevPopFields = {
  __typename?: 'applications_settings_stddev_pop_fields';
  application_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ApplicationsSettingsStddevSampFields = {
  __typename?: 'applications_settings_stddev_samp_fields';
  application_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "applications_settings" */
export type ApplicationsSettingsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ApplicationsSettingsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ApplicationsSettingsStreamCursorValueInput = {
  application_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  luma?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  weather?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type ApplicationsSettingsSumFields = {
  __typename?: 'applications_settings_sum_fields';
  application_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** update columns of table "applications_settings" */
export enum ApplicationsSettingsUpdateColumn {
  /** column name */
  APPLICATION_ID = 'application_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  LUMA = 'luma',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by',
  /** column name */
  WEATHER = 'weather'
}

export type ApplicationsSettingsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ApplicationsSettingsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ApplicationsSettingsSetInput>;
  /** filter the rows which have to be updated */
  where: ApplicationsSettingsBoolExp;
};

/** aggregate var_pop on columns */
export type ApplicationsSettingsVarPopFields = {
  __typename?: 'applications_settings_var_pop_fields';
  application_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ApplicationsSettingsVarSampFields = {
  __typename?: 'applications_settings_var_samp_fields';
  application_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ApplicationsSettingsVarianceFields = {
  __typename?: 'applications_settings_variance_fields';
  application_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate stddev on columns */
export type ApplicationsStddevFields = {
  __typename?: 'applications_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "applications" */
export type ApplicationsStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lat?: InputMaybe<OrderBy>;
  lon?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ApplicationsStddevPopFields = {
  __typename?: 'applications_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "applications" */
export type ApplicationsStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lat?: InputMaybe<OrderBy>;
  lon?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ApplicationsStddevSampFields = {
  __typename?: 'applications_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "applications" */
export type ApplicationsStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lat?: InputMaybe<OrderBy>;
  lon?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "applications" */
export type ApplicationsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ApplicationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ApplicationsStreamCursorValueInput = {
  address?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  lat?: InputMaybe<Scalars['numeric']>;
  lon?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['Int']>;
  provider_id?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ApplicationsSumFields = {
  __typename?: 'applications_sum_fields';
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['numeric']>;
  lon?: Maybe<Scalars['numeric']>;
  organization_id?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "applications" */
export type ApplicationsSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lat?: InputMaybe<OrderBy>;
  lon?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** update columns of table "applications" */
export enum ApplicationsUpdateColumn {
  /** column name */
  ADDRESS = 'address',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  ID = 'id',
  /** column name */
  LAT = 'lat',
  /** column name */
  LON = 'lon',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANIZATION_ID = 'organization_id',
  /** column name */
  PROVIDER_ID = 'provider_id',
  /** column name */
  TIMEZONE = 'timezone',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by'
}

export type ApplicationsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ApplicationsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ApplicationsSetInput>;
  /** filter the rows which have to be updated */
  where: ApplicationsBoolExp;
};

/** aggregate var_pop on columns */
export type ApplicationsVarPopFields = {
  __typename?: 'applications_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "applications" */
export type ApplicationsVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lat?: InputMaybe<OrderBy>;
  lon?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ApplicationsVarSampFields = {
  __typename?: 'applications_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "applications" */
export type ApplicationsVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lat?: InputMaybe<OrderBy>;
  lon?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ApplicationsVarianceFields = {
  __typename?: 'applications_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "applications" */
export type ApplicationsVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lat?: InputMaybe<OrderBy>;
  lon?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** areas container entity */
export type Areas = {
  __typename?: 'areas';
  /** An array relationship */
  analysis_applications: Array<AnalysisApplications>;
  /** An aggregate relationship */
  analysis_applications_aggregate: AnalysisApplicationsAggregate;
  /** An object relationship */
  application: Applications;
  application_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['Int']>;
  /** An object relationship */
  cultivation?: Maybe<AreasScopeCultivation>;
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  devices: Array<Devices>;
  /** An aggregate relationship */
  devices_aggregate: DevicesAggregate;
  icon?: Maybe<Scalars['areaicon']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  scope: AreasScopesEnum;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['Int']>;
};


/** areas container entity */
export type AreasAnalysisApplicationsArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsBoolExp>;
};


/** areas container entity */
export type AreasAnalysisApplicationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsBoolExp>;
};


/** areas container entity */
export type AreasDevicesArgs = {
  distinct_on?: InputMaybe<Array<DevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicesOrderBy>>;
  where?: InputMaybe<DevicesBoolExp>;
};


/** areas container entity */
export type AreasDevicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicesOrderBy>>;
  where?: InputMaybe<DevicesBoolExp>;
};


/** areas container entity */
export type AreasIconArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "areas" */
export type AreasAggregate = {
  __typename?: 'areas_aggregate';
  aggregate?: Maybe<AreasAggregateFields>;
  nodes: Array<Areas>;
};

export type AreasAggregateBoolExp = {
  count?: InputMaybe<AreasAggregateBoolExpCount>;
};

export type AreasAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AreasSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AreasBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "areas" */
export type AreasAggregateFields = {
  __typename?: 'areas_aggregate_fields';
  avg?: Maybe<AreasAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AreasMaxFields>;
  min?: Maybe<AreasMinFields>;
  stddev?: Maybe<AreasStddevFields>;
  stddev_pop?: Maybe<AreasStddevPopFields>;
  stddev_samp?: Maybe<AreasStddevSampFields>;
  sum?: Maybe<AreasSumFields>;
  var_pop?: Maybe<AreasVarPopFields>;
  var_samp?: Maybe<AreasVarSampFields>;
  variance?: Maybe<AreasVarianceFields>;
};


/** aggregate fields of "areas" */
export type AreasAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AreasSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "areas" */
export type AreasAggregateOrderBy = {
  avg?: InputMaybe<AreasAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AreasMaxOrderBy>;
  min?: InputMaybe<AreasMinOrderBy>;
  stddev?: InputMaybe<AreasStddevOrderBy>;
  stddev_pop?: InputMaybe<AreasStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AreasStddevSampOrderBy>;
  sum?: InputMaybe<AreasSumOrderBy>;
  var_pop?: InputMaybe<AreasVarPopOrderBy>;
  var_samp?: InputMaybe<AreasVarSampOrderBy>;
  variance?: InputMaybe<AreasVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AreasAppendInput = {
  icon?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "areas" */
export type AreasArrRelInsertInput = {
  data: Array<AreasInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AreasOnConflict>;
};

/** aggregate avg on columns */
export type AreasAvgFields = {
  __typename?: 'areas_avg_fields';
  application_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "areas" */
export type AreasAvgOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "areas". All fields are combined with a logical 'AND'. */
export type AreasBoolExp = {
  _and?: InputMaybe<Array<AreasBoolExp>>;
  _not?: InputMaybe<AreasBoolExp>;
  _or?: InputMaybe<Array<AreasBoolExp>>;
  analysis_applications?: InputMaybe<AnalysisApplicationsBoolExp>;
  analysis_applications_aggregate?: InputMaybe<AnalysisApplicationsAggregateBoolExp>;
  application?: InputMaybe<ApplicationsBoolExp>;
  application_id?: InputMaybe<IntComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<IntComparisonExp>;
  cultivation?: InputMaybe<AreasScopeCultivationBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  devices?: InputMaybe<DevicesBoolExp>;
  devices_aggregate?: InputMaybe<DevicesAggregateBoolExp>;
  icon?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  scope?: InputMaybe<AreasScopesEnumComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "areas" */
export enum AreasConstraint {
  /** unique or primary key constraint on columns "id" */
  AREAS_PKEY = 'areas_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AreasDeleteAtPathInput = {
  icon?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AreasDeleteElemInput = {
  icon?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AreasDeleteKeyInput = {
  icon?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "areas" */
export type AreasIncInput = {
  application_id?: InputMaybe<Scalars['Int']>;
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "areas" */
export type AreasInsertInput = {
  analysis_applications?: InputMaybe<AnalysisApplicationsArrRelInsertInput>;
  application?: InputMaybe<ApplicationsObjRelInsertInput>;
  application_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  cultivation?: InputMaybe<AreasScopeCultivationObjRelInsertInput>;
  description?: InputMaybe<Scalars['String']>;
  devices?: InputMaybe<DevicesArrRelInsertInput>;
  icon?: InputMaybe<Scalars['areaicon']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<AreasScopesEnum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type AreasMaxFields = {
  __typename?: 'areas_max_fields';
  application_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "areas" */
export type AreasMaxOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AreasMinFields = {
  __typename?: 'areas_min_fields';
  application_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "areas" */
export type AreasMinOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "areas" */
export type AreasMutationResponse = {
  __typename?: 'areas_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Areas>;
};

/** input type for inserting object relation for remote table "areas" */
export type AreasObjRelInsertInput = {
  data: AreasInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AreasOnConflict>;
};

/** on_conflict condition type for table "areas" */
export type AreasOnConflict = {
  constraint: AreasConstraint;
  update_columns?: Array<AreasUpdateColumn>;
  where?: InputMaybe<AreasBoolExp>;
};

/** Ordering options when selecting data from "areas". */
export type AreasOrderBy = {
  analysis_applications_aggregate?: InputMaybe<AnalysisApplicationsAggregateOrderBy>;
  application?: InputMaybe<ApplicationsOrderBy>;
  application_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  cultivation?: InputMaybe<AreasScopeCultivationOrderBy>;
  description?: InputMaybe<OrderBy>;
  devices_aggregate?: InputMaybe<DevicesAggregateOrderBy>;
  icon?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  scope?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: areas */
export type AreasPkColumnsInput = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AreasPrependInput = {
  icon?: InputMaybe<Scalars['jsonb']>;
};

/** Areas attribute related to cultivation scope */
export type AreasScopeCultivation = {
  __typename?: 'areas_scope_cultivation';
  /** An object relationship */
  area: Areas;
  area_id: Scalars['Int'];
  aw?: Maybe<Scalars['numeric']>;
  ca?: Maybe<Scalars['numeric']>;
  clay_percentage?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['Int']>;
  cultivation_type: CultivationTypesEnum;
  eaw?: Maybe<Scalars['numeric']>;
  farming_container?: Maybe<FarmingContainersEnum>;
  farming_container_capacity?: Maybe<Scalars['Int']>;
  farming_method: FarmingMethodsEnum;
  farming_structure: FarmingStructuresEnum;
  id: Scalars['Int'];
  nw?: Maybe<Scalars['numeric']>;
  organic_material_percentage?: Maybe<Scalars['Int']>;
  rw?: Maybe<Scalars['numeric']>;
  sand_percentage?: Maybe<Scalars['Int']>;
  /** An object relationship */
  substrate?: Maybe<Substrates>;
  substrate_id?: Maybe<Scalars['Int']>;
  taw?: Maybe<Scalars['numeric']>;
  tw?: Maybe<Scalars['numeric']>;
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['Int']>;
  wa?: Maybe<Scalars['numeric']>;
  wo?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "areas_scope_cultivation" */
export type AreasScopeCultivationAggregate = {
  __typename?: 'areas_scope_cultivation_aggregate';
  aggregate?: Maybe<AreasScopeCultivationAggregateFields>;
  nodes: Array<AreasScopeCultivation>;
};

/** aggregate fields of "areas_scope_cultivation" */
export type AreasScopeCultivationAggregateFields = {
  __typename?: 'areas_scope_cultivation_aggregate_fields';
  avg?: Maybe<AreasScopeCultivationAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AreasScopeCultivationMaxFields>;
  min?: Maybe<AreasScopeCultivationMinFields>;
  stddev?: Maybe<AreasScopeCultivationStddevFields>;
  stddev_pop?: Maybe<AreasScopeCultivationStddevPopFields>;
  stddev_samp?: Maybe<AreasScopeCultivationStddevSampFields>;
  sum?: Maybe<AreasScopeCultivationSumFields>;
  var_pop?: Maybe<AreasScopeCultivationVarPopFields>;
  var_samp?: Maybe<AreasScopeCultivationVarSampFields>;
  variance?: Maybe<AreasScopeCultivationVarianceFields>;
};


/** aggregate fields of "areas_scope_cultivation" */
export type AreasScopeCultivationAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AreasScopeCultivationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AreasScopeCultivationAvgFields = {
  __typename?: 'areas_scope_cultivation_avg_fields';
  area_id?: Maybe<Scalars['Float']>;
  aw?: Maybe<Scalars['Float']>;
  ca?: Maybe<Scalars['Float']>;
  clay_percentage?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  eaw?: Maybe<Scalars['Float']>;
  farming_container_capacity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nw?: Maybe<Scalars['Float']>;
  organic_material_percentage?: Maybe<Scalars['Float']>;
  rw?: Maybe<Scalars['Float']>;
  sand_percentage?: Maybe<Scalars['Float']>;
  substrate_id?: Maybe<Scalars['Float']>;
  taw?: Maybe<Scalars['Float']>;
  tw?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  wa?: Maybe<Scalars['Float']>;
  wo?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "areas_scope_cultivation". All fields are combined with a logical 'AND'. */
export type AreasScopeCultivationBoolExp = {
  _and?: InputMaybe<Array<AreasScopeCultivationBoolExp>>;
  _not?: InputMaybe<AreasScopeCultivationBoolExp>;
  _or?: InputMaybe<Array<AreasScopeCultivationBoolExp>>;
  area?: InputMaybe<AreasBoolExp>;
  area_id?: InputMaybe<IntComparisonExp>;
  aw?: InputMaybe<NumericComparisonExp>;
  ca?: InputMaybe<NumericComparisonExp>;
  clay_percentage?: InputMaybe<IntComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<IntComparisonExp>;
  cultivation_type?: InputMaybe<CultivationTypesEnumComparisonExp>;
  eaw?: InputMaybe<NumericComparisonExp>;
  farming_container?: InputMaybe<FarmingContainersEnumComparisonExp>;
  farming_container_capacity?: InputMaybe<IntComparisonExp>;
  farming_method?: InputMaybe<FarmingMethodsEnumComparisonExp>;
  farming_structure?: InputMaybe<FarmingStructuresEnumComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  nw?: InputMaybe<NumericComparisonExp>;
  organic_material_percentage?: InputMaybe<IntComparisonExp>;
  rw?: InputMaybe<NumericComparisonExp>;
  sand_percentage?: InputMaybe<IntComparisonExp>;
  substrate?: InputMaybe<SubstratesBoolExp>;
  substrate_id?: InputMaybe<IntComparisonExp>;
  taw?: InputMaybe<NumericComparisonExp>;
  tw?: InputMaybe<NumericComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<IntComparisonExp>;
  wa?: InputMaybe<NumericComparisonExp>;
  wo?: InputMaybe<NumericComparisonExp>;
};

/** unique or primary key constraints on table "areas_scope_cultivation" */
export enum AreasScopeCultivationConstraint {
  /** unique or primary key constraint on columns "id" */
  AREAS_SCOPE_CULTIVATION_PKEY = 'areas_scope_cultivation_pkey'
}

/** input type for incrementing numeric columns in table "areas_scope_cultivation" */
export type AreasScopeCultivationIncInput = {
  area_id?: InputMaybe<Scalars['Int']>;
  aw?: InputMaybe<Scalars['numeric']>;
  ca?: InputMaybe<Scalars['numeric']>;
  clay_percentage?: InputMaybe<Scalars['Int']>;
  created_by?: InputMaybe<Scalars['Int']>;
  eaw?: InputMaybe<Scalars['numeric']>;
  farming_container_capacity?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  nw?: InputMaybe<Scalars['numeric']>;
  organic_material_percentage?: InputMaybe<Scalars['Int']>;
  rw?: InputMaybe<Scalars['numeric']>;
  sand_percentage?: InputMaybe<Scalars['Int']>;
  substrate_id?: InputMaybe<Scalars['Int']>;
  taw?: InputMaybe<Scalars['numeric']>;
  tw?: InputMaybe<Scalars['numeric']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  wa?: InputMaybe<Scalars['numeric']>;
  wo?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "areas_scope_cultivation" */
export type AreasScopeCultivationInsertInput = {
  area?: InputMaybe<AreasObjRelInsertInput>;
  area_id?: InputMaybe<Scalars['Int']>;
  aw?: InputMaybe<Scalars['numeric']>;
  ca?: InputMaybe<Scalars['numeric']>;
  clay_percentage?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  cultivation_type?: InputMaybe<CultivationTypesEnum>;
  eaw?: InputMaybe<Scalars['numeric']>;
  farming_container?: InputMaybe<FarmingContainersEnum>;
  farming_container_capacity?: InputMaybe<Scalars['Int']>;
  farming_method?: InputMaybe<FarmingMethodsEnum>;
  farming_structure?: InputMaybe<FarmingStructuresEnum>;
  id?: InputMaybe<Scalars['Int']>;
  nw?: InputMaybe<Scalars['numeric']>;
  organic_material_percentage?: InputMaybe<Scalars['Int']>;
  rw?: InputMaybe<Scalars['numeric']>;
  sand_percentage?: InputMaybe<Scalars['Int']>;
  substrate?: InputMaybe<SubstratesObjRelInsertInput>;
  substrate_id?: InputMaybe<Scalars['Int']>;
  taw?: InputMaybe<Scalars['numeric']>;
  tw?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  wa?: InputMaybe<Scalars['numeric']>;
  wo?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type AreasScopeCultivationMaxFields = {
  __typename?: 'areas_scope_cultivation_max_fields';
  area_id?: Maybe<Scalars['Int']>;
  aw?: Maybe<Scalars['numeric']>;
  ca?: Maybe<Scalars['numeric']>;
  clay_percentage?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  eaw?: Maybe<Scalars['numeric']>;
  farming_container_capacity?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  nw?: Maybe<Scalars['numeric']>;
  organic_material_percentage?: Maybe<Scalars['Int']>;
  rw?: Maybe<Scalars['numeric']>;
  sand_percentage?: Maybe<Scalars['Int']>;
  substrate_id?: Maybe<Scalars['Int']>;
  taw?: Maybe<Scalars['numeric']>;
  tw?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
  wa?: Maybe<Scalars['numeric']>;
  wo?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type AreasScopeCultivationMinFields = {
  __typename?: 'areas_scope_cultivation_min_fields';
  area_id?: Maybe<Scalars['Int']>;
  aw?: Maybe<Scalars['numeric']>;
  ca?: Maybe<Scalars['numeric']>;
  clay_percentage?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  eaw?: Maybe<Scalars['numeric']>;
  farming_container_capacity?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  nw?: Maybe<Scalars['numeric']>;
  organic_material_percentage?: Maybe<Scalars['Int']>;
  rw?: Maybe<Scalars['numeric']>;
  sand_percentage?: Maybe<Scalars['Int']>;
  substrate_id?: Maybe<Scalars['Int']>;
  taw?: Maybe<Scalars['numeric']>;
  tw?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
  wa?: Maybe<Scalars['numeric']>;
  wo?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "areas_scope_cultivation" */
export type AreasScopeCultivationMutationResponse = {
  __typename?: 'areas_scope_cultivation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AreasScopeCultivation>;
};

/** input type for inserting object relation for remote table "areas_scope_cultivation" */
export type AreasScopeCultivationObjRelInsertInput = {
  data: AreasScopeCultivationInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AreasScopeCultivationOnConflict>;
};

/** on_conflict condition type for table "areas_scope_cultivation" */
export type AreasScopeCultivationOnConflict = {
  constraint: AreasScopeCultivationConstraint;
  update_columns?: Array<AreasScopeCultivationUpdateColumn>;
  where?: InputMaybe<AreasScopeCultivationBoolExp>;
};

/** Ordering options when selecting data from "areas_scope_cultivation". */
export type AreasScopeCultivationOrderBy = {
  area?: InputMaybe<AreasOrderBy>;
  area_id?: InputMaybe<OrderBy>;
  aw?: InputMaybe<OrderBy>;
  ca?: InputMaybe<OrderBy>;
  clay_percentage?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  cultivation_type?: InputMaybe<OrderBy>;
  eaw?: InputMaybe<OrderBy>;
  farming_container?: InputMaybe<OrderBy>;
  farming_container_capacity?: InputMaybe<OrderBy>;
  farming_method?: InputMaybe<OrderBy>;
  farming_structure?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  nw?: InputMaybe<OrderBy>;
  organic_material_percentage?: InputMaybe<OrderBy>;
  rw?: InputMaybe<OrderBy>;
  sand_percentage?: InputMaybe<OrderBy>;
  substrate?: InputMaybe<SubstratesOrderBy>;
  substrate_id?: InputMaybe<OrderBy>;
  taw?: InputMaybe<OrderBy>;
  tw?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  wa?: InputMaybe<OrderBy>;
  wo?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: areas_scope_cultivation */
export type AreasScopeCultivationPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "areas_scope_cultivation" */
export enum AreasScopeCultivationSelectColumn {
  /** column name */
  AREA_ID = 'area_id',
  /** column name */
  AW = 'aw',
  /** column name */
  CA = 'ca',
  /** column name */
  CLAY_PERCENTAGE = 'clay_percentage',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  CULTIVATION_TYPE = 'cultivation_type',
  /** column name */
  EAW = 'eaw',
  /** column name */
  FARMING_CONTAINER = 'farming_container',
  /** column name */
  FARMING_CONTAINER_CAPACITY = 'farming_container_capacity',
  /** column name */
  FARMING_METHOD = 'farming_method',
  /** column name */
  FARMING_STRUCTURE = 'farming_structure',
  /** column name */
  ID = 'id',
  /** column name */
  NW = 'nw',
  /** column name */
  ORGANIC_MATERIAL_PERCENTAGE = 'organic_material_percentage',
  /** column name */
  RW = 'rw',
  /** column name */
  SAND_PERCENTAGE = 'sand_percentage',
  /** column name */
  SUBSTRATE_ID = 'substrate_id',
  /** column name */
  TAW = 'taw',
  /** column name */
  TW = 'tw',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by',
  /** column name */
  WA = 'wa',
  /** column name */
  WO = 'wo'
}

/** input type for updating data in table "areas_scope_cultivation" */
export type AreasScopeCultivationSetInput = {
  area_id?: InputMaybe<Scalars['Int']>;
  aw?: InputMaybe<Scalars['numeric']>;
  ca?: InputMaybe<Scalars['numeric']>;
  clay_percentage?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  cultivation_type?: InputMaybe<CultivationTypesEnum>;
  eaw?: InputMaybe<Scalars['numeric']>;
  farming_container?: InputMaybe<FarmingContainersEnum>;
  farming_container_capacity?: InputMaybe<Scalars['Int']>;
  farming_method?: InputMaybe<FarmingMethodsEnum>;
  farming_structure?: InputMaybe<FarmingStructuresEnum>;
  id?: InputMaybe<Scalars['Int']>;
  nw?: InputMaybe<Scalars['numeric']>;
  organic_material_percentage?: InputMaybe<Scalars['Int']>;
  rw?: InputMaybe<Scalars['numeric']>;
  sand_percentage?: InputMaybe<Scalars['Int']>;
  substrate_id?: InputMaybe<Scalars['Int']>;
  taw?: InputMaybe<Scalars['numeric']>;
  tw?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  wa?: InputMaybe<Scalars['numeric']>;
  wo?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type AreasScopeCultivationStddevFields = {
  __typename?: 'areas_scope_cultivation_stddev_fields';
  area_id?: Maybe<Scalars['Float']>;
  aw?: Maybe<Scalars['Float']>;
  ca?: Maybe<Scalars['Float']>;
  clay_percentage?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  eaw?: Maybe<Scalars['Float']>;
  farming_container_capacity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nw?: Maybe<Scalars['Float']>;
  organic_material_percentage?: Maybe<Scalars['Float']>;
  rw?: Maybe<Scalars['Float']>;
  sand_percentage?: Maybe<Scalars['Float']>;
  substrate_id?: Maybe<Scalars['Float']>;
  taw?: Maybe<Scalars['Float']>;
  tw?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  wa?: Maybe<Scalars['Float']>;
  wo?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AreasScopeCultivationStddevPopFields = {
  __typename?: 'areas_scope_cultivation_stddev_pop_fields';
  area_id?: Maybe<Scalars['Float']>;
  aw?: Maybe<Scalars['Float']>;
  ca?: Maybe<Scalars['Float']>;
  clay_percentage?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  eaw?: Maybe<Scalars['Float']>;
  farming_container_capacity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nw?: Maybe<Scalars['Float']>;
  organic_material_percentage?: Maybe<Scalars['Float']>;
  rw?: Maybe<Scalars['Float']>;
  sand_percentage?: Maybe<Scalars['Float']>;
  substrate_id?: Maybe<Scalars['Float']>;
  taw?: Maybe<Scalars['Float']>;
  tw?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  wa?: Maybe<Scalars['Float']>;
  wo?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AreasScopeCultivationStddevSampFields = {
  __typename?: 'areas_scope_cultivation_stddev_samp_fields';
  area_id?: Maybe<Scalars['Float']>;
  aw?: Maybe<Scalars['Float']>;
  ca?: Maybe<Scalars['Float']>;
  clay_percentage?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  eaw?: Maybe<Scalars['Float']>;
  farming_container_capacity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nw?: Maybe<Scalars['Float']>;
  organic_material_percentage?: Maybe<Scalars['Float']>;
  rw?: Maybe<Scalars['Float']>;
  sand_percentage?: Maybe<Scalars['Float']>;
  substrate_id?: Maybe<Scalars['Float']>;
  taw?: Maybe<Scalars['Float']>;
  tw?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  wa?: Maybe<Scalars['Float']>;
  wo?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "areas_scope_cultivation" */
export type AreasScopeCultivationStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AreasScopeCultivationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AreasScopeCultivationStreamCursorValueInput = {
  area_id?: InputMaybe<Scalars['Int']>;
  aw?: InputMaybe<Scalars['numeric']>;
  ca?: InputMaybe<Scalars['numeric']>;
  clay_percentage?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  cultivation_type?: InputMaybe<CultivationTypesEnum>;
  eaw?: InputMaybe<Scalars['numeric']>;
  farming_container?: InputMaybe<FarmingContainersEnum>;
  farming_container_capacity?: InputMaybe<Scalars['Int']>;
  farming_method?: InputMaybe<FarmingMethodsEnum>;
  farming_structure?: InputMaybe<FarmingStructuresEnum>;
  id?: InputMaybe<Scalars['Int']>;
  nw?: InputMaybe<Scalars['numeric']>;
  organic_material_percentage?: InputMaybe<Scalars['Int']>;
  rw?: InputMaybe<Scalars['numeric']>;
  sand_percentage?: InputMaybe<Scalars['Int']>;
  substrate_id?: InputMaybe<Scalars['Int']>;
  taw?: InputMaybe<Scalars['numeric']>;
  tw?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  wa?: InputMaybe<Scalars['numeric']>;
  wo?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type AreasScopeCultivationSumFields = {
  __typename?: 'areas_scope_cultivation_sum_fields';
  area_id?: Maybe<Scalars['Int']>;
  aw?: Maybe<Scalars['numeric']>;
  ca?: Maybe<Scalars['numeric']>;
  clay_percentage?: Maybe<Scalars['Int']>;
  created_by?: Maybe<Scalars['Int']>;
  eaw?: Maybe<Scalars['numeric']>;
  farming_container_capacity?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  nw?: Maybe<Scalars['numeric']>;
  organic_material_percentage?: Maybe<Scalars['Int']>;
  rw?: Maybe<Scalars['numeric']>;
  sand_percentage?: Maybe<Scalars['Int']>;
  substrate_id?: Maybe<Scalars['Int']>;
  taw?: Maybe<Scalars['numeric']>;
  tw?: Maybe<Scalars['numeric']>;
  updated_by?: Maybe<Scalars['Int']>;
  wa?: Maybe<Scalars['numeric']>;
  wo?: Maybe<Scalars['numeric']>;
};

/** update columns of table "areas_scope_cultivation" */
export enum AreasScopeCultivationUpdateColumn {
  /** column name */
  AREA_ID = 'area_id',
  /** column name */
  AW = 'aw',
  /** column name */
  CA = 'ca',
  /** column name */
  CLAY_PERCENTAGE = 'clay_percentage',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  CULTIVATION_TYPE = 'cultivation_type',
  /** column name */
  EAW = 'eaw',
  /** column name */
  FARMING_CONTAINER = 'farming_container',
  /** column name */
  FARMING_CONTAINER_CAPACITY = 'farming_container_capacity',
  /** column name */
  FARMING_METHOD = 'farming_method',
  /** column name */
  FARMING_STRUCTURE = 'farming_structure',
  /** column name */
  ID = 'id',
  /** column name */
  NW = 'nw',
  /** column name */
  ORGANIC_MATERIAL_PERCENTAGE = 'organic_material_percentage',
  /** column name */
  RW = 'rw',
  /** column name */
  SAND_PERCENTAGE = 'sand_percentage',
  /** column name */
  SUBSTRATE_ID = 'substrate_id',
  /** column name */
  TAW = 'taw',
  /** column name */
  TW = 'tw',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by',
  /** column name */
  WA = 'wa',
  /** column name */
  WO = 'wo'
}

export type AreasScopeCultivationUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AreasScopeCultivationIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AreasScopeCultivationSetInput>;
  /** filter the rows which have to be updated */
  where: AreasScopeCultivationBoolExp;
};

/** aggregate var_pop on columns */
export type AreasScopeCultivationVarPopFields = {
  __typename?: 'areas_scope_cultivation_var_pop_fields';
  area_id?: Maybe<Scalars['Float']>;
  aw?: Maybe<Scalars['Float']>;
  ca?: Maybe<Scalars['Float']>;
  clay_percentage?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  eaw?: Maybe<Scalars['Float']>;
  farming_container_capacity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nw?: Maybe<Scalars['Float']>;
  organic_material_percentage?: Maybe<Scalars['Float']>;
  rw?: Maybe<Scalars['Float']>;
  sand_percentage?: Maybe<Scalars['Float']>;
  substrate_id?: Maybe<Scalars['Float']>;
  taw?: Maybe<Scalars['Float']>;
  tw?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  wa?: Maybe<Scalars['Float']>;
  wo?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AreasScopeCultivationVarSampFields = {
  __typename?: 'areas_scope_cultivation_var_samp_fields';
  area_id?: Maybe<Scalars['Float']>;
  aw?: Maybe<Scalars['Float']>;
  ca?: Maybe<Scalars['Float']>;
  clay_percentage?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  eaw?: Maybe<Scalars['Float']>;
  farming_container_capacity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nw?: Maybe<Scalars['Float']>;
  organic_material_percentage?: Maybe<Scalars['Float']>;
  rw?: Maybe<Scalars['Float']>;
  sand_percentage?: Maybe<Scalars['Float']>;
  substrate_id?: Maybe<Scalars['Float']>;
  taw?: Maybe<Scalars['Float']>;
  tw?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  wa?: Maybe<Scalars['Float']>;
  wo?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AreasScopeCultivationVarianceFields = {
  __typename?: 'areas_scope_cultivation_variance_fields';
  area_id?: Maybe<Scalars['Float']>;
  aw?: Maybe<Scalars['Float']>;
  ca?: Maybe<Scalars['Float']>;
  clay_percentage?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  eaw?: Maybe<Scalars['Float']>;
  farming_container_capacity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  nw?: Maybe<Scalars['Float']>;
  organic_material_percentage?: Maybe<Scalars['Float']>;
  rw?: Maybe<Scalars['Float']>;
  sand_percentage?: Maybe<Scalars['Float']>;
  substrate_id?: Maybe<Scalars['Float']>;
  taw?: Maybe<Scalars['Float']>;
  tw?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  wa?: Maybe<Scalars['Float']>;
  wo?: Maybe<Scalars['Float']>;
};

/** Enum related to different areas scopes */
export type AreasScopes = {
  __typename?: 'areas_scopes';
  comment: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "areas_scopes" */
export type AreasScopesAggregate = {
  __typename?: 'areas_scopes_aggregate';
  aggregate?: Maybe<AreasScopesAggregateFields>;
  nodes: Array<AreasScopes>;
};

/** aggregate fields of "areas_scopes" */
export type AreasScopesAggregateFields = {
  __typename?: 'areas_scopes_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<AreasScopesMaxFields>;
  min?: Maybe<AreasScopesMinFields>;
};


/** aggregate fields of "areas_scopes" */
export type AreasScopesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AreasScopesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "areas_scopes". All fields are combined with a logical 'AND'. */
export type AreasScopesBoolExp = {
  _and?: InputMaybe<Array<AreasScopesBoolExp>>;
  _not?: InputMaybe<AreasScopesBoolExp>;
  _or?: InputMaybe<Array<AreasScopesBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "areas_scopes" */
export enum AreasScopesConstraint {
  /** unique or primary key constraint on columns "value" */
  AREAS_SCOPES_PKEY = 'areas_scopes_pkey'
}

export enum AreasScopesEnum {
  /** Area dedicated to different types of cultivation */
  CULTIVATION = 'CULTIVATION',
  /** General purpose area */
  OTHER = 'OTHER'
}

/** Boolean expression to compare columns of type "areas_scopes_enum". All fields are combined with logical 'AND'. */
export type AreasScopesEnumComparisonExp = {
  _eq?: InputMaybe<AreasScopesEnum>;
  _in?: InputMaybe<Array<AreasScopesEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<AreasScopesEnum>;
  _nin?: InputMaybe<Array<AreasScopesEnum>>;
};

/** input type for inserting data into table "areas_scopes" */
export type AreasScopesInsertInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AreasScopesMaxFields = {
  __typename?: 'areas_scopes_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AreasScopesMinFields = {
  __typename?: 'areas_scopes_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "areas_scopes" */
export type AreasScopesMutationResponse = {
  __typename?: 'areas_scopes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AreasScopes>;
};

/** on_conflict condition type for table "areas_scopes" */
export type AreasScopesOnConflict = {
  constraint: AreasScopesConstraint;
  update_columns?: Array<AreasScopesUpdateColumn>;
  where?: InputMaybe<AreasScopesBoolExp>;
};

/** Ordering options when selecting data from "areas_scopes". */
export type AreasScopesOrderBy = {
  comment?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: areas_scopes */
export type AreasScopesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "areas_scopes" */
export enum AreasScopesSelectColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  VALUE = 'value'
}

/** input type for updating data in table "areas_scopes" */
export type AreasScopesSetInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "areas_scopes" */
export type AreasScopesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AreasScopesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AreasScopesStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "areas_scopes" */
export enum AreasScopesUpdateColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  VALUE = 'value'
}

export type AreasScopesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AreasScopesSetInput>;
  /** filter the rows which have to be updated */
  where: AreasScopesBoolExp;
};

/** select columns of table "areas" */
export enum AreasSelectColumn {
  /** column name */
  APPLICATION_ID = 'application_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ICON = 'icon',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  SCOPE = 'scope',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by'
}

/** input type for updating data in table "areas" */
export type AreasSetInput = {
  application_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['areaicon']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<AreasScopesEnum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type AreasStddevFields = {
  __typename?: 'areas_stddev_fields';
  application_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "areas" */
export type AreasStddevOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AreasStddevPopFields = {
  __typename?: 'areas_stddev_pop_fields';
  application_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "areas" */
export type AreasStddevPopOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AreasStddevSampFields = {
  __typename?: 'areas_stddev_samp_fields';
  application_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "areas" */
export type AreasStddevSampOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "areas" */
export type AreasStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AreasStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AreasStreamCursorValueInput = {
  application_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<AreasScopesEnum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type AreasSumFields = {
  __typename?: 'areas_sum_fields';
  application_id?: Maybe<Scalars['Int']>;
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "areas" */
export type AreasSumOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** update columns of table "areas" */
export enum AreasUpdateColumn {
  /** column name */
  APPLICATION_ID = 'application_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ICON = 'icon',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  SCOPE = 'scope',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by'
}

export type AreasUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AreasAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AreasDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AreasDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AreasDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AreasIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AreasPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AreasSetInput>;
  /** filter the rows which have to be updated */
  where: AreasBoolExp;
};

/** aggregate var_pop on columns */
export type AreasVarPopFields = {
  __typename?: 'areas_var_pop_fields';
  application_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "areas" */
export type AreasVarPopOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AreasVarSampFields = {
  __typename?: 'areas_var_samp_fields';
  application_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "areas" */
export type AreasVarSampOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AreasVarianceFields = {
  __typename?: 'areas_variance_fields';
  application_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "areas" */
export type AreasVarianceOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** automation timing execution kinds enum */
export type AutomationTimingExecutionKinds = {
  __typename?: 'automation_timing_execution_kinds';
  comment: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "automation_timing_execution_kinds" */
export type AutomationTimingExecutionKindsAggregate = {
  __typename?: 'automation_timing_execution_kinds_aggregate';
  aggregate?: Maybe<AutomationTimingExecutionKindsAggregateFields>;
  nodes: Array<AutomationTimingExecutionKinds>;
};

/** aggregate fields of "automation_timing_execution_kinds" */
export type AutomationTimingExecutionKindsAggregateFields = {
  __typename?: 'automation_timing_execution_kinds_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<AutomationTimingExecutionKindsMaxFields>;
  min?: Maybe<AutomationTimingExecutionKindsMinFields>;
};


/** aggregate fields of "automation_timing_execution_kinds" */
export type AutomationTimingExecutionKindsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AutomationTimingExecutionKindsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "automation_timing_execution_kinds". All fields are combined with a logical 'AND'. */
export type AutomationTimingExecutionKindsBoolExp = {
  _and?: InputMaybe<Array<AutomationTimingExecutionKindsBoolExp>>;
  _not?: InputMaybe<AutomationTimingExecutionKindsBoolExp>;
  _or?: InputMaybe<Array<AutomationTimingExecutionKindsBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "automation_timing_execution_kinds" */
export enum AutomationTimingExecutionKindsConstraint {
  /** unique or primary key constraint on columns "value" */
  AUTOMATION_TIMING_EXECUTION_KINDS_PKEY = 'automation_timing_execution_kinds_pkey'
}

export enum AutomationTimingExecutionKindsEnum {
  /** execute automation always */
  ALWAYS = 'ALWAYS',
  /** execute automation on monthly schedule */
  MONTHLY = 'MONTHLY'
}

/** Boolean expression to compare columns of type "automation_timing_execution_kinds_enum". All fields are combined with logical 'AND'. */
export type AutomationTimingExecutionKindsEnumComparisonExp = {
  _eq?: InputMaybe<AutomationTimingExecutionKindsEnum>;
  _in?: InputMaybe<Array<AutomationTimingExecutionKindsEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<AutomationTimingExecutionKindsEnum>;
  _nin?: InputMaybe<Array<AutomationTimingExecutionKindsEnum>>;
};

/** input type for inserting data into table "automation_timing_execution_kinds" */
export type AutomationTimingExecutionKindsInsertInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AutomationTimingExecutionKindsMaxFields = {
  __typename?: 'automation_timing_execution_kinds_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AutomationTimingExecutionKindsMinFields = {
  __typename?: 'automation_timing_execution_kinds_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "automation_timing_execution_kinds" */
export type AutomationTimingExecutionKindsMutationResponse = {
  __typename?: 'automation_timing_execution_kinds_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AutomationTimingExecutionKinds>;
};

/** on_conflict condition type for table "automation_timing_execution_kinds" */
export type AutomationTimingExecutionKindsOnConflict = {
  constraint: AutomationTimingExecutionKindsConstraint;
  update_columns?: Array<AutomationTimingExecutionKindsUpdateColumn>;
  where?: InputMaybe<AutomationTimingExecutionKindsBoolExp>;
};

/** Ordering options when selecting data from "automation_timing_execution_kinds". */
export type AutomationTimingExecutionKindsOrderBy = {
  comment?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: automation_timing_execution_kinds */
export type AutomationTimingExecutionKindsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "automation_timing_execution_kinds" */
export enum AutomationTimingExecutionKindsSelectColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  VALUE = 'value'
}

/** input type for updating data in table "automation_timing_execution_kinds" */
export type AutomationTimingExecutionKindsSetInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "automation_timing_execution_kinds" */
export type AutomationTimingExecutionKindsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AutomationTimingExecutionKindsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AutomationTimingExecutionKindsStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "automation_timing_execution_kinds" */
export enum AutomationTimingExecutionKindsUpdateColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  VALUE = 'value'
}

export type AutomationTimingExecutionKindsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AutomationTimingExecutionKindsSetInput>;
  /** filter the rows which have to be updated */
  where: AutomationTimingExecutionKindsBoolExp;
};

/** columns and relationships of "automations" */
export type Automations = {
  __typename?: 'automations';
  /** An object relationship */
  application: Applications;
  application_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  created_by: Scalars['Int'];
  enabled: Scalars['Boolean'];
  id: Scalars['Int'];
  monthly_scheduling?: Maybe<Scalars['bpchar']>;
  name: Scalars['String'];
  /** An array relationship */
  scenes: Array<Scenes>;
  /** An aggregate relationship */
  scenes_aggregate: ScenesAggregate;
  timing_execution_kind: AutomationTimingExecutionKindsEnum;
  updated_at: Scalars['timestamptz'];
  updated_by: Scalars['Int'];
  /** An array relationship */
  users_watching: Array<AutomationsWatchings>;
  /** An aggregate relationship */
  users_watching_aggregate: AutomationsWatchingsAggregate;
};


/** columns and relationships of "automations" */
export type AutomationsScenesArgs = {
  distinct_on?: InputMaybe<Array<ScenesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ScenesOrderBy>>;
  where?: InputMaybe<ScenesBoolExp>;
};


/** columns and relationships of "automations" */
export type AutomationsScenesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ScenesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ScenesOrderBy>>;
  where?: InputMaybe<ScenesBoolExp>;
};


/** columns and relationships of "automations" */
export type AutomationsUsersWatchingArgs = {
  distinct_on?: InputMaybe<Array<AutomationsWatchingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutomationsWatchingsOrderBy>>;
  where?: InputMaybe<AutomationsWatchingsBoolExp>;
};


/** columns and relationships of "automations" */
export type AutomationsUsersWatchingAggregateArgs = {
  distinct_on?: InputMaybe<Array<AutomationsWatchingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutomationsWatchingsOrderBy>>;
  where?: InputMaybe<AutomationsWatchingsBoolExp>;
};

/** aggregated selection of "automations" */
export type AutomationsAggregate = {
  __typename?: 'automations_aggregate';
  aggregate?: Maybe<AutomationsAggregateFields>;
  nodes: Array<Automations>;
};

export type AutomationsAggregateBoolExp = {
  bool_and?: InputMaybe<AutomationsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<AutomationsAggregateBoolExpBoolOr>;
  count?: InputMaybe<AutomationsAggregateBoolExpCount>;
};

export type AutomationsAggregateBoolExpBoolAnd = {
  arguments: AutomationsSelectColumnAutomationsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AutomationsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AutomationsAggregateBoolExpBoolOr = {
  arguments: AutomationsSelectColumnAutomationsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AutomationsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AutomationsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AutomationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AutomationsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "automations" */
export type AutomationsAggregateFields = {
  __typename?: 'automations_aggregate_fields';
  avg?: Maybe<AutomationsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AutomationsMaxFields>;
  min?: Maybe<AutomationsMinFields>;
  stddev?: Maybe<AutomationsStddevFields>;
  stddev_pop?: Maybe<AutomationsStddevPopFields>;
  stddev_samp?: Maybe<AutomationsStddevSampFields>;
  sum?: Maybe<AutomationsSumFields>;
  var_pop?: Maybe<AutomationsVarPopFields>;
  var_samp?: Maybe<AutomationsVarSampFields>;
  variance?: Maybe<AutomationsVarianceFields>;
};


/** aggregate fields of "automations" */
export type AutomationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AutomationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "automations" */
export type AutomationsAggregateOrderBy = {
  avg?: InputMaybe<AutomationsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AutomationsMaxOrderBy>;
  min?: InputMaybe<AutomationsMinOrderBy>;
  stddev?: InputMaybe<AutomationsStddevOrderBy>;
  stddev_pop?: InputMaybe<AutomationsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AutomationsStddevSampOrderBy>;
  sum?: InputMaybe<AutomationsSumOrderBy>;
  var_pop?: InputMaybe<AutomationsVarPopOrderBy>;
  var_samp?: InputMaybe<AutomationsVarSampOrderBy>;
  variance?: InputMaybe<AutomationsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "automations" */
export type AutomationsArrRelInsertInput = {
  data: Array<AutomationsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AutomationsOnConflict>;
};

/** aggregate avg on columns */
export type AutomationsAvgFields = {
  __typename?: 'automations_avg_fields';
  application_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "automations" */
export type AutomationsAvgOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "automations". All fields are combined with a logical 'AND'. */
export type AutomationsBoolExp = {
  _and?: InputMaybe<Array<AutomationsBoolExp>>;
  _not?: InputMaybe<AutomationsBoolExp>;
  _or?: InputMaybe<Array<AutomationsBoolExp>>;
  application?: InputMaybe<ApplicationsBoolExp>;
  application_id?: InputMaybe<IntComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<IntComparisonExp>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  monthly_scheduling?: InputMaybe<BpcharComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  scenes?: InputMaybe<ScenesBoolExp>;
  scenes_aggregate?: InputMaybe<ScenesAggregateBoolExp>;
  timing_execution_kind?: InputMaybe<AutomationTimingExecutionKindsEnumComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<IntComparisonExp>;
  users_watching?: InputMaybe<AutomationsWatchingsBoolExp>;
  users_watching_aggregate?: InputMaybe<AutomationsWatchingsAggregateBoolExp>;
};

/** unique or primary key constraints on table "automations" */
export enum AutomationsConstraint {
  /** unique or primary key constraint on columns "id" */
  AUTOMATIONS_PKEY = 'automations_pkey'
}

/** input type for incrementing numeric columns in table "automations" */
export type AutomationsIncInput = {
  application_id?: InputMaybe<Scalars['Int']>;
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "automations" */
export type AutomationsInsertInput = {
  application?: InputMaybe<ApplicationsObjRelInsertInput>;
  application_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  monthly_scheduling?: InputMaybe<Scalars['bpchar']>;
  name?: InputMaybe<Scalars['String']>;
  scenes?: InputMaybe<ScenesArrRelInsertInput>;
  timing_execution_kind?: InputMaybe<AutomationTimingExecutionKindsEnum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  users_watching?: InputMaybe<AutomationsWatchingsArrRelInsertInput>;
};

/** aggregate max on columns */
export type AutomationsMaxFields = {
  __typename?: 'automations_max_fields';
  application_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  monthly_scheduling?: Maybe<Scalars['bpchar']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "automations" */
export type AutomationsMaxOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  monthly_scheduling?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AutomationsMinFields = {
  __typename?: 'automations_min_fields';
  application_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  monthly_scheduling?: Maybe<Scalars['bpchar']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "automations" */
export type AutomationsMinOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  monthly_scheduling?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "automations" */
export type AutomationsMutationResponse = {
  __typename?: 'automations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Automations>;
};

/** input type for inserting object relation for remote table "automations" */
export type AutomationsObjRelInsertInput = {
  data: AutomationsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AutomationsOnConflict>;
};

/** on_conflict condition type for table "automations" */
export type AutomationsOnConflict = {
  constraint: AutomationsConstraint;
  update_columns?: Array<AutomationsUpdateColumn>;
  where?: InputMaybe<AutomationsBoolExp>;
};

/** Ordering options when selecting data from "automations". */
export type AutomationsOrderBy = {
  application?: InputMaybe<ApplicationsOrderBy>;
  application_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  enabled?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  monthly_scheduling?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  scenes_aggregate?: InputMaybe<ScenesAggregateOrderBy>;
  timing_execution_kind?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  users_watching_aggregate?: InputMaybe<AutomationsWatchingsAggregateOrderBy>;
};

/** primary key columns input for table: automations */
export type AutomationsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "automations" */
export enum AutomationsSelectColumn {
  /** column name */
  APPLICATION_ID = 'application_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  ENABLED = 'enabled',
  /** column name */
  ID = 'id',
  /** column name */
  MONTHLY_SCHEDULING = 'monthly_scheduling',
  /** column name */
  NAME = 'name',
  /** column name */
  TIMING_EXECUTION_KIND = 'timing_execution_kind',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by'
}

/** select "automations_aggregate_bool_exp_bool_and_arguments_columns" columns of table "automations" */
export enum AutomationsSelectColumnAutomationsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  ENABLED = 'enabled'
}

/** select "automations_aggregate_bool_exp_bool_or_arguments_columns" columns of table "automations" */
export enum AutomationsSelectColumnAutomationsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  ENABLED = 'enabled'
}

/** input type for updating data in table "automations" */
export type AutomationsSetInput = {
  application_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  monthly_scheduling?: InputMaybe<Scalars['bpchar']>;
  name?: InputMaybe<Scalars['String']>;
  timing_execution_kind?: InputMaybe<AutomationTimingExecutionKindsEnum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type AutomationsStddevFields = {
  __typename?: 'automations_stddev_fields';
  application_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "automations" */
export type AutomationsStddevOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AutomationsStddevPopFields = {
  __typename?: 'automations_stddev_pop_fields';
  application_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "automations" */
export type AutomationsStddevPopOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AutomationsStddevSampFields = {
  __typename?: 'automations_stddev_samp_fields';
  application_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "automations" */
export type AutomationsStddevSampOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "automations" */
export type AutomationsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AutomationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AutomationsStreamCursorValueInput = {
  application_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  monthly_scheduling?: InputMaybe<Scalars['bpchar']>;
  name?: InputMaybe<Scalars['String']>;
  timing_execution_kind?: InputMaybe<AutomationTimingExecutionKindsEnum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type AutomationsSumFields = {
  __typename?: 'automations_sum_fields';
  application_id?: Maybe<Scalars['Int']>;
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "automations" */
export type AutomationsSumOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** update columns of table "automations" */
export enum AutomationsUpdateColumn {
  /** column name */
  APPLICATION_ID = 'application_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  ENABLED = 'enabled',
  /** column name */
  ID = 'id',
  /** column name */
  MONTHLY_SCHEDULING = 'monthly_scheduling',
  /** column name */
  NAME = 'name',
  /** column name */
  TIMING_EXECUTION_KIND = 'timing_execution_kind',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by'
}

export type AutomationsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AutomationsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AutomationsSetInput>;
  /** filter the rows which have to be updated */
  where: AutomationsBoolExp;
};

/** aggregate var_pop on columns */
export type AutomationsVarPopFields = {
  __typename?: 'automations_var_pop_fields';
  application_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "automations" */
export type AutomationsVarPopOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AutomationsVarSampFields = {
  __typename?: 'automations_var_samp_fields';
  application_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "automations" */
export type AutomationsVarSampOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AutomationsVarianceFields = {
  __typename?: 'automations_variance_fields';
  application_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "automations" */
export type AutomationsVarianceOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** Many to many relationship related to automations watched by users */
export type AutomationsWatchings = {
  __typename?: 'automations_watchings';
  /** An object relationship */
  automation: Automations;
  automation_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: UsersPermissionsUser;
  user_id: Scalars['Int'];
};

/** aggregated selection of "automations_watchings" */
export type AutomationsWatchingsAggregate = {
  __typename?: 'automations_watchings_aggregate';
  aggregate?: Maybe<AutomationsWatchingsAggregateFields>;
  nodes: Array<AutomationsWatchings>;
};

export type AutomationsWatchingsAggregateBoolExp = {
  count?: InputMaybe<AutomationsWatchingsAggregateBoolExpCount>;
};

export type AutomationsWatchingsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AutomationsWatchingsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AutomationsWatchingsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "automations_watchings" */
export type AutomationsWatchingsAggregateFields = {
  __typename?: 'automations_watchings_aggregate_fields';
  avg?: Maybe<AutomationsWatchingsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<AutomationsWatchingsMaxFields>;
  min?: Maybe<AutomationsWatchingsMinFields>;
  stddev?: Maybe<AutomationsWatchingsStddevFields>;
  stddev_pop?: Maybe<AutomationsWatchingsStddevPopFields>;
  stddev_samp?: Maybe<AutomationsWatchingsStddevSampFields>;
  sum?: Maybe<AutomationsWatchingsSumFields>;
  var_pop?: Maybe<AutomationsWatchingsVarPopFields>;
  var_samp?: Maybe<AutomationsWatchingsVarSampFields>;
  variance?: Maybe<AutomationsWatchingsVarianceFields>;
};


/** aggregate fields of "automations_watchings" */
export type AutomationsWatchingsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AutomationsWatchingsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "automations_watchings" */
export type AutomationsWatchingsAggregateOrderBy = {
  avg?: InputMaybe<AutomationsWatchingsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AutomationsWatchingsMaxOrderBy>;
  min?: InputMaybe<AutomationsWatchingsMinOrderBy>;
  stddev?: InputMaybe<AutomationsWatchingsStddevOrderBy>;
  stddev_pop?: InputMaybe<AutomationsWatchingsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AutomationsWatchingsStddevSampOrderBy>;
  sum?: InputMaybe<AutomationsWatchingsSumOrderBy>;
  var_pop?: InputMaybe<AutomationsWatchingsVarPopOrderBy>;
  var_samp?: InputMaybe<AutomationsWatchingsVarSampOrderBy>;
  variance?: InputMaybe<AutomationsWatchingsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "automations_watchings" */
export type AutomationsWatchingsArrRelInsertInput = {
  data: Array<AutomationsWatchingsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AutomationsWatchingsOnConflict>;
};

/** aggregate avg on columns */
export type AutomationsWatchingsAvgFields = {
  __typename?: 'automations_watchings_avg_fields';
  automation_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "automations_watchings" */
export type AutomationsWatchingsAvgOrderBy = {
  automation_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "automations_watchings". All fields are combined with a logical 'AND'. */
export type AutomationsWatchingsBoolExp = {
  _and?: InputMaybe<Array<AutomationsWatchingsBoolExp>>;
  _not?: InputMaybe<AutomationsWatchingsBoolExp>;
  _or?: InputMaybe<Array<AutomationsWatchingsBoolExp>>;
  automation?: InputMaybe<AutomationsBoolExp>;
  automation_id?: InputMaybe<IntComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersPermissionsUserBoolExp>;
  user_id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "automations_watchings" */
export enum AutomationsWatchingsConstraint {
  /** unique or primary key constraint on columns "id" */
  AUTOMATIONS_WATCHINGS_PKEY = 'automations_watchings_pkey',
  /** unique or primary key constraint on columns "automation_id", "user_id" */
  AUTOMATIONS_WATCHINGS_USER_ID_AUTOMATION_ID_KEY = 'automations_watchings_user_id_automation_id_key'
}

/** input type for incrementing numeric columns in table "automations_watchings" */
export type AutomationsWatchingsIncInput = {
  automation_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "automations_watchings" */
export type AutomationsWatchingsInsertInput = {
  automation?: InputMaybe<AutomationsObjRelInsertInput>;
  automation_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<UsersPermissionsUserObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type AutomationsWatchingsMaxFields = {
  __typename?: 'automations_watchings_max_fields';
  automation_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "automations_watchings" */
export type AutomationsWatchingsMaxOrderBy = {
  automation_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AutomationsWatchingsMinFields = {
  __typename?: 'automations_watchings_min_fields';
  automation_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "automations_watchings" */
export type AutomationsWatchingsMinOrderBy = {
  automation_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "automations_watchings" */
export type AutomationsWatchingsMutationResponse = {
  __typename?: 'automations_watchings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AutomationsWatchings>;
};

/** on_conflict condition type for table "automations_watchings" */
export type AutomationsWatchingsOnConflict = {
  constraint: AutomationsWatchingsConstraint;
  update_columns?: Array<AutomationsWatchingsUpdateColumn>;
  where?: InputMaybe<AutomationsWatchingsBoolExp>;
};

/** Ordering options when selecting data from "automations_watchings". */
export type AutomationsWatchingsOrderBy = {
  automation?: InputMaybe<AutomationsOrderBy>;
  automation_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersPermissionsUserOrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: automations_watchings */
export type AutomationsWatchingsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "automations_watchings" */
export enum AutomationsWatchingsSelectColumn {
  /** column name */
  AUTOMATION_ID = 'automation_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
}

/** input type for updating data in table "automations_watchings" */
export type AutomationsWatchingsSetInput = {
  automation_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type AutomationsWatchingsStddevFields = {
  __typename?: 'automations_watchings_stddev_fields';
  automation_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "automations_watchings" */
export type AutomationsWatchingsStddevOrderBy = {
  automation_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AutomationsWatchingsStddevPopFields = {
  __typename?: 'automations_watchings_stddev_pop_fields';
  automation_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "automations_watchings" */
export type AutomationsWatchingsStddevPopOrderBy = {
  automation_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AutomationsWatchingsStddevSampFields = {
  __typename?: 'automations_watchings_stddev_samp_fields';
  automation_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "automations_watchings" */
export type AutomationsWatchingsStddevSampOrderBy = {
  automation_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "automations_watchings" */
export type AutomationsWatchingsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AutomationsWatchingsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AutomationsWatchingsStreamCursorValueInput = {
  automation_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type AutomationsWatchingsSumFields = {
  __typename?: 'automations_watchings_sum_fields';
  automation_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "automations_watchings" */
export type AutomationsWatchingsSumOrderBy = {
  automation_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** update columns of table "automations_watchings" */
export enum AutomationsWatchingsUpdateColumn {
  /** column name */
  AUTOMATION_ID = 'automation_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
}

export type AutomationsWatchingsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AutomationsWatchingsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AutomationsWatchingsSetInput>;
  /** filter the rows which have to be updated */
  where: AutomationsWatchingsBoolExp;
};

/** aggregate var_pop on columns */
export type AutomationsWatchingsVarPopFields = {
  __typename?: 'automations_watchings_var_pop_fields';
  automation_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "automations_watchings" */
export type AutomationsWatchingsVarPopOrderBy = {
  automation_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AutomationsWatchingsVarSampFields = {
  __typename?: 'automations_watchings_var_samp_fields';
  automation_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "automations_watchings" */
export type AutomationsWatchingsVarSampOrderBy = {
  automation_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AutomationsWatchingsVarianceFields = {
  __typename?: 'automations_watchings_variance_fields';
  automation_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "automations_watchings" */
export type AutomationsWatchingsVarianceOrderBy = {
  automation_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type BigintComparisonExp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** Boolean expression to compare columns of type "bpchar". All fields are combined with logical 'AND'. */
export type BpcharComparisonExp = {
  _eq?: InputMaybe<Scalars['bpchar']>;
  _gt?: InputMaybe<Scalars['bpchar']>;
  _gte?: InputMaybe<Scalars['bpchar']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['bpchar']>;
  _in?: InputMaybe<Array<Scalars['bpchar']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['bpchar']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['bpchar']>;
  _lt?: InputMaybe<Scalars['bpchar']>;
  _lte?: InputMaybe<Scalars['bpchar']>;
  _neq?: InputMaybe<Scalars['bpchar']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['bpchar']>;
  _nin?: InputMaybe<Array<Scalars['bpchar']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['bpchar']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['bpchar']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['bpchar']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['bpchar']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['bpchar']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['bpchar']>;
};

/** Enum for chat message types */
export type ChatMessageTypes = {
  __typename?: 'chat_message_types';
  comment: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "chat_message_types" */
export type ChatMessageTypesAggregate = {
  __typename?: 'chat_message_types_aggregate';
  aggregate?: Maybe<ChatMessageTypesAggregateFields>;
  nodes: Array<ChatMessageTypes>;
};

/** aggregate fields of "chat_message_types" */
export type ChatMessageTypesAggregateFields = {
  __typename?: 'chat_message_types_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<ChatMessageTypesMaxFields>;
  min?: Maybe<ChatMessageTypesMinFields>;
};


/** aggregate fields of "chat_message_types" */
export type ChatMessageTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ChatMessageTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "chat_message_types". All fields are combined with a logical 'AND'. */
export type ChatMessageTypesBoolExp = {
  _and?: InputMaybe<Array<ChatMessageTypesBoolExp>>;
  _not?: InputMaybe<ChatMessageTypesBoolExp>;
  _or?: InputMaybe<Array<ChatMessageTypesBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "chat_message_types" */
export enum ChatMessageTypesConstraint {
  /** unique or primary key constraint on columns "value" */
  CHAT_MESSAGE_TYPES_PKEY = 'chat_message_types_pkey'
}

export enum ChatMessageTypesEnum {
  /** Simple text message */
  TEXT = 'text'
}

/** Boolean expression to compare columns of type "chat_message_types_enum". All fields are combined with logical 'AND'. */
export type ChatMessageTypesEnumComparisonExp = {
  _eq?: InputMaybe<ChatMessageTypesEnum>;
  _in?: InputMaybe<Array<ChatMessageTypesEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<ChatMessageTypesEnum>;
  _nin?: InputMaybe<Array<ChatMessageTypesEnum>>;
};

/** input type for inserting data into table "chat_message_types" */
export type ChatMessageTypesInsertInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ChatMessageTypesMaxFields = {
  __typename?: 'chat_message_types_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type ChatMessageTypesMinFields = {
  __typename?: 'chat_message_types_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "chat_message_types" */
export type ChatMessageTypesMutationResponse = {
  __typename?: 'chat_message_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ChatMessageTypes>;
};

/** on_conflict condition type for table "chat_message_types" */
export type ChatMessageTypesOnConflict = {
  constraint: ChatMessageTypesConstraint;
  update_columns?: Array<ChatMessageTypesUpdateColumn>;
  where?: InputMaybe<ChatMessageTypesBoolExp>;
};

/** Ordering options when selecting data from "chat_message_types". */
export type ChatMessageTypesOrderBy = {
  comment?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: chat_message_types */
export type ChatMessageTypesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "chat_message_types" */
export enum ChatMessageTypesSelectColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  VALUE = 'value'
}

/** input type for updating data in table "chat_message_types" */
export type ChatMessageTypesSetInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "chat_message_types" */
export type ChatMessageTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ChatMessageTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ChatMessageTypesStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "chat_message_types" */
export enum ChatMessageTypesUpdateColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  VALUE = 'value'
}

export type ChatMessageTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ChatMessageTypesSetInput>;
  /** filter the rows which have to be updated */
  where: ChatMessageTypesBoolExp;
};

/** Luma chat messages */
export type ChatMessages = {
  __typename?: 'chat_messages';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  is_user_message: Scalars['Boolean'];
  message_content: Scalars['String'];
  message_type: ChatMessageTypesEnum;
  metadata?: Maybe<Scalars['jsonb']>;
  organization_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['Int'];
};


/** Luma chat messages */
export type ChatMessagesMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "chat_messages" */
export type ChatMessagesAggregate = {
  __typename?: 'chat_messages_aggregate';
  aggregate?: Maybe<ChatMessagesAggregateFields>;
  nodes: Array<ChatMessages>;
};

/** aggregate fields of "chat_messages" */
export type ChatMessagesAggregateFields = {
  __typename?: 'chat_messages_aggregate_fields';
  avg?: Maybe<ChatMessagesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ChatMessagesMaxFields>;
  min?: Maybe<ChatMessagesMinFields>;
  stddev?: Maybe<ChatMessagesStddevFields>;
  stddev_pop?: Maybe<ChatMessagesStddevPopFields>;
  stddev_samp?: Maybe<ChatMessagesStddevSampFields>;
  sum?: Maybe<ChatMessagesSumFields>;
  var_pop?: Maybe<ChatMessagesVarPopFields>;
  var_samp?: Maybe<ChatMessagesVarSampFields>;
  variance?: Maybe<ChatMessagesVarianceFields>;
};


/** aggregate fields of "chat_messages" */
export type ChatMessagesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ChatMessagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ChatMessagesAppendInput = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type ChatMessagesAvgFields = {
  __typename?: 'chat_messages_avg_fields';
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "chat_messages". All fields are combined with a logical 'AND'. */
export type ChatMessagesBoolExp = {
  _and?: InputMaybe<Array<ChatMessagesBoolExp>>;
  _not?: InputMaybe<ChatMessagesBoolExp>;
  _or?: InputMaybe<Array<ChatMessagesBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  is_user_message?: InputMaybe<BooleanComparisonExp>;
  message_content?: InputMaybe<StringComparisonExp>;
  message_type?: InputMaybe<ChatMessageTypesEnumComparisonExp>;
  metadata?: InputMaybe<JsonbComparisonExp>;
  organization_id?: InputMaybe<IntComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  user_id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "chat_messages" */
export enum ChatMessagesConstraint {
  /** unique or primary key constraint on columns "id" */
  CHAT_MESSAGES_PKEY = 'chat_messages_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ChatMessagesDeleteAtPathInput = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ChatMessagesDeleteElemInput = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ChatMessagesDeleteKeyInput = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "chat_messages" */
export type ChatMessagesIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  organization_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "chat_messages" */
export type ChatMessagesInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_user_message?: InputMaybe<Scalars['Boolean']>;
  message_content?: InputMaybe<Scalars['String']>;
  message_type?: InputMaybe<ChatMessageTypesEnum>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  organization_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type ChatMessagesMaxFields = {
  __typename?: 'chat_messages_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  message_content?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type ChatMessagesMinFields = {
  __typename?: 'chat_messages_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  message_content?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "chat_messages" */
export type ChatMessagesMutationResponse = {
  __typename?: 'chat_messages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ChatMessages>;
};

/** on_conflict condition type for table "chat_messages" */
export type ChatMessagesOnConflict = {
  constraint: ChatMessagesConstraint;
  update_columns?: Array<ChatMessagesUpdateColumn>;
  where?: InputMaybe<ChatMessagesBoolExp>;
};

/** Ordering options when selecting data from "chat_messages". */
export type ChatMessagesOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  is_user_message?: InputMaybe<OrderBy>;
  message_content?: InputMaybe<OrderBy>;
  message_type?: InputMaybe<OrderBy>;
  metadata?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: chat_messages */
export type ChatMessagesPkColumnsInput = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ChatMessagesPrependInput = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "chat_messages" */
export enum ChatMessagesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_USER_MESSAGE = 'is_user_message',
  /** column name */
  MESSAGE_CONTENT = 'message_content',
  /** column name */
  MESSAGE_TYPE = 'message_type',
  /** column name */
  METADATA = 'metadata',
  /** column name */
  ORGANIZATION_ID = 'organization_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
}

/** input type for updating data in table "chat_messages" */
export type ChatMessagesSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_user_message?: InputMaybe<Scalars['Boolean']>;
  message_content?: InputMaybe<Scalars['String']>;
  message_type?: InputMaybe<ChatMessageTypesEnum>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  organization_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type ChatMessagesStddevFields = {
  __typename?: 'chat_messages_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ChatMessagesStddevPopFields = {
  __typename?: 'chat_messages_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ChatMessagesStddevSampFields = {
  __typename?: 'chat_messages_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "chat_messages" */
export type ChatMessagesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ChatMessagesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ChatMessagesStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_user_message?: InputMaybe<Scalars['Boolean']>;
  message_content?: InputMaybe<Scalars['String']>;
  message_type?: InputMaybe<ChatMessageTypesEnum>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  organization_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ChatMessagesSumFields = {
  __typename?: 'chat_messages_sum_fields';
  id?: Maybe<Scalars['Int']>;
  organization_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "chat_messages" */
export enum ChatMessagesUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_USER_MESSAGE = 'is_user_message',
  /** column name */
  MESSAGE_CONTENT = 'message_content',
  /** column name */
  MESSAGE_TYPE = 'message_type',
  /** column name */
  METADATA = 'metadata',
  /** column name */
  ORGANIZATION_ID = 'organization_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
}

export type ChatMessagesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ChatMessagesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ChatMessagesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ChatMessagesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ChatMessagesDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ChatMessagesIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ChatMessagesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ChatMessagesSetInput>;
  /** filter the rows which have to be updated */
  where: ChatMessagesBoolExp;
};

/** aggregate var_pop on columns */
export type ChatMessagesVarPopFields = {
  __typename?: 'chat_messages_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ChatMessagesVarSampFields = {
  __typename?: 'chat_messages_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ChatMessagesVarianceFields = {
  __typename?: 'chat_messages_variance_fields';
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Cultivation types enum */
export type CultivationTypes = {
  __typename?: 'cultivation_types';
  comment: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "cultivation_types" */
export type CultivationTypesAggregate = {
  __typename?: 'cultivation_types_aggregate';
  aggregate?: Maybe<CultivationTypesAggregateFields>;
  nodes: Array<CultivationTypes>;
};

/** aggregate fields of "cultivation_types" */
export type CultivationTypesAggregateFields = {
  __typename?: 'cultivation_types_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<CultivationTypesMaxFields>;
  min?: Maybe<CultivationTypesMinFields>;
};


/** aggregate fields of "cultivation_types" */
export type CultivationTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CultivationTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "cultivation_types". All fields are combined with a logical 'AND'. */
export type CultivationTypesBoolExp = {
  _and?: InputMaybe<Array<CultivationTypesBoolExp>>;
  _not?: InputMaybe<CultivationTypesBoolExp>;
  _or?: InputMaybe<Array<CultivationTypesBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "cultivation_types" */
export enum CultivationTypesConstraint {
  /** unique or primary key constraint on columns "value" */
  CULTIVATION_TYPES_PKEY = 'cultivation_types_pkey'
}

export enum CultivationTypesEnum {
  /** Apples */
  APPLES = 'APPLES',
  /** Artichokes */
  ARTICHOKES = 'ARTICHOKES',
  /** Asparagus */
  ASPARAGUS = 'ASPARAGUS',
  /** Avocados */
  AVOCADOS = 'AVOCADOS',
  /** Barley */
  BARLEY = 'BARLEY',
  /** Basil */
  BASIL = 'BASIL',
  /** Beans */
  BEANS = 'BEANS',
  /** Beets */
  BEETS = 'BEETS',
  /** Bell Pepper */
  BELL_PEPPER = 'BELL_PEPPER',
  /** Bacche */
  BERRIES = 'BERRIES',
  /** More */
  BLACKBERRIES = 'BLACKBERRIES',
  /** Blueberries */
  BLUEBERRIES = 'BLUEBERRIES',
  /** Broccoli */
  BROCCOLI = 'BROCCOLI',
  /** Bulbi */
  BULBS = 'BULBS',
  /** Cabbage */
  CABBAGE = 'CABBAGE',
  /** Carrots */
  CARROTS = 'CARROTS',
  /** Cauliflower */
  CAULIFLOWER = 'CAULIFLOWER',
  /** Celery */
  CELERY = 'CELERY',
  /** Chrysanthemums */
  CHRYSANTHEMUMS = 'CHRYSANTHEMUMS',
  /** Cilantro */
  CILANTRO = 'CILANTRO',
  /** Citrus Fruits (Oranges, Lemons, Limes) */
  CITRUS_FRUITS = 'CITRUS_FRUITS',
  /** Corn */
  CORN = 'CORN',
  /** Cucumbers */
  CUCUMBERS = 'CUCUMBERS',
  /** Ribes */
  CURRANTS = 'CURRANTS',
  /** Daisies */
  DAISIES = 'DAISIES',
  /** Dill */
  DILL = 'DILL',
  /** Eggplant */
  EGGPLANT = 'EGGPLANT',
  /** Ortaggi da Frutto */
  FRUITING_VEGETABLES = 'FRUITING_VEGETABLES',
  /** Garlic */
  GARLIC = 'GARLIC',
  /** Cereali */
  GRAINS = 'GRAINS',
  /** Grapevine */
  GRAPEVINE = 'GRAPEVINE',
  /** Erbe Aromatiche */
  HERBS = 'HERBS',
  /** Kale */
  KALE = 'KALE',
  /** Ortaggi a Foglia Larga */
  LEAFY_VEGETABLES = 'LEAFY_VEGETABLES',
  /** Legumi */
  LEGUMES = 'LEGUMES',
  /** Lettuce */
  LETTUCE = 'LETTUCE',
  /** Lilies */
  LILIES = 'LILIES',
  /** Mangoes */
  MANGOES = 'MANGOES',
  /** Marigolds */
  MARIGOLDS = 'MARIGOLDS',
  /** Melons (Cantaloupe, Watermelon) */
  MELONS = 'MELONS',
  /** Mint */
  MINT = 'MINT',
  /** Noci */
  NUTS = 'NUTS',
  /** Oats */
  OATS = 'OATS',
  /** Olives */
  OLIVES = 'OLIVES',
  /** Onions */
  ONIONS = 'ONIONS',
  /** Orchids */
  ORCHIDS = 'ORCHIDS',
  /** Oregano */
  OREGANO = 'OREGANO',
  /** Parsley */
  PARSLEY = 'PARSLEY',
  /** Pears */
  PEARS = 'PEARS',
  /** Peas */
  PEAS = 'PEAS',
  /** Peppers (Hot, Sweet) */
  PEPPERS = 'PEPPERS',
  /** Pomacee */
  POME_FRUITS = 'POME_FRUITS',
  /** Potatoes */
  POTATOES = 'POTATOES',
  /** Pumpkins */
  PUMPKINS = 'PUMPKINS',
  /** Radishes */
  RADISHES = 'RADISHES',
  /** Lamponi */
  RASPBERRIES = 'RASPBERRIES',
  /** Radici */
  ROOT_VEGETABLES = 'ROOT_VEGETABLES',
  /** Rosemary */
  ROSEMARY = 'ROSEMARY',
  /** Roses */
  ROSES = 'ROSES',
  /** Spinach */
  SPINACH = 'SPINACH',
  /** Squash */
  SQUASH = 'SQUASH',
  /** Frutti a Nocciolo */
  STONE_FRUITS = 'STONE_FRUITS',
  /** Strawberries */
  STRAWBERRIES = 'STRAWBERRIES',
  /** Sunflowers */
  SUNFLOWERS = 'SUNFLOWERS',
  /** Sweet Potatoes */
  SWEET_POTATOES = 'SWEET_POTATOES',
  /** Thyme */
  THYME = 'THYME',
  /** Tomato */
  TOMATO = 'TOMATO',
  /** Frutti Tropicali */
  TROPICAL_FRUITS = 'TROPICAL_FRUITS',
  /** Tuberi */
  TUBERS = 'TUBERS',
  /** Tulips */
  TULIPS = 'TULIPS',
  /** Wheat */
  WHEAT = 'WHEAT',
  /** Zucchini */
  ZUCCHINI = 'ZUCCHINI'
}

/** Boolean expression to compare columns of type "cultivation_types_enum". All fields are combined with logical 'AND'. */
export type CultivationTypesEnumComparisonExp = {
  _eq?: InputMaybe<CultivationTypesEnum>;
  _in?: InputMaybe<Array<CultivationTypesEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<CultivationTypesEnum>;
  _nin?: InputMaybe<Array<CultivationTypesEnum>>;
};

/** input type for inserting data into table "cultivation_types" */
export type CultivationTypesInsertInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type CultivationTypesMaxFields = {
  __typename?: 'cultivation_types_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type CultivationTypesMinFields = {
  __typename?: 'cultivation_types_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "cultivation_types" */
export type CultivationTypesMutationResponse = {
  __typename?: 'cultivation_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CultivationTypes>;
};

/** on_conflict condition type for table "cultivation_types" */
export type CultivationTypesOnConflict = {
  constraint: CultivationTypesConstraint;
  update_columns?: Array<CultivationTypesUpdateColumn>;
  where?: InputMaybe<CultivationTypesBoolExp>;
};

/** Ordering options when selecting data from "cultivation_types". */
export type CultivationTypesOrderBy = {
  comment?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: cultivation_types */
export type CultivationTypesPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "cultivation_types" */
export enum CultivationTypesSelectColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  VALUE = 'value'
}

/** input type for updating data in table "cultivation_types" */
export type CultivationTypesSetInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "cultivation_types" */
export type CultivationTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CultivationTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CultivationTypesStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "cultivation_types" */
export enum CultivationTypesUpdateColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  VALUE = 'value'
}

export type CultivationTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CultivationTypesSetInput>;
  /** filter the rows which have to be updated */
  where: CultivationTypesBoolExp;
};

/** ordering argument of a cursor */
export enum CursorOrdering {
  /** ascending ordering of the cursor */
  ASC = 'ASC',
  /** descending ordering of the cursor */
  DESC = 'DESC'
}

/** columns and relationships of "device_actions" */
export type DeviceActions = {
  __typename?: 'device_actions';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  key: Scalars['String'];
  name: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
  value: Scalars['String'];
};

/** aggregated selection of "device_actions" */
export type DeviceActionsAggregate = {
  __typename?: 'device_actions_aggregate';
  aggregate?: Maybe<DeviceActionsAggregateFields>;
  nodes: Array<DeviceActions>;
};

/** aggregate fields of "device_actions" */
export type DeviceActionsAggregateFields = {
  __typename?: 'device_actions_aggregate_fields';
  avg?: Maybe<DeviceActionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<DeviceActionsMaxFields>;
  min?: Maybe<DeviceActionsMinFields>;
  stddev?: Maybe<DeviceActionsStddevFields>;
  stddev_pop?: Maybe<DeviceActionsStddevPopFields>;
  stddev_samp?: Maybe<DeviceActionsStddevSampFields>;
  sum?: Maybe<DeviceActionsSumFields>;
  var_pop?: Maybe<DeviceActionsVarPopFields>;
  var_samp?: Maybe<DeviceActionsVarSampFields>;
  variance?: Maybe<DeviceActionsVarianceFields>;
};


/** aggregate fields of "device_actions" */
export type DeviceActionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DeviceActionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type DeviceActionsAvgFields = {
  __typename?: 'device_actions_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "device_actions". All fields are combined with a logical 'AND'. */
export type DeviceActionsBoolExp = {
  _and?: InputMaybe<Array<DeviceActionsBoolExp>>;
  _not?: InputMaybe<DeviceActionsBoolExp>;
  _or?: InputMaybe<Array<DeviceActionsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  key?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<IntComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "device_actions" */
export enum DeviceActionsConstraint {
  /** unique or primary key constraint on columns "name" */
  DEVICE_ACTIONS_NAME_UNIQUE = 'device_actions_name_unique',
  /** unique or primary key constraint on columns "id" */
  DEVICE_ACTIONS_PKEY = 'device_actions_pkey'
}

/** input type for incrementing numeric columns in table "device_actions" */
export type DeviceActionsIncInput = {
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "device_actions" */
export type DeviceActionsInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type DeviceActionsMaxFields = {
  __typename?: 'device_actions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type DeviceActionsMinFields = {
  __typename?: 'device_actions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "device_actions" */
export type DeviceActionsMutationResponse = {
  __typename?: 'device_actions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DeviceActions>;
};

/** input type for inserting object relation for remote table "device_actions" */
export type DeviceActionsObjRelInsertInput = {
  data: DeviceActionsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<DeviceActionsOnConflict>;
};

/** on_conflict condition type for table "device_actions" */
export type DeviceActionsOnConflict = {
  constraint: DeviceActionsConstraint;
  update_columns?: Array<DeviceActionsUpdateColumn>;
  where?: InputMaybe<DeviceActionsBoolExp>;
};

/** Ordering options when selecting data from "device_actions". */
export type DeviceActionsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  key?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: device_actions */
export type DeviceActionsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "device_actions" */
export enum DeviceActionsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  ID = 'id',
  /** column name */
  KEY = 'key',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by',
  /** column name */
  VALUE = 'value'
}

/** input type for updating data in table "device_actions" */
export type DeviceActionsSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type DeviceActionsStddevFields = {
  __typename?: 'device_actions_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type DeviceActionsStddevPopFields = {
  __typename?: 'device_actions_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type DeviceActionsStddevSampFields = {
  __typename?: 'device_actions_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "device_actions" */
export type DeviceActionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DeviceActionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DeviceActionsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type DeviceActionsSumFields = {
  __typename?: 'device_actions_sum_fields';
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** update columns of table "device_actions" */
export enum DeviceActionsUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  ID = 'id',
  /** column name */
  KEY = 'key',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by',
  /** column name */
  VALUE = 'value'
}

export type DeviceActionsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DeviceActionsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DeviceActionsSetInput>;
  /** filter the rows which have to be updated */
  where: DeviceActionsBoolExp;
};

/** aggregate var_pop on columns */
export type DeviceActionsVarPopFields = {
  __typename?: 'device_actions_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type DeviceActionsVarSampFields = {
  __typename?: 'device_actions_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type DeviceActionsVarianceFields = {
  __typename?: 'device_actions_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** device categories */
export type DeviceCategories = {
  __typename?: 'device_categories';
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  devices: Array<DevicesDeviceCategories>;
  /** An aggregate relationship */
  devices_aggregate: DevicesDeviceCategoriesAggregate;
  id: Scalars['Int'];
  key: Scalars['String'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};


/** device categories */
export type DeviceCategoriesDevicesArgs = {
  distinct_on?: InputMaybe<Array<DevicesDeviceCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicesDeviceCategoriesOrderBy>>;
  where?: InputMaybe<DevicesDeviceCategoriesBoolExp>;
};


/** device categories */
export type DeviceCategoriesDevicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DevicesDeviceCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicesDeviceCategoriesOrderBy>>;
  where?: InputMaybe<DevicesDeviceCategoriesBoolExp>;
};

/** aggregated selection of "device_categories" */
export type DeviceCategoriesAggregate = {
  __typename?: 'device_categories_aggregate';
  aggregate?: Maybe<DeviceCategoriesAggregateFields>;
  nodes: Array<DeviceCategories>;
};

/** aggregate fields of "device_categories" */
export type DeviceCategoriesAggregateFields = {
  __typename?: 'device_categories_aggregate_fields';
  avg?: Maybe<DeviceCategoriesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<DeviceCategoriesMaxFields>;
  min?: Maybe<DeviceCategoriesMinFields>;
  stddev?: Maybe<DeviceCategoriesStddevFields>;
  stddev_pop?: Maybe<DeviceCategoriesStddevPopFields>;
  stddev_samp?: Maybe<DeviceCategoriesStddevSampFields>;
  sum?: Maybe<DeviceCategoriesSumFields>;
  var_pop?: Maybe<DeviceCategoriesVarPopFields>;
  var_samp?: Maybe<DeviceCategoriesVarSampFields>;
  variance?: Maybe<DeviceCategoriesVarianceFields>;
};


/** aggregate fields of "device_categories" */
export type DeviceCategoriesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DeviceCategoriesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type DeviceCategoriesAvgFields = {
  __typename?: 'device_categories_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "device_categories". All fields are combined with a logical 'AND'. */
export type DeviceCategoriesBoolExp = {
  _and?: InputMaybe<Array<DeviceCategoriesBoolExp>>;
  _not?: InputMaybe<DeviceCategoriesBoolExp>;
  _or?: InputMaybe<Array<DeviceCategoriesBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  devices?: InputMaybe<DevicesDeviceCategoriesBoolExp>;
  devices_aggregate?: InputMaybe<DevicesDeviceCategoriesAggregateBoolExp>;
  id?: InputMaybe<IntComparisonExp>;
  key?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "device_categories" */
export enum DeviceCategoriesConstraint {
  /** unique or primary key constraint on columns "key" */
  DEVICE_CATEGORIES_KEY_KEY = 'device_categories_key_key',
  /** unique or primary key constraint on columns "name" */
  DEVICE_CATEGORIES_NAME_KEY = 'device_categories_name_key',
  /** unique or primary key constraint on columns "id" */
  DEVICE_CATEGORIES_PKEY = 'device_categories_pkey'
}

/** input type for incrementing numeric columns in table "device_categories" */
export type DeviceCategoriesIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "device_categories" */
export type DeviceCategoriesInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  devices?: InputMaybe<DevicesDeviceCategoriesArrRelInsertInput>;
  id?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type DeviceCategoriesMaxFields = {
  __typename?: 'device_categories_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type DeviceCategoriesMinFields = {
  __typename?: 'device_categories_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "device_categories" */
export type DeviceCategoriesMutationResponse = {
  __typename?: 'device_categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DeviceCategories>;
};

/** input type for inserting object relation for remote table "device_categories" */
export type DeviceCategoriesObjRelInsertInput = {
  data: DeviceCategoriesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<DeviceCategoriesOnConflict>;
};

/** on_conflict condition type for table "device_categories" */
export type DeviceCategoriesOnConflict = {
  constraint: DeviceCategoriesConstraint;
  update_columns?: Array<DeviceCategoriesUpdateColumn>;
  where?: InputMaybe<DeviceCategoriesBoolExp>;
};

/** Ordering options when selecting data from "device_categories". */
export type DeviceCategoriesOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  devices_aggregate?: InputMaybe<DevicesDeviceCategoriesAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  key?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: device_categories */
export type DeviceCategoriesPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "device_categories" */
export enum DeviceCategoriesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  KEY = 'key',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATED_AT = 'updated_at'
}

/** input type for updating data in table "device_categories" */
export type DeviceCategoriesSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type DeviceCategoriesStddevFields = {
  __typename?: 'device_categories_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type DeviceCategoriesStddevPopFields = {
  __typename?: 'device_categories_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type DeviceCategoriesStddevSampFields = {
  __typename?: 'device_categories_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "device_categories" */
export type DeviceCategoriesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DeviceCategoriesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DeviceCategoriesStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type DeviceCategoriesSumFields = {
  __typename?: 'device_categories_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "device_categories" */
export enum DeviceCategoriesUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  KEY = 'key',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATED_AT = 'updated_at'
}

export type DeviceCategoriesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DeviceCategoriesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DeviceCategoriesSetInput>;
  /** filter the rows which have to be updated */
  where: DeviceCategoriesBoolExp;
};

/** aggregate var_pop on columns */
export type DeviceCategoriesVarPopFields = {
  __typename?: 'device_categories_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type DeviceCategoriesVarSampFields = {
  __typename?: 'device_categories_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type DeviceCategoriesVarianceFields = {
  __typename?: 'device_categories_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "device_payload_values" */
export type DevicePayloadValues = {
  __typename?: 'device_payload_values';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
  value: Scalars['String'];
};

/** aggregated selection of "device_payload_values" */
export type DevicePayloadValuesAggregate = {
  __typename?: 'device_payload_values_aggregate';
  aggregate?: Maybe<DevicePayloadValuesAggregateFields>;
  nodes: Array<DevicePayloadValues>;
};

/** aggregate fields of "device_payload_values" */
export type DevicePayloadValuesAggregateFields = {
  __typename?: 'device_payload_values_aggregate_fields';
  avg?: Maybe<DevicePayloadValuesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<DevicePayloadValuesMaxFields>;
  min?: Maybe<DevicePayloadValuesMinFields>;
  stddev?: Maybe<DevicePayloadValuesStddevFields>;
  stddev_pop?: Maybe<DevicePayloadValuesStddevPopFields>;
  stddev_samp?: Maybe<DevicePayloadValuesStddevSampFields>;
  sum?: Maybe<DevicePayloadValuesSumFields>;
  var_pop?: Maybe<DevicePayloadValuesVarPopFields>;
  var_samp?: Maybe<DevicePayloadValuesVarSampFields>;
  variance?: Maybe<DevicePayloadValuesVarianceFields>;
};


/** aggregate fields of "device_payload_values" */
export type DevicePayloadValuesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DevicePayloadValuesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type DevicePayloadValuesAvgFields = {
  __typename?: 'device_payload_values_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "device_payload_values". All fields are combined with a logical 'AND'. */
export type DevicePayloadValuesBoolExp = {
  _and?: InputMaybe<Array<DevicePayloadValuesBoolExp>>;
  _not?: InputMaybe<DevicePayloadValuesBoolExp>;
  _or?: InputMaybe<Array<DevicePayloadValuesBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<IntComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "device_payload_values" */
export enum DevicePayloadValuesConstraint {
  /** unique or primary key constraint on columns "name" */
  DEVICE_PAYLOAD_VALUES_NAME_UNIQUE = 'device_payload_values_name_unique',
  /** unique or primary key constraint on columns "id" */
  DEVICE_PAYLOAD_VALUES_PKEY = 'device_payload_values_pkey'
}

/** input type for incrementing numeric columns in table "device_payload_values" */
export type DevicePayloadValuesIncInput = {
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "device_payload_values" */
export type DevicePayloadValuesInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type DevicePayloadValuesMaxFields = {
  __typename?: 'device_payload_values_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type DevicePayloadValuesMinFields = {
  __typename?: 'device_payload_values_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "device_payload_values" */
export type DevicePayloadValuesMutationResponse = {
  __typename?: 'device_payload_values_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DevicePayloadValues>;
};

/** input type for inserting object relation for remote table "device_payload_values" */
export type DevicePayloadValuesObjRelInsertInput = {
  data: DevicePayloadValuesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<DevicePayloadValuesOnConflict>;
};

/** on_conflict condition type for table "device_payload_values" */
export type DevicePayloadValuesOnConflict = {
  constraint: DevicePayloadValuesConstraint;
  update_columns?: Array<DevicePayloadValuesUpdateColumn>;
  where?: InputMaybe<DevicePayloadValuesBoolExp>;
};

/** Ordering options when selecting data from "device_payload_values". */
export type DevicePayloadValuesOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: device_payload_values */
export type DevicePayloadValuesPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "device_payload_values" */
export enum DevicePayloadValuesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by',
  /** column name */
  VALUE = 'value'
}

/** input type for updating data in table "device_payload_values" */
export type DevicePayloadValuesSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type DevicePayloadValuesStddevFields = {
  __typename?: 'device_payload_values_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type DevicePayloadValuesStddevPopFields = {
  __typename?: 'device_payload_values_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type DevicePayloadValuesStddevSampFields = {
  __typename?: 'device_payload_values_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "device_payload_values" */
export type DevicePayloadValuesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DevicePayloadValuesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DevicePayloadValuesStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type DevicePayloadValuesSumFields = {
  __typename?: 'device_payload_values_sum_fields';
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** update columns of table "device_payload_values" */
export enum DevicePayloadValuesUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by',
  /** column name */
  VALUE = 'value'
}

export type DevicePayloadValuesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DevicePayloadValuesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DevicePayloadValuesSetInput>;
  /** filter the rows which have to be updated */
  where: DevicePayloadValuesBoolExp;
};

/** aggregate var_pop on columns */
export type DevicePayloadValuesVarPopFields = {
  __typename?: 'device_payload_values_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type DevicePayloadValuesVarSampFields = {
  __typename?: 'device_payload_values_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type DevicePayloadValuesVarianceFields = {
  __typename?: 'device_payload_values_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "device_payloads" */
export type DevicePayloads = {
  __typename?: 'device_payloads';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  key: Scalars['String'];
  name: Scalars['String'];
  payload_kind: Scalars['String'];
  /** An array relationship */
  payload_values: Array<DevicePayloadsPayloadValues>;
  /** An aggregate relationship */
  payload_values_aggregate: DevicePayloadsPayloadValuesAggregate;
  type: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "device_payloads" */
export type DevicePayloadsPayloadValuesArgs = {
  distinct_on?: InputMaybe<Array<DevicePayloadsPayloadValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicePayloadsPayloadValuesOrderBy>>;
  where?: InputMaybe<DevicePayloadsPayloadValuesBoolExp>;
};


/** columns and relationships of "device_payloads" */
export type DevicePayloadsPayloadValuesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DevicePayloadsPayloadValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicePayloadsPayloadValuesOrderBy>>;
  where?: InputMaybe<DevicePayloadsPayloadValuesBoolExp>;
};

/** columns and relationships of "device_payloads__payload_values" */
export type DevicePayloadsPayloadValues = {
  __typename?: 'device_payloads__payload_values';
  device_payload_id?: Maybe<Scalars['Int']>;
  device_payload_value_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  /** An object relationship */
  value?: Maybe<DevicePayloadValues>;
};

/** aggregated selection of "device_payloads__payload_values" */
export type DevicePayloadsPayloadValuesAggregate = {
  __typename?: 'device_payloads__payload_values_aggregate';
  aggregate?: Maybe<DevicePayloadsPayloadValuesAggregateFields>;
  nodes: Array<DevicePayloadsPayloadValues>;
};

export type DevicePayloadsPayloadValuesAggregateBoolExp = {
  count?: InputMaybe<DevicePayloadsPayloadValuesAggregateBoolExpCount>;
};

export type DevicePayloadsPayloadValuesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<DevicePayloadsPayloadValuesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DevicePayloadsPayloadValuesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "device_payloads__payload_values" */
export type DevicePayloadsPayloadValuesAggregateFields = {
  __typename?: 'device_payloads__payload_values_aggregate_fields';
  avg?: Maybe<DevicePayloadsPayloadValuesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<DevicePayloadsPayloadValuesMaxFields>;
  min?: Maybe<DevicePayloadsPayloadValuesMinFields>;
  stddev?: Maybe<DevicePayloadsPayloadValuesStddevFields>;
  stddev_pop?: Maybe<DevicePayloadsPayloadValuesStddevPopFields>;
  stddev_samp?: Maybe<DevicePayloadsPayloadValuesStddevSampFields>;
  sum?: Maybe<DevicePayloadsPayloadValuesSumFields>;
  var_pop?: Maybe<DevicePayloadsPayloadValuesVarPopFields>;
  var_samp?: Maybe<DevicePayloadsPayloadValuesVarSampFields>;
  variance?: Maybe<DevicePayloadsPayloadValuesVarianceFields>;
};


/** aggregate fields of "device_payloads__payload_values" */
export type DevicePayloadsPayloadValuesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DevicePayloadsPayloadValuesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "device_payloads__payload_values" */
export type DevicePayloadsPayloadValuesAggregateOrderBy = {
  avg?: InputMaybe<DevicePayloadsPayloadValuesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DevicePayloadsPayloadValuesMaxOrderBy>;
  min?: InputMaybe<DevicePayloadsPayloadValuesMinOrderBy>;
  stddev?: InputMaybe<DevicePayloadsPayloadValuesStddevOrderBy>;
  stddev_pop?: InputMaybe<DevicePayloadsPayloadValuesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<DevicePayloadsPayloadValuesStddevSampOrderBy>;
  sum?: InputMaybe<DevicePayloadsPayloadValuesSumOrderBy>;
  var_pop?: InputMaybe<DevicePayloadsPayloadValuesVarPopOrderBy>;
  var_samp?: InputMaybe<DevicePayloadsPayloadValuesVarSampOrderBy>;
  variance?: InputMaybe<DevicePayloadsPayloadValuesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "device_payloads__payload_values" */
export type DevicePayloadsPayloadValuesArrRelInsertInput = {
  data: Array<DevicePayloadsPayloadValuesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<DevicePayloadsPayloadValuesOnConflict>;
};

/** aggregate avg on columns */
export type DevicePayloadsPayloadValuesAvgFields = {
  __typename?: 'device_payloads__payload_values_avg_fields';
  device_payload_id?: Maybe<Scalars['Float']>;
  device_payload_value_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "device_payloads__payload_values" */
export type DevicePayloadsPayloadValuesAvgOrderBy = {
  device_payload_id?: InputMaybe<OrderBy>;
  device_payload_value_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "device_payloads__payload_values". All fields are combined with a logical 'AND'. */
export type DevicePayloadsPayloadValuesBoolExp = {
  _and?: InputMaybe<Array<DevicePayloadsPayloadValuesBoolExp>>;
  _not?: InputMaybe<DevicePayloadsPayloadValuesBoolExp>;
  _or?: InputMaybe<Array<DevicePayloadsPayloadValuesBoolExp>>;
  device_payload_id?: InputMaybe<IntComparisonExp>;
  device_payload_value_id?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  value?: InputMaybe<DevicePayloadValuesBoolExp>;
};

/** unique or primary key constraints on table "device_payloads__payload_values" */
export enum DevicePayloadsPayloadValuesConstraint {
  /** unique or primary key constraint on columns "id" */
  DEVICE_PAYLOADS__PAYLOAD_VALUES_PKEY = 'device_payloads__payload_values_pkey'
}

/** input type for incrementing numeric columns in table "device_payloads__payload_values" */
export type DevicePayloadsPayloadValuesIncInput = {
  device_payload_id?: InputMaybe<Scalars['Int']>;
  device_payload_value_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "device_payloads__payload_values" */
export type DevicePayloadsPayloadValuesInsertInput = {
  device_payload_id?: InputMaybe<Scalars['Int']>;
  device_payload_value_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<DevicePayloadValuesObjRelInsertInput>;
};

/** aggregate max on columns */
export type DevicePayloadsPayloadValuesMaxFields = {
  __typename?: 'device_payloads__payload_values_max_fields';
  device_payload_id?: Maybe<Scalars['Int']>;
  device_payload_value_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "device_payloads__payload_values" */
export type DevicePayloadsPayloadValuesMaxOrderBy = {
  device_payload_id?: InputMaybe<OrderBy>;
  device_payload_value_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type DevicePayloadsPayloadValuesMinFields = {
  __typename?: 'device_payloads__payload_values_min_fields';
  device_payload_id?: Maybe<Scalars['Int']>;
  device_payload_value_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "device_payloads__payload_values" */
export type DevicePayloadsPayloadValuesMinOrderBy = {
  device_payload_id?: InputMaybe<OrderBy>;
  device_payload_value_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "device_payloads__payload_values" */
export type DevicePayloadsPayloadValuesMutationResponse = {
  __typename?: 'device_payloads__payload_values_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DevicePayloadsPayloadValues>;
};

/** on_conflict condition type for table "device_payloads__payload_values" */
export type DevicePayloadsPayloadValuesOnConflict = {
  constraint: DevicePayloadsPayloadValuesConstraint;
  update_columns?: Array<DevicePayloadsPayloadValuesUpdateColumn>;
  where?: InputMaybe<DevicePayloadsPayloadValuesBoolExp>;
};

/** Ordering options when selecting data from "device_payloads__payload_values". */
export type DevicePayloadsPayloadValuesOrderBy = {
  device_payload_id?: InputMaybe<OrderBy>;
  device_payload_value_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  value?: InputMaybe<DevicePayloadValuesOrderBy>;
};

/** primary key columns input for table: device_payloads__payload_values */
export type DevicePayloadsPayloadValuesPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "device_payloads__payload_values" */
export enum DevicePayloadsPayloadValuesSelectColumn {
  /** column name */
  DEVICE_PAYLOAD_ID = 'device_payload_id',
  /** column name */
  DEVICE_PAYLOAD_VALUE_ID = 'device_payload_value_id',
  /** column name */
  ID = 'id'
}

/** input type for updating data in table "device_payloads__payload_values" */
export type DevicePayloadsPayloadValuesSetInput = {
  device_payload_id?: InputMaybe<Scalars['Int']>;
  device_payload_value_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type DevicePayloadsPayloadValuesStddevFields = {
  __typename?: 'device_payloads__payload_values_stddev_fields';
  device_payload_id?: Maybe<Scalars['Float']>;
  device_payload_value_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "device_payloads__payload_values" */
export type DevicePayloadsPayloadValuesStddevOrderBy = {
  device_payload_id?: InputMaybe<OrderBy>;
  device_payload_value_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type DevicePayloadsPayloadValuesStddevPopFields = {
  __typename?: 'device_payloads__payload_values_stddev_pop_fields';
  device_payload_id?: Maybe<Scalars['Float']>;
  device_payload_value_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "device_payloads__payload_values" */
export type DevicePayloadsPayloadValuesStddevPopOrderBy = {
  device_payload_id?: InputMaybe<OrderBy>;
  device_payload_value_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type DevicePayloadsPayloadValuesStddevSampFields = {
  __typename?: 'device_payloads__payload_values_stddev_samp_fields';
  device_payload_id?: Maybe<Scalars['Float']>;
  device_payload_value_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "device_payloads__payload_values" */
export type DevicePayloadsPayloadValuesStddevSampOrderBy = {
  device_payload_id?: InputMaybe<OrderBy>;
  device_payload_value_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "device_payloads__payload_values" */
export type DevicePayloadsPayloadValuesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DevicePayloadsPayloadValuesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DevicePayloadsPayloadValuesStreamCursorValueInput = {
  device_payload_id?: InputMaybe<Scalars['Int']>;
  device_payload_value_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type DevicePayloadsPayloadValuesSumFields = {
  __typename?: 'device_payloads__payload_values_sum_fields';
  device_payload_id?: Maybe<Scalars['Int']>;
  device_payload_value_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "device_payloads__payload_values" */
export type DevicePayloadsPayloadValuesSumOrderBy = {
  device_payload_id?: InputMaybe<OrderBy>;
  device_payload_value_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "device_payloads__payload_values" */
export enum DevicePayloadsPayloadValuesUpdateColumn {
  /** column name */
  DEVICE_PAYLOAD_ID = 'device_payload_id',
  /** column name */
  DEVICE_PAYLOAD_VALUE_ID = 'device_payload_value_id',
  /** column name */
  ID = 'id'
}

export type DevicePayloadsPayloadValuesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DevicePayloadsPayloadValuesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DevicePayloadsPayloadValuesSetInput>;
  /** filter the rows which have to be updated */
  where: DevicePayloadsPayloadValuesBoolExp;
};

/** aggregate var_pop on columns */
export type DevicePayloadsPayloadValuesVarPopFields = {
  __typename?: 'device_payloads__payload_values_var_pop_fields';
  device_payload_id?: Maybe<Scalars['Float']>;
  device_payload_value_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "device_payloads__payload_values" */
export type DevicePayloadsPayloadValuesVarPopOrderBy = {
  device_payload_id?: InputMaybe<OrderBy>;
  device_payload_value_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type DevicePayloadsPayloadValuesVarSampFields = {
  __typename?: 'device_payloads__payload_values_var_samp_fields';
  device_payload_id?: Maybe<Scalars['Float']>;
  device_payload_value_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "device_payloads__payload_values" */
export type DevicePayloadsPayloadValuesVarSampOrderBy = {
  device_payload_id?: InputMaybe<OrderBy>;
  device_payload_value_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type DevicePayloadsPayloadValuesVarianceFields = {
  __typename?: 'device_payloads__payload_values_variance_fields';
  device_payload_id?: Maybe<Scalars['Float']>;
  device_payload_value_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "device_payloads__payload_values" */
export type DevicePayloadsPayloadValuesVarianceOrderBy = {
  device_payload_id?: InputMaybe<OrderBy>;
  device_payload_value_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregated selection of "device_payloads" */
export type DevicePayloadsAggregate = {
  __typename?: 'device_payloads_aggregate';
  aggregate?: Maybe<DevicePayloadsAggregateFields>;
  nodes: Array<DevicePayloads>;
};

/** aggregate fields of "device_payloads" */
export type DevicePayloadsAggregateFields = {
  __typename?: 'device_payloads_aggregate_fields';
  avg?: Maybe<DevicePayloadsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<DevicePayloadsMaxFields>;
  min?: Maybe<DevicePayloadsMinFields>;
  stddev?: Maybe<DevicePayloadsStddevFields>;
  stddev_pop?: Maybe<DevicePayloadsStddevPopFields>;
  stddev_samp?: Maybe<DevicePayloadsStddevSampFields>;
  sum?: Maybe<DevicePayloadsSumFields>;
  var_pop?: Maybe<DevicePayloadsVarPopFields>;
  var_samp?: Maybe<DevicePayloadsVarSampFields>;
  variance?: Maybe<DevicePayloadsVarianceFields>;
};


/** aggregate fields of "device_payloads" */
export type DevicePayloadsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DevicePayloadsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type DevicePayloadsAvgFields = {
  __typename?: 'device_payloads_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "device_payloads". All fields are combined with a logical 'AND'. */
export type DevicePayloadsBoolExp = {
  _and?: InputMaybe<Array<DevicePayloadsBoolExp>>;
  _not?: InputMaybe<DevicePayloadsBoolExp>;
  _or?: InputMaybe<Array<DevicePayloadsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  key?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  payload_kind?: InputMaybe<StringComparisonExp>;
  payload_values?: InputMaybe<DevicePayloadsPayloadValuesBoolExp>;
  payload_values_aggregate?: InputMaybe<DevicePayloadsPayloadValuesAggregateBoolExp>;
  type?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "device_payloads" */
export enum DevicePayloadsConstraint {
  /** unique or primary key constraint on columns "key" */
  DEVICE_PAYLOADS_KEY_UNIQUE = 'device_payloads_key_unique',
  /** unique or primary key constraint on columns "name" */
  DEVICE_PAYLOADS_NAME_UNIQUE = 'device_payloads_name_unique',
  /** unique or primary key constraint on columns "id" */
  DEVICE_PAYLOADS_PKEY = 'device_payloads_pkey'
}

/** input type for incrementing numeric columns in table "device_payloads" */
export type DevicePayloadsIncInput = {
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "device_payloads" */
export type DevicePayloadsInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  payload_kind?: InputMaybe<Scalars['String']>;
  payload_values?: InputMaybe<DevicePayloadsPayloadValuesArrRelInsertInput>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type DevicePayloadsMaxFields = {
  __typename?: 'device_payloads_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  payload_kind?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type DevicePayloadsMinFields = {
  __typename?: 'device_payloads_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  payload_kind?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "device_payloads" */
export type DevicePayloadsMutationResponse = {
  __typename?: 'device_payloads_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DevicePayloads>;
};

/** input type for inserting object relation for remote table "device_payloads" */
export type DevicePayloadsObjRelInsertInput = {
  data: DevicePayloadsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<DevicePayloadsOnConflict>;
};

/** on_conflict condition type for table "device_payloads" */
export type DevicePayloadsOnConflict = {
  constraint: DevicePayloadsConstraint;
  update_columns?: Array<DevicePayloadsUpdateColumn>;
  where?: InputMaybe<DevicePayloadsBoolExp>;
};

/** Ordering options when selecting data from "device_payloads". */
export type DevicePayloadsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  key?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  payload_kind?: InputMaybe<OrderBy>;
  payload_values_aggregate?: InputMaybe<DevicePayloadsPayloadValuesAggregateOrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: device_payloads */
export type DevicePayloadsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "device_payloads" */
export enum DevicePayloadsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  ID = 'id',
  /** column name */
  KEY = 'key',
  /** column name */
  NAME = 'name',
  /** column name */
  PAYLOAD_KIND = 'payload_kind',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by'
}

/** input type for updating data in table "device_payloads" */
export type DevicePayloadsSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  payload_kind?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type DevicePayloadsStddevFields = {
  __typename?: 'device_payloads_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type DevicePayloadsStddevPopFields = {
  __typename?: 'device_payloads_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type DevicePayloadsStddevSampFields = {
  __typename?: 'device_payloads_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "device_payloads" */
export type DevicePayloadsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DevicePayloadsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DevicePayloadsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  payload_kind?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type DevicePayloadsSumFields = {
  __typename?: 'device_payloads_sum_fields';
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** update columns of table "device_payloads" */
export enum DevicePayloadsUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  ID = 'id',
  /** column name */
  KEY = 'key',
  /** column name */
  NAME = 'name',
  /** column name */
  PAYLOAD_KIND = 'payload_kind',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by'
}

export type DevicePayloadsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DevicePayloadsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DevicePayloadsSetInput>;
  /** filter the rows which have to be updated */
  where: DevicePayloadsBoolExp;
};

/** aggregate var_pop on columns */
export type DevicePayloadsVarPopFields = {
  __typename?: 'device_payloads_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type DevicePayloadsVarSampFields = {
  __typename?: 'device_payloads_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type DevicePayloadsVarianceFields = {
  __typename?: 'device_payloads_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "devices" */
export type Devices = {
  __typename?: 'devices';
  activationType?: Maybe<Scalars['String']>;
  /** An array relationship */
  analysis_applications: Array<AnalysisApplicationsDevices>;
  /** An aggregate relationship */
  analysis_applications_aggregate: AnalysisApplicationsDevicesAggregate;
  /** An object relationship */
  application?: Maybe<Applications>;
  application_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  area?: Maybe<Areas>;
  area_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  categories: Array<DevicesDeviceCategories>;
  /** An aggregate relationship */
  categories_aggregate: DevicesDeviceCategoriesAggregate;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  /** An array relationship */
  dashboards: Array<ApplicationsDashboardsDevices>;
  /** An aggregate relationship */
  dashboards_aggregate: ApplicationsDashboardsDevicesAggregate;
  /** An array relationship */
  device_actions: Array<DevicesDeviceActions>;
  /** An aggregate relationship */
  device_actions_aggregate: DevicesDeviceActionsAggregate;
  device_class?: Maybe<Scalars['String']>;
  /** An array relationship */
  device_payloads: Array<DevicesDevicePayloads>;
  /** An aggregate relationship */
  device_payloads_aggregate: DevicesDevicePayloadsAggregate;
  device_type: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  provider_id: Scalars['String'];
  resetFrames?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  scenes: Array<ScenesDevices>;
  /** An aggregate relationship */
  scenes_aggregate: ScenesDevicesAggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
  uplink_interval?: Maybe<Scalars['bigint']>;
  visible?: Maybe<Scalars['Boolean']>;
};


/** columns and relationships of "devices" */
export type DevicesAnalysisApplicationsArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsDevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsDevicesOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsDevicesBoolExp>;
};


/** columns and relationships of "devices" */
export type DevicesAnalysisApplicationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsDevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsDevicesOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsDevicesBoolExp>;
};


/** columns and relationships of "devices" */
export type DevicesCategoriesArgs = {
  distinct_on?: InputMaybe<Array<DevicesDeviceCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicesDeviceCategoriesOrderBy>>;
  where?: InputMaybe<DevicesDeviceCategoriesBoolExp>;
};


/** columns and relationships of "devices" */
export type DevicesCategoriesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DevicesDeviceCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicesDeviceCategoriesOrderBy>>;
  where?: InputMaybe<DevicesDeviceCategoriesBoolExp>;
};


/** columns and relationships of "devices" */
export type DevicesDashboardsArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsDashboardsDevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsDashboardsDevicesOrderBy>>;
  where?: InputMaybe<ApplicationsDashboardsDevicesBoolExp>;
};


/** columns and relationships of "devices" */
export type DevicesDashboardsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsDashboardsDevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsDashboardsDevicesOrderBy>>;
  where?: InputMaybe<ApplicationsDashboardsDevicesBoolExp>;
};


/** columns and relationships of "devices" */
export type DevicesDeviceActionsArgs = {
  distinct_on?: InputMaybe<Array<DevicesDeviceActionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicesDeviceActionsOrderBy>>;
  where?: InputMaybe<DevicesDeviceActionsBoolExp>;
};


/** columns and relationships of "devices" */
export type DevicesDeviceActionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DevicesDeviceActionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicesDeviceActionsOrderBy>>;
  where?: InputMaybe<DevicesDeviceActionsBoolExp>;
};


/** columns and relationships of "devices" */
export type DevicesDevicePayloadsArgs = {
  distinct_on?: InputMaybe<Array<DevicesDevicePayloadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicesDevicePayloadsOrderBy>>;
  where?: InputMaybe<DevicesDevicePayloadsBoolExp>;
};


/** columns and relationships of "devices" */
export type DevicesDevicePayloadsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DevicesDevicePayloadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicesDevicePayloadsOrderBy>>;
  where?: InputMaybe<DevicesDevicePayloadsBoolExp>;
};


/** columns and relationships of "devices" */
export type DevicesScenesArgs = {
  distinct_on?: InputMaybe<Array<ScenesDevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ScenesDevicesOrderBy>>;
  where?: InputMaybe<ScenesDevicesBoolExp>;
};


/** columns and relationships of "devices" */
export type DevicesScenesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ScenesDevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ScenesDevicesOrderBy>>;
  where?: InputMaybe<ScenesDevicesBoolExp>;
};

/** columns and relationships of "devices__device_actions" */
export type DevicesDeviceActions = {
  __typename?: 'devices__device_actions';
  /** An object relationship */
  device?: Maybe<Devices>;
  /** An object relationship */
  device_action?: Maybe<DeviceActions>;
  device_action_id?: Maybe<Scalars['Int']>;
  device_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
};

/** aggregated selection of "devices__device_actions" */
export type DevicesDeviceActionsAggregate = {
  __typename?: 'devices__device_actions_aggregate';
  aggregate?: Maybe<DevicesDeviceActionsAggregateFields>;
  nodes: Array<DevicesDeviceActions>;
};

export type DevicesDeviceActionsAggregateBoolExp = {
  count?: InputMaybe<DevicesDeviceActionsAggregateBoolExpCount>;
};

export type DevicesDeviceActionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<DevicesDeviceActionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DevicesDeviceActionsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "devices__device_actions" */
export type DevicesDeviceActionsAggregateFields = {
  __typename?: 'devices__device_actions_aggregate_fields';
  avg?: Maybe<DevicesDeviceActionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<DevicesDeviceActionsMaxFields>;
  min?: Maybe<DevicesDeviceActionsMinFields>;
  stddev?: Maybe<DevicesDeviceActionsStddevFields>;
  stddev_pop?: Maybe<DevicesDeviceActionsStddevPopFields>;
  stddev_samp?: Maybe<DevicesDeviceActionsStddevSampFields>;
  sum?: Maybe<DevicesDeviceActionsSumFields>;
  var_pop?: Maybe<DevicesDeviceActionsVarPopFields>;
  var_samp?: Maybe<DevicesDeviceActionsVarSampFields>;
  variance?: Maybe<DevicesDeviceActionsVarianceFields>;
};


/** aggregate fields of "devices__device_actions" */
export type DevicesDeviceActionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DevicesDeviceActionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "devices__device_actions" */
export type DevicesDeviceActionsAggregateOrderBy = {
  avg?: InputMaybe<DevicesDeviceActionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DevicesDeviceActionsMaxOrderBy>;
  min?: InputMaybe<DevicesDeviceActionsMinOrderBy>;
  stddev?: InputMaybe<DevicesDeviceActionsStddevOrderBy>;
  stddev_pop?: InputMaybe<DevicesDeviceActionsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<DevicesDeviceActionsStddevSampOrderBy>;
  sum?: InputMaybe<DevicesDeviceActionsSumOrderBy>;
  var_pop?: InputMaybe<DevicesDeviceActionsVarPopOrderBy>;
  var_samp?: InputMaybe<DevicesDeviceActionsVarSampOrderBy>;
  variance?: InputMaybe<DevicesDeviceActionsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "devices__device_actions" */
export type DevicesDeviceActionsArrRelInsertInput = {
  data: Array<DevicesDeviceActionsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<DevicesDeviceActionsOnConflict>;
};

/** aggregate avg on columns */
export type DevicesDeviceActionsAvgFields = {
  __typename?: 'devices__device_actions_avg_fields';
  device_action_id?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "devices__device_actions" */
export type DevicesDeviceActionsAvgOrderBy = {
  device_action_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "devices__device_actions". All fields are combined with a logical 'AND'. */
export type DevicesDeviceActionsBoolExp = {
  _and?: InputMaybe<Array<DevicesDeviceActionsBoolExp>>;
  _not?: InputMaybe<DevicesDeviceActionsBoolExp>;
  _or?: InputMaybe<Array<DevicesDeviceActionsBoolExp>>;
  device?: InputMaybe<DevicesBoolExp>;
  device_action?: InputMaybe<DeviceActionsBoolExp>;
  device_action_id?: InputMaybe<IntComparisonExp>;
  device_id?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "devices__device_actions" */
export enum DevicesDeviceActionsConstraint {
  /** unique or primary key constraint on columns "id" */
  DEVICES__DEVICE_ACTIONS_PKEY = 'devices__device_actions_pkey'
}

/** input type for incrementing numeric columns in table "devices__device_actions" */
export type DevicesDeviceActionsIncInput = {
  device_action_id?: InputMaybe<Scalars['Int']>;
  device_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "devices__device_actions" */
export type DevicesDeviceActionsInsertInput = {
  device?: InputMaybe<DevicesObjRelInsertInput>;
  device_action?: InputMaybe<DeviceActionsObjRelInsertInput>;
  device_action_id?: InputMaybe<Scalars['Int']>;
  device_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type DevicesDeviceActionsMaxFields = {
  __typename?: 'devices__device_actions_max_fields';
  device_action_id?: Maybe<Scalars['Int']>;
  device_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "devices__device_actions" */
export type DevicesDeviceActionsMaxOrderBy = {
  device_action_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type DevicesDeviceActionsMinFields = {
  __typename?: 'devices__device_actions_min_fields';
  device_action_id?: Maybe<Scalars['Int']>;
  device_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "devices__device_actions" */
export type DevicesDeviceActionsMinOrderBy = {
  device_action_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "devices__device_actions" */
export type DevicesDeviceActionsMutationResponse = {
  __typename?: 'devices__device_actions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DevicesDeviceActions>;
};

/** on_conflict condition type for table "devices__device_actions" */
export type DevicesDeviceActionsOnConflict = {
  constraint: DevicesDeviceActionsConstraint;
  update_columns?: Array<DevicesDeviceActionsUpdateColumn>;
  where?: InputMaybe<DevicesDeviceActionsBoolExp>;
};

/** Ordering options when selecting data from "devices__device_actions". */
export type DevicesDeviceActionsOrderBy = {
  device?: InputMaybe<DevicesOrderBy>;
  device_action?: InputMaybe<DeviceActionsOrderBy>;
  device_action_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: devices__device_actions */
export type DevicesDeviceActionsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "devices__device_actions" */
export enum DevicesDeviceActionsSelectColumn {
  /** column name */
  DEVICE_ACTION_ID = 'device_action_id',
  /** column name */
  DEVICE_ID = 'device_id',
  /** column name */
  ID = 'id'
}

/** input type for updating data in table "devices__device_actions" */
export type DevicesDeviceActionsSetInput = {
  device_action_id?: InputMaybe<Scalars['Int']>;
  device_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type DevicesDeviceActionsStddevFields = {
  __typename?: 'devices__device_actions_stddev_fields';
  device_action_id?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "devices__device_actions" */
export type DevicesDeviceActionsStddevOrderBy = {
  device_action_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type DevicesDeviceActionsStddevPopFields = {
  __typename?: 'devices__device_actions_stddev_pop_fields';
  device_action_id?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "devices__device_actions" */
export type DevicesDeviceActionsStddevPopOrderBy = {
  device_action_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type DevicesDeviceActionsStddevSampFields = {
  __typename?: 'devices__device_actions_stddev_samp_fields';
  device_action_id?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "devices__device_actions" */
export type DevicesDeviceActionsStddevSampOrderBy = {
  device_action_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "devices__device_actions" */
export type DevicesDeviceActionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DevicesDeviceActionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DevicesDeviceActionsStreamCursorValueInput = {
  device_action_id?: InputMaybe<Scalars['Int']>;
  device_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type DevicesDeviceActionsSumFields = {
  __typename?: 'devices__device_actions_sum_fields';
  device_action_id?: Maybe<Scalars['Int']>;
  device_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "devices__device_actions" */
export type DevicesDeviceActionsSumOrderBy = {
  device_action_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "devices__device_actions" */
export enum DevicesDeviceActionsUpdateColumn {
  /** column name */
  DEVICE_ACTION_ID = 'device_action_id',
  /** column name */
  DEVICE_ID = 'device_id',
  /** column name */
  ID = 'id'
}

export type DevicesDeviceActionsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DevicesDeviceActionsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DevicesDeviceActionsSetInput>;
  /** filter the rows which have to be updated */
  where: DevicesDeviceActionsBoolExp;
};

/** aggregate var_pop on columns */
export type DevicesDeviceActionsVarPopFields = {
  __typename?: 'devices__device_actions_var_pop_fields';
  device_action_id?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "devices__device_actions" */
export type DevicesDeviceActionsVarPopOrderBy = {
  device_action_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type DevicesDeviceActionsVarSampFields = {
  __typename?: 'devices__device_actions_var_samp_fields';
  device_action_id?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "devices__device_actions" */
export type DevicesDeviceActionsVarSampOrderBy = {
  device_action_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type DevicesDeviceActionsVarianceFields = {
  __typename?: 'devices__device_actions_variance_fields';
  device_action_id?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "devices__device_actions" */
export type DevicesDeviceActionsVarianceOrderBy = {
  device_action_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "devices__device_categories" */
export type DevicesDeviceCategories = {
  __typename?: 'devices__device_categories';
  /** An object relationship */
  category: DeviceCategories;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  device: Devices;
  device_category_id: Scalars['Int'];
  device_id: Scalars['Int'];
  id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "devices__device_categories" */
export type DevicesDeviceCategoriesAggregate = {
  __typename?: 'devices__device_categories_aggregate';
  aggregate?: Maybe<DevicesDeviceCategoriesAggregateFields>;
  nodes: Array<DevicesDeviceCategories>;
};

export type DevicesDeviceCategoriesAggregateBoolExp = {
  count?: InputMaybe<DevicesDeviceCategoriesAggregateBoolExpCount>;
};

export type DevicesDeviceCategoriesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<DevicesDeviceCategoriesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DevicesDeviceCategoriesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "devices__device_categories" */
export type DevicesDeviceCategoriesAggregateFields = {
  __typename?: 'devices__device_categories_aggregate_fields';
  avg?: Maybe<DevicesDeviceCategoriesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<DevicesDeviceCategoriesMaxFields>;
  min?: Maybe<DevicesDeviceCategoriesMinFields>;
  stddev?: Maybe<DevicesDeviceCategoriesStddevFields>;
  stddev_pop?: Maybe<DevicesDeviceCategoriesStddevPopFields>;
  stddev_samp?: Maybe<DevicesDeviceCategoriesStddevSampFields>;
  sum?: Maybe<DevicesDeviceCategoriesSumFields>;
  var_pop?: Maybe<DevicesDeviceCategoriesVarPopFields>;
  var_samp?: Maybe<DevicesDeviceCategoriesVarSampFields>;
  variance?: Maybe<DevicesDeviceCategoriesVarianceFields>;
};


/** aggregate fields of "devices__device_categories" */
export type DevicesDeviceCategoriesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DevicesDeviceCategoriesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "devices__device_categories" */
export type DevicesDeviceCategoriesAggregateOrderBy = {
  avg?: InputMaybe<DevicesDeviceCategoriesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DevicesDeviceCategoriesMaxOrderBy>;
  min?: InputMaybe<DevicesDeviceCategoriesMinOrderBy>;
  stddev?: InputMaybe<DevicesDeviceCategoriesStddevOrderBy>;
  stddev_pop?: InputMaybe<DevicesDeviceCategoriesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<DevicesDeviceCategoriesStddevSampOrderBy>;
  sum?: InputMaybe<DevicesDeviceCategoriesSumOrderBy>;
  var_pop?: InputMaybe<DevicesDeviceCategoriesVarPopOrderBy>;
  var_samp?: InputMaybe<DevicesDeviceCategoriesVarSampOrderBy>;
  variance?: InputMaybe<DevicesDeviceCategoriesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "devices__device_categories" */
export type DevicesDeviceCategoriesArrRelInsertInput = {
  data: Array<DevicesDeviceCategoriesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<DevicesDeviceCategoriesOnConflict>;
};

/** aggregate avg on columns */
export type DevicesDeviceCategoriesAvgFields = {
  __typename?: 'devices__device_categories_avg_fields';
  device_category_id?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "devices__device_categories" */
export type DevicesDeviceCategoriesAvgOrderBy = {
  device_category_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "devices__device_categories". All fields are combined with a logical 'AND'. */
export type DevicesDeviceCategoriesBoolExp = {
  _and?: InputMaybe<Array<DevicesDeviceCategoriesBoolExp>>;
  _not?: InputMaybe<DevicesDeviceCategoriesBoolExp>;
  _or?: InputMaybe<Array<DevicesDeviceCategoriesBoolExp>>;
  category?: InputMaybe<DeviceCategoriesBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  device?: InputMaybe<DevicesBoolExp>;
  device_category_id?: InputMaybe<IntComparisonExp>;
  device_id?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "devices__device_categories" */
export enum DevicesDeviceCategoriesConstraint {
  /** unique or primary key constraint on columns "device_category_id", "device_id" */
  DEVICES__DEVICE_CATEGORIES_DEVICE_ID_DEVICE_CATEGORY_ID_KEY = 'devices__device_categories_device_id_device_category_id_key',
  /** unique or primary key constraint on columns "id" */
  DEVICES__DEVICE_CATEGORIES_PKEY = 'devices__device_categories_pkey'
}

/** input type for incrementing numeric columns in table "devices__device_categories" */
export type DevicesDeviceCategoriesIncInput = {
  device_category_id?: InputMaybe<Scalars['Int']>;
  device_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "devices__device_categories" */
export type DevicesDeviceCategoriesInsertInput = {
  category?: InputMaybe<DeviceCategoriesObjRelInsertInput>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device?: InputMaybe<DevicesObjRelInsertInput>;
  device_category_id?: InputMaybe<Scalars['Int']>;
  device_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type DevicesDeviceCategoriesMaxFields = {
  __typename?: 'devices__device_categories_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  device_category_id?: Maybe<Scalars['Int']>;
  device_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "devices__device_categories" */
export type DevicesDeviceCategoriesMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  device_category_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type DevicesDeviceCategoriesMinFields = {
  __typename?: 'devices__device_categories_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  device_category_id?: Maybe<Scalars['Int']>;
  device_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "devices__device_categories" */
export type DevicesDeviceCategoriesMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  device_category_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "devices__device_categories" */
export type DevicesDeviceCategoriesMutationResponse = {
  __typename?: 'devices__device_categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DevicesDeviceCategories>;
};

/** on_conflict condition type for table "devices__device_categories" */
export type DevicesDeviceCategoriesOnConflict = {
  constraint: DevicesDeviceCategoriesConstraint;
  update_columns?: Array<DevicesDeviceCategoriesUpdateColumn>;
  where?: InputMaybe<DevicesDeviceCategoriesBoolExp>;
};

/** Ordering options when selecting data from "devices__device_categories". */
export type DevicesDeviceCategoriesOrderBy = {
  category?: InputMaybe<DeviceCategoriesOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  device?: InputMaybe<DevicesOrderBy>;
  device_category_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: devices__device_categories */
export type DevicesDeviceCategoriesPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "devices__device_categories" */
export enum DevicesDeviceCategoriesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEVICE_CATEGORY_ID = 'device_category_id',
  /** column name */
  DEVICE_ID = 'device_id',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
}

/** input type for updating data in table "devices__device_categories" */
export type DevicesDeviceCategoriesSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device_category_id?: InputMaybe<Scalars['Int']>;
  device_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type DevicesDeviceCategoriesStddevFields = {
  __typename?: 'devices__device_categories_stddev_fields';
  device_category_id?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "devices__device_categories" */
export type DevicesDeviceCategoriesStddevOrderBy = {
  device_category_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type DevicesDeviceCategoriesStddevPopFields = {
  __typename?: 'devices__device_categories_stddev_pop_fields';
  device_category_id?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "devices__device_categories" */
export type DevicesDeviceCategoriesStddevPopOrderBy = {
  device_category_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type DevicesDeviceCategoriesStddevSampFields = {
  __typename?: 'devices__device_categories_stddev_samp_fields';
  device_category_id?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "devices__device_categories" */
export type DevicesDeviceCategoriesStddevSampOrderBy = {
  device_category_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "devices__device_categories" */
export type DevicesDeviceCategoriesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DevicesDeviceCategoriesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DevicesDeviceCategoriesStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device_category_id?: InputMaybe<Scalars['Int']>;
  device_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type DevicesDeviceCategoriesSumFields = {
  __typename?: 'devices__device_categories_sum_fields';
  device_category_id?: Maybe<Scalars['Int']>;
  device_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "devices__device_categories" */
export type DevicesDeviceCategoriesSumOrderBy = {
  device_category_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "devices__device_categories" */
export enum DevicesDeviceCategoriesUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEVICE_CATEGORY_ID = 'device_category_id',
  /** column name */
  DEVICE_ID = 'device_id',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
}

export type DevicesDeviceCategoriesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DevicesDeviceCategoriesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DevicesDeviceCategoriesSetInput>;
  /** filter the rows which have to be updated */
  where: DevicesDeviceCategoriesBoolExp;
};

/** aggregate var_pop on columns */
export type DevicesDeviceCategoriesVarPopFields = {
  __typename?: 'devices__device_categories_var_pop_fields';
  device_category_id?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "devices__device_categories" */
export type DevicesDeviceCategoriesVarPopOrderBy = {
  device_category_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type DevicesDeviceCategoriesVarSampFields = {
  __typename?: 'devices__device_categories_var_samp_fields';
  device_category_id?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "devices__device_categories" */
export type DevicesDeviceCategoriesVarSampOrderBy = {
  device_category_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type DevicesDeviceCategoriesVarianceFields = {
  __typename?: 'devices__device_categories_variance_fields';
  device_category_id?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "devices__device_categories" */
export type DevicesDeviceCategoriesVarianceOrderBy = {
  device_category_id?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** columns and relationships of "devices__device_payloads" */
export type DevicesDevicePayloads = {
  __typename?: 'devices__device_payloads';
  /** An object relationship */
  device: Devices;
  device_id: Scalars['Int'];
  /** An object relationship */
  device_payload: DevicePayloads;
  device_payload_id: Scalars['Int'];
  id: Scalars['Int'];
};

/** aggregated selection of "devices__device_payloads" */
export type DevicesDevicePayloadsAggregate = {
  __typename?: 'devices__device_payloads_aggregate';
  aggregate?: Maybe<DevicesDevicePayloadsAggregateFields>;
  nodes: Array<DevicesDevicePayloads>;
};

export type DevicesDevicePayloadsAggregateBoolExp = {
  count?: InputMaybe<DevicesDevicePayloadsAggregateBoolExpCount>;
};

export type DevicesDevicePayloadsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<DevicesDevicePayloadsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DevicesDevicePayloadsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "devices__device_payloads" */
export type DevicesDevicePayloadsAggregateFields = {
  __typename?: 'devices__device_payloads_aggregate_fields';
  avg?: Maybe<DevicesDevicePayloadsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<DevicesDevicePayloadsMaxFields>;
  min?: Maybe<DevicesDevicePayloadsMinFields>;
  stddev?: Maybe<DevicesDevicePayloadsStddevFields>;
  stddev_pop?: Maybe<DevicesDevicePayloadsStddevPopFields>;
  stddev_samp?: Maybe<DevicesDevicePayloadsStddevSampFields>;
  sum?: Maybe<DevicesDevicePayloadsSumFields>;
  var_pop?: Maybe<DevicesDevicePayloadsVarPopFields>;
  var_samp?: Maybe<DevicesDevicePayloadsVarSampFields>;
  variance?: Maybe<DevicesDevicePayloadsVarianceFields>;
};


/** aggregate fields of "devices__device_payloads" */
export type DevicesDevicePayloadsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DevicesDevicePayloadsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "devices__device_payloads" */
export type DevicesDevicePayloadsAggregateOrderBy = {
  avg?: InputMaybe<DevicesDevicePayloadsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DevicesDevicePayloadsMaxOrderBy>;
  min?: InputMaybe<DevicesDevicePayloadsMinOrderBy>;
  stddev?: InputMaybe<DevicesDevicePayloadsStddevOrderBy>;
  stddev_pop?: InputMaybe<DevicesDevicePayloadsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<DevicesDevicePayloadsStddevSampOrderBy>;
  sum?: InputMaybe<DevicesDevicePayloadsSumOrderBy>;
  var_pop?: InputMaybe<DevicesDevicePayloadsVarPopOrderBy>;
  var_samp?: InputMaybe<DevicesDevicePayloadsVarSampOrderBy>;
  variance?: InputMaybe<DevicesDevicePayloadsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "devices__device_payloads" */
export type DevicesDevicePayloadsArrRelInsertInput = {
  data: Array<DevicesDevicePayloadsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<DevicesDevicePayloadsOnConflict>;
};

/** aggregate avg on columns */
export type DevicesDevicePayloadsAvgFields = {
  __typename?: 'devices__device_payloads_avg_fields';
  device_id?: Maybe<Scalars['Float']>;
  device_payload_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "devices__device_payloads" */
export type DevicesDevicePayloadsAvgOrderBy = {
  device_id?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "devices__device_payloads". All fields are combined with a logical 'AND'. */
export type DevicesDevicePayloadsBoolExp = {
  _and?: InputMaybe<Array<DevicesDevicePayloadsBoolExp>>;
  _not?: InputMaybe<DevicesDevicePayloadsBoolExp>;
  _or?: InputMaybe<Array<DevicesDevicePayloadsBoolExp>>;
  device?: InputMaybe<DevicesBoolExp>;
  device_id?: InputMaybe<IntComparisonExp>;
  device_payload?: InputMaybe<DevicePayloadsBoolExp>;
  device_payload_id?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "devices__device_payloads" */
export enum DevicesDevicePayloadsConstraint {
  /** unique or primary key constraint on columns "id" */
  DEVICES__DEVICE_PAYLOADS_PKEY = 'devices__device_payloads_pkey'
}

/** input type for incrementing numeric columns in table "devices__device_payloads" */
export type DevicesDevicePayloadsIncInput = {
  device_id?: InputMaybe<Scalars['Int']>;
  device_payload_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "devices__device_payloads" */
export type DevicesDevicePayloadsInsertInput = {
  device?: InputMaybe<DevicesObjRelInsertInput>;
  device_id?: InputMaybe<Scalars['Int']>;
  device_payload?: InputMaybe<DevicePayloadsObjRelInsertInput>;
  device_payload_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type DevicesDevicePayloadsMaxFields = {
  __typename?: 'devices__device_payloads_max_fields';
  device_id?: Maybe<Scalars['Int']>;
  device_payload_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "devices__device_payloads" */
export type DevicesDevicePayloadsMaxOrderBy = {
  device_id?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type DevicesDevicePayloadsMinFields = {
  __typename?: 'devices__device_payloads_min_fields';
  device_id?: Maybe<Scalars['Int']>;
  device_payload_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "devices__device_payloads" */
export type DevicesDevicePayloadsMinOrderBy = {
  device_id?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "devices__device_payloads" */
export type DevicesDevicePayloadsMutationResponse = {
  __typename?: 'devices__device_payloads_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DevicesDevicePayloads>;
};

/** on_conflict condition type for table "devices__device_payloads" */
export type DevicesDevicePayloadsOnConflict = {
  constraint: DevicesDevicePayloadsConstraint;
  update_columns?: Array<DevicesDevicePayloadsUpdateColumn>;
  where?: InputMaybe<DevicesDevicePayloadsBoolExp>;
};

/** Ordering options when selecting data from "devices__device_payloads". */
export type DevicesDevicePayloadsOrderBy = {
  device?: InputMaybe<DevicesOrderBy>;
  device_id?: InputMaybe<OrderBy>;
  device_payload?: InputMaybe<DevicePayloadsOrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: devices__device_payloads */
export type DevicesDevicePayloadsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "devices__device_payloads" */
export enum DevicesDevicePayloadsSelectColumn {
  /** column name */
  DEVICE_ID = 'device_id',
  /** column name */
  DEVICE_PAYLOAD_ID = 'device_payload_id',
  /** column name */
  ID = 'id'
}

/** input type for updating data in table "devices__device_payloads" */
export type DevicesDevicePayloadsSetInput = {
  device_id?: InputMaybe<Scalars['Int']>;
  device_payload_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type DevicesDevicePayloadsStddevFields = {
  __typename?: 'devices__device_payloads_stddev_fields';
  device_id?: Maybe<Scalars['Float']>;
  device_payload_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "devices__device_payloads" */
export type DevicesDevicePayloadsStddevOrderBy = {
  device_id?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type DevicesDevicePayloadsStddevPopFields = {
  __typename?: 'devices__device_payloads_stddev_pop_fields';
  device_id?: Maybe<Scalars['Float']>;
  device_payload_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "devices__device_payloads" */
export type DevicesDevicePayloadsStddevPopOrderBy = {
  device_id?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type DevicesDevicePayloadsStddevSampFields = {
  __typename?: 'devices__device_payloads_stddev_samp_fields';
  device_id?: Maybe<Scalars['Float']>;
  device_payload_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "devices__device_payloads" */
export type DevicesDevicePayloadsStddevSampOrderBy = {
  device_id?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "devices__device_payloads" */
export type DevicesDevicePayloadsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DevicesDevicePayloadsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DevicesDevicePayloadsStreamCursorValueInput = {
  device_id?: InputMaybe<Scalars['Int']>;
  device_payload_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type DevicesDevicePayloadsSumFields = {
  __typename?: 'devices__device_payloads_sum_fields';
  device_id?: Maybe<Scalars['Int']>;
  device_payload_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "devices__device_payloads" */
export type DevicesDevicePayloadsSumOrderBy = {
  device_id?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "devices__device_payloads" */
export enum DevicesDevicePayloadsUpdateColumn {
  /** column name */
  DEVICE_ID = 'device_id',
  /** column name */
  DEVICE_PAYLOAD_ID = 'device_payload_id',
  /** column name */
  ID = 'id'
}

export type DevicesDevicePayloadsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DevicesDevicePayloadsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DevicesDevicePayloadsSetInput>;
  /** filter the rows which have to be updated */
  where: DevicesDevicePayloadsBoolExp;
};

/** aggregate var_pop on columns */
export type DevicesDevicePayloadsVarPopFields = {
  __typename?: 'devices__device_payloads_var_pop_fields';
  device_id?: Maybe<Scalars['Float']>;
  device_payload_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "devices__device_payloads" */
export type DevicesDevicePayloadsVarPopOrderBy = {
  device_id?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type DevicesDevicePayloadsVarSampFields = {
  __typename?: 'devices__device_payloads_var_samp_fields';
  device_id?: Maybe<Scalars['Float']>;
  device_payload_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "devices__device_payloads" */
export type DevicesDevicePayloadsVarSampOrderBy = {
  device_id?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type DevicesDevicePayloadsVarianceFields = {
  __typename?: 'devices__device_payloads_variance_fields';
  device_id?: Maybe<Scalars['Float']>;
  device_payload_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "devices__device_payloads" */
export type DevicesDevicePayloadsVarianceOrderBy = {
  device_id?: InputMaybe<OrderBy>;
  device_payload_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregated selection of "devices" */
export type DevicesAggregate = {
  __typename?: 'devices_aggregate';
  aggregate?: Maybe<DevicesAggregateFields>;
  nodes: Array<Devices>;
};

export type DevicesAggregateBoolExp = {
  bool_and?: InputMaybe<DevicesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<DevicesAggregateBoolExpBoolOr>;
  count?: InputMaybe<DevicesAggregateBoolExpCount>;
};

export type DevicesAggregateBoolExpBoolAnd = {
  arguments: DevicesSelectColumnDevicesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DevicesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type DevicesAggregateBoolExpBoolOr = {
  arguments: DevicesSelectColumnDevicesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DevicesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type DevicesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<DevicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<DevicesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "devices" */
export type DevicesAggregateFields = {
  __typename?: 'devices_aggregate_fields';
  avg?: Maybe<DevicesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<DevicesMaxFields>;
  min?: Maybe<DevicesMinFields>;
  stddev?: Maybe<DevicesStddevFields>;
  stddev_pop?: Maybe<DevicesStddevPopFields>;
  stddev_samp?: Maybe<DevicesStddevSampFields>;
  sum?: Maybe<DevicesSumFields>;
  var_pop?: Maybe<DevicesVarPopFields>;
  var_samp?: Maybe<DevicesVarSampFields>;
  variance?: Maybe<DevicesVarianceFields>;
};


/** aggregate fields of "devices" */
export type DevicesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DevicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "devices" */
export type DevicesAggregateOrderBy = {
  avg?: InputMaybe<DevicesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DevicesMaxOrderBy>;
  min?: InputMaybe<DevicesMinOrderBy>;
  stddev?: InputMaybe<DevicesStddevOrderBy>;
  stddev_pop?: InputMaybe<DevicesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<DevicesStddevSampOrderBy>;
  sum?: InputMaybe<DevicesSumOrderBy>;
  var_pop?: InputMaybe<DevicesVarPopOrderBy>;
  var_samp?: InputMaybe<DevicesVarSampOrderBy>;
  variance?: InputMaybe<DevicesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "devices" */
export type DevicesArrRelInsertInput = {
  data: Array<DevicesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<DevicesOnConflict>;
};

/** aggregate avg on columns */
export type DevicesAvgFields = {
  __typename?: 'devices_avg_fields';
  application_id?: Maybe<Scalars['Float']>;
  area_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  uplink_interval?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "devices" */
export type DevicesAvgOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  area_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  uplink_interval?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "devices". All fields are combined with a logical 'AND'. */
export type DevicesBoolExp = {
  _and?: InputMaybe<Array<DevicesBoolExp>>;
  _not?: InputMaybe<DevicesBoolExp>;
  _or?: InputMaybe<Array<DevicesBoolExp>>;
  activationType?: InputMaybe<StringComparisonExp>;
  analysis_applications?: InputMaybe<AnalysisApplicationsDevicesBoolExp>;
  analysis_applications_aggregate?: InputMaybe<AnalysisApplicationsDevicesAggregateBoolExp>;
  application?: InputMaybe<ApplicationsBoolExp>;
  application_id?: InputMaybe<IntComparisonExp>;
  area?: InputMaybe<AreasBoolExp>;
  area_id?: InputMaybe<IntComparisonExp>;
  categories?: InputMaybe<DevicesDeviceCategoriesBoolExp>;
  categories_aggregate?: InputMaybe<DevicesDeviceCategoriesAggregateBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<IntComparisonExp>;
  dashboards?: InputMaybe<ApplicationsDashboardsDevicesBoolExp>;
  dashboards_aggregate?: InputMaybe<ApplicationsDashboardsDevicesAggregateBoolExp>;
  device_actions?: InputMaybe<DevicesDeviceActionsBoolExp>;
  device_actions_aggregate?: InputMaybe<DevicesDeviceActionsAggregateBoolExp>;
  device_class?: InputMaybe<StringComparisonExp>;
  device_payloads?: InputMaybe<DevicesDevicePayloadsBoolExp>;
  device_payloads_aggregate?: InputMaybe<DevicesDevicePayloadsAggregateBoolExp>;
  device_type?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  provider_id?: InputMaybe<StringComparisonExp>;
  resetFrames?: InputMaybe<BooleanComparisonExp>;
  scenes?: InputMaybe<ScenesDevicesBoolExp>;
  scenes_aggregate?: InputMaybe<ScenesDevicesAggregateBoolExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<IntComparisonExp>;
  uplink_interval?: InputMaybe<BigintComparisonExp>;
  visible?: InputMaybe<BooleanComparisonExp>;
};

/** unique or primary key constraints on table "devices" */
export enum DevicesConstraint {
  /** unique or primary key constraint on columns "id" */
  DEVICES_PKEY = 'devices_pkey',
  /** unique or primary key constraint on columns "provider_id" */
  DEVICES_PROVIDERID_UNIQUE = 'devices_providerId_unique'
}

/** input type for incrementing numeric columns in table "devices" */
export type DevicesIncInput = {
  application_id?: InputMaybe<Scalars['Int']>;
  area_id?: InputMaybe<Scalars['Int']>;
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  uplink_interval?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "devices" */
export type DevicesInsertInput = {
  activationType?: InputMaybe<Scalars['String']>;
  analysis_applications?: InputMaybe<AnalysisApplicationsDevicesArrRelInsertInput>;
  application?: InputMaybe<ApplicationsObjRelInsertInput>;
  application_id?: InputMaybe<Scalars['Int']>;
  area?: InputMaybe<AreasObjRelInsertInput>;
  area_id?: InputMaybe<Scalars['Int']>;
  categories?: InputMaybe<DevicesDeviceCategoriesArrRelInsertInput>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  dashboards?: InputMaybe<ApplicationsDashboardsDevicesArrRelInsertInput>;
  device_actions?: InputMaybe<DevicesDeviceActionsArrRelInsertInput>;
  device_class?: InputMaybe<Scalars['String']>;
  device_payloads?: InputMaybe<DevicesDevicePayloadsArrRelInsertInput>;
  device_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
  resetFrames?: InputMaybe<Scalars['Boolean']>;
  scenes?: InputMaybe<ScenesDevicesArrRelInsertInput>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  uplink_interval?: InputMaybe<Scalars['bigint']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type DevicesMaxFields = {
  __typename?: 'devices_max_fields';
  activationType?: Maybe<Scalars['String']>;
  application_id?: Maybe<Scalars['Int']>;
  area_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  device_class?: Maybe<Scalars['String']>;
  device_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
  uplink_interval?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "devices" */
export type DevicesMaxOrderBy = {
  activationType?: InputMaybe<OrderBy>;
  application_id?: InputMaybe<OrderBy>;
  area_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  device_class?: InputMaybe<OrderBy>;
  device_type?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  uplink_interval?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type DevicesMinFields = {
  __typename?: 'devices_min_fields';
  activationType?: Maybe<Scalars['String']>;
  application_id?: Maybe<Scalars['Int']>;
  area_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  device_class?: Maybe<Scalars['String']>;
  device_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
  uplink_interval?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "devices" */
export type DevicesMinOrderBy = {
  activationType?: InputMaybe<OrderBy>;
  application_id?: InputMaybe<OrderBy>;
  area_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  device_class?: InputMaybe<OrderBy>;
  device_type?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  uplink_interval?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "devices" */
export type DevicesMutationResponse = {
  __typename?: 'devices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Devices>;
};

/** input type for inserting object relation for remote table "devices" */
export type DevicesObjRelInsertInput = {
  data: DevicesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<DevicesOnConflict>;
};

/** on_conflict condition type for table "devices" */
export type DevicesOnConflict = {
  constraint: DevicesConstraint;
  update_columns?: Array<DevicesUpdateColumn>;
  where?: InputMaybe<DevicesBoolExp>;
};

/** Ordering options when selecting data from "devices". */
export type DevicesOrderBy = {
  activationType?: InputMaybe<OrderBy>;
  analysis_applications_aggregate?: InputMaybe<AnalysisApplicationsDevicesAggregateOrderBy>;
  application?: InputMaybe<ApplicationsOrderBy>;
  application_id?: InputMaybe<OrderBy>;
  area?: InputMaybe<AreasOrderBy>;
  area_id?: InputMaybe<OrderBy>;
  categories_aggregate?: InputMaybe<DevicesDeviceCategoriesAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  dashboards_aggregate?: InputMaybe<ApplicationsDashboardsDevicesAggregateOrderBy>;
  device_actions_aggregate?: InputMaybe<DevicesDeviceActionsAggregateOrderBy>;
  device_class?: InputMaybe<OrderBy>;
  device_payloads_aggregate?: InputMaybe<DevicesDevicePayloadsAggregateOrderBy>;
  device_type?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  provider_id?: InputMaybe<OrderBy>;
  resetFrames?: InputMaybe<OrderBy>;
  scenes_aggregate?: InputMaybe<ScenesDevicesAggregateOrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  uplink_interval?: InputMaybe<OrderBy>;
  visible?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: devices */
export type DevicesPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "devices" */
export enum DevicesSelectColumn {
  /** column name */
  ACTIVATIONTYPE = 'activationType',
  /** column name */
  APPLICATION_ID = 'application_id',
  /** column name */
  AREA_ID = 'area_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  DEVICE_CLASS = 'device_class',
  /** column name */
  DEVICE_TYPE = 'device_type',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  PROVIDER_ID = 'provider_id',
  /** column name */
  RESETFRAMES = 'resetFrames',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by',
  /** column name */
  UPLINK_INTERVAL = 'uplink_interval',
  /** column name */
  VISIBLE = 'visible'
}

/** select "devices_aggregate_bool_exp_bool_and_arguments_columns" columns of table "devices" */
export enum DevicesSelectColumnDevicesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  RESETFRAMES = 'resetFrames',
  /** column name */
  VISIBLE = 'visible'
}

/** select "devices_aggregate_bool_exp_bool_or_arguments_columns" columns of table "devices" */
export enum DevicesSelectColumnDevicesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  RESETFRAMES = 'resetFrames',
  /** column name */
  VISIBLE = 'visible'
}

/** input type for updating data in table "devices" */
export type DevicesSetInput = {
  activationType?: InputMaybe<Scalars['String']>;
  application_id?: InputMaybe<Scalars['Int']>;
  area_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  device_class?: InputMaybe<Scalars['String']>;
  device_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
  resetFrames?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  uplink_interval?: InputMaybe<Scalars['bigint']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type DevicesStddevFields = {
  __typename?: 'devices_stddev_fields';
  application_id?: Maybe<Scalars['Float']>;
  area_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  uplink_interval?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "devices" */
export type DevicesStddevOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  area_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  uplink_interval?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type DevicesStddevPopFields = {
  __typename?: 'devices_stddev_pop_fields';
  application_id?: Maybe<Scalars['Float']>;
  area_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  uplink_interval?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "devices" */
export type DevicesStddevPopOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  area_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  uplink_interval?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type DevicesStddevSampFields = {
  __typename?: 'devices_stddev_samp_fields';
  application_id?: Maybe<Scalars['Float']>;
  area_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  uplink_interval?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "devices" */
export type DevicesStddevSampOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  area_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  uplink_interval?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "devices" */
export type DevicesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DevicesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DevicesStreamCursorValueInput = {
  activationType?: InputMaybe<Scalars['String']>;
  application_id?: InputMaybe<Scalars['Int']>;
  area_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  device_class?: InputMaybe<Scalars['String']>;
  device_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
  resetFrames?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  uplink_interval?: InputMaybe<Scalars['bigint']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type DevicesSumFields = {
  __typename?: 'devices_sum_fields';
  application_id?: Maybe<Scalars['Int']>;
  area_id?: Maybe<Scalars['Int']>;
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['Int']>;
  uplink_interval?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "devices" */
export type DevicesSumOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  area_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  uplink_interval?: InputMaybe<OrderBy>;
};

/** update columns of table "devices" */
export enum DevicesUpdateColumn {
  /** column name */
  ACTIVATIONTYPE = 'activationType',
  /** column name */
  APPLICATION_ID = 'application_id',
  /** column name */
  AREA_ID = 'area_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  DEVICE_CLASS = 'device_class',
  /** column name */
  DEVICE_TYPE = 'device_type',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  PROVIDER_ID = 'provider_id',
  /** column name */
  RESETFRAMES = 'resetFrames',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by',
  /** column name */
  UPLINK_INTERVAL = 'uplink_interval',
  /** column name */
  VISIBLE = 'visible'
}

export type DevicesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DevicesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DevicesSetInput>;
  /** filter the rows which have to be updated */
  where: DevicesBoolExp;
};

/** aggregate var_pop on columns */
export type DevicesVarPopFields = {
  __typename?: 'devices_var_pop_fields';
  application_id?: Maybe<Scalars['Float']>;
  area_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  uplink_interval?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "devices" */
export type DevicesVarPopOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  area_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  uplink_interval?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type DevicesVarSampFields = {
  __typename?: 'devices_var_samp_fields';
  application_id?: Maybe<Scalars['Float']>;
  area_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  uplink_interval?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "devices" */
export type DevicesVarSampOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  area_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  uplink_interval?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type DevicesVarianceFields = {
  __typename?: 'devices_variance_fields';
  application_id?: Maybe<Scalars['Float']>;
  area_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  uplink_interval?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "devices" */
export type DevicesVarianceOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  area_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  uplink_interval?: InputMaybe<OrderBy>;
};

/** columns and relationships of "downlinks" */
export type Downlinks = {
  __typename?: 'downlinks';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  device_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  payload?: Maybe<Scalars['jsonb']>;
  sent_by?: Maybe<Scalars['String']>;
  sent_by_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "downlinks" */
export type DownlinksPayloadArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "downlinks" */
export type DownlinksAggregate = {
  __typename?: 'downlinks_aggregate';
  aggregate?: Maybe<DownlinksAggregateFields>;
  nodes: Array<Downlinks>;
};

/** aggregate fields of "downlinks" */
export type DownlinksAggregateFields = {
  __typename?: 'downlinks_aggregate_fields';
  avg?: Maybe<DownlinksAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<DownlinksMaxFields>;
  min?: Maybe<DownlinksMinFields>;
  stddev?: Maybe<DownlinksStddevFields>;
  stddev_pop?: Maybe<DownlinksStddevPopFields>;
  stddev_samp?: Maybe<DownlinksStddevSampFields>;
  sum?: Maybe<DownlinksSumFields>;
  var_pop?: Maybe<DownlinksVarPopFields>;
  var_samp?: Maybe<DownlinksVarSampFields>;
  variance?: Maybe<DownlinksVarianceFields>;
};


/** aggregate fields of "downlinks" */
export type DownlinksAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DownlinksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DownlinksAppendInput = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type DownlinksAvgFields = {
  __typename?: 'downlinks_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sent_by_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "downlinks". All fields are combined with a logical 'AND'. */
export type DownlinksBoolExp = {
  _and?: InputMaybe<Array<DownlinksBoolExp>>;
  _not?: InputMaybe<DownlinksBoolExp>;
  _or?: InputMaybe<Array<DownlinksBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<IntComparisonExp>;
  device_id?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  payload?: InputMaybe<JsonbComparisonExp>;
  sent_by?: InputMaybe<StringComparisonExp>;
  sent_by_id?: InputMaybe<IntComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "downlinks" */
export enum DownlinksConstraint {
  /** unique or primary key constraint on columns "id" */
  DOWNLINKS_PKEY = 'downlinks_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DownlinksDeleteAtPathInput = {
  payload?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DownlinksDeleteElemInput = {
  payload?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DownlinksDeleteKeyInput = {
  payload?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "downlinks" */
export type DownlinksIncInput = {
  created_by?: InputMaybe<Scalars['Int']>;
  device_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  sent_by_id?: InputMaybe<Scalars['Int']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "downlinks" */
export type DownlinksInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  device_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  sent_by?: InputMaybe<Scalars['String']>;
  sent_by_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type DownlinksMaxFields = {
  __typename?: 'downlinks_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  device_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  sent_by?: Maybe<Scalars['String']>;
  sent_by_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type DownlinksMinFields = {
  __typename?: 'downlinks_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  device_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  sent_by?: Maybe<Scalars['String']>;
  sent_by_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "downlinks" */
export type DownlinksMutationResponse = {
  __typename?: 'downlinks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Downlinks>;
};

/** input type for inserting object relation for remote table "downlinks" */
export type DownlinksObjRelInsertInput = {
  data: DownlinksInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<DownlinksOnConflict>;
};

/** on_conflict condition type for table "downlinks" */
export type DownlinksOnConflict = {
  constraint: DownlinksConstraint;
  update_columns?: Array<DownlinksUpdateColumn>;
  where?: InputMaybe<DownlinksBoolExp>;
};

/** Ordering options when selecting data from "downlinks". */
export type DownlinksOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  payload?: InputMaybe<OrderBy>;
  sent_by?: InputMaybe<OrderBy>;
  sent_by_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: downlinks */
export type DownlinksPkColumnsInput = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DownlinksPrependInput = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "downlinks" */
export enum DownlinksSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  DEVICE_ID = 'device_id',
  /** column name */
  ID = 'id',
  /** column name */
  PAYLOAD = 'payload',
  /** column name */
  SENT_BY = 'sent_by',
  /** column name */
  SENT_BY_ID = 'sent_by_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by'
}

/** input type for updating data in table "downlinks" */
export type DownlinksSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  device_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  sent_by?: InputMaybe<Scalars['String']>;
  sent_by_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type DownlinksStddevFields = {
  __typename?: 'downlinks_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sent_by_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type DownlinksStddevPopFields = {
  __typename?: 'downlinks_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sent_by_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type DownlinksStddevSampFields = {
  __typename?: 'downlinks_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sent_by_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "downlinks" */
export type DownlinksStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DownlinksStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DownlinksStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  device_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  sent_by?: InputMaybe<Scalars['String']>;
  sent_by_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type DownlinksSumFields = {
  __typename?: 'downlinks_sum_fields';
  created_by?: Maybe<Scalars['Int']>;
  device_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  sent_by_id?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** update columns of table "downlinks" */
export enum DownlinksUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  DEVICE_ID = 'device_id',
  /** column name */
  ID = 'id',
  /** column name */
  PAYLOAD = 'payload',
  /** column name */
  SENT_BY = 'sent_by',
  /** column name */
  SENT_BY_ID = 'sent_by_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by'
}

export type DownlinksUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<DownlinksAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<DownlinksDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<DownlinksDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<DownlinksDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DownlinksIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<DownlinksPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DownlinksSetInput>;
  /** filter the rows which have to be updated */
  where: DownlinksBoolExp;
};

/** aggregate var_pop on columns */
export type DownlinksVarPopFields = {
  __typename?: 'downlinks_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sent_by_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type DownlinksVarSampFields = {
  __typename?: 'downlinks_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sent_by_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type DownlinksVarianceFields = {
  __typename?: 'downlinks_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sent_by_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** farming containers enum */
export type FarmingContainers = {
  __typename?: 'farming_containers';
  comment: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "farming_containers" */
export type FarmingContainersAggregate = {
  __typename?: 'farming_containers_aggregate';
  aggregate?: Maybe<FarmingContainersAggregateFields>;
  nodes: Array<FarmingContainers>;
};

/** aggregate fields of "farming_containers" */
export type FarmingContainersAggregateFields = {
  __typename?: 'farming_containers_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<FarmingContainersMaxFields>;
  min?: Maybe<FarmingContainersMinFields>;
};


/** aggregate fields of "farming_containers" */
export type FarmingContainersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<FarmingContainersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "farming_containers". All fields are combined with a logical 'AND'. */
export type FarmingContainersBoolExp = {
  _and?: InputMaybe<Array<FarmingContainersBoolExp>>;
  _not?: InputMaybe<FarmingContainersBoolExp>;
  _or?: InputMaybe<Array<FarmingContainersBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "farming_containers" */
export enum FarmingContainersConstraint {
  /** unique or primary key constraint on columns "value" */
  CONTAINERS_PKEY = 'containers_pkey'
}

export enum FarmingContainersEnum {
  /** grow bag container */
  GROW_BAG = 'GROW_BAG',
  /** pot container */
  POT = 'POT'
}

/** Boolean expression to compare columns of type "farming_containers_enum". All fields are combined with logical 'AND'. */
export type FarmingContainersEnumComparisonExp = {
  _eq?: InputMaybe<FarmingContainersEnum>;
  _in?: InputMaybe<Array<FarmingContainersEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<FarmingContainersEnum>;
  _nin?: InputMaybe<Array<FarmingContainersEnum>>;
};

/** input type for inserting data into table "farming_containers" */
export type FarmingContainersInsertInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type FarmingContainersMaxFields = {
  __typename?: 'farming_containers_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type FarmingContainersMinFields = {
  __typename?: 'farming_containers_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "farming_containers" */
export type FarmingContainersMutationResponse = {
  __typename?: 'farming_containers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FarmingContainers>;
};

/** on_conflict condition type for table "farming_containers" */
export type FarmingContainersOnConflict = {
  constraint: FarmingContainersConstraint;
  update_columns?: Array<FarmingContainersUpdateColumn>;
  where?: InputMaybe<FarmingContainersBoolExp>;
};

/** Ordering options when selecting data from "farming_containers". */
export type FarmingContainersOrderBy = {
  comment?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: farming_containers */
export type FarmingContainersPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "farming_containers" */
export enum FarmingContainersSelectColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  VALUE = 'value'
}

/** input type for updating data in table "farming_containers" */
export type FarmingContainersSetInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "farming_containers" */
export type FarmingContainersStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FarmingContainersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FarmingContainersStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "farming_containers" */
export enum FarmingContainersUpdateColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  VALUE = 'value'
}

export type FarmingContainersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FarmingContainersSetInput>;
  /** filter the rows which have to be updated */
  where: FarmingContainersBoolExp;
};

/** Farming methods enum */
export type FarmingMethods = {
  __typename?: 'farming_methods';
  comment: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "farming_methods" */
export type FarmingMethodsAggregate = {
  __typename?: 'farming_methods_aggregate';
  aggregate?: Maybe<FarmingMethodsAggregateFields>;
  nodes: Array<FarmingMethods>;
};

/** aggregate fields of "farming_methods" */
export type FarmingMethodsAggregateFields = {
  __typename?: 'farming_methods_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<FarmingMethodsMaxFields>;
  min?: Maybe<FarmingMethodsMinFields>;
};


/** aggregate fields of "farming_methods" */
export type FarmingMethodsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<FarmingMethodsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "farming_methods". All fields are combined with a logical 'AND'. */
export type FarmingMethodsBoolExp = {
  _and?: InputMaybe<Array<FarmingMethodsBoolExp>>;
  _not?: InputMaybe<FarmingMethodsBoolExp>;
  _or?: InputMaybe<Array<FarmingMethodsBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "farming_methods" */
export enum FarmingMethodsConstraint {
  /** unique or primary key constraint on columns "value" */
  FARMING_METHODS_PKEY = 'farming_methods_pkey'
}

export enum FarmingMethodsEnum {
  /** Suolo */
  SOIL = 'SOIL',
  /** Fuori suolo */
  SOILLESS = 'SOILLESS'
}

/** Boolean expression to compare columns of type "farming_methods_enum". All fields are combined with logical 'AND'. */
export type FarmingMethodsEnumComparisonExp = {
  _eq?: InputMaybe<FarmingMethodsEnum>;
  _in?: InputMaybe<Array<FarmingMethodsEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<FarmingMethodsEnum>;
  _nin?: InputMaybe<Array<FarmingMethodsEnum>>;
};

/** input type for inserting data into table "farming_methods" */
export type FarmingMethodsInsertInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type FarmingMethodsMaxFields = {
  __typename?: 'farming_methods_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type FarmingMethodsMinFields = {
  __typename?: 'farming_methods_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "farming_methods" */
export type FarmingMethodsMutationResponse = {
  __typename?: 'farming_methods_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FarmingMethods>;
};

/** on_conflict condition type for table "farming_methods" */
export type FarmingMethodsOnConflict = {
  constraint: FarmingMethodsConstraint;
  update_columns?: Array<FarmingMethodsUpdateColumn>;
  where?: InputMaybe<FarmingMethodsBoolExp>;
};

/** Ordering options when selecting data from "farming_methods". */
export type FarmingMethodsOrderBy = {
  comment?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: farming_methods */
export type FarmingMethodsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "farming_methods" */
export enum FarmingMethodsSelectColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  VALUE = 'value'
}

/** input type for updating data in table "farming_methods" */
export type FarmingMethodsSetInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "farming_methods" */
export type FarmingMethodsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FarmingMethodsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FarmingMethodsStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "farming_methods" */
export enum FarmingMethodsUpdateColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  VALUE = 'value'
}

export type FarmingMethodsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FarmingMethodsSetInput>;
  /** filter the rows which have to be updated */
  where: FarmingMethodsBoolExp;
};

/** Farming structures enum */
export type FarmingStructures = {
  __typename?: 'farming_structures';
  comment: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "farming_structures" */
export type FarmingStructuresAggregate = {
  __typename?: 'farming_structures_aggregate';
  aggregate?: Maybe<FarmingStructuresAggregateFields>;
  nodes: Array<FarmingStructures>;
};

/** aggregate fields of "farming_structures" */
export type FarmingStructuresAggregateFields = {
  __typename?: 'farming_structures_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<FarmingStructuresMaxFields>;
  min?: Maybe<FarmingStructuresMinFields>;
};


/** aggregate fields of "farming_structures" */
export type FarmingStructuresAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<FarmingStructuresSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "farming_structures". All fields are combined with a logical 'AND'. */
export type FarmingStructuresBoolExp = {
  _and?: InputMaybe<Array<FarmingStructuresBoolExp>>;
  _not?: InputMaybe<FarmingStructuresBoolExp>;
  _or?: InputMaybe<Array<FarmingStructuresBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "farming_structures" */
export enum FarmingStructuresConstraint {
  /** unique or primary key constraint on columns "value" */
  FARMING_STRUCTURES_PKEY = 'farming_structures_pkey'
}

export enum FarmingStructuresEnum {
  /** Greenhouse structure */
  GREENHOUSE = 'GREENHOUSE',
  /** Open field structure */
  OPEN_FIELD = 'OPEN_FIELD',
  /** Tunnel structure */
  TUNNEL = 'TUNNEL'
}

/** Boolean expression to compare columns of type "farming_structures_enum". All fields are combined with logical 'AND'. */
export type FarmingStructuresEnumComparisonExp = {
  _eq?: InputMaybe<FarmingStructuresEnum>;
  _in?: InputMaybe<Array<FarmingStructuresEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<FarmingStructuresEnum>;
  _nin?: InputMaybe<Array<FarmingStructuresEnum>>;
};

/** input type for inserting data into table "farming_structures" */
export type FarmingStructuresInsertInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type FarmingStructuresMaxFields = {
  __typename?: 'farming_structures_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type FarmingStructuresMinFields = {
  __typename?: 'farming_structures_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "farming_structures" */
export type FarmingStructuresMutationResponse = {
  __typename?: 'farming_structures_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<FarmingStructures>;
};

/** on_conflict condition type for table "farming_structures" */
export type FarmingStructuresOnConflict = {
  constraint: FarmingStructuresConstraint;
  update_columns?: Array<FarmingStructuresUpdateColumn>;
  where?: InputMaybe<FarmingStructuresBoolExp>;
};

/** Ordering options when selecting data from "farming_structures". */
export type FarmingStructuresOrderBy = {
  comment?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: farming_structures */
export type FarmingStructuresPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "farming_structures" */
export enum FarmingStructuresSelectColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  VALUE = 'value'
}

/** input type for updating data in table "farming_structures" */
export type FarmingStructuresSetInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "farming_structures" */
export type FarmingStructuresStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FarmingStructuresStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FarmingStructuresStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "farming_structures" */
export enum FarmingStructuresUpdateColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  VALUE = 'value'
}

export type FarmingStructuresUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FarmingStructuresSetInput>;
  /** filter the rows which have to be updated */
  where: FarmingStructuresBoolExp;
};

export type HygraphMutation = {
  __typename?: 'hygraphMutation';
  /** Create an asset. Use the returned info to finish the creation process by uploading the asset. */
  createAsset?: Maybe<Asset>;
  /** Create one author */
  createAuthor?: Maybe<Author>;
  /** Create one messagesCollection */
  createMessagesCollection?: Maybe<MessagesCollection>;
  /** Create one releasesCollection */
  createReleasesCollection?: Maybe<ReleasesCollection>;
  /** Create one scheduledRelease */
  createScheduledRelease?: Maybe<ScheduledRelease>;
  /** Delete one asset from _all_ existing stages. Returns deleted document. */
  deleteAsset?: Maybe<Asset>;
  /** Delete one author from _all_ existing stages. Returns deleted document. */
  deleteAuthor?: Maybe<Author>;
  /** Delete many Asset documents */
  deleteManyAssets: BatchPayload;
  /** Delete many Asset documents, return deleted documents */
  deleteManyAssetsConnection: AssetConnection;
  /** Delete many Author documents */
  deleteManyAuthors: BatchPayload;
  /** Delete many Author documents, return deleted documents */
  deleteManyAuthorsConnection: AuthorConnection;
  /** Delete many MessagesCollection documents */
  deleteManyMessagesCollections: BatchPayload;
  /** Delete many MessagesCollection documents, return deleted documents */
  deleteManyMessagesCollectionsConnection: MessagesCollectionConnection;
  /** Delete many ReleasesCollection documents */
  deleteManyReleasesCollections: BatchPayload;
  /** Delete many ReleasesCollection documents, return deleted documents */
  deleteManyReleasesCollectionsConnection: ReleasesCollectionConnection;
  /** Delete one messagesCollection from _all_ existing stages. Returns deleted document. */
  deleteMessagesCollection?: Maybe<MessagesCollection>;
  /** Delete one releasesCollection from _all_ existing stages. Returns deleted document. */
  deleteReleasesCollection?: Maybe<ReleasesCollection>;
  /** Delete and return scheduled operation */
  deleteScheduledOperation?: Maybe<ScheduledOperation>;
  /** Delete one scheduledRelease from _all_ existing stages. Returns deleted document. */
  deleteScheduledRelease?: Maybe<ScheduledRelease>;
  /** Publish one asset */
  publishAsset?: Maybe<Asset>;
  /** Publish one author */
  publishAuthor?: Maybe<Author>;
  /** Publish many Asset documents */
  publishManyAssets: BatchPayload;
  /** Publish many Asset documents */
  publishManyAssetsConnection: AssetConnection;
  /** Publish many Author documents */
  publishManyAuthors: BatchPayload;
  /** Publish many Author documents */
  publishManyAuthorsConnection: AuthorConnection;
  /** Publish many MessagesCollection documents */
  publishManyMessagesCollections: BatchPayload;
  /** Publish many MessagesCollection documents */
  publishManyMessagesCollectionsConnection: MessagesCollectionConnection;
  /** Publish many ReleasesCollection documents */
  publishManyReleasesCollections: BatchPayload;
  /** Publish many ReleasesCollection documents */
  publishManyReleasesCollectionsConnection: ReleasesCollectionConnection;
  /** Publish one messagesCollection */
  publishMessagesCollection?: Maybe<MessagesCollection>;
  /** Publish one releasesCollection */
  publishReleasesCollection?: Maybe<ReleasesCollection>;
  /** Schedule to publish one asset */
  schedulePublishAsset?: Maybe<Asset>;
  /** Schedule to publish one author */
  schedulePublishAuthor?: Maybe<Author>;
  /** Schedule to publish one messagesCollection */
  schedulePublishMessagesCollection?: Maybe<MessagesCollection>;
  /** Schedule to publish one releasesCollection */
  schedulePublishReleasesCollection?: Maybe<ReleasesCollection>;
  /** Unpublish one asset from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAsset?: Maybe<Asset>;
  /** Unpublish one author from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAuthor?: Maybe<Author>;
  /** Unpublish one messagesCollection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishMessagesCollection?: Maybe<MessagesCollection>;
  /** Unpublish one releasesCollection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishReleasesCollection?: Maybe<ReleasesCollection>;
  /** Unpublish one asset from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAsset?: Maybe<Asset>;
  /** Unpublish one author from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAuthor?: Maybe<Author>;
  /** Unpublish many Asset documents */
  unpublishManyAssets: BatchPayload;
  /** Find many Asset documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAssetsConnection: AssetConnection;
  /** Unpublish many Author documents */
  unpublishManyAuthors: BatchPayload;
  /** Find many Author documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAuthorsConnection: AuthorConnection;
  /** Unpublish many MessagesCollection documents */
  unpublishManyMessagesCollections: BatchPayload;
  /** Find many MessagesCollection documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyMessagesCollectionsConnection: MessagesCollectionConnection;
  /** Unpublish many ReleasesCollection documents */
  unpublishManyReleasesCollections: BatchPayload;
  /** Find many ReleasesCollection documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyReleasesCollectionsConnection: ReleasesCollectionConnection;
  /** Unpublish one messagesCollection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishMessagesCollection?: Maybe<MessagesCollection>;
  /** Unpublish one releasesCollection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishReleasesCollection?: Maybe<ReleasesCollection>;
  /** Update one asset */
  updateAsset?: Maybe<Asset>;
  /** Update one author */
  updateAuthor?: Maybe<Author>;
  /** Update many assets */
  updateManyAssets: BatchPayload;
  /** Update many Asset documents */
  updateManyAssetsConnection: AssetConnection;
  /** Update many authors */
  updateManyAuthors: BatchPayload;
  /** Update many Author documents */
  updateManyAuthorsConnection: AuthorConnection;
  /** Update many messagesCollections */
  updateManyMessagesCollections: BatchPayload;
  /** Update many MessagesCollection documents */
  updateManyMessagesCollectionsConnection: MessagesCollectionConnection;
  /** Update many releasesCollections */
  updateManyReleasesCollections: BatchPayload;
  /** Update many ReleasesCollection documents */
  updateManyReleasesCollectionsConnection: ReleasesCollectionConnection;
  /** Update one messagesCollection */
  updateMessagesCollection?: Maybe<MessagesCollection>;
  /** Update one releasesCollection */
  updateReleasesCollection?: Maybe<ReleasesCollection>;
  /** Update one scheduledRelease */
  updateScheduledRelease?: Maybe<ScheduledRelease>;
  /** Upsert one asset */
  upsertAsset?: Maybe<Asset>;
  /** Upsert one author */
  upsertAuthor?: Maybe<Author>;
  /** Upsert one messagesCollection */
  upsertMessagesCollection?: Maybe<MessagesCollection>;
  /** Upsert one releasesCollection */
  upsertReleasesCollection?: Maybe<ReleasesCollection>;
};


export type HygraphMutationCreateAssetArgs = {
  data: AssetCreateInput;
};


export type HygraphMutationCreateAuthorArgs = {
  data: AuthorCreateInput;
};


export type HygraphMutationCreateMessagesCollectionArgs = {
  data: MessagesCollectionCreateInput;
};


export type HygraphMutationCreateReleasesCollectionArgs = {
  data: ReleasesCollectionCreateInput;
};


export type HygraphMutationCreateScheduledReleaseArgs = {
  data: ScheduledReleaseCreateInput;
};


export type HygraphMutationDeleteAssetArgs = {
  where: AssetWhereUniqueInput;
};


export type HygraphMutationDeleteAuthorArgs = {
  where: AuthorWhereUniqueInput;
};


export type HygraphMutationDeleteManyAssetsArgs = {
  where?: InputMaybe<AssetManyWhereInput>;
};


export type HygraphMutationDeleteManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type HygraphMutationDeleteManyAuthorsArgs = {
  where?: InputMaybe<AuthorManyWhereInput>;
};


export type HygraphMutationDeleteManyAuthorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AuthorManyWhereInput>;
};


export type HygraphMutationDeleteManyMessagesCollectionsArgs = {
  where?: InputMaybe<MessagesCollectionManyWhereInput>;
};


export type HygraphMutationDeleteManyMessagesCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MessagesCollectionManyWhereInput>;
};


export type HygraphMutationDeleteManyReleasesCollectionsArgs = {
  where?: InputMaybe<ReleasesCollectionManyWhereInput>;
};


export type HygraphMutationDeleteManyReleasesCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ReleasesCollectionManyWhereInput>;
};


export type HygraphMutationDeleteMessagesCollectionArgs = {
  where: MessagesCollectionWhereUniqueInput;
};


export type HygraphMutationDeleteReleasesCollectionArgs = {
  where: ReleasesCollectionWhereUniqueInput;
};


export type HygraphMutationDeleteScheduledOperationArgs = {
  where: ScheduledOperationWhereUniqueInput;
};


export type HygraphMutationDeleteScheduledReleaseArgs = {
  where: ScheduledReleaseWhereUniqueInput;
};


export type HygraphMutationPublishAssetArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where: AssetWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type HygraphMutationPublishAuthorArgs = {
  to?: Array<Stage>;
  where: AuthorWhereUniqueInput;
};


export type HygraphMutationPublishManyAssetsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where?: InputMaybe<AssetManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type HygraphMutationPublishManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<AssetManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type HygraphMutationPublishManyAuthorsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<AuthorManyWhereInput>;
};


export type HygraphMutationPublishManyAuthorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<AuthorManyWhereInput>;
};


export type HygraphMutationPublishManyMessagesCollectionsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where?: InputMaybe<MessagesCollectionManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type HygraphMutationPublishManyMessagesCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<MessagesCollectionManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type HygraphMutationPublishManyReleasesCollectionsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where?: InputMaybe<ReleasesCollectionManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type HygraphMutationPublishManyReleasesCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<ReleasesCollectionManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type HygraphMutationPublishMessagesCollectionArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where: MessagesCollectionWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type HygraphMutationPublishReleasesCollectionArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where: ReleasesCollectionWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type HygraphMutationSchedulePublishAssetArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: AssetWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type HygraphMutationSchedulePublishAuthorArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: AuthorWhereUniqueInput;
};


export type HygraphMutationSchedulePublishMessagesCollectionArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: MessagesCollectionWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type HygraphMutationSchedulePublishReleasesCollectionArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: ReleasesCollectionWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


export type HygraphMutationScheduleUnpublishAssetArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: AssetWhereUniqueInput;
};


export type HygraphMutationScheduleUnpublishAuthorArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: AuthorWhereUniqueInput;
};


export type HygraphMutationScheduleUnpublishMessagesCollectionArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: MessagesCollectionWhereUniqueInput;
};


export type HygraphMutationScheduleUnpublishReleasesCollectionArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: ReleasesCollectionWhereUniqueInput;
};


export type HygraphMutationUnpublishAssetArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: AssetWhereUniqueInput;
};


export type HygraphMutationUnpublishAuthorArgs = {
  from?: Array<Stage>;
  where: AuthorWhereUniqueInput;
};


export type HygraphMutationUnpublishManyAssetsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type HygraphMutationUnpublishManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type HygraphMutationUnpublishManyAuthorsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<AuthorManyWhereInput>;
};


export type HygraphMutationUnpublishManyAuthorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<AuthorManyWhereInput>;
};


export type HygraphMutationUnpublishManyMessagesCollectionsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<MessagesCollectionManyWhereInput>;
};


export type HygraphMutationUnpublishManyMessagesCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<MessagesCollectionManyWhereInput>;
};


export type HygraphMutationUnpublishManyReleasesCollectionsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ReleasesCollectionManyWhereInput>;
};


export type HygraphMutationUnpublishManyReleasesCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ReleasesCollectionManyWhereInput>;
};


export type HygraphMutationUnpublishMessagesCollectionArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: MessagesCollectionWhereUniqueInput;
};


export type HygraphMutationUnpublishReleasesCollectionArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: ReleasesCollectionWhereUniqueInput;
};


export type HygraphMutationUpdateAssetArgs = {
  data: AssetUpdateInput;
  where: AssetWhereUniqueInput;
};


export type HygraphMutationUpdateAuthorArgs = {
  data: AuthorUpdateInput;
  where: AuthorWhereUniqueInput;
};


export type HygraphMutationUpdateManyAssetsArgs = {
  data: AssetUpdateManyInput;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type HygraphMutationUpdateManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: AssetUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type HygraphMutationUpdateManyAuthorsArgs = {
  data: AuthorUpdateManyInput;
  where?: InputMaybe<AuthorManyWhereInput>;
};


export type HygraphMutationUpdateManyAuthorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: AuthorUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AuthorManyWhereInput>;
};


export type HygraphMutationUpdateManyMessagesCollectionsArgs = {
  data: MessagesCollectionUpdateManyInput;
  where?: InputMaybe<MessagesCollectionManyWhereInput>;
};


export type HygraphMutationUpdateManyMessagesCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: MessagesCollectionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MessagesCollectionManyWhereInput>;
};


export type HygraphMutationUpdateManyReleasesCollectionsArgs = {
  data: ReleasesCollectionUpdateManyInput;
  where?: InputMaybe<ReleasesCollectionManyWhereInput>;
};


export type HygraphMutationUpdateManyReleasesCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: ReleasesCollectionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ReleasesCollectionManyWhereInput>;
};


export type HygraphMutationUpdateMessagesCollectionArgs = {
  data: MessagesCollectionUpdateInput;
  where: MessagesCollectionWhereUniqueInput;
};


export type HygraphMutationUpdateReleasesCollectionArgs = {
  data: ReleasesCollectionUpdateInput;
  where: ReleasesCollectionWhereUniqueInput;
};


export type HygraphMutationUpdateScheduledReleaseArgs = {
  data: ScheduledReleaseUpdateInput;
  where: ScheduledReleaseWhereUniqueInput;
};


export type HygraphMutationUpsertAssetArgs = {
  upsert: AssetUpsertInput;
  where: AssetWhereUniqueInput;
};


export type HygraphMutationUpsertAuthorArgs = {
  upsert: AuthorUpsertInput;
  where: AuthorWhereUniqueInput;
};


export type HygraphMutationUpsertMessagesCollectionArgs = {
  upsert: MessagesCollectionUpsertInput;
  where: MessagesCollectionWhereUniqueInput;
};


export type HygraphMutationUpsertReleasesCollectionArgs = {
  upsert: ReleasesCollectionUpsertInput;
  where: ReleasesCollectionWhereUniqueInput;
};

export type HygraphQuery = {
  __typename?: 'hygraphQuery';
  /** Retrieve a single asset */
  asset?: Maybe<Asset>;
  /** Retrieve document version */
  assetVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple assets */
  assets: Array<Asset>;
  /** Retrieve multiple assets using the Relay connection interface */
  assetsConnection: AssetConnection;
  /** Retrieve a single author */
  author?: Maybe<Author>;
  /** Retrieve document version */
  authorVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple authors */
  authors: Array<Author>;
  /** Retrieve multiple authors using the Relay connection interface */
  authorsConnection: AuthorConnection;
  /** Fetches an object given its ID */
  entities?: Maybe<Array<Entity>>;
  /** Retrieve a single messagesCollection */
  messagesCollection?: Maybe<MessagesCollection>;
  /** Retrieve document version */
  messagesCollectionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple messagesCollections */
  messagesCollections: Array<MessagesCollection>;
  /** Retrieve multiple messagesCollections using the Relay connection interface */
  messagesCollectionsConnection: MessagesCollectionConnection;
  /** Fetches an object given its ID */
  node?: Maybe<Node>;
  /** Retrieve a single releasesCollection */
  releasesCollection?: Maybe<ReleasesCollection>;
  /** Retrieve document version */
  releasesCollectionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple releasesCollections */
  releasesCollections: Array<ReleasesCollection>;
  /** Retrieve multiple releasesCollections using the Relay connection interface */
  releasesCollectionsConnection: ReleasesCollectionConnection;
  /** Retrieve a single scheduledOperation */
  scheduledOperation?: Maybe<ScheduledOperation>;
  /** Retrieve multiple scheduledOperations */
  scheduledOperations: Array<ScheduledOperation>;
  /** Retrieve multiple scheduledOperations using the Relay connection interface */
  scheduledOperationsConnection: ScheduledOperationConnection;
  /** Retrieve a single scheduledRelease */
  scheduledRelease?: Maybe<ScheduledRelease>;
  /** Retrieve multiple scheduledReleases */
  scheduledReleases: Array<ScheduledRelease>;
  /** Retrieve multiple scheduledReleases using the Relay connection interface */
  scheduledReleasesConnection: ScheduledReleaseConnection;
  /** Retrieve a single user */
  user?: Maybe<User>;
  /** Retrieve multiple users */
  users: Array<User>;
  /** Retrieve multiple users using the Relay connection interface */
  usersConnection: UserConnection;
};


export type HygraphQueryAssetArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AssetWhereUniqueInput;
};


export type HygraphQueryAssetVersionArgs = {
  where: VersionWhereInput;
};


export type HygraphQueryAssetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<AssetWhereInput>;
};


export type HygraphQueryAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<AssetWhereInput>;
};


export type HygraphQueryAuthorArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AuthorWhereUniqueInput;
};


export type HygraphQueryAuthorVersionArgs = {
  where: VersionWhereInput;
};


export type HygraphQueryAuthorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AuthorOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<AuthorWhereInput>;
};


export type HygraphQueryAuthorsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AuthorOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<AuthorWhereInput>;
};


export type HygraphQueryEntitiesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  where: Array<EntityWhereInput>;
};


export type HygraphQueryMessagesCollectionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: MessagesCollectionWhereUniqueInput;
};


export type HygraphQueryMessagesCollectionVersionArgs = {
  where: VersionWhereInput;
};


export type HygraphQueryMessagesCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<MessagesCollectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<MessagesCollectionWhereInput>;
};


export type HygraphQueryMessagesCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<MessagesCollectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<MessagesCollectionWhereInput>;
};


export type HygraphQueryNodeArgs = {
  id: Scalars['ID'];
  locales?: Array<Locale>;
  stage?: Stage;
};


export type HygraphQueryReleasesCollectionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ReleasesCollectionWhereUniqueInput;
};


export type HygraphQueryReleasesCollectionVersionArgs = {
  where: VersionWhereInput;
};


export type HygraphQueryReleasesCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ReleasesCollectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<ReleasesCollectionWhereInput>;
};


export type HygraphQueryReleasesCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ReleasesCollectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<ReleasesCollectionWhereInput>;
};


export type HygraphQueryScheduledOperationArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ScheduledOperationWhereUniqueInput;
};


export type HygraphQueryScheduledOperationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type HygraphQueryScheduledOperationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type HygraphQueryScheduledReleaseArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ScheduledReleaseWhereUniqueInput;
};


export type HygraphQueryScheduledReleasesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledReleaseWhereInput>;
};


export type HygraphQueryScheduledReleasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledReleaseWhereInput>;
};


export type HygraphQueryUserArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: UserWhereUniqueInput;
};


export type HygraphQueryUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<UserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<UserWhereInput>;
};


export type HygraphQueryUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<UserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<UserWhereInput>;
};

export type JsonbCastExp = {
  String?: InputMaybe<StringComparisonExp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type JsonbComparisonExp = {
  _cast?: InputMaybe<JsonbCastExp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

export type LastComputedValueAnalysisApplicationsComputedArgs = {
  key?: InputMaybe<Scalars['String']>;
  kind?: InputMaybe<Scalars['String']>;
};

/** mutation root */
export type MutationRoot = {
  __typename?: 'mutation_root';
  /** Create an analysis application with payloads validation */
  analysis_application_create?: Maybe<AnalysisApplicationCreateOutput>;
  /** Update an analysis application with payloads validation */
  analysis_application_update?: Maybe<AnalysisApplicationUpdateOutput>;
  /** Create an area with validation */
  area_create?: Maybe<AreaCreateOutput>;
  /** Update area */
  area_update?: Maybe<AreaUpdateOutput>;
  /** Duplicate an automation passing a previously created automation id */
  automation_duplicate: AutomationDuplicateOutput;
  /** Create sso canny login */
  canny_login_create?: Maybe<CannyLoginCreateOutput>;
  /** delete data from the table: "analysis" */
  delete_analysis?: Maybe<AnalysisMutationResponse>;
  /** delete data from the table: "analysis__devices_payloads" */
  delete_analysis__devices_payloads?: Maybe<AnalysisDevicesPayloadsMutationResponse>;
  /** delete single row from the table: "analysis__devices_payloads" */
  delete_analysis__devices_payloads_by_pk?: Maybe<AnalysisDevicesPayloads>;
  /** delete data from the table: "analysis_applications" */
  delete_analysis_applications?: Maybe<AnalysisApplicationsMutationResponse>;
  /** delete data from the table: "analysis_applications__devices" */
  delete_analysis_applications__devices?: Maybe<AnalysisApplicationsDevicesMutationResponse>;
  /** delete single row from the table: "analysis_applications__devices" */
  delete_analysis_applications__devices_by_pk?: Maybe<AnalysisApplicationsDevices>;
  /** delete single row from the table: "analysis_applications" */
  delete_analysis_applications_by_pk?: Maybe<AnalysisApplications>;
  /** delete data from the table: "analysis_applications_computed" */
  delete_analysis_applications_computed?: Maybe<AnalysisApplicationsComputedMutationResponse>;
  /** delete single row from the table: "analysis_applications_computed" */
  delete_analysis_applications_computed_by_pk?: Maybe<AnalysisApplicationsComputed>;
  /** delete data from the table: "analysis_applications_computed_values" */
  delete_analysis_applications_computed_values?: Maybe<AnalysisApplicationsComputedValuesMutationResponse>;
  /** delete single row from the table: "analysis_applications_computed_values" */
  delete_analysis_applications_computed_values_by_pk?: Maybe<AnalysisApplicationsComputedValues>;
  /** delete data from the table: "analysis_applications_computed_values_kinds" */
  delete_analysis_applications_computed_values_kinds?: Maybe<AnalysisApplicationsComputedValuesKindsMutationResponse>;
  /** delete single row from the table: "analysis_applications_computed_values_kinds" */
  delete_analysis_applications_computed_values_kinds_by_pk?: Maybe<AnalysisApplicationsComputedValuesKinds>;
  /** delete single row from the table: "analysis" */
  delete_analysis_by_pk?: Maybe<Analysis>;
  /** delete data from the table: "analysis_device_categories_configs" */
  delete_analysis_device_categories_configs?: Maybe<AnalysisDeviceCategoriesConfigsMutationResponse>;
  /** delete single row from the table: "analysis_device_categories_configs" */
  delete_analysis_device_categories_configs_by_pk?: Maybe<AnalysisDeviceCategoriesConfigs>;
  /** delete data from the table: "analysis_groups" */
  delete_analysis_groups?: Maybe<AnalysisGroupsMutationResponse>;
  /** delete single row from the table: "analysis_groups" */
  delete_analysis_groups_by_pk?: Maybe<AnalysisGroups>;
  /** delete data from the table: "analysis_kinds" */
  delete_analysis_kinds?: Maybe<AnalysisKindsMutationResponse>;
  /** delete single row from the table: "analysis_kinds" */
  delete_analysis_kinds_by_pk?: Maybe<AnalysisKinds>;
  /** delete data from the table: "applications" */
  delete_applications?: Maybe<ApplicationsMutationResponse>;
  /** delete single row from the table: "applications" */
  delete_applications_by_pk?: Maybe<Applications>;
  /** delete data from the table: "applications_dashboards" */
  delete_applications_dashboards?: Maybe<ApplicationsDashboardsMutationResponse>;
  /** delete data from the table: "applications_dashboards_analysis" */
  delete_applications_dashboards_analysis?: Maybe<ApplicationsDashboardsAnalysisMutationResponse>;
  /** delete single row from the table: "applications_dashboards_analysis" */
  delete_applications_dashboards_analysis_by_pk?: Maybe<ApplicationsDashboardsAnalysis>;
  /** delete single row from the table: "applications_dashboards" */
  delete_applications_dashboards_by_pk?: Maybe<ApplicationsDashboards>;
  /** delete data from the table: "applications_dashboards_devices" */
  delete_applications_dashboards_devices?: Maybe<ApplicationsDashboardsDevicesMutationResponse>;
  /** delete single row from the table: "applications_dashboards_devices" */
  delete_applications_dashboards_devices_by_pk?: Maybe<ApplicationsDashboardsDevices>;
  /** delete data from the table: "applications_settings" */
  delete_applications_settings?: Maybe<ApplicationsSettingsMutationResponse>;
  /** delete single row from the table: "applications_settings" */
  delete_applications_settings_by_pk?: Maybe<ApplicationsSettings>;
  /** delete data from the table: "areas" */
  delete_areas?: Maybe<AreasMutationResponse>;
  /** delete single row from the table: "areas" */
  delete_areas_by_pk?: Maybe<Areas>;
  /** delete data from the table: "areas_scope_cultivation" */
  delete_areas_scope_cultivation?: Maybe<AreasScopeCultivationMutationResponse>;
  /** delete single row from the table: "areas_scope_cultivation" */
  delete_areas_scope_cultivation_by_pk?: Maybe<AreasScopeCultivation>;
  /** delete data from the table: "areas_scopes" */
  delete_areas_scopes?: Maybe<AreasScopesMutationResponse>;
  /** delete single row from the table: "areas_scopes" */
  delete_areas_scopes_by_pk?: Maybe<AreasScopes>;
  /** delete data from the table: "automation_timing_execution_kinds" */
  delete_automation_timing_execution_kinds?: Maybe<AutomationTimingExecutionKindsMutationResponse>;
  /** delete single row from the table: "automation_timing_execution_kinds" */
  delete_automation_timing_execution_kinds_by_pk?: Maybe<AutomationTimingExecutionKinds>;
  /** delete data from the table: "automations" */
  delete_automations?: Maybe<AutomationsMutationResponse>;
  /** delete single row from the table: "automations" */
  delete_automations_by_pk?: Maybe<Automations>;
  /** delete data from the table: "automations_watchings" */
  delete_automations_watchings?: Maybe<AutomationsWatchingsMutationResponse>;
  /** delete single row from the table: "automations_watchings" */
  delete_automations_watchings_by_pk?: Maybe<AutomationsWatchings>;
  /** delete data from the table: "chat_message_types" */
  delete_chat_message_types?: Maybe<ChatMessageTypesMutationResponse>;
  /** delete single row from the table: "chat_message_types" */
  delete_chat_message_types_by_pk?: Maybe<ChatMessageTypes>;
  /** delete data from the table: "chat_messages" */
  delete_chat_messages?: Maybe<ChatMessagesMutationResponse>;
  /** delete single row from the table: "chat_messages" */
  delete_chat_messages_by_pk?: Maybe<ChatMessages>;
  /** delete data from the table: "cultivation_types" */
  delete_cultivation_types?: Maybe<CultivationTypesMutationResponse>;
  /** delete single row from the table: "cultivation_types" */
  delete_cultivation_types_by_pk?: Maybe<CultivationTypes>;
  /** delete data from the table: "device_actions" */
  delete_device_actions?: Maybe<DeviceActionsMutationResponse>;
  /** delete single row from the table: "device_actions" */
  delete_device_actions_by_pk?: Maybe<DeviceActions>;
  /** delete data from the table: "device_categories" */
  delete_device_categories?: Maybe<DeviceCategoriesMutationResponse>;
  /** delete single row from the table: "device_categories" */
  delete_device_categories_by_pk?: Maybe<DeviceCategories>;
  /** delete data from the table: "device_payload_values" */
  delete_device_payload_values?: Maybe<DevicePayloadValuesMutationResponse>;
  /** delete single row from the table: "device_payload_values" */
  delete_device_payload_values_by_pk?: Maybe<DevicePayloadValues>;
  /** delete data from the table: "device_payloads" */
  delete_device_payloads?: Maybe<DevicePayloadsMutationResponse>;
  /** delete data from the table: "device_payloads__payload_values" */
  delete_device_payloads__payload_values?: Maybe<DevicePayloadsPayloadValuesMutationResponse>;
  /** delete single row from the table: "device_payloads__payload_values" */
  delete_device_payloads__payload_values_by_pk?: Maybe<DevicePayloadsPayloadValues>;
  /** delete single row from the table: "device_payloads" */
  delete_device_payloads_by_pk?: Maybe<DevicePayloads>;
  /** delete data from the table: "devices" */
  delete_devices?: Maybe<DevicesMutationResponse>;
  /** delete data from the table: "devices__device_actions" */
  delete_devices__device_actions?: Maybe<DevicesDeviceActionsMutationResponse>;
  /** delete single row from the table: "devices__device_actions" */
  delete_devices__device_actions_by_pk?: Maybe<DevicesDeviceActions>;
  /** delete data from the table: "devices__device_categories" */
  delete_devices__device_categories?: Maybe<DevicesDeviceCategoriesMutationResponse>;
  /** delete single row from the table: "devices__device_categories" */
  delete_devices__device_categories_by_pk?: Maybe<DevicesDeviceCategories>;
  /** delete data from the table: "devices__device_payloads" */
  delete_devices__device_payloads?: Maybe<DevicesDevicePayloadsMutationResponse>;
  /** delete single row from the table: "devices__device_payloads" */
  delete_devices__device_payloads_by_pk?: Maybe<DevicesDevicePayloads>;
  /** delete single row from the table: "devices" */
  delete_devices_by_pk?: Maybe<Devices>;
  /** delete data from the table: "downlinks" */
  delete_downlinks?: Maybe<DownlinksMutationResponse>;
  /** delete single row from the table: "downlinks" */
  delete_downlinks_by_pk?: Maybe<Downlinks>;
  /** delete data from the table: "farming_containers" */
  delete_farming_containers?: Maybe<FarmingContainersMutationResponse>;
  /** delete single row from the table: "farming_containers" */
  delete_farming_containers_by_pk?: Maybe<FarmingContainers>;
  /** delete data from the table: "farming_methods" */
  delete_farming_methods?: Maybe<FarmingMethodsMutationResponse>;
  /** delete single row from the table: "farming_methods" */
  delete_farming_methods_by_pk?: Maybe<FarmingMethods>;
  /** delete data from the table: "farming_structures" */
  delete_farming_structures?: Maybe<FarmingStructuresMutationResponse>;
  /** delete single row from the table: "farming_structures" */
  delete_farming_structures_by_pk?: Maybe<FarmingStructures>;
  /** delete data from the table: "notification_event_types" */
  delete_notification_event_types?: Maybe<NotificationEventTypesMutationResponse>;
  /** delete single row from the table: "notification_event_types" */
  delete_notification_event_types_by_pk?: Maybe<NotificationEventTypes>;
  /** delete data from the table: "notification_kinds" */
  delete_notification_kinds?: Maybe<NotificationKindsMutationResponse>;
  /** delete single row from the table: "notification_kinds" */
  delete_notification_kinds_by_pk?: Maybe<NotificationKinds>;
  /** delete data from the table: "notification_user_devices" */
  delete_notification_user_devices?: Maybe<NotificationUserDevicesMutationResponse>;
  /** delete data from the table: "notification_user_devices__event_types" */
  delete_notification_user_devices__event_types?: Maybe<NotificationUserDevicesEventTypesMutationResponse>;
  /** delete single row from the table: "notification_user_devices__event_types" */
  delete_notification_user_devices__event_types_by_pk?: Maybe<NotificationUserDevicesEventTypes>;
  /** delete single row from the table: "notification_user_devices" */
  delete_notification_user_devices_by_pk?: Maybe<NotificationUserDevices>;
  /** delete data from the table: "notification_user_settings" */
  delete_notification_user_settings?: Maybe<NotificationUserSettingsMutationResponse>;
  /** delete single row from the table: "notification_user_settings" */
  delete_notification_user_settings_by_pk?: Maybe<NotificationUserSettings>;
  /** delete data from the table: "notifications" */
  delete_notifications?: Maybe<NotificationsMutationResponse>;
  /** delete single row from the table: "notifications" */
  delete_notifications_by_pk?: Maybe<Notifications>;
  /** delete data from the table: "notifications_content" */
  delete_notifications_content?: Maybe<NotificationsContentMutationResponse>;
  /** delete single row from the table: "notifications_content" */
  delete_notifications_content_by_pk?: Maybe<NotificationsContent>;
  /** delete data from the table: "organizations" */
  delete_organizations?: Maybe<OrganizationsMutationResponse>;
  /** delete single row from the table: "organizations" */
  delete_organizations_by_pk?: Maybe<Organizations>;
  /** delete data from the table: "organizations_chat_params" */
  delete_organizations_chat_params?: Maybe<OrganizationsChatParamsMutationResponse>;
  /** delete single row from the table: "organizations_chat_params" */
  delete_organizations_chat_params_by_pk?: Maybe<OrganizationsChatParams>;
  /** delete data from the table: "organizations_feature_limits" */
  delete_organizations_feature_limits?: Maybe<OrganizationsFeatureLimitsMutationResponse>;
  /** delete single row from the table: "organizations_feature_limits" */
  delete_organizations_feature_limits_by_pk?: Maybe<OrganizationsFeatureLimits>;
  /** delete data from the table: "organizations_users__users_organizations" */
  delete_organizations_users__users_organizations?: Maybe<OrganizationsUsersUsersOrganizationsMutationResponse>;
  /** delete single row from the table: "organizations_users__users_organizations" */
  delete_organizations_users__users_organizations_by_pk?: Maybe<OrganizationsUsersUsersOrganizations>;
  /** delete data from the table: "scene_feedback_waits" */
  delete_scene_feedback_waits?: Maybe<SceneFeedbackWaitsMutationResponse>;
  /** delete single row from the table: "scene_feedback_waits" */
  delete_scene_feedback_waits_by_pk?: Maybe<SceneFeedbackWaits>;
  /** delete data from the table: "scene_scheduled_executions" */
  delete_scene_scheduled_executions?: Maybe<SceneScheduledExecutionsMutationResponse>;
  /** delete single row from the table: "scene_scheduled_executions" */
  delete_scene_scheduled_executions_by_pk?: Maybe<SceneScheduledExecutions>;
  /** delete data from the table: "scene_timing_execution_kinds" */
  delete_scene_timing_execution_kinds?: Maybe<SceneTimingExecutionKindsMutationResponse>;
  /** delete single row from the table: "scene_timing_execution_kinds" */
  delete_scene_timing_execution_kinds_by_pk?: Maybe<SceneTimingExecutionKinds>;
  /** delete data from the table: "scenes" */
  delete_scenes?: Maybe<ScenesMutationResponse>;
  /** delete data from the table: "scenes__devices" */
  delete_scenes__devices?: Maybe<ScenesDevicesMutationResponse>;
  /** delete single row from the table: "scenes__devices" */
  delete_scenes__devices_by_pk?: Maybe<ScenesDevices>;
  /** delete single row from the table: "scenes" */
  delete_scenes_by_pk?: Maybe<Scenes>;
  /** delete data from the table: "substrates" */
  delete_substrates?: Maybe<SubstratesMutationResponse>;
  /** delete single row from the table: "substrates" */
  delete_substrates_by_pk?: Maybe<Substrates>;
  /** delete data from the table: "telegram_users" */
  delete_telegram_users?: Maybe<TelegramUsersMutationResponse>;
  /** delete single row from the table: "telegram_users" */
  delete_telegram_users_by_pk?: Maybe<TelegramUsers>;
  /** delete data from the table: "uplink_dynamo_ref" */
  delete_uplink_dynamo_ref?: Maybe<UplinkDynamoRefMutationResponse>;
  /** delete single row from the table: "uplink_dynamo_ref" */
  delete_uplink_dynamo_ref_by_pk?: Maybe<UplinkDynamoRef>;
  /** delete data from the table: "user_roles" */
  delete_user_roles?: Maybe<UserRolesMutationResponse>;
  /** delete data from the table: "user_roles__users_permissions_user" */
  delete_user_roles__users_permissions_user?: Maybe<UserRolesUsersPermissionsUserMutationResponse>;
  /** delete single row from the table: "user_roles__users_permissions_user" */
  delete_user_roles__users_permissions_user_by_pk?: Maybe<UserRolesUsersPermissionsUser>;
  /** delete single row from the table: "user_roles" */
  delete_user_roles_by_pk?: Maybe<UserRoles>;
  /** delete data from the table: "users_permissions_user" */
  delete_users_permissions_user?: Maybe<UsersPermissionsUserMutationResponse>;
  /** delete single row from the table: "users_permissions_user" */
  delete_users_permissions_user_by_pk?: Maybe<UsersPermissionsUser>;
  /** Send a device action downlink */
  device_downlink: DeviceDownlinkOutput;
  hygraph?: Maybe<HygraphMutation>;
  /** insert data into the table: "analysis" */
  insert_analysis?: Maybe<AnalysisMutationResponse>;
  /** insert data into the table: "analysis__devices_payloads" */
  insert_analysis__devices_payloads?: Maybe<AnalysisDevicesPayloadsMutationResponse>;
  /** insert a single row into the table: "analysis__devices_payloads" */
  insert_analysis__devices_payloads_one?: Maybe<AnalysisDevicesPayloads>;
  /** insert data into the table: "analysis_applications" */
  insert_analysis_applications?: Maybe<AnalysisApplicationsMutationResponse>;
  /** insert data into the table: "analysis_applications__devices" */
  insert_analysis_applications__devices?: Maybe<AnalysisApplicationsDevicesMutationResponse>;
  /** insert a single row into the table: "analysis_applications__devices" */
  insert_analysis_applications__devices_one?: Maybe<AnalysisApplicationsDevices>;
  /** insert data into the table: "analysis_applications_computed" */
  insert_analysis_applications_computed?: Maybe<AnalysisApplicationsComputedMutationResponse>;
  /** insert a single row into the table: "analysis_applications_computed" */
  insert_analysis_applications_computed_one?: Maybe<AnalysisApplicationsComputed>;
  /** insert data into the table: "analysis_applications_computed_values" */
  insert_analysis_applications_computed_values?: Maybe<AnalysisApplicationsComputedValuesMutationResponse>;
  /** insert data into the table: "analysis_applications_computed_values_kinds" */
  insert_analysis_applications_computed_values_kinds?: Maybe<AnalysisApplicationsComputedValuesKindsMutationResponse>;
  /** insert a single row into the table: "analysis_applications_computed_values_kinds" */
  insert_analysis_applications_computed_values_kinds_one?: Maybe<AnalysisApplicationsComputedValuesKinds>;
  /** insert a single row into the table: "analysis_applications_computed_values" */
  insert_analysis_applications_computed_values_one?: Maybe<AnalysisApplicationsComputedValues>;
  /** insert a single row into the table: "analysis_applications" */
  insert_analysis_applications_one?: Maybe<AnalysisApplications>;
  /** insert data into the table: "analysis_device_categories_configs" */
  insert_analysis_device_categories_configs?: Maybe<AnalysisDeviceCategoriesConfigsMutationResponse>;
  /** insert a single row into the table: "analysis_device_categories_configs" */
  insert_analysis_device_categories_configs_one?: Maybe<AnalysisDeviceCategoriesConfigs>;
  /** insert data into the table: "analysis_groups" */
  insert_analysis_groups?: Maybe<AnalysisGroupsMutationResponse>;
  /** insert a single row into the table: "analysis_groups" */
  insert_analysis_groups_one?: Maybe<AnalysisGroups>;
  /** insert data into the table: "analysis_kinds" */
  insert_analysis_kinds?: Maybe<AnalysisKindsMutationResponse>;
  /** insert a single row into the table: "analysis_kinds" */
  insert_analysis_kinds_one?: Maybe<AnalysisKinds>;
  /** insert a single row into the table: "analysis" */
  insert_analysis_one?: Maybe<Analysis>;
  /** insert data into the table: "applications" */
  insert_applications?: Maybe<ApplicationsMutationResponse>;
  /** insert data into the table: "applications_dashboards" */
  insert_applications_dashboards?: Maybe<ApplicationsDashboardsMutationResponse>;
  /** insert data into the table: "applications_dashboards_analysis" */
  insert_applications_dashboards_analysis?: Maybe<ApplicationsDashboardsAnalysisMutationResponse>;
  /** insert a single row into the table: "applications_dashboards_analysis" */
  insert_applications_dashboards_analysis_one?: Maybe<ApplicationsDashboardsAnalysis>;
  /** insert data into the table: "applications_dashboards_devices" */
  insert_applications_dashboards_devices?: Maybe<ApplicationsDashboardsDevicesMutationResponse>;
  /** insert a single row into the table: "applications_dashboards_devices" */
  insert_applications_dashboards_devices_one?: Maybe<ApplicationsDashboardsDevices>;
  /** insert a single row into the table: "applications_dashboards" */
  insert_applications_dashboards_one?: Maybe<ApplicationsDashboards>;
  /** insert a single row into the table: "applications" */
  insert_applications_one?: Maybe<Applications>;
  /** insert data into the table: "applications_settings" */
  insert_applications_settings?: Maybe<ApplicationsSettingsMutationResponse>;
  /** insert a single row into the table: "applications_settings" */
  insert_applications_settings_one?: Maybe<ApplicationsSettings>;
  /** insert data into the table: "areas" */
  insert_areas?: Maybe<AreasMutationResponse>;
  /** insert a single row into the table: "areas" */
  insert_areas_one?: Maybe<Areas>;
  /** insert data into the table: "areas_scope_cultivation" */
  insert_areas_scope_cultivation?: Maybe<AreasScopeCultivationMutationResponse>;
  /** insert a single row into the table: "areas_scope_cultivation" */
  insert_areas_scope_cultivation_one?: Maybe<AreasScopeCultivation>;
  /** insert data into the table: "areas_scopes" */
  insert_areas_scopes?: Maybe<AreasScopesMutationResponse>;
  /** insert a single row into the table: "areas_scopes" */
  insert_areas_scopes_one?: Maybe<AreasScopes>;
  /** insert data into the table: "automation_timing_execution_kinds" */
  insert_automation_timing_execution_kinds?: Maybe<AutomationTimingExecutionKindsMutationResponse>;
  /** insert a single row into the table: "automation_timing_execution_kinds" */
  insert_automation_timing_execution_kinds_one?: Maybe<AutomationTimingExecutionKinds>;
  /** insert data into the table: "automations" */
  insert_automations?: Maybe<AutomationsMutationResponse>;
  /** insert a single row into the table: "automations" */
  insert_automations_one?: Maybe<Automations>;
  /** insert data into the table: "automations_watchings" */
  insert_automations_watchings?: Maybe<AutomationsWatchingsMutationResponse>;
  /** insert a single row into the table: "automations_watchings" */
  insert_automations_watchings_one?: Maybe<AutomationsWatchings>;
  /** insert data into the table: "chat_message_types" */
  insert_chat_message_types?: Maybe<ChatMessageTypesMutationResponse>;
  /** insert a single row into the table: "chat_message_types" */
  insert_chat_message_types_one?: Maybe<ChatMessageTypes>;
  /** insert data into the table: "chat_messages" */
  insert_chat_messages?: Maybe<ChatMessagesMutationResponse>;
  /** insert a single row into the table: "chat_messages" */
  insert_chat_messages_one?: Maybe<ChatMessages>;
  /** insert data into the table: "cultivation_types" */
  insert_cultivation_types?: Maybe<CultivationTypesMutationResponse>;
  /** insert a single row into the table: "cultivation_types" */
  insert_cultivation_types_one?: Maybe<CultivationTypes>;
  /** insert data into the table: "device_actions" */
  insert_device_actions?: Maybe<DeviceActionsMutationResponse>;
  /** insert a single row into the table: "device_actions" */
  insert_device_actions_one?: Maybe<DeviceActions>;
  /** insert data into the table: "device_categories" */
  insert_device_categories?: Maybe<DeviceCategoriesMutationResponse>;
  /** insert a single row into the table: "device_categories" */
  insert_device_categories_one?: Maybe<DeviceCategories>;
  /** insert data into the table: "device_payload_values" */
  insert_device_payload_values?: Maybe<DevicePayloadValuesMutationResponse>;
  /** insert a single row into the table: "device_payload_values" */
  insert_device_payload_values_one?: Maybe<DevicePayloadValues>;
  /** insert data into the table: "device_payloads" */
  insert_device_payloads?: Maybe<DevicePayloadsMutationResponse>;
  /** insert data into the table: "device_payloads__payload_values" */
  insert_device_payloads__payload_values?: Maybe<DevicePayloadsPayloadValuesMutationResponse>;
  /** insert a single row into the table: "device_payloads__payload_values" */
  insert_device_payloads__payload_values_one?: Maybe<DevicePayloadsPayloadValues>;
  /** insert a single row into the table: "device_payloads" */
  insert_device_payloads_one?: Maybe<DevicePayloads>;
  /** insert data into the table: "devices" */
  insert_devices?: Maybe<DevicesMutationResponse>;
  /** insert data into the table: "devices__device_actions" */
  insert_devices__device_actions?: Maybe<DevicesDeviceActionsMutationResponse>;
  /** insert a single row into the table: "devices__device_actions" */
  insert_devices__device_actions_one?: Maybe<DevicesDeviceActions>;
  /** insert data into the table: "devices__device_categories" */
  insert_devices__device_categories?: Maybe<DevicesDeviceCategoriesMutationResponse>;
  /** insert a single row into the table: "devices__device_categories" */
  insert_devices__device_categories_one?: Maybe<DevicesDeviceCategories>;
  /** insert data into the table: "devices__device_payloads" */
  insert_devices__device_payloads?: Maybe<DevicesDevicePayloadsMutationResponse>;
  /** insert a single row into the table: "devices__device_payloads" */
  insert_devices__device_payloads_one?: Maybe<DevicesDevicePayloads>;
  /** insert a single row into the table: "devices" */
  insert_devices_one?: Maybe<Devices>;
  /** insert data into the table: "downlinks" */
  insert_downlinks?: Maybe<DownlinksMutationResponse>;
  /** insert a single row into the table: "downlinks" */
  insert_downlinks_one?: Maybe<Downlinks>;
  /** insert data into the table: "farming_containers" */
  insert_farming_containers?: Maybe<FarmingContainersMutationResponse>;
  /** insert a single row into the table: "farming_containers" */
  insert_farming_containers_one?: Maybe<FarmingContainers>;
  /** insert data into the table: "farming_methods" */
  insert_farming_methods?: Maybe<FarmingMethodsMutationResponse>;
  /** insert a single row into the table: "farming_methods" */
  insert_farming_methods_one?: Maybe<FarmingMethods>;
  /** insert data into the table: "farming_structures" */
  insert_farming_structures?: Maybe<FarmingStructuresMutationResponse>;
  /** insert a single row into the table: "farming_structures" */
  insert_farming_structures_one?: Maybe<FarmingStructures>;
  /** insert data into the table: "notification_event_types" */
  insert_notification_event_types?: Maybe<NotificationEventTypesMutationResponse>;
  /** insert a single row into the table: "notification_event_types" */
  insert_notification_event_types_one?: Maybe<NotificationEventTypes>;
  /** insert data into the table: "notification_kinds" */
  insert_notification_kinds?: Maybe<NotificationKindsMutationResponse>;
  /** insert a single row into the table: "notification_kinds" */
  insert_notification_kinds_one?: Maybe<NotificationKinds>;
  /** insert data into the table: "notification_user_devices" */
  insert_notification_user_devices?: Maybe<NotificationUserDevicesMutationResponse>;
  /** insert data into the table: "notification_user_devices__event_types" */
  insert_notification_user_devices__event_types?: Maybe<NotificationUserDevicesEventTypesMutationResponse>;
  /** insert a single row into the table: "notification_user_devices__event_types" */
  insert_notification_user_devices__event_types_one?: Maybe<NotificationUserDevicesEventTypes>;
  /** insert a single row into the table: "notification_user_devices" */
  insert_notification_user_devices_one?: Maybe<NotificationUserDevices>;
  /** insert data into the table: "notification_user_settings" */
  insert_notification_user_settings?: Maybe<NotificationUserSettingsMutationResponse>;
  /** insert a single row into the table: "notification_user_settings" */
  insert_notification_user_settings_one?: Maybe<NotificationUserSettings>;
  /** insert data into the table: "notifications" */
  insert_notifications?: Maybe<NotificationsMutationResponse>;
  /** insert data into the table: "notifications_content" */
  insert_notifications_content?: Maybe<NotificationsContentMutationResponse>;
  /** insert a single row into the table: "notifications_content" */
  insert_notifications_content_one?: Maybe<NotificationsContent>;
  /** insert a single row into the table: "notifications" */
  insert_notifications_one?: Maybe<Notifications>;
  /** insert data into the table: "organizations" */
  insert_organizations?: Maybe<OrganizationsMutationResponse>;
  /** insert data into the table: "organizations_chat_params" */
  insert_organizations_chat_params?: Maybe<OrganizationsChatParamsMutationResponse>;
  /** insert a single row into the table: "organizations_chat_params" */
  insert_organizations_chat_params_one?: Maybe<OrganizationsChatParams>;
  /** insert data into the table: "organizations_feature_limits" */
  insert_organizations_feature_limits?: Maybe<OrganizationsFeatureLimitsMutationResponse>;
  /** insert a single row into the table: "organizations_feature_limits" */
  insert_organizations_feature_limits_one?: Maybe<OrganizationsFeatureLimits>;
  /** insert a single row into the table: "organizations" */
  insert_organizations_one?: Maybe<Organizations>;
  /** insert data into the table: "organizations_users__users_organizations" */
  insert_organizations_users__users_organizations?: Maybe<OrganizationsUsersUsersOrganizationsMutationResponse>;
  /** insert a single row into the table: "organizations_users__users_organizations" */
  insert_organizations_users__users_organizations_one?: Maybe<OrganizationsUsersUsersOrganizations>;
  /** insert data into the table: "scene_feedback_waits" */
  insert_scene_feedback_waits?: Maybe<SceneFeedbackWaitsMutationResponse>;
  /** insert a single row into the table: "scene_feedback_waits" */
  insert_scene_feedback_waits_one?: Maybe<SceneFeedbackWaits>;
  /** insert data into the table: "scene_scheduled_executions" */
  insert_scene_scheduled_executions?: Maybe<SceneScheduledExecutionsMutationResponse>;
  /** insert a single row into the table: "scene_scheduled_executions" */
  insert_scene_scheduled_executions_one?: Maybe<SceneScheduledExecutions>;
  /** insert data into the table: "scene_timing_execution_kinds" */
  insert_scene_timing_execution_kinds?: Maybe<SceneTimingExecutionKindsMutationResponse>;
  /** insert a single row into the table: "scene_timing_execution_kinds" */
  insert_scene_timing_execution_kinds_one?: Maybe<SceneTimingExecutionKinds>;
  /** insert data into the table: "scenes" */
  insert_scenes?: Maybe<ScenesMutationResponse>;
  /** insert data into the table: "scenes__devices" */
  insert_scenes__devices?: Maybe<ScenesDevicesMutationResponse>;
  /** insert a single row into the table: "scenes__devices" */
  insert_scenes__devices_one?: Maybe<ScenesDevices>;
  /** insert a single row into the table: "scenes" */
  insert_scenes_one?: Maybe<Scenes>;
  /** insert data into the table: "substrates" */
  insert_substrates?: Maybe<SubstratesMutationResponse>;
  /** insert a single row into the table: "substrates" */
  insert_substrates_one?: Maybe<Substrates>;
  /** insert data into the table: "telegram_users" */
  insert_telegram_users?: Maybe<TelegramUsersMutationResponse>;
  /** insert a single row into the table: "telegram_users" */
  insert_telegram_users_one?: Maybe<TelegramUsers>;
  /** insert data into the table: "uplink_dynamo_ref" */
  insert_uplink_dynamo_ref?: Maybe<UplinkDynamoRefMutationResponse>;
  /** insert a single row into the table: "uplink_dynamo_ref" */
  insert_uplink_dynamo_ref_one?: Maybe<UplinkDynamoRef>;
  /** insert data into the table: "user_roles" */
  insert_user_roles?: Maybe<UserRolesMutationResponse>;
  /** insert data into the table: "user_roles__users_permissions_user" */
  insert_user_roles__users_permissions_user?: Maybe<UserRolesUsersPermissionsUserMutationResponse>;
  /** insert a single row into the table: "user_roles__users_permissions_user" */
  insert_user_roles__users_permissions_user_one?: Maybe<UserRolesUsersPermissionsUser>;
  /** insert a single row into the table: "user_roles" */
  insert_user_roles_one?: Maybe<UserRoles>;
  /** insert data into the table: "users_permissions_user" */
  insert_users_permissions_user?: Maybe<UsersPermissionsUserMutationResponse>;
  /** insert a single row into the table: "users_permissions_user" */
  insert_users_permissions_user_one?: Maybe<UsersPermissionsUser>;
  /** update data of the table: "analysis" */
  update_analysis?: Maybe<AnalysisMutationResponse>;
  /** update data of the table: "analysis__devices_payloads" */
  update_analysis__devices_payloads?: Maybe<AnalysisDevicesPayloadsMutationResponse>;
  /** update single row of the table: "analysis__devices_payloads" */
  update_analysis__devices_payloads_by_pk?: Maybe<AnalysisDevicesPayloads>;
  /** update multiples rows of table: "analysis__devices_payloads" */
  update_analysis__devices_payloads_many?: Maybe<Array<Maybe<AnalysisDevicesPayloadsMutationResponse>>>;
  /** update data of the table: "analysis_applications" */
  update_analysis_applications?: Maybe<AnalysisApplicationsMutationResponse>;
  /** update data of the table: "analysis_applications__devices" */
  update_analysis_applications__devices?: Maybe<AnalysisApplicationsDevicesMutationResponse>;
  /** update single row of the table: "analysis_applications__devices" */
  update_analysis_applications__devices_by_pk?: Maybe<AnalysisApplicationsDevices>;
  /** update multiples rows of table: "analysis_applications__devices" */
  update_analysis_applications__devices_many?: Maybe<Array<Maybe<AnalysisApplicationsDevicesMutationResponse>>>;
  /** update single row of the table: "analysis_applications" */
  update_analysis_applications_by_pk?: Maybe<AnalysisApplications>;
  /** update data of the table: "analysis_applications_computed" */
  update_analysis_applications_computed?: Maybe<AnalysisApplicationsComputedMutationResponse>;
  /** update single row of the table: "analysis_applications_computed" */
  update_analysis_applications_computed_by_pk?: Maybe<AnalysisApplicationsComputed>;
  /** update multiples rows of table: "analysis_applications_computed" */
  update_analysis_applications_computed_many?: Maybe<Array<Maybe<AnalysisApplicationsComputedMutationResponse>>>;
  /** update data of the table: "analysis_applications_computed_values" */
  update_analysis_applications_computed_values?: Maybe<AnalysisApplicationsComputedValuesMutationResponse>;
  /** update single row of the table: "analysis_applications_computed_values" */
  update_analysis_applications_computed_values_by_pk?: Maybe<AnalysisApplicationsComputedValues>;
  /** update data of the table: "analysis_applications_computed_values_kinds" */
  update_analysis_applications_computed_values_kinds?: Maybe<AnalysisApplicationsComputedValuesKindsMutationResponse>;
  /** update single row of the table: "analysis_applications_computed_values_kinds" */
  update_analysis_applications_computed_values_kinds_by_pk?: Maybe<AnalysisApplicationsComputedValuesKinds>;
  /** update multiples rows of table: "analysis_applications_computed_values_kinds" */
  update_analysis_applications_computed_values_kinds_many?: Maybe<Array<Maybe<AnalysisApplicationsComputedValuesKindsMutationResponse>>>;
  /** update multiples rows of table: "analysis_applications_computed_values" */
  update_analysis_applications_computed_values_many?: Maybe<Array<Maybe<AnalysisApplicationsComputedValuesMutationResponse>>>;
  /** update multiples rows of table: "analysis_applications" */
  update_analysis_applications_many?: Maybe<Array<Maybe<AnalysisApplicationsMutationResponse>>>;
  /** update single row of the table: "analysis" */
  update_analysis_by_pk?: Maybe<Analysis>;
  /** update data of the table: "analysis_device_categories_configs" */
  update_analysis_device_categories_configs?: Maybe<AnalysisDeviceCategoriesConfigsMutationResponse>;
  /** update single row of the table: "analysis_device_categories_configs" */
  update_analysis_device_categories_configs_by_pk?: Maybe<AnalysisDeviceCategoriesConfigs>;
  /** update multiples rows of table: "analysis_device_categories_configs" */
  update_analysis_device_categories_configs_many?: Maybe<Array<Maybe<AnalysisDeviceCategoriesConfigsMutationResponse>>>;
  /** update data of the table: "analysis_groups" */
  update_analysis_groups?: Maybe<AnalysisGroupsMutationResponse>;
  /** update single row of the table: "analysis_groups" */
  update_analysis_groups_by_pk?: Maybe<AnalysisGroups>;
  /** update multiples rows of table: "analysis_groups" */
  update_analysis_groups_many?: Maybe<Array<Maybe<AnalysisGroupsMutationResponse>>>;
  /** update data of the table: "analysis_kinds" */
  update_analysis_kinds?: Maybe<AnalysisKindsMutationResponse>;
  /** update single row of the table: "analysis_kinds" */
  update_analysis_kinds_by_pk?: Maybe<AnalysisKinds>;
  /** update multiples rows of table: "analysis_kinds" */
  update_analysis_kinds_many?: Maybe<Array<Maybe<AnalysisKindsMutationResponse>>>;
  /** update multiples rows of table: "analysis" */
  update_analysis_many?: Maybe<Array<Maybe<AnalysisMutationResponse>>>;
  /** update data of the table: "applications" */
  update_applications?: Maybe<ApplicationsMutationResponse>;
  /** update single row of the table: "applications" */
  update_applications_by_pk?: Maybe<Applications>;
  /** update data of the table: "applications_dashboards" */
  update_applications_dashboards?: Maybe<ApplicationsDashboardsMutationResponse>;
  /** update data of the table: "applications_dashboards_analysis" */
  update_applications_dashboards_analysis?: Maybe<ApplicationsDashboardsAnalysisMutationResponse>;
  /** update single row of the table: "applications_dashboards_analysis" */
  update_applications_dashboards_analysis_by_pk?: Maybe<ApplicationsDashboardsAnalysis>;
  /** update multiples rows of table: "applications_dashboards_analysis" */
  update_applications_dashboards_analysis_many?: Maybe<Array<Maybe<ApplicationsDashboardsAnalysisMutationResponse>>>;
  /** update single row of the table: "applications_dashboards" */
  update_applications_dashboards_by_pk?: Maybe<ApplicationsDashboards>;
  /** update data of the table: "applications_dashboards_devices" */
  update_applications_dashboards_devices?: Maybe<ApplicationsDashboardsDevicesMutationResponse>;
  /** update single row of the table: "applications_dashboards_devices" */
  update_applications_dashboards_devices_by_pk?: Maybe<ApplicationsDashboardsDevices>;
  /** update multiples rows of table: "applications_dashboards_devices" */
  update_applications_dashboards_devices_many?: Maybe<Array<Maybe<ApplicationsDashboardsDevicesMutationResponse>>>;
  /** update multiples rows of table: "applications_dashboards" */
  update_applications_dashboards_many?: Maybe<Array<Maybe<ApplicationsDashboardsMutationResponse>>>;
  /** update multiples rows of table: "applications" */
  update_applications_many?: Maybe<Array<Maybe<ApplicationsMutationResponse>>>;
  /** update data of the table: "applications_settings" */
  update_applications_settings?: Maybe<ApplicationsSettingsMutationResponse>;
  /** update single row of the table: "applications_settings" */
  update_applications_settings_by_pk?: Maybe<ApplicationsSettings>;
  /** update multiples rows of table: "applications_settings" */
  update_applications_settings_many?: Maybe<Array<Maybe<ApplicationsSettingsMutationResponse>>>;
  /** update data of the table: "areas" */
  update_areas?: Maybe<AreasMutationResponse>;
  /** update single row of the table: "areas" */
  update_areas_by_pk?: Maybe<Areas>;
  /** update multiples rows of table: "areas" */
  update_areas_many?: Maybe<Array<Maybe<AreasMutationResponse>>>;
  /** update data of the table: "areas_scope_cultivation" */
  update_areas_scope_cultivation?: Maybe<AreasScopeCultivationMutationResponse>;
  /** update single row of the table: "areas_scope_cultivation" */
  update_areas_scope_cultivation_by_pk?: Maybe<AreasScopeCultivation>;
  /** update multiples rows of table: "areas_scope_cultivation" */
  update_areas_scope_cultivation_many?: Maybe<Array<Maybe<AreasScopeCultivationMutationResponse>>>;
  /** update data of the table: "areas_scopes" */
  update_areas_scopes?: Maybe<AreasScopesMutationResponse>;
  /** update single row of the table: "areas_scopes" */
  update_areas_scopes_by_pk?: Maybe<AreasScopes>;
  /** update multiples rows of table: "areas_scopes" */
  update_areas_scopes_many?: Maybe<Array<Maybe<AreasScopesMutationResponse>>>;
  /** update data of the table: "automation_timing_execution_kinds" */
  update_automation_timing_execution_kinds?: Maybe<AutomationTimingExecutionKindsMutationResponse>;
  /** update single row of the table: "automation_timing_execution_kinds" */
  update_automation_timing_execution_kinds_by_pk?: Maybe<AutomationTimingExecutionKinds>;
  /** update multiples rows of table: "automation_timing_execution_kinds" */
  update_automation_timing_execution_kinds_many?: Maybe<Array<Maybe<AutomationTimingExecutionKindsMutationResponse>>>;
  /** update data of the table: "automations" */
  update_automations?: Maybe<AutomationsMutationResponse>;
  /** update single row of the table: "automations" */
  update_automations_by_pk?: Maybe<Automations>;
  /** update multiples rows of table: "automations" */
  update_automations_many?: Maybe<Array<Maybe<AutomationsMutationResponse>>>;
  /** update data of the table: "automations_watchings" */
  update_automations_watchings?: Maybe<AutomationsWatchingsMutationResponse>;
  /** update single row of the table: "automations_watchings" */
  update_automations_watchings_by_pk?: Maybe<AutomationsWatchings>;
  /** update multiples rows of table: "automations_watchings" */
  update_automations_watchings_many?: Maybe<Array<Maybe<AutomationsWatchingsMutationResponse>>>;
  /** update data of the table: "chat_message_types" */
  update_chat_message_types?: Maybe<ChatMessageTypesMutationResponse>;
  /** update single row of the table: "chat_message_types" */
  update_chat_message_types_by_pk?: Maybe<ChatMessageTypes>;
  /** update multiples rows of table: "chat_message_types" */
  update_chat_message_types_many?: Maybe<Array<Maybe<ChatMessageTypesMutationResponse>>>;
  /** update data of the table: "chat_messages" */
  update_chat_messages?: Maybe<ChatMessagesMutationResponse>;
  /** update single row of the table: "chat_messages" */
  update_chat_messages_by_pk?: Maybe<ChatMessages>;
  /** update multiples rows of table: "chat_messages" */
  update_chat_messages_many?: Maybe<Array<Maybe<ChatMessagesMutationResponse>>>;
  /** update data of the table: "cultivation_types" */
  update_cultivation_types?: Maybe<CultivationTypesMutationResponse>;
  /** update single row of the table: "cultivation_types" */
  update_cultivation_types_by_pk?: Maybe<CultivationTypes>;
  /** update multiples rows of table: "cultivation_types" */
  update_cultivation_types_many?: Maybe<Array<Maybe<CultivationTypesMutationResponse>>>;
  /** update data of the table: "device_actions" */
  update_device_actions?: Maybe<DeviceActionsMutationResponse>;
  /** update single row of the table: "device_actions" */
  update_device_actions_by_pk?: Maybe<DeviceActions>;
  /** update multiples rows of table: "device_actions" */
  update_device_actions_many?: Maybe<Array<Maybe<DeviceActionsMutationResponse>>>;
  /** update data of the table: "device_categories" */
  update_device_categories?: Maybe<DeviceCategoriesMutationResponse>;
  /** update single row of the table: "device_categories" */
  update_device_categories_by_pk?: Maybe<DeviceCategories>;
  /** update multiples rows of table: "device_categories" */
  update_device_categories_many?: Maybe<Array<Maybe<DeviceCategoriesMutationResponse>>>;
  /** update data of the table: "device_payload_values" */
  update_device_payload_values?: Maybe<DevicePayloadValuesMutationResponse>;
  /** update single row of the table: "device_payload_values" */
  update_device_payload_values_by_pk?: Maybe<DevicePayloadValues>;
  /** update multiples rows of table: "device_payload_values" */
  update_device_payload_values_many?: Maybe<Array<Maybe<DevicePayloadValuesMutationResponse>>>;
  /** update data of the table: "device_payloads" */
  update_device_payloads?: Maybe<DevicePayloadsMutationResponse>;
  /** update data of the table: "device_payloads__payload_values" */
  update_device_payloads__payload_values?: Maybe<DevicePayloadsPayloadValuesMutationResponse>;
  /** update single row of the table: "device_payloads__payload_values" */
  update_device_payloads__payload_values_by_pk?: Maybe<DevicePayloadsPayloadValues>;
  /** update multiples rows of table: "device_payloads__payload_values" */
  update_device_payloads__payload_values_many?: Maybe<Array<Maybe<DevicePayloadsPayloadValuesMutationResponse>>>;
  /** update single row of the table: "device_payloads" */
  update_device_payloads_by_pk?: Maybe<DevicePayloads>;
  /** update multiples rows of table: "device_payloads" */
  update_device_payloads_many?: Maybe<Array<Maybe<DevicePayloadsMutationResponse>>>;
  /** update data of the table: "devices" */
  update_devices?: Maybe<DevicesMutationResponse>;
  /** update data of the table: "devices__device_actions" */
  update_devices__device_actions?: Maybe<DevicesDeviceActionsMutationResponse>;
  /** update single row of the table: "devices__device_actions" */
  update_devices__device_actions_by_pk?: Maybe<DevicesDeviceActions>;
  /** update multiples rows of table: "devices__device_actions" */
  update_devices__device_actions_many?: Maybe<Array<Maybe<DevicesDeviceActionsMutationResponse>>>;
  /** update data of the table: "devices__device_categories" */
  update_devices__device_categories?: Maybe<DevicesDeviceCategoriesMutationResponse>;
  /** update single row of the table: "devices__device_categories" */
  update_devices__device_categories_by_pk?: Maybe<DevicesDeviceCategories>;
  /** update multiples rows of table: "devices__device_categories" */
  update_devices__device_categories_many?: Maybe<Array<Maybe<DevicesDeviceCategoriesMutationResponse>>>;
  /** update data of the table: "devices__device_payloads" */
  update_devices__device_payloads?: Maybe<DevicesDevicePayloadsMutationResponse>;
  /** update single row of the table: "devices__device_payloads" */
  update_devices__device_payloads_by_pk?: Maybe<DevicesDevicePayloads>;
  /** update multiples rows of table: "devices__device_payloads" */
  update_devices__device_payloads_many?: Maybe<Array<Maybe<DevicesDevicePayloadsMutationResponse>>>;
  /** update single row of the table: "devices" */
  update_devices_by_pk?: Maybe<Devices>;
  /** update multiples rows of table: "devices" */
  update_devices_many?: Maybe<Array<Maybe<DevicesMutationResponse>>>;
  /** update data of the table: "downlinks" */
  update_downlinks?: Maybe<DownlinksMutationResponse>;
  /** update single row of the table: "downlinks" */
  update_downlinks_by_pk?: Maybe<Downlinks>;
  /** update multiples rows of table: "downlinks" */
  update_downlinks_many?: Maybe<Array<Maybe<DownlinksMutationResponse>>>;
  /** update data of the table: "farming_containers" */
  update_farming_containers?: Maybe<FarmingContainersMutationResponse>;
  /** update single row of the table: "farming_containers" */
  update_farming_containers_by_pk?: Maybe<FarmingContainers>;
  /** update multiples rows of table: "farming_containers" */
  update_farming_containers_many?: Maybe<Array<Maybe<FarmingContainersMutationResponse>>>;
  /** update data of the table: "farming_methods" */
  update_farming_methods?: Maybe<FarmingMethodsMutationResponse>;
  /** update single row of the table: "farming_methods" */
  update_farming_methods_by_pk?: Maybe<FarmingMethods>;
  /** update multiples rows of table: "farming_methods" */
  update_farming_methods_many?: Maybe<Array<Maybe<FarmingMethodsMutationResponse>>>;
  /** update data of the table: "farming_structures" */
  update_farming_structures?: Maybe<FarmingStructuresMutationResponse>;
  /** update single row of the table: "farming_structures" */
  update_farming_structures_by_pk?: Maybe<FarmingStructures>;
  /** update multiples rows of table: "farming_structures" */
  update_farming_structures_many?: Maybe<Array<Maybe<FarmingStructuresMutationResponse>>>;
  /** update data of the table: "notification_event_types" */
  update_notification_event_types?: Maybe<NotificationEventTypesMutationResponse>;
  /** update single row of the table: "notification_event_types" */
  update_notification_event_types_by_pk?: Maybe<NotificationEventTypes>;
  /** update multiples rows of table: "notification_event_types" */
  update_notification_event_types_many?: Maybe<Array<Maybe<NotificationEventTypesMutationResponse>>>;
  /** update data of the table: "notification_kinds" */
  update_notification_kinds?: Maybe<NotificationKindsMutationResponse>;
  /** update single row of the table: "notification_kinds" */
  update_notification_kinds_by_pk?: Maybe<NotificationKinds>;
  /** update multiples rows of table: "notification_kinds" */
  update_notification_kinds_many?: Maybe<Array<Maybe<NotificationKindsMutationResponse>>>;
  /** update data of the table: "notification_user_devices" */
  update_notification_user_devices?: Maybe<NotificationUserDevicesMutationResponse>;
  /** update data of the table: "notification_user_devices__event_types" */
  update_notification_user_devices__event_types?: Maybe<NotificationUserDevicesEventTypesMutationResponse>;
  /** update single row of the table: "notification_user_devices__event_types" */
  update_notification_user_devices__event_types_by_pk?: Maybe<NotificationUserDevicesEventTypes>;
  /** update multiples rows of table: "notification_user_devices__event_types" */
  update_notification_user_devices__event_types_many?: Maybe<Array<Maybe<NotificationUserDevicesEventTypesMutationResponse>>>;
  /** update single row of the table: "notification_user_devices" */
  update_notification_user_devices_by_pk?: Maybe<NotificationUserDevices>;
  /** update multiples rows of table: "notification_user_devices" */
  update_notification_user_devices_many?: Maybe<Array<Maybe<NotificationUserDevicesMutationResponse>>>;
  /** update data of the table: "notification_user_settings" */
  update_notification_user_settings?: Maybe<NotificationUserSettingsMutationResponse>;
  /** update single row of the table: "notification_user_settings" */
  update_notification_user_settings_by_pk?: Maybe<NotificationUserSettings>;
  /** update multiples rows of table: "notification_user_settings" */
  update_notification_user_settings_many?: Maybe<Array<Maybe<NotificationUserSettingsMutationResponse>>>;
  /** update data of the table: "notifications" */
  update_notifications?: Maybe<NotificationsMutationResponse>;
  /** update single row of the table: "notifications" */
  update_notifications_by_pk?: Maybe<Notifications>;
  /** update data of the table: "notifications_content" */
  update_notifications_content?: Maybe<NotificationsContentMutationResponse>;
  /** update single row of the table: "notifications_content" */
  update_notifications_content_by_pk?: Maybe<NotificationsContent>;
  /** update multiples rows of table: "notifications_content" */
  update_notifications_content_many?: Maybe<Array<Maybe<NotificationsContentMutationResponse>>>;
  /** update multiples rows of table: "notifications" */
  update_notifications_many?: Maybe<Array<Maybe<NotificationsMutationResponse>>>;
  /** update data of the table: "organizations" */
  update_organizations?: Maybe<OrganizationsMutationResponse>;
  /** update single row of the table: "organizations" */
  update_organizations_by_pk?: Maybe<Organizations>;
  /** update data of the table: "organizations_chat_params" */
  update_organizations_chat_params?: Maybe<OrganizationsChatParamsMutationResponse>;
  /** update single row of the table: "organizations_chat_params" */
  update_organizations_chat_params_by_pk?: Maybe<OrganizationsChatParams>;
  /** update multiples rows of table: "organizations_chat_params" */
  update_organizations_chat_params_many?: Maybe<Array<Maybe<OrganizationsChatParamsMutationResponse>>>;
  /** update data of the table: "organizations_feature_limits" */
  update_organizations_feature_limits?: Maybe<OrganizationsFeatureLimitsMutationResponse>;
  /** update single row of the table: "organizations_feature_limits" */
  update_organizations_feature_limits_by_pk?: Maybe<OrganizationsFeatureLimits>;
  /** update multiples rows of table: "organizations_feature_limits" */
  update_organizations_feature_limits_many?: Maybe<Array<Maybe<OrganizationsFeatureLimitsMutationResponse>>>;
  /** update multiples rows of table: "organizations" */
  update_organizations_many?: Maybe<Array<Maybe<OrganizationsMutationResponse>>>;
  /** update data of the table: "organizations_users__users_organizations" */
  update_organizations_users__users_organizations?: Maybe<OrganizationsUsersUsersOrganizationsMutationResponse>;
  /** update single row of the table: "organizations_users__users_organizations" */
  update_organizations_users__users_organizations_by_pk?: Maybe<OrganizationsUsersUsersOrganizations>;
  /** update multiples rows of table: "organizations_users__users_organizations" */
  update_organizations_users__users_organizations_many?: Maybe<Array<Maybe<OrganizationsUsersUsersOrganizationsMutationResponse>>>;
  /** update data of the table: "scene_feedback_waits" */
  update_scene_feedback_waits?: Maybe<SceneFeedbackWaitsMutationResponse>;
  /** update single row of the table: "scene_feedback_waits" */
  update_scene_feedback_waits_by_pk?: Maybe<SceneFeedbackWaits>;
  /** update multiples rows of table: "scene_feedback_waits" */
  update_scene_feedback_waits_many?: Maybe<Array<Maybe<SceneFeedbackWaitsMutationResponse>>>;
  /** update data of the table: "scene_scheduled_executions" */
  update_scene_scheduled_executions?: Maybe<SceneScheduledExecutionsMutationResponse>;
  /** update single row of the table: "scene_scheduled_executions" */
  update_scene_scheduled_executions_by_pk?: Maybe<SceneScheduledExecutions>;
  /** update multiples rows of table: "scene_scheduled_executions" */
  update_scene_scheduled_executions_many?: Maybe<Array<Maybe<SceneScheduledExecutionsMutationResponse>>>;
  /** update data of the table: "scene_timing_execution_kinds" */
  update_scene_timing_execution_kinds?: Maybe<SceneTimingExecutionKindsMutationResponse>;
  /** update single row of the table: "scene_timing_execution_kinds" */
  update_scene_timing_execution_kinds_by_pk?: Maybe<SceneTimingExecutionKinds>;
  /** update multiples rows of table: "scene_timing_execution_kinds" */
  update_scene_timing_execution_kinds_many?: Maybe<Array<Maybe<SceneTimingExecutionKindsMutationResponse>>>;
  /** update data of the table: "scenes" */
  update_scenes?: Maybe<ScenesMutationResponse>;
  /** update data of the table: "scenes__devices" */
  update_scenes__devices?: Maybe<ScenesDevicesMutationResponse>;
  /** update single row of the table: "scenes__devices" */
  update_scenes__devices_by_pk?: Maybe<ScenesDevices>;
  /** update multiples rows of table: "scenes__devices" */
  update_scenes__devices_many?: Maybe<Array<Maybe<ScenesDevicesMutationResponse>>>;
  /** update single row of the table: "scenes" */
  update_scenes_by_pk?: Maybe<Scenes>;
  /** update multiples rows of table: "scenes" */
  update_scenes_many?: Maybe<Array<Maybe<ScenesMutationResponse>>>;
  /** update data of the table: "substrates" */
  update_substrates?: Maybe<SubstratesMutationResponse>;
  /** update single row of the table: "substrates" */
  update_substrates_by_pk?: Maybe<Substrates>;
  /** update multiples rows of table: "substrates" */
  update_substrates_many?: Maybe<Array<Maybe<SubstratesMutationResponse>>>;
  /** update data of the table: "telegram_users" */
  update_telegram_users?: Maybe<TelegramUsersMutationResponse>;
  /** update single row of the table: "telegram_users" */
  update_telegram_users_by_pk?: Maybe<TelegramUsers>;
  /** update multiples rows of table: "telegram_users" */
  update_telegram_users_many?: Maybe<Array<Maybe<TelegramUsersMutationResponse>>>;
  /** update data of the table: "uplink_dynamo_ref" */
  update_uplink_dynamo_ref?: Maybe<UplinkDynamoRefMutationResponse>;
  /** update single row of the table: "uplink_dynamo_ref" */
  update_uplink_dynamo_ref_by_pk?: Maybe<UplinkDynamoRef>;
  /** update multiples rows of table: "uplink_dynamo_ref" */
  update_uplink_dynamo_ref_many?: Maybe<Array<Maybe<UplinkDynamoRefMutationResponse>>>;
  /** update data of the table: "user_roles" */
  update_user_roles?: Maybe<UserRolesMutationResponse>;
  /** update data of the table: "user_roles__users_permissions_user" */
  update_user_roles__users_permissions_user?: Maybe<UserRolesUsersPermissionsUserMutationResponse>;
  /** update single row of the table: "user_roles__users_permissions_user" */
  update_user_roles__users_permissions_user_by_pk?: Maybe<UserRolesUsersPermissionsUser>;
  /** update multiples rows of table: "user_roles__users_permissions_user" */
  update_user_roles__users_permissions_user_many?: Maybe<Array<Maybe<UserRolesUsersPermissionsUserMutationResponse>>>;
  /** update single row of the table: "user_roles" */
  update_user_roles_by_pk?: Maybe<UserRoles>;
  /** update multiples rows of table: "user_roles" */
  update_user_roles_many?: Maybe<Array<Maybe<UserRolesMutationResponse>>>;
  /** update data of the table: "users_permissions_user" */
  update_users_permissions_user?: Maybe<UsersPermissionsUserMutationResponse>;
  /** update single row of the table: "users_permissions_user" */
  update_users_permissions_user_by_pk?: Maybe<UsersPermissionsUser>;
  /** update multiples rows of table: "users_permissions_user" */
  update_users_permissions_user_many?: Maybe<Array<Maybe<UsersPermissionsUserMutationResponse>>>;
  user_create: CreateUserOutput;
};


/** mutation root */
export type MutationRootAnalysisApplicationCreateArgs = {
  args: AnalysisApplicationCreateInput;
};


/** mutation root */
export type MutationRootAnalysisApplicationUpdateArgs = {
  args: AnalysisApplicationUpdateInput;
};


/** mutation root */
export type MutationRootAreaCreateArgs = {
  args: AreaCreateInput;
};


/** mutation root */
export type MutationRootAreaUpdateArgs = {
  args: AreaUpdateInput;
};


/** mutation root */
export type MutationRootAutomationDuplicateArgs = {
  args: AutomationDuplicateInput;
};


/** mutation root */
export type MutationRootDeleteAnalysisArgs = {
  where: AnalysisBoolExp;
};


/** mutation root */
export type MutationRootDeleteAnalysisDevicesPayloadsArgs = {
  where: AnalysisDevicesPayloadsBoolExp;
};


/** mutation root */
export type MutationRootDeleteAnalysisDevicesPayloadsByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteAnalysisApplicationsArgs = {
  where: AnalysisApplicationsBoolExp;
};


/** mutation root */
export type MutationRootDeleteAnalysisApplicationsDevicesArgs = {
  where: AnalysisApplicationsDevicesBoolExp;
};


/** mutation root */
export type MutationRootDeleteAnalysisApplicationsDevicesByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteAnalysisApplicationsByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteAnalysisApplicationsComputedArgs = {
  where: AnalysisApplicationsComputedBoolExp;
};


/** mutation root */
export type MutationRootDeleteAnalysisApplicationsComputedByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteAnalysisApplicationsComputedValuesArgs = {
  where: AnalysisApplicationsComputedValuesBoolExp;
};


/** mutation root */
export type MutationRootDeleteAnalysisApplicationsComputedValuesByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteAnalysisApplicationsComputedValuesKindsArgs = {
  where: AnalysisApplicationsComputedValuesKindsBoolExp;
};


/** mutation root */
export type MutationRootDeleteAnalysisApplicationsComputedValuesKindsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteAnalysisByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteAnalysisDeviceCategoriesConfigsArgs = {
  where: AnalysisDeviceCategoriesConfigsBoolExp;
};


/** mutation root */
export type MutationRootDeleteAnalysisDeviceCategoriesConfigsByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteAnalysisGroupsArgs = {
  where: AnalysisGroupsBoolExp;
};


/** mutation root */
export type MutationRootDeleteAnalysisGroupsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteAnalysisKindsArgs = {
  where: AnalysisKindsBoolExp;
};


/** mutation root */
export type MutationRootDeleteAnalysisKindsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteApplicationsArgs = {
  where: ApplicationsBoolExp;
};


/** mutation root */
export type MutationRootDeleteApplicationsByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteApplicationsDashboardsArgs = {
  where: ApplicationsDashboardsBoolExp;
};


/** mutation root */
export type MutationRootDeleteApplicationsDashboardsAnalysisArgs = {
  where: ApplicationsDashboardsAnalysisBoolExp;
};


/** mutation root */
export type MutationRootDeleteApplicationsDashboardsAnalysisByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteApplicationsDashboardsByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteApplicationsDashboardsDevicesArgs = {
  where: ApplicationsDashboardsDevicesBoolExp;
};


/** mutation root */
export type MutationRootDeleteApplicationsDashboardsDevicesByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteApplicationsSettingsArgs = {
  where: ApplicationsSettingsBoolExp;
};


/** mutation root */
export type MutationRootDeleteApplicationsSettingsByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteAreasArgs = {
  where: AreasBoolExp;
};


/** mutation root */
export type MutationRootDeleteAreasByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteAreasScopeCultivationArgs = {
  where: AreasScopeCultivationBoolExp;
};


/** mutation root */
export type MutationRootDeleteAreasScopeCultivationByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteAreasScopesArgs = {
  where: AreasScopesBoolExp;
};


/** mutation root */
export type MutationRootDeleteAreasScopesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteAutomationTimingExecutionKindsArgs = {
  where: AutomationTimingExecutionKindsBoolExp;
};


/** mutation root */
export type MutationRootDeleteAutomationTimingExecutionKindsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteAutomationsArgs = {
  where: AutomationsBoolExp;
};


/** mutation root */
export type MutationRootDeleteAutomationsByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteAutomationsWatchingsArgs = {
  where: AutomationsWatchingsBoolExp;
};


/** mutation root */
export type MutationRootDeleteAutomationsWatchingsByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteChatMessageTypesArgs = {
  where: ChatMessageTypesBoolExp;
};


/** mutation root */
export type MutationRootDeleteChatMessageTypesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteChatMessagesArgs = {
  where: ChatMessagesBoolExp;
};


/** mutation root */
export type MutationRootDeleteChatMessagesByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteCultivationTypesArgs = {
  where: CultivationTypesBoolExp;
};


/** mutation root */
export type MutationRootDeleteCultivationTypesByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteDeviceActionsArgs = {
  where: DeviceActionsBoolExp;
};


/** mutation root */
export type MutationRootDeleteDeviceActionsByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteDeviceCategoriesArgs = {
  where: DeviceCategoriesBoolExp;
};


/** mutation root */
export type MutationRootDeleteDeviceCategoriesByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteDevicePayloadValuesArgs = {
  where: DevicePayloadValuesBoolExp;
};


/** mutation root */
export type MutationRootDeleteDevicePayloadValuesByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteDevicePayloadsArgs = {
  where: DevicePayloadsBoolExp;
};


/** mutation root */
export type MutationRootDeleteDevicePayloadsPayloadValuesArgs = {
  where: DevicePayloadsPayloadValuesBoolExp;
};


/** mutation root */
export type MutationRootDeleteDevicePayloadsPayloadValuesByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteDevicePayloadsByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteDevicesArgs = {
  where: DevicesBoolExp;
};


/** mutation root */
export type MutationRootDeleteDevicesDeviceActionsArgs = {
  where: DevicesDeviceActionsBoolExp;
};


/** mutation root */
export type MutationRootDeleteDevicesDeviceActionsByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteDevicesDeviceCategoriesArgs = {
  where: DevicesDeviceCategoriesBoolExp;
};


/** mutation root */
export type MutationRootDeleteDevicesDeviceCategoriesByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteDevicesDevicePayloadsArgs = {
  where: DevicesDevicePayloadsBoolExp;
};


/** mutation root */
export type MutationRootDeleteDevicesDevicePayloadsByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteDevicesByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteDownlinksArgs = {
  where: DownlinksBoolExp;
};


/** mutation root */
export type MutationRootDeleteDownlinksByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteFarmingContainersArgs = {
  where: FarmingContainersBoolExp;
};


/** mutation root */
export type MutationRootDeleteFarmingContainersByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteFarmingMethodsArgs = {
  where: FarmingMethodsBoolExp;
};


/** mutation root */
export type MutationRootDeleteFarmingMethodsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteFarmingStructuresArgs = {
  where: FarmingStructuresBoolExp;
};


/** mutation root */
export type MutationRootDeleteFarmingStructuresByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteNotificationEventTypesArgs = {
  where: NotificationEventTypesBoolExp;
};


/** mutation root */
export type MutationRootDeleteNotificationEventTypesByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteNotificationKindsArgs = {
  where: NotificationKindsBoolExp;
};


/** mutation root */
export type MutationRootDeleteNotificationKindsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteNotificationUserDevicesArgs = {
  where: NotificationUserDevicesBoolExp;
};


/** mutation root */
export type MutationRootDeleteNotificationUserDevicesEventTypesArgs = {
  where: NotificationUserDevicesEventTypesBoolExp;
};


/** mutation root */
export type MutationRootDeleteNotificationUserDevicesEventTypesByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteNotificationUserDevicesByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteNotificationUserSettingsArgs = {
  where: NotificationUserSettingsBoolExp;
};


/** mutation root */
export type MutationRootDeleteNotificationUserSettingsByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteNotificationsArgs = {
  where: NotificationsBoolExp;
};


/** mutation root */
export type MutationRootDeleteNotificationsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteNotificationsContentArgs = {
  where: NotificationsContentBoolExp;
};


/** mutation root */
export type MutationRootDeleteNotificationsContentByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteOrganizationsArgs = {
  where: OrganizationsBoolExp;
};


/** mutation root */
export type MutationRootDeleteOrganizationsByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteOrganizationsChatParamsArgs = {
  where: OrganizationsChatParamsBoolExp;
};


/** mutation root */
export type MutationRootDeleteOrganizationsChatParamsByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteOrganizationsFeatureLimitsArgs = {
  where: OrganizationsFeatureLimitsBoolExp;
};


/** mutation root */
export type MutationRootDeleteOrganizationsFeatureLimitsByPkArgs = {
  id: Scalars['Int'];
  organization_id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteOrganizationsUsersUsersOrganizationsArgs = {
  where: OrganizationsUsersUsersOrganizationsBoolExp;
};


/** mutation root */
export type MutationRootDeleteOrganizationsUsersUsersOrganizationsByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteSceneFeedbackWaitsArgs = {
  where: SceneFeedbackWaitsBoolExp;
};


/** mutation root */
export type MutationRootDeleteSceneFeedbackWaitsByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteSceneScheduledExecutionsArgs = {
  where: SceneScheduledExecutionsBoolExp;
};


/** mutation root */
export type MutationRootDeleteSceneScheduledExecutionsByPkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteSceneTimingExecutionKindsArgs = {
  where: SceneTimingExecutionKindsBoolExp;
};


/** mutation root */
export type MutationRootDeleteSceneTimingExecutionKindsByPkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteScenesArgs = {
  where: ScenesBoolExp;
};


/** mutation root */
export type MutationRootDeleteScenesDevicesArgs = {
  where: ScenesDevicesBoolExp;
};


/** mutation root */
export type MutationRootDeleteScenesDevicesByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteScenesByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteSubstratesArgs = {
  where: SubstratesBoolExp;
};


/** mutation root */
export type MutationRootDeleteSubstratesByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteTelegramUsersArgs = {
  where: TelegramUsersBoolExp;
};


/** mutation root */
export type MutationRootDeleteTelegramUsersByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteUplinkDynamoRefArgs = {
  where: UplinkDynamoRefBoolExp;
};


/** mutation root */
export type MutationRootDeleteUplinkDynamoRefByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteUserRolesArgs = {
  where: UserRolesBoolExp;
};


/** mutation root */
export type MutationRootDeleteUserRolesUsersPermissionsUserArgs = {
  where: UserRolesUsersPermissionsUserBoolExp;
};


/** mutation root */
export type MutationRootDeleteUserRolesUsersPermissionsUserByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteUserRolesByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteUsersPermissionsUserArgs = {
  where: UsersPermissionsUserBoolExp;
};


/** mutation root */
export type MutationRootDeleteUsersPermissionsUserByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeviceDownlinkArgs = {
  args: DeviceDownlinkInput;
};


/** mutation root */
export type MutationRootInsertAnalysisArgs = {
  objects: Array<AnalysisInsertInput>;
  on_conflict?: InputMaybe<AnalysisOnConflict>;
};


/** mutation root */
export type MutationRootInsertAnalysisDevicesPayloadsArgs = {
  objects: Array<AnalysisDevicesPayloadsInsertInput>;
  on_conflict?: InputMaybe<AnalysisDevicesPayloadsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAnalysisDevicesPayloadsOneArgs = {
  object: AnalysisDevicesPayloadsInsertInput;
  on_conflict?: InputMaybe<AnalysisDevicesPayloadsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAnalysisApplicationsArgs = {
  objects: Array<AnalysisApplicationsInsertInput>;
  on_conflict?: InputMaybe<AnalysisApplicationsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAnalysisApplicationsDevicesArgs = {
  objects: Array<AnalysisApplicationsDevicesInsertInput>;
  on_conflict?: InputMaybe<AnalysisApplicationsDevicesOnConflict>;
};


/** mutation root */
export type MutationRootInsertAnalysisApplicationsDevicesOneArgs = {
  object: AnalysisApplicationsDevicesInsertInput;
  on_conflict?: InputMaybe<AnalysisApplicationsDevicesOnConflict>;
};


/** mutation root */
export type MutationRootInsertAnalysisApplicationsComputedArgs = {
  objects: Array<AnalysisApplicationsComputedInsertInput>;
  on_conflict?: InputMaybe<AnalysisApplicationsComputedOnConflict>;
};


/** mutation root */
export type MutationRootInsertAnalysisApplicationsComputedOneArgs = {
  object: AnalysisApplicationsComputedInsertInput;
  on_conflict?: InputMaybe<AnalysisApplicationsComputedOnConflict>;
};


/** mutation root */
export type MutationRootInsertAnalysisApplicationsComputedValuesArgs = {
  objects: Array<AnalysisApplicationsComputedValuesInsertInput>;
  on_conflict?: InputMaybe<AnalysisApplicationsComputedValuesOnConflict>;
};


/** mutation root */
export type MutationRootInsertAnalysisApplicationsComputedValuesKindsArgs = {
  objects: Array<AnalysisApplicationsComputedValuesKindsInsertInput>;
  on_conflict?: InputMaybe<AnalysisApplicationsComputedValuesKindsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAnalysisApplicationsComputedValuesKindsOneArgs = {
  object: AnalysisApplicationsComputedValuesKindsInsertInput;
  on_conflict?: InputMaybe<AnalysisApplicationsComputedValuesKindsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAnalysisApplicationsComputedValuesOneArgs = {
  object: AnalysisApplicationsComputedValuesInsertInput;
  on_conflict?: InputMaybe<AnalysisApplicationsComputedValuesOnConflict>;
};


/** mutation root */
export type MutationRootInsertAnalysisApplicationsOneArgs = {
  object: AnalysisApplicationsInsertInput;
  on_conflict?: InputMaybe<AnalysisApplicationsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAnalysisDeviceCategoriesConfigsArgs = {
  objects: Array<AnalysisDeviceCategoriesConfigsInsertInput>;
  on_conflict?: InputMaybe<AnalysisDeviceCategoriesConfigsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAnalysisDeviceCategoriesConfigsOneArgs = {
  object: AnalysisDeviceCategoriesConfigsInsertInput;
  on_conflict?: InputMaybe<AnalysisDeviceCategoriesConfigsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAnalysisGroupsArgs = {
  objects: Array<AnalysisGroupsInsertInput>;
  on_conflict?: InputMaybe<AnalysisGroupsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAnalysisGroupsOneArgs = {
  object: AnalysisGroupsInsertInput;
  on_conflict?: InputMaybe<AnalysisGroupsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAnalysisKindsArgs = {
  objects: Array<AnalysisKindsInsertInput>;
  on_conflict?: InputMaybe<AnalysisKindsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAnalysisKindsOneArgs = {
  object: AnalysisKindsInsertInput;
  on_conflict?: InputMaybe<AnalysisKindsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAnalysisOneArgs = {
  object: AnalysisInsertInput;
  on_conflict?: InputMaybe<AnalysisOnConflict>;
};


/** mutation root */
export type MutationRootInsertApplicationsArgs = {
  objects: Array<ApplicationsInsertInput>;
  on_conflict?: InputMaybe<ApplicationsOnConflict>;
};


/** mutation root */
export type MutationRootInsertApplicationsDashboardsArgs = {
  objects: Array<ApplicationsDashboardsInsertInput>;
  on_conflict?: InputMaybe<ApplicationsDashboardsOnConflict>;
};


/** mutation root */
export type MutationRootInsertApplicationsDashboardsAnalysisArgs = {
  objects: Array<ApplicationsDashboardsAnalysisInsertInput>;
  on_conflict?: InputMaybe<ApplicationsDashboardsAnalysisOnConflict>;
};


/** mutation root */
export type MutationRootInsertApplicationsDashboardsAnalysisOneArgs = {
  object: ApplicationsDashboardsAnalysisInsertInput;
  on_conflict?: InputMaybe<ApplicationsDashboardsAnalysisOnConflict>;
};


/** mutation root */
export type MutationRootInsertApplicationsDashboardsDevicesArgs = {
  objects: Array<ApplicationsDashboardsDevicesInsertInput>;
  on_conflict?: InputMaybe<ApplicationsDashboardsDevicesOnConflict>;
};


/** mutation root */
export type MutationRootInsertApplicationsDashboardsDevicesOneArgs = {
  object: ApplicationsDashboardsDevicesInsertInput;
  on_conflict?: InputMaybe<ApplicationsDashboardsDevicesOnConflict>;
};


/** mutation root */
export type MutationRootInsertApplicationsDashboardsOneArgs = {
  object: ApplicationsDashboardsInsertInput;
  on_conflict?: InputMaybe<ApplicationsDashboardsOnConflict>;
};


/** mutation root */
export type MutationRootInsertApplicationsOneArgs = {
  object: ApplicationsInsertInput;
  on_conflict?: InputMaybe<ApplicationsOnConflict>;
};


/** mutation root */
export type MutationRootInsertApplicationsSettingsArgs = {
  objects: Array<ApplicationsSettingsInsertInput>;
  on_conflict?: InputMaybe<ApplicationsSettingsOnConflict>;
};


/** mutation root */
export type MutationRootInsertApplicationsSettingsOneArgs = {
  object: ApplicationsSettingsInsertInput;
  on_conflict?: InputMaybe<ApplicationsSettingsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAreasArgs = {
  objects: Array<AreasInsertInput>;
  on_conflict?: InputMaybe<AreasOnConflict>;
};


/** mutation root */
export type MutationRootInsertAreasOneArgs = {
  object: AreasInsertInput;
  on_conflict?: InputMaybe<AreasOnConflict>;
};


/** mutation root */
export type MutationRootInsertAreasScopeCultivationArgs = {
  objects: Array<AreasScopeCultivationInsertInput>;
  on_conflict?: InputMaybe<AreasScopeCultivationOnConflict>;
};


/** mutation root */
export type MutationRootInsertAreasScopeCultivationOneArgs = {
  object: AreasScopeCultivationInsertInput;
  on_conflict?: InputMaybe<AreasScopeCultivationOnConflict>;
};


/** mutation root */
export type MutationRootInsertAreasScopesArgs = {
  objects: Array<AreasScopesInsertInput>;
  on_conflict?: InputMaybe<AreasScopesOnConflict>;
};


/** mutation root */
export type MutationRootInsertAreasScopesOneArgs = {
  object: AreasScopesInsertInput;
  on_conflict?: InputMaybe<AreasScopesOnConflict>;
};


/** mutation root */
export type MutationRootInsertAutomationTimingExecutionKindsArgs = {
  objects: Array<AutomationTimingExecutionKindsInsertInput>;
  on_conflict?: InputMaybe<AutomationTimingExecutionKindsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAutomationTimingExecutionKindsOneArgs = {
  object: AutomationTimingExecutionKindsInsertInput;
  on_conflict?: InputMaybe<AutomationTimingExecutionKindsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAutomationsArgs = {
  objects: Array<AutomationsInsertInput>;
  on_conflict?: InputMaybe<AutomationsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAutomationsOneArgs = {
  object: AutomationsInsertInput;
  on_conflict?: InputMaybe<AutomationsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAutomationsWatchingsArgs = {
  objects: Array<AutomationsWatchingsInsertInput>;
  on_conflict?: InputMaybe<AutomationsWatchingsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAutomationsWatchingsOneArgs = {
  object: AutomationsWatchingsInsertInput;
  on_conflict?: InputMaybe<AutomationsWatchingsOnConflict>;
};


/** mutation root */
export type MutationRootInsertChatMessageTypesArgs = {
  objects: Array<ChatMessageTypesInsertInput>;
  on_conflict?: InputMaybe<ChatMessageTypesOnConflict>;
};


/** mutation root */
export type MutationRootInsertChatMessageTypesOneArgs = {
  object: ChatMessageTypesInsertInput;
  on_conflict?: InputMaybe<ChatMessageTypesOnConflict>;
};


/** mutation root */
export type MutationRootInsertChatMessagesArgs = {
  objects: Array<ChatMessagesInsertInput>;
  on_conflict?: InputMaybe<ChatMessagesOnConflict>;
};


/** mutation root */
export type MutationRootInsertChatMessagesOneArgs = {
  object: ChatMessagesInsertInput;
  on_conflict?: InputMaybe<ChatMessagesOnConflict>;
};


/** mutation root */
export type MutationRootInsertCultivationTypesArgs = {
  objects: Array<CultivationTypesInsertInput>;
  on_conflict?: InputMaybe<CultivationTypesOnConflict>;
};


/** mutation root */
export type MutationRootInsertCultivationTypesOneArgs = {
  object: CultivationTypesInsertInput;
  on_conflict?: InputMaybe<CultivationTypesOnConflict>;
};


/** mutation root */
export type MutationRootInsertDeviceActionsArgs = {
  objects: Array<DeviceActionsInsertInput>;
  on_conflict?: InputMaybe<DeviceActionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertDeviceActionsOneArgs = {
  object: DeviceActionsInsertInput;
  on_conflict?: InputMaybe<DeviceActionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertDeviceCategoriesArgs = {
  objects: Array<DeviceCategoriesInsertInput>;
  on_conflict?: InputMaybe<DeviceCategoriesOnConflict>;
};


/** mutation root */
export type MutationRootInsertDeviceCategoriesOneArgs = {
  object: DeviceCategoriesInsertInput;
  on_conflict?: InputMaybe<DeviceCategoriesOnConflict>;
};


/** mutation root */
export type MutationRootInsertDevicePayloadValuesArgs = {
  objects: Array<DevicePayloadValuesInsertInput>;
  on_conflict?: InputMaybe<DevicePayloadValuesOnConflict>;
};


/** mutation root */
export type MutationRootInsertDevicePayloadValuesOneArgs = {
  object: DevicePayloadValuesInsertInput;
  on_conflict?: InputMaybe<DevicePayloadValuesOnConflict>;
};


/** mutation root */
export type MutationRootInsertDevicePayloadsArgs = {
  objects: Array<DevicePayloadsInsertInput>;
  on_conflict?: InputMaybe<DevicePayloadsOnConflict>;
};


/** mutation root */
export type MutationRootInsertDevicePayloadsPayloadValuesArgs = {
  objects: Array<DevicePayloadsPayloadValuesInsertInput>;
  on_conflict?: InputMaybe<DevicePayloadsPayloadValuesOnConflict>;
};


/** mutation root */
export type MutationRootInsertDevicePayloadsPayloadValuesOneArgs = {
  object: DevicePayloadsPayloadValuesInsertInput;
  on_conflict?: InputMaybe<DevicePayloadsPayloadValuesOnConflict>;
};


/** mutation root */
export type MutationRootInsertDevicePayloadsOneArgs = {
  object: DevicePayloadsInsertInput;
  on_conflict?: InputMaybe<DevicePayloadsOnConflict>;
};


/** mutation root */
export type MutationRootInsertDevicesArgs = {
  objects: Array<DevicesInsertInput>;
  on_conflict?: InputMaybe<DevicesOnConflict>;
};


/** mutation root */
export type MutationRootInsertDevicesDeviceActionsArgs = {
  objects: Array<DevicesDeviceActionsInsertInput>;
  on_conflict?: InputMaybe<DevicesDeviceActionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertDevicesDeviceActionsOneArgs = {
  object: DevicesDeviceActionsInsertInput;
  on_conflict?: InputMaybe<DevicesDeviceActionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertDevicesDeviceCategoriesArgs = {
  objects: Array<DevicesDeviceCategoriesInsertInput>;
  on_conflict?: InputMaybe<DevicesDeviceCategoriesOnConflict>;
};


/** mutation root */
export type MutationRootInsertDevicesDeviceCategoriesOneArgs = {
  object: DevicesDeviceCategoriesInsertInput;
  on_conflict?: InputMaybe<DevicesDeviceCategoriesOnConflict>;
};


/** mutation root */
export type MutationRootInsertDevicesDevicePayloadsArgs = {
  objects: Array<DevicesDevicePayloadsInsertInput>;
  on_conflict?: InputMaybe<DevicesDevicePayloadsOnConflict>;
};


/** mutation root */
export type MutationRootInsertDevicesDevicePayloadsOneArgs = {
  object: DevicesDevicePayloadsInsertInput;
  on_conflict?: InputMaybe<DevicesDevicePayloadsOnConflict>;
};


/** mutation root */
export type MutationRootInsertDevicesOneArgs = {
  object: DevicesInsertInput;
  on_conflict?: InputMaybe<DevicesOnConflict>;
};


/** mutation root */
export type MutationRootInsertDownlinksArgs = {
  objects: Array<DownlinksInsertInput>;
  on_conflict?: InputMaybe<DownlinksOnConflict>;
};


/** mutation root */
export type MutationRootInsertDownlinksOneArgs = {
  object: DownlinksInsertInput;
  on_conflict?: InputMaybe<DownlinksOnConflict>;
};


/** mutation root */
export type MutationRootInsertFarmingContainersArgs = {
  objects: Array<FarmingContainersInsertInput>;
  on_conflict?: InputMaybe<FarmingContainersOnConflict>;
};


/** mutation root */
export type MutationRootInsertFarmingContainersOneArgs = {
  object: FarmingContainersInsertInput;
  on_conflict?: InputMaybe<FarmingContainersOnConflict>;
};


/** mutation root */
export type MutationRootInsertFarmingMethodsArgs = {
  objects: Array<FarmingMethodsInsertInput>;
  on_conflict?: InputMaybe<FarmingMethodsOnConflict>;
};


/** mutation root */
export type MutationRootInsertFarmingMethodsOneArgs = {
  object: FarmingMethodsInsertInput;
  on_conflict?: InputMaybe<FarmingMethodsOnConflict>;
};


/** mutation root */
export type MutationRootInsertFarmingStructuresArgs = {
  objects: Array<FarmingStructuresInsertInput>;
  on_conflict?: InputMaybe<FarmingStructuresOnConflict>;
};


/** mutation root */
export type MutationRootInsertFarmingStructuresOneArgs = {
  object: FarmingStructuresInsertInput;
  on_conflict?: InputMaybe<FarmingStructuresOnConflict>;
};


/** mutation root */
export type MutationRootInsertNotificationEventTypesArgs = {
  objects: Array<NotificationEventTypesInsertInput>;
  on_conflict?: InputMaybe<NotificationEventTypesOnConflict>;
};


/** mutation root */
export type MutationRootInsertNotificationEventTypesOneArgs = {
  object: NotificationEventTypesInsertInput;
  on_conflict?: InputMaybe<NotificationEventTypesOnConflict>;
};


/** mutation root */
export type MutationRootInsertNotificationKindsArgs = {
  objects: Array<NotificationKindsInsertInput>;
  on_conflict?: InputMaybe<NotificationKindsOnConflict>;
};


/** mutation root */
export type MutationRootInsertNotificationKindsOneArgs = {
  object: NotificationKindsInsertInput;
  on_conflict?: InputMaybe<NotificationKindsOnConflict>;
};


/** mutation root */
export type MutationRootInsertNotificationUserDevicesArgs = {
  objects: Array<NotificationUserDevicesInsertInput>;
  on_conflict?: InputMaybe<NotificationUserDevicesOnConflict>;
};


/** mutation root */
export type MutationRootInsertNotificationUserDevicesEventTypesArgs = {
  objects: Array<NotificationUserDevicesEventTypesInsertInput>;
  on_conflict?: InputMaybe<NotificationUserDevicesEventTypesOnConflict>;
};


/** mutation root */
export type MutationRootInsertNotificationUserDevicesEventTypesOneArgs = {
  object: NotificationUserDevicesEventTypesInsertInput;
  on_conflict?: InputMaybe<NotificationUserDevicesEventTypesOnConflict>;
};


/** mutation root */
export type MutationRootInsertNotificationUserDevicesOneArgs = {
  object: NotificationUserDevicesInsertInput;
  on_conflict?: InputMaybe<NotificationUserDevicesOnConflict>;
};


/** mutation root */
export type MutationRootInsertNotificationUserSettingsArgs = {
  objects: Array<NotificationUserSettingsInsertInput>;
  on_conflict?: InputMaybe<NotificationUserSettingsOnConflict>;
};


/** mutation root */
export type MutationRootInsertNotificationUserSettingsOneArgs = {
  object: NotificationUserSettingsInsertInput;
  on_conflict?: InputMaybe<NotificationUserSettingsOnConflict>;
};


/** mutation root */
export type MutationRootInsertNotificationsArgs = {
  objects: Array<NotificationsInsertInput>;
  on_conflict?: InputMaybe<NotificationsOnConflict>;
};


/** mutation root */
export type MutationRootInsertNotificationsContentArgs = {
  objects: Array<NotificationsContentInsertInput>;
  on_conflict?: InputMaybe<NotificationsContentOnConflict>;
};


/** mutation root */
export type MutationRootInsertNotificationsContentOneArgs = {
  object: NotificationsContentInsertInput;
  on_conflict?: InputMaybe<NotificationsContentOnConflict>;
};


/** mutation root */
export type MutationRootInsertNotificationsOneArgs = {
  object: NotificationsInsertInput;
  on_conflict?: InputMaybe<NotificationsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganizationsArgs = {
  objects: Array<OrganizationsInsertInput>;
  on_conflict?: InputMaybe<OrganizationsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganizationsChatParamsArgs = {
  objects: Array<OrganizationsChatParamsInsertInput>;
  on_conflict?: InputMaybe<OrganizationsChatParamsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganizationsChatParamsOneArgs = {
  object: OrganizationsChatParamsInsertInput;
  on_conflict?: InputMaybe<OrganizationsChatParamsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganizationsFeatureLimitsArgs = {
  objects: Array<OrganizationsFeatureLimitsInsertInput>;
  on_conflict?: InputMaybe<OrganizationsFeatureLimitsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganizationsFeatureLimitsOneArgs = {
  object: OrganizationsFeatureLimitsInsertInput;
  on_conflict?: InputMaybe<OrganizationsFeatureLimitsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganizationsOneArgs = {
  object: OrganizationsInsertInput;
  on_conflict?: InputMaybe<OrganizationsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganizationsUsersUsersOrganizationsArgs = {
  objects: Array<OrganizationsUsersUsersOrganizationsInsertInput>;
  on_conflict?: InputMaybe<OrganizationsUsersUsersOrganizationsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganizationsUsersUsersOrganizationsOneArgs = {
  object: OrganizationsUsersUsersOrganizationsInsertInput;
  on_conflict?: InputMaybe<OrganizationsUsersUsersOrganizationsOnConflict>;
};


/** mutation root */
export type MutationRootInsertSceneFeedbackWaitsArgs = {
  objects: Array<SceneFeedbackWaitsInsertInput>;
  on_conflict?: InputMaybe<SceneFeedbackWaitsOnConflict>;
};


/** mutation root */
export type MutationRootInsertSceneFeedbackWaitsOneArgs = {
  object: SceneFeedbackWaitsInsertInput;
  on_conflict?: InputMaybe<SceneFeedbackWaitsOnConflict>;
};


/** mutation root */
export type MutationRootInsertSceneScheduledExecutionsArgs = {
  objects: Array<SceneScheduledExecutionsInsertInput>;
  on_conflict?: InputMaybe<SceneScheduledExecutionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertSceneScheduledExecutionsOneArgs = {
  object: SceneScheduledExecutionsInsertInput;
  on_conflict?: InputMaybe<SceneScheduledExecutionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertSceneTimingExecutionKindsArgs = {
  objects: Array<SceneTimingExecutionKindsInsertInput>;
  on_conflict?: InputMaybe<SceneTimingExecutionKindsOnConflict>;
};


/** mutation root */
export type MutationRootInsertSceneTimingExecutionKindsOneArgs = {
  object: SceneTimingExecutionKindsInsertInput;
  on_conflict?: InputMaybe<SceneTimingExecutionKindsOnConflict>;
};


/** mutation root */
export type MutationRootInsertScenesArgs = {
  objects: Array<ScenesInsertInput>;
  on_conflict?: InputMaybe<ScenesOnConflict>;
};


/** mutation root */
export type MutationRootInsertScenesDevicesArgs = {
  objects: Array<ScenesDevicesInsertInput>;
  on_conflict?: InputMaybe<ScenesDevicesOnConflict>;
};


/** mutation root */
export type MutationRootInsertScenesDevicesOneArgs = {
  object: ScenesDevicesInsertInput;
  on_conflict?: InputMaybe<ScenesDevicesOnConflict>;
};


/** mutation root */
export type MutationRootInsertScenesOneArgs = {
  object: ScenesInsertInput;
  on_conflict?: InputMaybe<ScenesOnConflict>;
};


/** mutation root */
export type MutationRootInsertSubstratesArgs = {
  objects: Array<SubstratesInsertInput>;
  on_conflict?: InputMaybe<SubstratesOnConflict>;
};


/** mutation root */
export type MutationRootInsertSubstratesOneArgs = {
  object: SubstratesInsertInput;
  on_conflict?: InputMaybe<SubstratesOnConflict>;
};


/** mutation root */
export type MutationRootInsertTelegramUsersArgs = {
  objects: Array<TelegramUsersInsertInput>;
  on_conflict?: InputMaybe<TelegramUsersOnConflict>;
};


/** mutation root */
export type MutationRootInsertTelegramUsersOneArgs = {
  object: TelegramUsersInsertInput;
  on_conflict?: InputMaybe<TelegramUsersOnConflict>;
};


/** mutation root */
export type MutationRootInsertUplinkDynamoRefArgs = {
  objects: Array<UplinkDynamoRefInsertInput>;
  on_conflict?: InputMaybe<UplinkDynamoRefOnConflict>;
};


/** mutation root */
export type MutationRootInsertUplinkDynamoRefOneArgs = {
  object: UplinkDynamoRefInsertInput;
  on_conflict?: InputMaybe<UplinkDynamoRefOnConflict>;
};


/** mutation root */
export type MutationRootInsertUserRolesArgs = {
  objects: Array<UserRolesInsertInput>;
  on_conflict?: InputMaybe<UserRolesOnConflict>;
};


/** mutation root */
export type MutationRootInsertUserRolesUsersPermissionsUserArgs = {
  objects: Array<UserRolesUsersPermissionsUserInsertInput>;
  on_conflict?: InputMaybe<UserRolesUsersPermissionsUserOnConflict>;
};


/** mutation root */
export type MutationRootInsertUserRolesUsersPermissionsUserOneArgs = {
  object: UserRolesUsersPermissionsUserInsertInput;
  on_conflict?: InputMaybe<UserRolesUsersPermissionsUserOnConflict>;
};


/** mutation root */
export type MutationRootInsertUserRolesOneArgs = {
  object: UserRolesInsertInput;
  on_conflict?: InputMaybe<UserRolesOnConflict>;
};


/** mutation root */
export type MutationRootInsertUsersPermissionsUserArgs = {
  objects: Array<UsersPermissionsUserInsertInput>;
  on_conflict?: InputMaybe<UsersPermissionsUserOnConflict>;
};


/** mutation root */
export type MutationRootInsertUsersPermissionsUserOneArgs = {
  object: UsersPermissionsUserInsertInput;
  on_conflict?: InputMaybe<UsersPermissionsUserOnConflict>;
};


/** mutation root */
export type MutationRootUpdateAnalysisArgs = {
  _inc?: InputMaybe<AnalysisIncInput>;
  _set?: InputMaybe<AnalysisSetInput>;
  where: AnalysisBoolExp;
};


/** mutation root */
export type MutationRootUpdateAnalysisDevicesPayloadsArgs = {
  _inc?: InputMaybe<AnalysisDevicesPayloadsIncInput>;
  _set?: InputMaybe<AnalysisDevicesPayloadsSetInput>;
  where: AnalysisDevicesPayloadsBoolExp;
};


/** mutation root */
export type MutationRootUpdateAnalysisDevicesPayloadsByPkArgs = {
  _inc?: InputMaybe<AnalysisDevicesPayloadsIncInput>;
  _set?: InputMaybe<AnalysisDevicesPayloadsSetInput>;
  pk_columns: AnalysisDevicesPayloadsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAnalysisDevicesPayloadsManyArgs = {
  updates: Array<AnalysisDevicesPayloadsUpdates>;
};


/** mutation root */
export type MutationRootUpdateAnalysisApplicationsArgs = {
  _inc?: InputMaybe<AnalysisApplicationsIncInput>;
  _set?: InputMaybe<AnalysisApplicationsSetInput>;
  where: AnalysisApplicationsBoolExp;
};


/** mutation root */
export type MutationRootUpdateAnalysisApplicationsDevicesArgs = {
  _inc?: InputMaybe<AnalysisApplicationsDevicesIncInput>;
  _set?: InputMaybe<AnalysisApplicationsDevicesSetInput>;
  where: AnalysisApplicationsDevicesBoolExp;
};


/** mutation root */
export type MutationRootUpdateAnalysisApplicationsDevicesByPkArgs = {
  _inc?: InputMaybe<AnalysisApplicationsDevicesIncInput>;
  _set?: InputMaybe<AnalysisApplicationsDevicesSetInput>;
  pk_columns: AnalysisApplicationsDevicesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAnalysisApplicationsDevicesManyArgs = {
  updates: Array<AnalysisApplicationsDevicesUpdates>;
};


/** mutation root */
export type MutationRootUpdateAnalysisApplicationsByPkArgs = {
  _inc?: InputMaybe<AnalysisApplicationsIncInput>;
  _set?: InputMaybe<AnalysisApplicationsSetInput>;
  pk_columns: AnalysisApplicationsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAnalysisApplicationsComputedArgs = {
  _inc?: InputMaybe<AnalysisApplicationsComputedIncInput>;
  _set?: InputMaybe<AnalysisApplicationsComputedSetInput>;
  where: AnalysisApplicationsComputedBoolExp;
};


/** mutation root */
export type MutationRootUpdateAnalysisApplicationsComputedByPkArgs = {
  _inc?: InputMaybe<AnalysisApplicationsComputedIncInput>;
  _set?: InputMaybe<AnalysisApplicationsComputedSetInput>;
  pk_columns: AnalysisApplicationsComputedPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAnalysisApplicationsComputedManyArgs = {
  updates: Array<AnalysisApplicationsComputedUpdates>;
};


/** mutation root */
export type MutationRootUpdateAnalysisApplicationsComputedValuesArgs = {
  _inc?: InputMaybe<AnalysisApplicationsComputedValuesIncInput>;
  _set?: InputMaybe<AnalysisApplicationsComputedValuesSetInput>;
  where: AnalysisApplicationsComputedValuesBoolExp;
};


/** mutation root */
export type MutationRootUpdateAnalysisApplicationsComputedValuesByPkArgs = {
  _inc?: InputMaybe<AnalysisApplicationsComputedValuesIncInput>;
  _set?: InputMaybe<AnalysisApplicationsComputedValuesSetInput>;
  pk_columns: AnalysisApplicationsComputedValuesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAnalysisApplicationsComputedValuesKindsArgs = {
  _set?: InputMaybe<AnalysisApplicationsComputedValuesKindsSetInput>;
  where: AnalysisApplicationsComputedValuesKindsBoolExp;
};


/** mutation root */
export type MutationRootUpdateAnalysisApplicationsComputedValuesKindsByPkArgs = {
  _set?: InputMaybe<AnalysisApplicationsComputedValuesKindsSetInput>;
  pk_columns: AnalysisApplicationsComputedValuesKindsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAnalysisApplicationsComputedValuesKindsManyArgs = {
  updates: Array<AnalysisApplicationsComputedValuesKindsUpdates>;
};


/** mutation root */
export type MutationRootUpdateAnalysisApplicationsComputedValuesManyArgs = {
  updates: Array<AnalysisApplicationsComputedValuesUpdates>;
};


/** mutation root */
export type MutationRootUpdateAnalysisApplicationsManyArgs = {
  updates: Array<AnalysisApplicationsUpdates>;
};


/** mutation root */
export type MutationRootUpdateAnalysisByPkArgs = {
  _inc?: InputMaybe<AnalysisIncInput>;
  _set?: InputMaybe<AnalysisSetInput>;
  pk_columns: AnalysisPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAnalysisDeviceCategoriesConfigsArgs = {
  _inc?: InputMaybe<AnalysisDeviceCategoriesConfigsIncInput>;
  _set?: InputMaybe<AnalysisDeviceCategoriesConfigsSetInput>;
  where: AnalysisDeviceCategoriesConfigsBoolExp;
};


/** mutation root */
export type MutationRootUpdateAnalysisDeviceCategoriesConfigsByPkArgs = {
  _inc?: InputMaybe<AnalysisDeviceCategoriesConfigsIncInput>;
  _set?: InputMaybe<AnalysisDeviceCategoriesConfigsSetInput>;
  pk_columns: AnalysisDeviceCategoriesConfigsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAnalysisDeviceCategoriesConfigsManyArgs = {
  updates: Array<AnalysisDeviceCategoriesConfigsUpdates>;
};


/** mutation root */
export type MutationRootUpdateAnalysisGroupsArgs = {
  _set?: InputMaybe<AnalysisGroupsSetInput>;
  where: AnalysisGroupsBoolExp;
};


/** mutation root */
export type MutationRootUpdateAnalysisGroupsByPkArgs = {
  _set?: InputMaybe<AnalysisGroupsSetInput>;
  pk_columns: AnalysisGroupsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAnalysisGroupsManyArgs = {
  updates: Array<AnalysisGroupsUpdates>;
};


/** mutation root */
export type MutationRootUpdateAnalysisKindsArgs = {
  _set?: InputMaybe<AnalysisKindsSetInput>;
  where: AnalysisKindsBoolExp;
};


/** mutation root */
export type MutationRootUpdateAnalysisKindsByPkArgs = {
  _set?: InputMaybe<AnalysisKindsSetInput>;
  pk_columns: AnalysisKindsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAnalysisKindsManyArgs = {
  updates: Array<AnalysisKindsUpdates>;
};


/** mutation root */
export type MutationRootUpdateAnalysisManyArgs = {
  updates: Array<AnalysisUpdates>;
};


/** mutation root */
export type MutationRootUpdateApplicationsArgs = {
  _inc?: InputMaybe<ApplicationsIncInput>;
  _set?: InputMaybe<ApplicationsSetInput>;
  where: ApplicationsBoolExp;
};


/** mutation root */
export type MutationRootUpdateApplicationsByPkArgs = {
  _inc?: InputMaybe<ApplicationsIncInput>;
  _set?: InputMaybe<ApplicationsSetInput>;
  pk_columns: ApplicationsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateApplicationsDashboardsArgs = {
  _inc?: InputMaybe<ApplicationsDashboardsIncInput>;
  _set?: InputMaybe<ApplicationsDashboardsSetInput>;
  where: ApplicationsDashboardsBoolExp;
};


/** mutation root */
export type MutationRootUpdateApplicationsDashboardsAnalysisArgs = {
  _inc?: InputMaybe<ApplicationsDashboardsAnalysisIncInput>;
  _set?: InputMaybe<ApplicationsDashboardsAnalysisSetInput>;
  where: ApplicationsDashboardsAnalysisBoolExp;
};


/** mutation root */
export type MutationRootUpdateApplicationsDashboardsAnalysisByPkArgs = {
  _inc?: InputMaybe<ApplicationsDashboardsAnalysisIncInput>;
  _set?: InputMaybe<ApplicationsDashboardsAnalysisSetInput>;
  pk_columns: ApplicationsDashboardsAnalysisPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateApplicationsDashboardsAnalysisManyArgs = {
  updates: Array<ApplicationsDashboardsAnalysisUpdates>;
};


/** mutation root */
export type MutationRootUpdateApplicationsDashboardsByPkArgs = {
  _inc?: InputMaybe<ApplicationsDashboardsIncInput>;
  _set?: InputMaybe<ApplicationsDashboardsSetInput>;
  pk_columns: ApplicationsDashboardsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateApplicationsDashboardsDevicesArgs = {
  _inc?: InputMaybe<ApplicationsDashboardsDevicesIncInput>;
  _set?: InputMaybe<ApplicationsDashboardsDevicesSetInput>;
  where: ApplicationsDashboardsDevicesBoolExp;
};


/** mutation root */
export type MutationRootUpdateApplicationsDashboardsDevicesByPkArgs = {
  _inc?: InputMaybe<ApplicationsDashboardsDevicesIncInput>;
  _set?: InputMaybe<ApplicationsDashboardsDevicesSetInput>;
  pk_columns: ApplicationsDashboardsDevicesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateApplicationsDashboardsDevicesManyArgs = {
  updates: Array<ApplicationsDashboardsDevicesUpdates>;
};


/** mutation root */
export type MutationRootUpdateApplicationsDashboardsManyArgs = {
  updates: Array<ApplicationsDashboardsUpdates>;
};


/** mutation root */
export type MutationRootUpdateApplicationsManyArgs = {
  updates: Array<ApplicationsUpdates>;
};


/** mutation root */
export type MutationRootUpdateApplicationsSettingsArgs = {
  _inc?: InputMaybe<ApplicationsSettingsIncInput>;
  _set?: InputMaybe<ApplicationsSettingsSetInput>;
  where: ApplicationsSettingsBoolExp;
};


/** mutation root */
export type MutationRootUpdateApplicationsSettingsByPkArgs = {
  _inc?: InputMaybe<ApplicationsSettingsIncInput>;
  _set?: InputMaybe<ApplicationsSettingsSetInput>;
  pk_columns: ApplicationsSettingsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateApplicationsSettingsManyArgs = {
  updates: Array<ApplicationsSettingsUpdates>;
};


/** mutation root */
export type MutationRootUpdateAreasArgs = {
  _append?: InputMaybe<AreasAppendInput>;
  _delete_at_path?: InputMaybe<AreasDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AreasDeleteElemInput>;
  _delete_key?: InputMaybe<AreasDeleteKeyInput>;
  _inc?: InputMaybe<AreasIncInput>;
  _prepend?: InputMaybe<AreasPrependInput>;
  _set?: InputMaybe<AreasSetInput>;
  where: AreasBoolExp;
};


/** mutation root */
export type MutationRootUpdateAreasByPkArgs = {
  _append?: InputMaybe<AreasAppendInput>;
  _delete_at_path?: InputMaybe<AreasDeleteAtPathInput>;
  _delete_elem?: InputMaybe<AreasDeleteElemInput>;
  _delete_key?: InputMaybe<AreasDeleteKeyInput>;
  _inc?: InputMaybe<AreasIncInput>;
  _prepend?: InputMaybe<AreasPrependInput>;
  _set?: InputMaybe<AreasSetInput>;
  pk_columns: AreasPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAreasManyArgs = {
  updates: Array<AreasUpdates>;
};


/** mutation root */
export type MutationRootUpdateAreasScopeCultivationArgs = {
  _inc?: InputMaybe<AreasScopeCultivationIncInput>;
  _set?: InputMaybe<AreasScopeCultivationSetInput>;
  where: AreasScopeCultivationBoolExp;
};


/** mutation root */
export type MutationRootUpdateAreasScopeCultivationByPkArgs = {
  _inc?: InputMaybe<AreasScopeCultivationIncInput>;
  _set?: InputMaybe<AreasScopeCultivationSetInput>;
  pk_columns: AreasScopeCultivationPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAreasScopeCultivationManyArgs = {
  updates: Array<AreasScopeCultivationUpdates>;
};


/** mutation root */
export type MutationRootUpdateAreasScopesArgs = {
  _set?: InputMaybe<AreasScopesSetInput>;
  where: AreasScopesBoolExp;
};


/** mutation root */
export type MutationRootUpdateAreasScopesByPkArgs = {
  _set?: InputMaybe<AreasScopesSetInput>;
  pk_columns: AreasScopesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAreasScopesManyArgs = {
  updates: Array<AreasScopesUpdates>;
};


/** mutation root */
export type MutationRootUpdateAutomationTimingExecutionKindsArgs = {
  _set?: InputMaybe<AutomationTimingExecutionKindsSetInput>;
  where: AutomationTimingExecutionKindsBoolExp;
};


/** mutation root */
export type MutationRootUpdateAutomationTimingExecutionKindsByPkArgs = {
  _set?: InputMaybe<AutomationTimingExecutionKindsSetInput>;
  pk_columns: AutomationTimingExecutionKindsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAutomationTimingExecutionKindsManyArgs = {
  updates: Array<AutomationTimingExecutionKindsUpdates>;
};


/** mutation root */
export type MutationRootUpdateAutomationsArgs = {
  _inc?: InputMaybe<AutomationsIncInput>;
  _set?: InputMaybe<AutomationsSetInput>;
  where: AutomationsBoolExp;
};


/** mutation root */
export type MutationRootUpdateAutomationsByPkArgs = {
  _inc?: InputMaybe<AutomationsIncInput>;
  _set?: InputMaybe<AutomationsSetInput>;
  pk_columns: AutomationsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAutomationsManyArgs = {
  updates: Array<AutomationsUpdates>;
};


/** mutation root */
export type MutationRootUpdateAutomationsWatchingsArgs = {
  _inc?: InputMaybe<AutomationsWatchingsIncInput>;
  _set?: InputMaybe<AutomationsWatchingsSetInput>;
  where: AutomationsWatchingsBoolExp;
};


/** mutation root */
export type MutationRootUpdateAutomationsWatchingsByPkArgs = {
  _inc?: InputMaybe<AutomationsWatchingsIncInput>;
  _set?: InputMaybe<AutomationsWatchingsSetInput>;
  pk_columns: AutomationsWatchingsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAutomationsWatchingsManyArgs = {
  updates: Array<AutomationsWatchingsUpdates>;
};


/** mutation root */
export type MutationRootUpdateChatMessageTypesArgs = {
  _set?: InputMaybe<ChatMessageTypesSetInput>;
  where: ChatMessageTypesBoolExp;
};


/** mutation root */
export type MutationRootUpdateChatMessageTypesByPkArgs = {
  _set?: InputMaybe<ChatMessageTypesSetInput>;
  pk_columns: ChatMessageTypesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateChatMessageTypesManyArgs = {
  updates: Array<ChatMessageTypesUpdates>;
};


/** mutation root */
export type MutationRootUpdateChatMessagesArgs = {
  _append?: InputMaybe<ChatMessagesAppendInput>;
  _delete_at_path?: InputMaybe<ChatMessagesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ChatMessagesDeleteElemInput>;
  _delete_key?: InputMaybe<ChatMessagesDeleteKeyInput>;
  _inc?: InputMaybe<ChatMessagesIncInput>;
  _prepend?: InputMaybe<ChatMessagesPrependInput>;
  _set?: InputMaybe<ChatMessagesSetInput>;
  where: ChatMessagesBoolExp;
};


/** mutation root */
export type MutationRootUpdateChatMessagesByPkArgs = {
  _append?: InputMaybe<ChatMessagesAppendInput>;
  _delete_at_path?: InputMaybe<ChatMessagesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ChatMessagesDeleteElemInput>;
  _delete_key?: InputMaybe<ChatMessagesDeleteKeyInput>;
  _inc?: InputMaybe<ChatMessagesIncInput>;
  _prepend?: InputMaybe<ChatMessagesPrependInput>;
  _set?: InputMaybe<ChatMessagesSetInput>;
  pk_columns: ChatMessagesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateChatMessagesManyArgs = {
  updates: Array<ChatMessagesUpdates>;
};


/** mutation root */
export type MutationRootUpdateCultivationTypesArgs = {
  _set?: InputMaybe<CultivationTypesSetInput>;
  where: CultivationTypesBoolExp;
};


/** mutation root */
export type MutationRootUpdateCultivationTypesByPkArgs = {
  _set?: InputMaybe<CultivationTypesSetInput>;
  pk_columns: CultivationTypesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCultivationTypesManyArgs = {
  updates: Array<CultivationTypesUpdates>;
};


/** mutation root */
export type MutationRootUpdateDeviceActionsArgs = {
  _inc?: InputMaybe<DeviceActionsIncInput>;
  _set?: InputMaybe<DeviceActionsSetInput>;
  where: DeviceActionsBoolExp;
};


/** mutation root */
export type MutationRootUpdateDeviceActionsByPkArgs = {
  _inc?: InputMaybe<DeviceActionsIncInput>;
  _set?: InputMaybe<DeviceActionsSetInput>;
  pk_columns: DeviceActionsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateDeviceActionsManyArgs = {
  updates: Array<DeviceActionsUpdates>;
};


/** mutation root */
export type MutationRootUpdateDeviceCategoriesArgs = {
  _inc?: InputMaybe<DeviceCategoriesIncInput>;
  _set?: InputMaybe<DeviceCategoriesSetInput>;
  where: DeviceCategoriesBoolExp;
};


/** mutation root */
export type MutationRootUpdateDeviceCategoriesByPkArgs = {
  _inc?: InputMaybe<DeviceCategoriesIncInput>;
  _set?: InputMaybe<DeviceCategoriesSetInput>;
  pk_columns: DeviceCategoriesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateDeviceCategoriesManyArgs = {
  updates: Array<DeviceCategoriesUpdates>;
};


/** mutation root */
export type MutationRootUpdateDevicePayloadValuesArgs = {
  _inc?: InputMaybe<DevicePayloadValuesIncInput>;
  _set?: InputMaybe<DevicePayloadValuesSetInput>;
  where: DevicePayloadValuesBoolExp;
};


/** mutation root */
export type MutationRootUpdateDevicePayloadValuesByPkArgs = {
  _inc?: InputMaybe<DevicePayloadValuesIncInput>;
  _set?: InputMaybe<DevicePayloadValuesSetInput>;
  pk_columns: DevicePayloadValuesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateDevicePayloadValuesManyArgs = {
  updates: Array<DevicePayloadValuesUpdates>;
};


/** mutation root */
export type MutationRootUpdateDevicePayloadsArgs = {
  _inc?: InputMaybe<DevicePayloadsIncInput>;
  _set?: InputMaybe<DevicePayloadsSetInput>;
  where: DevicePayloadsBoolExp;
};


/** mutation root */
export type MutationRootUpdateDevicePayloadsPayloadValuesArgs = {
  _inc?: InputMaybe<DevicePayloadsPayloadValuesIncInput>;
  _set?: InputMaybe<DevicePayloadsPayloadValuesSetInput>;
  where: DevicePayloadsPayloadValuesBoolExp;
};


/** mutation root */
export type MutationRootUpdateDevicePayloadsPayloadValuesByPkArgs = {
  _inc?: InputMaybe<DevicePayloadsPayloadValuesIncInput>;
  _set?: InputMaybe<DevicePayloadsPayloadValuesSetInput>;
  pk_columns: DevicePayloadsPayloadValuesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateDevicePayloadsPayloadValuesManyArgs = {
  updates: Array<DevicePayloadsPayloadValuesUpdates>;
};


/** mutation root */
export type MutationRootUpdateDevicePayloadsByPkArgs = {
  _inc?: InputMaybe<DevicePayloadsIncInput>;
  _set?: InputMaybe<DevicePayloadsSetInput>;
  pk_columns: DevicePayloadsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateDevicePayloadsManyArgs = {
  updates: Array<DevicePayloadsUpdates>;
};


/** mutation root */
export type MutationRootUpdateDevicesArgs = {
  _inc?: InputMaybe<DevicesIncInput>;
  _set?: InputMaybe<DevicesSetInput>;
  where: DevicesBoolExp;
};


/** mutation root */
export type MutationRootUpdateDevicesDeviceActionsArgs = {
  _inc?: InputMaybe<DevicesDeviceActionsIncInput>;
  _set?: InputMaybe<DevicesDeviceActionsSetInput>;
  where: DevicesDeviceActionsBoolExp;
};


/** mutation root */
export type MutationRootUpdateDevicesDeviceActionsByPkArgs = {
  _inc?: InputMaybe<DevicesDeviceActionsIncInput>;
  _set?: InputMaybe<DevicesDeviceActionsSetInput>;
  pk_columns: DevicesDeviceActionsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateDevicesDeviceActionsManyArgs = {
  updates: Array<DevicesDeviceActionsUpdates>;
};


/** mutation root */
export type MutationRootUpdateDevicesDeviceCategoriesArgs = {
  _inc?: InputMaybe<DevicesDeviceCategoriesIncInput>;
  _set?: InputMaybe<DevicesDeviceCategoriesSetInput>;
  where: DevicesDeviceCategoriesBoolExp;
};


/** mutation root */
export type MutationRootUpdateDevicesDeviceCategoriesByPkArgs = {
  _inc?: InputMaybe<DevicesDeviceCategoriesIncInput>;
  _set?: InputMaybe<DevicesDeviceCategoriesSetInput>;
  pk_columns: DevicesDeviceCategoriesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateDevicesDeviceCategoriesManyArgs = {
  updates: Array<DevicesDeviceCategoriesUpdates>;
};


/** mutation root */
export type MutationRootUpdateDevicesDevicePayloadsArgs = {
  _inc?: InputMaybe<DevicesDevicePayloadsIncInput>;
  _set?: InputMaybe<DevicesDevicePayloadsSetInput>;
  where: DevicesDevicePayloadsBoolExp;
};


/** mutation root */
export type MutationRootUpdateDevicesDevicePayloadsByPkArgs = {
  _inc?: InputMaybe<DevicesDevicePayloadsIncInput>;
  _set?: InputMaybe<DevicesDevicePayloadsSetInput>;
  pk_columns: DevicesDevicePayloadsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateDevicesDevicePayloadsManyArgs = {
  updates: Array<DevicesDevicePayloadsUpdates>;
};


/** mutation root */
export type MutationRootUpdateDevicesByPkArgs = {
  _inc?: InputMaybe<DevicesIncInput>;
  _set?: InputMaybe<DevicesSetInput>;
  pk_columns: DevicesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateDevicesManyArgs = {
  updates: Array<DevicesUpdates>;
};


/** mutation root */
export type MutationRootUpdateDownlinksArgs = {
  _append?: InputMaybe<DownlinksAppendInput>;
  _delete_at_path?: InputMaybe<DownlinksDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DownlinksDeleteElemInput>;
  _delete_key?: InputMaybe<DownlinksDeleteKeyInput>;
  _inc?: InputMaybe<DownlinksIncInput>;
  _prepend?: InputMaybe<DownlinksPrependInput>;
  _set?: InputMaybe<DownlinksSetInput>;
  where: DownlinksBoolExp;
};


/** mutation root */
export type MutationRootUpdateDownlinksByPkArgs = {
  _append?: InputMaybe<DownlinksAppendInput>;
  _delete_at_path?: InputMaybe<DownlinksDeleteAtPathInput>;
  _delete_elem?: InputMaybe<DownlinksDeleteElemInput>;
  _delete_key?: InputMaybe<DownlinksDeleteKeyInput>;
  _inc?: InputMaybe<DownlinksIncInput>;
  _prepend?: InputMaybe<DownlinksPrependInput>;
  _set?: InputMaybe<DownlinksSetInput>;
  pk_columns: DownlinksPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateDownlinksManyArgs = {
  updates: Array<DownlinksUpdates>;
};


/** mutation root */
export type MutationRootUpdateFarmingContainersArgs = {
  _set?: InputMaybe<FarmingContainersSetInput>;
  where: FarmingContainersBoolExp;
};


/** mutation root */
export type MutationRootUpdateFarmingContainersByPkArgs = {
  _set?: InputMaybe<FarmingContainersSetInput>;
  pk_columns: FarmingContainersPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateFarmingContainersManyArgs = {
  updates: Array<FarmingContainersUpdates>;
};


/** mutation root */
export type MutationRootUpdateFarmingMethodsArgs = {
  _set?: InputMaybe<FarmingMethodsSetInput>;
  where: FarmingMethodsBoolExp;
};


/** mutation root */
export type MutationRootUpdateFarmingMethodsByPkArgs = {
  _set?: InputMaybe<FarmingMethodsSetInput>;
  pk_columns: FarmingMethodsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateFarmingMethodsManyArgs = {
  updates: Array<FarmingMethodsUpdates>;
};


/** mutation root */
export type MutationRootUpdateFarmingStructuresArgs = {
  _set?: InputMaybe<FarmingStructuresSetInput>;
  where: FarmingStructuresBoolExp;
};


/** mutation root */
export type MutationRootUpdateFarmingStructuresByPkArgs = {
  _set?: InputMaybe<FarmingStructuresSetInput>;
  pk_columns: FarmingStructuresPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateFarmingStructuresManyArgs = {
  updates: Array<FarmingStructuresUpdates>;
};


/** mutation root */
export type MutationRootUpdateNotificationEventTypesArgs = {
  _inc?: InputMaybe<NotificationEventTypesIncInput>;
  _set?: InputMaybe<NotificationEventTypesSetInput>;
  where: NotificationEventTypesBoolExp;
};


/** mutation root */
export type MutationRootUpdateNotificationEventTypesByPkArgs = {
  _inc?: InputMaybe<NotificationEventTypesIncInput>;
  _set?: InputMaybe<NotificationEventTypesSetInput>;
  pk_columns: NotificationEventTypesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateNotificationEventTypesManyArgs = {
  updates: Array<NotificationEventTypesUpdates>;
};


/** mutation root */
export type MutationRootUpdateNotificationKindsArgs = {
  _set?: InputMaybe<NotificationKindsSetInput>;
  where: NotificationKindsBoolExp;
};


/** mutation root */
export type MutationRootUpdateNotificationKindsByPkArgs = {
  _set?: InputMaybe<NotificationKindsSetInput>;
  pk_columns: NotificationKindsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateNotificationKindsManyArgs = {
  updates: Array<NotificationKindsUpdates>;
};


/** mutation root */
export type MutationRootUpdateNotificationUserDevicesArgs = {
  _inc?: InputMaybe<NotificationUserDevicesIncInput>;
  _set?: InputMaybe<NotificationUserDevicesSetInput>;
  where: NotificationUserDevicesBoolExp;
};


/** mutation root */
export type MutationRootUpdateNotificationUserDevicesEventTypesArgs = {
  _inc?: InputMaybe<NotificationUserDevicesEventTypesIncInput>;
  _set?: InputMaybe<NotificationUserDevicesEventTypesSetInput>;
  where: NotificationUserDevicesEventTypesBoolExp;
};


/** mutation root */
export type MutationRootUpdateNotificationUserDevicesEventTypesByPkArgs = {
  _inc?: InputMaybe<NotificationUserDevicesEventTypesIncInput>;
  _set?: InputMaybe<NotificationUserDevicesEventTypesSetInput>;
  pk_columns: NotificationUserDevicesEventTypesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateNotificationUserDevicesEventTypesManyArgs = {
  updates: Array<NotificationUserDevicesEventTypesUpdates>;
};


/** mutation root */
export type MutationRootUpdateNotificationUserDevicesByPkArgs = {
  _inc?: InputMaybe<NotificationUserDevicesIncInput>;
  _set?: InputMaybe<NotificationUserDevicesSetInput>;
  pk_columns: NotificationUserDevicesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateNotificationUserDevicesManyArgs = {
  updates: Array<NotificationUserDevicesUpdates>;
};


/** mutation root */
export type MutationRootUpdateNotificationUserSettingsArgs = {
  _inc?: InputMaybe<NotificationUserSettingsIncInput>;
  _set?: InputMaybe<NotificationUserSettingsSetInput>;
  where: NotificationUserSettingsBoolExp;
};


/** mutation root */
export type MutationRootUpdateNotificationUserSettingsByPkArgs = {
  _inc?: InputMaybe<NotificationUserSettingsIncInput>;
  _set?: InputMaybe<NotificationUserSettingsSetInput>;
  pk_columns: NotificationUserSettingsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateNotificationUserSettingsManyArgs = {
  updates: Array<NotificationUserSettingsUpdates>;
};


/** mutation root */
export type MutationRootUpdateNotificationsArgs = {
  _inc?: InputMaybe<NotificationsIncInput>;
  _set?: InputMaybe<NotificationsSetInput>;
  where: NotificationsBoolExp;
};


/** mutation root */
export type MutationRootUpdateNotificationsByPkArgs = {
  _inc?: InputMaybe<NotificationsIncInput>;
  _set?: InputMaybe<NotificationsSetInput>;
  pk_columns: NotificationsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateNotificationsContentArgs = {
  _append?: InputMaybe<NotificationsContentAppendInput>;
  _delete_at_path?: InputMaybe<NotificationsContentDeleteAtPathInput>;
  _delete_elem?: InputMaybe<NotificationsContentDeleteElemInput>;
  _delete_key?: InputMaybe<NotificationsContentDeleteKeyInput>;
  _inc?: InputMaybe<NotificationsContentIncInput>;
  _prepend?: InputMaybe<NotificationsContentPrependInput>;
  _set?: InputMaybe<NotificationsContentSetInput>;
  where: NotificationsContentBoolExp;
};


/** mutation root */
export type MutationRootUpdateNotificationsContentByPkArgs = {
  _append?: InputMaybe<NotificationsContentAppendInput>;
  _delete_at_path?: InputMaybe<NotificationsContentDeleteAtPathInput>;
  _delete_elem?: InputMaybe<NotificationsContentDeleteElemInput>;
  _delete_key?: InputMaybe<NotificationsContentDeleteKeyInput>;
  _inc?: InputMaybe<NotificationsContentIncInput>;
  _prepend?: InputMaybe<NotificationsContentPrependInput>;
  _set?: InputMaybe<NotificationsContentSetInput>;
  pk_columns: NotificationsContentPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateNotificationsContentManyArgs = {
  updates: Array<NotificationsContentUpdates>;
};


/** mutation root */
export type MutationRootUpdateNotificationsManyArgs = {
  updates: Array<NotificationsUpdates>;
};


/** mutation root */
export type MutationRootUpdateOrganizationsArgs = {
  _inc?: InputMaybe<OrganizationsIncInput>;
  _set?: InputMaybe<OrganizationsSetInput>;
  where: OrganizationsBoolExp;
};


/** mutation root */
export type MutationRootUpdateOrganizationsByPkArgs = {
  _inc?: InputMaybe<OrganizationsIncInput>;
  _set?: InputMaybe<OrganizationsSetInput>;
  pk_columns: OrganizationsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateOrganizationsChatParamsArgs = {
  _inc?: InputMaybe<OrganizationsChatParamsIncInput>;
  _set?: InputMaybe<OrganizationsChatParamsSetInput>;
  where: OrganizationsChatParamsBoolExp;
};


/** mutation root */
export type MutationRootUpdateOrganizationsChatParamsByPkArgs = {
  _inc?: InputMaybe<OrganizationsChatParamsIncInput>;
  _set?: InputMaybe<OrganizationsChatParamsSetInput>;
  pk_columns: OrganizationsChatParamsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateOrganizationsChatParamsManyArgs = {
  updates: Array<OrganizationsChatParamsUpdates>;
};


/** mutation root */
export type MutationRootUpdateOrganizationsFeatureLimitsArgs = {
  _inc?: InputMaybe<OrganizationsFeatureLimitsIncInput>;
  _set?: InputMaybe<OrganizationsFeatureLimitsSetInput>;
  where: OrganizationsFeatureLimitsBoolExp;
};


/** mutation root */
export type MutationRootUpdateOrganizationsFeatureLimitsByPkArgs = {
  _inc?: InputMaybe<OrganizationsFeatureLimitsIncInput>;
  _set?: InputMaybe<OrganizationsFeatureLimitsSetInput>;
  pk_columns: OrganizationsFeatureLimitsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateOrganizationsFeatureLimitsManyArgs = {
  updates: Array<OrganizationsFeatureLimitsUpdates>;
};


/** mutation root */
export type MutationRootUpdateOrganizationsManyArgs = {
  updates: Array<OrganizationsUpdates>;
};


/** mutation root */
export type MutationRootUpdateOrganizationsUsersUsersOrganizationsArgs = {
  _inc?: InputMaybe<OrganizationsUsersUsersOrganizationsIncInput>;
  _set?: InputMaybe<OrganizationsUsersUsersOrganizationsSetInput>;
  where: OrganizationsUsersUsersOrganizationsBoolExp;
};


/** mutation root */
export type MutationRootUpdateOrganizationsUsersUsersOrganizationsByPkArgs = {
  _inc?: InputMaybe<OrganizationsUsersUsersOrganizationsIncInput>;
  _set?: InputMaybe<OrganizationsUsersUsersOrganizationsSetInput>;
  pk_columns: OrganizationsUsersUsersOrganizationsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateOrganizationsUsersUsersOrganizationsManyArgs = {
  updates: Array<OrganizationsUsersUsersOrganizationsUpdates>;
};


/** mutation root */
export type MutationRootUpdateSceneFeedbackWaitsArgs = {
  _inc?: InputMaybe<SceneFeedbackWaitsIncInput>;
  _set?: InputMaybe<SceneFeedbackWaitsSetInput>;
  where: SceneFeedbackWaitsBoolExp;
};


/** mutation root */
export type MutationRootUpdateSceneFeedbackWaitsByPkArgs = {
  _inc?: InputMaybe<SceneFeedbackWaitsIncInput>;
  _set?: InputMaybe<SceneFeedbackWaitsSetInput>;
  pk_columns: SceneFeedbackWaitsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateSceneFeedbackWaitsManyArgs = {
  updates: Array<SceneFeedbackWaitsUpdates>;
};


/** mutation root */
export type MutationRootUpdateSceneScheduledExecutionsArgs = {
  _inc?: InputMaybe<SceneScheduledExecutionsIncInput>;
  _set?: InputMaybe<SceneScheduledExecutionsSetInput>;
  where: SceneScheduledExecutionsBoolExp;
};


/** mutation root */
export type MutationRootUpdateSceneScheduledExecutionsByPkArgs = {
  _inc?: InputMaybe<SceneScheduledExecutionsIncInput>;
  _set?: InputMaybe<SceneScheduledExecutionsSetInput>;
  pk_columns: SceneScheduledExecutionsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateSceneScheduledExecutionsManyArgs = {
  updates: Array<SceneScheduledExecutionsUpdates>;
};


/** mutation root */
export type MutationRootUpdateSceneTimingExecutionKindsArgs = {
  _set?: InputMaybe<SceneTimingExecutionKindsSetInput>;
  where: SceneTimingExecutionKindsBoolExp;
};


/** mutation root */
export type MutationRootUpdateSceneTimingExecutionKindsByPkArgs = {
  _set?: InputMaybe<SceneTimingExecutionKindsSetInput>;
  pk_columns: SceneTimingExecutionKindsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateSceneTimingExecutionKindsManyArgs = {
  updates: Array<SceneTimingExecutionKindsUpdates>;
};


/** mutation root */
export type MutationRootUpdateScenesArgs = {
  _append?: InputMaybe<ScenesAppendInput>;
  _delete_at_path?: InputMaybe<ScenesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ScenesDeleteElemInput>;
  _delete_key?: InputMaybe<ScenesDeleteKeyInput>;
  _inc?: InputMaybe<ScenesIncInput>;
  _prepend?: InputMaybe<ScenesPrependInput>;
  _set?: InputMaybe<ScenesSetInput>;
  where: ScenesBoolExp;
};


/** mutation root */
export type MutationRootUpdateScenesDevicesArgs = {
  _inc?: InputMaybe<ScenesDevicesIncInput>;
  _set?: InputMaybe<ScenesDevicesSetInput>;
  where: ScenesDevicesBoolExp;
};


/** mutation root */
export type MutationRootUpdateScenesDevicesByPkArgs = {
  _inc?: InputMaybe<ScenesDevicesIncInput>;
  _set?: InputMaybe<ScenesDevicesSetInput>;
  pk_columns: ScenesDevicesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateScenesDevicesManyArgs = {
  updates: Array<ScenesDevicesUpdates>;
};


/** mutation root */
export type MutationRootUpdateScenesByPkArgs = {
  _append?: InputMaybe<ScenesAppendInput>;
  _delete_at_path?: InputMaybe<ScenesDeleteAtPathInput>;
  _delete_elem?: InputMaybe<ScenesDeleteElemInput>;
  _delete_key?: InputMaybe<ScenesDeleteKeyInput>;
  _inc?: InputMaybe<ScenesIncInput>;
  _prepend?: InputMaybe<ScenesPrependInput>;
  _set?: InputMaybe<ScenesSetInput>;
  pk_columns: ScenesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateScenesManyArgs = {
  updates: Array<ScenesUpdates>;
};


/** mutation root */
export type MutationRootUpdateSubstratesArgs = {
  _inc?: InputMaybe<SubstratesIncInput>;
  _set?: InputMaybe<SubstratesSetInput>;
  where: SubstratesBoolExp;
};


/** mutation root */
export type MutationRootUpdateSubstratesByPkArgs = {
  _inc?: InputMaybe<SubstratesIncInput>;
  _set?: InputMaybe<SubstratesSetInput>;
  pk_columns: SubstratesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateSubstratesManyArgs = {
  updates: Array<SubstratesUpdates>;
};


/** mutation root */
export type MutationRootUpdateTelegramUsersArgs = {
  _inc?: InputMaybe<TelegramUsersIncInput>;
  _set?: InputMaybe<TelegramUsersSetInput>;
  where: TelegramUsersBoolExp;
};


/** mutation root */
export type MutationRootUpdateTelegramUsersByPkArgs = {
  _inc?: InputMaybe<TelegramUsersIncInput>;
  _set?: InputMaybe<TelegramUsersSetInput>;
  pk_columns: TelegramUsersPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateTelegramUsersManyArgs = {
  updates: Array<TelegramUsersUpdates>;
};


/** mutation root */
export type MutationRootUpdateUplinkDynamoRefArgs = {
  _append?: InputMaybe<UplinkDynamoRefAppendInput>;
  _delete_at_path?: InputMaybe<UplinkDynamoRefDeleteAtPathInput>;
  _delete_elem?: InputMaybe<UplinkDynamoRefDeleteElemInput>;
  _delete_key?: InputMaybe<UplinkDynamoRefDeleteKeyInput>;
  _inc?: InputMaybe<UplinkDynamoRefIncInput>;
  _prepend?: InputMaybe<UplinkDynamoRefPrependInput>;
  _set?: InputMaybe<UplinkDynamoRefSetInput>;
  where: UplinkDynamoRefBoolExp;
};


/** mutation root */
export type MutationRootUpdateUplinkDynamoRefByPkArgs = {
  _append?: InputMaybe<UplinkDynamoRefAppendInput>;
  _delete_at_path?: InputMaybe<UplinkDynamoRefDeleteAtPathInput>;
  _delete_elem?: InputMaybe<UplinkDynamoRefDeleteElemInput>;
  _delete_key?: InputMaybe<UplinkDynamoRefDeleteKeyInput>;
  _inc?: InputMaybe<UplinkDynamoRefIncInput>;
  _prepend?: InputMaybe<UplinkDynamoRefPrependInput>;
  _set?: InputMaybe<UplinkDynamoRefSetInput>;
  pk_columns: UplinkDynamoRefPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateUplinkDynamoRefManyArgs = {
  updates: Array<UplinkDynamoRefUpdates>;
};


/** mutation root */
export type MutationRootUpdateUserRolesArgs = {
  _inc?: InputMaybe<UserRolesIncInput>;
  _set?: InputMaybe<UserRolesSetInput>;
  where: UserRolesBoolExp;
};


/** mutation root */
export type MutationRootUpdateUserRolesUsersPermissionsUserArgs = {
  _inc?: InputMaybe<UserRolesUsersPermissionsUserIncInput>;
  _set?: InputMaybe<UserRolesUsersPermissionsUserSetInput>;
  where: UserRolesUsersPermissionsUserBoolExp;
};


/** mutation root */
export type MutationRootUpdateUserRolesUsersPermissionsUserByPkArgs = {
  _inc?: InputMaybe<UserRolesUsersPermissionsUserIncInput>;
  _set?: InputMaybe<UserRolesUsersPermissionsUserSetInput>;
  pk_columns: UserRolesUsersPermissionsUserPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateUserRolesUsersPermissionsUserManyArgs = {
  updates: Array<UserRolesUsersPermissionsUserUpdates>;
};


/** mutation root */
export type MutationRootUpdateUserRolesByPkArgs = {
  _inc?: InputMaybe<UserRolesIncInput>;
  _set?: InputMaybe<UserRolesSetInput>;
  pk_columns: UserRolesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateUserRolesManyArgs = {
  updates: Array<UserRolesUpdates>;
};


/** mutation root */
export type MutationRootUpdateUsersPermissionsUserArgs = {
  _inc?: InputMaybe<UsersPermissionsUserIncInput>;
  _set?: InputMaybe<UsersPermissionsUserSetInput>;
  where: UsersPermissionsUserBoolExp;
};


/** mutation root */
export type MutationRootUpdateUsersPermissionsUserByPkArgs = {
  _inc?: InputMaybe<UsersPermissionsUserIncInput>;
  _set?: InputMaybe<UsersPermissionsUserSetInput>;
  pk_columns: UsersPermissionsUserPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateUsersPermissionsUserManyArgs = {
  updates: Array<UsersPermissionsUserUpdates>;
};


/** mutation root */
export type MutationRootUserCreateArgs = {
  args: CreateUserInput;
};

/** columns and relationships of "notification_event_types" */
export type NotificationEventTypes = {
  __typename?: 'notification_event_types';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  event?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "notification_event_types" */
export type NotificationEventTypesAggregate = {
  __typename?: 'notification_event_types_aggregate';
  aggregate?: Maybe<NotificationEventTypesAggregateFields>;
  nodes: Array<NotificationEventTypes>;
};

/** aggregate fields of "notification_event_types" */
export type NotificationEventTypesAggregateFields = {
  __typename?: 'notification_event_types_aggregate_fields';
  avg?: Maybe<NotificationEventTypesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<NotificationEventTypesMaxFields>;
  min?: Maybe<NotificationEventTypesMinFields>;
  stddev?: Maybe<NotificationEventTypesStddevFields>;
  stddev_pop?: Maybe<NotificationEventTypesStddevPopFields>;
  stddev_samp?: Maybe<NotificationEventTypesStddevSampFields>;
  sum?: Maybe<NotificationEventTypesSumFields>;
  var_pop?: Maybe<NotificationEventTypesVarPopFields>;
  var_samp?: Maybe<NotificationEventTypesVarSampFields>;
  variance?: Maybe<NotificationEventTypesVarianceFields>;
};


/** aggregate fields of "notification_event_types" */
export type NotificationEventTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationEventTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type NotificationEventTypesAvgFields = {
  __typename?: 'notification_event_types_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "notification_event_types". All fields are combined with a logical 'AND'. */
export type NotificationEventTypesBoolExp = {
  _and?: InputMaybe<Array<NotificationEventTypesBoolExp>>;
  _not?: InputMaybe<NotificationEventTypesBoolExp>;
  _or?: InputMaybe<Array<NotificationEventTypesBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<IntComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  event?: InputMaybe<StringComparisonExp>;
  group?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  published_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "notification_event_types" */
export enum NotificationEventTypesConstraint {
  /** unique or primary key constraint on columns "event" */
  NOTIFICATION_EVENT_TYPES_EVENT_UNIQUE = 'notification_event_types_event_unique',
  /** unique or primary key constraint on columns "id" */
  NOTIFICATION_EVENT_TYPES_PKEY = 'notification_event_types_pkey'
}

/** input type for incrementing numeric columns in table "notification_event_types" */
export type NotificationEventTypesIncInput = {
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "notification_event_types" */
export type NotificationEventTypesInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  published_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type NotificationEventTypesMaxFields = {
  __typename?: 'notification_event_types_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  event?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type NotificationEventTypesMinFields = {
  __typename?: 'notification_event_types_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  event?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "notification_event_types" */
export type NotificationEventTypesMutationResponse = {
  __typename?: 'notification_event_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<NotificationEventTypes>;
};

/** input type for inserting object relation for remote table "notification_event_types" */
export type NotificationEventTypesObjRelInsertInput = {
  data: NotificationEventTypesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<NotificationEventTypesOnConflict>;
};

/** on_conflict condition type for table "notification_event_types" */
export type NotificationEventTypesOnConflict = {
  constraint: NotificationEventTypesConstraint;
  update_columns?: Array<NotificationEventTypesUpdateColumn>;
  where?: InputMaybe<NotificationEventTypesBoolExp>;
};

/** Ordering options when selecting data from "notification_event_types". */
export type NotificationEventTypesOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  event?: InputMaybe<OrderBy>;
  group?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  published_at?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: notification_event_types */
export type NotificationEventTypesPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "notification_event_types" */
export enum NotificationEventTypesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  EVENT = 'event',
  /** column name */
  GROUP = 'group',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  PUBLISHED_AT = 'published_at',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by'
}

/** input type for updating data in table "notification_event_types" */
export type NotificationEventTypesSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  published_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type NotificationEventTypesStddevFields = {
  __typename?: 'notification_event_types_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type NotificationEventTypesStddevPopFields = {
  __typename?: 'notification_event_types_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type NotificationEventTypesStddevSampFields = {
  __typename?: 'notification_event_types_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "notification_event_types" */
export type NotificationEventTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: NotificationEventTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationEventTypesStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  event?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  published_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type NotificationEventTypesSumFields = {
  __typename?: 'notification_event_types_sum_fields';
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** update columns of table "notification_event_types" */
export enum NotificationEventTypesUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  EVENT = 'event',
  /** column name */
  GROUP = 'group',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  PUBLISHED_AT = 'published_at',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by'
}

export type NotificationEventTypesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<NotificationEventTypesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NotificationEventTypesSetInput>;
  /** filter the rows which have to be updated */
  where: NotificationEventTypesBoolExp;
};

/** aggregate var_pop on columns */
export type NotificationEventTypesVarPopFields = {
  __typename?: 'notification_event_types_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type NotificationEventTypesVarSampFields = {
  __typename?: 'notification_event_types_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type NotificationEventTypesVarianceFields = {
  __typename?: 'notification_event_types_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** User notification kind enum */
export type NotificationKinds = {
  __typename?: 'notification_kinds';
  comment: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "notification_kinds" */
export type NotificationKindsAggregate = {
  __typename?: 'notification_kinds_aggregate';
  aggregate?: Maybe<NotificationKindsAggregateFields>;
  nodes: Array<NotificationKinds>;
};

/** aggregate fields of "notification_kinds" */
export type NotificationKindsAggregateFields = {
  __typename?: 'notification_kinds_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<NotificationKindsMaxFields>;
  min?: Maybe<NotificationKindsMinFields>;
};


/** aggregate fields of "notification_kinds" */
export type NotificationKindsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationKindsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "notification_kinds". All fields are combined with a logical 'AND'. */
export type NotificationKindsBoolExp = {
  _and?: InputMaybe<Array<NotificationKindsBoolExp>>;
  _not?: InputMaybe<NotificationKindsBoolExp>;
  _or?: InputMaybe<Array<NotificationKindsBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "notification_kinds" */
export enum NotificationKindsConstraint {
  /** unique or primary key constraint on columns "value" */
  NOTIFICATION_KINDS_ENUM_PKEY = 'notification_kinds_enum_pkey'
}

export enum NotificationKindsEnum {
  /** Notifications related to devices */
  DEVICE_EVENT = 'DEVICE_EVENT',
  /** Notifications related to missing devices */
  EVENT_DEVICE_MISSING = 'EVENT_DEVICE_MISSING',
  /** Notifications related to messages */
  EVENT_MESSAGE = 'EVENT_MESSAGE',
  /** Notifications related to new releases */
  EVENT_RELEASE = 'EVENT_RELEASE',
  /** Notifications related to scenes status failed */
  EVENT_SCENE_FAILED = 'EVENT_SCENE_FAILED',
  /** Notifications related to scenes status success */
  EVENT_SCENE_SUCCESS = 'EVENT_SCENE_SUCCESS',
  /** Notifications related to scenes status warning */
  EVENT_SCENE_WARNING = 'EVENT_SCENE_WARNING'
}

/** Boolean expression to compare columns of type "notification_kinds_enum". All fields are combined with logical 'AND'. */
export type NotificationKindsEnumComparisonExp = {
  _eq?: InputMaybe<NotificationKindsEnum>;
  _in?: InputMaybe<Array<NotificationKindsEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<NotificationKindsEnum>;
  _nin?: InputMaybe<Array<NotificationKindsEnum>>;
};

/** input type for inserting data into table "notification_kinds" */
export type NotificationKindsInsertInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type NotificationKindsMaxFields = {
  __typename?: 'notification_kinds_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type NotificationKindsMinFields = {
  __typename?: 'notification_kinds_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "notification_kinds" */
export type NotificationKindsMutationResponse = {
  __typename?: 'notification_kinds_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<NotificationKinds>;
};

/** on_conflict condition type for table "notification_kinds" */
export type NotificationKindsOnConflict = {
  constraint: NotificationKindsConstraint;
  update_columns?: Array<NotificationKindsUpdateColumn>;
  where?: InputMaybe<NotificationKindsBoolExp>;
};

/** Ordering options when selecting data from "notification_kinds". */
export type NotificationKindsOrderBy = {
  comment?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: notification_kinds */
export type NotificationKindsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "notification_kinds" */
export enum NotificationKindsSelectColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  VALUE = 'value'
}

/** input type for updating data in table "notification_kinds" */
export type NotificationKindsSetInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "notification_kinds" */
export type NotificationKindsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: NotificationKindsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationKindsStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "notification_kinds" */
export enum NotificationKindsUpdateColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  VALUE = 'value'
}

export type NotificationKindsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NotificationKindsSetInput>;
  /** filter the rows which have to be updated */
  where: NotificationKindsBoolExp;
};

/** columns and relationships of "notification_user_devices" */
export type NotificationUserDevices = {
  __typename?: 'notification_user_devices';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  /** An object relationship */
  device?: Maybe<Devices>;
  device_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  /** An array relationship */
  notification_user_devices_event_types: Array<NotificationUserDevicesEventTypes>;
  /** An aggregate relationship */
  notification_user_devices_event_types_aggregate: NotificationUserDevicesEventTypesAggregate;
  published_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
  /** An object relationship */
  user?: Maybe<UsersPermissionsUser>;
  user_id?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "notification_user_devices" */
export type NotificationUserDevicesNotificationUserDevicesEventTypesArgs = {
  distinct_on?: InputMaybe<Array<NotificationUserDevicesEventTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationUserDevicesEventTypesOrderBy>>;
  where?: InputMaybe<NotificationUserDevicesEventTypesBoolExp>;
};


/** columns and relationships of "notification_user_devices" */
export type NotificationUserDevicesNotificationUserDevicesEventTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationUserDevicesEventTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationUserDevicesEventTypesOrderBy>>;
  where?: InputMaybe<NotificationUserDevicesEventTypesBoolExp>;
};

/** columns and relationships of "notification_user_devices__event_types" */
export type NotificationUserDevicesEventTypes = {
  __typename?: 'notification_user_devices__event_types';
  id: Scalars['Int'];
  /** An object relationship */
  notification_event_type?: Maybe<NotificationEventTypes>;
  notification_event_type_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  notification_user_device?: Maybe<NotificationUserDevices>;
  notification_user_device_id?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "notification_user_devices__event_types" */
export type NotificationUserDevicesEventTypesAggregate = {
  __typename?: 'notification_user_devices__event_types_aggregate';
  aggregate?: Maybe<NotificationUserDevicesEventTypesAggregateFields>;
  nodes: Array<NotificationUserDevicesEventTypes>;
};

export type NotificationUserDevicesEventTypesAggregateBoolExp = {
  count?: InputMaybe<NotificationUserDevicesEventTypesAggregateBoolExpCount>;
};

export type NotificationUserDevicesEventTypesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<NotificationUserDevicesEventTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<NotificationUserDevicesEventTypesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "notification_user_devices__event_types" */
export type NotificationUserDevicesEventTypesAggregateFields = {
  __typename?: 'notification_user_devices__event_types_aggregate_fields';
  avg?: Maybe<NotificationUserDevicesEventTypesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<NotificationUserDevicesEventTypesMaxFields>;
  min?: Maybe<NotificationUserDevicesEventTypesMinFields>;
  stddev?: Maybe<NotificationUserDevicesEventTypesStddevFields>;
  stddev_pop?: Maybe<NotificationUserDevicesEventTypesStddevPopFields>;
  stddev_samp?: Maybe<NotificationUserDevicesEventTypesStddevSampFields>;
  sum?: Maybe<NotificationUserDevicesEventTypesSumFields>;
  var_pop?: Maybe<NotificationUserDevicesEventTypesVarPopFields>;
  var_samp?: Maybe<NotificationUserDevicesEventTypesVarSampFields>;
  variance?: Maybe<NotificationUserDevicesEventTypesVarianceFields>;
};


/** aggregate fields of "notification_user_devices__event_types" */
export type NotificationUserDevicesEventTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationUserDevicesEventTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "notification_user_devices__event_types" */
export type NotificationUserDevicesEventTypesAggregateOrderBy = {
  avg?: InputMaybe<NotificationUserDevicesEventTypesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<NotificationUserDevicesEventTypesMaxOrderBy>;
  min?: InputMaybe<NotificationUserDevicesEventTypesMinOrderBy>;
  stddev?: InputMaybe<NotificationUserDevicesEventTypesStddevOrderBy>;
  stddev_pop?: InputMaybe<NotificationUserDevicesEventTypesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<NotificationUserDevicesEventTypesStddevSampOrderBy>;
  sum?: InputMaybe<NotificationUserDevicesEventTypesSumOrderBy>;
  var_pop?: InputMaybe<NotificationUserDevicesEventTypesVarPopOrderBy>;
  var_samp?: InputMaybe<NotificationUserDevicesEventTypesVarSampOrderBy>;
  variance?: InputMaybe<NotificationUserDevicesEventTypesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "notification_user_devices__event_types" */
export type NotificationUserDevicesEventTypesArrRelInsertInput = {
  data: Array<NotificationUserDevicesEventTypesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<NotificationUserDevicesEventTypesOnConflict>;
};

/** aggregate avg on columns */
export type NotificationUserDevicesEventTypesAvgFields = {
  __typename?: 'notification_user_devices__event_types_avg_fields';
  id?: Maybe<Scalars['Float']>;
  notification_event_type_id?: Maybe<Scalars['Float']>;
  notification_user_device_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "notification_user_devices__event_types" */
export type NotificationUserDevicesEventTypesAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  notification_event_type_id?: InputMaybe<OrderBy>;
  notification_user_device_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "notification_user_devices__event_types". All fields are combined with a logical 'AND'. */
export type NotificationUserDevicesEventTypesBoolExp = {
  _and?: InputMaybe<Array<NotificationUserDevicesEventTypesBoolExp>>;
  _not?: InputMaybe<NotificationUserDevicesEventTypesBoolExp>;
  _or?: InputMaybe<Array<NotificationUserDevicesEventTypesBoolExp>>;
  id?: InputMaybe<IntComparisonExp>;
  notification_event_type?: InputMaybe<NotificationEventTypesBoolExp>;
  notification_event_type_id?: InputMaybe<IntComparisonExp>;
  notification_user_device?: InputMaybe<NotificationUserDevicesBoolExp>;
  notification_user_device_id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "notification_user_devices__event_types" */
export enum NotificationUserDevicesEventTypesConstraint {
  /** unique or primary key constraint on columns "id" */
  NOTIFICATION_USER_DEVICES__EVENT_TYPES_PKEY = 'notification_user_devices__event_types_pkey'
}

/** input type for incrementing numeric columns in table "notification_user_devices__event_types" */
export type NotificationUserDevicesEventTypesIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  notification_event_type_id?: InputMaybe<Scalars['Int']>;
  notification_user_device_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "notification_user_devices__event_types" */
export type NotificationUserDevicesEventTypesInsertInput = {
  id?: InputMaybe<Scalars['Int']>;
  notification_event_type?: InputMaybe<NotificationEventTypesObjRelInsertInput>;
  notification_event_type_id?: InputMaybe<Scalars['Int']>;
  notification_user_device?: InputMaybe<NotificationUserDevicesObjRelInsertInput>;
  notification_user_device_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type NotificationUserDevicesEventTypesMaxFields = {
  __typename?: 'notification_user_devices__event_types_max_fields';
  id?: Maybe<Scalars['Int']>;
  notification_event_type_id?: Maybe<Scalars['Int']>;
  notification_user_device_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "notification_user_devices__event_types" */
export type NotificationUserDevicesEventTypesMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  notification_event_type_id?: InputMaybe<OrderBy>;
  notification_user_device_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type NotificationUserDevicesEventTypesMinFields = {
  __typename?: 'notification_user_devices__event_types_min_fields';
  id?: Maybe<Scalars['Int']>;
  notification_event_type_id?: Maybe<Scalars['Int']>;
  notification_user_device_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "notification_user_devices__event_types" */
export type NotificationUserDevicesEventTypesMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  notification_event_type_id?: InputMaybe<OrderBy>;
  notification_user_device_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "notification_user_devices__event_types" */
export type NotificationUserDevicesEventTypesMutationResponse = {
  __typename?: 'notification_user_devices__event_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<NotificationUserDevicesEventTypes>;
};

/** on_conflict condition type for table "notification_user_devices__event_types" */
export type NotificationUserDevicesEventTypesOnConflict = {
  constraint: NotificationUserDevicesEventTypesConstraint;
  update_columns?: Array<NotificationUserDevicesEventTypesUpdateColumn>;
  where?: InputMaybe<NotificationUserDevicesEventTypesBoolExp>;
};

/** Ordering options when selecting data from "notification_user_devices__event_types". */
export type NotificationUserDevicesEventTypesOrderBy = {
  id?: InputMaybe<OrderBy>;
  notification_event_type?: InputMaybe<NotificationEventTypesOrderBy>;
  notification_event_type_id?: InputMaybe<OrderBy>;
  notification_user_device?: InputMaybe<NotificationUserDevicesOrderBy>;
  notification_user_device_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: notification_user_devices__event_types */
export type NotificationUserDevicesEventTypesPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "notification_user_devices__event_types" */
export enum NotificationUserDevicesEventTypesSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NOTIFICATION_EVENT_TYPE_ID = 'notification_event_type_id',
  /** column name */
  NOTIFICATION_USER_DEVICE_ID = 'notification_user_device_id'
}

/** input type for updating data in table "notification_user_devices__event_types" */
export type NotificationUserDevicesEventTypesSetInput = {
  id?: InputMaybe<Scalars['Int']>;
  notification_event_type_id?: InputMaybe<Scalars['Int']>;
  notification_user_device_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type NotificationUserDevicesEventTypesStddevFields = {
  __typename?: 'notification_user_devices__event_types_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  notification_event_type_id?: Maybe<Scalars['Float']>;
  notification_user_device_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "notification_user_devices__event_types" */
export type NotificationUserDevicesEventTypesStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  notification_event_type_id?: InputMaybe<OrderBy>;
  notification_user_device_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type NotificationUserDevicesEventTypesStddevPopFields = {
  __typename?: 'notification_user_devices__event_types_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  notification_event_type_id?: Maybe<Scalars['Float']>;
  notification_user_device_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "notification_user_devices__event_types" */
export type NotificationUserDevicesEventTypesStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  notification_event_type_id?: InputMaybe<OrderBy>;
  notification_user_device_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type NotificationUserDevicesEventTypesStddevSampFields = {
  __typename?: 'notification_user_devices__event_types_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  notification_event_type_id?: Maybe<Scalars['Float']>;
  notification_user_device_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "notification_user_devices__event_types" */
export type NotificationUserDevicesEventTypesStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  notification_event_type_id?: InputMaybe<OrderBy>;
  notification_user_device_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "notification_user_devices__event_types" */
export type NotificationUserDevicesEventTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: NotificationUserDevicesEventTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationUserDevicesEventTypesStreamCursorValueInput = {
  id?: InputMaybe<Scalars['Int']>;
  notification_event_type_id?: InputMaybe<Scalars['Int']>;
  notification_user_device_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type NotificationUserDevicesEventTypesSumFields = {
  __typename?: 'notification_user_devices__event_types_sum_fields';
  id?: Maybe<Scalars['Int']>;
  notification_event_type_id?: Maybe<Scalars['Int']>;
  notification_user_device_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "notification_user_devices__event_types" */
export type NotificationUserDevicesEventTypesSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  notification_event_type_id?: InputMaybe<OrderBy>;
  notification_user_device_id?: InputMaybe<OrderBy>;
};

/** update columns of table "notification_user_devices__event_types" */
export enum NotificationUserDevicesEventTypesUpdateColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NOTIFICATION_EVENT_TYPE_ID = 'notification_event_type_id',
  /** column name */
  NOTIFICATION_USER_DEVICE_ID = 'notification_user_device_id'
}

export type NotificationUserDevicesEventTypesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<NotificationUserDevicesEventTypesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NotificationUserDevicesEventTypesSetInput>;
  /** filter the rows which have to be updated */
  where: NotificationUserDevicesEventTypesBoolExp;
};

/** aggregate var_pop on columns */
export type NotificationUserDevicesEventTypesVarPopFields = {
  __typename?: 'notification_user_devices__event_types_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  notification_event_type_id?: Maybe<Scalars['Float']>;
  notification_user_device_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "notification_user_devices__event_types" */
export type NotificationUserDevicesEventTypesVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  notification_event_type_id?: InputMaybe<OrderBy>;
  notification_user_device_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type NotificationUserDevicesEventTypesVarSampFields = {
  __typename?: 'notification_user_devices__event_types_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  notification_event_type_id?: Maybe<Scalars['Float']>;
  notification_user_device_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "notification_user_devices__event_types" */
export type NotificationUserDevicesEventTypesVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  notification_event_type_id?: InputMaybe<OrderBy>;
  notification_user_device_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type NotificationUserDevicesEventTypesVarianceFields = {
  __typename?: 'notification_user_devices__event_types_variance_fields';
  id?: Maybe<Scalars['Float']>;
  notification_event_type_id?: Maybe<Scalars['Float']>;
  notification_user_device_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "notification_user_devices__event_types" */
export type NotificationUserDevicesEventTypesVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  notification_event_type_id?: InputMaybe<OrderBy>;
  notification_user_device_id?: InputMaybe<OrderBy>;
};

/** aggregated selection of "notification_user_devices" */
export type NotificationUserDevicesAggregate = {
  __typename?: 'notification_user_devices_aggregate';
  aggregate?: Maybe<NotificationUserDevicesAggregateFields>;
  nodes: Array<NotificationUserDevices>;
};

/** aggregate fields of "notification_user_devices" */
export type NotificationUserDevicesAggregateFields = {
  __typename?: 'notification_user_devices_aggregate_fields';
  avg?: Maybe<NotificationUserDevicesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<NotificationUserDevicesMaxFields>;
  min?: Maybe<NotificationUserDevicesMinFields>;
  stddev?: Maybe<NotificationUserDevicesStddevFields>;
  stddev_pop?: Maybe<NotificationUserDevicesStddevPopFields>;
  stddev_samp?: Maybe<NotificationUserDevicesStddevSampFields>;
  sum?: Maybe<NotificationUserDevicesSumFields>;
  var_pop?: Maybe<NotificationUserDevicesVarPopFields>;
  var_samp?: Maybe<NotificationUserDevicesVarSampFields>;
  variance?: Maybe<NotificationUserDevicesVarianceFields>;
};


/** aggregate fields of "notification_user_devices" */
export type NotificationUserDevicesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationUserDevicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type NotificationUserDevicesAvgFields = {
  __typename?: 'notification_user_devices_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "notification_user_devices". All fields are combined with a logical 'AND'. */
export type NotificationUserDevicesBoolExp = {
  _and?: InputMaybe<Array<NotificationUserDevicesBoolExp>>;
  _not?: InputMaybe<NotificationUserDevicesBoolExp>;
  _or?: InputMaybe<Array<NotificationUserDevicesBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<IntComparisonExp>;
  device?: InputMaybe<DevicesBoolExp>;
  device_id?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  notification_user_devices_event_types?: InputMaybe<NotificationUserDevicesEventTypesBoolExp>;
  notification_user_devices_event_types_aggregate?: InputMaybe<NotificationUserDevicesEventTypesAggregateBoolExp>;
  published_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<IntComparisonExp>;
  user?: InputMaybe<UsersPermissionsUserBoolExp>;
  user_id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "notification_user_devices" */
export enum NotificationUserDevicesConstraint {
  /** unique or primary key constraint on columns "id" */
  NOTIFICATION_USER_DEVICES_PKEY = 'notification_user_devices_pkey'
}

/** input type for incrementing numeric columns in table "notification_user_devices" */
export type NotificationUserDevicesIncInput = {
  created_by?: InputMaybe<Scalars['Int']>;
  device_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "notification_user_devices" */
export type NotificationUserDevicesInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  device?: InputMaybe<DevicesObjRelInsertInput>;
  device_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  notification_user_devices_event_types?: InputMaybe<NotificationUserDevicesEventTypesArrRelInsertInput>;
  published_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<UsersPermissionsUserObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type NotificationUserDevicesMaxFields = {
  __typename?: 'notification_user_devices_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  device_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type NotificationUserDevicesMinFields = {
  __typename?: 'notification_user_devices_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  device_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "notification_user_devices" */
export type NotificationUserDevicesMutationResponse = {
  __typename?: 'notification_user_devices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<NotificationUserDevices>;
};

/** input type for inserting object relation for remote table "notification_user_devices" */
export type NotificationUserDevicesObjRelInsertInput = {
  data: NotificationUserDevicesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<NotificationUserDevicesOnConflict>;
};

/** on_conflict condition type for table "notification_user_devices" */
export type NotificationUserDevicesOnConflict = {
  constraint: NotificationUserDevicesConstraint;
  update_columns?: Array<NotificationUserDevicesUpdateColumn>;
  where?: InputMaybe<NotificationUserDevicesBoolExp>;
};

/** Ordering options when selecting data from "notification_user_devices". */
export type NotificationUserDevicesOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  device?: InputMaybe<DevicesOrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  notification_user_devices_event_types_aggregate?: InputMaybe<NotificationUserDevicesEventTypesAggregateOrderBy>;
  published_at?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersPermissionsUserOrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: notification_user_devices */
export type NotificationUserDevicesPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "notification_user_devices" */
export enum NotificationUserDevicesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  DEVICE_ID = 'device_id',
  /** column name */
  ID = 'id',
  /** column name */
  PUBLISHED_AT = 'published_at',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by',
  /** column name */
  USER_ID = 'user_id'
}

/** input type for updating data in table "notification_user_devices" */
export type NotificationUserDevicesSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  device_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  published_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type NotificationUserDevicesStddevFields = {
  __typename?: 'notification_user_devices_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type NotificationUserDevicesStddevPopFields = {
  __typename?: 'notification_user_devices_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type NotificationUserDevicesStddevSampFields = {
  __typename?: 'notification_user_devices_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "notification_user_devices" */
export type NotificationUserDevicesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: NotificationUserDevicesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationUserDevicesStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  device_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  published_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type NotificationUserDevicesSumFields = {
  __typename?: 'notification_user_devices_sum_fields';
  created_by?: Maybe<Scalars['Int']>;
  device_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "notification_user_devices" */
export enum NotificationUserDevicesUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  DEVICE_ID = 'device_id',
  /** column name */
  ID = 'id',
  /** column name */
  PUBLISHED_AT = 'published_at',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by',
  /** column name */
  USER_ID = 'user_id'
}

export type NotificationUserDevicesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<NotificationUserDevicesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NotificationUserDevicesSetInput>;
  /** filter the rows which have to be updated */
  where: NotificationUserDevicesBoolExp;
};

/** aggregate var_pop on columns */
export type NotificationUserDevicesVarPopFields = {
  __typename?: 'notification_user_devices_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type NotificationUserDevicesVarSampFields = {
  __typename?: 'notification_user_devices_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type NotificationUserDevicesVarianceFields = {
  __typename?: 'notification_user_devices_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** User settings related to notifications */
export type NotificationUserSettings = {
  __typename?: 'notification_user_settings';
  created_at: Scalars['timestamptz'];
  events_enabled: Scalars['Boolean'];
  id: Scalars['Int'];
  messages_enabled: Scalars['Boolean'];
  releases_enabled: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['Int'];
};

/** aggregated selection of "notification_user_settings" */
export type NotificationUserSettingsAggregate = {
  __typename?: 'notification_user_settings_aggregate';
  aggregate?: Maybe<NotificationUserSettingsAggregateFields>;
  nodes: Array<NotificationUserSettings>;
};

/** aggregate fields of "notification_user_settings" */
export type NotificationUserSettingsAggregateFields = {
  __typename?: 'notification_user_settings_aggregate_fields';
  avg?: Maybe<NotificationUserSettingsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<NotificationUserSettingsMaxFields>;
  min?: Maybe<NotificationUserSettingsMinFields>;
  stddev?: Maybe<NotificationUserSettingsStddevFields>;
  stddev_pop?: Maybe<NotificationUserSettingsStddevPopFields>;
  stddev_samp?: Maybe<NotificationUserSettingsStddevSampFields>;
  sum?: Maybe<NotificationUserSettingsSumFields>;
  var_pop?: Maybe<NotificationUserSettingsVarPopFields>;
  var_samp?: Maybe<NotificationUserSettingsVarSampFields>;
  variance?: Maybe<NotificationUserSettingsVarianceFields>;
};


/** aggregate fields of "notification_user_settings" */
export type NotificationUserSettingsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationUserSettingsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type NotificationUserSettingsAvgFields = {
  __typename?: 'notification_user_settings_avg_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "notification_user_settings". All fields are combined with a logical 'AND'. */
export type NotificationUserSettingsBoolExp = {
  _and?: InputMaybe<Array<NotificationUserSettingsBoolExp>>;
  _not?: InputMaybe<NotificationUserSettingsBoolExp>;
  _or?: InputMaybe<Array<NotificationUserSettingsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  events_enabled?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  messages_enabled?: InputMaybe<BooleanComparisonExp>;
  releases_enabled?: InputMaybe<BooleanComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  user_id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "notification_user_settings" */
export enum NotificationUserSettingsConstraint {
  /** unique or primary key constraint on columns "id" */
  NOTIFICATION_USER_SETTINGS_PKEY = 'notification_user_settings_pkey',
  /** unique or primary key constraint on columns "user_id" */
  NOTIFICATION_USER_SETTINGS_USER_ID_KEY = 'notification_user_settings_user_id_key'
}

/** input type for incrementing numeric columns in table "notification_user_settings" */
export type NotificationUserSettingsIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "notification_user_settings" */
export type NotificationUserSettingsInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  events_enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  messages_enabled?: InputMaybe<Scalars['Boolean']>;
  releases_enabled?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type NotificationUserSettingsMaxFields = {
  __typename?: 'notification_user_settings_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type NotificationUserSettingsMinFields = {
  __typename?: 'notification_user_settings_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "notification_user_settings" */
export type NotificationUserSettingsMutationResponse = {
  __typename?: 'notification_user_settings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<NotificationUserSettings>;
};

/** input type for inserting object relation for remote table "notification_user_settings" */
export type NotificationUserSettingsObjRelInsertInput = {
  data: NotificationUserSettingsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<NotificationUserSettingsOnConflict>;
};

/** on_conflict condition type for table "notification_user_settings" */
export type NotificationUserSettingsOnConflict = {
  constraint: NotificationUserSettingsConstraint;
  update_columns?: Array<NotificationUserSettingsUpdateColumn>;
  where?: InputMaybe<NotificationUserSettingsBoolExp>;
};

/** Ordering options when selecting data from "notification_user_settings". */
export type NotificationUserSettingsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  events_enabled?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  messages_enabled?: InputMaybe<OrderBy>;
  releases_enabled?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: notification_user_settings */
export type NotificationUserSettingsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "notification_user_settings" */
export enum NotificationUserSettingsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  EVENTS_ENABLED = 'events_enabled',
  /** column name */
  ID = 'id',
  /** column name */
  MESSAGES_ENABLED = 'messages_enabled',
  /** column name */
  RELEASES_ENABLED = 'releases_enabled',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
}

/** input type for updating data in table "notification_user_settings" */
export type NotificationUserSettingsSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  events_enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  messages_enabled?: InputMaybe<Scalars['Boolean']>;
  releases_enabled?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type NotificationUserSettingsStddevFields = {
  __typename?: 'notification_user_settings_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type NotificationUserSettingsStddevPopFields = {
  __typename?: 'notification_user_settings_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type NotificationUserSettingsStddevSampFields = {
  __typename?: 'notification_user_settings_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "notification_user_settings" */
export type NotificationUserSettingsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: NotificationUserSettingsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationUserSettingsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  events_enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  messages_enabled?: InputMaybe<Scalars['Boolean']>;
  releases_enabled?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type NotificationUserSettingsSumFields = {
  __typename?: 'notification_user_settings_sum_fields';
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "notification_user_settings" */
export enum NotificationUserSettingsUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  EVENTS_ENABLED = 'events_enabled',
  /** column name */
  ID = 'id',
  /** column name */
  MESSAGES_ENABLED = 'messages_enabled',
  /** column name */
  RELEASES_ENABLED = 'releases_enabled',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
}

export type NotificationUserSettingsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<NotificationUserSettingsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NotificationUserSettingsSetInput>;
  /** filter the rows which have to be updated */
  where: NotificationUserSettingsBoolExp;
};

/** aggregate var_pop on columns */
export type NotificationUserSettingsVarPopFields = {
  __typename?: 'notification_user_settings_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type NotificationUserSettingsVarSampFields = {
  __typename?: 'notification_user_settings_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type NotificationUserSettingsVarianceFields = {
  __typename?: 'notification_user_settings_variance_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** User notifications */
export type Notifications = {
  __typename?: 'notifications';
  application_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  content: NotificationsContent;
  content_id: Scalars['bigint'];
  created_at: Scalars['timestamptz'];
  hidden: Scalars['Boolean'];
  id: Scalars['bigint'];
  kind: NotificationKindsEnum;
  read: Scalars['Boolean'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['Int'];
  version: Scalars['Int'];
};

/** aggregated selection of "notifications" */
export type NotificationsAggregate = {
  __typename?: 'notifications_aggregate';
  aggregate?: Maybe<NotificationsAggregateFields>;
  nodes: Array<Notifications>;
};

export type NotificationsAggregateBoolExp = {
  bool_and?: InputMaybe<NotificationsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<NotificationsAggregateBoolExpBoolOr>;
  count?: InputMaybe<NotificationsAggregateBoolExpCount>;
};

export type NotificationsAggregateBoolExpBoolAnd = {
  arguments: NotificationsSelectColumnNotificationsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<NotificationsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type NotificationsAggregateBoolExpBoolOr = {
  arguments: NotificationsSelectColumnNotificationsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<NotificationsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type NotificationsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<NotificationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<NotificationsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "notifications" */
export type NotificationsAggregateFields = {
  __typename?: 'notifications_aggregate_fields';
  avg?: Maybe<NotificationsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<NotificationsMaxFields>;
  min?: Maybe<NotificationsMinFields>;
  stddev?: Maybe<NotificationsStddevFields>;
  stddev_pop?: Maybe<NotificationsStddevPopFields>;
  stddev_samp?: Maybe<NotificationsStddevSampFields>;
  sum?: Maybe<NotificationsSumFields>;
  var_pop?: Maybe<NotificationsVarPopFields>;
  var_samp?: Maybe<NotificationsVarSampFields>;
  variance?: Maybe<NotificationsVarianceFields>;
};


/** aggregate fields of "notifications" */
export type NotificationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "notifications" */
export type NotificationsAggregateOrderBy = {
  avg?: InputMaybe<NotificationsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<NotificationsMaxOrderBy>;
  min?: InputMaybe<NotificationsMinOrderBy>;
  stddev?: InputMaybe<NotificationsStddevOrderBy>;
  stddev_pop?: InputMaybe<NotificationsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<NotificationsStddevSampOrderBy>;
  sum?: InputMaybe<NotificationsSumOrderBy>;
  var_pop?: InputMaybe<NotificationsVarPopOrderBy>;
  var_samp?: InputMaybe<NotificationsVarSampOrderBy>;
  variance?: InputMaybe<NotificationsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "notifications" */
export type NotificationsArrRelInsertInput = {
  data: Array<NotificationsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<NotificationsOnConflict>;
};

/** aggregate avg on columns */
export type NotificationsAvgFields = {
  __typename?: 'notifications_avg_fields';
  application_id?: Maybe<Scalars['Float']>;
  content_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "notifications" */
export type NotificationsAvgOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  content_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "notifications". All fields are combined with a logical 'AND'. */
export type NotificationsBoolExp = {
  _and?: InputMaybe<Array<NotificationsBoolExp>>;
  _not?: InputMaybe<NotificationsBoolExp>;
  _or?: InputMaybe<Array<NotificationsBoolExp>>;
  application_id?: InputMaybe<IntComparisonExp>;
  content?: InputMaybe<NotificationsContentBoolExp>;
  content_id?: InputMaybe<BigintComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  hidden?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  kind?: InputMaybe<NotificationKindsEnumComparisonExp>;
  read?: InputMaybe<BooleanComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  user_id?: InputMaybe<IntComparisonExp>;
  version?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "notifications" */
export enum NotificationsConstraint {
  /** unique or primary key constraint on columns "id" */
  NOTIFICATIONS_PKEY = 'notifications_pkey'
}

/** Content dynamic and managed by hygraph */
export type NotificationsContent = {
  __typename?: 'notifications_content';
  created_at: Scalars['timestamptz'];
  hygraph_message?: Maybe<MessagesCollection>;
  hygraph_release?: Maybe<ReleasesCollection>;
  id: Scalars['bigint'];
  kind: NotificationKindsEnum;
  message_hygraph_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An aggregate relationship */
  notifications_aggregate: NotificationsAggregate;
  release_hygraph_id?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  values?: Maybe<Scalars['notification_values']>;
};


/** Content dynamic and managed by hygraph */
export type NotificationsContentHygraphMessageArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
};


/** Content dynamic and managed by hygraph */
export type NotificationsContentHygraphReleaseArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
};


/** Content dynamic and managed by hygraph */
export type NotificationsContentNotificationsArgs = {
  distinct_on?: InputMaybe<Array<NotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationsOrderBy>>;
  where?: InputMaybe<NotificationsBoolExp>;
};


/** Content dynamic and managed by hygraph */
export type NotificationsContentNotificationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationsOrderBy>>;
  where?: InputMaybe<NotificationsBoolExp>;
};


/** Content dynamic and managed by hygraph */
export type NotificationsContentValuesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "notifications_content" */
export type NotificationsContentAggregate = {
  __typename?: 'notifications_content_aggregate';
  aggregate?: Maybe<NotificationsContentAggregateFields>;
  nodes: Array<NotificationsContent>;
};

/** aggregate fields of "notifications_content" */
export type NotificationsContentAggregateFields = {
  __typename?: 'notifications_content_aggregate_fields';
  avg?: Maybe<NotificationsContentAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<NotificationsContentMaxFields>;
  min?: Maybe<NotificationsContentMinFields>;
  stddev?: Maybe<NotificationsContentStddevFields>;
  stddev_pop?: Maybe<NotificationsContentStddevPopFields>;
  stddev_samp?: Maybe<NotificationsContentStddevSampFields>;
  sum?: Maybe<NotificationsContentSumFields>;
  var_pop?: Maybe<NotificationsContentVarPopFields>;
  var_samp?: Maybe<NotificationsContentVarSampFields>;
  variance?: Maybe<NotificationsContentVarianceFields>;
};


/** aggregate fields of "notifications_content" */
export type NotificationsContentAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationsContentSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type NotificationsContentAppendInput = {
  values?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type NotificationsContentAvgFields = {
  __typename?: 'notifications_content_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "notifications_content". All fields are combined with a logical 'AND'. */
export type NotificationsContentBoolExp = {
  _and?: InputMaybe<Array<NotificationsContentBoolExp>>;
  _not?: InputMaybe<NotificationsContentBoolExp>;
  _or?: InputMaybe<Array<NotificationsContentBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  kind?: InputMaybe<NotificationKindsEnumComparisonExp>;
  message_hygraph_id?: InputMaybe<StringComparisonExp>;
  notifications?: InputMaybe<NotificationsBoolExp>;
  notifications_aggregate?: InputMaybe<NotificationsAggregateBoolExp>;
  release_hygraph_id?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  values?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "notifications_content" */
export enum NotificationsContentConstraint {
  /** unique or primary key constraint on columns "id" */
  NOTIFICATIONS_CONTENT_PKEY = 'notifications_content_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type NotificationsContentDeleteAtPathInput = {
  values?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type NotificationsContentDeleteElemInput = {
  values?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type NotificationsContentDeleteKeyInput = {
  values?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "notifications_content" */
export type NotificationsContentIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "notifications_content" */
export type NotificationsContentInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<NotificationKindsEnum>;
  message_hygraph_id?: InputMaybe<Scalars['String']>;
  notifications?: InputMaybe<NotificationsArrRelInsertInput>;
  release_hygraph_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  values?: InputMaybe<Scalars['notification_values']>;
};

/** aggregate max on columns */
export type NotificationsContentMaxFields = {
  __typename?: 'notifications_content_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  message_hygraph_id?: Maybe<Scalars['String']>;
  release_hygraph_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type NotificationsContentMinFields = {
  __typename?: 'notifications_content_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  message_hygraph_id?: Maybe<Scalars['String']>;
  release_hygraph_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "notifications_content" */
export type NotificationsContentMutationResponse = {
  __typename?: 'notifications_content_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<NotificationsContent>;
};

/** input type for inserting object relation for remote table "notifications_content" */
export type NotificationsContentObjRelInsertInput = {
  data: NotificationsContentInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<NotificationsContentOnConflict>;
};

/** on_conflict condition type for table "notifications_content" */
export type NotificationsContentOnConflict = {
  constraint: NotificationsContentConstraint;
  update_columns?: Array<NotificationsContentUpdateColumn>;
  where?: InputMaybe<NotificationsContentBoolExp>;
};

/** Ordering options when selecting data from "notifications_content". */
export type NotificationsContentOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  kind?: InputMaybe<OrderBy>;
  message_hygraph_id?: InputMaybe<OrderBy>;
  notifications_aggregate?: InputMaybe<NotificationsAggregateOrderBy>;
  release_hygraph_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  values?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: notifications_content */
export type NotificationsContentPkColumnsInput = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type NotificationsContentPrependInput = {
  values?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "notifications_content" */
export enum NotificationsContentSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  KIND = 'kind',
  /** column name */
  MESSAGE_HYGRAPH_ID = 'message_hygraph_id',
  /** column name */
  RELEASE_HYGRAPH_ID = 'release_hygraph_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  VALUES = 'values'
}

/** input type for updating data in table "notifications_content" */
export type NotificationsContentSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<NotificationKindsEnum>;
  message_hygraph_id?: InputMaybe<Scalars['String']>;
  release_hygraph_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  values?: InputMaybe<Scalars['notification_values']>;
};

/** aggregate stddev on columns */
export type NotificationsContentStddevFields = {
  __typename?: 'notifications_content_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type NotificationsContentStddevPopFields = {
  __typename?: 'notifications_content_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type NotificationsContentStddevSampFields = {
  __typename?: 'notifications_content_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "notifications_content" */
export type NotificationsContentStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: NotificationsContentStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationsContentStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<NotificationKindsEnum>;
  message_hygraph_id?: InputMaybe<Scalars['String']>;
  release_hygraph_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  values?: InputMaybe<Scalars['notification_values']>;
};

/** aggregate sum on columns */
export type NotificationsContentSumFields = {
  __typename?: 'notifications_content_sum_fields';
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "notifications_content" */
export enum NotificationsContentUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  KIND = 'kind',
  /** column name */
  MESSAGE_HYGRAPH_ID = 'message_hygraph_id',
  /** column name */
  RELEASE_HYGRAPH_ID = 'release_hygraph_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  VALUES = 'values'
}

export type NotificationsContentUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<NotificationsContentAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<NotificationsContentDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<NotificationsContentDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<NotificationsContentDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<NotificationsContentIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<NotificationsContentPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NotificationsContentSetInput>;
  /** filter the rows which have to be updated */
  where: NotificationsContentBoolExp;
};

/** aggregate var_pop on columns */
export type NotificationsContentVarPopFields = {
  __typename?: 'notifications_content_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type NotificationsContentVarSampFields = {
  __typename?: 'notifications_content_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type NotificationsContentVarianceFields = {
  __typename?: 'notifications_content_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** input type for incrementing numeric columns in table "notifications" */
export type NotificationsIncInput = {
  application_id?: InputMaybe<Scalars['Int']>;
  content_id?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['Int']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "notifications" */
export type NotificationsInsertInput = {
  application_id?: InputMaybe<Scalars['Int']>;
  content?: InputMaybe<NotificationsContentObjRelInsertInput>;
  content_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<NotificationKindsEnum>;
  read?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type NotificationsMaxFields = {
  __typename?: 'notifications_max_fields';
  application_id?: Maybe<Scalars['Int']>;
  content_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "notifications" */
export type NotificationsMaxOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  content_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type NotificationsMinFields = {
  __typename?: 'notifications_min_fields';
  application_id?: Maybe<Scalars['Int']>;
  content_id?: Maybe<Scalars['bigint']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "notifications" */
export type NotificationsMinOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  content_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "notifications" */
export type NotificationsMutationResponse = {
  __typename?: 'notifications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notifications>;
};

/** on_conflict condition type for table "notifications" */
export type NotificationsOnConflict = {
  constraint: NotificationsConstraint;
  update_columns?: Array<NotificationsUpdateColumn>;
  where?: InputMaybe<NotificationsBoolExp>;
};

/** Ordering options when selecting data from "notifications". */
export type NotificationsOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  content?: InputMaybe<NotificationsContentOrderBy>;
  content_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  hidden?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  kind?: InputMaybe<OrderBy>;
  read?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: notifications */
export type NotificationsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "notifications" */
export enum NotificationsSelectColumn {
  /** column name */
  APPLICATION_ID = 'application_id',
  /** column name */
  CONTENT_ID = 'content_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  HIDDEN = 'hidden',
  /** column name */
  ID = 'id',
  /** column name */
  KIND = 'kind',
  /** column name */
  READ = 'read',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id',
  /** column name */
  VERSION = 'version'
}

/** select "notifications_aggregate_bool_exp_bool_and_arguments_columns" columns of table "notifications" */
export enum NotificationsSelectColumnNotificationsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  HIDDEN = 'hidden',
  /** column name */
  READ = 'read'
}

/** select "notifications_aggregate_bool_exp_bool_or_arguments_columns" columns of table "notifications" */
export enum NotificationsSelectColumnNotificationsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  HIDDEN = 'hidden',
  /** column name */
  READ = 'read'
}

/** input type for updating data in table "notifications" */
export type NotificationsSetInput = {
  application_id?: InputMaybe<Scalars['Int']>;
  content_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<NotificationKindsEnum>;
  read?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type NotificationsStddevFields = {
  __typename?: 'notifications_stddev_fields';
  application_id?: Maybe<Scalars['Float']>;
  content_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "notifications" */
export type NotificationsStddevOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  content_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type NotificationsStddevPopFields = {
  __typename?: 'notifications_stddev_pop_fields';
  application_id?: Maybe<Scalars['Float']>;
  content_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "notifications" */
export type NotificationsStddevPopOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  content_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type NotificationsStddevSampFields = {
  __typename?: 'notifications_stddev_samp_fields';
  application_id?: Maybe<Scalars['Float']>;
  content_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "notifications" */
export type NotificationsStddevSampOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  content_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "notifications" */
export type NotificationsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: NotificationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationsStreamCursorValueInput = {
  application_id?: InputMaybe<Scalars['Int']>;
  content_id?: InputMaybe<Scalars['bigint']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['bigint']>;
  kind?: InputMaybe<NotificationKindsEnum>;
  read?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type NotificationsSumFields = {
  __typename?: 'notifications_sum_fields';
  application_id?: Maybe<Scalars['Int']>;
  content_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "notifications" */
export type NotificationsSumOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  content_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** update columns of table "notifications" */
export enum NotificationsUpdateColumn {
  /** column name */
  APPLICATION_ID = 'application_id',
  /** column name */
  CONTENT_ID = 'content_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  HIDDEN = 'hidden',
  /** column name */
  ID = 'id',
  /** column name */
  KIND = 'kind',
  /** column name */
  READ = 'read',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id',
  /** column name */
  VERSION = 'version'
}

export type NotificationsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<NotificationsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NotificationsSetInput>;
  /** filter the rows which have to be updated */
  where: NotificationsBoolExp;
};

/** aggregate var_pop on columns */
export type NotificationsVarPopFields = {
  __typename?: 'notifications_var_pop_fields';
  application_id?: Maybe<Scalars['Float']>;
  content_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "notifications" */
export type NotificationsVarPopOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  content_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type NotificationsVarSampFields = {
  __typename?: 'notifications_var_samp_fields';
  application_id?: Maybe<Scalars['Float']>;
  content_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "notifications" */
export type NotificationsVarSampOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  content_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type NotificationsVarianceFields = {
  __typename?: 'notifications_variance_fields';
  application_id?: Maybe<Scalars['Float']>;
  content_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "notifications" */
export type NotificationsVarianceOrderBy = {
  application_id?: InputMaybe<OrderBy>;
  content_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type NumericComparisonExp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum OrderBy {
  /** in ascending order, nulls last */
  ASC = 'asc',
  /** in ascending order, nulls first */
  ASC_NULLS_FIRST = 'asc_nulls_first',
  /** in ascending order, nulls last */
  ASC_NULLS_LAST = 'asc_nulls_last',
  /** in descending order, nulls first */
  DESC = 'desc',
  /** in descending order, nulls first */
  DESC_NULLS_FIRST = 'desc_nulls_first',
  /** in descending order, nulls last */
  DESC_NULLS_LAST = 'desc_nulls_last'
}

/** columns and relationships of "organizations" */
export type Organizations = {
  __typename?: 'organizations';
  /** An array relationship */
  applications: Array<Applications>;
  /** An aggregate relationship */
  applications_aggregate: ApplicationsAggregate;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  /** An object relationship */
  feature_limits?: Maybe<OrganizationsFeatureLimits>;
  id: Scalars['Int'];
  migratedToCloud?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  providerId: Scalars['String'];
  providerToken: Scalars['String'];
  public: Scalars['Boolean'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
  /** An array relationship */
  users: Array<OrganizationsUsersUsersOrganizations>;
  /** An aggregate relationship */
  users_aggregate: OrganizationsUsersUsersOrganizationsAggregate;
};


/** columns and relationships of "organizations" */
export type OrganizationsApplicationsArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsOrderBy>>;
  where?: InputMaybe<ApplicationsBoolExp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsApplicationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsOrderBy>>;
  where?: InputMaybe<ApplicationsBoolExp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsUsersArgs = {
  distinct_on?: InputMaybe<Array<OrganizationsUsersUsersOrganizationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationsUsersUsersOrganizationsOrderBy>>;
  where?: InputMaybe<OrganizationsUsersUsersOrganizationsBoolExp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<OrganizationsUsersUsersOrganizationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationsUsersUsersOrganizationsOrderBy>>;
  where?: InputMaybe<OrganizationsUsersUsersOrganizationsBoolExp>;
};

/** aggregated selection of "organizations" */
export type OrganizationsAggregate = {
  __typename?: 'organizations_aggregate';
  aggregate?: Maybe<OrganizationsAggregateFields>;
  nodes: Array<Organizations>;
};

/** aggregate fields of "organizations" */
export type OrganizationsAggregateFields = {
  __typename?: 'organizations_aggregate_fields';
  avg?: Maybe<OrganizationsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<OrganizationsMaxFields>;
  min?: Maybe<OrganizationsMinFields>;
  stddev?: Maybe<OrganizationsStddevFields>;
  stddev_pop?: Maybe<OrganizationsStddevPopFields>;
  stddev_samp?: Maybe<OrganizationsStddevSampFields>;
  sum?: Maybe<OrganizationsSumFields>;
  var_pop?: Maybe<OrganizationsVarPopFields>;
  var_samp?: Maybe<OrganizationsVarSampFields>;
  variance?: Maybe<OrganizationsVarianceFields>;
};


/** aggregate fields of "organizations" */
export type OrganizationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<OrganizationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type OrganizationsAvgFields = {
  __typename?: 'organizations_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "organizations". All fields are combined with a logical 'AND'. */
export type OrganizationsBoolExp = {
  _and?: InputMaybe<Array<OrganizationsBoolExp>>;
  _not?: InputMaybe<OrganizationsBoolExp>;
  _or?: InputMaybe<Array<OrganizationsBoolExp>>;
  applications?: InputMaybe<ApplicationsBoolExp>;
  applications_aggregate?: InputMaybe<ApplicationsAggregateBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<IntComparisonExp>;
  feature_limits?: InputMaybe<OrganizationsFeatureLimitsBoolExp>;
  id?: InputMaybe<IntComparisonExp>;
  migratedToCloud?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  providerId?: InputMaybe<StringComparisonExp>;
  providerToken?: InputMaybe<StringComparisonExp>;
  public?: InputMaybe<BooleanComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<IntComparisonExp>;
  users?: InputMaybe<OrganizationsUsersUsersOrganizationsBoolExp>;
  users_aggregate?: InputMaybe<OrganizationsUsersUsersOrganizationsAggregateBoolExp>;
};

/** Dynamic current limits of chat per organization */
export type OrganizationsChatParams = {
  __typename?: 'organizations_chat_params';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['Int'];
  tokens_month_used: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "organizations_chat_params" */
export type OrganizationsChatParamsAggregate = {
  __typename?: 'organizations_chat_params_aggregate';
  aggregate?: Maybe<OrganizationsChatParamsAggregateFields>;
  nodes: Array<OrganizationsChatParams>;
};

/** aggregate fields of "organizations_chat_params" */
export type OrganizationsChatParamsAggregateFields = {
  __typename?: 'organizations_chat_params_aggregate_fields';
  avg?: Maybe<OrganizationsChatParamsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<OrganizationsChatParamsMaxFields>;
  min?: Maybe<OrganizationsChatParamsMinFields>;
  stddev?: Maybe<OrganizationsChatParamsStddevFields>;
  stddev_pop?: Maybe<OrganizationsChatParamsStddevPopFields>;
  stddev_samp?: Maybe<OrganizationsChatParamsStddevSampFields>;
  sum?: Maybe<OrganizationsChatParamsSumFields>;
  var_pop?: Maybe<OrganizationsChatParamsVarPopFields>;
  var_samp?: Maybe<OrganizationsChatParamsVarSampFields>;
  variance?: Maybe<OrganizationsChatParamsVarianceFields>;
};


/** aggregate fields of "organizations_chat_params" */
export type OrganizationsChatParamsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<OrganizationsChatParamsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type OrganizationsChatParamsAvgFields = {
  __typename?: 'organizations_chat_params_avg_fields';
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  tokens_month_used?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "organizations_chat_params". All fields are combined with a logical 'AND'. */
export type OrganizationsChatParamsBoolExp = {
  _and?: InputMaybe<Array<OrganizationsChatParamsBoolExp>>;
  _not?: InputMaybe<OrganizationsChatParamsBoolExp>;
  _or?: InputMaybe<Array<OrganizationsChatParamsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  organization?: InputMaybe<OrganizationsBoolExp>;
  organization_id?: InputMaybe<IntComparisonExp>;
  tokens_month_used?: InputMaybe<IntComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "organizations_chat_params" */
export enum OrganizationsChatParamsConstraint {
  /** unique or primary key constraint on columns "organization_id" */
  ORGANIZATIONS_CHAT_PARAMS_ORGANIZATION_ID_KEY = 'organizations_chat_params_organization_id_key',
  /** unique or primary key constraint on columns "id" */
  ORGANIZATIONS_CHAT_PARAMS_PKEY = 'organizations_chat_params_pkey'
}

/** input type for incrementing numeric columns in table "organizations_chat_params" */
export type OrganizationsChatParamsIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  organization_id?: InputMaybe<Scalars['Int']>;
  tokens_month_used?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "organizations_chat_params" */
export type OrganizationsChatParamsInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<OrganizationsObjRelInsertInput>;
  organization_id?: InputMaybe<Scalars['Int']>;
  tokens_month_used?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type OrganizationsChatParamsMaxFields = {
  __typename?: 'organizations_chat_params_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organization_id?: Maybe<Scalars['Int']>;
  tokens_month_used?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type OrganizationsChatParamsMinFields = {
  __typename?: 'organizations_chat_params_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  organization_id?: Maybe<Scalars['Int']>;
  tokens_month_used?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "organizations_chat_params" */
export type OrganizationsChatParamsMutationResponse = {
  __typename?: 'organizations_chat_params_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<OrganizationsChatParams>;
};

/** on_conflict condition type for table "organizations_chat_params" */
export type OrganizationsChatParamsOnConflict = {
  constraint: OrganizationsChatParamsConstraint;
  update_columns?: Array<OrganizationsChatParamsUpdateColumn>;
  where?: InputMaybe<OrganizationsChatParamsBoolExp>;
};

/** Ordering options when selecting data from "organizations_chat_params". */
export type OrganizationsChatParamsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organization?: InputMaybe<OrganizationsOrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  tokens_month_used?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: organizations_chat_params */
export type OrganizationsChatParamsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "organizations_chat_params" */
export enum OrganizationsChatParamsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANIZATION_ID = 'organization_id',
  /** column name */
  TOKENS_MONTH_USED = 'tokens_month_used',
  /** column name */
  UPDATED_AT = 'updated_at'
}

/** input type for updating data in table "organizations_chat_params" */
export type OrganizationsChatParamsSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  organization_id?: InputMaybe<Scalars['Int']>;
  tokens_month_used?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type OrganizationsChatParamsStddevFields = {
  __typename?: 'organizations_chat_params_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  tokens_month_used?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type OrganizationsChatParamsStddevPopFields = {
  __typename?: 'organizations_chat_params_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  tokens_month_used?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type OrganizationsChatParamsStddevSampFields = {
  __typename?: 'organizations_chat_params_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  tokens_month_used?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "organizations_chat_params" */
export type OrganizationsChatParamsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: OrganizationsChatParamsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OrganizationsChatParamsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  organization_id?: InputMaybe<Scalars['Int']>;
  tokens_month_used?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type OrganizationsChatParamsSumFields = {
  __typename?: 'organizations_chat_params_sum_fields';
  id?: Maybe<Scalars['Int']>;
  organization_id?: Maybe<Scalars['Int']>;
  tokens_month_used?: Maybe<Scalars['Int']>;
};

/** update columns of table "organizations_chat_params" */
export enum OrganizationsChatParamsUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANIZATION_ID = 'organization_id',
  /** column name */
  TOKENS_MONTH_USED = 'tokens_month_used',
  /** column name */
  UPDATED_AT = 'updated_at'
}

export type OrganizationsChatParamsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<OrganizationsChatParamsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrganizationsChatParamsSetInput>;
  /** filter the rows which have to be updated */
  where: OrganizationsChatParamsBoolExp;
};

/** aggregate var_pop on columns */
export type OrganizationsChatParamsVarPopFields = {
  __typename?: 'organizations_chat_params_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  tokens_month_used?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type OrganizationsChatParamsVarSampFields = {
  __typename?: 'organizations_chat_params_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  tokens_month_used?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type OrganizationsChatParamsVarianceFields = {
  __typename?: 'organizations_chat_params_variance_fields';
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  tokens_month_used?: Maybe<Scalars['Float']>;
};

/** unique or primary key constraints on table "organizations" */
export enum OrganizationsConstraint {
  /** unique or primary key constraint on columns "name" */
  ORGANIZATIONS_NAME_UNIQUE = 'organizations_name_unique',
  /** unique or primary key constraint on columns "id" */
  ORGANIZATIONS_PKEY = 'organizations_pkey',
  /** unique or primary key constraint on columns "providerId" */
  ORGANIZATIONS_PROVIDERID_UNIQUE = 'organizations_providerId_unique',
  /** unique or primary key constraint on columns "providerToken" */
  ORGANIZATIONS_PROVIDERTOKEN_UNIQUE = 'organizations_providerToken_unique'
}

/** Org Permission related to feature limits */
export type OrganizationsFeatureLimits = {
  __typename?: 'organizations_feature_limits';
  analysis: Scalars['Int'];
  applications: Scalars['Int'];
  automations: Scalars['Int'];
  chat_context_dataset_hours: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  devices: Scalars['Int'];
  id: Scalars['Int'];
  max_chat_history_messages: Scalars['Int'];
  max_chat_tokens_month: Scalars['Int'];
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['Int'];
  preventions: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  users: Scalars['Int'];
};

/** aggregated selection of "organizations_feature_limits" */
export type OrganizationsFeatureLimitsAggregate = {
  __typename?: 'organizations_feature_limits_aggregate';
  aggregate?: Maybe<OrganizationsFeatureLimitsAggregateFields>;
  nodes: Array<OrganizationsFeatureLimits>;
};

/** aggregate fields of "organizations_feature_limits" */
export type OrganizationsFeatureLimitsAggregateFields = {
  __typename?: 'organizations_feature_limits_aggregate_fields';
  avg?: Maybe<OrganizationsFeatureLimitsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<OrganizationsFeatureLimitsMaxFields>;
  min?: Maybe<OrganizationsFeatureLimitsMinFields>;
  stddev?: Maybe<OrganizationsFeatureLimitsStddevFields>;
  stddev_pop?: Maybe<OrganizationsFeatureLimitsStddevPopFields>;
  stddev_samp?: Maybe<OrganizationsFeatureLimitsStddevSampFields>;
  sum?: Maybe<OrganizationsFeatureLimitsSumFields>;
  var_pop?: Maybe<OrganizationsFeatureLimitsVarPopFields>;
  var_samp?: Maybe<OrganizationsFeatureLimitsVarSampFields>;
  variance?: Maybe<OrganizationsFeatureLimitsVarianceFields>;
};


/** aggregate fields of "organizations_feature_limits" */
export type OrganizationsFeatureLimitsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<OrganizationsFeatureLimitsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type OrganizationsFeatureLimitsAvgFields = {
  __typename?: 'organizations_feature_limits_avg_fields';
  analysis?: Maybe<Scalars['Float']>;
  applications?: Maybe<Scalars['Float']>;
  automations?: Maybe<Scalars['Float']>;
  chat_context_dataset_hours?: Maybe<Scalars['Float']>;
  devices?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_chat_history_messages?: Maybe<Scalars['Float']>;
  max_chat_tokens_month?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  preventions?: Maybe<Scalars['Float']>;
  users?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "organizations_feature_limits". All fields are combined with a logical 'AND'. */
export type OrganizationsFeatureLimitsBoolExp = {
  _and?: InputMaybe<Array<OrganizationsFeatureLimitsBoolExp>>;
  _not?: InputMaybe<OrganizationsFeatureLimitsBoolExp>;
  _or?: InputMaybe<Array<OrganizationsFeatureLimitsBoolExp>>;
  analysis?: InputMaybe<IntComparisonExp>;
  applications?: InputMaybe<IntComparisonExp>;
  automations?: InputMaybe<IntComparisonExp>;
  chat_context_dataset_hours?: InputMaybe<IntComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  devices?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  max_chat_history_messages?: InputMaybe<IntComparisonExp>;
  max_chat_tokens_month?: InputMaybe<IntComparisonExp>;
  organization?: InputMaybe<OrganizationsBoolExp>;
  organization_id?: InputMaybe<IntComparisonExp>;
  preventions?: InputMaybe<IntComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  users?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "organizations_feature_limits" */
export enum OrganizationsFeatureLimitsConstraint {
  /** unique or primary key constraint on columns "organization_id" */
  ORGANIZATIONS_FEATURE_LIMITS_ORGANIZATION_ID_KEY = 'organizations_feature_limits_organization_id_key',
  /** unique or primary key constraint on columns "id", "organization_id" */
  ORGANIZATIONS_FEATURE_LIMITS_PKEY = 'organizations_feature_limits_pkey'
}

/** input type for incrementing numeric columns in table "organizations_feature_limits" */
export type OrganizationsFeatureLimitsIncInput = {
  analysis?: InputMaybe<Scalars['Int']>;
  applications?: InputMaybe<Scalars['Int']>;
  automations?: InputMaybe<Scalars['Int']>;
  chat_context_dataset_hours?: InputMaybe<Scalars['Int']>;
  devices?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  max_chat_history_messages?: InputMaybe<Scalars['Int']>;
  max_chat_tokens_month?: InputMaybe<Scalars['Int']>;
  organization_id?: InputMaybe<Scalars['Int']>;
  preventions?: InputMaybe<Scalars['Int']>;
  users?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "organizations_feature_limits" */
export type OrganizationsFeatureLimitsInsertInput = {
  analysis?: InputMaybe<Scalars['Int']>;
  applications?: InputMaybe<Scalars['Int']>;
  automations?: InputMaybe<Scalars['Int']>;
  chat_context_dataset_hours?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  devices?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  max_chat_history_messages?: InputMaybe<Scalars['Int']>;
  max_chat_tokens_month?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<OrganizationsObjRelInsertInput>;
  organization_id?: InputMaybe<Scalars['Int']>;
  preventions?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  users?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type OrganizationsFeatureLimitsMaxFields = {
  __typename?: 'organizations_feature_limits_max_fields';
  analysis?: Maybe<Scalars['Int']>;
  applications?: Maybe<Scalars['Int']>;
  automations?: Maybe<Scalars['Int']>;
  chat_context_dataset_hours?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  devices?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  max_chat_history_messages?: Maybe<Scalars['Int']>;
  max_chat_tokens_month?: Maybe<Scalars['Int']>;
  organization_id?: Maybe<Scalars['Int']>;
  preventions?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  users?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type OrganizationsFeatureLimitsMinFields = {
  __typename?: 'organizations_feature_limits_min_fields';
  analysis?: Maybe<Scalars['Int']>;
  applications?: Maybe<Scalars['Int']>;
  automations?: Maybe<Scalars['Int']>;
  chat_context_dataset_hours?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  devices?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  max_chat_history_messages?: Maybe<Scalars['Int']>;
  max_chat_tokens_month?: Maybe<Scalars['Int']>;
  organization_id?: Maybe<Scalars['Int']>;
  preventions?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  users?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "organizations_feature_limits" */
export type OrganizationsFeatureLimitsMutationResponse = {
  __typename?: 'organizations_feature_limits_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<OrganizationsFeatureLimits>;
};

/** input type for inserting object relation for remote table "organizations_feature_limits" */
export type OrganizationsFeatureLimitsObjRelInsertInput = {
  data: OrganizationsFeatureLimitsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganizationsFeatureLimitsOnConflict>;
};

/** on_conflict condition type for table "organizations_feature_limits" */
export type OrganizationsFeatureLimitsOnConflict = {
  constraint: OrganizationsFeatureLimitsConstraint;
  update_columns?: Array<OrganizationsFeatureLimitsUpdateColumn>;
  where?: InputMaybe<OrganizationsFeatureLimitsBoolExp>;
};

/** Ordering options when selecting data from "organizations_feature_limits". */
export type OrganizationsFeatureLimitsOrderBy = {
  analysis?: InputMaybe<OrderBy>;
  applications?: InputMaybe<OrderBy>;
  automations?: InputMaybe<OrderBy>;
  chat_context_dataset_hours?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  devices?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  max_chat_history_messages?: InputMaybe<OrderBy>;
  max_chat_tokens_month?: InputMaybe<OrderBy>;
  organization?: InputMaybe<OrganizationsOrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  preventions?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  users?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: organizations_feature_limits */
export type OrganizationsFeatureLimitsPkColumnsInput = {
  id: Scalars['Int'];
  organization_id: Scalars['Int'];
};

/** select columns of table "organizations_feature_limits" */
export enum OrganizationsFeatureLimitsSelectColumn {
  /** column name */
  ANALYSIS = 'analysis',
  /** column name */
  APPLICATIONS = 'applications',
  /** column name */
  AUTOMATIONS = 'automations',
  /** column name */
  CHAT_CONTEXT_DATASET_HOURS = 'chat_context_dataset_hours',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEVICES = 'devices',
  /** column name */
  ID = 'id',
  /** column name */
  MAX_CHAT_HISTORY_MESSAGES = 'max_chat_history_messages',
  /** column name */
  MAX_CHAT_TOKENS_MONTH = 'max_chat_tokens_month',
  /** column name */
  ORGANIZATION_ID = 'organization_id',
  /** column name */
  PREVENTIONS = 'preventions',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USERS = 'users'
}

/** input type for updating data in table "organizations_feature_limits" */
export type OrganizationsFeatureLimitsSetInput = {
  analysis?: InputMaybe<Scalars['Int']>;
  applications?: InputMaybe<Scalars['Int']>;
  automations?: InputMaybe<Scalars['Int']>;
  chat_context_dataset_hours?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  devices?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  max_chat_history_messages?: InputMaybe<Scalars['Int']>;
  max_chat_tokens_month?: InputMaybe<Scalars['Int']>;
  organization_id?: InputMaybe<Scalars['Int']>;
  preventions?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  users?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type OrganizationsFeatureLimitsStddevFields = {
  __typename?: 'organizations_feature_limits_stddev_fields';
  analysis?: Maybe<Scalars['Float']>;
  applications?: Maybe<Scalars['Float']>;
  automations?: Maybe<Scalars['Float']>;
  chat_context_dataset_hours?: Maybe<Scalars['Float']>;
  devices?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_chat_history_messages?: Maybe<Scalars['Float']>;
  max_chat_tokens_month?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  preventions?: Maybe<Scalars['Float']>;
  users?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type OrganizationsFeatureLimitsStddevPopFields = {
  __typename?: 'organizations_feature_limits_stddev_pop_fields';
  analysis?: Maybe<Scalars['Float']>;
  applications?: Maybe<Scalars['Float']>;
  automations?: Maybe<Scalars['Float']>;
  chat_context_dataset_hours?: Maybe<Scalars['Float']>;
  devices?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_chat_history_messages?: Maybe<Scalars['Float']>;
  max_chat_tokens_month?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  preventions?: Maybe<Scalars['Float']>;
  users?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type OrganizationsFeatureLimitsStddevSampFields = {
  __typename?: 'organizations_feature_limits_stddev_samp_fields';
  analysis?: Maybe<Scalars['Float']>;
  applications?: Maybe<Scalars['Float']>;
  automations?: Maybe<Scalars['Float']>;
  chat_context_dataset_hours?: Maybe<Scalars['Float']>;
  devices?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_chat_history_messages?: Maybe<Scalars['Float']>;
  max_chat_tokens_month?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  preventions?: Maybe<Scalars['Float']>;
  users?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "organizations_feature_limits" */
export type OrganizationsFeatureLimitsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: OrganizationsFeatureLimitsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OrganizationsFeatureLimitsStreamCursorValueInput = {
  analysis?: InputMaybe<Scalars['Int']>;
  applications?: InputMaybe<Scalars['Int']>;
  automations?: InputMaybe<Scalars['Int']>;
  chat_context_dataset_hours?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  devices?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  max_chat_history_messages?: InputMaybe<Scalars['Int']>;
  max_chat_tokens_month?: InputMaybe<Scalars['Int']>;
  organization_id?: InputMaybe<Scalars['Int']>;
  preventions?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  users?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type OrganizationsFeatureLimitsSumFields = {
  __typename?: 'organizations_feature_limits_sum_fields';
  analysis?: Maybe<Scalars['Int']>;
  applications?: Maybe<Scalars['Int']>;
  automations?: Maybe<Scalars['Int']>;
  chat_context_dataset_hours?: Maybe<Scalars['Int']>;
  devices?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  max_chat_history_messages?: Maybe<Scalars['Int']>;
  max_chat_tokens_month?: Maybe<Scalars['Int']>;
  organization_id?: Maybe<Scalars['Int']>;
  preventions?: Maybe<Scalars['Int']>;
  users?: Maybe<Scalars['Int']>;
};

/** update columns of table "organizations_feature_limits" */
export enum OrganizationsFeatureLimitsUpdateColumn {
  /** column name */
  ANALYSIS = 'analysis',
  /** column name */
  APPLICATIONS = 'applications',
  /** column name */
  AUTOMATIONS = 'automations',
  /** column name */
  CHAT_CONTEXT_DATASET_HOURS = 'chat_context_dataset_hours',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEVICES = 'devices',
  /** column name */
  ID = 'id',
  /** column name */
  MAX_CHAT_HISTORY_MESSAGES = 'max_chat_history_messages',
  /** column name */
  MAX_CHAT_TOKENS_MONTH = 'max_chat_tokens_month',
  /** column name */
  ORGANIZATION_ID = 'organization_id',
  /** column name */
  PREVENTIONS = 'preventions',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USERS = 'users'
}

export type OrganizationsFeatureLimitsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<OrganizationsFeatureLimitsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrganizationsFeatureLimitsSetInput>;
  /** filter the rows which have to be updated */
  where: OrganizationsFeatureLimitsBoolExp;
};

/** aggregate var_pop on columns */
export type OrganizationsFeatureLimitsVarPopFields = {
  __typename?: 'organizations_feature_limits_var_pop_fields';
  analysis?: Maybe<Scalars['Float']>;
  applications?: Maybe<Scalars['Float']>;
  automations?: Maybe<Scalars['Float']>;
  chat_context_dataset_hours?: Maybe<Scalars['Float']>;
  devices?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_chat_history_messages?: Maybe<Scalars['Float']>;
  max_chat_tokens_month?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  preventions?: Maybe<Scalars['Float']>;
  users?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type OrganizationsFeatureLimitsVarSampFields = {
  __typename?: 'organizations_feature_limits_var_samp_fields';
  analysis?: Maybe<Scalars['Float']>;
  applications?: Maybe<Scalars['Float']>;
  automations?: Maybe<Scalars['Float']>;
  chat_context_dataset_hours?: Maybe<Scalars['Float']>;
  devices?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_chat_history_messages?: Maybe<Scalars['Float']>;
  max_chat_tokens_month?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  preventions?: Maybe<Scalars['Float']>;
  users?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type OrganizationsFeatureLimitsVarianceFields = {
  __typename?: 'organizations_feature_limits_variance_fields';
  analysis?: Maybe<Scalars['Float']>;
  applications?: Maybe<Scalars['Float']>;
  automations?: Maybe<Scalars['Float']>;
  chat_context_dataset_hours?: Maybe<Scalars['Float']>;
  devices?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_chat_history_messages?: Maybe<Scalars['Float']>;
  max_chat_tokens_month?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  preventions?: Maybe<Scalars['Float']>;
  users?: Maybe<Scalars['Float']>;
};

/** input type for incrementing numeric columns in table "organizations" */
export type OrganizationsIncInput = {
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "organizations" */
export type OrganizationsInsertInput = {
  applications?: InputMaybe<ApplicationsArrRelInsertInput>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  feature_limits?: InputMaybe<OrganizationsFeatureLimitsObjRelInsertInput>;
  id?: InputMaybe<Scalars['Int']>;
  migratedToCloud?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerToken?: InputMaybe<Scalars['String']>;
  public?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  users?: InputMaybe<OrganizationsUsersUsersOrganizationsArrRelInsertInput>;
};

/** aggregate max on columns */
export type OrganizationsMaxFields = {
  __typename?: 'organizations_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  providerToken?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type OrganizationsMinFields = {
  __typename?: 'organizations_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  providerToken?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "organizations" */
export type OrganizationsMutationResponse = {
  __typename?: 'organizations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organizations>;
};

/** input type for inserting object relation for remote table "organizations" */
export type OrganizationsObjRelInsertInput = {
  data: OrganizationsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganizationsOnConflict>;
};

/** on_conflict condition type for table "organizations" */
export type OrganizationsOnConflict = {
  constraint: OrganizationsConstraint;
  update_columns?: Array<OrganizationsUpdateColumn>;
  where?: InputMaybe<OrganizationsBoolExp>;
};

/** Ordering options when selecting data from "organizations". */
export type OrganizationsOrderBy = {
  applications_aggregate?: InputMaybe<ApplicationsAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  feature_limits?: InputMaybe<OrganizationsFeatureLimitsOrderBy>;
  id?: InputMaybe<OrderBy>;
  migratedToCloud?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  providerId?: InputMaybe<OrderBy>;
  providerToken?: InputMaybe<OrderBy>;
  public?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  users_aggregate?: InputMaybe<OrganizationsUsersUsersOrganizationsAggregateOrderBy>;
};

/** primary key columns input for table: organizations */
export type OrganizationsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "organizations" */
export enum OrganizationsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  ID = 'id',
  /** column name */
  MIGRATEDTOCLOUD = 'migratedToCloud',
  /** column name */
  NAME = 'name',
  /** column name */
  PROVIDERID = 'providerId',
  /** column name */
  PROVIDERTOKEN = 'providerToken',
  /** column name */
  PUBLIC = 'public',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by'
}

/** input type for updating data in table "organizations" */
export type OrganizationsSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  migratedToCloud?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerToken?: InputMaybe<Scalars['String']>;
  public?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type OrganizationsStddevFields = {
  __typename?: 'organizations_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type OrganizationsStddevPopFields = {
  __typename?: 'organizations_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type OrganizationsStddevSampFields = {
  __typename?: 'organizations_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "organizations" */
export type OrganizationsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: OrganizationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OrganizationsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  migratedToCloud?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providerToken?: InputMaybe<Scalars['String']>;
  public?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type OrganizationsSumFields = {
  __typename?: 'organizations_sum_fields';
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** update columns of table "organizations" */
export enum OrganizationsUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  ID = 'id',
  /** column name */
  MIGRATEDTOCLOUD = 'migratedToCloud',
  /** column name */
  NAME = 'name',
  /** column name */
  PROVIDERID = 'providerId',
  /** column name */
  PROVIDERTOKEN = 'providerToken',
  /** column name */
  PUBLIC = 'public',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by'
}

export type OrganizationsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<OrganizationsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrganizationsSetInput>;
  /** filter the rows which have to be updated */
  where: OrganizationsBoolExp;
};

/** columns and relationships of "organizations_users__users_organizations" */
export type OrganizationsUsersUsersOrganizations = {
  __typename?: 'organizations_users__users_organizations';
  id: Scalars['Int'];
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organization_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  user?: Maybe<UsersPermissionsUser>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "organizations_users__users_organizations" */
export type OrganizationsUsersUsersOrganizationsAggregate = {
  __typename?: 'organizations_users__users_organizations_aggregate';
  aggregate?: Maybe<OrganizationsUsersUsersOrganizationsAggregateFields>;
  nodes: Array<OrganizationsUsersUsersOrganizations>;
};

export type OrganizationsUsersUsersOrganizationsAggregateBoolExp = {
  count?: InputMaybe<OrganizationsUsersUsersOrganizationsAggregateBoolExpCount>;
};

export type OrganizationsUsersUsersOrganizationsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<OrganizationsUsersUsersOrganizationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<OrganizationsUsersUsersOrganizationsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "organizations_users__users_organizations" */
export type OrganizationsUsersUsersOrganizationsAggregateFields = {
  __typename?: 'organizations_users__users_organizations_aggregate_fields';
  avg?: Maybe<OrganizationsUsersUsersOrganizationsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<OrganizationsUsersUsersOrganizationsMaxFields>;
  min?: Maybe<OrganizationsUsersUsersOrganizationsMinFields>;
  stddev?: Maybe<OrganizationsUsersUsersOrganizationsStddevFields>;
  stddev_pop?: Maybe<OrganizationsUsersUsersOrganizationsStddevPopFields>;
  stddev_samp?: Maybe<OrganizationsUsersUsersOrganizationsStddevSampFields>;
  sum?: Maybe<OrganizationsUsersUsersOrganizationsSumFields>;
  var_pop?: Maybe<OrganizationsUsersUsersOrganizationsVarPopFields>;
  var_samp?: Maybe<OrganizationsUsersUsersOrganizationsVarSampFields>;
  variance?: Maybe<OrganizationsUsersUsersOrganizationsVarianceFields>;
};


/** aggregate fields of "organizations_users__users_organizations" */
export type OrganizationsUsersUsersOrganizationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<OrganizationsUsersUsersOrganizationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "organizations_users__users_organizations" */
export type OrganizationsUsersUsersOrganizationsAggregateOrderBy = {
  avg?: InputMaybe<OrganizationsUsersUsersOrganizationsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<OrganizationsUsersUsersOrganizationsMaxOrderBy>;
  min?: InputMaybe<OrganizationsUsersUsersOrganizationsMinOrderBy>;
  stddev?: InputMaybe<OrganizationsUsersUsersOrganizationsStddevOrderBy>;
  stddev_pop?: InputMaybe<OrganizationsUsersUsersOrganizationsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<OrganizationsUsersUsersOrganizationsStddevSampOrderBy>;
  sum?: InputMaybe<OrganizationsUsersUsersOrganizationsSumOrderBy>;
  var_pop?: InputMaybe<OrganizationsUsersUsersOrganizationsVarPopOrderBy>;
  var_samp?: InputMaybe<OrganizationsUsersUsersOrganizationsVarSampOrderBy>;
  variance?: InputMaybe<OrganizationsUsersUsersOrganizationsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "organizations_users__users_organizations" */
export type OrganizationsUsersUsersOrganizationsArrRelInsertInput = {
  data: Array<OrganizationsUsersUsersOrganizationsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganizationsUsersUsersOrganizationsOnConflict>;
};

/** aggregate avg on columns */
export type OrganizationsUsersUsersOrganizationsAvgFields = {
  __typename?: 'organizations_users__users_organizations_avg_fields';
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "organizations_users__users_organizations" */
export type OrganizationsUsersUsersOrganizationsAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "organizations_users__users_organizations". All fields are combined with a logical 'AND'. */
export type OrganizationsUsersUsersOrganizationsBoolExp = {
  _and?: InputMaybe<Array<OrganizationsUsersUsersOrganizationsBoolExp>>;
  _not?: InputMaybe<OrganizationsUsersUsersOrganizationsBoolExp>;
  _or?: InputMaybe<Array<OrganizationsUsersUsersOrganizationsBoolExp>>;
  id?: InputMaybe<IntComparisonExp>;
  organization?: InputMaybe<OrganizationsBoolExp>;
  organization_id?: InputMaybe<IntComparisonExp>;
  user?: InputMaybe<UsersPermissionsUserBoolExp>;
  user_id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "organizations_users__users_organizations" */
export enum OrganizationsUsersUsersOrganizationsConstraint {
  /** unique or primary key constraint on columns "id" */
  ORGANIZATIONS_USERS__USERS_ORGANIZATIONS_PKEY = 'organizations_users__users_organizations_pkey'
}

/** input type for incrementing numeric columns in table "organizations_users__users_organizations" */
export type OrganizationsUsersUsersOrganizationsIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  organization_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "organizations_users__users_organizations" */
export type OrganizationsUsersUsersOrganizationsInsertInput = {
  id?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<OrganizationsObjRelInsertInput>;
  organization_id?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<UsersPermissionsUserObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type OrganizationsUsersUsersOrganizationsMaxFields = {
  __typename?: 'organizations_users__users_organizations_max_fields';
  id?: Maybe<Scalars['Int']>;
  organization_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "organizations_users__users_organizations" */
export type OrganizationsUsersUsersOrganizationsMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type OrganizationsUsersUsersOrganizationsMinFields = {
  __typename?: 'organizations_users__users_organizations_min_fields';
  id?: Maybe<Scalars['Int']>;
  organization_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "organizations_users__users_organizations" */
export type OrganizationsUsersUsersOrganizationsMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "organizations_users__users_organizations" */
export type OrganizationsUsersUsersOrganizationsMutationResponse = {
  __typename?: 'organizations_users__users_organizations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<OrganizationsUsersUsersOrganizations>;
};

/** on_conflict condition type for table "organizations_users__users_organizations" */
export type OrganizationsUsersUsersOrganizationsOnConflict = {
  constraint: OrganizationsUsersUsersOrganizationsConstraint;
  update_columns?: Array<OrganizationsUsersUsersOrganizationsUpdateColumn>;
  where?: InputMaybe<OrganizationsUsersUsersOrganizationsBoolExp>;
};

/** Ordering options when selecting data from "organizations_users__users_organizations". */
export type OrganizationsUsersUsersOrganizationsOrderBy = {
  id?: InputMaybe<OrderBy>;
  organization?: InputMaybe<OrganizationsOrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersPermissionsUserOrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: organizations_users__users_organizations */
export type OrganizationsUsersUsersOrganizationsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "organizations_users__users_organizations" */
export enum OrganizationsUsersUsersOrganizationsSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  ORGANIZATION_ID = 'organization_id',
  /** column name */
  USER_ID = 'user_id'
}

/** input type for updating data in table "organizations_users__users_organizations" */
export type OrganizationsUsersUsersOrganizationsSetInput = {
  id?: InputMaybe<Scalars['Int']>;
  organization_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type OrganizationsUsersUsersOrganizationsStddevFields = {
  __typename?: 'organizations_users__users_organizations_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "organizations_users__users_organizations" */
export type OrganizationsUsersUsersOrganizationsStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type OrganizationsUsersUsersOrganizationsStddevPopFields = {
  __typename?: 'organizations_users__users_organizations_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "organizations_users__users_organizations" */
export type OrganizationsUsersUsersOrganizationsStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type OrganizationsUsersUsersOrganizationsStddevSampFields = {
  __typename?: 'organizations_users__users_organizations_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "organizations_users__users_organizations" */
export type OrganizationsUsersUsersOrganizationsStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "organizations_users__users_organizations" */
export type OrganizationsUsersUsersOrganizationsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: OrganizationsUsersUsersOrganizationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OrganizationsUsersUsersOrganizationsStreamCursorValueInput = {
  id?: InputMaybe<Scalars['Int']>;
  organization_id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type OrganizationsUsersUsersOrganizationsSumFields = {
  __typename?: 'organizations_users__users_organizations_sum_fields';
  id?: Maybe<Scalars['Int']>;
  organization_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "organizations_users__users_organizations" */
export type OrganizationsUsersUsersOrganizationsSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** update columns of table "organizations_users__users_organizations" */
export enum OrganizationsUsersUsersOrganizationsUpdateColumn {
  /** column name */
  ID = 'id',
  /** column name */
  ORGANIZATION_ID = 'organization_id',
  /** column name */
  USER_ID = 'user_id'
}

export type OrganizationsUsersUsersOrganizationsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<OrganizationsUsersUsersOrganizationsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrganizationsUsersUsersOrganizationsSetInput>;
  /** filter the rows which have to be updated */
  where: OrganizationsUsersUsersOrganizationsBoolExp;
};

/** aggregate var_pop on columns */
export type OrganizationsUsersUsersOrganizationsVarPopFields = {
  __typename?: 'organizations_users__users_organizations_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "organizations_users__users_organizations" */
export type OrganizationsUsersUsersOrganizationsVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type OrganizationsUsersUsersOrganizationsVarSampFields = {
  __typename?: 'organizations_users__users_organizations_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "organizations_users__users_organizations" */
export type OrganizationsUsersUsersOrganizationsVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type OrganizationsUsersUsersOrganizationsVarianceFields = {
  __typename?: 'organizations_users__users_organizations_variance_fields';
  id?: Maybe<Scalars['Float']>;
  organization_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "organizations_users__users_organizations" */
export type OrganizationsUsersUsersOrganizationsVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  organization_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type OrganizationsVarPopFields = {
  __typename?: 'organizations_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type OrganizationsVarSampFields = {
  __typename?: 'organizations_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type OrganizationsVarianceFields = {
  __typename?: 'organizations_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

export type QueryRoot = {
  __typename?: 'query_root';
  /** fetch data from the table: "analysis" */
  analysis: Array<Analysis>;
  /** An array relationship */
  analysis__devices_payloads: Array<AnalysisDevicesPayloads>;
  /** An aggregate relationship */
  analysis__devices_payloads_aggregate: AnalysisDevicesPayloadsAggregate;
  /** fetch data from the table: "analysis__devices_payloads" using primary key columns */
  analysis__devices_payloads_by_pk?: Maybe<AnalysisDevicesPayloads>;
  /** fetch aggregated fields from the table: "analysis" */
  analysis_aggregate: AnalysisAggregate;
  /** An array relationship */
  analysis_applications: Array<AnalysisApplications>;
  /** fetch data from the table: "analysis_applications__devices" */
  analysis_applications__devices: Array<AnalysisApplicationsDevices>;
  /** fetch aggregated fields from the table: "analysis_applications__devices" */
  analysis_applications__devices_aggregate: AnalysisApplicationsDevicesAggregate;
  /** fetch data from the table: "analysis_applications__devices" using primary key columns */
  analysis_applications__devices_by_pk?: Maybe<AnalysisApplicationsDevices>;
  /** An aggregate relationship */
  analysis_applications_aggregate: AnalysisApplicationsAggregate;
  /** fetch data from the table: "analysis_applications" using primary key columns */
  analysis_applications_by_pk?: Maybe<AnalysisApplications>;
  /** fetch data from the table: "analysis_applications_computed" */
  analysis_applications_computed: Array<AnalysisApplicationsComputed>;
  /** fetch aggregated fields from the table: "analysis_applications_computed" */
  analysis_applications_computed_aggregate: AnalysisApplicationsComputedAggregate;
  /** fetch data from the table: "analysis_applications_computed" using primary key columns */
  analysis_applications_computed_by_pk?: Maybe<AnalysisApplicationsComputed>;
  /** fetch data from the table: "analysis_applications_computed_values" */
  analysis_applications_computed_values: Array<AnalysisApplicationsComputedValues>;
  /** fetch aggregated fields from the table: "analysis_applications_computed_values" */
  analysis_applications_computed_values_aggregate: AnalysisApplicationsComputedValuesAggregate;
  /** fetch data from the table: "analysis_applications_computed_values" using primary key columns */
  analysis_applications_computed_values_by_pk?: Maybe<AnalysisApplicationsComputedValues>;
  /** fetch data from the table: "analysis_applications_computed_values_kinds" */
  analysis_applications_computed_values_kinds: Array<AnalysisApplicationsComputedValuesKinds>;
  /** fetch aggregated fields from the table: "analysis_applications_computed_values_kinds" */
  analysis_applications_computed_values_kinds_aggregate: AnalysisApplicationsComputedValuesKindsAggregate;
  /** fetch data from the table: "analysis_applications_computed_values_kinds" using primary key columns */
  analysis_applications_computed_values_kinds_by_pk?: Maybe<AnalysisApplicationsComputedValuesKinds>;
  /** fetch data from the table: "analysis" using primary key columns */
  analysis_by_pk?: Maybe<Analysis>;
  /** fetch data from the table: "analysis_device_categories_configs" */
  analysis_device_categories_configs: Array<AnalysisDeviceCategoriesConfigs>;
  /** fetch aggregated fields from the table: "analysis_device_categories_configs" */
  analysis_device_categories_configs_aggregate: AnalysisDeviceCategoriesConfigsAggregate;
  /** fetch data from the table: "analysis_device_categories_configs" using primary key columns */
  analysis_device_categories_configs_by_pk?: Maybe<AnalysisDeviceCategoriesConfigs>;
  /** fetch data from the table: "analysis_groups" */
  analysis_groups: Array<AnalysisGroups>;
  /** fetch aggregated fields from the table: "analysis_groups" */
  analysis_groups_aggregate: AnalysisGroupsAggregate;
  /** fetch data from the table: "analysis_groups" using primary key columns */
  analysis_groups_by_pk?: Maybe<AnalysisGroups>;
  /** fetch data from the table: "analysis_kinds" */
  analysis_kinds: Array<AnalysisKinds>;
  /** fetch aggregated fields from the table: "analysis_kinds" */
  analysis_kinds_aggregate: AnalysisKindsAggregate;
  /** fetch data from the table: "analysis_kinds" using primary key columns */
  analysis_kinds_by_pk?: Maybe<AnalysisKinds>;
  /** Weather for Application id, based on lat and lon */
  application_weather?: Maybe<ApplicationWeatherOutput>;
  /** An array relationship */
  applications: Array<Applications>;
  /** An aggregate relationship */
  applications_aggregate: ApplicationsAggregate;
  /** fetch data from the table: "applications" using primary key columns */
  applications_by_pk?: Maybe<Applications>;
  /** fetch data from the table: "applications_dashboards" */
  applications_dashboards: Array<ApplicationsDashboards>;
  /** fetch aggregated fields from the table: "applications_dashboards" */
  applications_dashboards_aggregate: ApplicationsDashboardsAggregate;
  /** An array relationship */
  applications_dashboards_analysis: Array<ApplicationsDashboardsAnalysis>;
  /** An aggregate relationship */
  applications_dashboards_analysis_aggregate: ApplicationsDashboardsAnalysisAggregate;
  /** fetch data from the table: "applications_dashboards_analysis" using primary key columns */
  applications_dashboards_analysis_by_pk?: Maybe<ApplicationsDashboardsAnalysis>;
  /** fetch data from the table: "applications_dashboards" using primary key columns */
  applications_dashboards_by_pk?: Maybe<ApplicationsDashboards>;
  /** An array relationship */
  applications_dashboards_devices: Array<ApplicationsDashboardsDevices>;
  /** An aggregate relationship */
  applications_dashboards_devices_aggregate: ApplicationsDashboardsDevicesAggregate;
  /** fetch data from the table: "applications_dashboards_devices" using primary key columns */
  applications_dashboards_devices_by_pk?: Maybe<ApplicationsDashboardsDevices>;
  /** fetch data from the table: "applications_settings" */
  applications_settings: Array<ApplicationsSettings>;
  /** fetch aggregated fields from the table: "applications_settings" */
  applications_settings_aggregate: ApplicationsSettingsAggregate;
  /** fetch data from the table: "applications_settings" using primary key columns */
  applications_settings_by_pk?: Maybe<ApplicationsSettings>;
  /** An array relationship */
  areas: Array<Areas>;
  /** An aggregate relationship */
  areas_aggregate: AreasAggregate;
  /** fetch data from the table: "areas" using primary key columns */
  areas_by_pk?: Maybe<Areas>;
  /** fetch data from the table: "areas_scope_cultivation" */
  areas_scope_cultivation: Array<AreasScopeCultivation>;
  /** fetch aggregated fields from the table: "areas_scope_cultivation" */
  areas_scope_cultivation_aggregate: AreasScopeCultivationAggregate;
  /** fetch data from the table: "areas_scope_cultivation" using primary key columns */
  areas_scope_cultivation_by_pk?: Maybe<AreasScopeCultivation>;
  /** fetch data from the table: "areas_scopes" */
  areas_scopes: Array<AreasScopes>;
  /** fetch aggregated fields from the table: "areas_scopes" */
  areas_scopes_aggregate: AreasScopesAggregate;
  /** fetch data from the table: "areas_scopes" using primary key columns */
  areas_scopes_by_pk?: Maybe<AreasScopes>;
  /** fetch data from the table: "automation_timing_execution_kinds" */
  automation_timing_execution_kinds: Array<AutomationTimingExecutionKinds>;
  /** fetch aggregated fields from the table: "automation_timing_execution_kinds" */
  automation_timing_execution_kinds_aggregate: AutomationTimingExecutionKindsAggregate;
  /** fetch data from the table: "automation_timing_execution_kinds" using primary key columns */
  automation_timing_execution_kinds_by_pk?: Maybe<AutomationTimingExecutionKinds>;
  /** An array relationship */
  automations: Array<Automations>;
  /** An aggregate relationship */
  automations_aggregate: AutomationsAggregate;
  /** fetch data from the table: "automations" using primary key columns */
  automations_by_pk?: Maybe<Automations>;
  /** fetch data from the table: "automations_watchings" */
  automations_watchings: Array<AutomationsWatchings>;
  /** fetch aggregated fields from the table: "automations_watchings" */
  automations_watchings_aggregate: AutomationsWatchingsAggregate;
  /** fetch data from the table: "automations_watchings" using primary key columns */
  automations_watchings_by_pk?: Maybe<AutomationsWatchings>;
  /** fetch data from the table: "chat_message_types" */
  chat_message_types: Array<ChatMessageTypes>;
  /** fetch aggregated fields from the table: "chat_message_types" */
  chat_message_types_aggregate: ChatMessageTypesAggregate;
  /** fetch data from the table: "chat_message_types" using primary key columns */
  chat_message_types_by_pk?: Maybe<ChatMessageTypes>;
  /** fetch data from the table: "chat_messages" */
  chat_messages: Array<ChatMessages>;
  /** fetch aggregated fields from the table: "chat_messages" */
  chat_messages_aggregate: ChatMessagesAggregate;
  /** fetch data from the table: "chat_messages" using primary key columns */
  chat_messages_by_pk?: Maybe<ChatMessages>;
  /** fetch data from the table: "cultivation_types" */
  cultivation_types: Array<CultivationTypes>;
  /** fetch aggregated fields from the table: "cultivation_types" */
  cultivation_types_aggregate: CultivationTypesAggregate;
  /** fetch data from the table: "cultivation_types" using primary key columns */
  cultivation_types_by_pk?: Maybe<CultivationTypes>;
  /** fetch data from the table: "device_actions" */
  device_actions: Array<DeviceActions>;
  /** fetch aggregated fields from the table: "device_actions" */
  device_actions_aggregate: DeviceActionsAggregate;
  /** fetch data from the table: "device_actions" using primary key columns */
  device_actions_by_pk?: Maybe<DeviceActions>;
  /** fetch data from the table: "device_categories" */
  device_categories: Array<DeviceCategories>;
  /** fetch aggregated fields from the table: "device_categories" */
  device_categories_aggregate: DeviceCategoriesAggregate;
  /** fetch data from the table: "device_categories" using primary key columns */
  device_categories_by_pk?: Maybe<DeviceCategories>;
  /** Get all device detail for chart and aggregation */
  device_detail?: Maybe<DeviceDetailOutput>;
  /** Get device last uplink data */
  device_last_uplink: DeviceLastUplinkOutput;
  /** fetch data from the table: "device_payload_values" */
  device_payload_values: Array<DevicePayloadValues>;
  /** fetch aggregated fields from the table: "device_payload_values" */
  device_payload_values_aggregate: DevicePayloadValuesAggregate;
  /** fetch data from the table: "device_payload_values" using primary key columns */
  device_payload_values_by_pk?: Maybe<DevicePayloadValues>;
  /** fetch data from the table: "device_payloads" */
  device_payloads: Array<DevicePayloads>;
  /** fetch data from the table: "device_payloads__payload_values" */
  device_payloads__payload_values: Array<DevicePayloadsPayloadValues>;
  /** fetch aggregated fields from the table: "device_payloads__payload_values" */
  device_payloads__payload_values_aggregate: DevicePayloadsPayloadValuesAggregate;
  /** fetch data from the table: "device_payloads__payload_values" using primary key columns */
  device_payloads__payload_values_by_pk?: Maybe<DevicePayloadsPayloadValues>;
  /** fetch aggregated fields from the table: "device_payloads" */
  device_payloads_aggregate: DevicePayloadsAggregate;
  /** fetch data from the table: "device_payloads" using primary key columns */
  device_payloads_by_pk?: Maybe<DevicePayloads>;
  /** An array relationship */
  devices: Array<Devices>;
  /** fetch data from the table: "devices__device_actions" */
  devices__device_actions: Array<DevicesDeviceActions>;
  /** fetch aggregated fields from the table: "devices__device_actions" */
  devices__device_actions_aggregate: DevicesDeviceActionsAggregate;
  /** fetch data from the table: "devices__device_actions" using primary key columns */
  devices__device_actions_by_pk?: Maybe<DevicesDeviceActions>;
  /** fetch data from the table: "devices__device_categories" */
  devices__device_categories: Array<DevicesDeviceCategories>;
  /** fetch aggregated fields from the table: "devices__device_categories" */
  devices__device_categories_aggregate: DevicesDeviceCategoriesAggregate;
  /** fetch data from the table: "devices__device_categories" using primary key columns */
  devices__device_categories_by_pk?: Maybe<DevicesDeviceCategories>;
  /** fetch data from the table: "devices__device_payloads" */
  devices__device_payloads: Array<DevicesDevicePayloads>;
  /** fetch aggregated fields from the table: "devices__device_payloads" */
  devices__device_payloads_aggregate: DevicesDevicePayloadsAggregate;
  /** fetch data from the table: "devices__device_payloads" using primary key columns */
  devices__device_payloads_by_pk?: Maybe<DevicesDevicePayloads>;
  /** An aggregate relationship */
  devices_aggregate: DevicesAggregate;
  /** fetch data from the table: "devices" using primary key columns */
  devices_by_pk?: Maybe<Devices>;
  /** fetch data from the table: "downlinks" */
  downlinks: Array<Downlinks>;
  /** fetch aggregated fields from the table: "downlinks" */
  downlinks_aggregate: DownlinksAggregate;
  /** fetch data from the table: "downlinks" using primary key columns */
  downlinks_by_pk?: Maybe<Downlinks>;
  /** fetch data from the table: "farming_containers" */
  farming_containers: Array<FarmingContainers>;
  /** fetch aggregated fields from the table: "farming_containers" */
  farming_containers_aggregate: FarmingContainersAggregate;
  /** fetch data from the table: "farming_containers" using primary key columns */
  farming_containers_by_pk?: Maybe<FarmingContainers>;
  /** fetch data from the table: "farming_methods" */
  farming_methods: Array<FarmingMethods>;
  /** fetch aggregated fields from the table: "farming_methods" */
  farming_methods_aggregate: FarmingMethodsAggregate;
  /** fetch data from the table: "farming_methods" using primary key columns */
  farming_methods_by_pk?: Maybe<FarmingMethods>;
  /** fetch data from the table: "farming_structures" */
  farming_structures: Array<FarmingStructures>;
  /** fetch aggregated fields from the table: "farming_structures" */
  farming_structures_aggregate: FarmingStructuresAggregate;
  /** fetch data from the table: "farming_structures" using primary key columns */
  farming_structures_by_pk?: Maybe<FarmingStructures>;
  hygraph?: Maybe<HygraphQuery>;
  /** fetch data from the table: "notification_event_types" */
  notification_event_types: Array<NotificationEventTypes>;
  /** fetch aggregated fields from the table: "notification_event_types" */
  notification_event_types_aggregate: NotificationEventTypesAggregate;
  /** fetch data from the table: "notification_event_types" using primary key columns */
  notification_event_types_by_pk?: Maybe<NotificationEventTypes>;
  /** fetch data from the table: "notification_kinds" */
  notification_kinds: Array<NotificationKinds>;
  /** fetch aggregated fields from the table: "notification_kinds" */
  notification_kinds_aggregate: NotificationKindsAggregate;
  /** fetch data from the table: "notification_kinds" using primary key columns */
  notification_kinds_by_pk?: Maybe<NotificationKinds>;
  /** fetch data from the table: "notification_user_devices" */
  notification_user_devices: Array<NotificationUserDevices>;
  /** fetch data from the table: "notification_user_devices__event_types" */
  notification_user_devices__event_types: Array<NotificationUserDevicesEventTypes>;
  /** fetch aggregated fields from the table: "notification_user_devices__event_types" */
  notification_user_devices__event_types_aggregate: NotificationUserDevicesEventTypesAggregate;
  /** fetch data from the table: "notification_user_devices__event_types" using primary key columns */
  notification_user_devices__event_types_by_pk?: Maybe<NotificationUserDevicesEventTypes>;
  /** fetch aggregated fields from the table: "notification_user_devices" */
  notification_user_devices_aggregate: NotificationUserDevicesAggregate;
  /** fetch data from the table: "notification_user_devices" using primary key columns */
  notification_user_devices_by_pk?: Maybe<NotificationUserDevices>;
  /** fetch data from the table: "notification_user_settings" */
  notification_user_settings: Array<NotificationUserSettings>;
  /** fetch aggregated fields from the table: "notification_user_settings" */
  notification_user_settings_aggregate: NotificationUserSettingsAggregate;
  /** fetch data from the table: "notification_user_settings" using primary key columns */
  notification_user_settings_by_pk?: Maybe<NotificationUserSettings>;
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An aggregate relationship */
  notifications_aggregate: NotificationsAggregate;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: Maybe<Notifications>;
  /** fetch data from the table: "notifications_content" */
  notifications_content: Array<NotificationsContent>;
  /** fetch aggregated fields from the table: "notifications_content" */
  notifications_content_aggregate: NotificationsContentAggregate;
  /** fetch data from the table: "notifications_content" using primary key columns */
  notifications_content_by_pk?: Maybe<NotificationsContent>;
  /** fetch data from the table: "organizations" */
  organizations: Array<Organizations>;
  /** fetch aggregated fields from the table: "organizations" */
  organizations_aggregate: OrganizationsAggregate;
  /** fetch data from the table: "organizations" using primary key columns */
  organizations_by_pk?: Maybe<Organizations>;
  /** fetch data from the table: "organizations_chat_params" */
  organizations_chat_params: Array<OrganizationsChatParams>;
  /** fetch aggregated fields from the table: "organizations_chat_params" */
  organizations_chat_params_aggregate: OrganizationsChatParamsAggregate;
  /** fetch data from the table: "organizations_chat_params" using primary key columns */
  organizations_chat_params_by_pk?: Maybe<OrganizationsChatParams>;
  /** fetch data from the table: "organizations_feature_limits" */
  organizations_feature_limits: Array<OrganizationsFeatureLimits>;
  /** fetch aggregated fields from the table: "organizations_feature_limits" */
  organizations_feature_limits_aggregate: OrganizationsFeatureLimitsAggregate;
  /** fetch data from the table: "organizations_feature_limits" using primary key columns */
  organizations_feature_limits_by_pk?: Maybe<OrganizationsFeatureLimits>;
  /** fetch data from the table: "organizations_users__users_organizations" */
  organizations_users__users_organizations: Array<OrganizationsUsersUsersOrganizations>;
  /** fetch aggregated fields from the table: "organizations_users__users_organizations" */
  organizations_users__users_organizations_aggregate: OrganizationsUsersUsersOrganizationsAggregate;
  /** fetch data from the table: "organizations_users__users_organizations" using primary key columns */
  organizations_users__users_organizations_by_pk?: Maybe<OrganizationsUsersUsersOrganizations>;
  /** fetch data from the table: "scene_feedback_waits" */
  scene_feedback_waits: Array<SceneFeedbackWaits>;
  /** fetch aggregated fields from the table: "scene_feedback_waits" */
  scene_feedback_waits_aggregate: SceneFeedbackWaitsAggregate;
  /** fetch data from the table: "scene_feedback_waits" using primary key columns */
  scene_feedback_waits_by_pk?: Maybe<SceneFeedbackWaits>;
  /** fetch data from the table: "scene_scheduled_executions" */
  scene_scheduled_executions: Array<SceneScheduledExecutions>;
  /** fetch aggregated fields from the table: "scene_scheduled_executions" */
  scene_scheduled_executions_aggregate: SceneScheduledExecutionsAggregate;
  /** fetch data from the table: "scene_scheduled_executions" using primary key columns */
  scene_scheduled_executions_by_pk?: Maybe<SceneScheduledExecutions>;
  /** fetch data from the table: "scene_timing_execution_kinds" */
  scene_timing_execution_kinds: Array<SceneTimingExecutionKinds>;
  /** fetch aggregated fields from the table: "scene_timing_execution_kinds" */
  scene_timing_execution_kinds_aggregate: SceneTimingExecutionKindsAggregate;
  /** fetch data from the table: "scene_timing_execution_kinds" using primary key columns */
  scene_timing_execution_kinds_by_pk?: Maybe<SceneTimingExecutionKinds>;
  /** An array relationship */
  scenes: Array<Scenes>;
  /** fetch data from the table: "scenes__devices" */
  scenes__devices: Array<ScenesDevices>;
  /** fetch aggregated fields from the table: "scenes__devices" */
  scenes__devices_aggregate: ScenesDevicesAggregate;
  /** fetch data from the table: "scenes__devices" using primary key columns */
  scenes__devices_by_pk?: Maybe<ScenesDevices>;
  /** An aggregate relationship */
  scenes_aggregate: ScenesAggregate;
  /** fetch data from the table: "scenes" using primary key columns */
  scenes_by_pk?: Maybe<Scenes>;
  /** fetch data from the table: "substrates" */
  substrates: Array<Substrates>;
  /** fetch aggregated fields from the table: "substrates" */
  substrates_aggregate: SubstratesAggregate;
  /** fetch data from the table: "substrates" using primary key columns */
  substrates_by_pk?: Maybe<Substrates>;
  /** An array relationship */
  telegram_users: Array<TelegramUsers>;
  /** An aggregate relationship */
  telegram_users_aggregate: TelegramUsersAggregate;
  /** fetch data from the table: "telegram_users" using primary key columns */
  telegram_users_by_pk?: Maybe<TelegramUsers>;
  /** fetch data from the table: "uplink_dynamo_ref" */
  uplink_dynamo_ref: Array<UplinkDynamoRef>;
  /** fetch aggregated fields from the table: "uplink_dynamo_ref" */
  uplink_dynamo_ref_aggregate: UplinkDynamoRefAggregate;
  /** fetch data from the table: "uplink_dynamo_ref" using primary key columns */
  uplink_dynamo_ref_by_pk?: Maybe<UplinkDynamoRef>;
  /** fetch data from the table: "user_roles" */
  user_roles: Array<UserRoles>;
  /** fetch data from the table: "user_roles__users_permissions_user" */
  user_roles__users_permissions_user: Array<UserRolesUsersPermissionsUser>;
  /** fetch aggregated fields from the table: "user_roles__users_permissions_user" */
  user_roles__users_permissions_user_aggregate: UserRolesUsersPermissionsUserAggregate;
  /** fetch data from the table: "user_roles__users_permissions_user" using primary key columns */
  user_roles__users_permissions_user_by_pk?: Maybe<UserRolesUsersPermissionsUser>;
  /** fetch aggregated fields from the table: "user_roles" */
  user_roles_aggregate: UserRolesAggregate;
  /** fetch data from the table: "user_roles" using primary key columns */
  user_roles_by_pk?: Maybe<UserRoles>;
  /** fetch data from the table: "users_permissions_user" */
  users_permissions_user: Array<UsersPermissionsUser>;
  /** fetch aggregated fields from the table: "users_permissions_user" */
  users_permissions_user_aggregate: UsersPermissionsUserAggregate;
  /** fetch data from the table: "users_permissions_user" using primary key columns */
  users_permissions_user_by_pk?: Maybe<UsersPermissionsUser>;
};


export type QueryRootAnalysisArgs = {
  distinct_on?: InputMaybe<Array<AnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisOrderBy>>;
  where?: InputMaybe<AnalysisBoolExp>;
};


export type QueryRootAnalysisDevicesPayloadsArgs = {
  distinct_on?: InputMaybe<Array<AnalysisDevicesPayloadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisDevicesPayloadsOrderBy>>;
  where?: InputMaybe<AnalysisDevicesPayloadsBoolExp>;
};


export type QueryRootAnalysisDevicesPayloadsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AnalysisDevicesPayloadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisDevicesPayloadsOrderBy>>;
  where?: InputMaybe<AnalysisDevicesPayloadsBoolExp>;
};


export type QueryRootAnalysisDevicesPayloadsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootAnalysisAggregateArgs = {
  distinct_on?: InputMaybe<Array<AnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisOrderBy>>;
  where?: InputMaybe<AnalysisBoolExp>;
};


export type QueryRootAnalysisApplicationsArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsBoolExp>;
};


export type QueryRootAnalysisApplicationsDevicesArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsDevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsDevicesOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsDevicesBoolExp>;
};


export type QueryRootAnalysisApplicationsDevicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsDevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsDevicesOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsDevicesBoolExp>;
};


export type QueryRootAnalysisApplicationsDevicesByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootAnalysisApplicationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsBoolExp>;
};


export type QueryRootAnalysisApplicationsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootAnalysisApplicationsComputedArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsComputedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsComputedOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsComputedBoolExp>;
};


export type QueryRootAnalysisApplicationsComputedAggregateArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsComputedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsComputedOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsComputedBoolExp>;
};


export type QueryRootAnalysisApplicationsComputedByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootAnalysisApplicationsComputedValuesArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsComputedValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsComputedValuesOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsComputedValuesBoolExp>;
};


export type QueryRootAnalysisApplicationsComputedValuesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsComputedValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsComputedValuesOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsComputedValuesBoolExp>;
};


export type QueryRootAnalysisApplicationsComputedValuesByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootAnalysisApplicationsComputedValuesKindsArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsComputedValuesKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsComputedValuesKindsOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsComputedValuesKindsBoolExp>;
};


export type QueryRootAnalysisApplicationsComputedValuesKindsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsComputedValuesKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsComputedValuesKindsOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsComputedValuesKindsBoolExp>;
};


export type QueryRootAnalysisApplicationsComputedValuesKindsByPkArgs = {
  value: Scalars['String'];
};


export type QueryRootAnalysisByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootAnalysisDeviceCategoriesConfigsArgs = {
  distinct_on?: InputMaybe<Array<AnalysisDeviceCategoriesConfigsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisDeviceCategoriesConfigsOrderBy>>;
  where?: InputMaybe<AnalysisDeviceCategoriesConfigsBoolExp>;
};


export type QueryRootAnalysisDeviceCategoriesConfigsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AnalysisDeviceCategoriesConfigsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisDeviceCategoriesConfigsOrderBy>>;
  where?: InputMaybe<AnalysisDeviceCategoriesConfigsBoolExp>;
};


export type QueryRootAnalysisDeviceCategoriesConfigsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootAnalysisGroupsArgs = {
  distinct_on?: InputMaybe<Array<AnalysisGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisGroupsOrderBy>>;
  where?: InputMaybe<AnalysisGroupsBoolExp>;
};


export type QueryRootAnalysisGroupsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AnalysisGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisGroupsOrderBy>>;
  where?: InputMaybe<AnalysisGroupsBoolExp>;
};


export type QueryRootAnalysisGroupsByPkArgs = {
  value: Scalars['String'];
};


export type QueryRootAnalysisKindsArgs = {
  distinct_on?: InputMaybe<Array<AnalysisKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisKindsOrderBy>>;
  where?: InputMaybe<AnalysisKindsBoolExp>;
};


export type QueryRootAnalysisKindsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AnalysisKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisKindsOrderBy>>;
  where?: InputMaybe<AnalysisKindsBoolExp>;
};


export type QueryRootAnalysisKindsByPkArgs = {
  value: Scalars['String'];
};


export type QueryRootApplicationWeatherArgs = {
  args: ApplicationWeatherInput;
};


export type QueryRootApplicationsArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsOrderBy>>;
  where?: InputMaybe<ApplicationsBoolExp>;
};


export type QueryRootApplicationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsOrderBy>>;
  where?: InputMaybe<ApplicationsBoolExp>;
};


export type QueryRootApplicationsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootApplicationsDashboardsArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsDashboardsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsDashboardsOrderBy>>;
  where?: InputMaybe<ApplicationsDashboardsBoolExp>;
};


export type QueryRootApplicationsDashboardsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsDashboardsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsDashboardsOrderBy>>;
  where?: InputMaybe<ApplicationsDashboardsBoolExp>;
};


export type QueryRootApplicationsDashboardsAnalysisArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsDashboardsAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsDashboardsAnalysisOrderBy>>;
  where?: InputMaybe<ApplicationsDashboardsAnalysisBoolExp>;
};


export type QueryRootApplicationsDashboardsAnalysisAggregateArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsDashboardsAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsDashboardsAnalysisOrderBy>>;
  where?: InputMaybe<ApplicationsDashboardsAnalysisBoolExp>;
};


export type QueryRootApplicationsDashboardsAnalysisByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootApplicationsDashboardsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootApplicationsDashboardsDevicesArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsDashboardsDevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsDashboardsDevicesOrderBy>>;
  where?: InputMaybe<ApplicationsDashboardsDevicesBoolExp>;
};


export type QueryRootApplicationsDashboardsDevicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsDashboardsDevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsDashboardsDevicesOrderBy>>;
  where?: InputMaybe<ApplicationsDashboardsDevicesBoolExp>;
};


export type QueryRootApplicationsDashboardsDevicesByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootApplicationsSettingsArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsSettingsOrderBy>>;
  where?: InputMaybe<ApplicationsSettingsBoolExp>;
};


export type QueryRootApplicationsSettingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsSettingsOrderBy>>;
  where?: InputMaybe<ApplicationsSettingsBoolExp>;
};


export type QueryRootApplicationsSettingsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootAreasArgs = {
  distinct_on?: InputMaybe<Array<AreasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AreasOrderBy>>;
  where?: InputMaybe<AreasBoolExp>;
};


export type QueryRootAreasAggregateArgs = {
  distinct_on?: InputMaybe<Array<AreasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AreasOrderBy>>;
  where?: InputMaybe<AreasBoolExp>;
};


export type QueryRootAreasByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootAreasScopeCultivationArgs = {
  distinct_on?: InputMaybe<Array<AreasScopeCultivationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AreasScopeCultivationOrderBy>>;
  where?: InputMaybe<AreasScopeCultivationBoolExp>;
};


export type QueryRootAreasScopeCultivationAggregateArgs = {
  distinct_on?: InputMaybe<Array<AreasScopeCultivationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AreasScopeCultivationOrderBy>>;
  where?: InputMaybe<AreasScopeCultivationBoolExp>;
};


export type QueryRootAreasScopeCultivationByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootAreasScopesArgs = {
  distinct_on?: InputMaybe<Array<AreasScopesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AreasScopesOrderBy>>;
  where?: InputMaybe<AreasScopesBoolExp>;
};


export type QueryRootAreasScopesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AreasScopesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AreasScopesOrderBy>>;
  where?: InputMaybe<AreasScopesBoolExp>;
};


export type QueryRootAreasScopesByPkArgs = {
  value: Scalars['String'];
};


export type QueryRootAutomationTimingExecutionKindsArgs = {
  distinct_on?: InputMaybe<Array<AutomationTimingExecutionKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutomationTimingExecutionKindsOrderBy>>;
  where?: InputMaybe<AutomationTimingExecutionKindsBoolExp>;
};


export type QueryRootAutomationTimingExecutionKindsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AutomationTimingExecutionKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutomationTimingExecutionKindsOrderBy>>;
  where?: InputMaybe<AutomationTimingExecutionKindsBoolExp>;
};


export type QueryRootAutomationTimingExecutionKindsByPkArgs = {
  value: Scalars['String'];
};


export type QueryRootAutomationsArgs = {
  distinct_on?: InputMaybe<Array<AutomationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutomationsOrderBy>>;
  where?: InputMaybe<AutomationsBoolExp>;
};


export type QueryRootAutomationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AutomationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutomationsOrderBy>>;
  where?: InputMaybe<AutomationsBoolExp>;
};


export type QueryRootAutomationsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootAutomationsWatchingsArgs = {
  distinct_on?: InputMaybe<Array<AutomationsWatchingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutomationsWatchingsOrderBy>>;
  where?: InputMaybe<AutomationsWatchingsBoolExp>;
};


export type QueryRootAutomationsWatchingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AutomationsWatchingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutomationsWatchingsOrderBy>>;
  where?: InputMaybe<AutomationsWatchingsBoolExp>;
};


export type QueryRootAutomationsWatchingsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootChatMessageTypesArgs = {
  distinct_on?: InputMaybe<Array<ChatMessageTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ChatMessageTypesOrderBy>>;
  where?: InputMaybe<ChatMessageTypesBoolExp>;
};


export type QueryRootChatMessageTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ChatMessageTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ChatMessageTypesOrderBy>>;
  where?: InputMaybe<ChatMessageTypesBoolExp>;
};


export type QueryRootChatMessageTypesByPkArgs = {
  value: Scalars['String'];
};


export type QueryRootChatMessagesArgs = {
  distinct_on?: InputMaybe<Array<ChatMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ChatMessagesOrderBy>>;
  where?: InputMaybe<ChatMessagesBoolExp>;
};


export type QueryRootChatMessagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ChatMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ChatMessagesOrderBy>>;
  where?: InputMaybe<ChatMessagesBoolExp>;
};


export type QueryRootChatMessagesByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootCultivationTypesArgs = {
  distinct_on?: InputMaybe<Array<CultivationTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CultivationTypesOrderBy>>;
  where?: InputMaybe<CultivationTypesBoolExp>;
};


export type QueryRootCultivationTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CultivationTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CultivationTypesOrderBy>>;
  where?: InputMaybe<CultivationTypesBoolExp>;
};


export type QueryRootCultivationTypesByPkArgs = {
  value: Scalars['String'];
};


export type QueryRootDeviceActionsArgs = {
  distinct_on?: InputMaybe<Array<DeviceActionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DeviceActionsOrderBy>>;
  where?: InputMaybe<DeviceActionsBoolExp>;
};


export type QueryRootDeviceActionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DeviceActionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DeviceActionsOrderBy>>;
  where?: InputMaybe<DeviceActionsBoolExp>;
};


export type QueryRootDeviceActionsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootDeviceCategoriesArgs = {
  distinct_on?: InputMaybe<Array<DeviceCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DeviceCategoriesOrderBy>>;
  where?: InputMaybe<DeviceCategoriesBoolExp>;
};


export type QueryRootDeviceCategoriesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DeviceCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DeviceCategoriesOrderBy>>;
  where?: InputMaybe<DeviceCategoriesBoolExp>;
};


export type QueryRootDeviceCategoriesByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootDeviceDetailArgs = {
  args: DeviceDetailInput;
};


export type QueryRootDeviceLastUplinkArgs = {
  args: DeviceLastUplinkInput;
};


export type QueryRootDevicePayloadValuesArgs = {
  distinct_on?: InputMaybe<Array<DevicePayloadValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicePayloadValuesOrderBy>>;
  where?: InputMaybe<DevicePayloadValuesBoolExp>;
};


export type QueryRootDevicePayloadValuesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DevicePayloadValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicePayloadValuesOrderBy>>;
  where?: InputMaybe<DevicePayloadValuesBoolExp>;
};


export type QueryRootDevicePayloadValuesByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootDevicePayloadsArgs = {
  distinct_on?: InputMaybe<Array<DevicePayloadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicePayloadsOrderBy>>;
  where?: InputMaybe<DevicePayloadsBoolExp>;
};


export type QueryRootDevicePayloadsPayloadValuesArgs = {
  distinct_on?: InputMaybe<Array<DevicePayloadsPayloadValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicePayloadsPayloadValuesOrderBy>>;
  where?: InputMaybe<DevicePayloadsPayloadValuesBoolExp>;
};


export type QueryRootDevicePayloadsPayloadValuesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DevicePayloadsPayloadValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicePayloadsPayloadValuesOrderBy>>;
  where?: InputMaybe<DevicePayloadsPayloadValuesBoolExp>;
};


export type QueryRootDevicePayloadsPayloadValuesByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootDevicePayloadsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DevicePayloadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicePayloadsOrderBy>>;
  where?: InputMaybe<DevicePayloadsBoolExp>;
};


export type QueryRootDevicePayloadsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootDevicesArgs = {
  distinct_on?: InputMaybe<Array<DevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicesOrderBy>>;
  where?: InputMaybe<DevicesBoolExp>;
};


export type QueryRootDevicesDeviceActionsArgs = {
  distinct_on?: InputMaybe<Array<DevicesDeviceActionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicesDeviceActionsOrderBy>>;
  where?: InputMaybe<DevicesDeviceActionsBoolExp>;
};


export type QueryRootDevicesDeviceActionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DevicesDeviceActionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicesDeviceActionsOrderBy>>;
  where?: InputMaybe<DevicesDeviceActionsBoolExp>;
};


export type QueryRootDevicesDeviceActionsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootDevicesDeviceCategoriesArgs = {
  distinct_on?: InputMaybe<Array<DevicesDeviceCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicesDeviceCategoriesOrderBy>>;
  where?: InputMaybe<DevicesDeviceCategoriesBoolExp>;
};


export type QueryRootDevicesDeviceCategoriesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DevicesDeviceCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicesDeviceCategoriesOrderBy>>;
  where?: InputMaybe<DevicesDeviceCategoriesBoolExp>;
};


export type QueryRootDevicesDeviceCategoriesByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootDevicesDevicePayloadsArgs = {
  distinct_on?: InputMaybe<Array<DevicesDevicePayloadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicesDevicePayloadsOrderBy>>;
  where?: InputMaybe<DevicesDevicePayloadsBoolExp>;
};


export type QueryRootDevicesDevicePayloadsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DevicesDevicePayloadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicesDevicePayloadsOrderBy>>;
  where?: InputMaybe<DevicesDevicePayloadsBoolExp>;
};


export type QueryRootDevicesDevicePayloadsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootDevicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicesOrderBy>>;
  where?: InputMaybe<DevicesBoolExp>;
};


export type QueryRootDevicesByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootDownlinksArgs = {
  distinct_on?: InputMaybe<Array<DownlinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DownlinksOrderBy>>;
  where?: InputMaybe<DownlinksBoolExp>;
};


export type QueryRootDownlinksAggregateArgs = {
  distinct_on?: InputMaybe<Array<DownlinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DownlinksOrderBy>>;
  where?: InputMaybe<DownlinksBoolExp>;
};


export type QueryRootDownlinksByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootFarmingContainersArgs = {
  distinct_on?: InputMaybe<Array<FarmingContainersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FarmingContainersOrderBy>>;
  where?: InputMaybe<FarmingContainersBoolExp>;
};


export type QueryRootFarmingContainersAggregateArgs = {
  distinct_on?: InputMaybe<Array<FarmingContainersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FarmingContainersOrderBy>>;
  where?: InputMaybe<FarmingContainersBoolExp>;
};


export type QueryRootFarmingContainersByPkArgs = {
  value: Scalars['String'];
};


export type QueryRootFarmingMethodsArgs = {
  distinct_on?: InputMaybe<Array<FarmingMethodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FarmingMethodsOrderBy>>;
  where?: InputMaybe<FarmingMethodsBoolExp>;
};


export type QueryRootFarmingMethodsAggregateArgs = {
  distinct_on?: InputMaybe<Array<FarmingMethodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FarmingMethodsOrderBy>>;
  where?: InputMaybe<FarmingMethodsBoolExp>;
};


export type QueryRootFarmingMethodsByPkArgs = {
  value: Scalars['String'];
};


export type QueryRootFarmingStructuresArgs = {
  distinct_on?: InputMaybe<Array<FarmingStructuresSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FarmingStructuresOrderBy>>;
  where?: InputMaybe<FarmingStructuresBoolExp>;
};


export type QueryRootFarmingStructuresAggregateArgs = {
  distinct_on?: InputMaybe<Array<FarmingStructuresSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FarmingStructuresOrderBy>>;
  where?: InputMaybe<FarmingStructuresBoolExp>;
};


export type QueryRootFarmingStructuresByPkArgs = {
  value: Scalars['String'];
};


export type QueryRootNotificationEventTypesArgs = {
  distinct_on?: InputMaybe<Array<NotificationEventTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationEventTypesOrderBy>>;
  where?: InputMaybe<NotificationEventTypesBoolExp>;
};


export type QueryRootNotificationEventTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationEventTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationEventTypesOrderBy>>;
  where?: InputMaybe<NotificationEventTypesBoolExp>;
};


export type QueryRootNotificationEventTypesByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootNotificationKindsArgs = {
  distinct_on?: InputMaybe<Array<NotificationKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationKindsOrderBy>>;
  where?: InputMaybe<NotificationKindsBoolExp>;
};


export type QueryRootNotificationKindsAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationKindsOrderBy>>;
  where?: InputMaybe<NotificationKindsBoolExp>;
};


export type QueryRootNotificationKindsByPkArgs = {
  value: Scalars['String'];
};


export type QueryRootNotificationUserDevicesArgs = {
  distinct_on?: InputMaybe<Array<NotificationUserDevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationUserDevicesOrderBy>>;
  where?: InputMaybe<NotificationUserDevicesBoolExp>;
};


export type QueryRootNotificationUserDevicesEventTypesArgs = {
  distinct_on?: InputMaybe<Array<NotificationUserDevicesEventTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationUserDevicesEventTypesOrderBy>>;
  where?: InputMaybe<NotificationUserDevicesEventTypesBoolExp>;
};


export type QueryRootNotificationUserDevicesEventTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationUserDevicesEventTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationUserDevicesEventTypesOrderBy>>;
  where?: InputMaybe<NotificationUserDevicesEventTypesBoolExp>;
};


export type QueryRootNotificationUserDevicesEventTypesByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootNotificationUserDevicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationUserDevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationUserDevicesOrderBy>>;
  where?: InputMaybe<NotificationUserDevicesBoolExp>;
};


export type QueryRootNotificationUserDevicesByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootNotificationUserSettingsArgs = {
  distinct_on?: InputMaybe<Array<NotificationUserSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationUserSettingsOrderBy>>;
  where?: InputMaybe<NotificationUserSettingsBoolExp>;
};


export type QueryRootNotificationUserSettingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationUserSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationUserSettingsOrderBy>>;
  where?: InputMaybe<NotificationUserSettingsBoolExp>;
};


export type QueryRootNotificationUserSettingsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootNotificationsArgs = {
  distinct_on?: InputMaybe<Array<NotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationsOrderBy>>;
  where?: InputMaybe<NotificationsBoolExp>;
};


export type QueryRootNotificationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationsOrderBy>>;
  where?: InputMaybe<NotificationsBoolExp>;
};


export type QueryRootNotificationsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootNotificationsContentArgs = {
  distinct_on?: InputMaybe<Array<NotificationsContentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationsContentOrderBy>>;
  where?: InputMaybe<NotificationsContentBoolExp>;
};


export type QueryRootNotificationsContentAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationsContentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationsContentOrderBy>>;
  where?: InputMaybe<NotificationsContentBoolExp>;
};


export type QueryRootNotificationsContentByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<OrganizationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationsOrderBy>>;
  where?: InputMaybe<OrganizationsBoolExp>;
};


export type QueryRootOrganizationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<OrganizationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationsOrderBy>>;
  where?: InputMaybe<OrganizationsBoolExp>;
};


export type QueryRootOrganizationsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootOrganizationsChatParamsArgs = {
  distinct_on?: InputMaybe<Array<OrganizationsChatParamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationsChatParamsOrderBy>>;
  where?: InputMaybe<OrganizationsChatParamsBoolExp>;
};


export type QueryRootOrganizationsChatParamsAggregateArgs = {
  distinct_on?: InputMaybe<Array<OrganizationsChatParamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationsChatParamsOrderBy>>;
  where?: InputMaybe<OrganizationsChatParamsBoolExp>;
};


export type QueryRootOrganizationsChatParamsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootOrganizationsFeatureLimitsArgs = {
  distinct_on?: InputMaybe<Array<OrganizationsFeatureLimitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationsFeatureLimitsOrderBy>>;
  where?: InputMaybe<OrganizationsFeatureLimitsBoolExp>;
};


export type QueryRootOrganizationsFeatureLimitsAggregateArgs = {
  distinct_on?: InputMaybe<Array<OrganizationsFeatureLimitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationsFeatureLimitsOrderBy>>;
  where?: InputMaybe<OrganizationsFeatureLimitsBoolExp>;
};


export type QueryRootOrganizationsFeatureLimitsByPkArgs = {
  id: Scalars['Int'];
  organization_id: Scalars['Int'];
};


export type QueryRootOrganizationsUsersUsersOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<OrganizationsUsersUsersOrganizationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationsUsersUsersOrganizationsOrderBy>>;
  where?: InputMaybe<OrganizationsUsersUsersOrganizationsBoolExp>;
};


export type QueryRootOrganizationsUsersUsersOrganizationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<OrganizationsUsersUsersOrganizationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationsUsersUsersOrganizationsOrderBy>>;
  where?: InputMaybe<OrganizationsUsersUsersOrganizationsBoolExp>;
};


export type QueryRootOrganizationsUsersUsersOrganizationsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootSceneFeedbackWaitsArgs = {
  distinct_on?: InputMaybe<Array<SceneFeedbackWaitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SceneFeedbackWaitsOrderBy>>;
  where?: InputMaybe<SceneFeedbackWaitsBoolExp>;
};


export type QueryRootSceneFeedbackWaitsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SceneFeedbackWaitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SceneFeedbackWaitsOrderBy>>;
  where?: InputMaybe<SceneFeedbackWaitsBoolExp>;
};


export type QueryRootSceneFeedbackWaitsByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootSceneScheduledExecutionsArgs = {
  distinct_on?: InputMaybe<Array<SceneScheduledExecutionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SceneScheduledExecutionsOrderBy>>;
  where?: InputMaybe<SceneScheduledExecutionsBoolExp>;
};


export type QueryRootSceneScheduledExecutionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SceneScheduledExecutionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SceneScheduledExecutionsOrderBy>>;
  where?: InputMaybe<SceneScheduledExecutionsBoolExp>;
};


export type QueryRootSceneScheduledExecutionsByPkArgs = {
  id: Scalars['bigint'];
};


export type QueryRootSceneTimingExecutionKindsArgs = {
  distinct_on?: InputMaybe<Array<SceneTimingExecutionKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SceneTimingExecutionKindsOrderBy>>;
  where?: InputMaybe<SceneTimingExecutionKindsBoolExp>;
};


export type QueryRootSceneTimingExecutionKindsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SceneTimingExecutionKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SceneTimingExecutionKindsOrderBy>>;
  where?: InputMaybe<SceneTimingExecutionKindsBoolExp>;
};


export type QueryRootSceneTimingExecutionKindsByPkArgs = {
  value: Scalars['String'];
};


export type QueryRootScenesArgs = {
  distinct_on?: InputMaybe<Array<ScenesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ScenesOrderBy>>;
  where?: InputMaybe<ScenesBoolExp>;
};


export type QueryRootScenesDevicesArgs = {
  distinct_on?: InputMaybe<Array<ScenesDevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ScenesDevicesOrderBy>>;
  where?: InputMaybe<ScenesDevicesBoolExp>;
};


export type QueryRootScenesDevicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ScenesDevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ScenesDevicesOrderBy>>;
  where?: InputMaybe<ScenesDevicesBoolExp>;
};


export type QueryRootScenesDevicesByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootScenesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ScenesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ScenesOrderBy>>;
  where?: InputMaybe<ScenesBoolExp>;
};


export type QueryRootScenesByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootSubstratesArgs = {
  distinct_on?: InputMaybe<Array<SubstratesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SubstratesOrderBy>>;
  where?: InputMaybe<SubstratesBoolExp>;
};


export type QueryRootSubstratesAggregateArgs = {
  distinct_on?: InputMaybe<Array<SubstratesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SubstratesOrderBy>>;
  where?: InputMaybe<SubstratesBoolExp>;
};


export type QueryRootSubstratesByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootTelegramUsersArgs = {
  distinct_on?: InputMaybe<Array<TelegramUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TelegramUsersOrderBy>>;
  where?: InputMaybe<TelegramUsersBoolExp>;
};


export type QueryRootTelegramUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<TelegramUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TelegramUsersOrderBy>>;
  where?: InputMaybe<TelegramUsersBoolExp>;
};


export type QueryRootTelegramUsersByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootUplinkDynamoRefArgs = {
  distinct_on?: InputMaybe<Array<UplinkDynamoRefSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UplinkDynamoRefOrderBy>>;
  where?: InputMaybe<UplinkDynamoRefBoolExp>;
};


export type QueryRootUplinkDynamoRefAggregateArgs = {
  distinct_on?: InputMaybe<Array<UplinkDynamoRefSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UplinkDynamoRefOrderBy>>;
  where?: InputMaybe<UplinkDynamoRefBoolExp>;
};


export type QueryRootUplinkDynamoRefByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootUserRolesArgs = {
  distinct_on?: InputMaybe<Array<UserRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserRolesOrderBy>>;
  where?: InputMaybe<UserRolesBoolExp>;
};


export type QueryRootUserRolesUsersPermissionsUserArgs = {
  distinct_on?: InputMaybe<Array<UserRolesUsersPermissionsUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserRolesUsersPermissionsUserOrderBy>>;
  where?: InputMaybe<UserRolesUsersPermissionsUserBoolExp>;
};


export type QueryRootUserRolesUsersPermissionsUserAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRolesUsersPermissionsUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserRolesUsersPermissionsUserOrderBy>>;
  where?: InputMaybe<UserRolesUsersPermissionsUserBoolExp>;
};


export type QueryRootUserRolesUsersPermissionsUserByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootUserRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserRolesOrderBy>>;
  where?: InputMaybe<UserRolesBoolExp>;
};


export type QueryRootUserRolesByPkArgs = {
  id: Scalars['Int'];
};


export type QueryRootUsersPermissionsUserArgs = {
  distinct_on?: InputMaybe<Array<UsersPermissionsUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersPermissionsUserOrderBy>>;
  where?: InputMaybe<UsersPermissionsUserBoolExp>;
};


export type QueryRootUsersPermissionsUserAggregateArgs = {
  distinct_on?: InputMaybe<Array<UsersPermissionsUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersPermissionsUserOrderBy>>;
  where?: InputMaybe<UsersPermissionsUserBoolExp>;
};


export type QueryRootUsersPermissionsUserByPkArgs = {
  id: Scalars['Int'];
};

/** columns and relationships of "scene_feedback_waits" */
export type SceneFeedbackWaits = {
  __typename?: 'scene_feedback_waits';
  allowed_retries: Scalars['Int'];
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  /** An object relationship */
  device: Devices;
  device_id: Scalars['Int'];
  /** An object relationship */
  downlink: Downlinks;
  downlink_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  scene: Scenes;
  scene_id: Scalars['Int'];
  timeout_at: Scalars['timestamptz'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "scene_feedback_waits" */
export type SceneFeedbackWaitsAggregate = {
  __typename?: 'scene_feedback_waits_aggregate';
  aggregate?: Maybe<SceneFeedbackWaitsAggregateFields>;
  nodes: Array<SceneFeedbackWaits>;
};

/** aggregate fields of "scene_feedback_waits" */
export type SceneFeedbackWaitsAggregateFields = {
  __typename?: 'scene_feedback_waits_aggregate_fields';
  avg?: Maybe<SceneFeedbackWaitsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SceneFeedbackWaitsMaxFields>;
  min?: Maybe<SceneFeedbackWaitsMinFields>;
  stddev?: Maybe<SceneFeedbackWaitsStddevFields>;
  stddev_pop?: Maybe<SceneFeedbackWaitsStddevPopFields>;
  stddev_samp?: Maybe<SceneFeedbackWaitsStddevSampFields>;
  sum?: Maybe<SceneFeedbackWaitsSumFields>;
  var_pop?: Maybe<SceneFeedbackWaitsVarPopFields>;
  var_samp?: Maybe<SceneFeedbackWaitsVarSampFields>;
  variance?: Maybe<SceneFeedbackWaitsVarianceFields>;
};


/** aggregate fields of "scene_feedback_waits" */
export type SceneFeedbackWaitsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SceneFeedbackWaitsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type SceneFeedbackWaitsAvgFields = {
  __typename?: 'scene_feedback_waits_avg_fields';
  allowed_retries?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  downlink_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  scene_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "scene_feedback_waits". All fields are combined with a logical 'AND'. */
export type SceneFeedbackWaitsBoolExp = {
  _and?: InputMaybe<Array<SceneFeedbackWaitsBoolExp>>;
  _not?: InputMaybe<SceneFeedbackWaitsBoolExp>;
  _or?: InputMaybe<Array<SceneFeedbackWaitsBoolExp>>;
  allowed_retries?: InputMaybe<IntComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<IntComparisonExp>;
  device?: InputMaybe<DevicesBoolExp>;
  device_id?: InputMaybe<IntComparisonExp>;
  downlink?: InputMaybe<DownlinksBoolExp>;
  downlink_id?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  scene?: InputMaybe<ScenesBoolExp>;
  scene_id?: InputMaybe<IntComparisonExp>;
  timeout_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "scene_feedback_waits" */
export enum SceneFeedbackWaitsConstraint {
  /** unique or primary key constraint on columns "id" */
  SCENE_FEEDBACK_WAITS_PKEY = 'scene_feedback_waits_pkey'
}

/** input type for incrementing numeric columns in table "scene_feedback_waits" */
export type SceneFeedbackWaitsIncInput = {
  allowed_retries?: InputMaybe<Scalars['Int']>;
  created_by?: InputMaybe<Scalars['Int']>;
  device_id?: InputMaybe<Scalars['Int']>;
  downlink_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  scene_id?: InputMaybe<Scalars['Int']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "scene_feedback_waits" */
export type SceneFeedbackWaitsInsertInput = {
  allowed_retries?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  device?: InputMaybe<DevicesObjRelInsertInput>;
  device_id?: InputMaybe<Scalars['Int']>;
  downlink?: InputMaybe<DownlinksObjRelInsertInput>;
  downlink_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  scene?: InputMaybe<ScenesObjRelInsertInput>;
  scene_id?: InputMaybe<Scalars['Int']>;
  timeout_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type SceneFeedbackWaitsMaxFields = {
  __typename?: 'scene_feedback_waits_max_fields';
  allowed_retries?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  device_id?: Maybe<Scalars['Int']>;
  downlink_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  scene_id?: Maybe<Scalars['Int']>;
  timeout_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type SceneFeedbackWaitsMinFields = {
  __typename?: 'scene_feedback_waits_min_fields';
  allowed_retries?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  device_id?: Maybe<Scalars['Int']>;
  downlink_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  scene_id?: Maybe<Scalars['Int']>;
  timeout_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "scene_feedback_waits" */
export type SceneFeedbackWaitsMutationResponse = {
  __typename?: 'scene_feedback_waits_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SceneFeedbackWaits>;
};

/** on_conflict condition type for table "scene_feedback_waits" */
export type SceneFeedbackWaitsOnConflict = {
  constraint: SceneFeedbackWaitsConstraint;
  update_columns?: Array<SceneFeedbackWaitsUpdateColumn>;
  where?: InputMaybe<SceneFeedbackWaitsBoolExp>;
};

/** Ordering options when selecting data from "scene_feedback_waits". */
export type SceneFeedbackWaitsOrderBy = {
  allowed_retries?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  device?: InputMaybe<DevicesOrderBy>;
  device_id?: InputMaybe<OrderBy>;
  downlink?: InputMaybe<DownlinksOrderBy>;
  downlink_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  scene?: InputMaybe<ScenesOrderBy>;
  scene_id?: InputMaybe<OrderBy>;
  timeout_at?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: scene_feedback_waits */
export type SceneFeedbackWaitsPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "scene_feedback_waits" */
export enum SceneFeedbackWaitsSelectColumn {
  /** column name */
  ALLOWED_RETRIES = 'allowed_retries',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  DEVICE_ID = 'device_id',
  /** column name */
  DOWNLINK_ID = 'downlink_id',
  /** column name */
  ID = 'id',
  /** column name */
  SCENE_ID = 'scene_id',
  /** column name */
  TIMEOUT_AT = 'timeout_at',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by'
}

/** input type for updating data in table "scene_feedback_waits" */
export type SceneFeedbackWaitsSetInput = {
  allowed_retries?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  device_id?: InputMaybe<Scalars['Int']>;
  downlink_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  scene_id?: InputMaybe<Scalars['Int']>;
  timeout_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type SceneFeedbackWaitsStddevFields = {
  __typename?: 'scene_feedback_waits_stddev_fields';
  allowed_retries?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  downlink_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  scene_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SceneFeedbackWaitsStddevPopFields = {
  __typename?: 'scene_feedback_waits_stddev_pop_fields';
  allowed_retries?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  downlink_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  scene_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SceneFeedbackWaitsStddevSampFields = {
  __typename?: 'scene_feedback_waits_stddev_samp_fields';
  allowed_retries?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  downlink_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  scene_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "scene_feedback_waits" */
export type SceneFeedbackWaitsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SceneFeedbackWaitsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SceneFeedbackWaitsStreamCursorValueInput = {
  allowed_retries?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  device_id?: InputMaybe<Scalars['Int']>;
  downlink_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  scene_id?: InputMaybe<Scalars['Int']>;
  timeout_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type SceneFeedbackWaitsSumFields = {
  __typename?: 'scene_feedback_waits_sum_fields';
  allowed_retries?: Maybe<Scalars['Int']>;
  created_by?: Maybe<Scalars['Int']>;
  device_id?: Maybe<Scalars['Int']>;
  downlink_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  scene_id?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** update columns of table "scene_feedback_waits" */
export enum SceneFeedbackWaitsUpdateColumn {
  /** column name */
  ALLOWED_RETRIES = 'allowed_retries',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  DEVICE_ID = 'device_id',
  /** column name */
  DOWNLINK_ID = 'downlink_id',
  /** column name */
  ID = 'id',
  /** column name */
  SCENE_ID = 'scene_id',
  /** column name */
  TIMEOUT_AT = 'timeout_at',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by'
}

export type SceneFeedbackWaitsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SceneFeedbackWaitsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SceneFeedbackWaitsSetInput>;
  /** filter the rows which have to be updated */
  where: SceneFeedbackWaitsBoolExp;
};

/** aggregate var_pop on columns */
export type SceneFeedbackWaitsVarPopFields = {
  __typename?: 'scene_feedback_waits_var_pop_fields';
  allowed_retries?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  downlink_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  scene_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SceneFeedbackWaitsVarSampFields = {
  __typename?: 'scene_feedback_waits_var_samp_fields';
  allowed_retries?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  downlink_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  scene_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SceneFeedbackWaitsVarianceFields = {
  __typename?: 'scene_feedback_waits_variance_fields';
  allowed_retries?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  device_id?: Maybe<Scalars['Float']>;
  downlink_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  scene_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** scheduled scene log */
export type SceneScheduledExecutions = {
  __typename?: 'scene_scheduled_executions';
  created_at: Scalars['timestamptz'];
  executed_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['bigint'];
  scene_id: Scalars['Int'];
  scheduled_at: Scalars['timestamptz'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "scene_scheduled_executions" */
export type SceneScheduledExecutionsAggregate = {
  __typename?: 'scene_scheduled_executions_aggregate';
  aggregate?: Maybe<SceneScheduledExecutionsAggregateFields>;
  nodes: Array<SceneScheduledExecutions>;
};

/** aggregate fields of "scene_scheduled_executions" */
export type SceneScheduledExecutionsAggregateFields = {
  __typename?: 'scene_scheduled_executions_aggregate_fields';
  avg?: Maybe<SceneScheduledExecutionsAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SceneScheduledExecutionsMaxFields>;
  min?: Maybe<SceneScheduledExecutionsMinFields>;
  stddev?: Maybe<SceneScheduledExecutionsStddevFields>;
  stddev_pop?: Maybe<SceneScheduledExecutionsStddevPopFields>;
  stddev_samp?: Maybe<SceneScheduledExecutionsStddevSampFields>;
  sum?: Maybe<SceneScheduledExecutionsSumFields>;
  var_pop?: Maybe<SceneScheduledExecutionsVarPopFields>;
  var_samp?: Maybe<SceneScheduledExecutionsVarSampFields>;
  variance?: Maybe<SceneScheduledExecutionsVarianceFields>;
};


/** aggregate fields of "scene_scheduled_executions" */
export type SceneScheduledExecutionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SceneScheduledExecutionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type SceneScheduledExecutionsAvgFields = {
  __typename?: 'scene_scheduled_executions_avg_fields';
  id?: Maybe<Scalars['Float']>;
  scene_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "scene_scheduled_executions". All fields are combined with a logical 'AND'. */
export type SceneScheduledExecutionsBoolExp = {
  _and?: InputMaybe<Array<SceneScheduledExecutionsBoolExp>>;
  _not?: InputMaybe<SceneScheduledExecutionsBoolExp>;
  _or?: InputMaybe<Array<SceneScheduledExecutionsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  executed_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<BigintComparisonExp>;
  scene_id?: InputMaybe<IntComparisonExp>;
  scheduled_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "scene_scheduled_executions" */
export enum SceneScheduledExecutionsConstraint {
  /** unique or primary key constraint on columns "id" */
  SCENE_SCHEDULED_EXECUTIONS_PKEY = 'scene_scheduled_executions_pkey',
  /** unique or primary key constraint on columns "scene_id", "scheduled_at" */
  SCENE_SCHEDULED_EXECUTIONS_SCENE_ID_SCHEDULED_AT_KEY = 'scene_scheduled_executions_scene_id_scheduled_at_key'
}

/** input type for incrementing numeric columns in table "scene_scheduled_executions" */
export type SceneScheduledExecutionsIncInput = {
  id?: InputMaybe<Scalars['bigint']>;
  scene_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "scene_scheduled_executions" */
export type SceneScheduledExecutionsInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  executed_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  scene_id?: InputMaybe<Scalars['Int']>;
  scheduled_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type SceneScheduledExecutionsMaxFields = {
  __typename?: 'scene_scheduled_executions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  executed_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  scene_id?: Maybe<Scalars['Int']>;
  scheduled_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type SceneScheduledExecutionsMinFields = {
  __typename?: 'scene_scheduled_executions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  executed_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  scene_id?: Maybe<Scalars['Int']>;
  scheduled_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "scene_scheduled_executions" */
export type SceneScheduledExecutionsMutationResponse = {
  __typename?: 'scene_scheduled_executions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SceneScheduledExecutions>;
};

/** on_conflict condition type for table "scene_scheduled_executions" */
export type SceneScheduledExecutionsOnConflict = {
  constraint: SceneScheduledExecutionsConstraint;
  update_columns?: Array<SceneScheduledExecutionsUpdateColumn>;
  where?: InputMaybe<SceneScheduledExecutionsBoolExp>;
};

/** Ordering options when selecting data from "scene_scheduled_executions". */
export type SceneScheduledExecutionsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  executed_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  scene_id?: InputMaybe<OrderBy>;
  scheduled_at?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: scene_scheduled_executions */
export type SceneScheduledExecutionsPkColumnsInput = {
  id: Scalars['bigint'];
};

/** select columns of table "scene_scheduled_executions" */
export enum SceneScheduledExecutionsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  EXECUTED_AT = 'executed_at',
  /** column name */
  ID = 'id',
  /** column name */
  SCENE_ID = 'scene_id',
  /** column name */
  SCHEDULED_AT = 'scheduled_at',
  /** column name */
  UPDATED_AT = 'updated_at'
}

/** input type for updating data in table "scene_scheduled_executions" */
export type SceneScheduledExecutionsSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  executed_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  scene_id?: InputMaybe<Scalars['Int']>;
  scheduled_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type SceneScheduledExecutionsStddevFields = {
  __typename?: 'scene_scheduled_executions_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  scene_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SceneScheduledExecutionsStddevPopFields = {
  __typename?: 'scene_scheduled_executions_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  scene_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SceneScheduledExecutionsStddevSampFields = {
  __typename?: 'scene_scheduled_executions_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  scene_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "scene_scheduled_executions" */
export type SceneScheduledExecutionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SceneScheduledExecutionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SceneScheduledExecutionsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  executed_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  scene_id?: InputMaybe<Scalars['Int']>;
  scheduled_at?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type SceneScheduledExecutionsSumFields = {
  __typename?: 'scene_scheduled_executions_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  scene_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "scene_scheduled_executions" */
export enum SceneScheduledExecutionsUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  EXECUTED_AT = 'executed_at',
  /** column name */
  ID = 'id',
  /** column name */
  SCENE_ID = 'scene_id',
  /** column name */
  SCHEDULED_AT = 'scheduled_at',
  /** column name */
  UPDATED_AT = 'updated_at'
}

export type SceneScheduledExecutionsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SceneScheduledExecutionsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SceneScheduledExecutionsSetInput>;
  /** filter the rows which have to be updated */
  where: SceneScheduledExecutionsBoolExp;
};

/** aggregate var_pop on columns */
export type SceneScheduledExecutionsVarPopFields = {
  __typename?: 'scene_scheduled_executions_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  scene_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SceneScheduledExecutionsVarSampFields = {
  __typename?: 'scene_scheduled_executions_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  scene_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SceneScheduledExecutionsVarianceFields = {
  __typename?: 'scene_scheduled_executions_variance_fields';
  id?: Maybe<Scalars['Float']>;
  scene_id?: Maybe<Scalars['Float']>;
};

/** scene_timing_execution_kinds enum */
export type SceneTimingExecutionKinds = {
  __typename?: 'scene_timing_execution_kinds';
  comment: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "scene_timing_execution_kinds" */
export type SceneTimingExecutionKindsAggregate = {
  __typename?: 'scene_timing_execution_kinds_aggregate';
  aggregate?: Maybe<SceneTimingExecutionKindsAggregateFields>;
  nodes: Array<SceneTimingExecutionKinds>;
};

/** aggregate fields of "scene_timing_execution_kinds" */
export type SceneTimingExecutionKindsAggregateFields = {
  __typename?: 'scene_timing_execution_kinds_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<SceneTimingExecutionKindsMaxFields>;
  min?: Maybe<SceneTimingExecutionKindsMinFields>;
};


/** aggregate fields of "scene_timing_execution_kinds" */
export type SceneTimingExecutionKindsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SceneTimingExecutionKindsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "scene_timing_execution_kinds". All fields are combined with a logical 'AND'. */
export type SceneTimingExecutionKindsBoolExp = {
  _and?: InputMaybe<Array<SceneTimingExecutionKindsBoolExp>>;
  _not?: InputMaybe<SceneTimingExecutionKindsBoolExp>;
  _or?: InputMaybe<Array<SceneTimingExecutionKindsBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "scene_timing_execution_kinds" */
export enum SceneTimingExecutionKindsConstraint {
  /** unique or primary key constraint on columns "value" */
  SCENE_TIMING_EXECUTION_KINDS_PKEY = 'scene_timing_execution_kinds_pkey'
}

export enum SceneTimingExecutionKindsEnum {
  /** execute scene always */
  ALWAYS = 'ALWAYS',
  /** execute scene at selected weekday and time */
  WEEKDAYS_SCHEDULED = 'WEEKDAYS_SCHEDULED',
  /** execute scene on selected weekdays and time range */
  WEEKDAYS_TIMERANGE = 'WEEKDAYS_TIMERANGE'
}

/** Boolean expression to compare columns of type "scene_timing_execution_kinds_enum". All fields are combined with logical 'AND'. */
export type SceneTimingExecutionKindsEnumComparisonExp = {
  _eq?: InputMaybe<SceneTimingExecutionKindsEnum>;
  _in?: InputMaybe<Array<SceneTimingExecutionKindsEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<SceneTimingExecutionKindsEnum>;
  _nin?: InputMaybe<Array<SceneTimingExecutionKindsEnum>>;
};

/** input type for inserting data into table "scene_timing_execution_kinds" */
export type SceneTimingExecutionKindsInsertInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type SceneTimingExecutionKindsMaxFields = {
  __typename?: 'scene_timing_execution_kinds_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type SceneTimingExecutionKindsMinFields = {
  __typename?: 'scene_timing_execution_kinds_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "scene_timing_execution_kinds" */
export type SceneTimingExecutionKindsMutationResponse = {
  __typename?: 'scene_timing_execution_kinds_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SceneTimingExecutionKinds>;
};

/** on_conflict condition type for table "scene_timing_execution_kinds" */
export type SceneTimingExecutionKindsOnConflict = {
  constraint: SceneTimingExecutionKindsConstraint;
  update_columns?: Array<SceneTimingExecutionKindsUpdateColumn>;
  where?: InputMaybe<SceneTimingExecutionKindsBoolExp>;
};

/** Ordering options when selecting data from "scene_timing_execution_kinds". */
export type SceneTimingExecutionKindsOrderBy = {
  comment?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: scene_timing_execution_kinds */
export type SceneTimingExecutionKindsPkColumnsInput = {
  value: Scalars['String'];
};

/** select columns of table "scene_timing_execution_kinds" */
export enum SceneTimingExecutionKindsSelectColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  VALUE = 'value'
}

/** input type for updating data in table "scene_timing_execution_kinds" */
export type SceneTimingExecutionKindsSetInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "scene_timing_execution_kinds" */
export type SceneTimingExecutionKindsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SceneTimingExecutionKindsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SceneTimingExecutionKindsStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "scene_timing_execution_kinds" */
export enum SceneTimingExecutionKindsUpdateColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  VALUE = 'value'
}

export type SceneTimingExecutionKindsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SceneTimingExecutionKindsSetInput>;
  /** filter the rows which have to be updated */
  where: SceneTimingExecutionKindsBoolExp;
};

/** columns and relationships of "scenes" */
export type Scenes = {
  __typename?: 'scenes';
  actions: Scalars['actions'];
  /** An object relationship */
  automation: Automations;
  automation_id: Scalars['Int'];
  conditions: Scalars['conditions'];
  created_at: Scalars['timestamptz'];
  created_by: Scalars['Int'];
  enabled: Scalars['Boolean'];
  execution_time?: Maybe<Scalars['time']>;
  from_time?: Maybe<Scalars['time']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  notifications_enabled: Scalars['Boolean'];
  /** An array relationship */
  scenes_devices: Array<ScenesDevices>;
  /** An aggregate relationship */
  scenes_devices_aggregate: ScenesDevicesAggregate;
  timing_execution_kind: SceneTimingExecutionKindsEnum;
  to_time?: Maybe<Scalars['time']>;
  updated_at: Scalars['timestamptz'];
  updated_by: Scalars['Int'];
  weekdays_scheduling?: Maybe<Scalars['bpchar']>;
};


/** columns and relationships of "scenes" */
export type ScenesActionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "scenes" */
export type ScenesConditionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "scenes" */
export type ScenesScenesDevicesArgs = {
  distinct_on?: InputMaybe<Array<ScenesDevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ScenesDevicesOrderBy>>;
  where?: InputMaybe<ScenesDevicesBoolExp>;
};


/** columns and relationships of "scenes" */
export type ScenesScenesDevicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ScenesDevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ScenesDevicesOrderBy>>;
  where?: InputMaybe<ScenesDevicesBoolExp>;
};

/** columns and relationships of "scenes__devices" */
export type ScenesDevices = {
  __typename?: 'scenes__devices';
  /** An object relationship */
  device: Devices;
  device_id: Scalars['Int'];
  id: Scalars['Int'];
  /** An object relationship */
  scene: Scenes;
  scene_id: Scalars['Int'];
};

/** aggregated selection of "scenes__devices" */
export type ScenesDevicesAggregate = {
  __typename?: 'scenes__devices_aggregate';
  aggregate?: Maybe<ScenesDevicesAggregateFields>;
  nodes: Array<ScenesDevices>;
};

export type ScenesDevicesAggregateBoolExp = {
  count?: InputMaybe<ScenesDevicesAggregateBoolExpCount>;
};

export type ScenesDevicesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ScenesDevicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ScenesDevicesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "scenes__devices" */
export type ScenesDevicesAggregateFields = {
  __typename?: 'scenes__devices_aggregate_fields';
  avg?: Maybe<ScenesDevicesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ScenesDevicesMaxFields>;
  min?: Maybe<ScenesDevicesMinFields>;
  stddev?: Maybe<ScenesDevicesStddevFields>;
  stddev_pop?: Maybe<ScenesDevicesStddevPopFields>;
  stddev_samp?: Maybe<ScenesDevicesStddevSampFields>;
  sum?: Maybe<ScenesDevicesSumFields>;
  var_pop?: Maybe<ScenesDevicesVarPopFields>;
  var_samp?: Maybe<ScenesDevicesVarSampFields>;
  variance?: Maybe<ScenesDevicesVarianceFields>;
};


/** aggregate fields of "scenes__devices" */
export type ScenesDevicesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ScenesDevicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "scenes__devices" */
export type ScenesDevicesAggregateOrderBy = {
  avg?: InputMaybe<ScenesDevicesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ScenesDevicesMaxOrderBy>;
  min?: InputMaybe<ScenesDevicesMinOrderBy>;
  stddev?: InputMaybe<ScenesDevicesStddevOrderBy>;
  stddev_pop?: InputMaybe<ScenesDevicesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ScenesDevicesStddevSampOrderBy>;
  sum?: InputMaybe<ScenesDevicesSumOrderBy>;
  var_pop?: InputMaybe<ScenesDevicesVarPopOrderBy>;
  var_samp?: InputMaybe<ScenesDevicesVarSampOrderBy>;
  variance?: InputMaybe<ScenesDevicesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "scenes__devices" */
export type ScenesDevicesArrRelInsertInput = {
  data: Array<ScenesDevicesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ScenesDevicesOnConflict>;
};

/** aggregate avg on columns */
export type ScenesDevicesAvgFields = {
  __typename?: 'scenes__devices_avg_fields';
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  scene_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "scenes__devices" */
export type ScenesDevicesAvgOrderBy = {
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  scene_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "scenes__devices". All fields are combined with a logical 'AND'. */
export type ScenesDevicesBoolExp = {
  _and?: InputMaybe<Array<ScenesDevicesBoolExp>>;
  _not?: InputMaybe<ScenesDevicesBoolExp>;
  _or?: InputMaybe<Array<ScenesDevicesBoolExp>>;
  device?: InputMaybe<DevicesBoolExp>;
  device_id?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  scene?: InputMaybe<ScenesBoolExp>;
  scene_id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "scenes__devices" */
export enum ScenesDevicesConstraint {
  /** unique or primary key constraint on columns "id" */
  SCENES__DEVICES_PKEY = 'scenes__devices_pkey'
}

/** input type for incrementing numeric columns in table "scenes__devices" */
export type ScenesDevicesIncInput = {
  device_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  scene_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "scenes__devices" */
export type ScenesDevicesInsertInput = {
  device?: InputMaybe<DevicesObjRelInsertInput>;
  device_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  scene?: InputMaybe<ScenesObjRelInsertInput>;
  scene_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type ScenesDevicesMaxFields = {
  __typename?: 'scenes__devices_max_fields';
  device_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  scene_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "scenes__devices" */
export type ScenesDevicesMaxOrderBy = {
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  scene_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ScenesDevicesMinFields = {
  __typename?: 'scenes__devices_min_fields';
  device_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  scene_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "scenes__devices" */
export type ScenesDevicesMinOrderBy = {
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  scene_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "scenes__devices" */
export type ScenesDevicesMutationResponse = {
  __typename?: 'scenes__devices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ScenesDevices>;
};

/** on_conflict condition type for table "scenes__devices" */
export type ScenesDevicesOnConflict = {
  constraint: ScenesDevicesConstraint;
  update_columns?: Array<ScenesDevicesUpdateColumn>;
  where?: InputMaybe<ScenesDevicesBoolExp>;
};

/** Ordering options when selecting data from "scenes__devices". */
export type ScenesDevicesOrderBy = {
  device?: InputMaybe<DevicesOrderBy>;
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  scene?: InputMaybe<ScenesOrderBy>;
  scene_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: scenes__devices */
export type ScenesDevicesPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "scenes__devices" */
export enum ScenesDevicesSelectColumn {
  /** column name */
  DEVICE_ID = 'device_id',
  /** column name */
  ID = 'id',
  /** column name */
  SCENE_ID = 'scene_id'
}

/** input type for updating data in table "scenes__devices" */
export type ScenesDevicesSetInput = {
  device_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  scene_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type ScenesDevicesStddevFields = {
  __typename?: 'scenes__devices_stddev_fields';
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  scene_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "scenes__devices" */
export type ScenesDevicesStddevOrderBy = {
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  scene_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ScenesDevicesStddevPopFields = {
  __typename?: 'scenes__devices_stddev_pop_fields';
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  scene_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "scenes__devices" */
export type ScenesDevicesStddevPopOrderBy = {
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  scene_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ScenesDevicesStddevSampFields = {
  __typename?: 'scenes__devices_stddev_samp_fields';
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  scene_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "scenes__devices" */
export type ScenesDevicesStddevSampOrderBy = {
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  scene_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "scenes__devices" */
export type ScenesDevicesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ScenesDevicesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ScenesDevicesStreamCursorValueInput = {
  device_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  scene_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type ScenesDevicesSumFields = {
  __typename?: 'scenes__devices_sum_fields';
  device_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  scene_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "scenes__devices" */
export type ScenesDevicesSumOrderBy = {
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  scene_id?: InputMaybe<OrderBy>;
};

/** update columns of table "scenes__devices" */
export enum ScenesDevicesUpdateColumn {
  /** column name */
  DEVICE_ID = 'device_id',
  /** column name */
  ID = 'id',
  /** column name */
  SCENE_ID = 'scene_id'
}

export type ScenesDevicesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ScenesDevicesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ScenesDevicesSetInput>;
  /** filter the rows which have to be updated */
  where: ScenesDevicesBoolExp;
};

/** aggregate var_pop on columns */
export type ScenesDevicesVarPopFields = {
  __typename?: 'scenes__devices_var_pop_fields';
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  scene_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "scenes__devices" */
export type ScenesDevicesVarPopOrderBy = {
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  scene_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ScenesDevicesVarSampFields = {
  __typename?: 'scenes__devices_var_samp_fields';
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  scene_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "scenes__devices" */
export type ScenesDevicesVarSampOrderBy = {
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  scene_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ScenesDevicesVarianceFields = {
  __typename?: 'scenes__devices_variance_fields';
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  scene_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "scenes__devices" */
export type ScenesDevicesVarianceOrderBy = {
  device_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  scene_id?: InputMaybe<OrderBy>;
};

/** aggregated selection of "scenes" */
export type ScenesAggregate = {
  __typename?: 'scenes_aggregate';
  aggregate?: Maybe<ScenesAggregateFields>;
  nodes: Array<Scenes>;
};

export type ScenesAggregateBoolExp = {
  bool_and?: InputMaybe<ScenesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<ScenesAggregateBoolExpBoolOr>;
  count?: InputMaybe<ScenesAggregateBoolExpCount>;
};

export type ScenesAggregateBoolExpBoolAnd = {
  arguments: ScenesSelectColumnScenesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ScenesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ScenesAggregateBoolExpBoolOr = {
  arguments: ScenesSelectColumnScenesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ScenesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ScenesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ScenesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ScenesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "scenes" */
export type ScenesAggregateFields = {
  __typename?: 'scenes_aggregate_fields';
  avg?: Maybe<ScenesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<ScenesMaxFields>;
  min?: Maybe<ScenesMinFields>;
  stddev?: Maybe<ScenesStddevFields>;
  stddev_pop?: Maybe<ScenesStddevPopFields>;
  stddev_samp?: Maybe<ScenesStddevSampFields>;
  sum?: Maybe<ScenesSumFields>;
  var_pop?: Maybe<ScenesVarPopFields>;
  var_samp?: Maybe<ScenesVarSampFields>;
  variance?: Maybe<ScenesVarianceFields>;
};


/** aggregate fields of "scenes" */
export type ScenesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ScenesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "scenes" */
export type ScenesAggregateOrderBy = {
  avg?: InputMaybe<ScenesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ScenesMaxOrderBy>;
  min?: InputMaybe<ScenesMinOrderBy>;
  stddev?: InputMaybe<ScenesStddevOrderBy>;
  stddev_pop?: InputMaybe<ScenesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ScenesStddevSampOrderBy>;
  sum?: InputMaybe<ScenesSumOrderBy>;
  var_pop?: InputMaybe<ScenesVarPopOrderBy>;
  var_samp?: InputMaybe<ScenesVarSampOrderBy>;
  variance?: InputMaybe<ScenesVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ScenesAppendInput = {
  actions?: InputMaybe<Scalars['jsonb']>;
  conditions?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "scenes" */
export type ScenesArrRelInsertInput = {
  data: Array<ScenesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ScenesOnConflict>;
};

/** aggregate avg on columns */
export type ScenesAvgFields = {
  __typename?: 'scenes_avg_fields';
  automation_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "scenes" */
export type ScenesAvgOrderBy = {
  automation_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "scenes". All fields are combined with a logical 'AND'. */
export type ScenesBoolExp = {
  _and?: InputMaybe<Array<ScenesBoolExp>>;
  _not?: InputMaybe<ScenesBoolExp>;
  _or?: InputMaybe<Array<ScenesBoolExp>>;
  actions?: InputMaybe<JsonbComparisonExp>;
  automation?: InputMaybe<AutomationsBoolExp>;
  automation_id?: InputMaybe<IntComparisonExp>;
  conditions?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<IntComparisonExp>;
  enabled?: InputMaybe<BooleanComparisonExp>;
  execution_time?: InputMaybe<TimeComparisonExp>;
  from_time?: InputMaybe<TimeComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  notifications_enabled?: InputMaybe<BooleanComparisonExp>;
  scenes_devices?: InputMaybe<ScenesDevicesBoolExp>;
  scenes_devices_aggregate?: InputMaybe<ScenesDevicesAggregateBoolExp>;
  timing_execution_kind?: InputMaybe<SceneTimingExecutionKindsEnumComparisonExp>;
  to_time?: InputMaybe<TimeComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<IntComparisonExp>;
  weekdays_scheduling?: InputMaybe<BpcharComparisonExp>;
};

/** unique or primary key constraints on table "scenes" */
export enum ScenesConstraint {
  /** unique or primary key constraint on columns "id" */
  SCENES_PKEY = 'scenes_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ScenesDeleteAtPathInput = {
  actions?: InputMaybe<Array<Scalars['String']>>;
  conditions?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ScenesDeleteElemInput = {
  actions?: InputMaybe<Scalars['Int']>;
  conditions?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ScenesDeleteKeyInput = {
  actions?: InputMaybe<Scalars['String']>;
  conditions?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "scenes" */
export type ScenesIncInput = {
  automation_id?: InputMaybe<Scalars['Int']>;
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "scenes" */
export type ScenesInsertInput = {
  actions: Scalars['actions'];
  automation?: InputMaybe<AutomationsObjRelInsertInput>;
  automation_id?: InputMaybe<Scalars['Int']>;
  conditions: Scalars['conditions'];
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  execution_time?: InputMaybe<Scalars['time']>;
  from_time?: InputMaybe<Scalars['time']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  notifications_enabled?: InputMaybe<Scalars['Boolean']>;
  scenes_devices?: InputMaybe<ScenesDevicesArrRelInsertInput>;
  timing_execution_kind?: InputMaybe<SceneTimingExecutionKindsEnum>;
  to_time?: InputMaybe<Scalars['time']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  weekdays_scheduling?: InputMaybe<Scalars['bpchar']>;
};

/** aggregate max on columns */
export type ScenesMaxFields = {
  __typename?: 'scenes_max_fields';
  automation_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
  weekdays_scheduling?: Maybe<Scalars['bpchar']>;
};

/** order by max() on columns of table "scenes" */
export type ScenesMaxOrderBy = {
  automation_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  weekdays_scheduling?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ScenesMinFields = {
  __typename?: 'scenes_min_fields';
  automation_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
  weekdays_scheduling?: Maybe<Scalars['bpchar']>;
};

/** order by min() on columns of table "scenes" */
export type ScenesMinOrderBy = {
  automation_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  weekdays_scheduling?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "scenes" */
export type ScenesMutationResponse = {
  __typename?: 'scenes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Scenes>;
};

/** input type for inserting object relation for remote table "scenes" */
export type ScenesObjRelInsertInput = {
  data: ScenesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<ScenesOnConflict>;
};

/** on_conflict condition type for table "scenes" */
export type ScenesOnConflict = {
  constraint: ScenesConstraint;
  update_columns?: Array<ScenesUpdateColumn>;
  where?: InputMaybe<ScenesBoolExp>;
};

/** Ordering options when selecting data from "scenes". */
export type ScenesOrderBy = {
  actions?: InputMaybe<OrderBy>;
  automation?: InputMaybe<AutomationsOrderBy>;
  automation_id?: InputMaybe<OrderBy>;
  conditions?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  enabled?: InputMaybe<OrderBy>;
  execution_time?: InputMaybe<OrderBy>;
  from_time?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  notifications_enabled?: InputMaybe<OrderBy>;
  scenes_devices_aggregate?: InputMaybe<ScenesDevicesAggregateOrderBy>;
  timing_execution_kind?: InputMaybe<OrderBy>;
  to_time?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  weekdays_scheduling?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: scenes */
export type ScenesPkColumnsInput = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ScenesPrependInput = {
  actions?: InputMaybe<Scalars['jsonb']>;
  conditions?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "scenes" */
export enum ScenesSelectColumn {
  /** column name */
  ACTIONS = 'actions',
  /** column name */
  AUTOMATION_ID = 'automation_id',
  /** column name */
  CONDITIONS = 'conditions',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  ENABLED = 'enabled',
  /** column name */
  EXECUTION_TIME = 'execution_time',
  /** column name */
  FROM_TIME = 'from_time',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  NOTIFICATIONS_ENABLED = 'notifications_enabled',
  /** column name */
  TIMING_EXECUTION_KIND = 'timing_execution_kind',
  /** column name */
  TO_TIME = 'to_time',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by',
  /** column name */
  WEEKDAYS_SCHEDULING = 'weekdays_scheduling'
}

/** select "scenes_aggregate_bool_exp_bool_and_arguments_columns" columns of table "scenes" */
export enum ScenesSelectColumnScenesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  ENABLED = 'enabled',
  /** column name */
  NOTIFICATIONS_ENABLED = 'notifications_enabled'
}

/** select "scenes_aggregate_bool_exp_bool_or_arguments_columns" columns of table "scenes" */
export enum ScenesSelectColumnScenesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  ENABLED = 'enabled',
  /** column name */
  NOTIFICATIONS_ENABLED = 'notifications_enabled'
}

/** input type for updating data in table "scenes" */
export type ScenesSetInput = {
  actions?: InputMaybe<Scalars['actions']>;
  automation_id?: InputMaybe<Scalars['Int']>;
  conditions?: InputMaybe<Scalars['conditions']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  execution_time?: InputMaybe<Scalars['time']>;
  from_time?: InputMaybe<Scalars['time']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  notifications_enabled?: InputMaybe<Scalars['Boolean']>;
  timing_execution_kind?: InputMaybe<SceneTimingExecutionKindsEnum>;
  to_time?: InputMaybe<Scalars['time']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  weekdays_scheduling?: InputMaybe<Scalars['bpchar']>;
};

/** aggregate stddev on columns */
export type ScenesStddevFields = {
  __typename?: 'scenes_stddev_fields';
  automation_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "scenes" */
export type ScenesStddevOrderBy = {
  automation_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ScenesStddevPopFields = {
  __typename?: 'scenes_stddev_pop_fields';
  automation_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "scenes" */
export type ScenesStddevPopOrderBy = {
  automation_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ScenesStddevSampFields = {
  __typename?: 'scenes_stddev_samp_fields';
  automation_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "scenes" */
export type ScenesStddevSampOrderBy = {
  automation_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "scenes" */
export type ScenesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ScenesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ScenesStreamCursorValueInput = {
  actions?: InputMaybe<Scalars['actions']>;
  automation_id?: InputMaybe<Scalars['Int']>;
  conditions?: InputMaybe<Scalars['conditions']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  execution_time?: InputMaybe<Scalars['time']>;
  from_time?: InputMaybe<Scalars['time']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  notifications_enabled?: InputMaybe<Scalars['Boolean']>;
  timing_execution_kind?: InputMaybe<SceneTimingExecutionKindsEnum>;
  to_time?: InputMaybe<Scalars['time']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  weekdays_scheduling?: InputMaybe<Scalars['bpchar']>;
};

/** aggregate sum on columns */
export type ScenesSumFields = {
  __typename?: 'scenes_sum_fields';
  automation_id?: Maybe<Scalars['Int']>;
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "scenes" */
export type ScenesSumOrderBy = {
  automation_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** update columns of table "scenes" */
export enum ScenesUpdateColumn {
  /** column name */
  ACTIONS = 'actions',
  /** column name */
  AUTOMATION_ID = 'automation_id',
  /** column name */
  CONDITIONS = 'conditions',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  ENABLED = 'enabled',
  /** column name */
  EXECUTION_TIME = 'execution_time',
  /** column name */
  FROM_TIME = 'from_time',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  NOTIFICATIONS_ENABLED = 'notifications_enabled',
  /** column name */
  TIMING_EXECUTION_KIND = 'timing_execution_kind',
  /** column name */
  TO_TIME = 'to_time',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by',
  /** column name */
  WEEKDAYS_SCHEDULING = 'weekdays_scheduling'
}

export type ScenesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ScenesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ScenesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ScenesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ScenesDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ScenesIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ScenesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ScenesSetInput>;
  /** filter the rows which have to be updated */
  where: ScenesBoolExp;
};

/** aggregate var_pop on columns */
export type ScenesVarPopFields = {
  __typename?: 'scenes_var_pop_fields';
  automation_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "scenes" */
export type ScenesVarPopOrderBy = {
  automation_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ScenesVarSampFields = {
  __typename?: 'scenes_var_samp_fields';
  automation_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "scenes" */
export type ScenesVarSampOrderBy = {
  automation_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ScenesVarianceFields = {
  __typename?: 'scenes_variance_fields';
  automation_id?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "scenes" */
export type ScenesVarianceOrderBy = {
  automation_id?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
};

export type SubscriptionRoot = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "analysis" */
  analysis: Array<Analysis>;
  /** An array relationship */
  analysis__devices_payloads: Array<AnalysisDevicesPayloads>;
  /** An aggregate relationship */
  analysis__devices_payloads_aggregate: AnalysisDevicesPayloadsAggregate;
  /** fetch data from the table: "analysis__devices_payloads" using primary key columns */
  analysis__devices_payloads_by_pk?: Maybe<AnalysisDevicesPayloads>;
  /** fetch data from the table in a streaming manner: "analysis__devices_payloads" */
  analysis__devices_payloads_stream: Array<AnalysisDevicesPayloads>;
  /** fetch aggregated fields from the table: "analysis" */
  analysis_aggregate: AnalysisAggregate;
  /** An array relationship */
  analysis_applications: Array<AnalysisApplications>;
  /** fetch data from the table: "analysis_applications__devices" */
  analysis_applications__devices: Array<AnalysisApplicationsDevices>;
  /** fetch aggregated fields from the table: "analysis_applications__devices" */
  analysis_applications__devices_aggregate: AnalysisApplicationsDevicesAggregate;
  /** fetch data from the table: "analysis_applications__devices" using primary key columns */
  analysis_applications__devices_by_pk?: Maybe<AnalysisApplicationsDevices>;
  /** fetch data from the table in a streaming manner: "analysis_applications__devices" */
  analysis_applications__devices_stream: Array<AnalysisApplicationsDevices>;
  /** An aggregate relationship */
  analysis_applications_aggregate: AnalysisApplicationsAggregate;
  /** fetch data from the table: "analysis_applications" using primary key columns */
  analysis_applications_by_pk?: Maybe<AnalysisApplications>;
  /** fetch data from the table: "analysis_applications_computed" */
  analysis_applications_computed: Array<AnalysisApplicationsComputed>;
  /** fetch aggregated fields from the table: "analysis_applications_computed" */
  analysis_applications_computed_aggregate: AnalysisApplicationsComputedAggregate;
  /** fetch data from the table: "analysis_applications_computed" using primary key columns */
  analysis_applications_computed_by_pk?: Maybe<AnalysisApplicationsComputed>;
  /** fetch data from the table in a streaming manner: "analysis_applications_computed" */
  analysis_applications_computed_stream: Array<AnalysisApplicationsComputed>;
  /** fetch data from the table: "analysis_applications_computed_values" */
  analysis_applications_computed_values: Array<AnalysisApplicationsComputedValues>;
  /** fetch aggregated fields from the table: "analysis_applications_computed_values" */
  analysis_applications_computed_values_aggregate: AnalysisApplicationsComputedValuesAggregate;
  /** fetch data from the table: "analysis_applications_computed_values" using primary key columns */
  analysis_applications_computed_values_by_pk?: Maybe<AnalysisApplicationsComputedValues>;
  /** fetch data from the table: "analysis_applications_computed_values_kinds" */
  analysis_applications_computed_values_kinds: Array<AnalysisApplicationsComputedValuesKinds>;
  /** fetch aggregated fields from the table: "analysis_applications_computed_values_kinds" */
  analysis_applications_computed_values_kinds_aggregate: AnalysisApplicationsComputedValuesKindsAggregate;
  /** fetch data from the table: "analysis_applications_computed_values_kinds" using primary key columns */
  analysis_applications_computed_values_kinds_by_pk?: Maybe<AnalysisApplicationsComputedValuesKinds>;
  /** fetch data from the table in a streaming manner: "analysis_applications_computed_values_kinds" */
  analysis_applications_computed_values_kinds_stream: Array<AnalysisApplicationsComputedValuesKinds>;
  /** fetch data from the table in a streaming manner: "analysis_applications_computed_values" */
  analysis_applications_computed_values_stream: Array<AnalysisApplicationsComputedValues>;
  /** fetch data from the table in a streaming manner: "analysis_applications" */
  analysis_applications_stream: Array<AnalysisApplications>;
  /** fetch data from the table: "analysis" using primary key columns */
  analysis_by_pk?: Maybe<Analysis>;
  /** fetch data from the table: "analysis_device_categories_configs" */
  analysis_device_categories_configs: Array<AnalysisDeviceCategoriesConfigs>;
  /** fetch aggregated fields from the table: "analysis_device_categories_configs" */
  analysis_device_categories_configs_aggregate: AnalysisDeviceCategoriesConfigsAggregate;
  /** fetch data from the table: "analysis_device_categories_configs" using primary key columns */
  analysis_device_categories_configs_by_pk?: Maybe<AnalysisDeviceCategoriesConfigs>;
  /** fetch data from the table in a streaming manner: "analysis_device_categories_configs" */
  analysis_device_categories_configs_stream: Array<AnalysisDeviceCategoriesConfigs>;
  /** fetch data from the table: "analysis_groups" */
  analysis_groups: Array<AnalysisGroups>;
  /** fetch aggregated fields from the table: "analysis_groups" */
  analysis_groups_aggregate: AnalysisGroupsAggregate;
  /** fetch data from the table: "analysis_groups" using primary key columns */
  analysis_groups_by_pk?: Maybe<AnalysisGroups>;
  /** fetch data from the table in a streaming manner: "analysis_groups" */
  analysis_groups_stream: Array<AnalysisGroups>;
  /** fetch data from the table: "analysis_kinds" */
  analysis_kinds: Array<AnalysisKinds>;
  /** fetch aggregated fields from the table: "analysis_kinds" */
  analysis_kinds_aggregate: AnalysisKindsAggregate;
  /** fetch data from the table: "analysis_kinds" using primary key columns */
  analysis_kinds_by_pk?: Maybe<AnalysisKinds>;
  /** fetch data from the table in a streaming manner: "analysis_kinds" */
  analysis_kinds_stream: Array<AnalysisKinds>;
  /** fetch data from the table in a streaming manner: "analysis" */
  analysis_stream: Array<Analysis>;
  /** An array relationship */
  applications: Array<Applications>;
  /** An aggregate relationship */
  applications_aggregate: ApplicationsAggregate;
  /** fetch data from the table: "applications" using primary key columns */
  applications_by_pk?: Maybe<Applications>;
  /** fetch data from the table: "applications_dashboards" */
  applications_dashboards: Array<ApplicationsDashboards>;
  /** fetch aggregated fields from the table: "applications_dashboards" */
  applications_dashboards_aggregate: ApplicationsDashboardsAggregate;
  /** An array relationship */
  applications_dashboards_analysis: Array<ApplicationsDashboardsAnalysis>;
  /** An aggregate relationship */
  applications_dashboards_analysis_aggregate: ApplicationsDashboardsAnalysisAggregate;
  /** fetch data from the table: "applications_dashboards_analysis" using primary key columns */
  applications_dashboards_analysis_by_pk?: Maybe<ApplicationsDashboardsAnalysis>;
  /** fetch data from the table in a streaming manner: "applications_dashboards_analysis" */
  applications_dashboards_analysis_stream: Array<ApplicationsDashboardsAnalysis>;
  /** fetch data from the table: "applications_dashboards" using primary key columns */
  applications_dashboards_by_pk?: Maybe<ApplicationsDashboards>;
  /** An array relationship */
  applications_dashboards_devices: Array<ApplicationsDashboardsDevices>;
  /** An aggregate relationship */
  applications_dashboards_devices_aggregate: ApplicationsDashboardsDevicesAggregate;
  /** fetch data from the table: "applications_dashboards_devices" using primary key columns */
  applications_dashboards_devices_by_pk?: Maybe<ApplicationsDashboardsDevices>;
  /** fetch data from the table in a streaming manner: "applications_dashboards_devices" */
  applications_dashboards_devices_stream: Array<ApplicationsDashboardsDevices>;
  /** fetch data from the table in a streaming manner: "applications_dashboards" */
  applications_dashboards_stream: Array<ApplicationsDashboards>;
  /** fetch data from the table: "applications_settings" */
  applications_settings: Array<ApplicationsSettings>;
  /** fetch aggregated fields from the table: "applications_settings" */
  applications_settings_aggregate: ApplicationsSettingsAggregate;
  /** fetch data from the table: "applications_settings" using primary key columns */
  applications_settings_by_pk?: Maybe<ApplicationsSettings>;
  /** fetch data from the table in a streaming manner: "applications_settings" */
  applications_settings_stream: Array<ApplicationsSettings>;
  /** fetch data from the table in a streaming manner: "applications" */
  applications_stream: Array<Applications>;
  /** An array relationship */
  areas: Array<Areas>;
  /** An aggregate relationship */
  areas_aggregate: AreasAggregate;
  /** fetch data from the table: "areas" using primary key columns */
  areas_by_pk?: Maybe<Areas>;
  /** fetch data from the table: "areas_scope_cultivation" */
  areas_scope_cultivation: Array<AreasScopeCultivation>;
  /** fetch aggregated fields from the table: "areas_scope_cultivation" */
  areas_scope_cultivation_aggregate: AreasScopeCultivationAggregate;
  /** fetch data from the table: "areas_scope_cultivation" using primary key columns */
  areas_scope_cultivation_by_pk?: Maybe<AreasScopeCultivation>;
  /** fetch data from the table in a streaming manner: "areas_scope_cultivation" */
  areas_scope_cultivation_stream: Array<AreasScopeCultivation>;
  /** fetch data from the table: "areas_scopes" */
  areas_scopes: Array<AreasScopes>;
  /** fetch aggregated fields from the table: "areas_scopes" */
  areas_scopes_aggregate: AreasScopesAggregate;
  /** fetch data from the table: "areas_scopes" using primary key columns */
  areas_scopes_by_pk?: Maybe<AreasScopes>;
  /** fetch data from the table in a streaming manner: "areas_scopes" */
  areas_scopes_stream: Array<AreasScopes>;
  /** fetch data from the table in a streaming manner: "areas" */
  areas_stream: Array<Areas>;
  /** fetch data from the table: "automation_timing_execution_kinds" */
  automation_timing_execution_kinds: Array<AutomationTimingExecutionKinds>;
  /** fetch aggregated fields from the table: "automation_timing_execution_kinds" */
  automation_timing_execution_kinds_aggregate: AutomationTimingExecutionKindsAggregate;
  /** fetch data from the table: "automation_timing_execution_kinds" using primary key columns */
  automation_timing_execution_kinds_by_pk?: Maybe<AutomationTimingExecutionKinds>;
  /** fetch data from the table in a streaming manner: "automation_timing_execution_kinds" */
  automation_timing_execution_kinds_stream: Array<AutomationTimingExecutionKinds>;
  /** An array relationship */
  automations: Array<Automations>;
  /** An aggregate relationship */
  automations_aggregate: AutomationsAggregate;
  /** fetch data from the table: "automations" using primary key columns */
  automations_by_pk?: Maybe<Automations>;
  /** fetch data from the table in a streaming manner: "automations" */
  automations_stream: Array<Automations>;
  /** fetch data from the table: "automations_watchings" */
  automations_watchings: Array<AutomationsWatchings>;
  /** fetch aggregated fields from the table: "automations_watchings" */
  automations_watchings_aggregate: AutomationsWatchingsAggregate;
  /** fetch data from the table: "automations_watchings" using primary key columns */
  automations_watchings_by_pk?: Maybe<AutomationsWatchings>;
  /** fetch data from the table in a streaming manner: "automations_watchings" */
  automations_watchings_stream: Array<AutomationsWatchings>;
  /** fetch data from the table: "chat_message_types" */
  chat_message_types: Array<ChatMessageTypes>;
  /** fetch aggregated fields from the table: "chat_message_types" */
  chat_message_types_aggregate: ChatMessageTypesAggregate;
  /** fetch data from the table: "chat_message_types" using primary key columns */
  chat_message_types_by_pk?: Maybe<ChatMessageTypes>;
  /** fetch data from the table in a streaming manner: "chat_message_types" */
  chat_message_types_stream: Array<ChatMessageTypes>;
  /** fetch data from the table: "chat_messages" */
  chat_messages: Array<ChatMessages>;
  /** fetch aggregated fields from the table: "chat_messages" */
  chat_messages_aggregate: ChatMessagesAggregate;
  /** fetch data from the table: "chat_messages" using primary key columns */
  chat_messages_by_pk?: Maybe<ChatMessages>;
  /** fetch data from the table in a streaming manner: "chat_messages" */
  chat_messages_stream: Array<ChatMessages>;
  /** fetch data from the table: "cultivation_types" */
  cultivation_types: Array<CultivationTypes>;
  /** fetch aggregated fields from the table: "cultivation_types" */
  cultivation_types_aggregate: CultivationTypesAggregate;
  /** fetch data from the table: "cultivation_types" using primary key columns */
  cultivation_types_by_pk?: Maybe<CultivationTypes>;
  /** fetch data from the table in a streaming manner: "cultivation_types" */
  cultivation_types_stream: Array<CultivationTypes>;
  /** fetch data from the table: "device_actions" */
  device_actions: Array<DeviceActions>;
  /** fetch aggregated fields from the table: "device_actions" */
  device_actions_aggregate: DeviceActionsAggregate;
  /** fetch data from the table: "device_actions" using primary key columns */
  device_actions_by_pk?: Maybe<DeviceActions>;
  /** fetch data from the table in a streaming manner: "device_actions" */
  device_actions_stream: Array<DeviceActions>;
  /** fetch data from the table: "device_categories" */
  device_categories: Array<DeviceCategories>;
  /** fetch aggregated fields from the table: "device_categories" */
  device_categories_aggregate: DeviceCategoriesAggregate;
  /** fetch data from the table: "device_categories" using primary key columns */
  device_categories_by_pk?: Maybe<DeviceCategories>;
  /** fetch data from the table in a streaming manner: "device_categories" */
  device_categories_stream: Array<DeviceCategories>;
  /** fetch data from the table: "device_payload_values" */
  device_payload_values: Array<DevicePayloadValues>;
  /** fetch aggregated fields from the table: "device_payload_values" */
  device_payload_values_aggregate: DevicePayloadValuesAggregate;
  /** fetch data from the table: "device_payload_values" using primary key columns */
  device_payload_values_by_pk?: Maybe<DevicePayloadValues>;
  /** fetch data from the table in a streaming manner: "device_payload_values" */
  device_payload_values_stream: Array<DevicePayloadValues>;
  /** fetch data from the table: "device_payloads" */
  device_payloads: Array<DevicePayloads>;
  /** fetch data from the table: "device_payloads__payload_values" */
  device_payloads__payload_values: Array<DevicePayloadsPayloadValues>;
  /** fetch aggregated fields from the table: "device_payloads__payload_values" */
  device_payloads__payload_values_aggregate: DevicePayloadsPayloadValuesAggregate;
  /** fetch data from the table: "device_payloads__payload_values" using primary key columns */
  device_payloads__payload_values_by_pk?: Maybe<DevicePayloadsPayloadValues>;
  /** fetch data from the table in a streaming manner: "device_payloads__payload_values" */
  device_payloads__payload_values_stream: Array<DevicePayloadsPayloadValues>;
  /** fetch aggregated fields from the table: "device_payloads" */
  device_payloads_aggregate: DevicePayloadsAggregate;
  /** fetch data from the table: "device_payloads" using primary key columns */
  device_payloads_by_pk?: Maybe<DevicePayloads>;
  /** fetch data from the table in a streaming manner: "device_payloads" */
  device_payloads_stream: Array<DevicePayloads>;
  /** An array relationship */
  devices: Array<Devices>;
  /** fetch data from the table: "devices__device_actions" */
  devices__device_actions: Array<DevicesDeviceActions>;
  /** fetch aggregated fields from the table: "devices__device_actions" */
  devices__device_actions_aggregate: DevicesDeviceActionsAggregate;
  /** fetch data from the table: "devices__device_actions" using primary key columns */
  devices__device_actions_by_pk?: Maybe<DevicesDeviceActions>;
  /** fetch data from the table in a streaming manner: "devices__device_actions" */
  devices__device_actions_stream: Array<DevicesDeviceActions>;
  /** fetch data from the table: "devices__device_categories" */
  devices__device_categories: Array<DevicesDeviceCategories>;
  /** fetch aggregated fields from the table: "devices__device_categories" */
  devices__device_categories_aggregate: DevicesDeviceCategoriesAggregate;
  /** fetch data from the table: "devices__device_categories" using primary key columns */
  devices__device_categories_by_pk?: Maybe<DevicesDeviceCategories>;
  /** fetch data from the table in a streaming manner: "devices__device_categories" */
  devices__device_categories_stream: Array<DevicesDeviceCategories>;
  /** fetch data from the table: "devices__device_payloads" */
  devices__device_payloads: Array<DevicesDevicePayloads>;
  /** fetch aggregated fields from the table: "devices__device_payloads" */
  devices__device_payloads_aggregate: DevicesDevicePayloadsAggregate;
  /** fetch data from the table: "devices__device_payloads" using primary key columns */
  devices__device_payloads_by_pk?: Maybe<DevicesDevicePayloads>;
  /** fetch data from the table in a streaming manner: "devices__device_payloads" */
  devices__device_payloads_stream: Array<DevicesDevicePayloads>;
  /** An aggregate relationship */
  devices_aggregate: DevicesAggregate;
  /** fetch data from the table: "devices" using primary key columns */
  devices_by_pk?: Maybe<Devices>;
  /** fetch data from the table in a streaming manner: "devices" */
  devices_stream: Array<Devices>;
  /** fetch data from the table: "downlinks" */
  downlinks: Array<Downlinks>;
  /** fetch aggregated fields from the table: "downlinks" */
  downlinks_aggregate: DownlinksAggregate;
  /** fetch data from the table: "downlinks" using primary key columns */
  downlinks_by_pk?: Maybe<Downlinks>;
  /** fetch data from the table in a streaming manner: "downlinks" */
  downlinks_stream: Array<Downlinks>;
  /** fetch data from the table: "farming_containers" */
  farming_containers: Array<FarmingContainers>;
  /** fetch aggregated fields from the table: "farming_containers" */
  farming_containers_aggregate: FarmingContainersAggregate;
  /** fetch data from the table: "farming_containers" using primary key columns */
  farming_containers_by_pk?: Maybe<FarmingContainers>;
  /** fetch data from the table in a streaming manner: "farming_containers" */
  farming_containers_stream: Array<FarmingContainers>;
  /** fetch data from the table: "farming_methods" */
  farming_methods: Array<FarmingMethods>;
  /** fetch aggregated fields from the table: "farming_methods" */
  farming_methods_aggregate: FarmingMethodsAggregate;
  /** fetch data from the table: "farming_methods" using primary key columns */
  farming_methods_by_pk?: Maybe<FarmingMethods>;
  /** fetch data from the table in a streaming manner: "farming_methods" */
  farming_methods_stream: Array<FarmingMethods>;
  /** fetch data from the table: "farming_structures" */
  farming_structures: Array<FarmingStructures>;
  /** fetch aggregated fields from the table: "farming_structures" */
  farming_structures_aggregate: FarmingStructuresAggregate;
  /** fetch data from the table: "farming_structures" using primary key columns */
  farming_structures_by_pk?: Maybe<FarmingStructures>;
  /** fetch data from the table in a streaming manner: "farming_structures" */
  farming_structures_stream: Array<FarmingStructures>;
  /** fetch data from the table: "notification_event_types" */
  notification_event_types: Array<NotificationEventTypes>;
  /** fetch aggregated fields from the table: "notification_event_types" */
  notification_event_types_aggregate: NotificationEventTypesAggregate;
  /** fetch data from the table: "notification_event_types" using primary key columns */
  notification_event_types_by_pk?: Maybe<NotificationEventTypes>;
  /** fetch data from the table in a streaming manner: "notification_event_types" */
  notification_event_types_stream: Array<NotificationEventTypes>;
  /** fetch data from the table: "notification_kinds" */
  notification_kinds: Array<NotificationKinds>;
  /** fetch aggregated fields from the table: "notification_kinds" */
  notification_kinds_aggregate: NotificationKindsAggregate;
  /** fetch data from the table: "notification_kinds" using primary key columns */
  notification_kinds_by_pk?: Maybe<NotificationKinds>;
  /** fetch data from the table in a streaming manner: "notification_kinds" */
  notification_kinds_stream: Array<NotificationKinds>;
  /** fetch data from the table: "notification_user_devices" */
  notification_user_devices: Array<NotificationUserDevices>;
  /** fetch data from the table: "notification_user_devices__event_types" */
  notification_user_devices__event_types: Array<NotificationUserDevicesEventTypes>;
  /** fetch aggregated fields from the table: "notification_user_devices__event_types" */
  notification_user_devices__event_types_aggregate: NotificationUserDevicesEventTypesAggregate;
  /** fetch data from the table: "notification_user_devices__event_types" using primary key columns */
  notification_user_devices__event_types_by_pk?: Maybe<NotificationUserDevicesEventTypes>;
  /** fetch data from the table in a streaming manner: "notification_user_devices__event_types" */
  notification_user_devices__event_types_stream: Array<NotificationUserDevicesEventTypes>;
  /** fetch aggregated fields from the table: "notification_user_devices" */
  notification_user_devices_aggregate: NotificationUserDevicesAggregate;
  /** fetch data from the table: "notification_user_devices" using primary key columns */
  notification_user_devices_by_pk?: Maybe<NotificationUserDevices>;
  /** fetch data from the table in a streaming manner: "notification_user_devices" */
  notification_user_devices_stream: Array<NotificationUserDevices>;
  /** fetch data from the table: "notification_user_settings" */
  notification_user_settings: Array<NotificationUserSettings>;
  /** fetch aggregated fields from the table: "notification_user_settings" */
  notification_user_settings_aggregate: NotificationUserSettingsAggregate;
  /** fetch data from the table: "notification_user_settings" using primary key columns */
  notification_user_settings_by_pk?: Maybe<NotificationUserSettings>;
  /** fetch data from the table in a streaming manner: "notification_user_settings" */
  notification_user_settings_stream: Array<NotificationUserSettings>;
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An aggregate relationship */
  notifications_aggregate: NotificationsAggregate;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: Maybe<Notifications>;
  /** fetch data from the table: "notifications_content" */
  notifications_content: Array<NotificationsContent>;
  /** fetch aggregated fields from the table: "notifications_content" */
  notifications_content_aggregate: NotificationsContentAggregate;
  /** fetch data from the table: "notifications_content" using primary key columns */
  notifications_content_by_pk?: Maybe<NotificationsContent>;
  /** fetch data from the table in a streaming manner: "notifications_content" */
  notifications_content_stream: Array<NotificationsContent>;
  /** fetch data from the table in a streaming manner: "notifications" */
  notifications_stream: Array<Notifications>;
  /** fetch data from the table: "organizations" */
  organizations: Array<Organizations>;
  /** fetch aggregated fields from the table: "organizations" */
  organizations_aggregate: OrganizationsAggregate;
  /** fetch data from the table: "organizations" using primary key columns */
  organizations_by_pk?: Maybe<Organizations>;
  /** fetch data from the table: "organizations_chat_params" */
  organizations_chat_params: Array<OrganizationsChatParams>;
  /** fetch aggregated fields from the table: "organizations_chat_params" */
  organizations_chat_params_aggregate: OrganizationsChatParamsAggregate;
  /** fetch data from the table: "organizations_chat_params" using primary key columns */
  organizations_chat_params_by_pk?: Maybe<OrganizationsChatParams>;
  /** fetch data from the table in a streaming manner: "organizations_chat_params" */
  organizations_chat_params_stream: Array<OrganizationsChatParams>;
  /** fetch data from the table: "organizations_feature_limits" */
  organizations_feature_limits: Array<OrganizationsFeatureLimits>;
  /** fetch aggregated fields from the table: "organizations_feature_limits" */
  organizations_feature_limits_aggregate: OrganizationsFeatureLimitsAggregate;
  /** fetch data from the table: "organizations_feature_limits" using primary key columns */
  organizations_feature_limits_by_pk?: Maybe<OrganizationsFeatureLimits>;
  /** fetch data from the table in a streaming manner: "organizations_feature_limits" */
  organizations_feature_limits_stream: Array<OrganizationsFeatureLimits>;
  /** fetch data from the table in a streaming manner: "organizations" */
  organizations_stream: Array<Organizations>;
  /** fetch data from the table: "organizations_users__users_organizations" */
  organizations_users__users_organizations: Array<OrganizationsUsersUsersOrganizations>;
  /** fetch aggregated fields from the table: "organizations_users__users_organizations" */
  organizations_users__users_organizations_aggregate: OrganizationsUsersUsersOrganizationsAggregate;
  /** fetch data from the table: "organizations_users__users_organizations" using primary key columns */
  organizations_users__users_organizations_by_pk?: Maybe<OrganizationsUsersUsersOrganizations>;
  /** fetch data from the table in a streaming manner: "organizations_users__users_organizations" */
  organizations_users__users_organizations_stream: Array<OrganizationsUsersUsersOrganizations>;
  /** fetch data from the table: "scene_feedback_waits" */
  scene_feedback_waits: Array<SceneFeedbackWaits>;
  /** fetch aggregated fields from the table: "scene_feedback_waits" */
  scene_feedback_waits_aggregate: SceneFeedbackWaitsAggregate;
  /** fetch data from the table: "scene_feedback_waits" using primary key columns */
  scene_feedback_waits_by_pk?: Maybe<SceneFeedbackWaits>;
  /** fetch data from the table in a streaming manner: "scene_feedback_waits" */
  scene_feedback_waits_stream: Array<SceneFeedbackWaits>;
  /** fetch data from the table: "scene_scheduled_executions" */
  scene_scheduled_executions: Array<SceneScheduledExecutions>;
  /** fetch aggregated fields from the table: "scene_scheduled_executions" */
  scene_scheduled_executions_aggregate: SceneScheduledExecutionsAggregate;
  /** fetch data from the table: "scene_scheduled_executions" using primary key columns */
  scene_scheduled_executions_by_pk?: Maybe<SceneScheduledExecutions>;
  /** fetch data from the table in a streaming manner: "scene_scheduled_executions" */
  scene_scheduled_executions_stream: Array<SceneScheduledExecutions>;
  /** fetch data from the table: "scene_timing_execution_kinds" */
  scene_timing_execution_kinds: Array<SceneTimingExecutionKinds>;
  /** fetch aggregated fields from the table: "scene_timing_execution_kinds" */
  scene_timing_execution_kinds_aggregate: SceneTimingExecutionKindsAggregate;
  /** fetch data from the table: "scene_timing_execution_kinds" using primary key columns */
  scene_timing_execution_kinds_by_pk?: Maybe<SceneTimingExecutionKinds>;
  /** fetch data from the table in a streaming manner: "scene_timing_execution_kinds" */
  scene_timing_execution_kinds_stream: Array<SceneTimingExecutionKinds>;
  /** An array relationship */
  scenes: Array<Scenes>;
  /** fetch data from the table: "scenes__devices" */
  scenes__devices: Array<ScenesDevices>;
  /** fetch aggregated fields from the table: "scenes__devices" */
  scenes__devices_aggregate: ScenesDevicesAggregate;
  /** fetch data from the table: "scenes__devices" using primary key columns */
  scenes__devices_by_pk?: Maybe<ScenesDevices>;
  /** fetch data from the table in a streaming manner: "scenes__devices" */
  scenes__devices_stream: Array<ScenesDevices>;
  /** An aggregate relationship */
  scenes_aggregate: ScenesAggregate;
  /** fetch data from the table: "scenes" using primary key columns */
  scenes_by_pk?: Maybe<Scenes>;
  /** fetch data from the table in a streaming manner: "scenes" */
  scenes_stream: Array<Scenes>;
  /** fetch data from the table: "substrates" */
  substrates: Array<Substrates>;
  /** fetch aggregated fields from the table: "substrates" */
  substrates_aggregate: SubstratesAggregate;
  /** fetch data from the table: "substrates" using primary key columns */
  substrates_by_pk?: Maybe<Substrates>;
  /** fetch data from the table in a streaming manner: "substrates" */
  substrates_stream: Array<Substrates>;
  /** An array relationship */
  telegram_users: Array<TelegramUsers>;
  /** An aggregate relationship */
  telegram_users_aggregate: TelegramUsersAggregate;
  /** fetch data from the table: "telegram_users" using primary key columns */
  telegram_users_by_pk?: Maybe<TelegramUsers>;
  /** fetch data from the table in a streaming manner: "telegram_users" */
  telegram_users_stream: Array<TelegramUsers>;
  /** fetch data from the table: "uplink_dynamo_ref" */
  uplink_dynamo_ref: Array<UplinkDynamoRef>;
  /** fetch aggregated fields from the table: "uplink_dynamo_ref" */
  uplink_dynamo_ref_aggregate: UplinkDynamoRefAggregate;
  /** fetch data from the table: "uplink_dynamo_ref" using primary key columns */
  uplink_dynamo_ref_by_pk?: Maybe<UplinkDynamoRef>;
  /** fetch data from the table in a streaming manner: "uplink_dynamo_ref" */
  uplink_dynamo_ref_stream: Array<UplinkDynamoRef>;
  /** fetch data from the table: "user_roles" */
  user_roles: Array<UserRoles>;
  /** fetch data from the table: "user_roles__users_permissions_user" */
  user_roles__users_permissions_user: Array<UserRolesUsersPermissionsUser>;
  /** fetch aggregated fields from the table: "user_roles__users_permissions_user" */
  user_roles__users_permissions_user_aggregate: UserRolesUsersPermissionsUserAggregate;
  /** fetch data from the table: "user_roles__users_permissions_user" using primary key columns */
  user_roles__users_permissions_user_by_pk?: Maybe<UserRolesUsersPermissionsUser>;
  /** fetch data from the table in a streaming manner: "user_roles__users_permissions_user" */
  user_roles__users_permissions_user_stream: Array<UserRolesUsersPermissionsUser>;
  /** fetch aggregated fields from the table: "user_roles" */
  user_roles_aggregate: UserRolesAggregate;
  /** fetch data from the table: "user_roles" using primary key columns */
  user_roles_by_pk?: Maybe<UserRoles>;
  /** fetch data from the table in a streaming manner: "user_roles" */
  user_roles_stream: Array<UserRoles>;
  /** fetch data from the table: "users_permissions_user" */
  users_permissions_user: Array<UsersPermissionsUser>;
  /** fetch aggregated fields from the table: "users_permissions_user" */
  users_permissions_user_aggregate: UsersPermissionsUserAggregate;
  /** fetch data from the table: "users_permissions_user" using primary key columns */
  users_permissions_user_by_pk?: Maybe<UsersPermissionsUser>;
  /** fetch data from the table in a streaming manner: "users_permissions_user" */
  users_permissions_user_stream: Array<UsersPermissionsUser>;
};


export type SubscriptionRootAnalysisArgs = {
  distinct_on?: InputMaybe<Array<AnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisOrderBy>>;
  where?: InputMaybe<AnalysisBoolExp>;
};


export type SubscriptionRootAnalysisDevicesPayloadsArgs = {
  distinct_on?: InputMaybe<Array<AnalysisDevicesPayloadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisDevicesPayloadsOrderBy>>;
  where?: InputMaybe<AnalysisDevicesPayloadsBoolExp>;
};


export type SubscriptionRootAnalysisDevicesPayloadsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AnalysisDevicesPayloadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisDevicesPayloadsOrderBy>>;
  where?: InputMaybe<AnalysisDevicesPayloadsBoolExp>;
};


export type SubscriptionRootAnalysisDevicesPayloadsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootAnalysisDevicesPayloadsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AnalysisDevicesPayloadsStreamCursorInput>>;
  where?: InputMaybe<AnalysisDevicesPayloadsBoolExp>;
};


export type SubscriptionRootAnalysisAggregateArgs = {
  distinct_on?: InputMaybe<Array<AnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisOrderBy>>;
  where?: InputMaybe<AnalysisBoolExp>;
};


export type SubscriptionRootAnalysisApplicationsArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsBoolExp>;
};


export type SubscriptionRootAnalysisApplicationsDevicesArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsDevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsDevicesOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsDevicesBoolExp>;
};


export type SubscriptionRootAnalysisApplicationsDevicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsDevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsDevicesOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsDevicesBoolExp>;
};


export type SubscriptionRootAnalysisApplicationsDevicesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootAnalysisApplicationsDevicesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AnalysisApplicationsDevicesStreamCursorInput>>;
  where?: InputMaybe<AnalysisApplicationsDevicesBoolExp>;
};


export type SubscriptionRootAnalysisApplicationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsBoolExp>;
};


export type SubscriptionRootAnalysisApplicationsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootAnalysisApplicationsComputedArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsComputedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsComputedOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsComputedBoolExp>;
};


export type SubscriptionRootAnalysisApplicationsComputedAggregateArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsComputedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsComputedOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsComputedBoolExp>;
};


export type SubscriptionRootAnalysisApplicationsComputedByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootAnalysisApplicationsComputedStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AnalysisApplicationsComputedStreamCursorInput>>;
  where?: InputMaybe<AnalysisApplicationsComputedBoolExp>;
};


export type SubscriptionRootAnalysisApplicationsComputedValuesArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsComputedValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsComputedValuesOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsComputedValuesBoolExp>;
};


export type SubscriptionRootAnalysisApplicationsComputedValuesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsComputedValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsComputedValuesOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsComputedValuesBoolExp>;
};


export type SubscriptionRootAnalysisApplicationsComputedValuesByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootAnalysisApplicationsComputedValuesKindsArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsComputedValuesKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsComputedValuesKindsOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsComputedValuesKindsBoolExp>;
};


export type SubscriptionRootAnalysisApplicationsComputedValuesKindsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AnalysisApplicationsComputedValuesKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisApplicationsComputedValuesKindsOrderBy>>;
  where?: InputMaybe<AnalysisApplicationsComputedValuesKindsBoolExp>;
};


export type SubscriptionRootAnalysisApplicationsComputedValuesKindsByPkArgs = {
  value: Scalars['String'];
};


export type SubscriptionRootAnalysisApplicationsComputedValuesKindsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AnalysisApplicationsComputedValuesKindsStreamCursorInput>>;
  where?: InputMaybe<AnalysisApplicationsComputedValuesKindsBoolExp>;
};


export type SubscriptionRootAnalysisApplicationsComputedValuesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AnalysisApplicationsComputedValuesStreamCursorInput>>;
  where?: InputMaybe<AnalysisApplicationsComputedValuesBoolExp>;
};


export type SubscriptionRootAnalysisApplicationsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AnalysisApplicationsStreamCursorInput>>;
  where?: InputMaybe<AnalysisApplicationsBoolExp>;
};


export type SubscriptionRootAnalysisByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootAnalysisDeviceCategoriesConfigsArgs = {
  distinct_on?: InputMaybe<Array<AnalysisDeviceCategoriesConfigsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisDeviceCategoriesConfigsOrderBy>>;
  where?: InputMaybe<AnalysisDeviceCategoriesConfigsBoolExp>;
};


export type SubscriptionRootAnalysisDeviceCategoriesConfigsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AnalysisDeviceCategoriesConfigsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisDeviceCategoriesConfigsOrderBy>>;
  where?: InputMaybe<AnalysisDeviceCategoriesConfigsBoolExp>;
};


export type SubscriptionRootAnalysisDeviceCategoriesConfigsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootAnalysisDeviceCategoriesConfigsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AnalysisDeviceCategoriesConfigsStreamCursorInput>>;
  where?: InputMaybe<AnalysisDeviceCategoriesConfigsBoolExp>;
};


export type SubscriptionRootAnalysisGroupsArgs = {
  distinct_on?: InputMaybe<Array<AnalysisGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisGroupsOrderBy>>;
  where?: InputMaybe<AnalysisGroupsBoolExp>;
};


export type SubscriptionRootAnalysisGroupsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AnalysisGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisGroupsOrderBy>>;
  where?: InputMaybe<AnalysisGroupsBoolExp>;
};


export type SubscriptionRootAnalysisGroupsByPkArgs = {
  value: Scalars['String'];
};


export type SubscriptionRootAnalysisGroupsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AnalysisGroupsStreamCursorInput>>;
  where?: InputMaybe<AnalysisGroupsBoolExp>;
};


export type SubscriptionRootAnalysisKindsArgs = {
  distinct_on?: InputMaybe<Array<AnalysisKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisKindsOrderBy>>;
  where?: InputMaybe<AnalysisKindsBoolExp>;
};


export type SubscriptionRootAnalysisKindsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AnalysisKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AnalysisKindsOrderBy>>;
  where?: InputMaybe<AnalysisKindsBoolExp>;
};


export type SubscriptionRootAnalysisKindsByPkArgs = {
  value: Scalars['String'];
};


export type SubscriptionRootAnalysisKindsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AnalysisKindsStreamCursorInput>>;
  where?: InputMaybe<AnalysisKindsBoolExp>;
};


export type SubscriptionRootAnalysisStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AnalysisStreamCursorInput>>;
  where?: InputMaybe<AnalysisBoolExp>;
};


export type SubscriptionRootApplicationsArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsOrderBy>>;
  where?: InputMaybe<ApplicationsBoolExp>;
};


export type SubscriptionRootApplicationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsOrderBy>>;
  where?: InputMaybe<ApplicationsBoolExp>;
};


export type SubscriptionRootApplicationsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootApplicationsDashboardsArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsDashboardsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsDashboardsOrderBy>>;
  where?: InputMaybe<ApplicationsDashboardsBoolExp>;
};


export type SubscriptionRootApplicationsDashboardsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsDashboardsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsDashboardsOrderBy>>;
  where?: InputMaybe<ApplicationsDashboardsBoolExp>;
};


export type SubscriptionRootApplicationsDashboardsAnalysisArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsDashboardsAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsDashboardsAnalysisOrderBy>>;
  where?: InputMaybe<ApplicationsDashboardsAnalysisBoolExp>;
};


export type SubscriptionRootApplicationsDashboardsAnalysisAggregateArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsDashboardsAnalysisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsDashboardsAnalysisOrderBy>>;
  where?: InputMaybe<ApplicationsDashboardsAnalysisBoolExp>;
};


export type SubscriptionRootApplicationsDashboardsAnalysisByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootApplicationsDashboardsAnalysisStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ApplicationsDashboardsAnalysisStreamCursorInput>>;
  where?: InputMaybe<ApplicationsDashboardsAnalysisBoolExp>;
};


export type SubscriptionRootApplicationsDashboardsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootApplicationsDashboardsDevicesArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsDashboardsDevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsDashboardsDevicesOrderBy>>;
  where?: InputMaybe<ApplicationsDashboardsDevicesBoolExp>;
};


export type SubscriptionRootApplicationsDashboardsDevicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsDashboardsDevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsDashboardsDevicesOrderBy>>;
  where?: InputMaybe<ApplicationsDashboardsDevicesBoolExp>;
};


export type SubscriptionRootApplicationsDashboardsDevicesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootApplicationsDashboardsDevicesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ApplicationsDashboardsDevicesStreamCursorInput>>;
  where?: InputMaybe<ApplicationsDashboardsDevicesBoolExp>;
};


export type SubscriptionRootApplicationsDashboardsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ApplicationsDashboardsStreamCursorInput>>;
  where?: InputMaybe<ApplicationsDashboardsBoolExp>;
};


export type SubscriptionRootApplicationsSettingsArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsSettingsOrderBy>>;
  where?: InputMaybe<ApplicationsSettingsBoolExp>;
};


export type SubscriptionRootApplicationsSettingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ApplicationsSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ApplicationsSettingsOrderBy>>;
  where?: InputMaybe<ApplicationsSettingsBoolExp>;
};


export type SubscriptionRootApplicationsSettingsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootApplicationsSettingsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ApplicationsSettingsStreamCursorInput>>;
  where?: InputMaybe<ApplicationsSettingsBoolExp>;
};


export type SubscriptionRootApplicationsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ApplicationsStreamCursorInput>>;
  where?: InputMaybe<ApplicationsBoolExp>;
};


export type SubscriptionRootAreasArgs = {
  distinct_on?: InputMaybe<Array<AreasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AreasOrderBy>>;
  where?: InputMaybe<AreasBoolExp>;
};


export type SubscriptionRootAreasAggregateArgs = {
  distinct_on?: InputMaybe<Array<AreasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AreasOrderBy>>;
  where?: InputMaybe<AreasBoolExp>;
};


export type SubscriptionRootAreasByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootAreasScopeCultivationArgs = {
  distinct_on?: InputMaybe<Array<AreasScopeCultivationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AreasScopeCultivationOrderBy>>;
  where?: InputMaybe<AreasScopeCultivationBoolExp>;
};


export type SubscriptionRootAreasScopeCultivationAggregateArgs = {
  distinct_on?: InputMaybe<Array<AreasScopeCultivationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AreasScopeCultivationOrderBy>>;
  where?: InputMaybe<AreasScopeCultivationBoolExp>;
};


export type SubscriptionRootAreasScopeCultivationByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootAreasScopeCultivationStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AreasScopeCultivationStreamCursorInput>>;
  where?: InputMaybe<AreasScopeCultivationBoolExp>;
};


export type SubscriptionRootAreasScopesArgs = {
  distinct_on?: InputMaybe<Array<AreasScopesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AreasScopesOrderBy>>;
  where?: InputMaybe<AreasScopesBoolExp>;
};


export type SubscriptionRootAreasScopesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AreasScopesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AreasScopesOrderBy>>;
  where?: InputMaybe<AreasScopesBoolExp>;
};


export type SubscriptionRootAreasScopesByPkArgs = {
  value: Scalars['String'];
};


export type SubscriptionRootAreasScopesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AreasScopesStreamCursorInput>>;
  where?: InputMaybe<AreasScopesBoolExp>;
};


export type SubscriptionRootAreasStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AreasStreamCursorInput>>;
  where?: InputMaybe<AreasBoolExp>;
};


export type SubscriptionRootAutomationTimingExecutionKindsArgs = {
  distinct_on?: InputMaybe<Array<AutomationTimingExecutionKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutomationTimingExecutionKindsOrderBy>>;
  where?: InputMaybe<AutomationTimingExecutionKindsBoolExp>;
};


export type SubscriptionRootAutomationTimingExecutionKindsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AutomationTimingExecutionKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutomationTimingExecutionKindsOrderBy>>;
  where?: InputMaybe<AutomationTimingExecutionKindsBoolExp>;
};


export type SubscriptionRootAutomationTimingExecutionKindsByPkArgs = {
  value: Scalars['String'];
};


export type SubscriptionRootAutomationTimingExecutionKindsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AutomationTimingExecutionKindsStreamCursorInput>>;
  where?: InputMaybe<AutomationTimingExecutionKindsBoolExp>;
};


export type SubscriptionRootAutomationsArgs = {
  distinct_on?: InputMaybe<Array<AutomationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutomationsOrderBy>>;
  where?: InputMaybe<AutomationsBoolExp>;
};


export type SubscriptionRootAutomationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AutomationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutomationsOrderBy>>;
  where?: InputMaybe<AutomationsBoolExp>;
};


export type SubscriptionRootAutomationsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootAutomationsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AutomationsStreamCursorInput>>;
  where?: InputMaybe<AutomationsBoolExp>;
};


export type SubscriptionRootAutomationsWatchingsArgs = {
  distinct_on?: InputMaybe<Array<AutomationsWatchingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutomationsWatchingsOrderBy>>;
  where?: InputMaybe<AutomationsWatchingsBoolExp>;
};


export type SubscriptionRootAutomationsWatchingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AutomationsWatchingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutomationsWatchingsOrderBy>>;
  where?: InputMaybe<AutomationsWatchingsBoolExp>;
};


export type SubscriptionRootAutomationsWatchingsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootAutomationsWatchingsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AutomationsWatchingsStreamCursorInput>>;
  where?: InputMaybe<AutomationsWatchingsBoolExp>;
};


export type SubscriptionRootChatMessageTypesArgs = {
  distinct_on?: InputMaybe<Array<ChatMessageTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ChatMessageTypesOrderBy>>;
  where?: InputMaybe<ChatMessageTypesBoolExp>;
};


export type SubscriptionRootChatMessageTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ChatMessageTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ChatMessageTypesOrderBy>>;
  where?: InputMaybe<ChatMessageTypesBoolExp>;
};


export type SubscriptionRootChatMessageTypesByPkArgs = {
  value: Scalars['String'];
};


export type SubscriptionRootChatMessageTypesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ChatMessageTypesStreamCursorInput>>;
  where?: InputMaybe<ChatMessageTypesBoolExp>;
};


export type SubscriptionRootChatMessagesArgs = {
  distinct_on?: InputMaybe<Array<ChatMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ChatMessagesOrderBy>>;
  where?: InputMaybe<ChatMessagesBoolExp>;
};


export type SubscriptionRootChatMessagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ChatMessagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ChatMessagesOrderBy>>;
  where?: InputMaybe<ChatMessagesBoolExp>;
};


export type SubscriptionRootChatMessagesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootChatMessagesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ChatMessagesStreamCursorInput>>;
  where?: InputMaybe<ChatMessagesBoolExp>;
};


export type SubscriptionRootCultivationTypesArgs = {
  distinct_on?: InputMaybe<Array<CultivationTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CultivationTypesOrderBy>>;
  where?: InputMaybe<CultivationTypesBoolExp>;
};


export type SubscriptionRootCultivationTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<CultivationTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CultivationTypesOrderBy>>;
  where?: InputMaybe<CultivationTypesBoolExp>;
};


export type SubscriptionRootCultivationTypesByPkArgs = {
  value: Scalars['String'];
};


export type SubscriptionRootCultivationTypesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CultivationTypesStreamCursorInput>>;
  where?: InputMaybe<CultivationTypesBoolExp>;
};


export type SubscriptionRootDeviceActionsArgs = {
  distinct_on?: InputMaybe<Array<DeviceActionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DeviceActionsOrderBy>>;
  where?: InputMaybe<DeviceActionsBoolExp>;
};


export type SubscriptionRootDeviceActionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DeviceActionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DeviceActionsOrderBy>>;
  where?: InputMaybe<DeviceActionsBoolExp>;
};


export type SubscriptionRootDeviceActionsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootDeviceActionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DeviceActionsStreamCursorInput>>;
  where?: InputMaybe<DeviceActionsBoolExp>;
};


export type SubscriptionRootDeviceCategoriesArgs = {
  distinct_on?: InputMaybe<Array<DeviceCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DeviceCategoriesOrderBy>>;
  where?: InputMaybe<DeviceCategoriesBoolExp>;
};


export type SubscriptionRootDeviceCategoriesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DeviceCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DeviceCategoriesOrderBy>>;
  where?: InputMaybe<DeviceCategoriesBoolExp>;
};


export type SubscriptionRootDeviceCategoriesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootDeviceCategoriesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DeviceCategoriesStreamCursorInput>>;
  where?: InputMaybe<DeviceCategoriesBoolExp>;
};


export type SubscriptionRootDevicePayloadValuesArgs = {
  distinct_on?: InputMaybe<Array<DevicePayloadValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicePayloadValuesOrderBy>>;
  where?: InputMaybe<DevicePayloadValuesBoolExp>;
};


export type SubscriptionRootDevicePayloadValuesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DevicePayloadValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicePayloadValuesOrderBy>>;
  where?: InputMaybe<DevicePayloadValuesBoolExp>;
};


export type SubscriptionRootDevicePayloadValuesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootDevicePayloadValuesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DevicePayloadValuesStreamCursorInput>>;
  where?: InputMaybe<DevicePayloadValuesBoolExp>;
};


export type SubscriptionRootDevicePayloadsArgs = {
  distinct_on?: InputMaybe<Array<DevicePayloadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicePayloadsOrderBy>>;
  where?: InputMaybe<DevicePayloadsBoolExp>;
};


export type SubscriptionRootDevicePayloadsPayloadValuesArgs = {
  distinct_on?: InputMaybe<Array<DevicePayloadsPayloadValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicePayloadsPayloadValuesOrderBy>>;
  where?: InputMaybe<DevicePayloadsPayloadValuesBoolExp>;
};


export type SubscriptionRootDevicePayloadsPayloadValuesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DevicePayloadsPayloadValuesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicePayloadsPayloadValuesOrderBy>>;
  where?: InputMaybe<DevicePayloadsPayloadValuesBoolExp>;
};


export type SubscriptionRootDevicePayloadsPayloadValuesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootDevicePayloadsPayloadValuesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DevicePayloadsPayloadValuesStreamCursorInput>>;
  where?: InputMaybe<DevicePayloadsPayloadValuesBoolExp>;
};


export type SubscriptionRootDevicePayloadsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DevicePayloadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicePayloadsOrderBy>>;
  where?: InputMaybe<DevicePayloadsBoolExp>;
};


export type SubscriptionRootDevicePayloadsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootDevicePayloadsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DevicePayloadsStreamCursorInput>>;
  where?: InputMaybe<DevicePayloadsBoolExp>;
};


export type SubscriptionRootDevicesArgs = {
  distinct_on?: InputMaybe<Array<DevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicesOrderBy>>;
  where?: InputMaybe<DevicesBoolExp>;
};


export type SubscriptionRootDevicesDeviceActionsArgs = {
  distinct_on?: InputMaybe<Array<DevicesDeviceActionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicesDeviceActionsOrderBy>>;
  where?: InputMaybe<DevicesDeviceActionsBoolExp>;
};


export type SubscriptionRootDevicesDeviceActionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DevicesDeviceActionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicesDeviceActionsOrderBy>>;
  where?: InputMaybe<DevicesDeviceActionsBoolExp>;
};


export type SubscriptionRootDevicesDeviceActionsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootDevicesDeviceActionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DevicesDeviceActionsStreamCursorInput>>;
  where?: InputMaybe<DevicesDeviceActionsBoolExp>;
};


export type SubscriptionRootDevicesDeviceCategoriesArgs = {
  distinct_on?: InputMaybe<Array<DevicesDeviceCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicesDeviceCategoriesOrderBy>>;
  where?: InputMaybe<DevicesDeviceCategoriesBoolExp>;
};


export type SubscriptionRootDevicesDeviceCategoriesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DevicesDeviceCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicesDeviceCategoriesOrderBy>>;
  where?: InputMaybe<DevicesDeviceCategoriesBoolExp>;
};


export type SubscriptionRootDevicesDeviceCategoriesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootDevicesDeviceCategoriesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DevicesDeviceCategoriesStreamCursorInput>>;
  where?: InputMaybe<DevicesDeviceCategoriesBoolExp>;
};


export type SubscriptionRootDevicesDevicePayloadsArgs = {
  distinct_on?: InputMaybe<Array<DevicesDevicePayloadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicesDevicePayloadsOrderBy>>;
  where?: InputMaybe<DevicesDevicePayloadsBoolExp>;
};


export type SubscriptionRootDevicesDevicePayloadsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DevicesDevicePayloadsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicesDevicePayloadsOrderBy>>;
  where?: InputMaybe<DevicesDevicePayloadsBoolExp>;
};


export type SubscriptionRootDevicesDevicePayloadsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootDevicesDevicePayloadsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DevicesDevicePayloadsStreamCursorInput>>;
  where?: InputMaybe<DevicesDevicePayloadsBoolExp>;
};


export type SubscriptionRootDevicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<DevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DevicesOrderBy>>;
  where?: InputMaybe<DevicesBoolExp>;
};


export type SubscriptionRootDevicesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootDevicesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DevicesStreamCursorInput>>;
  where?: InputMaybe<DevicesBoolExp>;
};


export type SubscriptionRootDownlinksArgs = {
  distinct_on?: InputMaybe<Array<DownlinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DownlinksOrderBy>>;
  where?: InputMaybe<DownlinksBoolExp>;
};


export type SubscriptionRootDownlinksAggregateArgs = {
  distinct_on?: InputMaybe<Array<DownlinksSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DownlinksOrderBy>>;
  where?: InputMaybe<DownlinksBoolExp>;
};


export type SubscriptionRootDownlinksByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootDownlinksStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DownlinksStreamCursorInput>>;
  where?: InputMaybe<DownlinksBoolExp>;
};


export type SubscriptionRootFarmingContainersArgs = {
  distinct_on?: InputMaybe<Array<FarmingContainersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FarmingContainersOrderBy>>;
  where?: InputMaybe<FarmingContainersBoolExp>;
};


export type SubscriptionRootFarmingContainersAggregateArgs = {
  distinct_on?: InputMaybe<Array<FarmingContainersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FarmingContainersOrderBy>>;
  where?: InputMaybe<FarmingContainersBoolExp>;
};


export type SubscriptionRootFarmingContainersByPkArgs = {
  value: Scalars['String'];
};


export type SubscriptionRootFarmingContainersStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<FarmingContainersStreamCursorInput>>;
  where?: InputMaybe<FarmingContainersBoolExp>;
};


export type SubscriptionRootFarmingMethodsArgs = {
  distinct_on?: InputMaybe<Array<FarmingMethodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FarmingMethodsOrderBy>>;
  where?: InputMaybe<FarmingMethodsBoolExp>;
};


export type SubscriptionRootFarmingMethodsAggregateArgs = {
  distinct_on?: InputMaybe<Array<FarmingMethodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FarmingMethodsOrderBy>>;
  where?: InputMaybe<FarmingMethodsBoolExp>;
};


export type SubscriptionRootFarmingMethodsByPkArgs = {
  value: Scalars['String'];
};


export type SubscriptionRootFarmingMethodsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<FarmingMethodsStreamCursorInput>>;
  where?: InputMaybe<FarmingMethodsBoolExp>;
};


export type SubscriptionRootFarmingStructuresArgs = {
  distinct_on?: InputMaybe<Array<FarmingStructuresSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FarmingStructuresOrderBy>>;
  where?: InputMaybe<FarmingStructuresBoolExp>;
};


export type SubscriptionRootFarmingStructuresAggregateArgs = {
  distinct_on?: InputMaybe<Array<FarmingStructuresSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<FarmingStructuresOrderBy>>;
  where?: InputMaybe<FarmingStructuresBoolExp>;
};


export type SubscriptionRootFarmingStructuresByPkArgs = {
  value: Scalars['String'];
};


export type SubscriptionRootFarmingStructuresStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<FarmingStructuresStreamCursorInput>>;
  where?: InputMaybe<FarmingStructuresBoolExp>;
};


export type SubscriptionRootNotificationEventTypesArgs = {
  distinct_on?: InputMaybe<Array<NotificationEventTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationEventTypesOrderBy>>;
  where?: InputMaybe<NotificationEventTypesBoolExp>;
};


export type SubscriptionRootNotificationEventTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationEventTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationEventTypesOrderBy>>;
  where?: InputMaybe<NotificationEventTypesBoolExp>;
};


export type SubscriptionRootNotificationEventTypesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootNotificationEventTypesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<NotificationEventTypesStreamCursorInput>>;
  where?: InputMaybe<NotificationEventTypesBoolExp>;
};


export type SubscriptionRootNotificationKindsArgs = {
  distinct_on?: InputMaybe<Array<NotificationKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationKindsOrderBy>>;
  where?: InputMaybe<NotificationKindsBoolExp>;
};


export type SubscriptionRootNotificationKindsAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationKindsOrderBy>>;
  where?: InputMaybe<NotificationKindsBoolExp>;
};


export type SubscriptionRootNotificationKindsByPkArgs = {
  value: Scalars['String'];
};


export type SubscriptionRootNotificationKindsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<NotificationKindsStreamCursorInput>>;
  where?: InputMaybe<NotificationKindsBoolExp>;
};


export type SubscriptionRootNotificationUserDevicesArgs = {
  distinct_on?: InputMaybe<Array<NotificationUserDevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationUserDevicesOrderBy>>;
  where?: InputMaybe<NotificationUserDevicesBoolExp>;
};


export type SubscriptionRootNotificationUserDevicesEventTypesArgs = {
  distinct_on?: InputMaybe<Array<NotificationUserDevicesEventTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationUserDevicesEventTypesOrderBy>>;
  where?: InputMaybe<NotificationUserDevicesEventTypesBoolExp>;
};


export type SubscriptionRootNotificationUserDevicesEventTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationUserDevicesEventTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationUserDevicesEventTypesOrderBy>>;
  where?: InputMaybe<NotificationUserDevicesEventTypesBoolExp>;
};


export type SubscriptionRootNotificationUserDevicesEventTypesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootNotificationUserDevicesEventTypesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<NotificationUserDevicesEventTypesStreamCursorInput>>;
  where?: InputMaybe<NotificationUserDevicesEventTypesBoolExp>;
};


export type SubscriptionRootNotificationUserDevicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationUserDevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationUserDevicesOrderBy>>;
  where?: InputMaybe<NotificationUserDevicesBoolExp>;
};


export type SubscriptionRootNotificationUserDevicesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootNotificationUserDevicesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<NotificationUserDevicesStreamCursorInput>>;
  where?: InputMaybe<NotificationUserDevicesBoolExp>;
};


export type SubscriptionRootNotificationUserSettingsArgs = {
  distinct_on?: InputMaybe<Array<NotificationUserSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationUserSettingsOrderBy>>;
  where?: InputMaybe<NotificationUserSettingsBoolExp>;
};


export type SubscriptionRootNotificationUserSettingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationUserSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationUserSettingsOrderBy>>;
  where?: InputMaybe<NotificationUserSettingsBoolExp>;
};


export type SubscriptionRootNotificationUserSettingsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootNotificationUserSettingsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<NotificationUserSettingsStreamCursorInput>>;
  where?: InputMaybe<NotificationUserSettingsBoolExp>;
};


export type SubscriptionRootNotificationsArgs = {
  distinct_on?: InputMaybe<Array<NotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationsOrderBy>>;
  where?: InputMaybe<NotificationsBoolExp>;
};


export type SubscriptionRootNotificationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationsOrderBy>>;
  where?: InputMaybe<NotificationsBoolExp>;
};


export type SubscriptionRootNotificationsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootNotificationsContentArgs = {
  distinct_on?: InputMaybe<Array<NotificationsContentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationsContentOrderBy>>;
  where?: InputMaybe<NotificationsContentBoolExp>;
};


export type SubscriptionRootNotificationsContentAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationsContentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationsContentOrderBy>>;
  where?: InputMaybe<NotificationsContentBoolExp>;
};


export type SubscriptionRootNotificationsContentByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootNotificationsContentStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<NotificationsContentStreamCursorInput>>;
  where?: InputMaybe<NotificationsContentBoolExp>;
};


export type SubscriptionRootNotificationsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<NotificationsStreamCursorInput>>;
  where?: InputMaybe<NotificationsBoolExp>;
};


export type SubscriptionRootOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<OrganizationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationsOrderBy>>;
  where?: InputMaybe<OrganizationsBoolExp>;
};


export type SubscriptionRootOrganizationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<OrganizationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationsOrderBy>>;
  where?: InputMaybe<OrganizationsBoolExp>;
};


export type SubscriptionRootOrganizationsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootOrganizationsChatParamsArgs = {
  distinct_on?: InputMaybe<Array<OrganizationsChatParamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationsChatParamsOrderBy>>;
  where?: InputMaybe<OrganizationsChatParamsBoolExp>;
};


export type SubscriptionRootOrganizationsChatParamsAggregateArgs = {
  distinct_on?: InputMaybe<Array<OrganizationsChatParamsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationsChatParamsOrderBy>>;
  where?: InputMaybe<OrganizationsChatParamsBoolExp>;
};


export type SubscriptionRootOrganizationsChatParamsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootOrganizationsChatParamsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<OrganizationsChatParamsStreamCursorInput>>;
  where?: InputMaybe<OrganizationsChatParamsBoolExp>;
};


export type SubscriptionRootOrganizationsFeatureLimitsArgs = {
  distinct_on?: InputMaybe<Array<OrganizationsFeatureLimitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationsFeatureLimitsOrderBy>>;
  where?: InputMaybe<OrganizationsFeatureLimitsBoolExp>;
};


export type SubscriptionRootOrganizationsFeatureLimitsAggregateArgs = {
  distinct_on?: InputMaybe<Array<OrganizationsFeatureLimitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationsFeatureLimitsOrderBy>>;
  where?: InputMaybe<OrganizationsFeatureLimitsBoolExp>;
};


export type SubscriptionRootOrganizationsFeatureLimitsByPkArgs = {
  id: Scalars['Int'];
  organization_id: Scalars['Int'];
};


export type SubscriptionRootOrganizationsFeatureLimitsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<OrganizationsFeatureLimitsStreamCursorInput>>;
  where?: InputMaybe<OrganizationsFeatureLimitsBoolExp>;
};


export type SubscriptionRootOrganizationsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<OrganizationsStreamCursorInput>>;
  where?: InputMaybe<OrganizationsBoolExp>;
};


export type SubscriptionRootOrganizationsUsersUsersOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<OrganizationsUsersUsersOrganizationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationsUsersUsersOrganizationsOrderBy>>;
  where?: InputMaybe<OrganizationsUsersUsersOrganizationsBoolExp>;
};


export type SubscriptionRootOrganizationsUsersUsersOrganizationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<OrganizationsUsersUsersOrganizationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationsUsersUsersOrganizationsOrderBy>>;
  where?: InputMaybe<OrganizationsUsersUsersOrganizationsBoolExp>;
};


export type SubscriptionRootOrganizationsUsersUsersOrganizationsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootOrganizationsUsersUsersOrganizationsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<OrganizationsUsersUsersOrganizationsStreamCursorInput>>;
  where?: InputMaybe<OrganizationsUsersUsersOrganizationsBoolExp>;
};


export type SubscriptionRootSceneFeedbackWaitsArgs = {
  distinct_on?: InputMaybe<Array<SceneFeedbackWaitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SceneFeedbackWaitsOrderBy>>;
  where?: InputMaybe<SceneFeedbackWaitsBoolExp>;
};


export type SubscriptionRootSceneFeedbackWaitsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SceneFeedbackWaitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SceneFeedbackWaitsOrderBy>>;
  where?: InputMaybe<SceneFeedbackWaitsBoolExp>;
};


export type SubscriptionRootSceneFeedbackWaitsByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootSceneFeedbackWaitsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SceneFeedbackWaitsStreamCursorInput>>;
  where?: InputMaybe<SceneFeedbackWaitsBoolExp>;
};


export type SubscriptionRootSceneScheduledExecutionsArgs = {
  distinct_on?: InputMaybe<Array<SceneScheduledExecutionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SceneScheduledExecutionsOrderBy>>;
  where?: InputMaybe<SceneScheduledExecutionsBoolExp>;
};


export type SubscriptionRootSceneScheduledExecutionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SceneScheduledExecutionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SceneScheduledExecutionsOrderBy>>;
  where?: InputMaybe<SceneScheduledExecutionsBoolExp>;
};


export type SubscriptionRootSceneScheduledExecutionsByPkArgs = {
  id: Scalars['bigint'];
};


export type SubscriptionRootSceneScheduledExecutionsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SceneScheduledExecutionsStreamCursorInput>>;
  where?: InputMaybe<SceneScheduledExecutionsBoolExp>;
};


export type SubscriptionRootSceneTimingExecutionKindsArgs = {
  distinct_on?: InputMaybe<Array<SceneTimingExecutionKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SceneTimingExecutionKindsOrderBy>>;
  where?: InputMaybe<SceneTimingExecutionKindsBoolExp>;
};


export type SubscriptionRootSceneTimingExecutionKindsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SceneTimingExecutionKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SceneTimingExecutionKindsOrderBy>>;
  where?: InputMaybe<SceneTimingExecutionKindsBoolExp>;
};


export type SubscriptionRootSceneTimingExecutionKindsByPkArgs = {
  value: Scalars['String'];
};


export type SubscriptionRootSceneTimingExecutionKindsStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SceneTimingExecutionKindsStreamCursorInput>>;
  where?: InputMaybe<SceneTimingExecutionKindsBoolExp>;
};


export type SubscriptionRootScenesArgs = {
  distinct_on?: InputMaybe<Array<ScenesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ScenesOrderBy>>;
  where?: InputMaybe<ScenesBoolExp>;
};


export type SubscriptionRootScenesDevicesArgs = {
  distinct_on?: InputMaybe<Array<ScenesDevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ScenesDevicesOrderBy>>;
  where?: InputMaybe<ScenesDevicesBoolExp>;
};


export type SubscriptionRootScenesDevicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ScenesDevicesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ScenesDevicesOrderBy>>;
  where?: InputMaybe<ScenesDevicesBoolExp>;
};


export type SubscriptionRootScenesDevicesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootScenesDevicesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ScenesDevicesStreamCursorInput>>;
  where?: InputMaybe<ScenesDevicesBoolExp>;
};


export type SubscriptionRootScenesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ScenesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ScenesOrderBy>>;
  where?: InputMaybe<ScenesBoolExp>;
};


export type SubscriptionRootScenesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootScenesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ScenesStreamCursorInput>>;
  where?: InputMaybe<ScenesBoolExp>;
};


export type SubscriptionRootSubstratesArgs = {
  distinct_on?: InputMaybe<Array<SubstratesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SubstratesOrderBy>>;
  where?: InputMaybe<SubstratesBoolExp>;
};


export type SubscriptionRootSubstratesAggregateArgs = {
  distinct_on?: InputMaybe<Array<SubstratesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SubstratesOrderBy>>;
  where?: InputMaybe<SubstratesBoolExp>;
};


export type SubscriptionRootSubstratesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootSubstratesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SubstratesStreamCursorInput>>;
  where?: InputMaybe<SubstratesBoolExp>;
};


export type SubscriptionRootTelegramUsersArgs = {
  distinct_on?: InputMaybe<Array<TelegramUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TelegramUsersOrderBy>>;
  where?: InputMaybe<TelegramUsersBoolExp>;
};


export type SubscriptionRootTelegramUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<TelegramUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TelegramUsersOrderBy>>;
  where?: InputMaybe<TelegramUsersBoolExp>;
};


export type SubscriptionRootTelegramUsersByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootTelegramUsersStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TelegramUsersStreamCursorInput>>;
  where?: InputMaybe<TelegramUsersBoolExp>;
};


export type SubscriptionRootUplinkDynamoRefArgs = {
  distinct_on?: InputMaybe<Array<UplinkDynamoRefSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UplinkDynamoRefOrderBy>>;
  where?: InputMaybe<UplinkDynamoRefBoolExp>;
};


export type SubscriptionRootUplinkDynamoRefAggregateArgs = {
  distinct_on?: InputMaybe<Array<UplinkDynamoRefSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UplinkDynamoRefOrderBy>>;
  where?: InputMaybe<UplinkDynamoRefBoolExp>;
};


export type SubscriptionRootUplinkDynamoRefByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootUplinkDynamoRefStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UplinkDynamoRefStreamCursorInput>>;
  where?: InputMaybe<UplinkDynamoRefBoolExp>;
};


export type SubscriptionRootUserRolesArgs = {
  distinct_on?: InputMaybe<Array<UserRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserRolesOrderBy>>;
  where?: InputMaybe<UserRolesBoolExp>;
};


export type SubscriptionRootUserRolesUsersPermissionsUserArgs = {
  distinct_on?: InputMaybe<Array<UserRolesUsersPermissionsUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserRolesUsersPermissionsUserOrderBy>>;
  where?: InputMaybe<UserRolesUsersPermissionsUserBoolExp>;
};


export type SubscriptionRootUserRolesUsersPermissionsUserAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRolesUsersPermissionsUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserRolesUsersPermissionsUserOrderBy>>;
  where?: InputMaybe<UserRolesUsersPermissionsUserBoolExp>;
};


export type SubscriptionRootUserRolesUsersPermissionsUserByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootUserRolesUsersPermissionsUserStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UserRolesUsersPermissionsUserStreamCursorInput>>;
  where?: InputMaybe<UserRolesUsersPermissionsUserBoolExp>;
};


export type SubscriptionRootUserRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserRolesOrderBy>>;
  where?: InputMaybe<UserRolesBoolExp>;
};


export type SubscriptionRootUserRolesByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootUserRolesStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UserRolesStreamCursorInput>>;
  where?: InputMaybe<UserRolesBoolExp>;
};


export type SubscriptionRootUsersPermissionsUserArgs = {
  distinct_on?: InputMaybe<Array<UsersPermissionsUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersPermissionsUserOrderBy>>;
  where?: InputMaybe<UsersPermissionsUserBoolExp>;
};


export type SubscriptionRootUsersPermissionsUserAggregateArgs = {
  distinct_on?: InputMaybe<Array<UsersPermissionsUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersPermissionsUserOrderBy>>;
  where?: InputMaybe<UsersPermissionsUserBoolExp>;
};


export type SubscriptionRootUsersPermissionsUserByPkArgs = {
  id: Scalars['Int'];
};


export type SubscriptionRootUsersPermissionsUserStreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UsersPermissionsUserStreamCursorInput>>;
  where?: InputMaybe<UsersPermissionsUserBoolExp>;
};

/** Soilless substrates */
export type Substrates = {
  __typename?: 'substrates';
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  name: Scalars['String'];
  slug: Scalars['String'];
  total_porosity_percentage: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  vwc_0_kpa: Scalars['numeric'];
  vwc_minus_1_kpa: Scalars['numeric'];
  vwc_minus_3_kpa: Scalars['numeric'];
  vwc_minus_5_kpa: Scalars['numeric'];
  vwc_minus_10_kpa: Scalars['numeric'];
  vwc_minus_15_kpa?: Maybe<Scalars['numeric']>;
  vwc_minus_20_kpa?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "substrates" */
export type SubstratesAggregate = {
  __typename?: 'substrates_aggregate';
  aggregate?: Maybe<SubstratesAggregateFields>;
  nodes: Array<Substrates>;
};

/** aggregate fields of "substrates" */
export type SubstratesAggregateFields = {
  __typename?: 'substrates_aggregate_fields';
  avg?: Maybe<SubstratesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<SubstratesMaxFields>;
  min?: Maybe<SubstratesMinFields>;
  stddev?: Maybe<SubstratesStddevFields>;
  stddev_pop?: Maybe<SubstratesStddevPopFields>;
  stddev_samp?: Maybe<SubstratesStddevSampFields>;
  sum?: Maybe<SubstratesSumFields>;
  var_pop?: Maybe<SubstratesVarPopFields>;
  var_samp?: Maybe<SubstratesVarSampFields>;
  variance?: Maybe<SubstratesVarianceFields>;
};


/** aggregate fields of "substrates" */
export type SubstratesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SubstratesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type SubstratesAvgFields = {
  __typename?: 'substrates_avg_fields';
  id?: Maybe<Scalars['Float']>;
  total_porosity_percentage?: Maybe<Scalars['Float']>;
  vwc_0_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_1_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_3_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_5_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_10_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_15_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_20_kpa?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "substrates". All fields are combined with a logical 'AND'. */
export type SubstratesBoolExp = {
  _and?: InputMaybe<Array<SubstratesBoolExp>>;
  _not?: InputMaybe<SubstratesBoolExp>;
  _or?: InputMaybe<Array<SubstratesBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  total_porosity_percentage?: InputMaybe<IntComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  vwc_0_kpa?: InputMaybe<NumericComparisonExp>;
  vwc_minus_1_kpa?: InputMaybe<NumericComparisonExp>;
  vwc_minus_3_kpa?: InputMaybe<NumericComparisonExp>;
  vwc_minus_5_kpa?: InputMaybe<NumericComparisonExp>;
  vwc_minus_10_kpa?: InputMaybe<NumericComparisonExp>;
  vwc_minus_15_kpa?: InputMaybe<NumericComparisonExp>;
  vwc_minus_20_kpa?: InputMaybe<NumericComparisonExp>;
};

/** unique or primary key constraints on table "substrates" */
export enum SubstratesConstraint {
  /** unique or primary key constraint on columns "name" */
  SUBSTRATES_NAME_KEY = 'substrates_name_key',
  /** unique or primary key constraint on columns "id" */
  SUBSTRATES_PKEY = 'substrates_pkey',
  /** unique or primary key constraint on columns "slug" */
  SUBSTRATES_SLUG_KEY = 'substrates_slug_key'
}

/** input type for incrementing numeric columns in table "substrates" */
export type SubstratesIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  total_porosity_percentage?: InputMaybe<Scalars['Int']>;
  vwc_0_kpa?: InputMaybe<Scalars['numeric']>;
  vwc_minus_1_kpa?: InputMaybe<Scalars['numeric']>;
  vwc_minus_3_kpa?: InputMaybe<Scalars['numeric']>;
  vwc_minus_5_kpa?: InputMaybe<Scalars['numeric']>;
  vwc_minus_10_kpa?: InputMaybe<Scalars['numeric']>;
  vwc_minus_15_kpa?: InputMaybe<Scalars['numeric']>;
  vwc_minus_20_kpa?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "substrates" */
export type SubstratesInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  total_porosity_percentage?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  vwc_0_kpa?: InputMaybe<Scalars['numeric']>;
  vwc_minus_1_kpa?: InputMaybe<Scalars['numeric']>;
  vwc_minus_3_kpa?: InputMaybe<Scalars['numeric']>;
  vwc_minus_5_kpa?: InputMaybe<Scalars['numeric']>;
  vwc_minus_10_kpa?: InputMaybe<Scalars['numeric']>;
  vwc_minus_15_kpa?: InputMaybe<Scalars['numeric']>;
  vwc_minus_20_kpa?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type SubstratesMaxFields = {
  __typename?: 'substrates_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  total_porosity_percentage?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vwc_0_kpa?: Maybe<Scalars['numeric']>;
  vwc_minus_1_kpa?: Maybe<Scalars['numeric']>;
  vwc_minus_3_kpa?: Maybe<Scalars['numeric']>;
  vwc_minus_5_kpa?: Maybe<Scalars['numeric']>;
  vwc_minus_10_kpa?: Maybe<Scalars['numeric']>;
  vwc_minus_15_kpa?: Maybe<Scalars['numeric']>;
  vwc_minus_20_kpa?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type SubstratesMinFields = {
  __typename?: 'substrates_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  total_porosity_percentage?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vwc_0_kpa?: Maybe<Scalars['numeric']>;
  vwc_minus_1_kpa?: Maybe<Scalars['numeric']>;
  vwc_minus_3_kpa?: Maybe<Scalars['numeric']>;
  vwc_minus_5_kpa?: Maybe<Scalars['numeric']>;
  vwc_minus_10_kpa?: Maybe<Scalars['numeric']>;
  vwc_minus_15_kpa?: Maybe<Scalars['numeric']>;
  vwc_minus_20_kpa?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "substrates" */
export type SubstratesMutationResponse = {
  __typename?: 'substrates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Substrates>;
};

/** input type for inserting object relation for remote table "substrates" */
export type SubstratesObjRelInsertInput = {
  data: SubstratesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<SubstratesOnConflict>;
};

/** on_conflict condition type for table "substrates" */
export type SubstratesOnConflict = {
  constraint: SubstratesConstraint;
  update_columns?: Array<SubstratesUpdateColumn>;
  where?: InputMaybe<SubstratesBoolExp>;
};

/** Ordering options when selecting data from "substrates". */
export type SubstratesOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  total_porosity_percentage?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  vwc_0_kpa?: InputMaybe<OrderBy>;
  vwc_minus_1_kpa?: InputMaybe<OrderBy>;
  vwc_minus_3_kpa?: InputMaybe<OrderBy>;
  vwc_minus_5_kpa?: InputMaybe<OrderBy>;
  vwc_minus_10_kpa?: InputMaybe<OrderBy>;
  vwc_minus_15_kpa?: InputMaybe<OrderBy>;
  vwc_minus_20_kpa?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: substrates */
export type SubstratesPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "substrates" */
export enum SubstratesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  SLUG = 'slug',
  /** column name */
  TOTAL_POROSITY_PERCENTAGE = 'total_porosity_percentage',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  VWC_0_KPA = 'vwc_0_kpa',
  /** column name */
  VWC_MINUS_1_KPA = 'vwc_minus_1_kpa',
  /** column name */
  VWC_MINUS_3_KPA = 'vwc_minus_3_kpa',
  /** column name */
  VWC_MINUS_5_KPA = 'vwc_minus_5_kpa',
  /** column name */
  VWC_MINUS_10_KPA = 'vwc_minus_10_kpa',
  /** column name */
  VWC_MINUS_15_KPA = 'vwc_minus_15_kpa',
  /** column name */
  VWC_MINUS_20_KPA = 'vwc_minus_20_kpa'
}

/** input type for updating data in table "substrates" */
export type SubstratesSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  total_porosity_percentage?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  vwc_0_kpa?: InputMaybe<Scalars['numeric']>;
  vwc_minus_1_kpa?: InputMaybe<Scalars['numeric']>;
  vwc_minus_3_kpa?: InputMaybe<Scalars['numeric']>;
  vwc_minus_5_kpa?: InputMaybe<Scalars['numeric']>;
  vwc_minus_10_kpa?: InputMaybe<Scalars['numeric']>;
  vwc_minus_15_kpa?: InputMaybe<Scalars['numeric']>;
  vwc_minus_20_kpa?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type SubstratesStddevFields = {
  __typename?: 'substrates_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  total_porosity_percentage?: Maybe<Scalars['Float']>;
  vwc_0_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_1_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_3_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_5_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_10_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_15_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_20_kpa?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SubstratesStddevPopFields = {
  __typename?: 'substrates_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  total_porosity_percentage?: Maybe<Scalars['Float']>;
  vwc_0_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_1_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_3_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_5_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_10_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_15_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_20_kpa?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SubstratesStddevSampFields = {
  __typename?: 'substrates_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  total_porosity_percentage?: Maybe<Scalars['Float']>;
  vwc_0_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_1_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_3_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_5_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_10_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_15_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_20_kpa?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "substrates" */
export type SubstratesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: SubstratesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SubstratesStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  total_porosity_percentage?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  vwc_0_kpa?: InputMaybe<Scalars['numeric']>;
  vwc_minus_1_kpa?: InputMaybe<Scalars['numeric']>;
  vwc_minus_3_kpa?: InputMaybe<Scalars['numeric']>;
  vwc_minus_5_kpa?: InputMaybe<Scalars['numeric']>;
  vwc_minus_10_kpa?: InputMaybe<Scalars['numeric']>;
  vwc_minus_15_kpa?: InputMaybe<Scalars['numeric']>;
  vwc_minus_20_kpa?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type SubstratesSumFields = {
  __typename?: 'substrates_sum_fields';
  id?: Maybe<Scalars['Int']>;
  total_porosity_percentage?: Maybe<Scalars['Int']>;
  vwc_0_kpa?: Maybe<Scalars['numeric']>;
  vwc_minus_1_kpa?: Maybe<Scalars['numeric']>;
  vwc_minus_3_kpa?: Maybe<Scalars['numeric']>;
  vwc_minus_5_kpa?: Maybe<Scalars['numeric']>;
  vwc_minus_10_kpa?: Maybe<Scalars['numeric']>;
  vwc_minus_15_kpa?: Maybe<Scalars['numeric']>;
  vwc_minus_20_kpa?: Maybe<Scalars['numeric']>;
};

/** update columns of table "substrates" */
export enum SubstratesUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  SLUG = 'slug',
  /** column name */
  TOTAL_POROSITY_PERCENTAGE = 'total_porosity_percentage',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  VWC_0_KPA = 'vwc_0_kpa',
  /** column name */
  VWC_MINUS_1_KPA = 'vwc_minus_1_kpa',
  /** column name */
  VWC_MINUS_3_KPA = 'vwc_minus_3_kpa',
  /** column name */
  VWC_MINUS_5_KPA = 'vwc_minus_5_kpa',
  /** column name */
  VWC_MINUS_10_KPA = 'vwc_minus_10_kpa',
  /** column name */
  VWC_MINUS_15_KPA = 'vwc_minus_15_kpa',
  /** column name */
  VWC_MINUS_20_KPA = 'vwc_minus_20_kpa'
}

export type SubstratesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SubstratesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SubstratesSetInput>;
  /** filter the rows which have to be updated */
  where: SubstratesBoolExp;
};

/** aggregate var_pop on columns */
export type SubstratesVarPopFields = {
  __typename?: 'substrates_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  total_porosity_percentage?: Maybe<Scalars['Float']>;
  vwc_0_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_1_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_3_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_5_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_10_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_15_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_20_kpa?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SubstratesVarSampFields = {
  __typename?: 'substrates_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  total_porosity_percentage?: Maybe<Scalars['Float']>;
  vwc_0_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_1_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_3_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_5_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_10_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_15_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_20_kpa?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SubstratesVarianceFields = {
  __typename?: 'substrates_variance_fields';
  id?: Maybe<Scalars['Float']>;
  total_porosity_percentage?: Maybe<Scalars['Float']>;
  vwc_0_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_1_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_3_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_5_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_10_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_15_kpa?: Maybe<Scalars['Float']>;
  vwc_minus_20_kpa?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "telegram_users" */
export type TelegramUsers = {
  __typename?: 'telegram_users';
  active?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  lang?: Maybe<Scalars['String']>;
  telegram_id?: Maybe<Scalars['bigint']>;
  telegram_username: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
  /** An object relationship */
  user?: Maybe<UsersPermissionsUser>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "telegram_users" */
export type TelegramUsersAggregate = {
  __typename?: 'telegram_users_aggregate';
  aggregate?: Maybe<TelegramUsersAggregateFields>;
  nodes: Array<TelegramUsers>;
};

export type TelegramUsersAggregateBoolExp = {
  bool_and?: InputMaybe<TelegramUsersAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<TelegramUsersAggregateBoolExpBoolOr>;
  count?: InputMaybe<TelegramUsersAggregateBoolExpCount>;
};

export type TelegramUsersAggregateBoolExpBoolAnd = {
  arguments: TelegramUsersSelectColumnTelegramUsersAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TelegramUsersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type TelegramUsersAggregateBoolExpBoolOr = {
  arguments: TelegramUsersSelectColumnTelegramUsersAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TelegramUsersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type TelegramUsersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TelegramUsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TelegramUsersBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "telegram_users" */
export type TelegramUsersAggregateFields = {
  __typename?: 'telegram_users_aggregate_fields';
  avg?: Maybe<TelegramUsersAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<TelegramUsersMaxFields>;
  min?: Maybe<TelegramUsersMinFields>;
  stddev?: Maybe<TelegramUsersStddevFields>;
  stddev_pop?: Maybe<TelegramUsersStddevPopFields>;
  stddev_samp?: Maybe<TelegramUsersStddevSampFields>;
  sum?: Maybe<TelegramUsersSumFields>;
  var_pop?: Maybe<TelegramUsersVarPopFields>;
  var_samp?: Maybe<TelegramUsersVarSampFields>;
  variance?: Maybe<TelegramUsersVarianceFields>;
};


/** aggregate fields of "telegram_users" */
export type TelegramUsersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TelegramUsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "telegram_users" */
export type TelegramUsersAggregateOrderBy = {
  avg?: InputMaybe<TelegramUsersAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<TelegramUsersMaxOrderBy>;
  min?: InputMaybe<TelegramUsersMinOrderBy>;
  stddev?: InputMaybe<TelegramUsersStddevOrderBy>;
  stddev_pop?: InputMaybe<TelegramUsersStddevPopOrderBy>;
  stddev_samp?: InputMaybe<TelegramUsersStddevSampOrderBy>;
  sum?: InputMaybe<TelegramUsersSumOrderBy>;
  var_pop?: InputMaybe<TelegramUsersVarPopOrderBy>;
  var_samp?: InputMaybe<TelegramUsersVarSampOrderBy>;
  variance?: InputMaybe<TelegramUsersVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "telegram_users" */
export type TelegramUsersArrRelInsertInput = {
  data: Array<TelegramUsersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<TelegramUsersOnConflict>;
};

/** aggregate avg on columns */
export type TelegramUsersAvgFields = {
  __typename?: 'telegram_users_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  telegram_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "telegram_users" */
export type TelegramUsersAvgOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  telegram_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "telegram_users". All fields are combined with a logical 'AND'. */
export type TelegramUsersBoolExp = {
  _and?: InputMaybe<Array<TelegramUsersBoolExp>>;
  _not?: InputMaybe<TelegramUsersBoolExp>;
  _or?: InputMaybe<Array<TelegramUsersBoolExp>>;
  active?: InputMaybe<BooleanComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  lang?: InputMaybe<StringComparisonExp>;
  telegram_id?: InputMaybe<BigintComparisonExp>;
  telegram_username?: InputMaybe<StringComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<IntComparisonExp>;
  user?: InputMaybe<UsersPermissionsUserBoolExp>;
  user_id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "telegram_users" */
export enum TelegramUsersConstraint {
  /** unique or primary key constraint on columns "id" */
  TELEGRAM_USERS_PKEY = 'telegram_users_pkey',
  /** unique or primary key constraint on columns "telegram_id" */
  TELEGRAM_USERS_TELEGRAMID_UNIQUE = 'telegram_users_telegramId_unique',
  /** unique or primary key constraint on columns "telegram_username" */
  TELEGRAM_USERS_TELEGRAMUSERNAME_UNIQUE = 'telegram_users_telegramUsername_unique'
}

/** input type for incrementing numeric columns in table "telegram_users" */
export type TelegramUsersIncInput = {
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  telegram_id?: InputMaybe<Scalars['bigint']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "telegram_users" */
export type TelegramUsersInsertInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  lang?: InputMaybe<Scalars['String']>;
  telegram_id?: InputMaybe<Scalars['bigint']>;
  telegram_username?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<UsersPermissionsUserObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type TelegramUsersMaxFields = {
  __typename?: 'telegram_users_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  lang?: Maybe<Scalars['String']>;
  telegram_id?: Maybe<Scalars['bigint']>;
  telegram_username?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "telegram_users" */
export type TelegramUsersMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lang?: InputMaybe<OrderBy>;
  telegram_id?: InputMaybe<OrderBy>;
  telegram_username?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type TelegramUsersMinFields = {
  __typename?: 'telegram_users_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  lang?: Maybe<Scalars['String']>;
  telegram_id?: Maybe<Scalars['bigint']>;
  telegram_username?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "telegram_users" */
export type TelegramUsersMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lang?: InputMaybe<OrderBy>;
  telegram_id?: InputMaybe<OrderBy>;
  telegram_username?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "telegram_users" */
export type TelegramUsersMutationResponse = {
  __typename?: 'telegram_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TelegramUsers>;
};

/** on_conflict condition type for table "telegram_users" */
export type TelegramUsersOnConflict = {
  constraint: TelegramUsersConstraint;
  update_columns?: Array<TelegramUsersUpdateColumn>;
  where?: InputMaybe<TelegramUsersBoolExp>;
};

/** Ordering options when selecting data from "telegram_users". */
export type TelegramUsersOrderBy = {
  active?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lang?: InputMaybe<OrderBy>;
  telegram_id?: InputMaybe<OrderBy>;
  telegram_username?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersPermissionsUserOrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: telegram_users */
export type TelegramUsersPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "telegram_users" */
export enum TelegramUsersSelectColumn {
  /** column name */
  ACTIVE = 'active',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  ID = 'id',
  /** column name */
  LANG = 'lang',
  /** column name */
  TELEGRAM_ID = 'telegram_id',
  /** column name */
  TELEGRAM_USERNAME = 'telegram_username',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by',
  /** column name */
  USER_ID = 'user_id'
}

/** select "telegram_users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "telegram_users" */
export enum TelegramUsersSelectColumnTelegramUsersAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  ACTIVE = 'active'
}

/** select "telegram_users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "telegram_users" */
export enum TelegramUsersSelectColumnTelegramUsersAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  ACTIVE = 'active'
}

/** input type for updating data in table "telegram_users" */
export type TelegramUsersSetInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  lang?: InputMaybe<Scalars['String']>;
  telegram_id?: InputMaybe<Scalars['bigint']>;
  telegram_username?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type TelegramUsersStddevFields = {
  __typename?: 'telegram_users_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  telegram_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "telegram_users" */
export type TelegramUsersStddevOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  telegram_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type TelegramUsersStddevPopFields = {
  __typename?: 'telegram_users_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  telegram_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "telegram_users" */
export type TelegramUsersStddevPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  telegram_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type TelegramUsersStddevSampFields = {
  __typename?: 'telegram_users_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  telegram_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "telegram_users" */
export type TelegramUsersStddevSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  telegram_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "telegram_users" */
export type TelegramUsersStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: TelegramUsersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TelegramUsersStreamCursorValueInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  lang?: InputMaybe<Scalars['String']>;
  telegram_id?: InputMaybe<Scalars['bigint']>;
  telegram_username?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type TelegramUsersSumFields = {
  __typename?: 'telegram_users_sum_fields';
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  telegram_id?: Maybe<Scalars['bigint']>;
  updated_by?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "telegram_users" */
export type TelegramUsersSumOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  telegram_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** update columns of table "telegram_users" */
export enum TelegramUsersUpdateColumn {
  /** column name */
  ACTIVE = 'active',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  ID = 'id',
  /** column name */
  LANG = 'lang',
  /** column name */
  TELEGRAM_ID = 'telegram_id',
  /** column name */
  TELEGRAM_USERNAME = 'telegram_username',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by',
  /** column name */
  USER_ID = 'user_id'
}

export type TelegramUsersUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TelegramUsersIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TelegramUsersSetInput>;
  /** filter the rows which have to be updated */
  where: TelegramUsersBoolExp;
};

/** aggregate var_pop on columns */
export type TelegramUsersVarPopFields = {
  __typename?: 'telegram_users_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  telegram_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "telegram_users" */
export type TelegramUsersVarPopOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  telegram_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type TelegramUsersVarSampFields = {
  __typename?: 'telegram_users_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  telegram_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "telegram_users" */
export type TelegramUsersVarSampOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  telegram_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type TelegramUsersVarianceFields = {
  __typename?: 'telegram_users_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  telegram_id?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "telegram_users" */
export type TelegramUsersVarianceOrderBy = {
  created_by?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  telegram_id?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type TimeComparisonExp = {
  _eq?: InputMaybe<Scalars['time']>;
  _gt?: InputMaybe<Scalars['time']>;
  _gte?: InputMaybe<Scalars['time']>;
  _in?: InputMaybe<Array<Scalars['time']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['time']>;
  _lte?: InputMaybe<Scalars['time']>;
  _neq?: InputMaybe<Scalars['time']>;
  _nin?: InputMaybe<Array<Scalars['time']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type TimestamptzComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** Uplink table for saving the ref id of the uplink saved on dynamo and trigger the other actions */
export type UplinkDynamoRef = {
  __typename?: 'uplink_dynamo_ref';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  device: Devices;
  device_id: Scalars['Int'];
  dynamo_id: Scalars['uuid'];
  id: Scalars['Int'];
  last_uplink_data: Scalars['jsonb'];
  updated_at: Scalars['timestamptz'];
};


/** Uplink table for saving the ref id of the uplink saved on dynamo and trigger the other actions */
export type UplinkDynamoRefLastUplinkDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "uplink_dynamo_ref" */
export type UplinkDynamoRefAggregate = {
  __typename?: 'uplink_dynamo_ref_aggregate';
  aggregate?: Maybe<UplinkDynamoRefAggregateFields>;
  nodes: Array<UplinkDynamoRef>;
};

/** aggregate fields of "uplink_dynamo_ref" */
export type UplinkDynamoRefAggregateFields = {
  __typename?: 'uplink_dynamo_ref_aggregate_fields';
  avg?: Maybe<UplinkDynamoRefAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<UplinkDynamoRefMaxFields>;
  min?: Maybe<UplinkDynamoRefMinFields>;
  stddev?: Maybe<UplinkDynamoRefStddevFields>;
  stddev_pop?: Maybe<UplinkDynamoRefStddevPopFields>;
  stddev_samp?: Maybe<UplinkDynamoRefStddevSampFields>;
  sum?: Maybe<UplinkDynamoRefSumFields>;
  var_pop?: Maybe<UplinkDynamoRefVarPopFields>;
  var_samp?: Maybe<UplinkDynamoRefVarSampFields>;
  variance?: Maybe<UplinkDynamoRefVarianceFields>;
};


/** aggregate fields of "uplink_dynamo_ref" */
export type UplinkDynamoRefAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UplinkDynamoRefSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type UplinkDynamoRefAppendInput = {
  last_uplink_data?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type UplinkDynamoRefAvgFields = {
  __typename?: 'uplink_dynamo_ref_avg_fields';
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "uplink_dynamo_ref". All fields are combined with a logical 'AND'. */
export type UplinkDynamoRefBoolExp = {
  _and?: InputMaybe<Array<UplinkDynamoRefBoolExp>>;
  _not?: InputMaybe<UplinkDynamoRefBoolExp>;
  _or?: InputMaybe<Array<UplinkDynamoRefBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  device?: InputMaybe<DevicesBoolExp>;
  device_id?: InputMaybe<IntComparisonExp>;
  dynamo_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  last_uplink_data?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "uplink_dynamo_ref" */
export enum UplinkDynamoRefConstraint {
  /** unique or primary key constraint on columns "id" */
  UPLINK_DYNAMO_REF_PKEY = 'uplink_dynamo_ref_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type UplinkDynamoRefDeleteAtPathInput = {
  last_uplink_data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type UplinkDynamoRefDeleteElemInput = {
  last_uplink_data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type UplinkDynamoRefDeleteKeyInput = {
  last_uplink_data?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "uplink_dynamo_ref" */
export type UplinkDynamoRefIncInput = {
  device_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "uplink_dynamo_ref" */
export type UplinkDynamoRefInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device?: InputMaybe<DevicesObjRelInsertInput>;
  device_id?: InputMaybe<Scalars['Int']>;
  dynamo_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  last_uplink_data?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type UplinkDynamoRefMaxFields = {
  __typename?: 'uplink_dynamo_ref_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  device_id?: Maybe<Scalars['Int']>;
  dynamo_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type UplinkDynamoRefMinFields = {
  __typename?: 'uplink_dynamo_ref_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  device_id?: Maybe<Scalars['Int']>;
  dynamo_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "uplink_dynamo_ref" */
export type UplinkDynamoRefMutationResponse = {
  __typename?: 'uplink_dynamo_ref_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UplinkDynamoRef>;
};

/** on_conflict condition type for table "uplink_dynamo_ref" */
export type UplinkDynamoRefOnConflict = {
  constraint: UplinkDynamoRefConstraint;
  update_columns?: Array<UplinkDynamoRefUpdateColumn>;
  where?: InputMaybe<UplinkDynamoRefBoolExp>;
};

/** Ordering options when selecting data from "uplink_dynamo_ref". */
export type UplinkDynamoRefOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  device?: InputMaybe<DevicesOrderBy>;
  device_id?: InputMaybe<OrderBy>;
  dynamo_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  last_uplink_data?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: uplink_dynamo_ref */
export type UplinkDynamoRefPkColumnsInput = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type UplinkDynamoRefPrependInput = {
  last_uplink_data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "uplink_dynamo_ref" */
export enum UplinkDynamoRefSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEVICE_ID = 'device_id',
  /** column name */
  DYNAMO_ID = 'dynamo_id',
  /** column name */
  ID = 'id',
  /** column name */
  LAST_UPLINK_DATA = 'last_uplink_data',
  /** column name */
  UPDATED_AT = 'updated_at'
}

/** input type for updating data in table "uplink_dynamo_ref" */
export type UplinkDynamoRefSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device_id?: InputMaybe<Scalars['Int']>;
  dynamo_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  last_uplink_data?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type UplinkDynamoRefStddevFields = {
  __typename?: 'uplink_dynamo_ref_stddev_fields';
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type UplinkDynamoRefStddevPopFields = {
  __typename?: 'uplink_dynamo_ref_stddev_pop_fields';
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type UplinkDynamoRefStddevSampFields = {
  __typename?: 'uplink_dynamo_ref_stddev_samp_fields';
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "uplink_dynamo_ref" */
export type UplinkDynamoRefStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: UplinkDynamoRefStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UplinkDynamoRefStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  device_id?: InputMaybe<Scalars['Int']>;
  dynamo_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  last_uplink_data?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type UplinkDynamoRefSumFields = {
  __typename?: 'uplink_dynamo_ref_sum_fields';
  device_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "uplink_dynamo_ref" */
export enum UplinkDynamoRefUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEVICE_ID = 'device_id',
  /** column name */
  DYNAMO_ID = 'dynamo_id',
  /** column name */
  ID = 'id',
  /** column name */
  LAST_UPLINK_DATA = 'last_uplink_data',
  /** column name */
  UPDATED_AT = 'updated_at'
}

export type UplinkDynamoRefUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<UplinkDynamoRefAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<UplinkDynamoRefDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<UplinkDynamoRefDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<UplinkDynamoRefDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UplinkDynamoRefIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<UplinkDynamoRefPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UplinkDynamoRefSetInput>;
  /** filter the rows which have to be updated */
  where: UplinkDynamoRefBoolExp;
};

/** aggregate var_pop on columns */
export type UplinkDynamoRefVarPopFields = {
  __typename?: 'uplink_dynamo_ref_var_pop_fields';
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type UplinkDynamoRefVarSampFields = {
  __typename?: 'uplink_dynamo_ref_var_samp_fields';
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type UplinkDynamoRefVarianceFields = {
  __typename?: 'uplink_dynamo_ref_variance_fields';
  device_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "user_roles" */
export type UserRoles = {
  __typename?: 'user_roles';
  description: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  type: Scalars['String'];
};

/** columns and relationships of "user_roles__users_permissions_user" */
export type UserRolesUsersPermissionsUser = {
  __typename?: 'user_roles__users_permissions_user';
  id: Scalars['Int'];
  user_id: Scalars['Int'];
  /** An object relationship */
  user_role: UserRoles;
  user_roles_id: Scalars['Int'];
};

/** aggregated selection of "user_roles__users_permissions_user" */
export type UserRolesUsersPermissionsUserAggregate = {
  __typename?: 'user_roles__users_permissions_user_aggregate';
  aggregate?: Maybe<UserRolesUsersPermissionsUserAggregateFields>;
  nodes: Array<UserRolesUsersPermissionsUser>;
};

export type UserRolesUsersPermissionsUserAggregateBoolExp = {
  count?: InputMaybe<UserRolesUsersPermissionsUserAggregateBoolExpCount>;
};

export type UserRolesUsersPermissionsUserAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserRolesUsersPermissionsUserSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UserRolesUsersPermissionsUserBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "user_roles__users_permissions_user" */
export type UserRolesUsersPermissionsUserAggregateFields = {
  __typename?: 'user_roles__users_permissions_user_aggregate_fields';
  avg?: Maybe<UserRolesUsersPermissionsUserAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<UserRolesUsersPermissionsUserMaxFields>;
  min?: Maybe<UserRolesUsersPermissionsUserMinFields>;
  stddev?: Maybe<UserRolesUsersPermissionsUserStddevFields>;
  stddev_pop?: Maybe<UserRolesUsersPermissionsUserStddevPopFields>;
  stddev_samp?: Maybe<UserRolesUsersPermissionsUserStddevSampFields>;
  sum?: Maybe<UserRolesUsersPermissionsUserSumFields>;
  var_pop?: Maybe<UserRolesUsersPermissionsUserVarPopFields>;
  var_samp?: Maybe<UserRolesUsersPermissionsUserVarSampFields>;
  variance?: Maybe<UserRolesUsersPermissionsUserVarianceFields>;
};


/** aggregate fields of "user_roles__users_permissions_user" */
export type UserRolesUsersPermissionsUserAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserRolesUsersPermissionsUserSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_roles__users_permissions_user" */
export type UserRolesUsersPermissionsUserAggregateOrderBy = {
  avg?: InputMaybe<UserRolesUsersPermissionsUserAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserRolesUsersPermissionsUserMaxOrderBy>;
  min?: InputMaybe<UserRolesUsersPermissionsUserMinOrderBy>;
  stddev?: InputMaybe<UserRolesUsersPermissionsUserStddevOrderBy>;
  stddev_pop?: InputMaybe<UserRolesUsersPermissionsUserStddevPopOrderBy>;
  stddev_samp?: InputMaybe<UserRolesUsersPermissionsUserStddevSampOrderBy>;
  sum?: InputMaybe<UserRolesUsersPermissionsUserSumOrderBy>;
  var_pop?: InputMaybe<UserRolesUsersPermissionsUserVarPopOrderBy>;
  var_samp?: InputMaybe<UserRolesUsersPermissionsUserVarSampOrderBy>;
  variance?: InputMaybe<UserRolesUsersPermissionsUserVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "user_roles__users_permissions_user" */
export type UserRolesUsersPermissionsUserArrRelInsertInput = {
  data: Array<UserRolesUsersPermissionsUserInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<UserRolesUsersPermissionsUserOnConflict>;
};

/** aggregate avg on columns */
export type UserRolesUsersPermissionsUserAvgFields = {
  __typename?: 'user_roles__users_permissions_user_avg_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  user_roles_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_roles__users_permissions_user" */
export type UserRolesUsersPermissionsUserAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  user_roles_id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "user_roles__users_permissions_user". All fields are combined with a logical 'AND'. */
export type UserRolesUsersPermissionsUserBoolExp = {
  _and?: InputMaybe<Array<UserRolesUsersPermissionsUserBoolExp>>;
  _not?: InputMaybe<UserRolesUsersPermissionsUserBoolExp>;
  _or?: InputMaybe<Array<UserRolesUsersPermissionsUserBoolExp>>;
  id?: InputMaybe<IntComparisonExp>;
  user_id?: InputMaybe<IntComparisonExp>;
  user_role?: InputMaybe<UserRolesBoolExp>;
  user_roles_id?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "user_roles__users_permissions_user" */
export enum UserRolesUsersPermissionsUserConstraint {
  /** unique or primary key constraint on columns "id" */
  USER_ROLES__USERS_ROLES_PKEY = 'user_roles__users_roles_pkey'
}

/** input type for incrementing numeric columns in table "user_roles__users_permissions_user" */
export type UserRolesUsersPermissionsUserIncInput = {
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
  user_roles_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_roles__users_permissions_user" */
export type UserRolesUsersPermissionsUserInsertInput = {
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
  user_role?: InputMaybe<UserRolesObjRelInsertInput>;
  user_roles_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type UserRolesUsersPermissionsUserMaxFields = {
  __typename?: 'user_roles__users_permissions_user_max_fields';
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
  user_roles_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "user_roles__users_permissions_user" */
export type UserRolesUsersPermissionsUserMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  user_roles_id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserRolesUsersPermissionsUserMinFields = {
  __typename?: 'user_roles__users_permissions_user_min_fields';
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
  user_roles_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "user_roles__users_permissions_user" */
export type UserRolesUsersPermissionsUserMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  user_roles_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_roles__users_permissions_user" */
export type UserRolesUsersPermissionsUserMutationResponse = {
  __typename?: 'user_roles__users_permissions_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserRolesUsersPermissionsUser>;
};

/** on_conflict condition type for table "user_roles__users_permissions_user" */
export type UserRolesUsersPermissionsUserOnConflict = {
  constraint: UserRolesUsersPermissionsUserConstraint;
  update_columns?: Array<UserRolesUsersPermissionsUserUpdateColumn>;
  where?: InputMaybe<UserRolesUsersPermissionsUserBoolExp>;
};

/** Ordering options when selecting data from "user_roles__users_permissions_user". */
export type UserRolesUsersPermissionsUserOrderBy = {
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  user_role?: InputMaybe<UserRolesOrderBy>;
  user_roles_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_roles__users_permissions_user */
export type UserRolesUsersPermissionsUserPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "user_roles__users_permissions_user" */
export enum UserRolesUsersPermissionsUserSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  USER_ID = 'user_id',
  /** column name */
  USER_ROLES_ID = 'user_roles_id'
}

/** input type for updating data in table "user_roles__users_permissions_user" */
export type UserRolesUsersPermissionsUserSetInput = {
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
  user_roles_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type UserRolesUsersPermissionsUserStddevFields = {
  __typename?: 'user_roles__users_permissions_user_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  user_roles_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_roles__users_permissions_user" */
export type UserRolesUsersPermissionsUserStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  user_roles_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type UserRolesUsersPermissionsUserStddevPopFields = {
  __typename?: 'user_roles__users_permissions_user_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  user_roles_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_roles__users_permissions_user" */
export type UserRolesUsersPermissionsUserStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  user_roles_id?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type UserRolesUsersPermissionsUserStddevSampFields = {
  __typename?: 'user_roles__users_permissions_user_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  user_roles_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_roles__users_permissions_user" */
export type UserRolesUsersPermissionsUserStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  user_roles_id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "user_roles__users_permissions_user" */
export type UserRolesUsersPermissionsUserStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: UserRolesUsersPermissionsUserStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserRolesUsersPermissionsUserStreamCursorValueInput = {
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
  user_roles_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type UserRolesUsersPermissionsUserSumFields = {
  __typename?: 'user_roles__users_permissions_user_sum_fields';
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
  user_roles_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_roles__users_permissions_user" */
export type UserRolesUsersPermissionsUserSumOrderBy = {
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  user_roles_id?: InputMaybe<OrderBy>;
};

/** update columns of table "user_roles__users_permissions_user" */
export enum UserRolesUsersPermissionsUserUpdateColumn {
  /** column name */
  ID = 'id',
  /** column name */
  USER_ID = 'user_id',
  /** column name */
  USER_ROLES_ID = 'user_roles_id'
}

export type UserRolesUsersPermissionsUserUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserRolesUsersPermissionsUserIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserRolesUsersPermissionsUserSetInput>;
  /** filter the rows which have to be updated */
  where: UserRolesUsersPermissionsUserBoolExp;
};

/** aggregate var_pop on columns */
export type UserRolesUsersPermissionsUserVarPopFields = {
  __typename?: 'user_roles__users_permissions_user_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  user_roles_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_roles__users_permissions_user" */
export type UserRolesUsersPermissionsUserVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  user_roles_id?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type UserRolesUsersPermissionsUserVarSampFields = {
  __typename?: 'user_roles__users_permissions_user_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  user_roles_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_roles__users_permissions_user" */
export type UserRolesUsersPermissionsUserVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  user_roles_id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type UserRolesUsersPermissionsUserVarianceFields = {
  __typename?: 'user_roles__users_permissions_user_variance_fields';
  id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  user_roles_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_roles__users_permissions_user" */
export type UserRolesUsersPermissionsUserVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
  user_roles_id?: InputMaybe<OrderBy>;
};

/** aggregated selection of "user_roles" */
export type UserRolesAggregate = {
  __typename?: 'user_roles_aggregate';
  aggregate?: Maybe<UserRolesAggregateFields>;
  nodes: Array<UserRoles>;
};

/** aggregate fields of "user_roles" */
export type UserRolesAggregateFields = {
  __typename?: 'user_roles_aggregate_fields';
  avg?: Maybe<UserRolesAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<UserRolesMaxFields>;
  min?: Maybe<UserRolesMinFields>;
  stddev?: Maybe<UserRolesStddevFields>;
  stddev_pop?: Maybe<UserRolesStddevPopFields>;
  stddev_samp?: Maybe<UserRolesStddevSampFields>;
  sum?: Maybe<UserRolesSumFields>;
  var_pop?: Maybe<UserRolesVarPopFields>;
  var_samp?: Maybe<UserRolesVarSampFields>;
  variance?: Maybe<UserRolesVarianceFields>;
};


/** aggregate fields of "user_roles" */
export type UserRolesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserRolesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type UserRolesAvgFields = {
  __typename?: 'user_roles_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_roles". All fields are combined with a logical 'AND'. */
export type UserRolesBoolExp = {
  _and?: InputMaybe<Array<UserRolesBoolExp>>;
  _not?: InputMaybe<UserRolesBoolExp>;
  _or?: InputMaybe<Array<UserRolesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "user_roles" */
export enum UserRolesConstraint {
  /** unique or primary key constraint on columns "id" */
  USER_ROLES_PKEY = 'user_roles_pkey',
  /** unique or primary key constraint on columns "type" */
  USER_ROLES_TYPE_KEY = 'user_roles_type_key'
}

/** input type for incrementing numeric columns in table "user_roles" */
export type UserRolesIncInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_roles" */
export type UserRolesInsertInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type UserRolesMaxFields = {
  __typename?: 'user_roles_max_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type UserRolesMinFields = {
  __typename?: 'user_roles_min_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_roles" */
export type UserRolesMutationResponse = {
  __typename?: 'user_roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserRoles>;
};

/** input type for inserting object relation for remote table "user_roles" */
export type UserRolesObjRelInsertInput = {
  data: UserRolesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<UserRolesOnConflict>;
};

/** on_conflict condition type for table "user_roles" */
export type UserRolesOnConflict = {
  constraint: UserRolesConstraint;
  update_columns?: Array<UserRolesUpdateColumn>;
  where?: InputMaybe<UserRolesBoolExp>;
};

/** Ordering options when selecting data from "user_roles". */
export type UserRolesOrderBy = {
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_roles */
export type UserRolesPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "user_roles" */
export enum UserRolesSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  TYPE = 'type'
}

/** input type for updating data in table "user_roles" */
export type UserRolesSetInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type UserRolesStddevFields = {
  __typename?: 'user_roles_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type UserRolesStddevPopFields = {
  __typename?: 'user_roles_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type UserRolesStddevSampFields = {
  __typename?: 'user_roles_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_roles" */
export type UserRolesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: UserRolesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserRolesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type UserRolesSumFields = {
  __typename?: 'user_roles_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "user_roles" */
export enum UserRolesUpdateColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  TYPE = 'type'
}

export type UserRolesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserRolesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserRolesSetInput>;
  /** filter the rows which have to be updated */
  where: UserRolesBoolExp;
};

/** aggregate var_pop on columns */
export type UserRolesVarPopFields = {
  __typename?: 'user_roles_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type UserRolesVarSampFields = {
  __typename?: 'user_roles_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type UserRolesVarianceFields = {
  __typename?: 'user_roles_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "users_permissions_user" */
export type UsersPermissionsUser = {
  __typename?: 'users_permissions_user';
  /** An array relationship */
  automations_watching: Array<AutomationsWatchings>;
  /** An aggregate relationship */
  automations_watching_aggregate: AutomationsWatchingsAggregate;
  avatar_url?: Maybe<Scalars['String']>;
  blocked?: Maybe<Scalars['Boolean']>;
  confirmationToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  email: Scalars['String'];
  id: Scalars['Int'];
  /** An object relationship */
  notification_setting?: Maybe<NotificationUserSettings>;
  organization?: Maybe<Scalars['Int']>;
  /** An array relationship */
  organizations: Array<OrganizationsUsersUsersOrganizations>;
  /** An aggregate relationship */
  organizations_aggregate: OrganizationsUsersUsersOrganizationsAggregate;
  otp?: Maybe<Scalars['String']>;
  otp_attempts_left?: Maybe<Scalars['Int']>;
  otp_expiration?: Maybe<Scalars['timestamptz']>;
  password?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  /** An array relationship */
  telegram_users: Array<TelegramUsers>;
  /** An aggregate relationship */
  telegram_users_aggregate: TelegramUsersAggregate;
  tokenVersion?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
  /** An array relationship */
  user_roles: Array<UserRolesUsersPermissionsUser>;
  /** An aggregate relationship */
  user_roles_aggregate: UserRolesUsersPermissionsUserAggregate;
  username: Scalars['String'];
};


/** columns and relationships of "users_permissions_user" */
export type UsersPermissionsUserAutomationsWatchingArgs = {
  distinct_on?: InputMaybe<Array<AutomationsWatchingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutomationsWatchingsOrderBy>>;
  where?: InputMaybe<AutomationsWatchingsBoolExp>;
};


/** columns and relationships of "users_permissions_user" */
export type UsersPermissionsUserAutomationsWatchingAggregateArgs = {
  distinct_on?: InputMaybe<Array<AutomationsWatchingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AutomationsWatchingsOrderBy>>;
  where?: InputMaybe<AutomationsWatchingsBoolExp>;
};


/** columns and relationships of "users_permissions_user" */
export type UsersPermissionsUserOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<OrganizationsUsersUsersOrganizationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationsUsersUsersOrganizationsOrderBy>>;
  where?: InputMaybe<OrganizationsUsersUsersOrganizationsBoolExp>;
};


/** columns and relationships of "users_permissions_user" */
export type UsersPermissionsUserOrganizationsAggregateArgs = {
  distinct_on?: InputMaybe<Array<OrganizationsUsersUsersOrganizationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<OrganizationsUsersUsersOrganizationsOrderBy>>;
  where?: InputMaybe<OrganizationsUsersUsersOrganizationsBoolExp>;
};


/** columns and relationships of "users_permissions_user" */
export type UsersPermissionsUserTelegramUsersArgs = {
  distinct_on?: InputMaybe<Array<TelegramUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TelegramUsersOrderBy>>;
  where?: InputMaybe<TelegramUsersBoolExp>;
};


/** columns and relationships of "users_permissions_user" */
export type UsersPermissionsUserTelegramUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<TelegramUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TelegramUsersOrderBy>>;
  where?: InputMaybe<TelegramUsersBoolExp>;
};


/** columns and relationships of "users_permissions_user" */
export type UsersPermissionsUserUserRolesArgs = {
  distinct_on?: InputMaybe<Array<UserRolesUsersPermissionsUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserRolesUsersPermissionsUserOrderBy>>;
  where?: InputMaybe<UserRolesUsersPermissionsUserBoolExp>;
};


/** columns and relationships of "users_permissions_user" */
export type UsersPermissionsUserUserRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRolesUsersPermissionsUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserRolesUsersPermissionsUserOrderBy>>;
  where?: InputMaybe<UserRolesUsersPermissionsUserBoolExp>;
};

/** aggregated selection of "users_permissions_user" */
export type UsersPermissionsUserAggregate = {
  __typename?: 'users_permissions_user_aggregate';
  aggregate?: Maybe<UsersPermissionsUserAggregateFields>;
  nodes: Array<UsersPermissionsUser>;
};

/** aggregate fields of "users_permissions_user" */
export type UsersPermissionsUserAggregateFields = {
  __typename?: 'users_permissions_user_aggregate_fields';
  avg?: Maybe<UsersPermissionsUserAvgFields>;
  count: Scalars['Int'];
  max?: Maybe<UsersPermissionsUserMaxFields>;
  min?: Maybe<UsersPermissionsUserMinFields>;
  stddev?: Maybe<UsersPermissionsUserStddevFields>;
  stddev_pop?: Maybe<UsersPermissionsUserStddevPopFields>;
  stddev_samp?: Maybe<UsersPermissionsUserStddevSampFields>;
  sum?: Maybe<UsersPermissionsUserSumFields>;
  var_pop?: Maybe<UsersPermissionsUserVarPopFields>;
  var_samp?: Maybe<UsersPermissionsUserVarSampFields>;
  variance?: Maybe<UsersPermissionsUserVarianceFields>;
};


/** aggregate fields of "users_permissions_user" */
export type UsersPermissionsUserAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UsersPermissionsUserSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type UsersPermissionsUserAvgFields = {
  __typename?: 'users_permissions_user_avg_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organization?: Maybe<Scalars['Float']>;
  otp_attempts_left?: Maybe<Scalars['Float']>;
  tokenVersion?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "users_permissions_user". All fields are combined with a logical 'AND'. */
export type UsersPermissionsUserBoolExp = {
  _and?: InputMaybe<Array<UsersPermissionsUserBoolExp>>;
  _not?: InputMaybe<UsersPermissionsUserBoolExp>;
  _or?: InputMaybe<Array<UsersPermissionsUserBoolExp>>;
  automations_watching?: InputMaybe<AutomationsWatchingsBoolExp>;
  automations_watching_aggregate?: InputMaybe<AutomationsWatchingsAggregateBoolExp>;
  avatar_url?: InputMaybe<StringComparisonExp>;
  blocked?: InputMaybe<BooleanComparisonExp>;
  confirmationToken?: InputMaybe<StringComparisonExp>;
  confirmed?: InputMaybe<BooleanComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  created_by?: InputMaybe<IntComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  notification_setting?: InputMaybe<NotificationUserSettingsBoolExp>;
  organization?: InputMaybe<IntComparisonExp>;
  organizations?: InputMaybe<OrganizationsUsersUsersOrganizationsBoolExp>;
  organizations_aggregate?: InputMaybe<OrganizationsUsersUsersOrganizationsAggregateBoolExp>;
  otp?: InputMaybe<StringComparisonExp>;
  otp_attempts_left?: InputMaybe<IntComparisonExp>;
  otp_expiration?: InputMaybe<TimestamptzComparisonExp>;
  password?: InputMaybe<StringComparisonExp>;
  provider?: InputMaybe<StringComparisonExp>;
  resetPasswordToken?: InputMaybe<StringComparisonExp>;
  telegram_users?: InputMaybe<TelegramUsersBoolExp>;
  telegram_users_aggregate?: InputMaybe<TelegramUsersAggregateBoolExp>;
  tokenVersion?: InputMaybe<IntComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<IntComparisonExp>;
  user_roles?: InputMaybe<UserRolesUsersPermissionsUserBoolExp>;
  user_roles_aggregate?: InputMaybe<UserRolesUsersPermissionsUserAggregateBoolExp>;
  username?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "users_permissions_user" */
export enum UsersPermissionsUserConstraint {
  /** unique or primary key constraint on columns "email" */
  USERS_PERMISSIONS_USER_EMAIL_KEY = 'users_permissions_user_email_key',
  /** unique or primary key constraint on columns "id" */
  USERS_PERMISSIONS_USER_PKEY = 'users_permissions_user_pkey',
  /** unique or primary key constraint on columns "username" */
  USERS_PERMISSIONS_USER_USERNAME_UNIQUE = 'users_permissions_user_username_unique'
}

/** input type for incrementing numeric columns in table "users_permissions_user" */
export type UsersPermissionsUserIncInput = {
  created_by?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Scalars['Int']>;
  otp_attempts_left?: InputMaybe<Scalars['Int']>;
  tokenVersion?: InputMaybe<Scalars['Int']>;
  updated_by?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "users_permissions_user" */
export type UsersPermissionsUserInsertInput = {
  automations_watching?: InputMaybe<AutomationsWatchingsArrRelInsertInput>;
  avatar_url?: InputMaybe<Scalars['String']>;
  blocked?: InputMaybe<Scalars['Boolean']>;
  confirmationToken?: InputMaybe<Scalars['String']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  notification_setting?: InputMaybe<NotificationUserSettingsObjRelInsertInput>;
  organization?: InputMaybe<Scalars['Int']>;
  organizations?: InputMaybe<OrganizationsUsersUsersOrganizationsArrRelInsertInput>;
  otp?: InputMaybe<Scalars['String']>;
  otp_attempts_left?: InputMaybe<Scalars['Int']>;
  otp_expiration?: InputMaybe<Scalars['timestamptz']>;
  password?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  telegram_users?: InputMaybe<TelegramUsersArrRelInsertInput>;
  tokenVersion?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  user_roles?: InputMaybe<UserRolesUsersPermissionsUserArrRelInsertInput>;
  username?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type UsersPermissionsUserMaxFields = {
  __typename?: 'users_permissions_user_max_fields';
  avatar_url?: Maybe<Scalars['String']>;
  confirmationToken?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  organization?: Maybe<Scalars['Int']>;
  otp?: Maybe<Scalars['String']>;
  otp_attempts_left?: Maybe<Scalars['Int']>;
  otp_expiration?: Maybe<Scalars['timestamptz']>;
  password?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  tokenVersion?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
  username?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type UsersPermissionsUserMinFields = {
  __typename?: 'users_permissions_user_min_fields';
  avatar_url?: Maybe<Scalars['String']>;
  confirmationToken?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  organization?: Maybe<Scalars['Int']>;
  otp?: Maybe<Scalars['String']>;
  otp_attempts_left?: Maybe<Scalars['Int']>;
  otp_expiration?: Maybe<Scalars['timestamptz']>;
  password?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  tokenVersion?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['Int']>;
  username?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "users_permissions_user" */
export type UsersPermissionsUserMutationResponse = {
  __typename?: 'users_permissions_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UsersPermissionsUser>;
};

/** input type for inserting object relation for remote table "users_permissions_user" */
export type UsersPermissionsUserObjRelInsertInput = {
  data: UsersPermissionsUserInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<UsersPermissionsUserOnConflict>;
};

/** on_conflict condition type for table "users_permissions_user" */
export type UsersPermissionsUserOnConflict = {
  constraint: UsersPermissionsUserConstraint;
  update_columns?: Array<UsersPermissionsUserUpdateColumn>;
  where?: InputMaybe<UsersPermissionsUserBoolExp>;
};

/** Ordering options when selecting data from "users_permissions_user". */
export type UsersPermissionsUserOrderBy = {
  automations_watching_aggregate?: InputMaybe<AutomationsWatchingsAggregateOrderBy>;
  avatar_url?: InputMaybe<OrderBy>;
  blocked?: InputMaybe<OrderBy>;
  confirmationToken?: InputMaybe<OrderBy>;
  confirmed?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  created_by?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  notification_setting?: InputMaybe<NotificationUserSettingsOrderBy>;
  organization?: InputMaybe<OrderBy>;
  organizations_aggregate?: InputMaybe<OrganizationsUsersUsersOrganizationsAggregateOrderBy>;
  otp?: InputMaybe<OrderBy>;
  otp_attempts_left?: InputMaybe<OrderBy>;
  otp_expiration?: InputMaybe<OrderBy>;
  password?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  resetPasswordToken?: InputMaybe<OrderBy>;
  telegram_users_aggregate?: InputMaybe<TelegramUsersAggregateOrderBy>;
  tokenVersion?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  user_roles_aggregate?: InputMaybe<UserRolesUsersPermissionsUserAggregateOrderBy>;
  username?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: users_permissions_user */
export type UsersPermissionsUserPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "users_permissions_user" */
export enum UsersPermissionsUserSelectColumn {
  /** column name */
  AVATAR_URL = 'avatar_url',
  /** column name */
  BLOCKED = 'blocked',
  /** column name */
  CONFIRMATIONTOKEN = 'confirmationToken',
  /** column name */
  CONFIRMED = 'confirmed',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  EMAIL = 'email',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANIZATION = 'organization',
  /** column name */
  OTP = 'otp',
  /** column name */
  OTP_ATTEMPTS_LEFT = 'otp_attempts_left',
  /** column name */
  OTP_EXPIRATION = 'otp_expiration',
  /** column name */
  PASSWORD = 'password',
  /** column name */
  PROVIDER = 'provider',
  /** column name */
  RESETPASSWORDTOKEN = 'resetPasswordToken',
  /** column name */
  TOKENVERSION = 'tokenVersion',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by',
  /** column name */
  USERNAME = 'username'
}

/** input type for updating data in table "users_permissions_user" */
export type UsersPermissionsUserSetInput = {
  avatar_url?: InputMaybe<Scalars['String']>;
  blocked?: InputMaybe<Scalars['Boolean']>;
  confirmationToken?: InputMaybe<Scalars['String']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Scalars['Int']>;
  otp?: InputMaybe<Scalars['String']>;
  otp_attempts_left?: InputMaybe<Scalars['Int']>;
  otp_expiration?: InputMaybe<Scalars['timestamptz']>;
  password?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  tokenVersion?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  username?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type UsersPermissionsUserStddevFields = {
  __typename?: 'users_permissions_user_stddev_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organization?: Maybe<Scalars['Float']>;
  otp_attempts_left?: Maybe<Scalars['Float']>;
  tokenVersion?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type UsersPermissionsUserStddevPopFields = {
  __typename?: 'users_permissions_user_stddev_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organization?: Maybe<Scalars['Float']>;
  otp_attempts_left?: Maybe<Scalars['Float']>;
  tokenVersion?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type UsersPermissionsUserStddevSampFields = {
  __typename?: 'users_permissions_user_stddev_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organization?: Maybe<Scalars['Float']>;
  otp_attempts_left?: Maybe<Scalars['Float']>;
  tokenVersion?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "users_permissions_user" */
export type UsersPermissionsUserStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: UsersPermissionsUserStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UsersPermissionsUserStreamCursorValueInput = {
  avatar_url?: InputMaybe<Scalars['String']>;
  blocked?: InputMaybe<Scalars['Boolean']>;
  confirmationToken?: InputMaybe<Scalars['String']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Scalars['Int']>;
  otp?: InputMaybe<Scalars['String']>;
  otp_attempts_left?: InputMaybe<Scalars['Int']>;
  otp_expiration?: InputMaybe<Scalars['timestamptz']>;
  password?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  tokenVersion?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['Int']>;
  username?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type UsersPermissionsUserSumFields = {
  __typename?: 'users_permissions_user_sum_fields';
  created_by?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  organization?: Maybe<Scalars['Int']>;
  otp_attempts_left?: Maybe<Scalars['Int']>;
  tokenVersion?: Maybe<Scalars['Int']>;
  updated_by?: Maybe<Scalars['Int']>;
};

/** update columns of table "users_permissions_user" */
export enum UsersPermissionsUserUpdateColumn {
  /** column name */
  AVATAR_URL = 'avatar_url',
  /** column name */
  BLOCKED = 'blocked',
  /** column name */
  CONFIRMATIONTOKEN = 'confirmationToken',
  /** column name */
  CONFIRMED = 'confirmed',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_BY = 'created_by',
  /** column name */
  EMAIL = 'email',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANIZATION = 'organization',
  /** column name */
  OTP = 'otp',
  /** column name */
  OTP_ATTEMPTS_LEFT = 'otp_attempts_left',
  /** column name */
  OTP_EXPIRATION = 'otp_expiration',
  /** column name */
  PASSWORD = 'password',
  /** column name */
  PROVIDER = 'provider',
  /** column name */
  RESETPASSWORDTOKEN = 'resetPasswordToken',
  /** column name */
  TOKENVERSION = 'tokenVersion',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by',
  /** column name */
  USERNAME = 'username'
}

export type UsersPermissionsUserUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UsersPermissionsUserIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UsersPermissionsUserSetInput>;
  /** filter the rows which have to be updated */
  where: UsersPermissionsUserBoolExp;
};

/** aggregate var_pop on columns */
export type UsersPermissionsUserVarPopFields = {
  __typename?: 'users_permissions_user_var_pop_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organization?: Maybe<Scalars['Float']>;
  otp_attempts_left?: Maybe<Scalars['Float']>;
  tokenVersion?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type UsersPermissionsUserVarSampFields = {
  __typename?: 'users_permissions_user_var_samp_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organization?: Maybe<Scalars['Float']>;
  otp_attempts_left?: Maybe<Scalars['Float']>;
  tokenVersion?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type UsersPermissionsUserVarianceFields = {
  __typename?: 'users_permissions_user_variance_fields';
  created_by?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  organization?: Maybe<Scalars['Float']>;
  otp_attempts_left?: Maybe<Scalars['Float']>;
  tokenVersion?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidComparisonExp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

export type DeviceForAnalysisFragment = { __typename?: 'analysis_applications__devices', id: number, deleted: boolean, deletedAt?: string | undefined | null, device: { __typename?: 'devices', id: number, name: string, categories: Array<{ __typename?: 'devices__device_categories', category: { __typename?: 'device_categories', id: number, key: string } }>, payloads: Array<{ __typename?: 'devices__device_payloads', id: number, payload: { __typename?: 'device_payloads', id: number, name: string, key: string, type: string, kind: string, payloadValues: Array<{ __typename?: 'device_payloads__payload_values', payloadValue?: { __typename?: 'device_payload_values', id: number, name: string, value: string } | undefined | null }> } }> } };

export type AnalysisAvailableDataFragment = { __typename?: 'analysis', id: number, name: string, enabled: boolean, group: AnalysisGroupsEnum, kind: AnalysisKindsEnum, slug: string, analysisApplications: Array<{ __typename?: 'analysis_applications', id: number, devices: Array<{ __typename?: 'analysis_applications__devices', id: number, deleted: boolean, deletedAt?: string | undefined | null, deviceId: number }> }>, devicesCategories: Array<{ __typename?: 'analysis_device_categories_configs', max: number, min: number, deviceCategory: { __typename?: 'device_categories', id: number, key: string } }>, payloads: Array<{ __typename?: 'analysis__devices_payloads', id: number, payloadId: number }> };

export type AnalysisApplicationDataFragment = { __typename?: 'analysis_applications', id: number, name: string, enabled: boolean, analysis: { __typename?: 'analysis', id: number, name: string, enabled: boolean, group: AnalysisGroupsEnum, slug: string, payloads: Array<{ __typename?: 'analysis__devices_payloads', payload: { __typename?: 'device_payloads', key: string, type: string } }> }, area?: { __typename?: 'areas', id: number, name: string, icon?: AreaIcon | undefined | null, scope: AreasScopesEnum, analysisApplications: Array<{ __typename?: 'analysis_applications', id: number }>, cultivation?: { __typename?: 'areas_scope_cultivation', nw?: number | undefined | null, wa?: number | undefined | null, wo?: number | undefined | null, clayPercentage?: number | undefined | null, cultivationType: CultivationTypesEnum, farmingContainer?: FarmingContainersEnum | undefined | null, farmingContainerCapacity?: number | undefined | null, farmingMethod: FarmingMethodsEnum, farmingStructure: FarmingStructuresEnum, organicMaterialPercentage?: number | undefined | null, sandPercentage?: number | undefined | null, substrate?: { __typename?: 'substrates', id: number, name: string, slug: string, kpa1: number, kpa5: number } | undefined | null } | undefined | null, devices: Array<{ __typename?: 'devices', id: number }> } | undefined | null, dashboards: Array<{ __typename?: 'applications_dashboards_analysis', id: number }>, devices: Array<{ __typename?: 'analysis_applications__devices', id: number, deleted: boolean, deletedAt?: string | undefined | null, device: { __typename?: 'devices', id: number, name: string, categories: Array<{ __typename?: 'devices__device_categories', category: { __typename?: 'device_categories', id: number, key: string } }>, payloads: Array<{ __typename?: 'devices__device_payloads', id: number, payload: { __typename?: 'device_payloads', id: number, name: string, key: string, type: string, kind: string, payloadValues: Array<{ __typename?: 'device_payloads__payload_values', payloadValue?: { __typename?: 'device_payload_values', id: number, name: string, value: string } | undefined | null }> } }> } }> };

export type AnalysesAvailableQueryVariables = Exact<{
  applicationId: Scalars['Int'];
}>;


export type AnalysesAvailableQuery = { health: Array<{ __typename?: 'analysis', id: number, name: string, enabled: boolean, group: AnalysisGroupsEnum, kind: AnalysisKindsEnum, slug: string, analysisApplications: Array<{ __typename?: 'analysis_applications', id: number, devices: Array<{ __typename?: 'analysis_applications__devices', id: number, deleted: boolean, deletedAt?: string | undefined | null, deviceId: number }> }>, devicesCategories: Array<{ __typename?: 'analysis_device_categories_configs', max: number, min: number, deviceCategory: { __typename?: 'device_categories', id: number, key: string } }>, payloads: Array<{ __typename?: 'analysis__devices_payloads', id: number, payloadId: number }> }>, other: Array<{ __typename?: 'analysis', id: number, name: string, enabled: boolean, group: AnalysisGroupsEnum, kind: AnalysisKindsEnum, slug: string, analysisApplications: Array<{ __typename?: 'analysis_applications', id: number, devices: Array<{ __typename?: 'analysis_applications__devices', id: number, deleted: boolean, deletedAt?: string | undefined | null, deviceId: number }> }>, devicesCategories: Array<{ __typename?: 'analysis_device_categories_configs', max: number, min: number, deviceCategory: { __typename?: 'device_categories', id: number, key: string } }>, payloads: Array<{ __typename?: 'analysis__devices_payloads', id: number, payloadId: number }> }>, preventions: Array<{ __typename?: 'analysis', id: number, name: string, enabled: boolean, group: AnalysisGroupsEnum, kind: AnalysisKindsEnum, slug: string, analysisApplications: Array<{ __typename?: 'analysis_applications', id: number, devices: Array<{ __typename?: 'analysis_applications__devices', id: number, deleted: boolean, deletedAt?: string | undefined | null, deviceId: number }> }>, devicesCategories: Array<{ __typename?: 'analysis_device_categories_configs', max: number, min: number, deviceCategory: { __typename?: 'device_categories', id: number, key: string } }>, payloads: Array<{ __typename?: 'analysis__devices_payloads', id: number, payloadId: number }> }> };

export type AnalysesApplicationQueryVariables = Exact<{
  applicationId: Scalars['Int'];
}>;


export type AnalysesApplicationQuery = { analysesApplication: Array<{ __typename?: 'analysis_applications', id: number, name: string, enabled: boolean, analysis: { __typename?: 'analysis', id: number, name: string, enabled: boolean, group: AnalysisGroupsEnum, slug: string, payloads: Array<{ __typename?: 'analysis__devices_payloads', payload: { __typename?: 'device_payloads', key: string, type: string } }> }, area?: { __typename?: 'areas', id: number, name: string, icon?: AreaIcon | undefined | null, scope: AreasScopesEnum, analysisApplications: Array<{ __typename?: 'analysis_applications', id: number }>, cultivation?: { __typename?: 'areas_scope_cultivation', nw?: number | undefined | null, wa?: number | undefined | null, wo?: number | undefined | null, clayPercentage?: number | undefined | null, cultivationType: CultivationTypesEnum, farmingContainer?: FarmingContainersEnum | undefined | null, farmingContainerCapacity?: number | undefined | null, farmingMethod: FarmingMethodsEnum, farmingStructure: FarmingStructuresEnum, organicMaterialPercentage?: number | undefined | null, sandPercentage?: number | undefined | null, substrate?: { __typename?: 'substrates', id: number, name: string, slug: string, kpa1: number, kpa5: number } | undefined | null } | undefined | null, devices: Array<{ __typename?: 'devices', id: number }> } | undefined | null, dashboards: Array<{ __typename?: 'applications_dashboards_analysis', id: number }>, devices: Array<{ __typename?: 'analysis_applications__devices', id: number, deleted: boolean, deletedAt?: string | undefined | null, device: { __typename?: 'devices', id: number, name: string, categories: Array<{ __typename?: 'devices__device_categories', category: { __typename?: 'device_categories', id: number, key: string } }>, payloads: Array<{ __typename?: 'devices__device_payloads', id: number, payload: { __typename?: 'device_payloads', id: number, name: string, key: string, type: string, kind: string, payloadValues: Array<{ __typename?: 'device_payloads__payload_values', payloadValue?: { __typename?: 'device_payload_values', id: number, name: string, value: string } | undefined | null }> } }> } }> }> };

export type AnalysesApplicationsByTypeQueryVariables = Exact<{
  analysisId: Scalars['Int'];
  applicationId: Scalars['Int'];
}>;


export type AnalysesApplicationsByTypeQuery = { analysesApplications: Array<{ __typename?: 'analysis_applications', id: number, name: string, enabled: boolean }> };

export type AnalysesApplicationBySlugQueryVariables = Exact<{
  applicationId: Scalars['Int'];
  slug: Scalars['String'];
}>;


export type AnalysesApplicationBySlugQuery = { analysesApplication: Array<{ __typename?: 'analysis_applications', id: number, name: string, enabled: boolean, analysis: { __typename?: 'analysis', id: number, name: string, enabled: boolean, group: AnalysisGroupsEnum, slug: string, payloads: Array<{ __typename?: 'analysis__devices_payloads', payload: { __typename?: 'device_payloads', key: string, type: string } }> }, area?: { __typename?: 'areas', id: number, name: string, icon?: AreaIcon | undefined | null, scope: AreasScopesEnum, analysisApplications: Array<{ __typename?: 'analysis_applications', id: number }>, cultivation?: { __typename?: 'areas_scope_cultivation', nw?: number | undefined | null, wa?: number | undefined | null, wo?: number | undefined | null, clayPercentage?: number | undefined | null, cultivationType: CultivationTypesEnum, farmingContainer?: FarmingContainersEnum | undefined | null, farmingContainerCapacity?: number | undefined | null, farmingMethod: FarmingMethodsEnum, farmingStructure: FarmingStructuresEnum, organicMaterialPercentage?: number | undefined | null, sandPercentage?: number | undefined | null, substrate?: { __typename?: 'substrates', id: number, name: string, slug: string, kpa1: number, kpa5: number } | undefined | null } | undefined | null, devices: Array<{ __typename?: 'devices', id: number }> } | undefined | null, dashboards: Array<{ __typename?: 'applications_dashboards_analysis', id: number }>, devices: Array<{ __typename?: 'analysis_applications__devices', id: number, deleted: boolean, deletedAt?: string | undefined | null, device: { __typename?: 'devices', id: number, name: string, categories: Array<{ __typename?: 'devices__device_categories', category: { __typename?: 'device_categories', id: number, key: string } }>, payloads: Array<{ __typename?: 'devices__device_payloads', id: number, payload: { __typename?: 'device_payloads', id: number, name: string, key: string, type: string, kind: string, payloadValues: Array<{ __typename?: 'device_payloads__payload_values', payloadValue?: { __typename?: 'device_payload_values', id: number, name: string, value: string } | undefined | null }> } }> } }> }> };

export type AnalysesApplicationByAreaQueryVariables = Exact<{
  applicationId: Scalars['Int'];
  areaId: Scalars['Int'];
}>;


export type AnalysesApplicationByAreaQuery = { analysesApplication: Array<{ __typename?: 'analysis_applications', id: number, name: string, enabled: boolean, analysis: { __typename?: 'analysis', id: number, name: string, enabled: boolean, group: AnalysisGroupsEnum, slug: string, payloads: Array<{ __typename?: 'analysis__devices_payloads', payload: { __typename?: 'device_payloads', key: string, type: string } }> }, area?: { __typename?: 'areas', id: number, name: string, icon?: AreaIcon | undefined | null, scope: AreasScopesEnum, analysisApplications: Array<{ __typename?: 'analysis_applications', id: number }>, cultivation?: { __typename?: 'areas_scope_cultivation', nw?: number | undefined | null, wa?: number | undefined | null, wo?: number | undefined | null, clayPercentage?: number | undefined | null, cultivationType: CultivationTypesEnum, farmingContainer?: FarmingContainersEnum | undefined | null, farmingContainerCapacity?: number | undefined | null, farmingMethod: FarmingMethodsEnum, farmingStructure: FarmingStructuresEnum, organicMaterialPercentage?: number | undefined | null, sandPercentage?: number | undefined | null, substrate?: { __typename?: 'substrates', id: number, name: string, slug: string, kpa1: number, kpa5: number } | undefined | null } | undefined | null, devices: Array<{ __typename?: 'devices', id: number }> } | undefined | null, dashboards: Array<{ __typename?: 'applications_dashboards_analysis', id: number }>, devices: Array<{ __typename?: 'analysis_applications__devices', id: number, deleted: boolean, deletedAt?: string | undefined | null, device: { __typename?: 'devices', id: number, name: string, categories: Array<{ __typename?: 'devices__device_categories', category: { __typename?: 'device_categories', id: number, key: string } }>, payloads: Array<{ __typename?: 'devices__device_payloads', id: number, payload: { __typename?: 'device_payloads', id: number, name: string, key: string, type: string, kind: string, payloadValues: Array<{ __typename?: 'device_payloads__payload_values', payloadValue?: { __typename?: 'device_payload_values', id: number, name: string, value: string } | undefined | null }> } }> } }> }> };

export type AnalysisApplicationDetailsQueryVariables = Exact<{
  analysisApplicationId: Scalars['Int'];
}>;


export type AnalysisApplicationDetailsQuery = { analysisApplication?: { __typename?: 'analysis_applications', id: number, name: string, enabled: boolean, analysis: { __typename?: 'analysis', id: number, name: string, enabled: boolean, group: AnalysisGroupsEnum, slug: string, payloads: Array<{ __typename?: 'analysis__devices_payloads', payload: { __typename?: 'device_payloads', key: string, type: string } }> }, area?: { __typename?: 'areas', id: number, name: string, icon?: AreaIcon | undefined | null, scope: AreasScopesEnum, analysisApplications: Array<{ __typename?: 'analysis_applications', id: number }>, cultivation?: { __typename?: 'areas_scope_cultivation', nw?: number | undefined | null, wa?: number | undefined | null, wo?: number | undefined | null, clayPercentage?: number | undefined | null, cultivationType: CultivationTypesEnum, farmingContainer?: FarmingContainersEnum | undefined | null, farmingContainerCapacity?: number | undefined | null, farmingMethod: FarmingMethodsEnum, farmingStructure: FarmingStructuresEnum, organicMaterialPercentage?: number | undefined | null, sandPercentage?: number | undefined | null, substrate?: { __typename?: 'substrates', id: number, name: string, slug: string, kpa1: number, kpa5: number } | undefined | null } | undefined | null, devices: Array<{ __typename?: 'devices', id: number }> } | undefined | null, dashboards: Array<{ __typename?: 'applications_dashboards_analysis', id: number }>, devices: Array<{ __typename?: 'analysis_applications__devices', id: number, deleted: boolean, deletedAt?: string | undefined | null, device: { __typename?: 'devices', id: number, name: string, categories: Array<{ __typename?: 'devices__device_categories', category: { __typename?: 'device_categories', id: number, key: string } }>, payloads: Array<{ __typename?: 'devices__device_payloads', id: number, payload: { __typename?: 'device_payloads', id: number, name: string, key: string, type: string, kind: string, payloadValues: Array<{ __typename?: 'device_payloads__payload_values', payloadValue?: { __typename?: 'device_payload_values', id: number, name: string, value: string } | undefined | null }> } }> } }> } | undefined | null };

export type InsertAnalysisApplicationMutationVariables = Exact<{
  name: Scalars['String'];
  analysisId: Scalars['Int'];
  applicationId: Scalars['Int'];
  areaId?: InputMaybe<Scalars['Int']>;
  devices: Array<Scalars['Int']> | Scalars['Int'];
  enabled: Scalars['Boolean'];
}>;


export type InsertAnalysisApplicationMutation = { insertAnalysis?: { __typename?: 'AnalysisApplicationCreateOutput', id: number } | undefined | null };

export type EditAnalysisApplicationMutationVariables = Exact<{
  name: Scalars['String'];
  analysisApplicationId: Scalars['Int'];
  devices: Array<Scalars['Int']> | Scalars['Int'];
  enabled: Scalars['Boolean'];
}>;


export type EditAnalysisApplicationMutation = { updateAnalysis?: { __typename?: 'AnalysisApplicationUpdateOutput', id: number } | undefined | null };

export type DeleteAnalysisApplicationMutationVariables = Exact<{
  analysisApplicationId: Scalars['Int'];
}>;


export type DeleteAnalysisApplicationMutation = { deleteDashboardAnalysis?: { __typename?: 'applications_dashboards_analysis_mutation_response', affected_rows: number } | undefined | null, deleteAnalysis?: { __typename?: 'analysis_applications', id: number } | undefined | null };

export type AnalysisComputedDataFragment = { __typename?: 'analysis_applications_computed', prob?: number | undefined | null, temperature?: number | undefined | null, wetness?: number | undefined | null, x: string };

export type AnalysisHealthComputedDataFragment = { __typename?: 'analysis_applications_computed', x: string, values: Array<{ __typename?: 'analysis_applications_computed_values', value?: number | undefined | null, deviceId?: number | undefined | null, devicePayload?: { __typename?: 'device_payloads', id: number, name: string, key: string, type: string } | undefined | null }> };

export type AnalysisComputedQueryVariables = Exact<{
  analysisApplicationId: Scalars['Int'];
  endDate: Scalars['timestamptz'];
  startDate: Scalars['timestamptz'];
}>;


export type AnalysisComputedQuery = { analysisComputed: Array<{ __typename?: 'analysis_applications_computed', prob?: number | undefined | null, temperature?: number | undefined | null, wetness?: number | undefined | null, x: string }> };

export type AnalysisHealthComputedDataQueryVariables = Exact<{
  analysisApplicationId: Scalars['Int'];
  endDate: Scalars['timestamptz'];
  startDate: Scalars['timestamptz'];
}>;


export type AnalysisHealthComputedDataQuery = { analysisComputed: Array<{ __typename?: 'analysis_applications_computed', x: string, values: Array<{ __typename?: 'analysis_applications_computed_values', value?: number | undefined | null, deviceId?: number | undefined | null, devicePayload?: { __typename?: 'device_payloads', id: number, name: string, key: string, type: string } | undefined | null }> }> };

export type AnalysisComputedLatestQueryVariables = Exact<{
  analysisApplicationId: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type AnalysisComputedLatestQuery = { analysisComputed: Array<{ __typename?: 'analysis_applications_computed', prob?: number | undefined | null, temperature?: number | undefined | null, wetness?: number | undefined | null, x: string }> };

export type AnalysisHealthComputedLatestQueryVariables = Exact<{
  analysisApplicationId: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type AnalysisHealthComputedLatestQuery = { analysisComputed: Array<{ __typename?: 'analysis_applications_computed', x: string, values: Array<{ __typename?: 'analysis_applications_computed_values', value?: number | undefined | null, deviceId?: number | undefined | null, devicePayload?: { __typename?: 'device_payloads', id: number, name: string, key: string, type: string } | undefined | null }> }> };

export type AnalysisComputedAggregateQueryVariables = Exact<{
  analysisApplicationId: Scalars['Int'];
  endDate: Scalars['timestamptz'];
  startDate: Scalars['timestamptz'];
}>;


export type AnalysisComputedAggregateQuery = { highRisk: { __typename?: 'analysis_applications_computed_values_aggregate', aggregate?: { __typename?: 'analysis_applications_computed_values_aggregate_fields', count: number } | undefined | null }, lowRisk: { __typename?: 'analysis_applications_computed_values_aggregate', aggregate?: { __typename?: 'analysis_applications_computed_values_aggregate_fields', count: number } | undefined | null }, mediumRisk: { __typename?: 'analysis_applications_computed_values_aggregate', aggregate?: { __typename?: 'analysis_applications_computed_values_aggregate_fields', count: number } | undefined | null } };

export type ApplicationsQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type ApplicationsQuery = { applications: Array<{ __typename?: 'applications', id: number, name: string, lat?: number | undefined | null, lon?: number | undefined | null, organizationId: number, providerId: string, automationsAggregate: { __typename?: 'automations_aggregate', aggregate?: { __typename?: 'automations_aggregate_fields', count: number } | undefined | null }, devicesAggregate: { __typename?: 'devices_aggregate', aggregate?: { __typename?: 'devices_aggregate_fields', count: number } | undefined | null } }> };

export type ApplicationWeatherQueryVariables = Exact<{
  applicationId: Scalars['Int'];
}>;


export type ApplicationWeatherQuery = { applicationWeather?: { __typename?: 'ApplicationWeatherOutput', weather: { __typename?: 'ApplicationWeather', alerts: Array<{ __typename?: 'ApplicationWeatherAlert', event: string }>, current: { __typename?: 'ApplicationWeatherCurrent', cloudy: boolean, humidity: number, pressure: number, sunrise: string, sunset: string, temperature: number, time: string, weatherIconId: string, windDegree: number, windSpeed: number }, forecast: Array<{ __typename?: 'ApplicationWeatherForecast', cloudy: boolean, humidity: number, pressure: number, time: string, weatherIconId: string, windDegree: number, windGust: number, windSpeed: number, temperature: { __typename?: 'ApplicationWeatherForecastTemperature', max: number, min: number } }> } } | undefined | null };

export type AreaDeviceFragment = { __typename?: 'devices', id: number, name: string, providerId: string, type: string, area?: { __typename?: 'areas', id: number, name: string } | undefined | null, categories: Array<{ __typename?: 'devices__device_categories', category: { __typename?: 'device_categories', id: number, key: string } }>, dashboards: Array<{ __typename?: 'applications_dashboards_devices', id: number }>, payloads: Array<{ __typename?: 'devices__device_payloads', id: number, payload: { __typename?: 'device_payloads', id: number, name: string, key: string, type: string, kind: string, payloadValues: Array<{ __typename?: 'device_payloads__payload_values', payloadValue?: { __typename?: 'device_payload_values', id: number, name: string, value: string } | undefined | null }> } }> };

export type CultivationDataFragment = { __typename?: 'areas_scope_cultivation', clayPercentage?: number | undefined | null, cultivationType: CultivationTypesEnum, farmingContainer?: FarmingContainersEnum | undefined | null, farmingContainerCapacity?: number | undefined | null, farmingMethod: FarmingMethodsEnum, farmingStructure: FarmingStructuresEnum, organicMaterialPercentage?: number | undefined | null, sandPercentage?: number | undefined | null, substrate?: { __typename?: 'substrates', id: number, name: string, slug: string } | undefined | null };

export type AreaDataFragment = { __typename?: 'areas', id: number, name: string, description?: string | undefined | null, icon?: AreaIcon | undefined | null, scope: AreasScopesEnum, cultivation?: { __typename?: 'areas_scope_cultivation', clayPercentage?: number | undefined | null, cultivationType: CultivationTypesEnum, farmingContainer?: FarmingContainersEnum | undefined | null, farmingContainerCapacity?: number | undefined | null, farmingMethod: FarmingMethodsEnum, farmingStructure: FarmingStructuresEnum, organicMaterialPercentage?: number | undefined | null, sandPercentage?: number | undefined | null, substrate?: { __typename?: 'substrates', id: number, name: string, slug: string } | undefined | null } | undefined | null, devices: Array<{ __typename?: 'devices', id: number, name: string, providerId: string, type: string, area?: { __typename?: 'areas', id: number, name: string } | undefined | null, categories: Array<{ __typename?: 'devices__device_categories', category: { __typename?: 'device_categories', id: number, key: string } }>, dashboards: Array<{ __typename?: 'applications_dashboards_devices', id: number }>, payloads: Array<{ __typename?: 'devices__device_payloads', id: number, payload: { __typename?: 'device_payloads', id: number, name: string, key: string, type: string, kind: string, payloadValues: Array<{ __typename?: 'device_payloads__payload_values', payloadValue?: { __typename?: 'device_payload_values', id: number, name: string, value: string } | undefined | null }> } }> }> };

export type AreaDataLiteFragment = { __typename?: 'areas', id: number, name: string, icon?: AreaIcon | undefined | null, scope: AreasScopesEnum, analysisApplications: Array<{ __typename?: 'analysis_applications', id: number }>, cultivation?: { __typename?: 'areas_scope_cultivation', nw?: number | undefined | null, wa?: number | undefined | null, wo?: number | undefined | null, clayPercentage?: number | undefined | null, cultivationType: CultivationTypesEnum, farmingContainer?: FarmingContainersEnum | undefined | null, farmingContainerCapacity?: number | undefined | null, farmingMethod: FarmingMethodsEnum, farmingStructure: FarmingStructuresEnum, organicMaterialPercentage?: number | undefined | null, sandPercentage?: number | undefined | null, substrate?: { __typename?: 'substrates', id: number, name: string, slug: string, kpa1: number, kpa5: number } | undefined | null } | undefined | null, devices: Array<{ __typename?: 'devices', id: number }> };

export type GetAreasQueryVariables = Exact<{
  applicationId: Scalars['Int'];
}>;


export type GetAreasQuery = { areas: Array<{ __typename?: 'areas', id: number, name: string, icon?: AreaIcon | undefined | null, scope: AreasScopesEnum, devices: Array<{ __typename?: 'devices', id: number, categories: Array<{ __typename?: 'devices__device_categories', category: { __typename?: 'device_categories', id: number, key: string } }> }> }> };

export type GetCultivationDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCultivationDataQuery = { cultivationTypes: Array<{ __typename?: 'cultivation_types', value: string }>, farmingContainers: Array<{ __typename?: 'farming_containers', value: string }>, farmingMethods: Array<{ __typename?: 'farming_methods', value: string }>, farmingStructures: Array<{ __typename?: 'farming_structures', value: string }>, substrateTypes: Array<{ __typename?: 'substrates', id: number, name: string, slug: string }> };

export type GetAreaQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetAreaQuery = { area?: { __typename?: 'areas', id: number, name: string, description?: string | undefined | null, icon?: AreaIcon | undefined | null, scope: AreasScopesEnum, cultivation?: { __typename?: 'areas_scope_cultivation', clayPercentage?: number | undefined | null, cultivationType: CultivationTypesEnum, farmingContainer?: FarmingContainersEnum | undefined | null, farmingContainerCapacity?: number | undefined | null, farmingMethod: FarmingMethodsEnum, farmingStructure: FarmingStructuresEnum, organicMaterialPercentage?: number | undefined | null, sandPercentage?: number | undefined | null, substrate?: { __typename?: 'substrates', id: number, name: string, slug: string } | undefined | null } | undefined | null, devices: Array<{ __typename?: 'devices', id: number, name: string, providerId: string, type: string, area?: { __typename?: 'areas', id: number, name: string } | undefined | null, categories: Array<{ __typename?: 'devices__device_categories', category: { __typename?: 'device_categories', id: number, key: string } }>, dashboards: Array<{ __typename?: 'applications_dashboards_devices', id: number }>, payloads: Array<{ __typename?: 'devices__device_payloads', id: number, payload: { __typename?: 'device_payloads', id: number, name: string, key: string, type: string, kind: string, payloadValues: Array<{ __typename?: 'device_payloads__payload_values', payloadValue?: { __typename?: 'device_payload_values', id: number, name: string, value: string } | undefined | null }> } }> }> } | undefined | null };

export type GetAreaLiteQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetAreaLiteQuery = { area?: { __typename?: 'areas', id: number, name: string, icon?: AreaIcon | undefined | null, scope: AreasScopesEnum, analysisApplications: Array<{ __typename?: 'analysis_applications', id: number }>, cultivation?: { __typename?: 'areas_scope_cultivation', nw?: number | undefined | null, wa?: number | undefined | null, wo?: number | undefined | null, clayPercentage?: number | undefined | null, cultivationType: CultivationTypesEnum, farmingContainer?: FarmingContainersEnum | undefined | null, farmingContainerCapacity?: number | undefined | null, farmingMethod: FarmingMethodsEnum, farmingStructure: FarmingStructuresEnum, organicMaterialPercentage?: number | undefined | null, sandPercentage?: number | undefined | null, substrate?: { __typename?: 'substrates', id: number, name: string, slug: string, kpa1: number, kpa5: number } | undefined | null } | undefined | null, devices: Array<{ __typename?: 'devices', id: number }> } | undefined | null };

export type CreateAreaMutationVariables = Exact<{
  input: AreaCreateInput;
}>;


export type CreateAreaMutation = { area?: { __typename?: 'AreaCreateOutput', id: number } | undefined | null };

export type EditAreaMutationVariables = Exact<{
  input: AreaUpdateInput;
}>;


export type EditAreaMutation = { area?: { __typename?: 'AreaUpdateOutput', id: number } | undefined | null };

export type DeleteAreaMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteAreaMutation = { area?: { __typename?: 'areas', id: number } | undefined | null };

export type AutomationDeviceFragment = { __typename?: 'devices', id: number, name: string, type: string };

export type AutomationSceneFragment = { __typename?: 'scenes', id: number, name: string, actions: SceneAction[], conditions: SceneCondition[], enabled: boolean, fromTime?: string | undefined | null, toTime?: string | undefined | null, executionTime?: string | undefined | null, timingExecutionKind: SceneTimingExecutionKindsEnum, weekDaysScheduling?: string | undefined | null, notificationsEnabled: boolean, devices: Array<{ __typename?: 'scenes__devices', id: number, device: { __typename?: 'devices', id: number, name: string, type: string } }> };

export type AutomationFragment = { __typename?: 'automations', id: number, name: string, enabled: boolean, updatedAt: string, monthlyScheduling?: string | undefined | null, timingExecutionKind: AutomationTimingExecutionKindsEnum, scenes: Array<{ __typename?: 'scenes', id: number, name: string, actions: SceneAction[], conditions: SceneCondition[], enabled: boolean, fromTime?: string | undefined | null, toTime?: string | undefined | null, executionTime?: string | undefined | null, timingExecutionKind: SceneTimingExecutionKindsEnum, weekDaysScheduling?: string | undefined | null, notificationsEnabled: boolean, devices: Array<{ __typename?: 'scenes__devices', id: number, device: { __typename?: 'devices', id: number, name: string, type: string } }> }>, watching: Array<{ __typename?: 'automations_watchings', id: number, userId: number }> };

export type InsertAutomationWithWatchingMutationVariables = Exact<{
  name: Scalars['String'];
  applicationId: Scalars['Int'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  scenes: Array<ScenesInsertInput> | ScenesInsertInput;
  userId?: InputMaybe<Scalars['Int']>;
  monthlyScheduling?: InputMaybe<Scalars['bpchar']>;
  timingExecutionKind?: InputMaybe<AutomationTimingExecutionKindsEnum>;
}>;


export type InsertAutomationWithWatchingMutation = { result?: { __typename?: 'automations', id: number } | undefined | null };

export type InsertAutomationMutationVariables = Exact<{
  name: Scalars['String'];
  applicationId: Scalars['Int'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  scenes: Array<ScenesInsertInput> | ScenesInsertInput;
  monthlyScheduling?: InputMaybe<Scalars['bpchar']>;
  timingExecutionKind?: InputMaybe<AutomationTimingExecutionKindsEnum>;
}>;


export type InsertAutomationMutation = { result?: { __typename?: 'automations', id: number } | undefined | null };

export type DuplicateAutomationMutationVariables = Exact<{
  automationId: Scalars['Int'];
}>;


export type DuplicateAutomationMutation = { duplicateAutomationResult: { __typename?: 'AutomationDuplicateOutput', id: number } };

export type DeleteAutomationsMutationVariables = Exact<{
  ids: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type DeleteAutomationsMutation = { result?: { __typename?: 'automations_mutation_response', rows: number } | undefined | null };

export type UpdateAutomationGeneralMutationVariables = Exact<{
  id: Scalars['Int'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  monthlyScheduling?: InputMaybe<Scalars['bpchar']>;
  timingExecutionKind?: InputMaybe<AutomationTimingExecutionKindsEnum>;
}>;


export type UpdateAutomationGeneralMutation = { result?: { __typename?: 'automations', id: number } | undefined | null };

export type UpdateAutomationGeneralAddingWatchingMutationVariables = Exact<{
  userId: Scalars['Int'];
  id: Scalars['Int'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  monthlyScheduling?: InputMaybe<Scalars['bpchar']>;
  timingExecutionKind?: InputMaybe<AutomationTimingExecutionKindsEnum>;
  automationIds: Array<Scalars['Int']> | Scalars['Int'];
  automationsWatching: Array<AutomationsWatchingsInsertInput> | AutomationsWatchingsInsertInput;
}>;


export type UpdateAutomationGeneralAddingWatchingMutation = { result?: { __typename?: 'automations', id: number } | undefined | null, delete_automations_watchings?: { __typename?: 'automations_watchings_mutation_response', rows: number } | undefined | null, resultWatching?: { __typename?: 'automations_watchings_mutation_response', returning: Array<{ __typename?: 'automations_watchings', automationId: number }> } | undefined | null };

export type UpdateAutomationGeneralDeletingWatchingMutationVariables = Exact<{
  userId: Scalars['Int'];
  id: Scalars['Int'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  monthlyScheduling?: InputMaybe<Scalars['bpchar']>;
  timingExecutionKind?: InputMaybe<AutomationTimingExecutionKindsEnum>;
  automationIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type UpdateAutomationGeneralDeletingWatchingMutation = { result?: { __typename?: 'automations', id: number } | undefined | null, resultWatching?: { __typename?: 'automations_watchings_mutation_response', rows: number } | undefined | null };

export type UpdateAutomationsEnabledMutationVariables = Exact<{
  enabled: Scalars['Boolean'];
  ids: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type UpdateAutomationsEnabledMutation = { result?: { __typename?: 'automations_mutation_response', rows: number } | undefined | null };

export type DeleteAutomationsWatchingMutationVariables = Exact<{
  automationIds: Array<Scalars['Int']> | Scalars['Int'];
  userId: Scalars['Int'];
}>;


export type DeleteAutomationsWatchingMutation = { result?: { __typename?: 'automations_watchings_mutation_response', rows: number } | undefined | null };

export type InsertAutomationsWatchingMutationVariables = Exact<{
  automationIds: Array<Scalars['Int']> | Scalars['Int'];
  automationsWatching: Array<AutomationsWatchingsInsertInput> | AutomationsWatchingsInsertInput;
  userId: Scalars['Int'];
}>;


export type InsertAutomationsWatchingMutation = { delete_automations_watchings?: { __typename?: 'automations_watchings_mutation_response', rows: number } | undefined | null, result?: { __typename?: 'automations_watchings_mutation_response', returning: Array<{ __typename?: 'automations_watchings', automationId: number }> } | undefined | null };

export type UpdateAutomationSceneMutationVariables = Exact<{
  id: Scalars['Int'];
  scene: ScenesSetInput;
  devices: Array<ScenesDevicesInsertInput> | ScenesDevicesInsertInput;
}>;


export type UpdateAutomationSceneMutation = { updated?: { __typename?: 'scenes', id: number } | undefined | null, delete_scenes__devices?: { __typename?: 'scenes__devices_mutation_response', returning: Array<{ __typename?: 'scenes__devices', id: number }> } | undefined | null, insert_scenes__devices?: { __typename?: 'scenes__devices_mutation_response', returning: Array<{ __typename?: 'scenes__devices', id: number }> } | undefined | null };

export type DeleteAutomationScenesMutationVariables = Exact<{
  ids: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type DeleteAutomationScenesMutation = { result?: { __typename?: 'scenes_mutation_response', rows: number } | undefined | null };

export type InsertAutomationScenesMutationVariables = Exact<{
  scenes: Array<ScenesInsertInput> | ScenesInsertInput;
}>;


export type InsertAutomationScenesMutation = { result?: { __typename?: 'scenes_mutation_response', returning: Array<{ __typename?: 'scenes', id: number }> } | undefined | null };

export type GetAutomationQueryVariables = Exact<{
  automationId: Scalars['Int'];
  userId: Scalars['Int'];
}>;


export type GetAutomationQuery = { automation?: { __typename?: 'automations', id: number, name: string, enabled: boolean, updatedAt: string, monthlyScheduling?: string | undefined | null, timingExecutionKind: AutomationTimingExecutionKindsEnum, scenes: Array<{ __typename?: 'scenes', id: number, name: string, actions: SceneAction[], conditions: SceneCondition[], enabled: boolean, fromTime?: string | undefined | null, toTime?: string | undefined | null, executionTime?: string | undefined | null, timingExecutionKind: SceneTimingExecutionKindsEnum, weekDaysScheduling?: string | undefined | null, notificationsEnabled: boolean, devices: Array<{ __typename?: 'scenes__devices', id: number, device: { __typename?: 'devices', id: number, name: string, type: string } }> }>, watching: Array<{ __typename?: 'automations_watchings', id: number, userId: number }> } | undefined | null };

export type GetAutomationsQueryVariables = Exact<{
  applicationId: Scalars['Int'];
  userId: Scalars['Int'];
}>;


export type GetAutomationsQuery = { automations: Array<{ __typename?: 'automations', id: number, name: string, enabled: boolean, updatedAt: string, monthlyScheduling?: string | undefined | null, timingExecutionKind: AutomationTimingExecutionKindsEnum, scenes: Array<{ __typename?: 'scenes', id: number, name: string, actions: SceneAction[], conditions: SceneCondition[], enabled: boolean, fromTime?: string | undefined | null, toTime?: string | undefined | null, executionTime?: string | undefined | null, timingExecutionKind: SceneTimingExecutionKindsEnum, weekDaysScheduling?: string | undefined | null, notificationsEnabled: boolean, devices: Array<{ __typename?: 'scenes__devices', id: number, device: { __typename?: 'devices', id: number, name: string, type: string } }> }>, watching: Array<{ __typename?: 'automations_watchings', id: number, userId: number }> }>, disabledAutomationsCounter: { __typename?: 'automations_aggregate', aggregate?: { __typename?: 'automations_aggregate_fields', count: number } | undefined | null }, enabledAutomationsCounter: { __typename?: 'automations_aggregate', aggregate?: { __typename?: 'automations_aggregate_fields', count: number } | undefined | null }, watchingAutomationsCounter: { __typename?: 'automations_aggregate', aggregate?: { __typename?: 'automations_aggregate_fields', count: number } | undefined | null } };

export type ChatMessageDataFragment = { __typename?: 'chat_messages', id: number, content: string, isUserMessage: boolean, createdAt: string };

export type OrganizationChatParamsDataFragment = { __typename?: 'organizations_chat_params', id: number, tokensMonthUsed: number };

export type GetChatMessagesQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  organizationId: Scalars['Int'];
  userId: Scalars['Int'];
}>;


export type GetChatMessagesQuery = { chatMessages: Array<{ __typename?: 'chat_messages', id: number, content: string, isUserMessage: boolean, createdAt: string }> };

export type DeleteChatMessagesMutationVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type DeleteChatMessagesMutation = { deleteChatMessages?: { __typename?: 'chat_messages_mutation_response', affected_rows: number } | undefined | null };

export type ChatMessagesSubscriptionVariables = Exact<{
  organizationId: Scalars['Int'];
  startDate: Scalars['timestamptz'];
  userId: Scalars['Int'];
}>;


export type ChatMessagesSubscription = { chatMessages: Array<{ __typename?: 'chat_messages', id: number, content: string, isUserMessage: boolean, createdAt: string }> };

export type OrganizationChatParamsSubscriptionVariables = Exact<{
  organizationId: Scalars['Int'];
}>;


export type OrganizationChatParamsSubscription = { organizationsChatParams: Array<{ __typename?: 'organizations_chat_params', id: number, tokensMonthUsed: number }> };

export type ApplicationDashboardDataFragment = { __typename?: 'applications_dashboards', id: number, analysesApplications: Array<{ __typename?: 'applications_dashboards_analysis', id: number, analysisApplication: { __typename?: 'analysis_applications', id: number, name: string, enabled: boolean, analysis: { __typename?: 'analysis', id: number, name: string, enabled: boolean, group: AnalysisGroupsEnum, slug: string, payloads: Array<{ __typename?: 'analysis__devices_payloads', payload: { __typename?: 'device_payloads', key: string, type: string } }> }, area?: { __typename?: 'areas', id: number, name: string, icon?: AreaIcon | undefined | null, scope: AreasScopesEnum, analysisApplications: Array<{ __typename?: 'analysis_applications', id: number }>, cultivation?: { __typename?: 'areas_scope_cultivation', nw?: number | undefined | null, wa?: number | undefined | null, wo?: number | undefined | null, clayPercentage?: number | undefined | null, cultivationType: CultivationTypesEnum, farmingContainer?: FarmingContainersEnum | undefined | null, farmingContainerCapacity?: number | undefined | null, farmingMethod: FarmingMethodsEnum, farmingStructure: FarmingStructuresEnum, organicMaterialPercentage?: number | undefined | null, sandPercentage?: number | undefined | null, substrate?: { __typename?: 'substrates', id: number, name: string, slug: string, kpa1: number, kpa5: number } | undefined | null } | undefined | null, devices: Array<{ __typename?: 'devices', id: number }> } | undefined | null, dashboards: Array<{ __typename?: 'applications_dashboards_analysis', id: number }>, devices: Array<{ __typename?: 'analysis_applications__devices', id: number, deleted: boolean, deletedAt?: string | undefined | null, device: { __typename?: 'devices', id: number, name: string, categories: Array<{ __typename?: 'devices__device_categories', category: { __typename?: 'device_categories', id: number, key: string } }>, payloads: Array<{ __typename?: 'devices__device_payloads', id: number, payload: { __typename?: 'device_payloads', id: number, name: string, key: string, type: string, kind: string, payloadValues: Array<{ __typename?: 'device_payloads__payload_values', payloadValue?: { __typename?: 'device_payload_values', id: number, name: string, value: string } | undefined | null }> } }> } }> } }>, devices: Array<{ __typename?: 'applications_dashboards_devices', id: number, device: { __typename?: 'devices', id: number, name: string, type: string } }> };

export type ApplicationsDashboardQueryVariables = Exact<{
  applicationId: Scalars['Int'];
}>;


export type ApplicationsDashboardQuery = { dashboards: Array<{ __typename?: 'applications_dashboards', id: number, analysesApplications: Array<{ __typename?: 'applications_dashboards_analysis', id: number, analysisApplication: { __typename?: 'analysis_applications', id: number, name: string, enabled: boolean, analysis: { __typename?: 'analysis', id: number, name: string, enabled: boolean, group: AnalysisGroupsEnum, slug: string, payloads: Array<{ __typename?: 'analysis__devices_payloads', payload: { __typename?: 'device_payloads', key: string, type: string } }> }, area?: { __typename?: 'areas', id: number, name: string, icon?: AreaIcon | undefined | null, scope: AreasScopesEnum, analysisApplications: Array<{ __typename?: 'analysis_applications', id: number }>, cultivation?: { __typename?: 'areas_scope_cultivation', nw?: number | undefined | null, wa?: number | undefined | null, wo?: number | undefined | null, clayPercentage?: number | undefined | null, cultivationType: CultivationTypesEnum, farmingContainer?: FarmingContainersEnum | undefined | null, farmingContainerCapacity?: number | undefined | null, farmingMethod: FarmingMethodsEnum, farmingStructure: FarmingStructuresEnum, organicMaterialPercentage?: number | undefined | null, sandPercentage?: number | undefined | null, substrate?: { __typename?: 'substrates', id: number, name: string, slug: string, kpa1: number, kpa5: number } | undefined | null } | undefined | null, devices: Array<{ __typename?: 'devices', id: number }> } | undefined | null, dashboards: Array<{ __typename?: 'applications_dashboards_analysis', id: number }>, devices: Array<{ __typename?: 'analysis_applications__devices', id: number, deleted: boolean, deletedAt?: string | undefined | null, device: { __typename?: 'devices', id: number, name: string, categories: Array<{ __typename?: 'devices__device_categories', category: { __typename?: 'device_categories', id: number, key: string } }>, payloads: Array<{ __typename?: 'devices__device_payloads', id: number, payload: { __typename?: 'device_payloads', id: number, name: string, key: string, type: string, kind: string, payloadValues: Array<{ __typename?: 'device_payloads__payload_values', payloadValue?: { __typename?: 'device_payload_values', id: number, name: string, value: string } | undefined | null }> } }> } }> } }>, devices: Array<{ __typename?: 'applications_dashboards_devices', id: number, device: { __typename?: 'devices', id: number, name: string, type: string } }> }> };

export type LastApplicationEventsQueryVariables = Exact<{
  applicationId: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type LastApplicationEventsQuery = { notificationsEvents: Array<{ __typename?: 'notifications', id: number, kind: NotificationKindsEnum, read: boolean, createdAt: string, content: { __typename?: 'notifications_content', id: number, values?: NotificationValuesComplete | undefined | null } }> };

export type UpdateApplicationsDashboardMutationVariables = Exact<{
  applicationDashboardId: Scalars['Int'];
  objects: Array<ApplicationsDashboardsDevicesInsertInput> | ApplicationsDashboardsDevicesInsertInput;
}>;


export type UpdateApplicationsDashboardMutation = { delete_applications_dashboards_devices?: { __typename?: 'applications_dashboards_devices_mutation_response', affected_rows: number } | undefined | null, insert_applications_dashboards_devices?: { __typename?: 'applications_dashboards_devices_mutation_response', affected_rows: number } | undefined | null };

export type UpdateAnalysesApplicationsDashboardMutationVariables = Exact<{
  applicationDashboardId: Scalars['Int'];
  objects: Array<ApplicationsDashboardsAnalysisInsertInput> | ApplicationsDashboardsAnalysisInsertInput;
}>;


export type UpdateAnalysesApplicationsDashboardMutation = { delete_applications_dashboards_analysis?: { __typename?: 'applications_dashboards_analysis_mutation_response', affected_rows: number } | undefined | null, insert_applications_dashboards_analysis?: { __typename?: 'applications_dashboards_analysis_mutation_response', affected_rows: number } | undefined | null };

export type DeviceLiteFragment = { __typename?: 'devices', id: number, name: string, providerId: string, type: string, area?: { __typename?: 'areas', id: number, name: string } | undefined | null, categories: Array<{ __typename?: 'devices__device_categories', category: { __typename?: 'device_categories', id: number, key: string } }>, dashboards: Array<{ __typename?: 'applications_dashboards_devices', id: number }>, payloads: Array<{ __typename?: 'devices__device_payloads', id: number, payload: { __typename?: 'device_payloads', id: number, name: string, key: string, type: string, kind: string, payloadValues: Array<{ __typename?: 'device_payloads__payload_values', payloadValue?: { __typename?: 'device_payload_values', id: number, name: string, value: string } | undefined | null }> } }> };

export type DeviceActionDataFragment = { __typename?: 'device_actions', id: number, name: string, key: string, value: string };

export type DeviceApplicationDataFragment = { __typename?: 'devices', id: number, name: string, providerId: string, type: string, actions: Array<{ __typename?: 'devices__device_actions', id: number, action?: { __typename?: 'device_actions', id: number, name: string, key: string, value: string } | undefined | null }>, area?: { __typename?: 'areas', id: number, name: string, icon?: AreaIcon | undefined | null, scope: AreasScopesEnum, cultivation?: { __typename?: 'areas_scope_cultivation', clayPercentage?: number | undefined | null, cultivationType: CultivationTypesEnum, farmingContainer?: FarmingContainersEnum | undefined | null, farmingContainerCapacity?: number | undefined | null, farmingMethod: FarmingMethodsEnum, farmingStructure: FarmingStructuresEnum, organicMaterialPercentage?: number | undefined | null, sandPercentage?: number | undefined | null, substrate?: { __typename?: 'substrates', id: number, name: string, slug: string } | undefined | null } | undefined | null } | undefined | null, categories: Array<{ __typename?: 'devices__device_categories', category: { __typename?: 'device_categories', id: number, key: string } }>, dashboards: Array<{ __typename?: 'applications_dashboards_devices', id: number }>, payloads: Array<{ __typename?: 'devices__device_payloads', id: number, payload: { __typename?: 'device_payloads', id: number, name: string, key: string, type: string, kind: string, payloadValues: Array<{ __typename?: 'device_payloads__payload_values', payloadValue?: { __typename?: 'device_payload_values', id: number, name: string, value: string } | undefined | null }> } }> };

export type DevicesApplicationQueryVariables = Exact<{
  applicationId: Scalars['Int'];
}>;


export type DevicesApplicationQuery = { devices: Array<{ __typename?: 'devices', id: number, name: string, providerId: string, type: string, actions: Array<{ __typename?: 'devices__device_actions', id: number, action?: { __typename?: 'device_actions', id: number, name: string, key: string, value: string } | undefined | null }>, area?: { __typename?: 'areas', id: number, name: string, icon?: AreaIcon | undefined | null, scope: AreasScopesEnum, cultivation?: { __typename?: 'areas_scope_cultivation', clayPercentage?: number | undefined | null, cultivationType: CultivationTypesEnum, farmingContainer?: FarmingContainersEnum | undefined | null, farmingContainerCapacity?: number | undefined | null, farmingMethod: FarmingMethodsEnum, farmingStructure: FarmingStructuresEnum, organicMaterialPercentage?: number | undefined | null, sandPercentage?: number | undefined | null, substrate?: { __typename?: 'substrates', id: number, name: string, slug: string } | undefined | null } | undefined | null } | undefined | null, categories: Array<{ __typename?: 'devices__device_categories', category: { __typename?: 'device_categories', id: number, key: string } }>, dashboards: Array<{ __typename?: 'applications_dashboards_devices', id: number }>, payloads: Array<{ __typename?: 'devices__device_payloads', id: number, payload: { __typename?: 'device_payloads', id: number, name: string, key: string, type: string, kind: string, payloadValues: Array<{ __typename?: 'device_payloads__payload_values', payloadValue?: { __typename?: 'device_payload_values', id: number, name: string, value: string } | undefined | null }> } }> }> };

export type DevicesApplicationProviderIdQueryVariables = Exact<{
  applicationProviderId: Scalars['String'];
}>;


export type DevicesApplicationProviderIdQuery = { devices: Array<{ __typename?: 'devices', id: number, name: string, providerId: string, type: string, area?: { __typename?: 'areas', id: number, name: string } | undefined | null, categories: Array<{ __typename?: 'devices__device_categories', category: { __typename?: 'device_categories', id: number, key: string } }>, dashboards: Array<{ __typename?: 'applications_dashboards_devices', id: number }>, payloads: Array<{ __typename?: 'devices__device_payloads', id: number, payload: { __typename?: 'device_payloads', id: number, name: string, key: string, type: string, kind: string, payloadValues: Array<{ __typename?: 'device_payloads__payload_values', payloadValue?: { __typename?: 'device_payload_values', id: number, name: string, value: string } | undefined | null }> } }> }> };

export type DevicesApplicationCountQueryVariables = Exact<{
  applicationId: Scalars['Int'];
}>;


export type DevicesApplicationCountQuery = { devicesCount: { __typename?: 'devices_aggregate', aggregate?: { __typename?: 'devices_aggregate_fields', count: number } | undefined | null } };

export type DevicesApplicationByTypeQueryVariables = Exact<{
  applicationId: Scalars['Int'];
  deviceType: Scalars['String'];
}>;


export type DevicesApplicationByTypeQuery = { devices: Array<{ __typename?: 'devices', id: number, name: string, providerId: string, type: string, actions: Array<{ __typename?: 'devices__device_actions', id: number, action?: { __typename?: 'device_actions', id: number, name: string, key: string, value: string } | undefined | null }>, area?: { __typename?: 'areas', id: number, name: string, icon?: AreaIcon | undefined | null, scope: AreasScopesEnum, cultivation?: { __typename?: 'areas_scope_cultivation', clayPercentage?: number | undefined | null, cultivationType: CultivationTypesEnum, farmingContainer?: FarmingContainersEnum | undefined | null, farmingContainerCapacity?: number | undefined | null, farmingMethod: FarmingMethodsEnum, farmingStructure: FarmingStructuresEnum, organicMaterialPercentage?: number | undefined | null, sandPercentage?: number | undefined | null, substrate?: { __typename?: 'substrates', id: number, name: string, slug: string } | undefined | null } | undefined | null } | undefined | null, categories: Array<{ __typename?: 'devices__device_categories', category: { __typename?: 'device_categories', id: number, key: string } }>, dashboards: Array<{ __typename?: 'applications_dashboards_devices', id: number }>, payloads: Array<{ __typename?: 'devices__device_payloads', id: number, payload: { __typename?: 'device_payloads', id: number, name: string, key: string, type: string, kind: string, payloadValues: Array<{ __typename?: 'device_payloads__payload_values', payloadValue?: { __typename?: 'device_payload_values', id: number, name: string, value: string } | undefined | null }> } }> }> };

export type DevicesByCategoriesQueryVariables = Exact<{
  applicationId: Scalars['Int'];
  categoriesIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type DevicesByCategoriesQuery = { devices: Array<{ __typename?: 'devices', id: number, name: string, providerId: string, type: string, actions: Array<{ __typename?: 'devices__device_actions', id: number, action?: { __typename?: 'device_actions', id: number, name: string, key: string, value: string } | undefined | null }>, area?: { __typename?: 'areas', id: number, name: string, icon?: AreaIcon | undefined | null, scope: AreasScopesEnum, cultivation?: { __typename?: 'areas_scope_cultivation', clayPercentage?: number | undefined | null, cultivationType: CultivationTypesEnum, farmingContainer?: FarmingContainersEnum | undefined | null, farmingContainerCapacity?: number | undefined | null, farmingMethod: FarmingMethodsEnum, farmingStructure: FarmingStructuresEnum, organicMaterialPercentage?: number | undefined | null, sandPercentage?: number | undefined | null, substrate?: { __typename?: 'substrates', id: number, name: string, slug: string } | undefined | null } | undefined | null } | undefined | null, categories: Array<{ __typename?: 'devices__device_categories', category: { __typename?: 'device_categories', id: number, key: string } }>, dashboards: Array<{ __typename?: 'applications_dashboards_devices', id: number }>, payloads: Array<{ __typename?: 'devices__device_payloads', id: number, payload: { __typename?: 'device_payloads', id: number, name: string, key: string, type: string, kind: string, payloadValues: Array<{ __typename?: 'device_payloads__payload_values', payloadValue?: { __typename?: 'device_payload_values', id: number, name: string, value: string } | undefined | null }> } }> }> };

export type DevicesAsSensorsAndSwitchesQueryVariables = Exact<{
  applicationId: Scalars['Int'];
}>;


export type DevicesAsSensorsAndSwitchesQuery = { sensors: Array<{ __typename?: 'devices', id: number, name: string, providerId: string, type: string, actions: Array<{ __typename?: 'devices__device_actions', id: number, action?: { __typename?: 'device_actions', id: number, name: string, key: string, value: string } | undefined | null }>, area?: { __typename?: 'areas', id: number, name: string, icon?: AreaIcon | undefined | null, scope: AreasScopesEnum, cultivation?: { __typename?: 'areas_scope_cultivation', clayPercentage?: number | undefined | null, cultivationType: CultivationTypesEnum, farmingContainer?: FarmingContainersEnum | undefined | null, farmingContainerCapacity?: number | undefined | null, farmingMethod: FarmingMethodsEnum, farmingStructure: FarmingStructuresEnum, organicMaterialPercentage?: number | undefined | null, sandPercentage?: number | undefined | null, substrate?: { __typename?: 'substrates', id: number, name: string, slug: string } | undefined | null } | undefined | null } | undefined | null, categories: Array<{ __typename?: 'devices__device_categories', category: { __typename?: 'device_categories', id: number, key: string } }>, dashboards: Array<{ __typename?: 'applications_dashboards_devices', id: number }>, payloads: Array<{ __typename?: 'devices__device_payloads', id: number, payload: { __typename?: 'device_payloads', id: number, name: string, key: string, type: string, kind: string, payloadValues: Array<{ __typename?: 'device_payloads__payload_values', payloadValue?: { __typename?: 'device_payload_values', id: number, name: string, value: string } | undefined | null }> } }> }>, switches: Array<{ __typename?: 'devices', id: number, name: string, providerId: string, type: string, actions: Array<{ __typename?: 'devices__device_actions', id: number, action?: { __typename?: 'device_actions', id: number, name: string, key: string, value: string } | undefined | null }>, area?: { __typename?: 'areas', id: number, name: string, icon?: AreaIcon | undefined | null, scope: AreasScopesEnum, cultivation?: { __typename?: 'areas_scope_cultivation', clayPercentage?: number | undefined | null, cultivationType: CultivationTypesEnum, farmingContainer?: FarmingContainersEnum | undefined | null, farmingContainerCapacity?: number | undefined | null, farmingMethod: FarmingMethodsEnum, farmingStructure: FarmingStructuresEnum, organicMaterialPercentage?: number | undefined | null, sandPercentage?: number | undefined | null, substrate?: { __typename?: 'substrates', id: number, name: string, slug: string } | undefined | null } | undefined | null } | undefined | null, categories: Array<{ __typename?: 'devices__device_categories', category: { __typename?: 'device_categories', id: number, key: string } }>, dashboards: Array<{ __typename?: 'applications_dashboards_devices', id: number }>, payloads: Array<{ __typename?: 'devices__device_payloads', id: number, payload: { __typename?: 'device_payloads', id: number, name: string, key: string, type: string, kind: string, payloadValues: Array<{ __typename?: 'device_payloads__payload_values', payloadValue?: { __typename?: 'device_payload_values', id: number, name: string, value: string } | undefined | null }> } }> }> };

export type DeviceByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeviceByIdQuery = { devices: Array<{ __typename?: 'devices', id: number, name: string, providerId: string, type: string, actions: Array<{ __typename?: 'devices__device_actions', id: number, action?: { __typename?: 'device_actions', id: number, name: string, key: string, value: string } | undefined | null }>, area?: { __typename?: 'areas', id: number, name: string, icon?: AreaIcon | undefined | null, scope: AreasScopesEnum, cultivation?: { __typename?: 'areas_scope_cultivation', clayPercentage?: number | undefined | null, cultivationType: CultivationTypesEnum, farmingContainer?: FarmingContainersEnum | undefined | null, farmingContainerCapacity?: number | undefined | null, farmingMethod: FarmingMethodsEnum, farmingStructure: FarmingStructuresEnum, organicMaterialPercentage?: number | undefined | null, sandPercentage?: number | undefined | null, substrate?: { __typename?: 'substrates', id: number, name: string, slug: string } | undefined | null } | undefined | null } | undefined | null, categories: Array<{ __typename?: 'devices__device_categories', category: { __typename?: 'device_categories', id: number, key: string } }>, dashboards: Array<{ __typename?: 'applications_dashboards_devices', id: number }>, payloads: Array<{ __typename?: 'devices__device_payloads', id: number, payload: { __typename?: 'device_payloads', id: number, name: string, key: string, type: string, kind: string, payloadValues: Array<{ __typename?: 'device_payloads__payload_values', payloadValue?: { __typename?: 'device_payload_values', id: number, name: string, value: string } | undefined | null }> } }> }> };

export type DeviceDetailDataFragment = { __typename?: 'DeviceDetailOutput', id: number, name: string, hasDashboard: boolean, lastSeen?: string | undefined | null, avgPayloads: Array<{ __typename?: 'DeviceDetailAvgMinMaxPayload', avg?: number | undefined | null, key: string, max?: number | undefined | null, min?: number | undefined | null, payloadKind: string, type: string }>, chart?: { __typename?: 'ChartPayload', dataset?: Dataset | undefined | null, lines?: Array<{ __typename?: 'ChartLines', payloadKey: string, payloadType: string }> | undefined | null } | undefined | null, extraAvgPayloads: Array<{ __typename?: 'DeviceDetailAvgMinMaxPayload', avg?: number | undefined | null, key: string, max?: number | undefined | null, min?: number | undefined | null, payloadKind: string, type: string }>, lastUplink: Array<{ __typename?: 'DeviceDetailLastUplink', key: string, kind: string, type: string, value: number }>, signal: { __typename?: 'DeviceDetailSignal', rssi: number, sentiment: number, snr: number } };

export type DeviceDetailQueryVariables = Exact<{
  deviceId: Scalars['Int'];
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
}>;


export type DeviceDetailQuery = { deviceDetail?: { __typename?: 'DeviceDetailOutput', id: number, name: string, hasDashboard: boolean, lastSeen?: string | undefined | null, avgPayloads: Array<{ __typename?: 'DeviceDetailAvgMinMaxPayload', avg?: number | undefined | null, key: string, max?: number | undefined | null, min?: number | undefined | null, payloadKind: string, type: string }>, chart?: { __typename?: 'ChartPayload', dataset?: Dataset | undefined | null, lines?: Array<{ __typename?: 'ChartLines', payloadKey: string, payloadType: string }> | undefined | null } | undefined | null, extraAvgPayloads: Array<{ __typename?: 'DeviceDetailAvgMinMaxPayload', avg?: number | undefined | null, key: string, max?: number | undefined | null, min?: number | undefined | null, payloadKind: string, type: string }>, lastUplink: Array<{ __typename?: 'DeviceDetailLastUplink', key: string, kind: string, type: string, value: number }>, signal: { __typename?: 'DeviceDetailSignal', rssi: number, sentiment: number, snr: number } } | undefined | null, moreData?: { __typename?: 'devices', area?: { __typename?: 'areas', id: number } | undefined | null } | undefined | null };

export type DeviceDetailPreviewQueryVariables = Exact<{
  deviceId: Scalars['Int'];
  endDate?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  startDate?: InputMaybe<Scalars['String']>;
}>;


export type DeviceDetailPreviewQuery = { deviceDetailPreview?: { __typename?: 'DeviceDetailOutput', id: number, name: string, hasDashboard: boolean, lastSeen?: string | undefined | null, avgPayloads: Array<{ __typename?: 'DeviceDetailAvgMinMaxPayload', avg?: number | undefined | null, key: string, max?: number | undefined | null, min?: number | undefined | null, payloadKind: string, type: string }>, chart?: { __typename?: 'ChartPayload', dataset?: Dataset | undefined | null, lines?: Array<{ __typename?: 'ChartLines', payloadKey: string, payloadType: string }> | undefined | null } | undefined | null, extraAvgPayloads: Array<{ __typename?: 'DeviceDetailAvgMinMaxPayload', avg?: number | undefined | null, key: string, max?: number | undefined | null, min?: number | undefined | null, payloadKind: string, type: string }>, lastUplink: Array<{ __typename?: 'DeviceDetailLastUplink', key: string, kind: string, type: string, value: number }>, signal: { __typename?: 'DeviceDetailSignal', rssi: number, sentiment: number, snr: number } } | undefined | null, moreData?: { __typename?: 'devices', area?: { __typename?: 'areas', id: number } | undefined | null } | undefined | null };

export type DeviceNotificationsEventTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type DeviceNotificationsEventTypesQuery = { deviceEventTypes: Array<{ __typename?: 'notification_event_types', id: number, event?: string | undefined | null }> };

export type DeviceInSceneDataFragment = { __typename?: 'scenes', actions: SceneAction[], sceneId: number, sceneName: string, automation: { __typename?: 'automations', id: number, name: string } };

export type DevicesInScenesQueryVariables = Exact<{
  currentSceneId: Scalars['Int'];
  deviceId: Scalars['Int'];
}>;


export type DevicesInScenesQuery = { deviceInScenes: Array<{ __typename?: 'scenes', actions: SceneAction[], sceneId: number, sceneName: string, automation: { __typename?: 'automations', id: number, name: string } }> };

export type DevicesInScenesCountQueryVariables = Exact<{
  currentSceneId: Scalars['Int'];
  deviceId: Scalars['Int'];
}>;


export type DevicesInScenesCountQuery = { deviceInScenesCount: { __typename?: 'scenes_aggregate', aggregate?: { __typename?: 'scenes_aggregate_fields', count: number } | undefined | null } };

export type DeviceCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type DeviceCategoriesQuery = { deviceCategories: Array<{ __typename?: 'device_categories', id: number, key: string }> };

export type DeviceLastUplinkSubscriptionVariables = Exact<{
  deviceId: Scalars['Int'];
}>;


export type DeviceLastUplinkSubscription = { lastUplink: Array<{ __typename?: 'uplink_dynamo_ref', id: number, lastUplinkData: unknown }> };

export type UpdateDeviceDetailsMutationVariables = Exact<{
  deviceId: Scalars['Int'];
  deviceName: Scalars['String'];
}>;


export type UpdateDeviceDetailsMutation = { result?: { __typename?: 'devices_mutation_response', returning: Array<{ __typename?: 'devices', id: number, name: string }> } | undefined | null };

export type SendDeviceActionMutationVariables = Exact<{
  actionId: Scalars['Int'];
  deviceId: Scalars['Int'];
}>;


export type SendDeviceActionMutation = { result: { __typename?: 'DeviceDownlinkOutput', id: number } };

export type NotificationDataFragment = { __typename?: 'notifications', id: number, kind: NotificationKindsEnum, read: boolean, createdAt: string, content: { __typename?: 'notifications_content', id: number, values?: NotificationValuesComplete | undefined | null } };

export type NotificationContentMessageInnerFragment = { __typename?: 'notifications_content', id: number, hygraph?: { __typename?: 'MessagesCollection', id: string, publishedAt?: string | undefined | null, author?: { __typename?: 'Author', id: string, name: string, avatar: { __typename?: 'Asset', id: string, url: string } } | undefined | null, message: { __typename?: 'Message', id: string, excerpt?: string | undefined | null, shortTitle: string, title: string, content: { __typename?: 'RichText', raw?: RichTextProps['content'] | undefined | null } } } | undefined | null };

export type NotificationContentMessageDataFragment = { __typename?: 'notifications', content: { __typename?: 'notifications_content', id: number, hygraph?: { __typename?: 'MessagesCollection', id: string, publishedAt?: string | undefined | null, author?: { __typename?: 'Author', id: string, name: string, avatar: { __typename?: 'Asset', id: string, url: string } } | undefined | null, message: { __typename?: 'Message', id: string, excerpt?: string | undefined | null, shortTitle: string, title: string, content: { __typename?: 'RichText', raw?: RichTextProps['content'] | undefined | null } } } | undefined | null } };

export type NotificationContentReleaseInnerFragment = { __typename?: 'notifications_content', id: number, hygraph?: { __typename?: 'ReleasesCollection', id: string, publishedAt?: string | undefined | null, release: { __typename?: 'Release', id: string, changed: Array<string>, content?: string | undefined | null, new: Array<string>, version?: string | undefined | null } } | undefined | null };

export type NotificationContentReleaseDataFragment = { __typename?: 'notifications', content: { __typename?: 'notifications_content', id: number, hygraph?: { __typename?: 'ReleasesCollection', id: string, publishedAt?: string | undefined | null, release: { __typename?: 'Release', id: string, changed: Array<string>, content?: string | undefined | null, new: Array<string>, version?: string | undefined | null } } | undefined | null } };

export type NotificationsEventsQueryVariables = Exact<{
  offset: Scalars['Int'];
}>;


export type NotificationsEventsQuery = { notificationsEvents: Array<{ __typename?: 'notifications', id: number, kind: NotificationKindsEnum, read: boolean, createdAt: string, content: { __typename?: 'notifications_content', id: number, values?: NotificationValuesComplete | undefined | null } }> };

export type NotificationsMessagesQueryVariables = Exact<{
  locale?: InputMaybe<Array<Locale> | Locale>;
  offset: Scalars['Int'];
}>;


export type NotificationsMessagesQuery = { notificationsMessages: Array<{ __typename?: 'notifications', id: number, kind: NotificationKindsEnum, read: boolean, createdAt: string, content: { __typename?: 'notifications_content', id: number, values?: NotificationValuesComplete | undefined | null, hygraph?: { __typename?: 'MessagesCollection', id: string, publishedAt?: string | undefined | null, author?: { __typename?: 'Author', id: string, name: string, avatar: { __typename?: 'Asset', id: string, url: string } } | undefined | null, message: { __typename?: 'Message', id: string, excerpt?: string | undefined | null, shortTitle: string, title: string, content: { __typename?: 'RichText', raw?: RichTextProps['content'] | undefined | null } } } | undefined | null } }> };

export type NotificationsReleasesQueryVariables = Exact<{
  locale?: InputMaybe<Array<Locale> | Locale>;
  offset: Scalars['Int'];
}>;


export type NotificationsReleasesQuery = { notificationsReleases: Array<{ __typename?: 'notifications', id: number, kind: NotificationKindsEnum, read: boolean, createdAt: string, content: { __typename?: 'notifications_content', id: number, values?: NotificationValuesComplete | undefined | null, hygraph?: { __typename?: 'ReleasesCollection', id: string, publishedAt?: string | undefined | null, release: { __typename?: 'Release', id: string, changed: Array<string>, content?: string | undefined | null, new: Array<string>, version?: string | undefined | null } } | undefined | null } }> };

export type NotificationsSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsSettingsQuery = { notificationsSettings: Array<{ __typename?: 'notification_user_settings', id: number, eventsEnabled: boolean, messagesEnabled: boolean, releasesEnabled: boolean }> };

export type NotificationsNotReadCountQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsNotReadCountQuery = { notificationsNotReadCount: { __typename?: 'notifications_aggregate', aggregate?: { __typename?: 'notifications_aggregate_fields', count: number } | undefined | null } };

export type NotificationsNotReadCountByTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsNotReadCountByTypeQuery = { notificationsNotReadEvents: { __typename?: 'notifications_aggregate', aggregate?: { __typename?: 'notifications_aggregate_fields', count: number } | undefined | null }, notificationsNotReadMessages: { __typename?: 'notifications_aggregate', aggregate?: { __typename?: 'notifications_aggregate_fields', count: number } | undefined | null }, notificationsNotReadReleases: { __typename?: 'notifications_aggregate', aggregate?: { __typename?: 'notifications_aggregate_fields', count: number } | undefined | null } };

export type NotificationMessageContentQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  notificationContentId: Scalars['bigint'];
}>;


export type NotificationMessageContentQuery = { notification: Array<{ __typename?: 'notifications', content: { __typename?: 'notifications_content', id: number, hygraph?: { __typename?: 'MessagesCollection', id: string, publishedAt?: string | undefined | null, author?: { __typename?: 'Author', id: string, name: string, avatar: { __typename?: 'Asset', id: string, url: string } } | undefined | null, message: { __typename?: 'Message', id: string, excerpt?: string | undefined | null, shortTitle: string, title: string, content: { __typename?: 'RichText', raw?: RichTextProps['content'] | undefined | null } } } | undefined | null } }> };

export type NotificationReleaseContentQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  notificationContentId: Scalars['bigint'];
}>;


export type NotificationReleaseContentQuery = { notification: Array<{ __typename?: 'notifications', content: { __typename?: 'notifications_content', id: number, hygraph?: { __typename?: 'ReleasesCollection', id: string, publishedAt?: string | undefined | null, release: { __typename?: 'Release', id: string, changed: Array<string>, content?: string | undefined | null, new: Array<string>, version?: string | undefined | null } } | undefined | null } }> };

export type NotificationsReadMutationVariables = Exact<{
  ids: Array<Scalars['bigint']> | Scalars['bigint'];
}>;


export type NotificationsReadMutation = { updateNotifications?: { __typename?: 'notifications_mutation_response', count: number } | undefined | null };

export type NotificationsAllReadMutationVariables = Exact<{ [key: string]: never; }>;


export type NotificationsAllReadMutation = { updateNotifications?: { __typename?: 'notifications_mutation_response', count: number } | undefined | null };

export type NotificationsSettingsUpdateMutationVariables = Exact<{
  id: Scalars['Int'];
  props: NotificationUserSettingsSetInput;
}>;


export type NotificationsSettingsUpdateMutation = { updateNotificationsSettings?: { __typename?: 'notification_user_settings', id: number } | undefined | null };

export type OrganizationFeatureLimitsFragment = { __typename?: 'organizations_feature_limits', analysis: number, applications: number, automations: number, preventions: number, users: number, maxChatHistoryMessages: number, maxChatTokensMonth: number, chatContextDatasetHours: number };

export type OrganizationFeatureLimitsQueryVariables = Exact<{
  organizationId: Scalars['Int'];
}>;


export type OrganizationFeatureLimitsQuery = { featureLimits: Array<{ __typename?: 'organizations_feature_limits', analysis: number, applications: number, automations: number, preventions: number, users: number, maxChatHistoryMessages: number, maxChatTokensMonth: number, chatContextDatasetHours: number }> };

export type CannyLoginCreateMutationVariables = Exact<{ [key: string]: never; }>;


export type CannyLoginCreateMutation = { cannyLoginCreate?: { __typename?: 'CannyLoginCreateOutput', token: string } | undefined | null };

export type UserDataFragment = { __typename?: 'users_permissions_user', id: number, blocked?: boolean | undefined | null, email: string, avatarUrl?: string | undefined | null, organizations: Array<{ __typename?: 'organizations_users__users_organizations', id: number }>, telegramUsers: Array<{ __typename?: 'telegram_users', id: number, active?: boolean | undefined | null, telegramId?: number | undefined | null, telegramUsername: string }> };

export type UserQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UserQuery = { user?: { __typename?: 'users_permissions_user', id: number, blocked?: boolean | undefined | null, email: string, avatarUrl?: string | undefined | null, organizations: Array<{ __typename?: 'organizations_users__users_organizations', id: number }>, telegramUsers: Array<{ __typename?: 'telegram_users', id: number, active?: boolean | undefined | null, telegramId?: number | undefined | null, telegramUsername: string }> } | undefined | null };

export type UserDevicesNotificationsQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type UserDevicesNotificationsQuery = { userDeviceNotifications: Array<{ __typename?: 'notification_user_devices', id: number, device?: { __typename?: 'devices', id: number } | undefined | null }> };

export type UserDeviceNotificationQueryVariables = Exact<{
  deviceId: Scalars['Int'];
  userId: Scalars['Int'];
}>;


export type UserDeviceNotificationQuery = { userDeviceNotification: Array<{ __typename?: 'notification_user_devices', id: number }> };

export type AddUserDeviceNotificationEventTypesMutationVariables = Exact<{
  deviceId: Scalars['Int'];
  notificationEventTypesInput: Array<NotificationUserDevicesEventTypesInsertInput> | NotificationUserDevicesEventTypesInsertInput;
  userId: Scalars['Int'];
}>;


export type AddUserDeviceNotificationEventTypesMutation = { delete_notification_user_devices?: { __typename?: 'notification_user_devices_mutation_response', affected_rows: number } | undefined | null, insert_notification_user_devices_one?: { __typename?: 'notification_user_devices', id: number } | undefined | null };

export type DeleteUserDeviceNotificationsMutationVariables = Exact<{
  deviceId: Scalars['Int'];
  userId: Scalars['Int'];
}>;


export type DeleteUserDeviceNotificationsMutation = { delete_notification_user_devices?: { __typename?: 'notification_user_devices_mutation_response', affected_rows: number } | undefined | null };

export type AddTelegramUserMutationVariables = Exact<{
  telegramUsername: Scalars['String'];
  userId: Scalars['Int'];
}>;


export type AddTelegramUserMutation = { insert_telegram_users_one?: { __typename?: 'telegram_users', id: number, telegramUsername: string, userId?: number | undefined | null } | undefined | null };

export type UpdateTelegramUserMutationVariables = Exact<{
  id: Scalars['Int'];
  telegramUsername: Scalars['String'];
}>;


export type UpdateTelegramUserMutation = { update_telegram_users_by_pk?: { __typename?: 'telegram_users', id: number, telegramUsername: string } | undefined | null };

export type UpdateTelegramUserStatusMutationVariables = Exact<{
  id: Scalars['Int'];
  active: Scalars['Boolean'];
}>;


export type UpdateTelegramUserStatusMutation = { update_telegram_users_by_pk?: { __typename?: 'telegram_users', id: number, active?: boolean | undefined | null } | undefined | null };

export const AnalysisAvailableDataFragmentDoc = gql`
    fragment AnalysisAvailableData on analysis {
  id
  name
  analysisApplications: analysis_applications(
    where: {application_id: {_eq: $applicationId}}
  ) {
    id
    devices {
      id
      deleted
      deletedAt: deleted_at
      deviceId: device_id
    }
  }
  devicesCategories: device_categories_configs {
    deviceCategory: device_category {
      id
      key
    }
    max
    min
  }
  enabled
  group
  kind
  payloads: analysis__devices_payloads {
    id
    payloadId: device_payload_id
  }
  slug
}
    `;
export const AnalysisComputedDataFragmentDoc = gql`
    fragment AnalysisComputedData on analysis_applications_computed {
  prob: last_computed_value(args: {kind: "PROB"})
  temperature: last_computed_value(
    args: {kind: "PAYLOAD_VALUE", key: "temperature"}
  )
  wetness: last_computed_value(args: {kind: "PAYLOAD_VALUE", key: "wetness"})
  x: computed_at
}
    `;
export const AnalysisHealthComputedDataFragmentDoc = gql`
    fragment AnalysisHealthComputedData on analysis_applications_computed {
  values {
    deviceId: device_id
    devicePayload: device_payload {
      id
      name
      key
      type
    }
    value
  }
  x: computed_at
}
    `;
export const CultivationDataFragmentDoc = gql`
    fragment CultivationData on areas_scope_cultivation {
  clayPercentage: clay_percentage
  cultivationType: cultivation_type
  farmingContainer: farming_container
  farmingContainerCapacity: farming_container_capacity
  farmingMethod: farming_method
  farmingStructure: farming_structure
  organicMaterialPercentage: organic_material_percentage
  sandPercentage: sand_percentage
  substrate {
    id
    name
    slug
  }
}
    `;
export const AreaDeviceFragmentDoc = gql`
    fragment AreaDevice on devices {
  id
  name
  area {
    id
    name
  }
  categories {
    category {
      id
      key
    }
  }
  dashboards {
    id
  }
  payloads: device_payloads(order_by: {device_payload: {key: desc}}) {
    id
    payload: device_payload {
      id
      name
      key
      kind: payload_kind
      payloadValues: payload_values {
        payloadValue: value {
          id
          name
          value
        }
      }
      type
    }
  }
  providerId: provider_id
  type: device_type
}
    `;
export const AreaDataFragmentDoc = gql`
    fragment AreaData on areas {
  id
  name
  cultivation {
    ...CultivationData
  }
  description
  devices(
    order_by: [{device_type: asc}, {name: asc}]
    where: {visible: {_eq: true}}
  ) {
    ...AreaDevice
  }
  icon
  scope
}
    ${CultivationDataFragmentDoc}
${AreaDeviceFragmentDoc}`;
export const AutomationDeviceFragmentDoc = gql`
    fragment AutomationDevice on devices {
  id
  name
  type: device_type
}
    `;
export const AutomationSceneFragmentDoc = gql`
    fragment AutomationScene on scenes {
  id
  name
  actions
  conditions
  fromTime: from_time
  toTime: to_time
  executionTime: execution_time
  timingExecutionKind: timing_execution_kind
  weekDaysScheduling: weekdays_scheduling
  devices: scenes_devices {
    id
    device {
      ...AutomationDevice
    }
  }
  notificationsEnabled: notifications_enabled
  enabled
}
    ${AutomationDeviceFragmentDoc}`;
export const AutomationFragmentDoc = gql`
    fragment Automation on automations {
  id
  name
  enabled
  scenes(order_by: {id: desc}) {
    ...AutomationScene
  }
  watching: users_watching(where: {user_id: {_eq: $userId}}) {
    id
    userId: user_id
  }
  updatedAt: updated_at
  monthlyScheduling: monthly_scheduling
  timingExecutionKind: timing_execution_kind
}
    ${AutomationSceneFragmentDoc}`;
export const ChatMessageDataFragmentDoc = gql`
    fragment ChatMessageData on chat_messages {
  id
  content: message_content
  isUserMessage: is_user_message
  createdAt: created_at
}
    `;
export const OrganizationChatParamsDataFragmentDoc = gql`
    fragment OrganizationChatParamsData on organizations_chat_params {
  id
  tokensMonthUsed: tokens_month_used
}
    `;
export const AreaDataLiteFragmentDoc = gql`
    fragment AreaDataLite on areas {
  id
  name
  analysisApplications: analysis_applications {
    id
  }
  cultivation {
    clayPercentage: clay_percentage
    cultivationType: cultivation_type
    farmingContainer: farming_container
    farmingContainerCapacity: farming_container_capacity
    farmingMethod: farming_method
    farmingStructure: farming_structure
    nw
    organicMaterialPercentage: organic_material_percentage
    sandPercentage: sand_percentage
    substrate {
      id
      name
      kpa1: vwc_minus_1_kpa
      kpa5: vwc_minus_5_kpa
      slug
    }
    wa
    wo
  }
  devices(where: {visible: {_eq: true}}) {
    id
  }
  icon
  scope
}
    `;
export const DeviceForAnalysisFragmentDoc = gql`
    fragment DeviceForAnalysis on analysis_applications__devices {
  id
  deleted
  deletedAt: deleted_at
  device {
    id
    name
    categories {
      category {
        id
        key
      }
    }
    payloads: device_payloads(order_by: {device_payload: {key: desc}}) {
      id
      payload: device_payload {
        id
        name
        key
        kind: payload_kind
        payloadValues: payload_values {
          payloadValue: value {
            id
            name
            value
          }
        }
        type
      }
    }
  }
}
    `;
export const AnalysisApplicationDataFragmentDoc = gql`
    fragment AnalysisApplicationData on analysis_applications {
  id
  name
  analysis {
    id
    name
    enabled
    group
    payloads: analysis__devices_payloads(order_by: {payload: {key: asc}}) {
      payload {
        key
        type
      }
    }
    slug
  }
  area {
    ...AreaDataLite
  }
  dashboards {
    id
  }
  devices {
    ...DeviceForAnalysis
  }
  enabled
}
    ${AreaDataLiteFragmentDoc}
${DeviceForAnalysisFragmentDoc}`;
export const ApplicationDashboardDataFragmentDoc = gql`
    fragment ApplicationDashboardData on applications_dashboards {
  id
  analysesApplications: applications_dashboards_analysis(
    where: {analysis_application: {analysis: {enabled: {_eq: true}}}}
  ) {
    id
    analysisApplication: analysis_application {
      ...AnalysisApplicationData
    }
  }
  devices: applications_dashboards_devices {
    id
    device {
      id
      name
      type: device_type
    }
  }
}
    ${AnalysisApplicationDataFragmentDoc}`;
export const DeviceLiteFragmentDoc = gql`
    fragment DeviceLite on devices {
  id
  name
  area {
    id
    name
  }
  categories {
    category {
      id
      key
    }
  }
  dashboards {
    id
  }
  payloads: device_payloads(order_by: {device_payload: {key: desc}}) {
    id
    payload: device_payload {
      id
      name
      key
      kind: payload_kind
      payloadValues: payload_values {
        payloadValue: value {
          id
          name
          value
        }
      }
      type
    }
  }
  providerId: provider_id
  type: device_type
}
    `;
export const DeviceActionDataFragmentDoc = gql`
    fragment DeviceActionData on device_actions {
  id
  name
  key
  value
}
    `;
export const DeviceApplicationDataFragmentDoc = gql`
    fragment DeviceApplicationData on devices {
  id
  name
  actions: device_actions(order_by: {device_action: {name: asc}}) {
    id
    action: device_action {
      ...DeviceActionData
    }
  }
  area {
    id
    name
    icon
    scope
    cultivation {
      ...CultivationData
    }
  }
  categories {
    category {
      id
      key
    }
  }
  dashboards {
    id
  }
  payloads: device_payloads(order_by: {device_payload: {key: desc}}) {
    id
    payload: device_payload {
      id
      name
      key
      kind: payload_kind
      payloadValues: payload_values {
        payloadValue: value {
          id
          name
          value
        }
      }
      type
    }
  }
  providerId: provider_id
  type: device_type
}
    ${DeviceActionDataFragmentDoc}
${CultivationDataFragmentDoc}`;
export const DeviceDetailDataFragmentDoc = gql`
    fragment DeviceDetailData on DeviceDetailOutput {
  id
  name
  avgPayloads {
    avg
    key
    max
    min
    payloadKind
    type
  }
  chart {
    dataset
    lines {
      payloadKey
      payloadType
    }
  }
  extraAvgPayloads {
    avg
    key
    max
    min
    payloadKind
    type
  }
  hasDashboard
  lastSeen
  lastUplink {
    key
    kind
    type
    value
  }
  signal {
    rssi
    sentiment
    snr
  }
}
    `;
export const DeviceInSceneDataFragmentDoc = gql`
    fragment DeviceInSceneData on scenes {
  actions
  automation {
    id
    name
  }
  sceneId: id
  sceneName: name
}
    `;
export const NotificationDataFragmentDoc = gql`
    fragment NotificationData on notifications {
  id
  content {
    id
    values
  }
  kind
  read
  createdAt: created_at
}
    `;
export const NotificationContentMessageInnerFragmentDoc = gql`
    fragment NotificationContentMessageInner on notifications_content {
  id
  hygraph: hygraph_message(stage: PUBLISHED) {
    id
    author {
      id
      name
      avatar {
        id
        url(transformation: {document: {output: {format: webp}}})
      }
    }
    message(locales: $locale) {
      id
      content {
        raw
      }
      excerpt
      shortTitle
      title
    }
    publishedAt
  }
}
    `;
export const NotificationContentMessageDataFragmentDoc = gql`
    fragment NotificationContentMessageData on notifications {
  content {
    ...NotificationContentMessageInner
  }
}
    ${NotificationContentMessageInnerFragmentDoc}`;
export const NotificationContentReleaseInnerFragmentDoc = gql`
    fragment NotificationContentReleaseInner on notifications_content {
  id
  hygraph: hygraph_release(locales: $locale) {
    id
    publishedAt
    release {
      id
      changed
      content
      new
      version
    }
  }
}
    `;
export const NotificationContentReleaseDataFragmentDoc = gql`
    fragment NotificationContentReleaseData on notifications {
  content {
    ...NotificationContentReleaseInner
  }
}
    ${NotificationContentReleaseInnerFragmentDoc}`;
export const OrganizationFeatureLimitsFragmentDoc = gql`
    fragment OrganizationFeatureLimits on organizations_feature_limits {
  analysis
  applications
  automations
  maxChatHistoryMessages: max_chat_history_messages
  maxChatTokensMonth: max_chat_tokens_month
  chatContextDatasetHours: chat_context_dataset_hours
  preventions
  users
}
    `;
export const UserDataFragmentDoc = gql`
    fragment UserData on users_permissions_user {
  id
  avatarUrl: avatar_url
  blocked
  email
  organizations {
    id
  }
  telegramUsers: telegram_users {
    id
    active
    telegramId: telegram_id
    telegramUsername: telegram_username
  }
}
    `;
export const AnalysesAvailableDocument = gql`
    query AnalysesAvailable($applicationId: Int!) {
  health: analysis(where: {group: {_eq: HEALTH}}) {
    ...AnalysisAvailableData
  }
  other: analysis(where: {group: {_eq: OTHER}}) {
    ...AnalysisAvailableData
  }
  preventions: analysis(where: {group: {_in: [PREVENTION]}}) {
    ...AnalysisAvailableData
  }
}
    ${AnalysisAvailableDataFragmentDoc}`;

/**
 * __useAnalysesAvailableQuery__
 *
 * To run a query within a React component, call `useAnalysesAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalysesAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalysesAvailableQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useAnalysesAvailableQuery(baseOptions: Apollo.QueryHookOptions<AnalysesAvailableQuery, AnalysesAvailableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalysesAvailableQuery, AnalysesAvailableQueryVariables>(AnalysesAvailableDocument, options);
      }
export function useAnalysesAvailableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalysesAvailableQuery, AnalysesAvailableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalysesAvailableQuery, AnalysesAvailableQueryVariables>(AnalysesAvailableDocument, options);
        }
export type AnalysesAvailableQueryHookResult = ReturnType<typeof useAnalysesAvailableQuery>;
export type AnalysesAvailableLazyQueryHookResult = ReturnType<typeof useAnalysesAvailableLazyQuery>;
export type AnalysesAvailableQueryResult = Apollo.QueryResult<AnalysesAvailableQuery, AnalysesAvailableQueryVariables>;
export const AnalysesApplicationDocument = gql`
    query AnalysesApplication($applicationId: Int!) {
  analysesApplication: analysis_applications(
    where: {application_id: {_eq: $applicationId}, analysis: {enabled: {_eq: true}}}
  ) {
    ...AnalysisApplicationData
  }
}
    ${AnalysisApplicationDataFragmentDoc}`;

/**
 * __useAnalysesApplicationQuery__
 *
 * To run a query within a React component, call `useAnalysesApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalysesApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalysesApplicationQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useAnalysesApplicationQuery(baseOptions: Apollo.QueryHookOptions<AnalysesApplicationQuery, AnalysesApplicationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalysesApplicationQuery, AnalysesApplicationQueryVariables>(AnalysesApplicationDocument, options);
      }
export function useAnalysesApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalysesApplicationQuery, AnalysesApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalysesApplicationQuery, AnalysesApplicationQueryVariables>(AnalysesApplicationDocument, options);
        }
export type AnalysesApplicationQueryHookResult = ReturnType<typeof useAnalysesApplicationQuery>;
export type AnalysesApplicationLazyQueryHookResult = ReturnType<typeof useAnalysesApplicationLazyQuery>;
export type AnalysesApplicationQueryResult = Apollo.QueryResult<AnalysesApplicationQuery, AnalysesApplicationQueryVariables>;
export const AnalysesApplicationsByTypeDocument = gql`
    query AnalysesApplicationsByType($analysisId: Int!, $applicationId: Int!) {
  analysesApplications: analysis_applications(
    where: {analysis_id: {_eq: $analysisId}, application_id: {_eq: $applicationId}, analysis: {enabled: {_eq: true}}}
  ) {
    id
    name
    enabled
  }
}
    `;

/**
 * __useAnalysesApplicationsByTypeQuery__
 *
 * To run a query within a React component, call `useAnalysesApplicationsByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalysesApplicationsByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalysesApplicationsByTypeQuery({
 *   variables: {
 *      analysisId: // value for 'analysisId'
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useAnalysesApplicationsByTypeQuery(baseOptions: Apollo.QueryHookOptions<AnalysesApplicationsByTypeQuery, AnalysesApplicationsByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalysesApplicationsByTypeQuery, AnalysesApplicationsByTypeQueryVariables>(AnalysesApplicationsByTypeDocument, options);
      }
export function useAnalysesApplicationsByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalysesApplicationsByTypeQuery, AnalysesApplicationsByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalysesApplicationsByTypeQuery, AnalysesApplicationsByTypeQueryVariables>(AnalysesApplicationsByTypeDocument, options);
        }
export type AnalysesApplicationsByTypeQueryHookResult = ReturnType<typeof useAnalysesApplicationsByTypeQuery>;
export type AnalysesApplicationsByTypeLazyQueryHookResult = ReturnType<typeof useAnalysesApplicationsByTypeLazyQuery>;
export type AnalysesApplicationsByTypeQueryResult = Apollo.QueryResult<AnalysesApplicationsByTypeQuery, AnalysesApplicationsByTypeQueryVariables>;
export const AnalysesApplicationBySlugDocument = gql`
    query AnalysesApplicationBySlug($applicationId: Int!, $slug: String!) {
  analysesApplication: analysis_applications(
    order_by: {name: asc}
    where: {analysis: {slug: {_eq: $slug}, enabled: {_eq: true}}, application_id: {_eq: $applicationId}}
  ) {
    ...AnalysisApplicationData
  }
}
    ${AnalysisApplicationDataFragmentDoc}`;

/**
 * __useAnalysesApplicationBySlugQuery__
 *
 * To run a query within a React component, call `useAnalysesApplicationBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalysesApplicationBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalysesApplicationBySlugQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useAnalysesApplicationBySlugQuery(baseOptions: Apollo.QueryHookOptions<AnalysesApplicationBySlugQuery, AnalysesApplicationBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalysesApplicationBySlugQuery, AnalysesApplicationBySlugQueryVariables>(AnalysesApplicationBySlugDocument, options);
      }
export function useAnalysesApplicationBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalysesApplicationBySlugQuery, AnalysesApplicationBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalysesApplicationBySlugQuery, AnalysesApplicationBySlugQueryVariables>(AnalysesApplicationBySlugDocument, options);
        }
export type AnalysesApplicationBySlugQueryHookResult = ReturnType<typeof useAnalysesApplicationBySlugQuery>;
export type AnalysesApplicationBySlugLazyQueryHookResult = ReturnType<typeof useAnalysesApplicationBySlugLazyQuery>;
export type AnalysesApplicationBySlugQueryResult = Apollo.QueryResult<AnalysesApplicationBySlugQuery, AnalysesApplicationBySlugQueryVariables>;
export const AnalysesApplicationByAreaDocument = gql`
    query AnalysesApplicationByArea($applicationId: Int!, $areaId: Int!) {
  analysesApplication: analysis_applications(
    where: {application_id: {_eq: $applicationId}, area_id: {_eq: $areaId}, analysis: {enabled: {_eq: true}}}
  ) {
    ...AnalysisApplicationData
  }
}
    ${AnalysisApplicationDataFragmentDoc}`;

/**
 * __useAnalysesApplicationByAreaQuery__
 *
 * To run a query within a React component, call `useAnalysesApplicationByAreaQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalysesApplicationByAreaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalysesApplicationByAreaQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      areaId: // value for 'areaId'
 *   },
 * });
 */
export function useAnalysesApplicationByAreaQuery(baseOptions: Apollo.QueryHookOptions<AnalysesApplicationByAreaQuery, AnalysesApplicationByAreaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalysesApplicationByAreaQuery, AnalysesApplicationByAreaQueryVariables>(AnalysesApplicationByAreaDocument, options);
      }
export function useAnalysesApplicationByAreaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalysesApplicationByAreaQuery, AnalysesApplicationByAreaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalysesApplicationByAreaQuery, AnalysesApplicationByAreaQueryVariables>(AnalysesApplicationByAreaDocument, options);
        }
export type AnalysesApplicationByAreaQueryHookResult = ReturnType<typeof useAnalysesApplicationByAreaQuery>;
export type AnalysesApplicationByAreaLazyQueryHookResult = ReturnType<typeof useAnalysesApplicationByAreaLazyQuery>;
export type AnalysesApplicationByAreaQueryResult = Apollo.QueryResult<AnalysesApplicationByAreaQuery, AnalysesApplicationByAreaQueryVariables>;
export const AnalysisApplicationDetailsDocument = gql`
    query AnalysisApplicationDetails($analysisApplicationId: Int!) {
  analysisApplication: analysis_applications_by_pk(id: $analysisApplicationId) {
    ...AnalysisApplicationData
  }
}
    ${AnalysisApplicationDataFragmentDoc}`;

/**
 * __useAnalysisApplicationDetailsQuery__
 *
 * To run a query within a React component, call `useAnalysisApplicationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalysisApplicationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalysisApplicationDetailsQuery({
 *   variables: {
 *      analysisApplicationId: // value for 'analysisApplicationId'
 *   },
 * });
 */
export function useAnalysisApplicationDetailsQuery(baseOptions: Apollo.QueryHookOptions<AnalysisApplicationDetailsQuery, AnalysisApplicationDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalysisApplicationDetailsQuery, AnalysisApplicationDetailsQueryVariables>(AnalysisApplicationDetailsDocument, options);
      }
export function useAnalysisApplicationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalysisApplicationDetailsQuery, AnalysisApplicationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalysisApplicationDetailsQuery, AnalysisApplicationDetailsQueryVariables>(AnalysisApplicationDetailsDocument, options);
        }
export type AnalysisApplicationDetailsQueryHookResult = ReturnType<typeof useAnalysisApplicationDetailsQuery>;
export type AnalysisApplicationDetailsLazyQueryHookResult = ReturnType<typeof useAnalysisApplicationDetailsLazyQuery>;
export type AnalysisApplicationDetailsQueryResult = Apollo.QueryResult<AnalysisApplicationDetailsQuery, AnalysisApplicationDetailsQueryVariables>;
export const InsertAnalysisApplicationDocument = gql`
    mutation InsertAnalysisApplication($name: String!, $analysisId: Int!, $applicationId: Int!, $areaId: Int, $devices: [Int!]!, $enabled: Boolean!) {
  insertAnalysis: analysis_application_create(
    args: {name: $name, analysis_id: $analysisId, application_id: $applicationId, devices: $devices, enabled: $enabled, area_id: $areaId}
  ) {
    id
  }
}
    `;
export type InsertAnalysisApplicationMutationFn = Apollo.MutationFunction<InsertAnalysisApplicationMutation, InsertAnalysisApplicationMutationVariables>;

/**
 * __useInsertAnalysisApplicationMutation__
 *
 * To run a mutation, you first call `useInsertAnalysisApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertAnalysisApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertAnalysisApplicationMutation, { data, loading, error }] = useInsertAnalysisApplicationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      analysisId: // value for 'analysisId'
 *      applicationId: // value for 'applicationId'
 *      areaId: // value for 'areaId'
 *      devices: // value for 'devices'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useInsertAnalysisApplicationMutation(baseOptions?: Apollo.MutationHookOptions<InsertAnalysisApplicationMutation, InsertAnalysisApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertAnalysisApplicationMutation, InsertAnalysisApplicationMutationVariables>(InsertAnalysisApplicationDocument, options);
      }
export type InsertAnalysisApplicationMutationHookResult = ReturnType<typeof useInsertAnalysisApplicationMutation>;
export type InsertAnalysisApplicationMutationResult = Apollo.MutationResult<InsertAnalysisApplicationMutation>;
export type InsertAnalysisApplicationMutationOptions = Apollo.BaseMutationOptions<InsertAnalysisApplicationMutation, InsertAnalysisApplicationMutationVariables>;
export const EditAnalysisApplicationDocument = gql`
    mutation EditAnalysisApplication($name: String!, $analysisApplicationId: Int!, $devices: [Int!]!, $enabled: Boolean!) {
  updateAnalysis: analysis_application_update(
    args: {analysis_application_id: $analysisApplicationId, devices: $devices, enabled: $enabled, name: $name}
  ) {
    id
  }
}
    `;
export type EditAnalysisApplicationMutationFn = Apollo.MutationFunction<EditAnalysisApplicationMutation, EditAnalysisApplicationMutationVariables>;

/**
 * __useEditAnalysisApplicationMutation__
 *
 * To run a mutation, you first call `useEditAnalysisApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAnalysisApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAnalysisApplicationMutation, { data, loading, error }] = useEditAnalysisApplicationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      analysisApplicationId: // value for 'analysisApplicationId'
 *      devices: // value for 'devices'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useEditAnalysisApplicationMutation(baseOptions?: Apollo.MutationHookOptions<EditAnalysisApplicationMutation, EditAnalysisApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditAnalysisApplicationMutation, EditAnalysisApplicationMutationVariables>(EditAnalysisApplicationDocument, options);
      }
export type EditAnalysisApplicationMutationHookResult = ReturnType<typeof useEditAnalysisApplicationMutation>;
export type EditAnalysisApplicationMutationResult = Apollo.MutationResult<EditAnalysisApplicationMutation>;
export type EditAnalysisApplicationMutationOptions = Apollo.BaseMutationOptions<EditAnalysisApplicationMutation, EditAnalysisApplicationMutationVariables>;
export const DeleteAnalysisApplicationDocument = gql`
    mutation DeleteAnalysisApplication($analysisApplicationId: Int!) {
  deleteDashboardAnalysis: delete_applications_dashboards_analysis(
    where: {analysis_application_id: {_eq: $analysisApplicationId}}
  ) {
    affected_rows
  }
  deleteAnalysis: delete_analysis_applications_by_pk(id: $analysisApplicationId) {
    id
  }
}
    `;
export type DeleteAnalysisApplicationMutationFn = Apollo.MutationFunction<DeleteAnalysisApplicationMutation, DeleteAnalysisApplicationMutationVariables>;

/**
 * __useDeleteAnalysisApplicationMutation__
 *
 * To run a mutation, you first call `useDeleteAnalysisApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnalysisApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnalysisApplicationMutation, { data, loading, error }] = useDeleteAnalysisApplicationMutation({
 *   variables: {
 *      analysisApplicationId: // value for 'analysisApplicationId'
 *   },
 * });
 */
export function useDeleteAnalysisApplicationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAnalysisApplicationMutation, DeleteAnalysisApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAnalysisApplicationMutation, DeleteAnalysisApplicationMutationVariables>(DeleteAnalysisApplicationDocument, options);
      }
export type DeleteAnalysisApplicationMutationHookResult = ReturnType<typeof useDeleteAnalysisApplicationMutation>;
export type DeleteAnalysisApplicationMutationResult = Apollo.MutationResult<DeleteAnalysisApplicationMutation>;
export type DeleteAnalysisApplicationMutationOptions = Apollo.BaseMutationOptions<DeleteAnalysisApplicationMutation, DeleteAnalysisApplicationMutationVariables>;
export const AnalysisComputedDocument = gql`
    query AnalysisComputed($analysisApplicationId: Int!, $endDate: timestamptz!, $startDate: timestamptz!) {
  analysisComputed: analysis_applications_computed(
    order_by: {computed_at: asc}
    where: {analysis_application_id: {_eq: $analysisApplicationId}, computed_at: {_gte: $startDate, _lte: $endDate}}
  ) {
    ...AnalysisComputedData
  }
}
    ${AnalysisComputedDataFragmentDoc}`;

/**
 * __useAnalysisComputedQuery__
 *
 * To run a query within a React component, call `useAnalysisComputedQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalysisComputedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalysisComputedQuery({
 *   variables: {
 *      analysisApplicationId: // value for 'analysisApplicationId'
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useAnalysisComputedQuery(baseOptions: Apollo.QueryHookOptions<AnalysisComputedQuery, AnalysisComputedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalysisComputedQuery, AnalysisComputedQueryVariables>(AnalysisComputedDocument, options);
      }
export function useAnalysisComputedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalysisComputedQuery, AnalysisComputedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalysisComputedQuery, AnalysisComputedQueryVariables>(AnalysisComputedDocument, options);
        }
export type AnalysisComputedQueryHookResult = ReturnType<typeof useAnalysisComputedQuery>;
export type AnalysisComputedLazyQueryHookResult = ReturnType<typeof useAnalysisComputedLazyQuery>;
export type AnalysisComputedQueryResult = Apollo.QueryResult<AnalysisComputedQuery, AnalysisComputedQueryVariables>;
export const AnalysisHealthComputedDataDocument = gql`
    query AnalysisHealthComputedData($analysisApplicationId: Int!, $endDate: timestamptz!, $startDate: timestamptz!) {
  analysisComputed: analysis_applications_computed(
    order_by: {computed_at: asc}
    where: {analysis_application_id: {_eq: $analysisApplicationId}, computed_at: {_gte: $startDate, _lte: $endDate}}
  ) {
    ...AnalysisHealthComputedData
  }
}
    ${AnalysisHealthComputedDataFragmentDoc}`;

/**
 * __useAnalysisHealthComputedDataQuery__
 *
 * To run a query within a React component, call `useAnalysisHealthComputedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalysisHealthComputedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalysisHealthComputedDataQuery({
 *   variables: {
 *      analysisApplicationId: // value for 'analysisApplicationId'
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useAnalysisHealthComputedDataQuery(baseOptions: Apollo.QueryHookOptions<AnalysisHealthComputedDataQuery, AnalysisHealthComputedDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalysisHealthComputedDataQuery, AnalysisHealthComputedDataQueryVariables>(AnalysisHealthComputedDataDocument, options);
      }
export function useAnalysisHealthComputedDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalysisHealthComputedDataQuery, AnalysisHealthComputedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalysisHealthComputedDataQuery, AnalysisHealthComputedDataQueryVariables>(AnalysisHealthComputedDataDocument, options);
        }
export type AnalysisHealthComputedDataQueryHookResult = ReturnType<typeof useAnalysisHealthComputedDataQuery>;
export type AnalysisHealthComputedDataLazyQueryHookResult = ReturnType<typeof useAnalysisHealthComputedDataLazyQuery>;
export type AnalysisHealthComputedDataQueryResult = Apollo.QueryResult<AnalysisHealthComputedDataQuery, AnalysisHealthComputedDataQueryVariables>;
export const AnalysisComputedLatestDocument = gql`
    query AnalysisComputedLatest($analysisApplicationId: Int!, $limit: Int!) {
  analysisComputed: analysis_applications_computed(
    limit: $limit
    order_by: {computed_at: desc}
    where: {analysis_application_id: {_eq: $analysisApplicationId}}
  ) {
    ...AnalysisComputedData
  }
}
    ${AnalysisComputedDataFragmentDoc}`;

/**
 * __useAnalysisComputedLatestQuery__
 *
 * To run a query within a React component, call `useAnalysisComputedLatestQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalysisComputedLatestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalysisComputedLatestQuery({
 *   variables: {
 *      analysisApplicationId: // value for 'analysisApplicationId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAnalysisComputedLatestQuery(baseOptions: Apollo.QueryHookOptions<AnalysisComputedLatestQuery, AnalysisComputedLatestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalysisComputedLatestQuery, AnalysisComputedLatestQueryVariables>(AnalysisComputedLatestDocument, options);
      }
export function useAnalysisComputedLatestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalysisComputedLatestQuery, AnalysisComputedLatestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalysisComputedLatestQuery, AnalysisComputedLatestQueryVariables>(AnalysisComputedLatestDocument, options);
        }
export type AnalysisComputedLatestQueryHookResult = ReturnType<typeof useAnalysisComputedLatestQuery>;
export type AnalysisComputedLatestLazyQueryHookResult = ReturnType<typeof useAnalysisComputedLatestLazyQuery>;
export type AnalysisComputedLatestQueryResult = Apollo.QueryResult<AnalysisComputedLatestQuery, AnalysisComputedLatestQueryVariables>;
export const AnalysisHealthComputedLatestDocument = gql`
    query AnalysisHealthComputedLatest($analysisApplicationId: Int!, $limit: Int!) {
  analysisComputed: analysis_applications_computed(
    limit: $limit
    order_by: {computed_at: desc}
    where: {analysis_application_id: {_eq: $analysisApplicationId}}
  ) {
    ...AnalysisHealthComputedData
  }
}
    ${AnalysisHealthComputedDataFragmentDoc}`;

/**
 * __useAnalysisHealthComputedLatestQuery__
 *
 * To run a query within a React component, call `useAnalysisHealthComputedLatestQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalysisHealthComputedLatestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalysisHealthComputedLatestQuery({
 *   variables: {
 *      analysisApplicationId: // value for 'analysisApplicationId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAnalysisHealthComputedLatestQuery(baseOptions: Apollo.QueryHookOptions<AnalysisHealthComputedLatestQuery, AnalysisHealthComputedLatestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalysisHealthComputedLatestQuery, AnalysisHealthComputedLatestQueryVariables>(AnalysisHealthComputedLatestDocument, options);
      }
export function useAnalysisHealthComputedLatestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalysisHealthComputedLatestQuery, AnalysisHealthComputedLatestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalysisHealthComputedLatestQuery, AnalysisHealthComputedLatestQueryVariables>(AnalysisHealthComputedLatestDocument, options);
        }
export type AnalysisHealthComputedLatestQueryHookResult = ReturnType<typeof useAnalysisHealthComputedLatestQuery>;
export type AnalysisHealthComputedLatestLazyQueryHookResult = ReturnType<typeof useAnalysisHealthComputedLatestLazyQuery>;
export type AnalysisHealthComputedLatestQueryResult = Apollo.QueryResult<AnalysisHealthComputedLatestQuery, AnalysisHealthComputedLatestQueryVariables>;
export const AnalysisComputedAggregateDocument = gql`
    query AnalysisComputedAggregate($analysisApplicationId: Int!, $endDate: timestamptz!, $startDate: timestamptz!) {
  highRisk: analysis_applications_computed_values_aggregate(
    where: {computed: {analysis_application_id: {_eq: $analysisApplicationId}, computed_at: {_gte: $startDate, _lte: $endDate}}, kind: {_eq: PROB}, value: {_gte: 51}}
  ) {
    aggregate {
      count
    }
  }
  lowRisk: analysis_applications_computed_values_aggregate(
    where: {computed: {analysis_application_id: {_eq: $analysisApplicationId}, computed_at: {_gte: $startDate, _lte: $endDate}}, kind: {_eq: PROB}, value: {_gte: 0, _lte: 20}}
  ) {
    aggregate {
      count
    }
  }
  mediumRisk: analysis_applications_computed_values_aggregate(
    where: {computed: {analysis_application_id: {_eq: $analysisApplicationId}, computed_at: {_gte: $startDate, _lte: $endDate}}, kind: {_eq: PROB}, value: {_gte: 21, _lte: 50}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAnalysisComputedAggregateQuery__
 *
 * To run a query within a React component, call `useAnalysisComputedAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalysisComputedAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalysisComputedAggregateQuery({
 *   variables: {
 *      analysisApplicationId: // value for 'analysisApplicationId'
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useAnalysisComputedAggregateQuery(baseOptions: Apollo.QueryHookOptions<AnalysisComputedAggregateQuery, AnalysisComputedAggregateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalysisComputedAggregateQuery, AnalysisComputedAggregateQueryVariables>(AnalysisComputedAggregateDocument, options);
      }
export function useAnalysisComputedAggregateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalysisComputedAggregateQuery, AnalysisComputedAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalysisComputedAggregateQuery, AnalysisComputedAggregateQueryVariables>(AnalysisComputedAggregateDocument, options);
        }
export type AnalysisComputedAggregateQueryHookResult = ReturnType<typeof useAnalysisComputedAggregateQuery>;
export type AnalysisComputedAggregateLazyQueryHookResult = ReturnType<typeof useAnalysisComputedAggregateLazyQuery>;
export type AnalysisComputedAggregateQueryResult = Apollo.QueryResult<AnalysisComputedAggregateQuery, AnalysisComputedAggregateQueryVariables>;
export const ApplicationsDocument = gql`
    query Applications($userId: Int!) {
  applications(where: {organization: {users: {user_id: {_eq: $userId}}}}) {
    id
    name
    automationsAggregate: automations_aggregate {
      aggregate {
        count
      }
    }
    devicesAggregate: devices_aggregate {
      aggregate {
        count
      }
    }
    lat
    lon
    organizationId: organization_id
    providerId: provider_id
  }
}
    `;

/**
 * __useApplicationsQuery__
 *
 * To run a query within a React component, call `useApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useApplicationsQuery(baseOptions: Apollo.QueryHookOptions<ApplicationsQuery, ApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationsQuery, ApplicationsQueryVariables>(ApplicationsDocument, options);
      }
export function useApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationsQuery, ApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationsQuery, ApplicationsQueryVariables>(ApplicationsDocument, options);
        }
export type ApplicationsQueryHookResult = ReturnType<typeof useApplicationsQuery>;
export type ApplicationsLazyQueryHookResult = ReturnType<typeof useApplicationsLazyQuery>;
export type ApplicationsQueryResult = Apollo.QueryResult<ApplicationsQuery, ApplicationsQueryVariables>;
export const ApplicationWeatherDocument = gql`
    query ApplicationWeather($applicationId: Int!) {
  applicationWeather: application_weather(args: {application_id: $applicationId}) {
    weather {
      alerts {
        event
      }
      current {
        cloudy
        humidity
        pressure
        sunrise
        sunset
        temperature
        time
        weatherIconId
        windDegree
        windSpeed
      }
      forecast {
        cloudy
        humidity
        pressure
        temperature {
          max
          min
        }
        time
        weatherIconId
        windDegree
        windGust
        windSpeed
      }
    }
  }
}
    `;

/**
 * __useApplicationWeatherQuery__
 *
 * To run a query within a React component, call `useApplicationWeatherQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationWeatherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationWeatherQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useApplicationWeatherQuery(baseOptions: Apollo.QueryHookOptions<ApplicationWeatherQuery, ApplicationWeatherQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationWeatherQuery, ApplicationWeatherQueryVariables>(ApplicationWeatherDocument, options);
      }
export function useApplicationWeatherLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationWeatherQuery, ApplicationWeatherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationWeatherQuery, ApplicationWeatherQueryVariables>(ApplicationWeatherDocument, options);
        }
export type ApplicationWeatherQueryHookResult = ReturnType<typeof useApplicationWeatherQuery>;
export type ApplicationWeatherLazyQueryHookResult = ReturnType<typeof useApplicationWeatherLazyQuery>;
export type ApplicationWeatherQueryResult = Apollo.QueryResult<ApplicationWeatherQuery, ApplicationWeatherQueryVariables>;
export const GetAreasDocument = gql`
    query GetAreas($applicationId: Int!) {
  areas(order_by: {name: asc}, where: {application_id: {_eq: $applicationId}}) {
    id
    name
    devices(where: {visible: {_eq: true}}) {
      id
      categories {
        category {
          id
          key
        }
      }
    }
    icon
    scope
  }
}
    `;

/**
 * __useGetAreasQuery__
 *
 * To run a query within a React component, call `useGetAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAreasQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useGetAreasQuery(baseOptions: Apollo.QueryHookOptions<GetAreasQuery, GetAreasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAreasQuery, GetAreasQueryVariables>(GetAreasDocument, options);
      }
export function useGetAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAreasQuery, GetAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAreasQuery, GetAreasQueryVariables>(GetAreasDocument, options);
        }
export type GetAreasQueryHookResult = ReturnType<typeof useGetAreasQuery>;
export type GetAreasLazyQueryHookResult = ReturnType<typeof useGetAreasLazyQuery>;
export type GetAreasQueryResult = Apollo.QueryResult<GetAreasQuery, GetAreasQueryVariables>;
export const GetCultivationDataDocument = gql`
    query GetCultivationData {
  cultivationTypes: cultivation_types(order_by: {value: asc}) {
    value
  }
  farmingContainers: farming_containers {
    value
  }
  farmingMethods: farming_methods {
    value
  }
  farmingStructures: farming_structures {
    value
  }
  substrateTypes: substrates {
    id
    name
    slug
  }
}
    `;

/**
 * __useGetCultivationDataQuery__
 *
 * To run a query within a React component, call `useGetCultivationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCultivationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCultivationDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCultivationDataQuery(baseOptions?: Apollo.QueryHookOptions<GetCultivationDataQuery, GetCultivationDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCultivationDataQuery, GetCultivationDataQueryVariables>(GetCultivationDataDocument, options);
      }
export function useGetCultivationDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCultivationDataQuery, GetCultivationDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCultivationDataQuery, GetCultivationDataQueryVariables>(GetCultivationDataDocument, options);
        }
export type GetCultivationDataQueryHookResult = ReturnType<typeof useGetCultivationDataQuery>;
export type GetCultivationDataLazyQueryHookResult = ReturnType<typeof useGetCultivationDataLazyQuery>;
export type GetCultivationDataQueryResult = Apollo.QueryResult<GetCultivationDataQuery, GetCultivationDataQueryVariables>;
export const GetAreaDocument = gql`
    query GetArea($id: Int!) {
  area: areas_by_pk(id: $id) {
    ...AreaData
  }
}
    ${AreaDataFragmentDoc}`;

/**
 * __useGetAreaQuery__
 *
 * To run a query within a React component, call `useGetAreaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAreaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAreaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAreaQuery(baseOptions: Apollo.QueryHookOptions<GetAreaQuery, GetAreaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAreaQuery, GetAreaQueryVariables>(GetAreaDocument, options);
      }
export function useGetAreaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAreaQuery, GetAreaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAreaQuery, GetAreaQueryVariables>(GetAreaDocument, options);
        }
export type GetAreaQueryHookResult = ReturnType<typeof useGetAreaQuery>;
export type GetAreaLazyQueryHookResult = ReturnType<typeof useGetAreaLazyQuery>;
export type GetAreaQueryResult = Apollo.QueryResult<GetAreaQuery, GetAreaQueryVariables>;
export const GetAreaLiteDocument = gql`
    query GetAreaLite($id: Int!) {
  area: areas_by_pk(id: $id) {
    ...AreaDataLite
  }
}
    ${AreaDataLiteFragmentDoc}`;

/**
 * __useGetAreaLiteQuery__
 *
 * To run a query within a React component, call `useGetAreaLiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAreaLiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAreaLiteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAreaLiteQuery(baseOptions: Apollo.QueryHookOptions<GetAreaLiteQuery, GetAreaLiteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAreaLiteQuery, GetAreaLiteQueryVariables>(GetAreaLiteDocument, options);
      }
export function useGetAreaLiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAreaLiteQuery, GetAreaLiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAreaLiteQuery, GetAreaLiteQueryVariables>(GetAreaLiteDocument, options);
        }
export type GetAreaLiteQueryHookResult = ReturnType<typeof useGetAreaLiteQuery>;
export type GetAreaLiteLazyQueryHookResult = ReturnType<typeof useGetAreaLiteLazyQuery>;
export type GetAreaLiteQueryResult = Apollo.QueryResult<GetAreaLiteQuery, GetAreaLiteQueryVariables>;
export const CreateAreaDocument = gql`
    mutation CreateArea($input: AreaCreateInput!) {
  area: area_create(args: $input) {
    id
  }
}
    `;
export type CreateAreaMutationFn = Apollo.MutationFunction<CreateAreaMutation, CreateAreaMutationVariables>;

/**
 * __useCreateAreaMutation__
 *
 * To run a mutation, you first call `useCreateAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAreaMutation, { data, loading, error }] = useCreateAreaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAreaMutation(baseOptions?: Apollo.MutationHookOptions<CreateAreaMutation, CreateAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAreaMutation, CreateAreaMutationVariables>(CreateAreaDocument, options);
      }
export type CreateAreaMutationHookResult = ReturnType<typeof useCreateAreaMutation>;
export type CreateAreaMutationResult = Apollo.MutationResult<CreateAreaMutation>;
export type CreateAreaMutationOptions = Apollo.BaseMutationOptions<CreateAreaMutation, CreateAreaMutationVariables>;
export const EditAreaDocument = gql`
    mutation EditArea($input: AreaUpdateInput!) {
  area: area_update(args: $input) {
    id
  }
}
    `;
export type EditAreaMutationFn = Apollo.MutationFunction<EditAreaMutation, EditAreaMutationVariables>;

/**
 * __useEditAreaMutation__
 *
 * To run a mutation, you first call `useEditAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAreaMutation, { data, loading, error }] = useEditAreaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditAreaMutation(baseOptions?: Apollo.MutationHookOptions<EditAreaMutation, EditAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditAreaMutation, EditAreaMutationVariables>(EditAreaDocument, options);
      }
export type EditAreaMutationHookResult = ReturnType<typeof useEditAreaMutation>;
export type EditAreaMutationResult = Apollo.MutationResult<EditAreaMutation>;
export type EditAreaMutationOptions = Apollo.BaseMutationOptions<EditAreaMutation, EditAreaMutationVariables>;
export const DeleteAreaDocument = gql`
    mutation DeleteArea($id: Int!) {
  area: delete_areas_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteAreaMutationFn = Apollo.MutationFunction<DeleteAreaMutation, DeleteAreaMutationVariables>;

/**
 * __useDeleteAreaMutation__
 *
 * To run a mutation, you first call `useDeleteAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAreaMutation, { data, loading, error }] = useDeleteAreaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAreaMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAreaMutation, DeleteAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAreaMutation, DeleteAreaMutationVariables>(DeleteAreaDocument, options);
      }
export type DeleteAreaMutationHookResult = ReturnType<typeof useDeleteAreaMutation>;
export type DeleteAreaMutationResult = Apollo.MutationResult<DeleteAreaMutation>;
export type DeleteAreaMutationOptions = Apollo.BaseMutationOptions<DeleteAreaMutation, DeleteAreaMutationVariables>;
export const InsertAutomationWithWatchingDocument = gql`
    mutation InsertAutomationWithWatching($name: String!, $applicationId: Int!, $enabled: Boolean, $scenes: [scenes_insert_input!]!, $userId: Int, $monthlyScheduling: bpchar, $timingExecutionKind: automation_timing_execution_kinds_enum) {
  result: insert_automations_one(
    object: {application_id: $applicationId, name: $name, enabled: $enabled, monthly_scheduling: $monthlyScheduling, timing_execution_kind: $timingExecutionKind, scenes: {data: $scenes}, users_watching: {data: {user_id: $userId}}}
  ) {
    id
  }
}
    `;
export type InsertAutomationWithWatchingMutationFn = Apollo.MutationFunction<InsertAutomationWithWatchingMutation, InsertAutomationWithWatchingMutationVariables>;

/**
 * __useInsertAutomationWithWatchingMutation__
 *
 * To run a mutation, you first call `useInsertAutomationWithWatchingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertAutomationWithWatchingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertAutomationWithWatchingMutation, { data, loading, error }] = useInsertAutomationWithWatchingMutation({
 *   variables: {
 *      name: // value for 'name'
 *      applicationId: // value for 'applicationId'
 *      enabled: // value for 'enabled'
 *      scenes: // value for 'scenes'
 *      userId: // value for 'userId'
 *      monthlyScheduling: // value for 'monthlyScheduling'
 *      timingExecutionKind: // value for 'timingExecutionKind'
 *   },
 * });
 */
export function useInsertAutomationWithWatchingMutation(baseOptions?: Apollo.MutationHookOptions<InsertAutomationWithWatchingMutation, InsertAutomationWithWatchingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertAutomationWithWatchingMutation, InsertAutomationWithWatchingMutationVariables>(InsertAutomationWithWatchingDocument, options);
      }
export type InsertAutomationWithWatchingMutationHookResult = ReturnType<typeof useInsertAutomationWithWatchingMutation>;
export type InsertAutomationWithWatchingMutationResult = Apollo.MutationResult<InsertAutomationWithWatchingMutation>;
export type InsertAutomationWithWatchingMutationOptions = Apollo.BaseMutationOptions<InsertAutomationWithWatchingMutation, InsertAutomationWithWatchingMutationVariables>;
export const InsertAutomationDocument = gql`
    mutation InsertAutomation($name: String!, $applicationId: Int!, $enabled: Boolean, $scenes: [scenes_insert_input!]!, $monthlyScheduling: bpchar, $timingExecutionKind: automation_timing_execution_kinds_enum) {
  result: insert_automations_one(
    object: {application_id: $applicationId, name: $name, enabled: $enabled, monthly_scheduling: $monthlyScheduling, timing_execution_kind: $timingExecutionKind, scenes: {data: $scenes}}
  ) {
    id
  }
}
    `;
export type InsertAutomationMutationFn = Apollo.MutationFunction<InsertAutomationMutation, InsertAutomationMutationVariables>;

/**
 * __useInsertAutomationMutation__
 *
 * To run a mutation, you first call `useInsertAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertAutomationMutation, { data, loading, error }] = useInsertAutomationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      applicationId: // value for 'applicationId'
 *      enabled: // value for 'enabled'
 *      scenes: // value for 'scenes'
 *      monthlyScheduling: // value for 'monthlyScheduling'
 *      timingExecutionKind: // value for 'timingExecutionKind'
 *   },
 * });
 */
export function useInsertAutomationMutation(baseOptions?: Apollo.MutationHookOptions<InsertAutomationMutation, InsertAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertAutomationMutation, InsertAutomationMutationVariables>(InsertAutomationDocument, options);
      }
export type InsertAutomationMutationHookResult = ReturnType<typeof useInsertAutomationMutation>;
export type InsertAutomationMutationResult = Apollo.MutationResult<InsertAutomationMutation>;
export type InsertAutomationMutationOptions = Apollo.BaseMutationOptions<InsertAutomationMutation, InsertAutomationMutationVariables>;
export const DuplicateAutomationDocument = gql`
    mutation DuplicateAutomation($automationId: Int!) {
  duplicateAutomationResult: automation_duplicate(
    args: {automation_id: $automationId}
  ) {
    id
  }
}
    `;
export type DuplicateAutomationMutationFn = Apollo.MutationFunction<DuplicateAutomationMutation, DuplicateAutomationMutationVariables>;

/**
 * __useDuplicateAutomationMutation__
 *
 * To run a mutation, you first call `useDuplicateAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateAutomationMutation, { data, loading, error }] = useDuplicateAutomationMutation({
 *   variables: {
 *      automationId: // value for 'automationId'
 *   },
 * });
 */
export function useDuplicateAutomationMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateAutomationMutation, DuplicateAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateAutomationMutation, DuplicateAutomationMutationVariables>(DuplicateAutomationDocument, options);
      }
export type DuplicateAutomationMutationHookResult = ReturnType<typeof useDuplicateAutomationMutation>;
export type DuplicateAutomationMutationResult = Apollo.MutationResult<DuplicateAutomationMutation>;
export type DuplicateAutomationMutationOptions = Apollo.BaseMutationOptions<DuplicateAutomationMutation, DuplicateAutomationMutationVariables>;
export const DeleteAutomationsDocument = gql`
    mutation DeleteAutomations($ids: [Int!]!) {
  result: delete_automations(where: {id: {_in: $ids}}) {
    rows: affected_rows
  }
}
    `;
export type DeleteAutomationsMutationFn = Apollo.MutationFunction<DeleteAutomationsMutation, DeleteAutomationsMutationVariables>;

/**
 * __useDeleteAutomationsMutation__
 *
 * To run a mutation, you first call `useDeleteAutomationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAutomationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAutomationsMutation, { data, loading, error }] = useDeleteAutomationsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteAutomationsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAutomationsMutation, DeleteAutomationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAutomationsMutation, DeleteAutomationsMutationVariables>(DeleteAutomationsDocument, options);
      }
export type DeleteAutomationsMutationHookResult = ReturnType<typeof useDeleteAutomationsMutation>;
export type DeleteAutomationsMutationResult = Apollo.MutationResult<DeleteAutomationsMutation>;
export type DeleteAutomationsMutationOptions = Apollo.BaseMutationOptions<DeleteAutomationsMutation, DeleteAutomationsMutationVariables>;
export const UpdateAutomationGeneralDocument = gql`
    mutation UpdateAutomationGeneral($id: Int!, $enabled: Boolean, $name: String!, $monthlyScheduling: bpchar, $timingExecutionKind: automation_timing_execution_kinds_enum) {
  result: update_automations_by_pk(
    _set: {name: $name, enabled: $enabled, monthly_scheduling: $monthlyScheduling, timing_execution_kind: $timingExecutionKind}
    pk_columns: {id: $id}
  ) {
    id
  }
}
    `;
export type UpdateAutomationGeneralMutationFn = Apollo.MutationFunction<UpdateAutomationGeneralMutation, UpdateAutomationGeneralMutationVariables>;

/**
 * __useUpdateAutomationGeneralMutation__
 *
 * To run a mutation, you first call `useUpdateAutomationGeneralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutomationGeneralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutomationGeneralMutation, { data, loading, error }] = useUpdateAutomationGeneralMutation({
 *   variables: {
 *      id: // value for 'id'
 *      enabled: // value for 'enabled'
 *      name: // value for 'name'
 *      monthlyScheduling: // value for 'monthlyScheduling'
 *      timingExecutionKind: // value for 'timingExecutionKind'
 *   },
 * });
 */
export function useUpdateAutomationGeneralMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAutomationGeneralMutation, UpdateAutomationGeneralMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAutomationGeneralMutation, UpdateAutomationGeneralMutationVariables>(UpdateAutomationGeneralDocument, options);
      }
export type UpdateAutomationGeneralMutationHookResult = ReturnType<typeof useUpdateAutomationGeneralMutation>;
export type UpdateAutomationGeneralMutationResult = Apollo.MutationResult<UpdateAutomationGeneralMutation>;
export type UpdateAutomationGeneralMutationOptions = Apollo.BaseMutationOptions<UpdateAutomationGeneralMutation, UpdateAutomationGeneralMutationVariables>;
export const UpdateAutomationGeneralAddingWatchingDocument = gql`
    mutation UpdateAutomationGeneralAddingWatching($userId: Int!, $id: Int!, $enabled: Boolean, $name: String!, $monthlyScheduling: bpchar, $timingExecutionKind: automation_timing_execution_kinds_enum, $automationIds: [Int!]!, $automationsWatching: [automations_watchings_insert_input!]!) {
  result: update_automations_by_pk(
    _set: {name: $name, enabled: $enabled, monthly_scheduling: $monthlyScheduling, timing_execution_kind: $timingExecutionKind}
    pk_columns: {id: $id}
  ) {
    id
  }
  delete_automations_watchings(
    where: {automation_id: {_in: $automationIds}, user_id: {_eq: $userId}}
  ) {
    rows: affected_rows
  }
  resultWatching: insert_automations_watchings(objects: $automationsWatching) {
    returning {
      automationId: automation_id
    }
  }
}
    `;
export type UpdateAutomationGeneralAddingWatchingMutationFn = Apollo.MutationFunction<UpdateAutomationGeneralAddingWatchingMutation, UpdateAutomationGeneralAddingWatchingMutationVariables>;

/**
 * __useUpdateAutomationGeneralAddingWatchingMutation__
 *
 * To run a mutation, you first call `useUpdateAutomationGeneralAddingWatchingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutomationGeneralAddingWatchingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutomationGeneralAddingWatchingMutation, { data, loading, error }] = useUpdateAutomationGeneralAddingWatchingMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      id: // value for 'id'
 *      enabled: // value for 'enabled'
 *      name: // value for 'name'
 *      monthlyScheduling: // value for 'monthlyScheduling'
 *      timingExecutionKind: // value for 'timingExecutionKind'
 *      automationIds: // value for 'automationIds'
 *      automationsWatching: // value for 'automationsWatching'
 *   },
 * });
 */
export function useUpdateAutomationGeneralAddingWatchingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAutomationGeneralAddingWatchingMutation, UpdateAutomationGeneralAddingWatchingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAutomationGeneralAddingWatchingMutation, UpdateAutomationGeneralAddingWatchingMutationVariables>(UpdateAutomationGeneralAddingWatchingDocument, options);
      }
export type UpdateAutomationGeneralAddingWatchingMutationHookResult = ReturnType<typeof useUpdateAutomationGeneralAddingWatchingMutation>;
export type UpdateAutomationGeneralAddingWatchingMutationResult = Apollo.MutationResult<UpdateAutomationGeneralAddingWatchingMutation>;
export type UpdateAutomationGeneralAddingWatchingMutationOptions = Apollo.BaseMutationOptions<UpdateAutomationGeneralAddingWatchingMutation, UpdateAutomationGeneralAddingWatchingMutationVariables>;
export const UpdateAutomationGeneralDeletingWatchingDocument = gql`
    mutation UpdateAutomationGeneralDeletingWatching($userId: Int!, $id: Int!, $enabled: Boolean, $name: String!, $monthlyScheduling: bpchar, $timingExecutionKind: automation_timing_execution_kinds_enum, $automationIds: [Int!]!) {
  result: update_automations_by_pk(
    _set: {name: $name, enabled: $enabled, monthly_scheduling: $monthlyScheduling, timing_execution_kind: $timingExecutionKind}
    pk_columns: {id: $id}
  ) {
    id
  }
  resultWatching: delete_automations_watchings(
    where: {automation_id: {_in: $automationIds}, user_id: {_eq: $userId}}
  ) {
    rows: affected_rows
  }
}
    `;
export type UpdateAutomationGeneralDeletingWatchingMutationFn = Apollo.MutationFunction<UpdateAutomationGeneralDeletingWatchingMutation, UpdateAutomationGeneralDeletingWatchingMutationVariables>;

/**
 * __useUpdateAutomationGeneralDeletingWatchingMutation__
 *
 * To run a mutation, you first call `useUpdateAutomationGeneralDeletingWatchingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutomationGeneralDeletingWatchingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutomationGeneralDeletingWatchingMutation, { data, loading, error }] = useUpdateAutomationGeneralDeletingWatchingMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      id: // value for 'id'
 *      enabled: // value for 'enabled'
 *      name: // value for 'name'
 *      monthlyScheduling: // value for 'monthlyScheduling'
 *      timingExecutionKind: // value for 'timingExecutionKind'
 *      automationIds: // value for 'automationIds'
 *   },
 * });
 */
export function useUpdateAutomationGeneralDeletingWatchingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAutomationGeneralDeletingWatchingMutation, UpdateAutomationGeneralDeletingWatchingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAutomationGeneralDeletingWatchingMutation, UpdateAutomationGeneralDeletingWatchingMutationVariables>(UpdateAutomationGeneralDeletingWatchingDocument, options);
      }
export type UpdateAutomationGeneralDeletingWatchingMutationHookResult = ReturnType<typeof useUpdateAutomationGeneralDeletingWatchingMutation>;
export type UpdateAutomationGeneralDeletingWatchingMutationResult = Apollo.MutationResult<UpdateAutomationGeneralDeletingWatchingMutation>;
export type UpdateAutomationGeneralDeletingWatchingMutationOptions = Apollo.BaseMutationOptions<UpdateAutomationGeneralDeletingWatchingMutation, UpdateAutomationGeneralDeletingWatchingMutationVariables>;
export const UpdateAutomationsEnabledDocument = gql`
    mutation UpdateAutomationsEnabled($enabled: Boolean!, $ids: [Int!]!) {
  result: update_automations(_set: {enabled: $enabled}, where: {id: {_in: $ids}}) {
    rows: affected_rows
  }
}
    `;
export type UpdateAutomationsEnabledMutationFn = Apollo.MutationFunction<UpdateAutomationsEnabledMutation, UpdateAutomationsEnabledMutationVariables>;

/**
 * __useUpdateAutomationsEnabledMutation__
 *
 * To run a mutation, you first call `useUpdateAutomationsEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutomationsEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutomationsEnabledMutation, { data, loading, error }] = useUpdateAutomationsEnabledMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUpdateAutomationsEnabledMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAutomationsEnabledMutation, UpdateAutomationsEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAutomationsEnabledMutation, UpdateAutomationsEnabledMutationVariables>(UpdateAutomationsEnabledDocument, options);
      }
export type UpdateAutomationsEnabledMutationHookResult = ReturnType<typeof useUpdateAutomationsEnabledMutation>;
export type UpdateAutomationsEnabledMutationResult = Apollo.MutationResult<UpdateAutomationsEnabledMutation>;
export type UpdateAutomationsEnabledMutationOptions = Apollo.BaseMutationOptions<UpdateAutomationsEnabledMutation, UpdateAutomationsEnabledMutationVariables>;
export const DeleteAutomationsWatchingDocument = gql`
    mutation DeleteAutomationsWatching($automationIds: [Int!]!, $userId: Int!) {
  result: delete_automations_watchings(
    where: {automation_id: {_in: $automationIds}, user_id: {_eq: $userId}}
  ) {
    rows: affected_rows
  }
}
    `;
export type DeleteAutomationsWatchingMutationFn = Apollo.MutationFunction<DeleteAutomationsWatchingMutation, DeleteAutomationsWatchingMutationVariables>;

/**
 * __useDeleteAutomationsWatchingMutation__
 *
 * To run a mutation, you first call `useDeleteAutomationsWatchingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAutomationsWatchingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAutomationsWatchingMutation, { data, loading, error }] = useDeleteAutomationsWatchingMutation({
 *   variables: {
 *      automationIds: // value for 'automationIds'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteAutomationsWatchingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAutomationsWatchingMutation, DeleteAutomationsWatchingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAutomationsWatchingMutation, DeleteAutomationsWatchingMutationVariables>(DeleteAutomationsWatchingDocument, options);
      }
export type DeleteAutomationsWatchingMutationHookResult = ReturnType<typeof useDeleteAutomationsWatchingMutation>;
export type DeleteAutomationsWatchingMutationResult = Apollo.MutationResult<DeleteAutomationsWatchingMutation>;
export type DeleteAutomationsWatchingMutationOptions = Apollo.BaseMutationOptions<DeleteAutomationsWatchingMutation, DeleteAutomationsWatchingMutationVariables>;
export const InsertAutomationsWatchingDocument = gql`
    mutation InsertAutomationsWatching($automationIds: [Int!]!, $automationsWatching: [automations_watchings_insert_input!]!, $userId: Int!) {
  delete_automations_watchings(
    where: {automation_id: {_in: $automationIds}, user_id: {_eq: $userId}}
  ) {
    rows: affected_rows
  }
  result: insert_automations_watchings(objects: $automationsWatching) {
    returning {
      automationId: automation_id
    }
  }
}
    `;
export type InsertAutomationsWatchingMutationFn = Apollo.MutationFunction<InsertAutomationsWatchingMutation, InsertAutomationsWatchingMutationVariables>;

/**
 * __useInsertAutomationsWatchingMutation__
 *
 * To run a mutation, you first call `useInsertAutomationsWatchingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertAutomationsWatchingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertAutomationsWatchingMutation, { data, loading, error }] = useInsertAutomationsWatchingMutation({
 *   variables: {
 *      automationIds: // value for 'automationIds'
 *      automationsWatching: // value for 'automationsWatching'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useInsertAutomationsWatchingMutation(baseOptions?: Apollo.MutationHookOptions<InsertAutomationsWatchingMutation, InsertAutomationsWatchingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertAutomationsWatchingMutation, InsertAutomationsWatchingMutationVariables>(InsertAutomationsWatchingDocument, options);
      }
export type InsertAutomationsWatchingMutationHookResult = ReturnType<typeof useInsertAutomationsWatchingMutation>;
export type InsertAutomationsWatchingMutationResult = Apollo.MutationResult<InsertAutomationsWatchingMutation>;
export type InsertAutomationsWatchingMutationOptions = Apollo.BaseMutationOptions<InsertAutomationsWatchingMutation, InsertAutomationsWatchingMutationVariables>;
export const UpdateAutomationSceneDocument = gql`
    mutation UpdateAutomationScene($id: Int!, $scene: scenes_set_input!, $devices: [scenes__devices_insert_input!]!) {
  updated: update_scenes_by_pk(pk_columns: {id: $id}, _set: $scene) {
    id
  }
  delete_scenes__devices(where: {scene_id: {_eq: $id}}) {
    returning {
      id
    }
  }
  insert_scenes__devices(objects: $devices) {
    returning {
      id
    }
  }
}
    `;
export type UpdateAutomationSceneMutationFn = Apollo.MutationFunction<UpdateAutomationSceneMutation, UpdateAutomationSceneMutationVariables>;

/**
 * __useUpdateAutomationSceneMutation__
 *
 * To run a mutation, you first call `useUpdateAutomationSceneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutomationSceneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutomationSceneMutation, { data, loading, error }] = useUpdateAutomationSceneMutation({
 *   variables: {
 *      id: // value for 'id'
 *      scene: // value for 'scene'
 *      devices: // value for 'devices'
 *   },
 * });
 */
export function useUpdateAutomationSceneMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAutomationSceneMutation, UpdateAutomationSceneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAutomationSceneMutation, UpdateAutomationSceneMutationVariables>(UpdateAutomationSceneDocument, options);
      }
export type UpdateAutomationSceneMutationHookResult = ReturnType<typeof useUpdateAutomationSceneMutation>;
export type UpdateAutomationSceneMutationResult = Apollo.MutationResult<UpdateAutomationSceneMutation>;
export type UpdateAutomationSceneMutationOptions = Apollo.BaseMutationOptions<UpdateAutomationSceneMutation, UpdateAutomationSceneMutationVariables>;
export const DeleteAutomationScenesDocument = gql`
    mutation DeleteAutomationScenes($ids: [Int!]!) {
  result: delete_scenes(where: {id: {_in: $ids}}) {
    rows: affected_rows
  }
}
    `;
export type DeleteAutomationScenesMutationFn = Apollo.MutationFunction<DeleteAutomationScenesMutation, DeleteAutomationScenesMutationVariables>;

/**
 * __useDeleteAutomationScenesMutation__
 *
 * To run a mutation, you first call `useDeleteAutomationScenesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAutomationScenesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAutomationScenesMutation, { data, loading, error }] = useDeleteAutomationScenesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteAutomationScenesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAutomationScenesMutation, DeleteAutomationScenesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAutomationScenesMutation, DeleteAutomationScenesMutationVariables>(DeleteAutomationScenesDocument, options);
      }
export type DeleteAutomationScenesMutationHookResult = ReturnType<typeof useDeleteAutomationScenesMutation>;
export type DeleteAutomationScenesMutationResult = Apollo.MutationResult<DeleteAutomationScenesMutation>;
export type DeleteAutomationScenesMutationOptions = Apollo.BaseMutationOptions<DeleteAutomationScenesMutation, DeleteAutomationScenesMutationVariables>;
export const InsertAutomationScenesDocument = gql`
    mutation InsertAutomationScenes($scenes: [scenes_insert_input!]!) {
  result: insert_scenes(objects: $scenes) {
    returning {
      id
    }
  }
}
    `;
export type InsertAutomationScenesMutationFn = Apollo.MutationFunction<InsertAutomationScenesMutation, InsertAutomationScenesMutationVariables>;

/**
 * __useInsertAutomationScenesMutation__
 *
 * To run a mutation, you first call `useInsertAutomationScenesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertAutomationScenesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertAutomationScenesMutation, { data, loading, error }] = useInsertAutomationScenesMutation({
 *   variables: {
 *      scenes: // value for 'scenes'
 *   },
 * });
 */
export function useInsertAutomationScenesMutation(baseOptions?: Apollo.MutationHookOptions<InsertAutomationScenesMutation, InsertAutomationScenesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertAutomationScenesMutation, InsertAutomationScenesMutationVariables>(InsertAutomationScenesDocument, options);
      }
export type InsertAutomationScenesMutationHookResult = ReturnType<typeof useInsertAutomationScenesMutation>;
export type InsertAutomationScenesMutationResult = Apollo.MutationResult<InsertAutomationScenesMutation>;
export type InsertAutomationScenesMutationOptions = Apollo.BaseMutationOptions<InsertAutomationScenesMutation, InsertAutomationScenesMutationVariables>;
export const GetAutomationDocument = gql`
    query GetAutomation($automationId: Int!, $userId: Int!) {
  automation: automations_by_pk(id: $automationId) {
    ...Automation
  }
}
    ${AutomationFragmentDoc}`;

/**
 * __useGetAutomationQuery__
 *
 * To run a query within a React component, call `useGetAutomationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutomationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutomationQuery({
 *   variables: {
 *      automationId: // value for 'automationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetAutomationQuery(baseOptions: Apollo.QueryHookOptions<GetAutomationQuery, GetAutomationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAutomationQuery, GetAutomationQueryVariables>(GetAutomationDocument, options);
      }
export function useGetAutomationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAutomationQuery, GetAutomationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAutomationQuery, GetAutomationQueryVariables>(GetAutomationDocument, options);
        }
export type GetAutomationQueryHookResult = ReturnType<typeof useGetAutomationQuery>;
export type GetAutomationLazyQueryHookResult = ReturnType<typeof useGetAutomationLazyQuery>;
export type GetAutomationQueryResult = Apollo.QueryResult<GetAutomationQuery, GetAutomationQueryVariables>;
export const GetAutomationsDocument = gql`
    query GetAutomations($applicationId: Int!, $userId: Int!) {
  automations: automations(
    order_by: {created_at: desc}
    where: {application_id: {_eq: $applicationId}}
  ) {
    ...Automation
  }
  disabledAutomationsCounter: automations_aggregate(
    where: {enabled: {_eq: false}, application_id: {_eq: $applicationId}}
  ) {
    aggregate {
      count
    }
  }
  enabledAutomationsCounter: automations_aggregate(
    where: {enabled: {_eq: true}, application_id: {_eq: $applicationId}}
  ) {
    aggregate {
      count
    }
  }
  watchingAutomationsCounter: automations_aggregate(
    where: {application_id: {_eq: $applicationId}, _and: {users_watching: {}}}
  ) {
    aggregate {
      count
    }
  }
}
    ${AutomationFragmentDoc}`;

/**
 * __useGetAutomationsQuery__
 *
 * To run a query within a React component, call `useGetAutomationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutomationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutomationsQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetAutomationsQuery(baseOptions: Apollo.QueryHookOptions<GetAutomationsQuery, GetAutomationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAutomationsQuery, GetAutomationsQueryVariables>(GetAutomationsDocument, options);
      }
export function useGetAutomationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAutomationsQuery, GetAutomationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAutomationsQuery, GetAutomationsQueryVariables>(GetAutomationsDocument, options);
        }
export type GetAutomationsQueryHookResult = ReturnType<typeof useGetAutomationsQuery>;
export type GetAutomationsLazyQueryHookResult = ReturnType<typeof useGetAutomationsLazyQuery>;
export type GetAutomationsQueryResult = Apollo.QueryResult<GetAutomationsQuery, GetAutomationsQueryVariables>;
export const GetChatMessagesDocument = gql`
    query GetChatMessages($limit: Int!, $offset: Int!, $organizationId: Int!, $userId: Int!) {
  chatMessages: chat_messages(
    limit: $limit
    offset: $offset
    order_by: {created_at: desc}
    where: {user_id: {_eq: $userId}, organization_id: {_eq: $organizationId}}
  ) {
    ...ChatMessageData
  }
}
    ${ChatMessageDataFragmentDoc}`;

/**
 * __useGetChatMessagesQuery__
 *
 * To run a query within a React component, call `useGetChatMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatMessagesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      organizationId: // value for 'organizationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetChatMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetChatMessagesQuery, GetChatMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatMessagesQuery, GetChatMessagesQueryVariables>(GetChatMessagesDocument, options);
      }
export function useGetChatMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatMessagesQuery, GetChatMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatMessagesQuery, GetChatMessagesQueryVariables>(GetChatMessagesDocument, options);
        }
export type GetChatMessagesQueryHookResult = ReturnType<typeof useGetChatMessagesQuery>;
export type GetChatMessagesLazyQueryHookResult = ReturnType<typeof useGetChatMessagesLazyQuery>;
export type GetChatMessagesQueryResult = Apollo.QueryResult<GetChatMessagesQuery, GetChatMessagesQueryVariables>;
export const DeleteChatMessagesDocument = gql`
    mutation DeleteChatMessages($userId: Int!) {
  deleteChatMessages: delete_chat_messages(where: {user_id: {_eq: $userId}}) {
    affected_rows
  }
}
    `;
export type DeleteChatMessagesMutationFn = Apollo.MutationFunction<DeleteChatMessagesMutation, DeleteChatMessagesMutationVariables>;

/**
 * __useDeleteChatMessagesMutation__
 *
 * To run a mutation, you first call `useDeleteChatMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChatMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChatMessagesMutation, { data, loading, error }] = useDeleteChatMessagesMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteChatMessagesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChatMessagesMutation, DeleteChatMessagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChatMessagesMutation, DeleteChatMessagesMutationVariables>(DeleteChatMessagesDocument, options);
      }
export type DeleteChatMessagesMutationHookResult = ReturnType<typeof useDeleteChatMessagesMutation>;
export type DeleteChatMessagesMutationResult = Apollo.MutationResult<DeleteChatMessagesMutation>;
export type DeleteChatMessagesMutationOptions = Apollo.BaseMutationOptions<DeleteChatMessagesMutation, DeleteChatMessagesMutationVariables>;
export const ChatMessagesDocument = gql`
    subscription ChatMessages($organizationId: Int!, $startDate: timestamptz!, $userId: Int!) {
  chatMessages: chat_messages(
    limit: 2
    order_by: {created_at: desc}
    where: {user_id: {_eq: $userId}, organization_id: {_eq: $organizationId}, created_at: {_gte: $startDate}}
  ) {
    ...ChatMessageData
  }
}
    ${ChatMessageDataFragmentDoc}`;

/**
 * __useChatMessagesSubscription__
 *
 * To run a query within a React component, call `useChatMessagesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChatMessagesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatMessagesSubscription({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      startDate: // value for 'startDate'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useChatMessagesSubscription(baseOptions: Apollo.SubscriptionHookOptions<ChatMessagesSubscription, ChatMessagesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ChatMessagesSubscription, ChatMessagesSubscriptionVariables>(ChatMessagesDocument, options);
      }
export type ChatMessagesSubscriptionHookResult = ReturnType<typeof useChatMessagesSubscription>;
export type ChatMessagesSubscriptionResult = Apollo.SubscriptionResult<ChatMessagesSubscription>;
export const OrganizationChatParamsDocument = gql`
    subscription OrganizationChatParams($organizationId: Int!) {
  organizationsChatParams: organizations_chat_params(
    where: {organization_id: {_eq: $organizationId}}
  ) {
    ...OrganizationChatParamsData
  }
}
    ${OrganizationChatParamsDataFragmentDoc}`;

/**
 * __useOrganizationChatParamsSubscription__
 *
 * To run a query within a React component, call `useOrganizationChatParamsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationChatParamsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationChatParamsSubscription({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationChatParamsSubscription(baseOptions: Apollo.SubscriptionHookOptions<OrganizationChatParamsSubscription, OrganizationChatParamsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OrganizationChatParamsSubscription, OrganizationChatParamsSubscriptionVariables>(OrganizationChatParamsDocument, options);
      }
export type OrganizationChatParamsSubscriptionHookResult = ReturnType<typeof useOrganizationChatParamsSubscription>;
export type OrganizationChatParamsSubscriptionResult = Apollo.SubscriptionResult<OrganizationChatParamsSubscription>;
export const ApplicationsDashboardDocument = gql`
    query ApplicationsDashboard($applicationId: Int!) {
  dashboards: applications_dashboards(
    where: {application_id: {_eq: $applicationId}}
  ) {
    ...ApplicationDashboardData
  }
}
    ${ApplicationDashboardDataFragmentDoc}`;

/**
 * __useApplicationsDashboardQuery__
 *
 * To run a query within a React component, call `useApplicationsDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationsDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationsDashboardQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useApplicationsDashboardQuery(baseOptions: Apollo.QueryHookOptions<ApplicationsDashboardQuery, ApplicationsDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationsDashboardQuery, ApplicationsDashboardQueryVariables>(ApplicationsDashboardDocument, options);
      }
export function useApplicationsDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationsDashboardQuery, ApplicationsDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationsDashboardQuery, ApplicationsDashboardQueryVariables>(ApplicationsDashboardDocument, options);
        }
export type ApplicationsDashboardQueryHookResult = ReturnType<typeof useApplicationsDashboardQuery>;
export type ApplicationsDashboardLazyQueryHookResult = ReturnType<typeof useApplicationsDashboardLazyQuery>;
export type ApplicationsDashboardQueryResult = Apollo.QueryResult<ApplicationsDashboardQuery, ApplicationsDashboardQueryVariables>;
export const LastApplicationEventsDocument = gql`
    query LastApplicationEvents($applicationId: Int!, $limit: Int) {
  notificationsEvents: notifications(
    limit: $limit
    order_by: {created_at: desc}
    where: {application_id: {_eq: $applicationId}, kind: {_in: [EVENT_SCENE_SUCCESS, EVENT_SCENE_FAILED]}}
  ) {
    ...NotificationData
  }
}
    ${NotificationDataFragmentDoc}`;

/**
 * __useLastApplicationEventsQuery__
 *
 * To run a query within a React component, call `useLastApplicationEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastApplicationEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastApplicationEventsQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useLastApplicationEventsQuery(baseOptions: Apollo.QueryHookOptions<LastApplicationEventsQuery, LastApplicationEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LastApplicationEventsQuery, LastApplicationEventsQueryVariables>(LastApplicationEventsDocument, options);
      }
export function useLastApplicationEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LastApplicationEventsQuery, LastApplicationEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LastApplicationEventsQuery, LastApplicationEventsQueryVariables>(LastApplicationEventsDocument, options);
        }
export type LastApplicationEventsQueryHookResult = ReturnType<typeof useLastApplicationEventsQuery>;
export type LastApplicationEventsLazyQueryHookResult = ReturnType<typeof useLastApplicationEventsLazyQuery>;
export type LastApplicationEventsQueryResult = Apollo.QueryResult<LastApplicationEventsQuery, LastApplicationEventsQueryVariables>;
export const UpdateApplicationsDashboardDocument = gql`
    mutation UpdateApplicationsDashboard($applicationDashboardId: Int!, $objects: [applications_dashboards_devices_insert_input!]!) {
  delete_applications_dashboards_devices(
    where: {application_dashboard_id: {_eq: $applicationDashboardId}}
  ) {
    affected_rows
  }
  insert_applications_dashboards_devices(objects: $objects) {
    affected_rows
  }
}
    `;
export type UpdateApplicationsDashboardMutationFn = Apollo.MutationFunction<UpdateApplicationsDashboardMutation, UpdateApplicationsDashboardMutationVariables>;

/**
 * __useUpdateApplicationsDashboardMutation__
 *
 * To run a mutation, you first call `useUpdateApplicationsDashboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApplicationsDashboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApplicationsDashboardMutation, { data, loading, error }] = useUpdateApplicationsDashboardMutation({
 *   variables: {
 *      applicationDashboardId: // value for 'applicationDashboardId'
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpdateApplicationsDashboardMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApplicationsDashboardMutation, UpdateApplicationsDashboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApplicationsDashboardMutation, UpdateApplicationsDashboardMutationVariables>(UpdateApplicationsDashboardDocument, options);
      }
export type UpdateApplicationsDashboardMutationHookResult = ReturnType<typeof useUpdateApplicationsDashboardMutation>;
export type UpdateApplicationsDashboardMutationResult = Apollo.MutationResult<UpdateApplicationsDashboardMutation>;
export type UpdateApplicationsDashboardMutationOptions = Apollo.BaseMutationOptions<UpdateApplicationsDashboardMutation, UpdateApplicationsDashboardMutationVariables>;
export const UpdateAnalysesApplicationsDashboardDocument = gql`
    mutation UpdateAnalysesApplicationsDashboard($applicationDashboardId: Int!, $objects: [applications_dashboards_analysis_insert_input!]!) {
  delete_applications_dashboards_analysis(
    where: {application_dashboard_id: {_eq: $applicationDashboardId}}
  ) {
    affected_rows
  }
  insert_applications_dashboards_analysis(objects: $objects) {
    affected_rows
  }
}
    `;
export type UpdateAnalysesApplicationsDashboardMutationFn = Apollo.MutationFunction<UpdateAnalysesApplicationsDashboardMutation, UpdateAnalysesApplicationsDashboardMutationVariables>;

/**
 * __useUpdateAnalysesApplicationsDashboardMutation__
 *
 * To run a mutation, you first call `useUpdateAnalysesApplicationsDashboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnalysesApplicationsDashboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnalysesApplicationsDashboardMutation, { data, loading, error }] = useUpdateAnalysesApplicationsDashboardMutation({
 *   variables: {
 *      applicationDashboardId: // value for 'applicationDashboardId'
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpdateAnalysesApplicationsDashboardMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAnalysesApplicationsDashboardMutation, UpdateAnalysesApplicationsDashboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAnalysesApplicationsDashboardMutation, UpdateAnalysesApplicationsDashboardMutationVariables>(UpdateAnalysesApplicationsDashboardDocument, options);
      }
export type UpdateAnalysesApplicationsDashboardMutationHookResult = ReturnType<typeof useUpdateAnalysesApplicationsDashboardMutation>;
export type UpdateAnalysesApplicationsDashboardMutationResult = Apollo.MutationResult<UpdateAnalysesApplicationsDashboardMutation>;
export type UpdateAnalysesApplicationsDashboardMutationOptions = Apollo.BaseMutationOptions<UpdateAnalysesApplicationsDashboardMutation, UpdateAnalysesApplicationsDashboardMutationVariables>;
export const DevicesApplicationDocument = gql`
    query DevicesApplication($applicationId: Int!) {
  devices(
    order_by: [{device_type: asc}, {name: asc}]
    where: {application_id: {_eq: $applicationId}, visible: {_eq: true}}
  ) {
    ...DeviceApplicationData
  }
}
    ${DeviceApplicationDataFragmentDoc}`;

/**
 * __useDevicesApplicationQuery__
 *
 * To run a query within a React component, call `useDevicesApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevicesApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevicesApplicationQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useDevicesApplicationQuery(baseOptions: Apollo.QueryHookOptions<DevicesApplicationQuery, DevicesApplicationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevicesApplicationQuery, DevicesApplicationQueryVariables>(DevicesApplicationDocument, options);
      }
export function useDevicesApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevicesApplicationQuery, DevicesApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevicesApplicationQuery, DevicesApplicationQueryVariables>(DevicesApplicationDocument, options);
        }
export type DevicesApplicationQueryHookResult = ReturnType<typeof useDevicesApplicationQuery>;
export type DevicesApplicationLazyQueryHookResult = ReturnType<typeof useDevicesApplicationLazyQuery>;
export type DevicesApplicationQueryResult = Apollo.QueryResult<DevicesApplicationQuery, DevicesApplicationQueryVariables>;
export const DevicesApplicationProviderIdDocument = gql`
    query DevicesApplicationProviderId($applicationProviderId: String!) {
  devices(
    order_by: [{device_type: asc}, {name: asc}]
    where: {application: {provider_id: {_eq: $applicationProviderId}}, visible: {_eq: true}}
  ) {
    ...DeviceLite
  }
}
    ${DeviceLiteFragmentDoc}`;

/**
 * __useDevicesApplicationProviderIdQuery__
 *
 * To run a query within a React component, call `useDevicesApplicationProviderIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevicesApplicationProviderIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevicesApplicationProviderIdQuery({
 *   variables: {
 *      applicationProviderId: // value for 'applicationProviderId'
 *   },
 * });
 */
export function useDevicesApplicationProviderIdQuery(baseOptions: Apollo.QueryHookOptions<DevicesApplicationProviderIdQuery, DevicesApplicationProviderIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevicesApplicationProviderIdQuery, DevicesApplicationProviderIdQueryVariables>(DevicesApplicationProviderIdDocument, options);
      }
export function useDevicesApplicationProviderIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevicesApplicationProviderIdQuery, DevicesApplicationProviderIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevicesApplicationProviderIdQuery, DevicesApplicationProviderIdQueryVariables>(DevicesApplicationProviderIdDocument, options);
        }
export type DevicesApplicationProviderIdQueryHookResult = ReturnType<typeof useDevicesApplicationProviderIdQuery>;
export type DevicesApplicationProviderIdLazyQueryHookResult = ReturnType<typeof useDevicesApplicationProviderIdLazyQuery>;
export type DevicesApplicationProviderIdQueryResult = Apollo.QueryResult<DevicesApplicationProviderIdQuery, DevicesApplicationProviderIdQueryVariables>;
export const DevicesApplicationCountDocument = gql`
    query DevicesApplicationCount($applicationId: Int!) {
  devicesCount: devices_aggregate(
    where: {application_id: {_eq: $applicationId}, visible: {_eq: true}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useDevicesApplicationCountQuery__
 *
 * To run a query within a React component, call `useDevicesApplicationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevicesApplicationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevicesApplicationCountQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useDevicesApplicationCountQuery(baseOptions: Apollo.QueryHookOptions<DevicesApplicationCountQuery, DevicesApplicationCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevicesApplicationCountQuery, DevicesApplicationCountQueryVariables>(DevicesApplicationCountDocument, options);
      }
export function useDevicesApplicationCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevicesApplicationCountQuery, DevicesApplicationCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevicesApplicationCountQuery, DevicesApplicationCountQueryVariables>(DevicesApplicationCountDocument, options);
        }
export type DevicesApplicationCountQueryHookResult = ReturnType<typeof useDevicesApplicationCountQuery>;
export type DevicesApplicationCountLazyQueryHookResult = ReturnType<typeof useDevicesApplicationCountLazyQuery>;
export type DevicesApplicationCountQueryResult = Apollo.QueryResult<DevicesApplicationCountQuery, DevicesApplicationCountQueryVariables>;
export const DevicesApplicationByTypeDocument = gql`
    query DevicesApplicationByType($applicationId: Int!, $deviceType: String!) {
  devices(
    where: {application_id: {_eq: $applicationId}, device_type: {_eq: $deviceType}, visible: {_eq: true}}
  ) {
    ...DeviceApplicationData
  }
}
    ${DeviceApplicationDataFragmentDoc}`;

/**
 * __useDevicesApplicationByTypeQuery__
 *
 * To run a query within a React component, call `useDevicesApplicationByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevicesApplicationByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevicesApplicationByTypeQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      deviceType: // value for 'deviceType'
 *   },
 * });
 */
export function useDevicesApplicationByTypeQuery(baseOptions: Apollo.QueryHookOptions<DevicesApplicationByTypeQuery, DevicesApplicationByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevicesApplicationByTypeQuery, DevicesApplicationByTypeQueryVariables>(DevicesApplicationByTypeDocument, options);
      }
export function useDevicesApplicationByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevicesApplicationByTypeQuery, DevicesApplicationByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevicesApplicationByTypeQuery, DevicesApplicationByTypeQueryVariables>(DevicesApplicationByTypeDocument, options);
        }
export type DevicesApplicationByTypeQueryHookResult = ReturnType<typeof useDevicesApplicationByTypeQuery>;
export type DevicesApplicationByTypeLazyQueryHookResult = ReturnType<typeof useDevicesApplicationByTypeLazyQuery>;
export type DevicesApplicationByTypeQueryResult = Apollo.QueryResult<DevicesApplicationByTypeQuery, DevicesApplicationByTypeQueryVariables>;
export const DevicesByCategoriesDocument = gql`
    query DevicesByCategories($applicationId: Int!, $categoriesIds: [Int!]!) {
  devices(
    where: {application_id: {_eq: $applicationId}, categories: {device_category_id: {_in: $categoriesIds}}, visible: {_eq: true}}
  ) {
    ...DeviceApplicationData
  }
}
    ${DeviceApplicationDataFragmentDoc}`;

/**
 * __useDevicesByCategoriesQuery__
 *
 * To run a query within a React component, call `useDevicesByCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevicesByCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevicesByCategoriesQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      categoriesIds: // value for 'categoriesIds'
 *   },
 * });
 */
export function useDevicesByCategoriesQuery(baseOptions: Apollo.QueryHookOptions<DevicesByCategoriesQuery, DevicesByCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevicesByCategoriesQuery, DevicesByCategoriesQueryVariables>(DevicesByCategoriesDocument, options);
      }
export function useDevicesByCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevicesByCategoriesQuery, DevicesByCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevicesByCategoriesQuery, DevicesByCategoriesQueryVariables>(DevicesByCategoriesDocument, options);
        }
export type DevicesByCategoriesQueryHookResult = ReturnType<typeof useDevicesByCategoriesQuery>;
export type DevicesByCategoriesLazyQueryHookResult = ReturnType<typeof useDevicesByCategoriesLazyQuery>;
export type DevicesByCategoriesQueryResult = Apollo.QueryResult<DevicesByCategoriesQuery, DevicesByCategoriesQueryVariables>;
export const DevicesAsSensorsAndSwitchesDocument = gql`
    query DevicesAsSensorsAndSwitches($applicationId: Int!) {
  sensors: devices(
    order_by: {name: asc}
    where: {application_id: {_eq: $applicationId}, device_type: {_eq: "sensor"}, visible: {_eq: true}}
  ) {
    ...DeviceApplicationData
  }
  switches: devices(
    order_by: {name: asc}
    where: {application_id: {_eq: $applicationId}, device_type: {_eq: "switch"}, visible: {_eq: true}}
  ) {
    ...DeviceApplicationData
  }
}
    ${DeviceApplicationDataFragmentDoc}`;

/**
 * __useDevicesAsSensorsAndSwitchesQuery__
 *
 * To run a query within a React component, call `useDevicesAsSensorsAndSwitchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevicesAsSensorsAndSwitchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevicesAsSensorsAndSwitchesQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useDevicesAsSensorsAndSwitchesQuery(baseOptions: Apollo.QueryHookOptions<DevicesAsSensorsAndSwitchesQuery, DevicesAsSensorsAndSwitchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevicesAsSensorsAndSwitchesQuery, DevicesAsSensorsAndSwitchesQueryVariables>(DevicesAsSensorsAndSwitchesDocument, options);
      }
export function useDevicesAsSensorsAndSwitchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevicesAsSensorsAndSwitchesQuery, DevicesAsSensorsAndSwitchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevicesAsSensorsAndSwitchesQuery, DevicesAsSensorsAndSwitchesQueryVariables>(DevicesAsSensorsAndSwitchesDocument, options);
        }
export type DevicesAsSensorsAndSwitchesQueryHookResult = ReturnType<typeof useDevicesAsSensorsAndSwitchesQuery>;
export type DevicesAsSensorsAndSwitchesLazyQueryHookResult = ReturnType<typeof useDevicesAsSensorsAndSwitchesLazyQuery>;
export type DevicesAsSensorsAndSwitchesQueryResult = Apollo.QueryResult<DevicesAsSensorsAndSwitchesQuery, DevicesAsSensorsAndSwitchesQueryVariables>;
export const DeviceByIdDocument = gql`
    query DeviceById($id: Int!) {
  devices(where: {id: {_eq: $id}, visible: {_eq: true}}) {
    ...DeviceApplicationData
  }
}
    ${DeviceApplicationDataFragmentDoc}`;

/**
 * __useDeviceByIdQuery__
 *
 * To run a query within a React component, call `useDeviceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeviceByIdQuery(baseOptions: Apollo.QueryHookOptions<DeviceByIdQuery, DeviceByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceByIdQuery, DeviceByIdQueryVariables>(DeviceByIdDocument, options);
      }
export function useDeviceByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceByIdQuery, DeviceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceByIdQuery, DeviceByIdQueryVariables>(DeviceByIdDocument, options);
        }
export type DeviceByIdQueryHookResult = ReturnType<typeof useDeviceByIdQuery>;
export type DeviceByIdLazyQueryHookResult = ReturnType<typeof useDeviceByIdLazyQuery>;
export type DeviceByIdQueryResult = Apollo.QueryResult<DeviceByIdQuery, DeviceByIdQueryVariables>;
export const DeviceDetailDocument = gql`
    query DeviceDetail($deviceId: Int!, $endDate: String, $startDate: String) {
  deviceDetail: device_detail(
    args: {device_id: $deviceId, start_date: $startDate, end_date: $endDate}
  ) {
    ...DeviceDetailData
  }
  moreData: devices_by_pk(id: $deviceId) {
    area {
      id
    }
  }
}
    ${DeviceDetailDataFragmentDoc}`;

/**
 * __useDeviceDetailQuery__
 *
 * To run a query within a React component, call `useDeviceDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceDetailQuery({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useDeviceDetailQuery(baseOptions: Apollo.QueryHookOptions<DeviceDetailQuery, DeviceDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceDetailQuery, DeviceDetailQueryVariables>(DeviceDetailDocument, options);
      }
export function useDeviceDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceDetailQuery, DeviceDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceDetailQuery, DeviceDetailQueryVariables>(DeviceDetailDocument, options);
        }
export type DeviceDetailQueryHookResult = ReturnType<typeof useDeviceDetailQuery>;
export type DeviceDetailLazyQueryHookResult = ReturnType<typeof useDeviceDetailLazyQuery>;
export type DeviceDetailQueryResult = Apollo.QueryResult<DeviceDetailQuery, DeviceDetailQueryVariables>;
export const DeviceDetailPreviewDocument = gql`
    query DeviceDetailPreview($deviceId: Int!, $endDate: String, $limit: Int!, $startDate: String) {
  deviceDetailPreview: device_detail(
    args: {device_id: $deviceId, start_date: $startDate, end_date: $endDate, limit: $limit}
  ) {
    ...DeviceDetailData
  }
  moreData: devices_by_pk(id: $deviceId) {
    area {
      id
    }
  }
}
    ${DeviceDetailDataFragmentDoc}`;

/**
 * __useDeviceDetailPreviewQuery__
 *
 * To run a query within a React component, call `useDeviceDetailPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceDetailPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceDetailPreviewQuery({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      endDate: // value for 'endDate'
 *      limit: // value for 'limit'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useDeviceDetailPreviewQuery(baseOptions: Apollo.QueryHookOptions<DeviceDetailPreviewQuery, DeviceDetailPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceDetailPreviewQuery, DeviceDetailPreviewQueryVariables>(DeviceDetailPreviewDocument, options);
      }
export function useDeviceDetailPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceDetailPreviewQuery, DeviceDetailPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceDetailPreviewQuery, DeviceDetailPreviewQueryVariables>(DeviceDetailPreviewDocument, options);
        }
export type DeviceDetailPreviewQueryHookResult = ReturnType<typeof useDeviceDetailPreviewQuery>;
export type DeviceDetailPreviewLazyQueryHookResult = ReturnType<typeof useDeviceDetailPreviewLazyQuery>;
export type DeviceDetailPreviewQueryResult = Apollo.QueryResult<DeviceDetailPreviewQuery, DeviceDetailPreviewQueryVariables>;
export const DeviceNotificationsEventTypesDocument = gql`
    query DeviceNotificationsEventTypes {
  deviceEventTypes: notification_event_types(where: {group: {_eq: "device"}}) {
    id
    event
  }
}
    `;

/**
 * __useDeviceNotificationsEventTypesQuery__
 *
 * To run a query within a React component, call `useDeviceNotificationsEventTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceNotificationsEventTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceNotificationsEventTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDeviceNotificationsEventTypesQuery(baseOptions?: Apollo.QueryHookOptions<DeviceNotificationsEventTypesQuery, DeviceNotificationsEventTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceNotificationsEventTypesQuery, DeviceNotificationsEventTypesQueryVariables>(DeviceNotificationsEventTypesDocument, options);
      }
export function useDeviceNotificationsEventTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceNotificationsEventTypesQuery, DeviceNotificationsEventTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceNotificationsEventTypesQuery, DeviceNotificationsEventTypesQueryVariables>(DeviceNotificationsEventTypesDocument, options);
        }
export type DeviceNotificationsEventTypesQueryHookResult = ReturnType<typeof useDeviceNotificationsEventTypesQuery>;
export type DeviceNotificationsEventTypesLazyQueryHookResult = ReturnType<typeof useDeviceNotificationsEventTypesLazyQuery>;
export type DeviceNotificationsEventTypesQueryResult = Apollo.QueryResult<DeviceNotificationsEventTypesQuery, DeviceNotificationsEventTypesQueryVariables>;
export const DevicesInScenesDocument = gql`
    query DevicesInScenes($currentSceneId: Int!, $deviceId: Int!) {
  deviceInScenes: scenes(
    where: {id: {_neq: $currentSceneId}, scenes_devices: {device_id: {_in: [$deviceId]}}}
  ) {
    ...DeviceInSceneData
  }
}
    ${DeviceInSceneDataFragmentDoc}`;

/**
 * __useDevicesInScenesQuery__
 *
 * To run a query within a React component, call `useDevicesInScenesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevicesInScenesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevicesInScenesQuery({
 *   variables: {
 *      currentSceneId: // value for 'currentSceneId'
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useDevicesInScenesQuery(baseOptions: Apollo.QueryHookOptions<DevicesInScenesQuery, DevicesInScenesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevicesInScenesQuery, DevicesInScenesQueryVariables>(DevicesInScenesDocument, options);
      }
export function useDevicesInScenesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevicesInScenesQuery, DevicesInScenesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevicesInScenesQuery, DevicesInScenesQueryVariables>(DevicesInScenesDocument, options);
        }
export type DevicesInScenesQueryHookResult = ReturnType<typeof useDevicesInScenesQuery>;
export type DevicesInScenesLazyQueryHookResult = ReturnType<typeof useDevicesInScenesLazyQuery>;
export type DevicesInScenesQueryResult = Apollo.QueryResult<DevicesInScenesQuery, DevicesInScenesQueryVariables>;
export const DevicesInScenesCountDocument = gql`
    query DevicesInScenesCount($currentSceneId: Int!, $deviceId: Int!) {
  deviceInScenesCount: scenes_aggregate(
    where: {id: {_neq: $currentSceneId}, scenes_devices: {device_id: {_in: [$deviceId]}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useDevicesInScenesCountQuery__
 *
 * To run a query within a React component, call `useDevicesInScenesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevicesInScenesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevicesInScenesCountQuery({
 *   variables: {
 *      currentSceneId: // value for 'currentSceneId'
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useDevicesInScenesCountQuery(baseOptions: Apollo.QueryHookOptions<DevicesInScenesCountQuery, DevicesInScenesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevicesInScenesCountQuery, DevicesInScenesCountQueryVariables>(DevicesInScenesCountDocument, options);
      }
export function useDevicesInScenesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevicesInScenesCountQuery, DevicesInScenesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevicesInScenesCountQuery, DevicesInScenesCountQueryVariables>(DevicesInScenesCountDocument, options);
        }
export type DevicesInScenesCountQueryHookResult = ReturnType<typeof useDevicesInScenesCountQuery>;
export type DevicesInScenesCountLazyQueryHookResult = ReturnType<typeof useDevicesInScenesCountLazyQuery>;
export type DevicesInScenesCountQueryResult = Apollo.QueryResult<DevicesInScenesCountQuery, DevicesInScenesCountQueryVariables>;
export const DeviceCategoriesDocument = gql`
    query DeviceCategories {
  deviceCategories: device_categories {
    id
    key
  }
}
    `;

/**
 * __useDeviceCategoriesQuery__
 *
 * To run a query within a React component, call `useDeviceCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDeviceCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<DeviceCategoriesQuery, DeviceCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceCategoriesQuery, DeviceCategoriesQueryVariables>(DeviceCategoriesDocument, options);
      }
export function useDeviceCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceCategoriesQuery, DeviceCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceCategoriesQuery, DeviceCategoriesQueryVariables>(DeviceCategoriesDocument, options);
        }
export type DeviceCategoriesQueryHookResult = ReturnType<typeof useDeviceCategoriesQuery>;
export type DeviceCategoriesLazyQueryHookResult = ReturnType<typeof useDeviceCategoriesLazyQuery>;
export type DeviceCategoriesQueryResult = Apollo.QueryResult<DeviceCategoriesQuery, DeviceCategoriesQueryVariables>;
export const DeviceLastUplinkDocument = gql`
    subscription DeviceLastUplink($deviceId: Int!) {
  lastUplink: uplink_dynamo_ref(
    limit: 1
    order_by: {created_at: desc}
    where: {device_id: {_eq: $deviceId}}
  ) {
    id
    lastUplinkData: last_uplink_data
  }
}
    `;

/**
 * __useDeviceLastUplinkSubscription__
 *
 * To run a query within a React component, call `useDeviceLastUplinkSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeviceLastUplinkSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceLastUplinkSubscription({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useDeviceLastUplinkSubscription(baseOptions: Apollo.SubscriptionHookOptions<DeviceLastUplinkSubscription, DeviceLastUplinkSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeviceLastUplinkSubscription, DeviceLastUplinkSubscriptionVariables>(DeviceLastUplinkDocument, options);
      }
export type DeviceLastUplinkSubscriptionHookResult = ReturnType<typeof useDeviceLastUplinkSubscription>;
export type DeviceLastUplinkSubscriptionResult = Apollo.SubscriptionResult<DeviceLastUplinkSubscription>;
export const UpdateDeviceDetailsDocument = gql`
    mutation UpdateDeviceDetails($deviceId: Int!, $deviceName: String!) {
  result: update_devices(_set: {name: $deviceName}, where: {id: {_eq: $deviceId}}) {
    returning {
      id
      name
    }
  }
}
    `;
export type UpdateDeviceDetailsMutationFn = Apollo.MutationFunction<UpdateDeviceDetailsMutation, UpdateDeviceDetailsMutationVariables>;

/**
 * __useUpdateDeviceDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateDeviceDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeviceDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeviceDetailsMutation, { data, loading, error }] = useUpdateDeviceDetailsMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      deviceName: // value for 'deviceName'
 *   },
 * });
 */
export function useUpdateDeviceDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeviceDetailsMutation, UpdateDeviceDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeviceDetailsMutation, UpdateDeviceDetailsMutationVariables>(UpdateDeviceDetailsDocument, options);
      }
export type UpdateDeviceDetailsMutationHookResult = ReturnType<typeof useUpdateDeviceDetailsMutation>;
export type UpdateDeviceDetailsMutationResult = Apollo.MutationResult<UpdateDeviceDetailsMutation>;
export type UpdateDeviceDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateDeviceDetailsMutation, UpdateDeviceDetailsMutationVariables>;
export const SendDeviceActionDocument = gql`
    mutation SendDeviceAction($actionId: Int!, $deviceId: Int!) {
  result: device_downlink(args: {device_id: $deviceId, action_id: $actionId}) {
    id
  }
}
    `;
export type SendDeviceActionMutationFn = Apollo.MutationFunction<SendDeviceActionMutation, SendDeviceActionMutationVariables>;

/**
 * __useSendDeviceActionMutation__
 *
 * To run a mutation, you first call `useSendDeviceActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDeviceActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDeviceActionMutation, { data, loading, error }] = useSendDeviceActionMutation({
 *   variables: {
 *      actionId: // value for 'actionId'
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useSendDeviceActionMutation(baseOptions?: Apollo.MutationHookOptions<SendDeviceActionMutation, SendDeviceActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendDeviceActionMutation, SendDeviceActionMutationVariables>(SendDeviceActionDocument, options);
      }
export type SendDeviceActionMutationHookResult = ReturnType<typeof useSendDeviceActionMutation>;
export type SendDeviceActionMutationResult = Apollo.MutationResult<SendDeviceActionMutation>;
export type SendDeviceActionMutationOptions = Apollo.BaseMutationOptions<SendDeviceActionMutation, SendDeviceActionMutationVariables>;
export const NotificationsEventsDocument = gql`
    query NotificationsEvents($offset: Int!) {
  notificationsEvents: notifications(
    limit: 20
    offset: $offset
    order_by: {created_at: desc}
    where: {hidden: {_eq: false}, kind: {_in: [EVENT_SCENE_SUCCESS, EVENT_SCENE_WARNING, EVENT_SCENE_FAILED, EVENT_DEVICE_MISSING]}}
  ) {
    ...NotificationData
  }
}
    ${NotificationDataFragmentDoc}`;

/**
 * __useNotificationsEventsQuery__
 *
 * To run a query within a React component, call `useNotificationsEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsEventsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useNotificationsEventsQuery(baseOptions: Apollo.QueryHookOptions<NotificationsEventsQuery, NotificationsEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsEventsQuery, NotificationsEventsQueryVariables>(NotificationsEventsDocument, options);
      }
export function useNotificationsEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsEventsQuery, NotificationsEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsEventsQuery, NotificationsEventsQueryVariables>(NotificationsEventsDocument, options);
        }
export type NotificationsEventsQueryHookResult = ReturnType<typeof useNotificationsEventsQuery>;
export type NotificationsEventsLazyQueryHookResult = ReturnType<typeof useNotificationsEventsLazyQuery>;
export type NotificationsEventsQueryResult = Apollo.QueryResult<NotificationsEventsQuery, NotificationsEventsQueryVariables>;
export const NotificationsMessagesDocument = gql`
    query NotificationsMessages($locale: [Locale!], $offset: Int!) {
  notificationsMessages: notifications(
    limit: 20
    offset: $offset
    order_by: {created_at: desc}
    where: {kind: {_in: [EVENT_MESSAGE]}}
  ) {
    ...NotificationContentMessageData
    ...NotificationData
  }
}
    ${NotificationContentMessageDataFragmentDoc}
${NotificationDataFragmentDoc}`;

/**
 * __useNotificationsMessagesQuery__
 *
 * To run a query within a React component, call `useNotificationsMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsMessagesQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useNotificationsMessagesQuery(baseOptions: Apollo.QueryHookOptions<NotificationsMessagesQuery, NotificationsMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsMessagesQuery, NotificationsMessagesQueryVariables>(NotificationsMessagesDocument, options);
      }
export function useNotificationsMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsMessagesQuery, NotificationsMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsMessagesQuery, NotificationsMessagesQueryVariables>(NotificationsMessagesDocument, options);
        }
export type NotificationsMessagesQueryHookResult = ReturnType<typeof useNotificationsMessagesQuery>;
export type NotificationsMessagesLazyQueryHookResult = ReturnType<typeof useNotificationsMessagesLazyQuery>;
export type NotificationsMessagesQueryResult = Apollo.QueryResult<NotificationsMessagesQuery, NotificationsMessagesQueryVariables>;
export const NotificationsReleasesDocument = gql`
    query NotificationsReleases($locale: [Locale!], $offset: Int!) {
  notificationsReleases: notifications(
    limit: 20
    offset: $offset
    order_by: {created_at: desc}
    where: {kind: {_in: [EVENT_RELEASE]}}
  ) {
    ...NotificationContentReleaseData
    ...NotificationData
  }
}
    ${NotificationContentReleaseDataFragmentDoc}
${NotificationDataFragmentDoc}`;

/**
 * __useNotificationsReleasesQuery__
 *
 * To run a query within a React component, call `useNotificationsReleasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsReleasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsReleasesQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useNotificationsReleasesQuery(baseOptions: Apollo.QueryHookOptions<NotificationsReleasesQuery, NotificationsReleasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsReleasesQuery, NotificationsReleasesQueryVariables>(NotificationsReleasesDocument, options);
      }
export function useNotificationsReleasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsReleasesQuery, NotificationsReleasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsReleasesQuery, NotificationsReleasesQueryVariables>(NotificationsReleasesDocument, options);
        }
export type NotificationsReleasesQueryHookResult = ReturnType<typeof useNotificationsReleasesQuery>;
export type NotificationsReleasesLazyQueryHookResult = ReturnType<typeof useNotificationsReleasesLazyQuery>;
export type NotificationsReleasesQueryResult = Apollo.QueryResult<NotificationsReleasesQuery, NotificationsReleasesQueryVariables>;
export const NotificationsSettingsDocument = gql`
    query NotificationsSettings {
  notificationsSettings: notification_user_settings {
    id
    eventsEnabled: events_enabled
    messagesEnabled: messages_enabled
    releasesEnabled: releases_enabled
  }
}
    `;

/**
 * __useNotificationsSettingsQuery__
 *
 * To run a query within a React component, call `useNotificationsSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationsSettingsQuery(baseOptions?: Apollo.QueryHookOptions<NotificationsSettingsQuery, NotificationsSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsSettingsQuery, NotificationsSettingsQueryVariables>(NotificationsSettingsDocument, options);
      }
export function useNotificationsSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsSettingsQuery, NotificationsSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsSettingsQuery, NotificationsSettingsQueryVariables>(NotificationsSettingsDocument, options);
        }
export type NotificationsSettingsQueryHookResult = ReturnType<typeof useNotificationsSettingsQuery>;
export type NotificationsSettingsLazyQueryHookResult = ReturnType<typeof useNotificationsSettingsLazyQuery>;
export type NotificationsSettingsQueryResult = Apollo.QueryResult<NotificationsSettingsQuery, NotificationsSettingsQueryVariables>;
export const NotificationsNotReadCountDocument = gql`
    query NotificationsNotReadCount {
  notificationsNotReadCount: notifications_aggregate(
    limit: 1
    order_by: {created_at: desc}
    where: {hidden: {_eq: false}, read: {_eq: false}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useNotificationsNotReadCountQuery__
 *
 * To run a query within a React component, call `useNotificationsNotReadCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsNotReadCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsNotReadCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationsNotReadCountQuery(baseOptions?: Apollo.QueryHookOptions<NotificationsNotReadCountQuery, NotificationsNotReadCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsNotReadCountQuery, NotificationsNotReadCountQueryVariables>(NotificationsNotReadCountDocument, options);
      }
export function useNotificationsNotReadCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsNotReadCountQuery, NotificationsNotReadCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsNotReadCountQuery, NotificationsNotReadCountQueryVariables>(NotificationsNotReadCountDocument, options);
        }
export type NotificationsNotReadCountQueryHookResult = ReturnType<typeof useNotificationsNotReadCountQuery>;
export type NotificationsNotReadCountLazyQueryHookResult = ReturnType<typeof useNotificationsNotReadCountLazyQuery>;
export type NotificationsNotReadCountQueryResult = Apollo.QueryResult<NotificationsNotReadCountQuery, NotificationsNotReadCountQueryVariables>;
export const NotificationsNotReadCountByTypeDocument = gql`
    query NotificationsNotReadCountByType {
  notificationsNotReadEvents: notifications_aggregate(
    limit: 20
    order_by: {created_at: desc}
    where: {read: {_eq: false}, hidden: {_eq: false}, kind: {_in: [EVENT_SCENE_SUCCESS, EVENT_SCENE_WARNING, EVENT_SCENE_FAILED, EVENT_DEVICE_MISSING]}}
  ) {
    aggregate {
      count
    }
  }
  notificationsNotReadMessages: notifications_aggregate(
    limit: 20
    order_by: {created_at: desc}
    where: {read: {_eq: false}, kind: {_in: [EVENT_MESSAGE]}}
  ) {
    aggregate {
      count
    }
  }
  notificationsNotReadReleases: notifications_aggregate(
    limit: 20
    order_by: {created_at: desc}
    where: {read: {_eq: false}, kind: {_in: [EVENT_RELEASE]}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useNotificationsNotReadCountByTypeQuery__
 *
 * To run a query within a React component, call `useNotificationsNotReadCountByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsNotReadCountByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsNotReadCountByTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationsNotReadCountByTypeQuery(baseOptions?: Apollo.QueryHookOptions<NotificationsNotReadCountByTypeQuery, NotificationsNotReadCountByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsNotReadCountByTypeQuery, NotificationsNotReadCountByTypeQueryVariables>(NotificationsNotReadCountByTypeDocument, options);
      }
export function useNotificationsNotReadCountByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsNotReadCountByTypeQuery, NotificationsNotReadCountByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsNotReadCountByTypeQuery, NotificationsNotReadCountByTypeQueryVariables>(NotificationsNotReadCountByTypeDocument, options);
        }
export type NotificationsNotReadCountByTypeQueryHookResult = ReturnType<typeof useNotificationsNotReadCountByTypeQuery>;
export type NotificationsNotReadCountByTypeLazyQueryHookResult = ReturnType<typeof useNotificationsNotReadCountByTypeLazyQuery>;
export type NotificationsNotReadCountByTypeQueryResult = Apollo.QueryResult<NotificationsNotReadCountByTypeQuery, NotificationsNotReadCountByTypeQueryVariables>;
export const NotificationMessageContentDocument = gql`
    query NotificationMessageContent($locale: [Locale!]!, $notificationContentId: bigint!) {
  notification: notifications(
    where: {content_id: {_eq: $notificationContentId}}
    limit: 1
  ) {
    ...NotificationContentMessageData
  }
}
    ${NotificationContentMessageDataFragmentDoc}`;

/**
 * __useNotificationMessageContentQuery__
 *
 * To run a query within a React component, call `useNotificationMessageContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationMessageContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationMessageContentQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      notificationContentId: // value for 'notificationContentId'
 *   },
 * });
 */
export function useNotificationMessageContentQuery(baseOptions: Apollo.QueryHookOptions<NotificationMessageContentQuery, NotificationMessageContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationMessageContentQuery, NotificationMessageContentQueryVariables>(NotificationMessageContentDocument, options);
      }
export function useNotificationMessageContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationMessageContentQuery, NotificationMessageContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationMessageContentQuery, NotificationMessageContentQueryVariables>(NotificationMessageContentDocument, options);
        }
export type NotificationMessageContentQueryHookResult = ReturnType<typeof useNotificationMessageContentQuery>;
export type NotificationMessageContentLazyQueryHookResult = ReturnType<typeof useNotificationMessageContentLazyQuery>;
export type NotificationMessageContentQueryResult = Apollo.QueryResult<NotificationMessageContentQuery, NotificationMessageContentQueryVariables>;
export const NotificationReleaseContentDocument = gql`
    query NotificationReleaseContent($locale: [Locale!]!, $notificationContentId: bigint!) {
  notification: notifications(
    where: {content_id: {_eq: $notificationContentId}}
    limit: 1
  ) {
    ...NotificationContentReleaseData
  }
}
    ${NotificationContentReleaseDataFragmentDoc}`;

/**
 * __useNotificationReleaseContentQuery__
 *
 * To run a query within a React component, call `useNotificationReleaseContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationReleaseContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationReleaseContentQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      notificationContentId: // value for 'notificationContentId'
 *   },
 * });
 */
export function useNotificationReleaseContentQuery(baseOptions: Apollo.QueryHookOptions<NotificationReleaseContentQuery, NotificationReleaseContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationReleaseContentQuery, NotificationReleaseContentQueryVariables>(NotificationReleaseContentDocument, options);
      }
export function useNotificationReleaseContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationReleaseContentQuery, NotificationReleaseContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationReleaseContentQuery, NotificationReleaseContentQueryVariables>(NotificationReleaseContentDocument, options);
        }
export type NotificationReleaseContentQueryHookResult = ReturnType<typeof useNotificationReleaseContentQuery>;
export type NotificationReleaseContentLazyQueryHookResult = ReturnType<typeof useNotificationReleaseContentLazyQuery>;
export type NotificationReleaseContentQueryResult = Apollo.QueryResult<NotificationReleaseContentQuery, NotificationReleaseContentQueryVariables>;
export const NotificationsReadDocument = gql`
    mutation NotificationsRead($ids: [bigint!]!) {
  updateNotifications: update_notifications(
    _set: {read: true}
    where: {hidden: {_eq: false}, id: {_in: $ids}}
  ) {
    count: affected_rows
  }
}
    `;
export type NotificationsReadMutationFn = Apollo.MutationFunction<NotificationsReadMutation, NotificationsReadMutationVariables>;

/**
 * __useNotificationsReadMutation__
 *
 * To run a mutation, you first call `useNotificationsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationsReadMutation, { data, loading, error }] = useNotificationsReadMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useNotificationsReadMutation(baseOptions?: Apollo.MutationHookOptions<NotificationsReadMutation, NotificationsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotificationsReadMutation, NotificationsReadMutationVariables>(NotificationsReadDocument, options);
      }
export type NotificationsReadMutationHookResult = ReturnType<typeof useNotificationsReadMutation>;
export type NotificationsReadMutationResult = Apollo.MutationResult<NotificationsReadMutation>;
export type NotificationsReadMutationOptions = Apollo.BaseMutationOptions<NotificationsReadMutation, NotificationsReadMutationVariables>;
export const NotificationsAllReadDocument = gql`
    mutation NotificationsAllRead {
  updateNotifications: update_notifications(
    _set: {read: true}
    where: {hidden: {_eq: false}, read: {_eq: false}}
  ) {
    count: affected_rows
  }
}
    `;
export type NotificationsAllReadMutationFn = Apollo.MutationFunction<NotificationsAllReadMutation, NotificationsAllReadMutationVariables>;

/**
 * __useNotificationsAllReadMutation__
 *
 * To run a mutation, you first call `useNotificationsAllReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationsAllReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationsAllReadMutation, { data, loading, error }] = useNotificationsAllReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useNotificationsAllReadMutation(baseOptions?: Apollo.MutationHookOptions<NotificationsAllReadMutation, NotificationsAllReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotificationsAllReadMutation, NotificationsAllReadMutationVariables>(NotificationsAllReadDocument, options);
      }
export type NotificationsAllReadMutationHookResult = ReturnType<typeof useNotificationsAllReadMutation>;
export type NotificationsAllReadMutationResult = Apollo.MutationResult<NotificationsAllReadMutation>;
export type NotificationsAllReadMutationOptions = Apollo.BaseMutationOptions<NotificationsAllReadMutation, NotificationsAllReadMutationVariables>;
export const NotificationsSettingsUpdateDocument = gql`
    mutation NotificationsSettingsUpdate($id: Int!, $props: notification_user_settings_set_input!) {
  updateNotificationsSettings: update_notification_user_settings_by_pk(
    _set: $props
    pk_columns: {id: $id}
  ) {
    id
  }
}
    `;
export type NotificationsSettingsUpdateMutationFn = Apollo.MutationFunction<NotificationsSettingsUpdateMutation, NotificationsSettingsUpdateMutationVariables>;

/**
 * __useNotificationsSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useNotificationsSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationsSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationsSettingsUpdateMutation, { data, loading, error }] = useNotificationsSettingsUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      props: // value for 'props'
 *   },
 * });
 */
export function useNotificationsSettingsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<NotificationsSettingsUpdateMutation, NotificationsSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotificationsSettingsUpdateMutation, NotificationsSettingsUpdateMutationVariables>(NotificationsSettingsUpdateDocument, options);
      }
export type NotificationsSettingsUpdateMutationHookResult = ReturnType<typeof useNotificationsSettingsUpdateMutation>;
export type NotificationsSettingsUpdateMutationResult = Apollo.MutationResult<NotificationsSettingsUpdateMutation>;
export type NotificationsSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<NotificationsSettingsUpdateMutation, NotificationsSettingsUpdateMutationVariables>;
export const OrganizationFeatureLimitsDocument = gql`
    query OrganizationFeatureLimits($organizationId: Int!) {
  featureLimits: organizations_feature_limits(
    where: {organization_id: {_eq: $organizationId}}
  ) {
    ...OrganizationFeatureLimits
  }
}
    ${OrganizationFeatureLimitsFragmentDoc}`;

/**
 * __useOrganizationFeatureLimitsQuery__
 *
 * To run a query within a React component, call `useOrganizationFeatureLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationFeatureLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationFeatureLimitsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationFeatureLimitsQuery(baseOptions: Apollo.QueryHookOptions<OrganizationFeatureLimitsQuery, OrganizationFeatureLimitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationFeatureLimitsQuery, OrganizationFeatureLimitsQueryVariables>(OrganizationFeatureLimitsDocument, options);
      }
export function useOrganizationFeatureLimitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationFeatureLimitsQuery, OrganizationFeatureLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationFeatureLimitsQuery, OrganizationFeatureLimitsQueryVariables>(OrganizationFeatureLimitsDocument, options);
        }
export type OrganizationFeatureLimitsQueryHookResult = ReturnType<typeof useOrganizationFeatureLimitsQuery>;
export type OrganizationFeatureLimitsLazyQueryHookResult = ReturnType<typeof useOrganizationFeatureLimitsLazyQuery>;
export type OrganizationFeatureLimitsQueryResult = Apollo.QueryResult<OrganizationFeatureLimitsQuery, OrganizationFeatureLimitsQueryVariables>;
export const CannyLoginCreateDocument = gql`
    mutation CannyLoginCreate {
  cannyLoginCreate: canny_login_create {
    token
  }
}
    `;
export type CannyLoginCreateMutationFn = Apollo.MutationFunction<CannyLoginCreateMutation, CannyLoginCreateMutationVariables>;

/**
 * __useCannyLoginCreateMutation__
 *
 * To run a mutation, you first call `useCannyLoginCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCannyLoginCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cannyLoginCreateMutation, { data, loading, error }] = useCannyLoginCreateMutation({
 *   variables: {
 *   },
 * });
 */
export function useCannyLoginCreateMutation(baseOptions?: Apollo.MutationHookOptions<CannyLoginCreateMutation, CannyLoginCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CannyLoginCreateMutation, CannyLoginCreateMutationVariables>(CannyLoginCreateDocument, options);
      }
export type CannyLoginCreateMutationHookResult = ReturnType<typeof useCannyLoginCreateMutation>;
export type CannyLoginCreateMutationResult = Apollo.MutationResult<CannyLoginCreateMutation>;
export type CannyLoginCreateMutationOptions = Apollo.BaseMutationOptions<CannyLoginCreateMutation, CannyLoginCreateMutationVariables>;
export const UserDocument = gql`
    query User($id: Int!) {
  user: users_permissions_user_by_pk(id: $id) {
    ...UserData
  }
}
    ${UserDataFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UserDevicesNotificationsDocument = gql`
    query UserDevicesNotifications($userId: Int!) {
  userDeviceNotifications: notification_user_devices(
    where: {user_id: {_eq: $userId}}
  ) {
    id
    device {
      id
    }
  }
}
    `;

/**
 * __useUserDevicesNotificationsQuery__
 *
 * To run a query within a React component, call `useUserDevicesNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDevicesNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDevicesNotificationsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserDevicesNotificationsQuery(baseOptions: Apollo.QueryHookOptions<UserDevicesNotificationsQuery, UserDevicesNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDevicesNotificationsQuery, UserDevicesNotificationsQueryVariables>(UserDevicesNotificationsDocument, options);
      }
export function useUserDevicesNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDevicesNotificationsQuery, UserDevicesNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDevicesNotificationsQuery, UserDevicesNotificationsQueryVariables>(UserDevicesNotificationsDocument, options);
        }
export type UserDevicesNotificationsQueryHookResult = ReturnType<typeof useUserDevicesNotificationsQuery>;
export type UserDevicesNotificationsLazyQueryHookResult = ReturnType<typeof useUserDevicesNotificationsLazyQuery>;
export type UserDevicesNotificationsQueryResult = Apollo.QueryResult<UserDevicesNotificationsQuery, UserDevicesNotificationsQueryVariables>;
export const UserDeviceNotificationDocument = gql`
    query UserDeviceNotification($deviceId: Int!, $userId: Int!) {
  userDeviceNotification: notification_user_devices(
    where: {user_id: {_eq: $userId}, device_id: {_eq: $deviceId}}
  ) {
    id
  }
}
    `;

/**
 * __useUserDeviceNotificationQuery__
 *
 * To run a query within a React component, call `useUserDeviceNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDeviceNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDeviceNotificationQuery({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserDeviceNotificationQuery(baseOptions: Apollo.QueryHookOptions<UserDeviceNotificationQuery, UserDeviceNotificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDeviceNotificationQuery, UserDeviceNotificationQueryVariables>(UserDeviceNotificationDocument, options);
      }
export function useUserDeviceNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDeviceNotificationQuery, UserDeviceNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDeviceNotificationQuery, UserDeviceNotificationQueryVariables>(UserDeviceNotificationDocument, options);
        }
export type UserDeviceNotificationQueryHookResult = ReturnType<typeof useUserDeviceNotificationQuery>;
export type UserDeviceNotificationLazyQueryHookResult = ReturnType<typeof useUserDeviceNotificationLazyQuery>;
export type UserDeviceNotificationQueryResult = Apollo.QueryResult<UserDeviceNotificationQuery, UserDeviceNotificationQueryVariables>;
export const AddUserDeviceNotificationEventTypesDocument = gql`
    mutation AddUserDeviceNotificationEventTypes($deviceId: Int!, $notificationEventTypesInput: [notification_user_devices__event_types_insert_input!]!, $userId: Int!) {
  delete_notification_user_devices(
    where: {user_id: {_eq: $userId}, device_id: {_eq: $deviceId}}
  ) {
    affected_rows
  }
  insert_notification_user_devices_one(
    object: {user_id: $userId, device_id: $deviceId, notification_user_devices_event_types: {data: $notificationEventTypesInput}}
  ) {
    id
  }
}
    `;
export type AddUserDeviceNotificationEventTypesMutationFn = Apollo.MutationFunction<AddUserDeviceNotificationEventTypesMutation, AddUserDeviceNotificationEventTypesMutationVariables>;

/**
 * __useAddUserDeviceNotificationEventTypesMutation__
 *
 * To run a mutation, you first call `useAddUserDeviceNotificationEventTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserDeviceNotificationEventTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserDeviceNotificationEventTypesMutation, { data, loading, error }] = useAddUserDeviceNotificationEventTypesMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      notificationEventTypesInput: // value for 'notificationEventTypesInput'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddUserDeviceNotificationEventTypesMutation(baseOptions?: Apollo.MutationHookOptions<AddUserDeviceNotificationEventTypesMutation, AddUserDeviceNotificationEventTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserDeviceNotificationEventTypesMutation, AddUserDeviceNotificationEventTypesMutationVariables>(AddUserDeviceNotificationEventTypesDocument, options);
      }
export type AddUserDeviceNotificationEventTypesMutationHookResult = ReturnType<typeof useAddUserDeviceNotificationEventTypesMutation>;
export type AddUserDeviceNotificationEventTypesMutationResult = Apollo.MutationResult<AddUserDeviceNotificationEventTypesMutation>;
export type AddUserDeviceNotificationEventTypesMutationOptions = Apollo.BaseMutationOptions<AddUserDeviceNotificationEventTypesMutation, AddUserDeviceNotificationEventTypesMutationVariables>;
export const DeleteUserDeviceNotificationsDocument = gql`
    mutation DeleteUserDeviceNotifications($deviceId: Int!, $userId: Int!) {
  delete_notification_user_devices(
    where: {user_id: {_eq: $userId}, device_id: {_eq: $deviceId}}
  ) {
    affected_rows
  }
}
    `;
export type DeleteUserDeviceNotificationsMutationFn = Apollo.MutationFunction<DeleteUserDeviceNotificationsMutation, DeleteUserDeviceNotificationsMutationVariables>;

/**
 * __useDeleteUserDeviceNotificationsMutation__
 *
 * To run a mutation, you first call `useDeleteUserDeviceNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserDeviceNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserDeviceNotificationsMutation, { data, loading, error }] = useDeleteUserDeviceNotificationsMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteUserDeviceNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserDeviceNotificationsMutation, DeleteUserDeviceNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserDeviceNotificationsMutation, DeleteUserDeviceNotificationsMutationVariables>(DeleteUserDeviceNotificationsDocument, options);
      }
export type DeleteUserDeviceNotificationsMutationHookResult = ReturnType<typeof useDeleteUserDeviceNotificationsMutation>;
export type DeleteUserDeviceNotificationsMutationResult = Apollo.MutationResult<DeleteUserDeviceNotificationsMutation>;
export type DeleteUserDeviceNotificationsMutationOptions = Apollo.BaseMutationOptions<DeleteUserDeviceNotificationsMutation, DeleteUserDeviceNotificationsMutationVariables>;
export const AddTelegramUserDocument = gql`
    mutation AddTelegramUser($telegramUsername: String!, $userId: Int!) {
  insert_telegram_users_one(
    object: {telegram_username: $telegramUsername, user_id: $userId, active: true}
  ) {
    id
    telegramUsername: telegram_username
    userId: user_id
  }
}
    `;
export type AddTelegramUserMutationFn = Apollo.MutationFunction<AddTelegramUserMutation, AddTelegramUserMutationVariables>;

/**
 * __useAddTelegramUserMutation__
 *
 * To run a mutation, you first call `useAddTelegramUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTelegramUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTelegramUserMutation, { data, loading, error }] = useAddTelegramUserMutation({
 *   variables: {
 *      telegramUsername: // value for 'telegramUsername'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddTelegramUserMutation(baseOptions?: Apollo.MutationHookOptions<AddTelegramUserMutation, AddTelegramUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTelegramUserMutation, AddTelegramUserMutationVariables>(AddTelegramUserDocument, options);
      }
export type AddTelegramUserMutationHookResult = ReturnType<typeof useAddTelegramUserMutation>;
export type AddTelegramUserMutationResult = Apollo.MutationResult<AddTelegramUserMutation>;
export type AddTelegramUserMutationOptions = Apollo.BaseMutationOptions<AddTelegramUserMutation, AddTelegramUserMutationVariables>;
export const UpdateTelegramUserDocument = gql`
    mutation UpdateTelegramUser($id: Int!, $telegramUsername: String!) {
  update_telegram_users_by_pk(
    _set: {telegram_username: $telegramUsername}
    pk_columns: {id: $id}
  ) {
    id
    telegramUsername: telegram_username
  }
}
    `;
export type UpdateTelegramUserMutationFn = Apollo.MutationFunction<UpdateTelegramUserMutation, UpdateTelegramUserMutationVariables>;

/**
 * __useUpdateTelegramUserMutation__
 *
 * To run a mutation, you first call `useUpdateTelegramUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTelegramUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTelegramUserMutation, { data, loading, error }] = useUpdateTelegramUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      telegramUsername: // value for 'telegramUsername'
 *   },
 * });
 */
export function useUpdateTelegramUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTelegramUserMutation, UpdateTelegramUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTelegramUserMutation, UpdateTelegramUserMutationVariables>(UpdateTelegramUserDocument, options);
      }
export type UpdateTelegramUserMutationHookResult = ReturnType<typeof useUpdateTelegramUserMutation>;
export type UpdateTelegramUserMutationResult = Apollo.MutationResult<UpdateTelegramUserMutation>;
export type UpdateTelegramUserMutationOptions = Apollo.BaseMutationOptions<UpdateTelegramUserMutation, UpdateTelegramUserMutationVariables>;
export const UpdateTelegramUserStatusDocument = gql`
    mutation UpdateTelegramUserStatus($id: Int!, $active: Boolean!) {
  update_telegram_users_by_pk(_set: {active: $active}, pk_columns: {id: $id}) {
    id
    active
  }
}
    `;
export type UpdateTelegramUserStatusMutationFn = Apollo.MutationFunction<UpdateTelegramUserStatusMutation, UpdateTelegramUserStatusMutationVariables>;

/**
 * __useUpdateTelegramUserStatusMutation__
 *
 * To run a mutation, you first call `useUpdateTelegramUserStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTelegramUserStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTelegramUserStatusMutation, { data, loading, error }] = useUpdateTelegramUserStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useUpdateTelegramUserStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTelegramUserStatusMutation, UpdateTelegramUserStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTelegramUserStatusMutation, UpdateTelegramUserStatusMutationVariables>(UpdateTelegramUserStatusDocument, options);
      }
export type UpdateTelegramUserStatusMutationHookResult = ReturnType<typeof useUpdateTelegramUserStatusMutation>;
export type UpdateTelegramUserStatusMutationResult = Apollo.MutationResult<UpdateTelegramUserStatusMutation>;
export type UpdateTelegramUserStatusMutationOptions = Apollo.BaseMutationOptions<UpdateTelegramUserStatusMutation, UpdateTelegramUserStatusMutationVariables>;